
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("gGjAb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b0516d70dca921df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $7ZwLV = parcelRequire("7ZwLV");
var $enb7h = parcelRequire("enb7h");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $fWkFY = parcelRequire("fWkFY");

var $1Iui1 = parcelRequire("1Iui1");

var $h4Fhh = parcelRequire("h4Fhh");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $keguF = parcelRequire("keguF");

var $7vf5z = parcelRequire("7vf5z");

var $jD3pk = parcelRequire("jD3pk");

var $2j5ni = parcelRequire("2j5ni");

var $dWvpo = parcelRequire("dWvpo");

var $kKzsy = parcelRequire("kKzsy");

var $3e4zR = parcelRequire("3e4zR");

var $6M8Uw = parcelRequire("6M8Uw");

var $51ACp = parcelRequire("51ACp");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");
var $3e9vj = parcelRequire("3e9vj");
var $4xHig = parcelRequire("4xHig");

var $jK1pm = parcelRequire("jK1pm");

var $2VrwK = parcelRequire("2VrwK");

var $j0CW6 = parcelRequire("j0CW6");

var $7mFxr = parcelRequire("7mFxr");
const $b0516d70dca921df$var$getInviteThirdPartyTeamsExperiment = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('confluence.frontend.growth.invite-3rd-party-teams', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ]);
const $b0516d70dca921df$var$PeopleProfilesShell = ({ history: history })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ data: gspData }, { fetchState: fetchState }] = (0, $dWvpo.useGettingStartedPanelState)();
    (0, $eUqFw.useEffect)(()=>{
        if (gspData === undefined) fetchState();
    }, [
        gspData,
        fetchState
    ]);
    const gspProjectId = gspData?.properties?.user?.projectId;
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $2j5ni.useIsFirstProjectITSM)(gspProjectId);
    /**
	 * Initializes the active tab to 'alerts' within the Getting Started Panel
	 * specifically for NPLE for ITSM experiment.
	 */ (0, $3e4zR.useInitializeActiveTab)('alerts', gspProjectId);
    const addFlag = (0, $eUqFw.useMemo)(()=>(0, $j0CW6.createShowFlagHandler)(showFlag, dismissFlag), [
        showFlag,
        dismissFlag
    ]);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const atlassianAccountId = (0, $dxcfv.useAccountId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $3e9vj.useEnvironment)();
    const locale = (0, $4xHig.useLocale)();
    const previousSubProduct = (0, $keguF.getPreviousSubProduct)();
    const invitePeopleExperimentalFeatures = {
        inviteThirdPartyTeams: $b0516d70dca921df$var$getInviteThirdPartyTeamsExperiment(),
        displayInfiSpotlight: (0, $1ybV0.ff)('confluence.frontend.growth.display-infi-spotlight')
    };
    const { openModal: openModal } = (0, $enb7h.useInvitePeopleModal)({
        continueUrl: window.location.href,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleDirectory',
        subProduct: previousSubProduct === 'unknown' || previousSubProduct === null ? undefined : previousSubProduct
    });
    const invitePeopleHandlers = (0, $eUqFw.useMemo)(()=>({
            handleOpenDialog: openModal
        }), [
        openModal
    ]);
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    if (!atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWkFY.default), null);
    const { push: push, replace: replace } = history;
    const productFeatureFlags = {
        'event-on-call-consolidation_s97c8': true,
        'event-on-call-consolidation-state': shouldUseJSM
    };
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2VrwK.default), {
        appName: "jira-directory",
        contextSpaPaths: [
            '/browse',
            '/jira',
            '/projects'
        ],
        contextEntryPoint: "/jira/people",
        env: environment === 'prod' ? 'prod' : 'stg',
        locale: locale,
        // @ts-expect-error - TS2322 - Type '(flagFromPTC: FlagFromPTC) => void' is not assignable to type '(props: FlagProps) => void'.
        addFlag: addFlag,
        push: push,
        replace: replace,
        docTitle: {
            end: 'Jira'
        },
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'JiraSubProduct | undefined'.
        subProduct: previousSubProduct,
        invitePeopleHandlers: invitePeopleHandlers,
        productFeatureFlags: productFeatureFlags
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "people-profiles",
        isExpectedToHaveSsr: false,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $7mFxr.peopleProfilesPageLoad)
    }))), isNpleForItsmEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelOpenButton), null)));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b0516d70dca921df$export$2e2bcd8739ae039 = ()=>// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51ACp.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZwLV.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0516d70dca921df$var$PeopleProfilesShell, {
            history: history
        })));

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("fWkFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42223e83f1ce9c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3da0c = parcelRequire("3da0c");

var $lPArN = parcelRequire("lPArN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b42223e83f1ce9c0$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPArN.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("lPArN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dddb8b24cbf4df$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84dddb8b24cbf4df$export$2e2bcd8739ae039 = ({ url: url })=>{
    window.location.assign(url);
    return null;
};

});


parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $gnIbC = parcelRequire("gnIbC");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Yjr.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $gnIbC.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("2j5ni", function(module, exports) {

$parcel$export(module.exports, "useGettingStartedPageStateActions", () => $cde75c243fb1da47$export$8d2572f02ec0aa4c);
$parcel$export(module.exports, "useIsFirstProjectITSM", () => $cde75c243fb1da47$export$852fe39748ba826d);
$parcel$export(module.exports, "useGetNpleDisabledProjectProperty", () => $cde75c243fb1da47$export$24659fa3abfd0100);
$parcel$export(module.exports, "useIsGettingStartedPageEnabled", () => $cde75c243fb1da47$export$a58e406dc976509e);
$parcel$export(module.exports, "useRedirectToGettingStartedPage", () => $cde75c243fb1da47$export$158eb7fa085b0684);

var $eUqFw = parcelRequire("eUqFw");

var $9CmwD = parcelRequire("9CmwD");

var $1Iui1 = parcelRequire("1Iui1");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $bFzGY = parcelRequire("bFzGY");

var $dwCxb = parcelRequire("dwCxb");

var $bNe1g = parcelRequire("bNe1g");

var $gd0Sp = parcelRequire("gd0Sp");

var $cwfEs = parcelRequire("cwfEs");

var $2wBzW = parcelRequire("2wBzW");

var $9qZHX = parcelRequire("9qZHX");
const $cde75c243fb1da47$export$8d2572f02ec0aa4c = ()=>{
    const baseUrl = window.location.origin;
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { data: data } = (0, $bNe1g.useProjectContext)() || {};
    const { projectId: projectId, projectKey: projectKey } = data || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const projectIdString = projectId ? projectId.toString() : '';
    const projectKeyString = projectKey ? projectKey.toString() : '';
    return (0, $eUqFw.useMemo)(()=>{
        const actionProps = {
            baseUrl: baseUrl,
            cloudId: cloudId,
            projectId: projectIdString,
            createAnalyticsEvent: createAnalyticsEvent
        };
        return [
            {
                updateTaskCompletion: (0, $9qZHX.updateTaskCompletion)(actionProps),
                updateLandingPageStateProperties: (0, $9qZHX.updateLandingPageStateProperties)(actionProps),
                getLandingPageState: (0, $9qZHX.getLandingPageState)(actionProps),
                initialiseLandingPageState: (0, $9qZHX.initialiseLandingPageState)(actionProps),
                getManageExternalInformationData: {
                    getAllFeatures: (0, $9qZHX.getAllFeatures)({
                        baseUrl: baseUrl,
                        projectId: projectIdString,
                        createAnalyticsEvent: createAnalyticsEvent
                    }),
                    getCustomerData: (0, $9qZHX.getCustomersData)(baseUrl, projectKeyString)
                }
            }
        ];
    }, [
        baseUrl,
        cloudId,
        createAnalyticsEvent,
        projectIdString,
        projectKeyString
    ]);
};
const $cde75c243fb1da47$export$852fe39748ba826d = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $bNe1g.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const [isFirstProject, setIsFirstProject] = (0, $eUqFw.useState)(false);
    const [isFirstProjectItsm, setIsFirstProjectItsm] = (0, $eUqFw.useState)(false);
    const [isStateLoading, setStateLoading] = (0, $eUqFw.useState)(true);
    const { error: isFirstProjectError, firstProject: firstProject } = (0, $2wBzW.useFirstProjectDetails)();
    (0, $eUqFw.useEffect)(()=>{
        if (currentProjectId && !isFirstProjectError && firstProject) {
            setIsFirstProject(firstProject.projectId === `${currentProjectId}`);
            setIsFirstProjectItsm(firstProject.projectTemplateKey === (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY));
            setStateLoading(false);
        } else if (isFirstProjectError) setStateLoading(false);
    }, [
        currentProjectId,
        firstProject,
        isFirstProjectError,
        setStateLoading
    ]);
    const memoizedValue = (0, $eUqFw.useMemo)(()=>({
            isLoading: loading || isStateLoading,
            isFirstProject: isFirstProject,
            isFirstProjectItsm: isFirstProjectItsm,
            isFirstProjectError: isFirstProjectError
        }), [
        isFirstProject,
        isFirstProjectItsm,
        isFirstProjectError,
        loading,
        isStateLoading
    ]);
    return memoizedValue;
};
const $cde75c243fb1da47$export$da3441212b1c36fb = (projectId)=>{
    const { [(0, $9CmwD.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)]: initialProjectTemplate } = (0, $dwCxb.useProjectProperties)([
        (0, $9CmwD.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)
    ], (0, $1ybV0.ff)('passing-projectid-to-useisgettingstartedpageenabled') ? projectId : undefined);
    const isLoading = initialProjectTemplate === undefined;
    let excludedProjectTemplates;
    const { isLoading: isFirstProjectITSMLoading, isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = $cde75c243fb1da47$export$852fe39748ba826d((0, $1ybV0.ff)('passing-projectid-to-useisgettingstartedpageenabled') ? projectId : undefined);
    if ((0, $1ybV0.ff)('getting_started_page_production_rollout')) excludedProjectTemplates = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') ? (0, $cwfEs.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM) : (0, $cwfEs.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD);
    else excludedProjectTemplates = (0, $cwfEs.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES);
    return (0, $eUqFw.useMemo)(()=>[
            isLoading || isFirstProjectITSMLoading,
            !!initialProjectTemplate && excludedProjectTemplates.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            initialProjectTemplate)
        ], [
        excludedProjectTemplates,
        initialProjectTemplate,
        isFirstProjectITSMLoading,
        isLoading
    ]);
};
const $cde75c243fb1da47$export$24659fa3abfd0100 = (projectKeyOrId)=>{
    const [npleDisabled, setNpleDisabled] = (0, $eUqFw.useState)(projectKeyOrId ? undefined : true);
    const isLoading = npleDisabled === undefined;
    const getNpleDisabledProjectProperty = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = await (0, $lRmyA.performGetRequest)(`/rest/api/3/project/${projectKeyOrId}/properties/${(0, $cwfEs.DISABLE_NPLE_PROJECT_PROJECT_KEY)}`);
            setNpleDisabled(response.value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setNpleDisabled(error.statusCode !== 404);
            error.statusCode !== 404 && (0, $guiFP.default)({
                meta: {
                    id: 'getDisableNpleProjectProperty',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        projectKeyOrId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (projectKeyOrId) getNpleDisabledProjectProperty();
    }, [
        getNpleDisabledProjectProperty,
        projectKeyOrId
    ]);
    return [
        isLoading,
        npleDisabled
    ];
};
const $cde75c243fb1da47$export$a58e406dc976509e = (customContext)=>{
    const { data: data } = (0, $bNe1g.useProjectContext)((0, $1ybV0.ff)('passing-projectid-to-useisgettingstartedpageenabled') ? customContext : undefined) || {};
    const isNpleProductionised = (0, $1ybV0.ff)('getting_started_page_production_rollout');
    const { simplified: isSimplified = false, isProjectAdmin: isProjectAdmin, projectKey: projectKey, projectId: projectId } = data || {};
    const [isLoading, isExcludedProject] = $cde75c243fb1da47$export$da3441212b1c36fb((0, $1ybV0.ff)('passing-projectid-to-useisgettingstartedpageenabled') ? projectId?.toString() : undefined);
    const [isGetNpleDisabledLoading, npleDisabled] = $cde75c243fb1da47$export$24659fa3abfd0100(isNpleProductionised ? projectKey : undefined);
    const isDataLoading = isLoading || isGetNpleDisabledLoading && isNpleProductionised;
    return (0, $eUqFw.useMemo)(()=>[
            isDataLoading,
            !isDataLoading ? isProjectAdmin && !isSimplified && !isExcludedProject && (!npleDisabled && isNpleProductionised || [
                (0, $1Iui1.VAR1),
                (0, $1Iui1.VAR2)
            ].includes((0, $79xbN.expVal)('jsm_getting_started_page_fast_follows', 'cohort', 'not-enrolled'))) : false
        ], [
        isDataLoading,
        isProjectAdmin,
        isSimplified,
        isExcludedProject,
        npleDisabled,
        isNpleProductionised
    ]);
};
const $cde75c243fb1da47$export$158eb7fa085b0684 = (queryParams)=>{
    const [isLoading, isGettingStatedPageEnabled] = $cde75c243fb1da47$export$a58e406dc976509e();
    const [redirectState, setRedirectState] = (0, $eUqFw.useState)({
        loading: true,
        shouldRedirect: false
    });
    const [stateActions] = $cde75c243fb1da47$export$8d2572f02ec0aa4c();
    const referredByGSP = queryParams?.referrer === 'gettingStartedPage' || queryParams?.referrer === 'gettingStartedPageLearnByDoing';
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('getting_started_page_production_rollout')) return setRedirectState({
            loading: false,
            shouldRedirect: false
        });
        if (isLoading) return;
        if (isGettingStatedPageEnabled && !referredByGSP) // This is being made serially to avoid slowing down the experience for customers who aren't in the target
        // audience or projects which don't support getting started page.
        stateActions.getLandingPageState().then(({ completedItems: completedItems })=>{
            setRedirectState({
                loading: false,
                shouldRedirect: completedItems.length < 3
            });
        }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            // if we receive a 404 error, we create a new completed item
            // list for the user
            if (error.statusCode === (0, $cwfEs.ERROR_CODE_NOT_FOUND)) stateActions.initialiseLandingPageState();
            setRedirectState({
                loading: false,
                shouldRedirect: true
            });
        });
        else setRedirectState({
            loading: false,
            shouldRedirect: false
        });
    }, [
        isLoading,
        isGettingStatedPageEnabled,
        stateActions,
        referredByGSP
    ]);
    return redirectState;
};

});
parcelRegister("dwCxb", function(module, exports) {

$parcel$export(module.exports, "useProjectProperties", () => $261b340823618fbf$export$58be98885c2d686a);

var $eUqFw = parcelRequire("eUqFw");

var $3OXzs = parcelRequire("3OXzs");

var $hTLlD = parcelRequire("hTLlD");

var $3LiTJ = parcelRequire("3LiTJ");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $cPEpP = parcelRequire("cPEpP");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fML59 = parcelRequire("fML59");
const $261b340823618fbf$export$d4c72bab9d6cc13a = {};
const $261b340823618fbf$var$Store = (0, $a61MH.createStore)({
    name: 'project-properties',
    initialState: $261b340823618fbf$export$d4c72bab9d6cc13a,
    actions: $fML59.actions
});
const $261b340823618fbf$export$eebf791068e870dd = (0, $ggKAj.createHook)($261b340823618fbf$var$Store);
const $261b340823618fbf$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $cPEpP.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined && (0, $eI5EY.fg)('pass_project_id_to_useprojectproperties') ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $261b340823618fbf$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $hzcvF.usePrevious)(propertyKeys);
    (0, $eUqFw.useEffect)(()=>{
        if (projectId === undefined && (0, $eI5EY.fg)('pass_project_id_to_useprojectproperties')) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, $1ybV0.ff)('passing-projectid-to-useisgettingstartedpageenabled') ? (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(propertyKeys, prevPropertyKeys) && !projectIdOverride : (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(propertyKeys, prevPropertyKeys)) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))(propertyKeys, key)) : {};
};

});
parcelRegister("3OXzs", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $hNahz = parcelRequire("hNahz");

var $hvbu2 = parcelRequire("hvbu2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c84401faa0612b2$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $2c84401faa0612b2$var$includes(collection, value, fromIndex, guard) {
    collection = $jxg5X(collection) ? collection : $hvbu2(collection);
    fromIndex = fromIndex && !guard ? $hNahz(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $2c84401faa0612b2$var$nativeMax(length + fromIndex, 0);
    return $4ZYEI(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $jkhuN(collection, value, fromIndex) > -1;
}
module.exports = $2c84401faa0612b2$var$includes;

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});


parcelRegister("fML59", function(module, exports) {

$parcel$export(module.exports, "actions", () => $25fe75f2cbd4ad0a$export$e324594224ef24da);

var $eoHhV = parcelRequire("eoHhV");
const $25fe75f2cbd4ad0a$export$e324594224ef24da = {
    get: $eoHhV.get
};

});
parcelRegister("eoHhV", function(module, exports) {

$parcel$export(module.exports, "get", () => $6126316a064d2715$export$3988ae62b71be9a3);

var $iVIEg = parcelRequire("iVIEg");

var $kkgbD = parcelRequire("kkgbD");

var $8nrDO = parcelRequire("8nrDO");

var $dw98K = parcelRequire("dw98K");
const $6126316a064d2715$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($8nrDO)))(currentProperties));
        missingProperties.length && (0, $dw98K.default)({
            baseUrl: '',
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        });
    };

});
parcelRegister("dw98K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d933a28077a68115$export$2e2bcd8739ae039);

var $95f8K = parcelRequire("95f8K");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d933a28077a68115$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $95f8K.get)(baseUrl, {
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};

});




parcelRegister("cwfEs", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $e789c0ba11eae82e$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $e789c0ba11eae82e$export$2b3151a089bc8780);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_CHANNELS_CUSTOMISED", () => $e789c0ba11eae82e$export$190fb6b68393ab0a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_REQUEST_TYPES_REVIEWED", () => $e789c0ba11eae82e$export$b51e545ada86528a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_QUEUE_CUSTOMISED", () => $e789c0ba11eae82e$export$2527ae3f75e929d);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_ADD_TEAMMATES", () => $e789c0ba11eae82e$export$ad0f77484b3c614d);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_NAME", () => $e789c0ba11eae82e$export$649bb2ebeb1bddc7);
$parcel$export(module.exports, "REFERRER", () => $e789c0ba11eae82e$export$adee93c2017009c);
$parcel$export(module.exports, "ERROR_CODE_NOT_FOUND", () => $e789c0ba11eae82e$export$7741797ac345bc17);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $e789c0ba11eae82e$export$2c16bd1d8b68b11f);
$parcel$export(module.exports, "JSM_DOCUMENTATION_URL", () => $e789c0ba11eae82e$export$3b0c21ad7d48c17f);
$parcel$export(module.exports, "ASK_COMMUNITY_URL", () => $e789c0ba11eae82e$export$eb3a822ca5964b4c);
$parcel$export(module.exports, "ASK_COMMUNITY_URL_V2", () => $e789c0ba11eae82e$export$4ef7cfb6ab85e0ea);
$parcel$export(module.exports, "SAMPLE_SPACE_URL", () => $e789c0ba11eae82e$export$7d64ff3c41d97984);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES", () => $e789c0ba11eae82e$export$5b4be8b43e96a817);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD", () => $e789c0ba11eae82e$export$eb8426badfb143b);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM", () => $e789c0ba11eae82e$export$6e4b80733f1b287d);
$parcel$export(module.exports, "JSM_EXCLUDED_TEMPLATES_FOR_NPLE", () => $e789c0ba11eae82e$export$849d996b61162ae5);
$parcel$export(module.exports, "REQUEST_CHANNEL_PORTAL", () => $e789c0ba11eae82e$export$84bc97b21fdd244a);
$parcel$export(module.exports, "REQUEST_CHANNEL_CHAT", () => $e789c0ba11eae82e$export$a45136678da730c);
$parcel$export(module.exports, "REQUEST_CHANNEL_EMAIL", () => $e789c0ba11eae82e$export$4585842137473138);
$parcel$export(module.exports, "REQUEST_TYPES_MAX_ELEMENTS", () => $e789c0ba11eae82e$export$4ff5ead961dddcb6);
$parcel$export(module.exports, "REQUEST_TYPES_MAX_ELEMENTS_V2", () => $e789c0ba11eae82e$export$b4ff7eeadf671357);
$parcel$export(module.exports, "ManageQueuesArticleId", () => $e789c0ba11eae82e$export$337d9a01cb6ca6b9);
$parcel$export(module.exports, "InviteTeamArticleId", () => $e789c0ba11eae82e$export$4427f2578322b0c1);
$parcel$export(module.exports, "RequestChannelsArticleId", () => $e789c0ba11eae82e$export$14ea17a7011e8003);
$parcel$export(module.exports, "RequestTypesArticleId", () => $e789c0ba11eae82e$export$bf7175403ae935b4);
$parcel$export(module.exports, "ViewIssueArticleId", () => $e789c0ba11eae82e$export$3a62b051817d4794);
$parcel$export(module.exports, "REQUEST_CHANNELS", () => $e789c0ba11eae82e$export$66b0ce7a4d805ff);
$parcel$export(module.exports, "REQUEST_TYPES", () => $e789c0ba11eae82e$export$b1183955728be615);
$parcel$export(module.exports, "INVITE_TEAM", () => $e789c0ba11eae82e$export$5b2e9a43da487c8d);
$parcel$export(module.exports, "MANAGE_QUEUES", () => $e789c0ba11eae82e$export$82cf56f84f36683f);
$parcel$export(module.exports, "CUSTOMISE_QUEUES", () => $e789c0ba11eae82e$export$36281698ab29d3d1);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_EVENT", () => $e789c0ba11eae82e$export$d60f66633d4d2f8);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_LEARN_BY_DOING_EVENT", () => $e789c0ba11eae82e$export$33e6b6f1b81c57a);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD", () => $e789c0ba11eae82e$export$56dfbf0bd0f6a594);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD_ITSM", () => $e789c0ba11eae82e$export$7153e91b542b7f0a);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_CHECKLIST_EXPERIMENT_VARIATION", () => $e789c0ba11eae82e$export$7fa5aedfca9e5325);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_CHECKLIST_EXPERIMENT_CONTROL", () => $e789c0ba11eae82e$export$fbd49a7cd7290cca);
$parcel$export(module.exports, "DEMO_ISSUE_LABEL", () => $e789c0ba11eae82e$export$fe4edbd608405ae2);
$parcel$export(module.exports, "DEMO_ISSUE_ERROR_FLAG_ID", () => $e789c0ba11eae82e$export$b2f56b9b16e7a5d8);
$parcel$export(module.exports, "DISABLE_NPLE_PROJECT_PROJECT_KEY", () => $e789c0ba11eae82e$export$8b55ba9520951f74);
$parcel$export(module.exports, "DISABLE_NPLE_ERROR_FLAG_ID", () => $e789c0ba11eae82e$export$8ce85ec44321d12);
$parcel$export(module.exports, "DISABLE_NPLE_SUCCESS_FLAG_ID", () => $e789c0ba11eae82e$export$2b5c9784d8cd5f0);
$parcel$export(module.exports, "INCIDENTS", () => $e789c0ba11eae82e$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "CHANGES", () => $e789c0ba11eae82e$export$8598196f74460271);
$parcel$export(module.exports, "ALERTS", () => $e789c0ba11eae82e$export$bc57e9dea1fac017);

var $9CmwD = parcelRequire("9CmwD");
const $e789c0ba11eae82e$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPage';
const $e789c0ba11eae82e$export$2b3151a089bc8780 = 'ITSolMithril';
const $e789c0ba11eae82e$export$190fb6b68393ab0a = 'servicedesk-getting-started-page-request-channels-customised';
const $e789c0ba11eae82e$export$b51e545ada86528a = 'servicedesk-getting-started-page-request-types-reviewed';
const $e789c0ba11eae82e$export$2527ae3f75e929d = 'servicedesk-getting-started-page-queue-customised';
const $e789c0ba11eae82e$export$ad0f77484b3c614d = 'servicedesk-getting-started-page-invite-team';
const $e789c0ba11eae82e$export$649bb2ebeb1bddc7 = 'servicedesk-getting-started-page';
const $e789c0ba11eae82e$export$f250cf2c117f5561 = 'jsm.it-service-management';
const $e789c0ba11eae82e$export$adee93c2017009c = 'referrer';
const $e789c0ba11eae82e$export$7741797ac345bc17 = 404;
const $e789c0ba11eae82e$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/';
const $e789c0ba11eae82e$export$3b0c21ad7d48c17f = 'https://support.atlassian.com/jira-service-management-cloud/docs/get-started-with-jira-service-management/';
const $e789c0ba11eae82e$export$eb3a822ca5964b4c = 'https://community.atlassian.com/t5/New-to-Jira-Service-Management/gh-p/newtojsm';
const $e789c0ba11eae82e$export$4ef7cfb6ab85e0ea = 'https://community.atlassian.com/t5/Jira-Service-Management/Welcome-to-Jira-Service-Management/m-p/2690403?utm_source=community&utm_medium=inapp&utm_campaign=P:jira-service-management%7CO:community%7CC:community%7CW:jsmlp%7CH:05/07/2024%7CI:onboarding%7C';
const $e789c0ba11eae82e$export$7d64ff3c41d97984 = '/jira/servicedesk/itsm-sample-space';
const $e789c0ba11eae82e$export$5b4be8b43e96a817 = [
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.EXTERNAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY)
];
const $e789c0ba11eae82e$export$eb8426badfb143b = [
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY)
];
const $e789c0ba11eae82e$export$6e4b80733f1b287d = [
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY)
];
const $e789c0ba11eae82e$export$849d996b61162ae5 = [
    $e789c0ba11eae82e$export$f250cf2c117f5561,
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY)
];
const $e789c0ba11eae82e$export$84bc97b21fdd244a = 'Portal';
const $e789c0ba11eae82e$export$a45136678da730c = 'Chat';
const $e789c0ba11eae82e$export$4585842137473138 = 'Email';
const $e789c0ba11eae82e$export$4ff5ead961dddcb6 = 3;
const $e789c0ba11eae82e$export$b4ff7eeadf671357 = 4;
const $e789c0ba11eae82e$export$337d9a01cb6ca6b9 = '5b7BuVaVJqmbyCZ2mbMYHD';
const $e789c0ba11eae82e$export$4427f2578322b0c1 = '3cdZ1Fc5T12gySP1kroJJr';
const $e789c0ba11eae82e$export$14ea17a7011e8003 = '3v4bqtuzeA4dOJq6A4yhiM';
const $e789c0ba11eae82e$export$bf7175403ae935b4 = 'eYQImfQnsXgIvrECKaQTF';
const $e789c0ba11eae82e$export$3a62b051817d4794 = '102lbF25oEeqn7GG1rXPUA';
const $e789c0ba11eae82e$export$66b0ce7a4d805ff = 'RequestChannel';
const $e789c0ba11eae82e$export$b1183955728be615 = 'RequestTypes';
const $e789c0ba11eae82e$export$5b2e9a43da487c8d = 'InviteTeam';
const $e789c0ba11eae82e$export$82cf56f84f36683f = 'ManageQueues';
const $e789c0ba11eae82e$export$36281698ab29d3d1 = 'CustomiseQueues';
const $e789c0ba11eae82e$export$34a69842860a7f60 = 'organization';
const $e789c0ba11eae82e$export$ce6912900fd4664 = 'customer';
const $e789c0ba11eae82e$export$6195d296159ef312 = 'csm-customer-context';
const $e789c0ba11eae82e$export$d60f66633d4d2f8 = 'newLandingPageExperienceEvent';
const $e789c0ba11eae82e$export$33e6b6f1b81c57a = 'newLandingPageExperienceLearnByDoingEvent';
const $e789c0ba11eae82e$export$56dfbf0bd0f6a594 = 'newLandingPageExperienceProd';
const $e789c0ba11eae82e$export$7153e91b542b7f0a = 'newLandingPageExperienceProdITSM';
const $e789c0ba11eae82e$export$7fa5aedfca9e5325 = 'newLandingPageExperienceChecklistExperimentVariation';
const $e789c0ba11eae82e$export$fbd49a7cd7290cca = 'newLandingPageExperienceChecklistExperimentControl';
const $e789c0ba11eae82e$export$be01cbdafda7d87f = 'rejected';
const $e789c0ba11eae82e$export$fe4edbd608405ae2 = 'onboarding-learn-by-doing-demo-issue';
const $e789c0ba11eae82e$export$b2f56b9b16e7a5d8 = 'onboarding-sample-issue-error';
const $e789c0ba11eae82e$export$8b55ba9520951f74 = 'npleDisabled';
const $e789c0ba11eae82e$export$8ce85ec44321d12 = 'disable-nple-error';
const $e789c0ba11eae82e$export$2b5c9784d8cd5f0 = 'disable-nple-success';
const $e789c0ba11eae82e$export$a50b49a533b5f7bc = 'incidents';
const $e789c0ba11eae82e$export$8598196f74460271 = 'changes';
const $e789c0ba11eae82e$export$bc57e9dea1fac017 = 'alerts';

});

parcelRegister("2wBzW", function(module, exports) {

$parcel$export(module.exports, "useFirstProjectDetails", () => $dc9ff023e450a76d$export$a2dd21ca7232bc34);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");


var $gd0Sp = parcelRequire("gd0Sp");

var $3tjIy = parcelRequire("3tjIy");
const $dc9ff023e450a76d$var$initialState = {
    error: false,
    firstProject: undefined
};
const $dc9ff023e450a76d$var$setError = (error)=>({ setState: setState })=>{
        setState({
            error: error
        });
    };
const $dc9ff023e450a76d$var$setFirstProject = (firstProject)=>({ setState: setState })=>{
        setState({
            firstProject: firstProject
        });
    };
const $dc9ff023e450a76d$export$e324594224ef24da = {
    setError: $dc9ff023e450a76d$var$setError,
    setFirstProject: $dc9ff023e450a76d$var$setFirstProject
};
const $dc9ff023e450a76d$var$store = (0, $a61MH.createStore)({
    name: 'getting-started-page-is-first-project',
    initialState: $dc9ff023e450a76d$var$initialState,
    actions: $dc9ff023e450a76d$export$e324594224ef24da
});
const $dc9ff023e450a76d$export$a47f6b1a99a5e57f = (0, $ggKAj.createHook)($dc9ff023e450a76d$var$store);
const $dc9ff023e450a76d$export$a2dd21ca7232bc34 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $dc9ff023e450a76d$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61];
    (0, $eUqFw.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        (0, $3tjIy.getFirstProject)().then((response)=>{
            setFirstProjectDetails(response);
        }).catch(()=>{
            setErrorState(true);
        });
    }, [
        hasJsmLicense,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return data;
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("3tjIy", function(module, exports) {

$parcel$export(module.exports, "getFirstProject", () => $1416e82639659d77$export$197802963901b2fb);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $cwfEs = parcelRequire("cwfEs");
const $1416e82639659d77$export$197802963901b2fb = async ()=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)('/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk');
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode !== 404) (0, $guiFP.default)({
            meta: {
                id: 'getFirstProject',
                packageName: (0, $cwfEs.PACKAGE_NAME),
                teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("9qZHX", function(module, exports) {

$parcel$export(module.exports, "initialiseLandingPageState", () => $37d0166180f1cc09$export$afc4bcbfce806408);
$parcel$export(module.exports, "getLandingPageState", () => $37d0166180f1cc09$export$43654a89c1df0019);
$parcel$export(module.exports, "updateTaskCompletion", () => $37d0166180f1cc09$export$429debaced201bcf);
$parcel$export(module.exports, "updateLandingPageStateProperties", () => $37d0166180f1cc09$export$2dede61295d6c46);
$parcel$export(module.exports, "getAllFeatures", () => $37d0166180f1cc09$export$a15e774d3d888bb9);
$parcel$export(module.exports, "getCustomersData", () => $37d0166180f1cc09$export$e0c1133e42fd8b00);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $cwfEs = parcelRequire("cwfEs");
const $37d0166180f1cc09$export$afc4bcbfce806408 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            await (0, $lRmyA.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'initialised'
            }), 'jiraServicedeskGettingStartedPage.State initialised');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
const $37d0166180f1cc09$export$43654a89c1df0019 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            const response = await (0, $lRmyA.performGetRequestWithRetry)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'fetched'
            }), 'jiraServicedeskGettingStartedPage.State fetched');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
const $37d0166180f1cc09$export$429debaced201bcf = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async (userAction)=>{
        try {
            await (0, $lRmyA.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page/item/${userAction}`);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'jiraServicedeskGettingStartedPage.Task',
                action: 'completed'
            }), 'jiraServicedeskGettingStartedPage.Task completed', {
                property: {
                    userAction: userAction
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'jiraServicedeskGettingStartedPage.Task',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
const $37d0166180f1cc09$export$2dede61295d6c46 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async (properties)=>{
        const sectionStateString = JSON.stringify(properties);
        try {
            await (0, $lRmyA.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page/properties`, {
                body: JSON.stringify({
                    sectionState: sectionStateString
                })
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'Properties',
                action: 'updated'
            }), 'jiraServicedeskGettingStartedPage.Properties updated', {
                property: properties
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'Properties',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
const $37d0166180f1cc09$export$a15e774d3d888bb9 = ({ projectId: projectId, baseUrl: baseUrl, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectId}/features`);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'Features',
                action: 'fetched'
            }), 'jiraServicedeskGettingStartedPage.Features fetched');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'getAllFeatures',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
const $37d0166180f1cc09$export$755164a39986f380 = async (baseUrl, serviceDeskId)=>{
    try {
        const response = await (0, $lRmyA.performGetRequestWithRetry)(`${baseUrl}/rest/servicedeskapi/servicedesk/${serviceDeskId}/organization`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getOrganizationData',
                packageName: (0, $cwfEs.PACKAGE_NAME),
                teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $37d0166180f1cc09$export$e0c1133e42fd8b00 = (baseUrl, projectKey)=>async ()=>{
        try {
            const response = await (0, $lRmyA.performGetRequestWithRetry)(`${baseUrl}/rest/servicedesk/1/pages/people/customers/pagination/${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'getCustomersData',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };

});


parcelRegister("dWvpo", function(module, exports) {

$parcel$export(module.exports, "useOpsTeamMode", () => $f367f2772b7579d7$export$97247be508d7d058);
$parcel$export(module.exports, "useGettingStartedPanelState", () => $f367f2772b7579d7$export$50f195e39d82318);
$parcel$export(module.exports, "useGettingStartedPanelActions", () => $f367f2772b7579d7$export$bb089b373d239cdd);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bFzGY = parcelRequire("bFzGY");

var $h4Fhh = parcelRequire("h4Fhh");

var $SEaoU = parcelRequire("SEaoU");

var $kJlBc = parcelRequire("kJlBc");

var $IsF0v = parcelRequire("IsF0v");

var $lhDSB = parcelRequire("lhDSB");

var $gEZA0 = parcelRequire("gEZA0");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $iv53h = parcelRequire("iv53h");

var $dIgUk = parcelRequire("dIgUk");
const $f367f2772b7579d7$var$initialState = {
    data: undefined,
    isGspInitialized: true,
    isSaving: false,
    shouldRecordPerformanceExperiences: true
};
const $f367f2772b7579d7$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'GettingStartedPanelState',
    initialState: $f367f2772b7579d7$var$initialState,
    actions: (0, $dIgUk.actions)
});
const $f367f2772b7579d7$var$useGettingStartedPanelStoreState = (0, $ggKAj.createHook)($f367f2772b7579d7$export$6f57813fe9f31bf9, {
    selector: ({ data: data, isGspInitialized: isGspInitialized, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>{
        const canRender = isGspInitialized && data?.properties.user.activeState === (0, $iv53h.ActiveState).On;
        const canRenderPanel = canRender && data?.properties.user.visualState === (0, $iv53h.VisualState).FullPanel;
        const canRenderOpenButton = canRender && data?.properties.user.visualState === (0, $iv53h.VisualState).Lozenge;
        const canRenderReopenButton = isGspInitialized && data?.properties.user.activeState === (0, $iv53h.ActiveState).Off;
        const canRenderReopenSpotlight = canRenderReopenButton && data?.properties.user.hasSeenReopenSpotlight === (0, $iv53h.HasSeenReopenSpotlight).No;
        const canPollPanelState = data?.properties.user.activeState === (0, $iv53h.ActiveState).On;
        return {
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        };
    }
});
const $f367f2772b7579d7$var$useGettingStartedPanelStoreActions = (0, $ggKAj.createHook)($f367f2772b7579d7$export$6f57813fe9f31bf9, {
    selector: null
});
/**
 * Hook returns if FSF tour is seen
 */ const $f367f2772b7579d7$var$useIsProjectTourSeen = ()=>{
    const [{ data: data, isLoading: isLoading, error: error }, { getTourState: getTourState }] = (0, $lhDSB.useTourState)();
    const isError = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error);
    const hasData = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasData && !isLoading && !isError) getTourState();
    }, [
        hasData,
        isLoading,
        isError,
        getTourState
    ]);
    return data?.seenProjectTour === (0, $ef7033652bab160b$export$e47bc222770d5cfd);
};
/**
 * Hook returns if ITSM sample project
 */ const $f367f2772b7579d7$var$useIsSampleProject = ()=>{
    const { data: isItsmSampleProject } = (0, $gEZA0.useIsItsmSampleProject)();
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    if (isItsmSampleProject != null) return isItsmSampleProject;
    /*
    When isItsmSampleProject is null or undefined - return null/undefined, but only if we are in project context
    (this is to identify that this var has not been initialized yet, see isItsmSampleProject usages, where we check for null/isNil);
    return false otherwise
 */ return containerContext?.contextType === 'project' ? isItsmSampleProject : false;
};
const $f367f2772b7579d7$export$2486eddc1a0bc021 = ()=>{
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    const projectId = containerContext?.contextType === 'project' && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(containerContext.project) ? (0, $6vrw7.toProjectId)(String(containerContext.project.id)) : undefined;
    return {
        isItsmProject: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId) && isItsmProject === true,
        projectId: projectId
    };
};
const $f367f2772b7579d7$export$97247be508d7d058 = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $kJlBc.useRouter)();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const isOpsPage = pathname.startsWith('/jira/ops/teams/');
    const [teamId] = (0, $kJlBc.usePathParam)('teamId');
    const enableOpsTeamMode = isOpsPage && teamId !== undefined && !!shouldUseJSM;
    return {
        teamId: teamId,
        enableOpsTeamMode: enableOpsTeamMode
    };
};
const $f367f2772b7579d7$export$678a38a9dc2d3a0 = ()=>{
    const { isItsmProject: isItsmProject } = $f367f2772b7579d7$export$2486eddc1a0bc021();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const enableUserCentricMode = isItsmProject && !!shouldUseJSM;
    return enableUserCentricMode;
};
const $f367f2772b7579d7$var$useActionsMemo = ({ baseUrl: baseUrl, cloudId: cloudId, accountId: accountId, initializeState: initializeState, reopenGettingStartedPanel: reopenGettingStartedPanel, markReopenSpotlightAsSeen: markReopenSpotlightAsSeen, fetchState: fetchState, savePanelState: savePanelState, resolveTask: resolveTask, saveProperty: saveProperty, stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences, setOpsAdminTaskVisibility: setOpsAdminTaskVisibility })=>{
    const gatewayBaseUrl = (0, $6vrw7.toBaseUrl)(`${baseUrl}/gateway/api`);
    const isItsmSampleProject = $f367f2772b7579d7$var$useIsSampleProject();
    const { isItsmProject: isItsmProject, projectId: projectId } = $f367f2772b7579d7$export$2486eddc1a0bc021();
    const isProjectTourSeen = $f367f2772b7579d7$var$useIsProjectTourSeen();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { teamId: teamId, enableOpsTeamMode: enableOpsTeamMode } = $f367f2772b7579d7$export$97247be508d7d058();
    const enableUserCentricMode = $f367f2772b7579d7$export$678a38a9dc2d3a0();
    return (0, $eUqFw.useMemo)(()=>{
        const actionProps = {
            createAnalyticsEvent: createAnalyticsEvent,
            baseUrl: gatewayBaseUrl,
            cloudId: cloudId,
            accountId: accountId,
            isItsmSampleProject: isItsmSampleProject,
            isProjectTourSeen: isProjectTourSeen,
            isItsmProject: isItsmProject,
            projectId: projectId,
            ...enableOpsTeamMode && {
                teamId: teamId,
                enableOpsTeamMode: enableOpsTeamMode
            },
            ...enableUserCentricMode && {
                enableUserCentricMode: enableUserCentricMode
            }
        };
        return {
            initializeState: initializeState(actionProps),
            reopenGettingStartedPanel: reopenGettingStartedPanel(actionProps),
            markReopenSpotlightAsSeen: markReopenSpotlightAsSeen(actionProps),
            fetchState: fetchState(actionProps),
            savePanelState: savePanelState(actionProps),
            resolveTask: resolveTask(actionProps),
            saveProperty: saveProperty(actionProps),
            stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences(),
            setOpsAdminTaskVisibility: setOpsAdminTaskVisibility(actionProps)
        };
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        cloudId,
        accountId,
        isItsmSampleProject,
        isProjectTourSeen,
        isItsmProject,
        projectId,
        enableOpsTeamMode,
        teamId,
        enableUserCentricMode,
        initializeState,
        reopenGettingStartedPanel,
        markReopenSpotlightAsSeen,
        fetchState,
        savePanelState,
        resolveTask,
        saveProperty,
        stopRecordingPerformanceExperiences,
        setOpsAdminTaskVisibility
    ]);
};
const $f367f2772b7579d7$var$useStateMemo = ({ data: data, canRenderPanel: canRenderPanel, canRenderOpenButton: canRenderOpenButton, canRenderReopenButton: canRenderReopenButton, canRenderReopenSpotlight: canRenderReopenSpotlight, canPollPanelState: canPollPanelState, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        }), [
        data,
        canRenderPanel,
        canRenderOpenButton,
        canRenderReopenButton,
        canRenderReopenSpotlight,
        canPollPanelState,
        shouldRecordPerformanceExperiences
    ]);
const $f367f2772b7579d7$export$50f195e39d82318 = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const [state, actions] = $f367f2772b7579d7$var$useGettingStartedPanelStoreState();
    const memoizedActions = $f367f2772b7579d7$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    const memoizedState = $f367f2772b7579d7$var$useStateMemo(state);
    return (0, $eUqFw.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};
const $f367f2772b7579d7$export$bb089b373d239cdd = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const [, actions] = $f367f2772b7579d7$var$useGettingStartedPanelStoreActions();
    const memoizedActions = $f367f2772b7579d7$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    return (0, $eUqFw.useMemo)(()=>[
            undefined,
            memoizedActions
        ], [
        memoizedActions
    ]);
};

});
parcelRegister("IsF0v", function(module, exports) {

$parcel$export(module.exports, "useIsItsmTemplateProject", () => $07a4c10d5645b4e2$export$7bb46948fb84f164);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $8hg3R = parcelRequire("8hg3R");


const $07a4c10d5645b4e2$var$getDataLoader = ()=>(parcelRequire("4s5wr"));
const $07a4c10d5645b4e2$var$ONE_DAY_IN_MILLIS = 86400000;
const $07a4c10d5645b4e2$export$920308cef4e291b1 = (0, $3HCkE.createResource)({
    type: (0, $f57291778ecbd978$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $07a4c10d5645b4e2$var$getDataLoader,
    maxAge: $07a4c10d5645b4e2$var$ONE_DAY_IN_MILLIS
});
const $07a4c10d5645b4e2$export$7bb46948fb84f164 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)($07a4c10d5645b4e2$export$920308cef4e291b1);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if ((data === null || data === undefined) && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $f57291778ecbd978$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("4s5wr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iNHzY');
        const value = parcelRequire('hQH0C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iNHzY").then(()=>parcelRequire('hQH0C'));
}

});


const $ef7033652bab160b$export$17227441e89ee693 = 'INITIAL';
const $ef7033652bab160b$export$23324e66dcb20cea = 'NOTSEEN';
const $ef7033652bab160b$export$e47bc222770d5cfd = 'SEEN';
const $ef7033652bab160b$export$103bedf43ba882db = 'ERROR';
const $ef7033652bab160b$export$b8b9d90f9e5bd72b = 'jiraServicedeskItsmFirstSessionFlow';
const $ef7033652bab160b$export$d57b6b390e78d90f = 'itops-mithril';

parcelRegister("lhDSB", function(module, exports) {

$parcel$export(module.exports, "useTourState", () => $3c47e23fdd4320f6$export$4aecabf781c5d857);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $d2tO7 = parcelRequire("d2tO7");
const $3c47e23fdd4320f6$export$d4c72bab9d6cc13a = {
    data: undefined,
    isLoading: false,
    error: undefined
};
const $3c47e23fdd4320f6$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'ItsmFirstSessionFlowTourState',
    initialState: $3c47e23fdd4320f6$export$d4c72bab9d6cc13a,
    actions: (0, $d2tO7.actions)
});
const $3c47e23fdd4320f6$var$useStore = (0, $ggKAj.createHook)($3c47e23fdd4320f6$export$6f57813fe9f31bf9);
// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'getTourState' implicitly has an 'any' type. | TS7031 - Binding element 'setTourState' implicitly has an 'any' type.
const $3c47e23fdd4320f6$var$useActionsMemo = ({ baseUrl: baseUrl, getTourState: getTourState, setTourState: setTourState })=>(0, $eUqFw.useMemo)(()=>({
            getTourState: getTourState({
                baseUrl: baseUrl
            }),
            setTourState: setTourState({
                baseUrl: baseUrl
            })
        }), [
        baseUrl,
        getTourState,
        setTourState
    ]);
const $3c47e23fdd4320f6$var$useStateMemo = ({ data: data, isLoading: isLoading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            isLoading: isLoading,
            error: error
        }), [
        data,
        isLoading,
        error
    ]);
const $3c47e23fdd4320f6$export$4aecabf781c5d857 = ()=>{
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, actions] = $3c47e23fdd4320f6$var$useStore();
    const memoizedActions = $3c47e23fdd4320f6$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl
    });
    const memoizedState = $3c47e23fdd4320f6$var$useStateMemo(state);
    return (0, $eUqFw.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};

});
parcelRegister("d2tO7", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5324b94d76febd17$export$e324594224ef24da);

var $eU696 = parcelRequire("eU696");

var $dv6lu = parcelRequire("dv6lu");
const $5324b94d76febd17$export$e324594224ef24da = {
    getTourState: $eU696.getTourState,
    setTourState: $dv6lu.setTourState
};

});
parcelRegister("eU696", function(module, exports) {

$parcel$export(module.exports, "getTourState", () => $4c66438699410e17$export$a758fd93ae41dde5);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $7EhAs = parcelRequire("7EhAs");

var $6vrw7 = parcelRequire("6vrw7");

const $4c66438699410e17$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $4c66438699410e17$var$fetchTourState = async (baseUrl)=>{
    const url = $4c66438699410e17$var$getUrl(baseUrl);
    const response = await fetch(url, (0, $fVqUX.default));
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $7EhAs.default)(response.status, text);
        // Still throw the error even if it's a client fetch error,
        // so we get the error path in the handling code.
        // We only want to skip analytics firing.
        if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getTourState_responseNotOK',
                packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
    return response.json();
};
const $4c66438699410e17$export$a758fd93ae41dde5 = ({ baseUrl: baseUrl })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data, isLoading: isLoading } = getState();
            if (data || isLoading) return;
            setState({
                error: undefined,
                isLoading: true
            });
            try {
                const result = await $4c66438699410e17$var$fetchTourState(baseUrl);
                const { seenProjectTour: seenProjectTour, projectId: projectId } = result;
                setState({
                    data: {
                        seenProjectTour: seenProjectTour,
                        projectId: projectId === null ? null : (0, $6vrw7.toProjectId)(projectId)
                    },
                    isLoading: false
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'getTourState',
                        packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error,
                    isLoading: false
                });
                if (!(0, $JRB5w.isClientFetchError)(error)) throw error;
            }
        };

});

parcelRegister("dv6lu", function(module, exports) {

$parcel$export(module.exports, "setTourState", () => $106ad4ed6da8c60b$export$35f9649c739aaca3);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

const $106ad4ed6da8c60b$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $106ad4ed6da8c60b$var$putTourState = async (baseUrl, tourState)=>{
    const url = $106ad4ed6da8c60b$var$getUrl(baseUrl);
    const response = await fetch(url, {
        ...(0, $fVqUX.default),
        method: 'PUT',
        body: JSON.stringify(tourState)
    });
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $7EhAs.default)(response.status, text);
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'setTourState_responseNotOK',
                packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $106ad4ed6da8c60b$export$35f9649c739aaca3 = ({ baseUrl: baseUrl })=>({ setState: setState })=>// @ts-expect-error - TS2322 - Type 'SetTourState' is not assignable to type 'void | Promise<void>'.
        async (tourState)=>{
            setState({
                error: undefined,
                data: tourState,
                isLoading: true
            });
            try {
                await $106ad4ed6da8c60b$var$putTourState(baseUrl, tourState);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'setTourState',
                        packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error
                });
                throw error;
            } finally{
                setState({
                    isLoading: false
                });
            }
        };

});



parcelRegister("gEZA0", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $d550131522ea0515$export$b8afdaba4bd6f483);

var $ldoFd = parcelRequire("ldoFd");

var $IsF0v = parcelRequire("IsF0v");

var $f7V0E = parcelRequire("f7V0E");
const $d550131522ea0515$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $f7V0E.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("f7V0E", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $8aa166fc00256124$export$9b4078600f2ad4d2);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $7kN7I = parcelRequire("7kN7I");

var $au7K4 = parcelRequire("au7K4");
const $8aa166fc00256124$export$d4c72bab9d6cc13a = {};
const $8aa166fc00256124$export$bf108b10a3a0ab90 = (0, $a61MH.createStore)({
    name: 'IsDemoProject',
    initialState: $8aa166fc00256124$export$d4c72bab9d6cc13a,
    actions: (0, $7kN7I.actions)
});
const $8aa166fc00256124$var$useIsDemoProjectStore = (0, $ggKAj.createHook)($8aa166fc00256124$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $8aa166fc00256124$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $8aa166fc00256124$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $6vrw7.toProjectId)(String(numProjectId));
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $8aa166fc00256124$var$useIsDemoProjectStore();
    const memoizedState = $8aa166fc00256124$var$useStateMemo({
        ...state[projectId] ?? (0, $au7K4.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("7kN7I", function(module, exports) {

$parcel$export(module.exports, "actions", () => $284bc3e2d216ef40$export$e324594224ef24da);

var $eQBT8 = parcelRequire("eQBT8");
const $284bc3e2d216ef40$export$e324594224ef24da = {
    fetchIsDemoProject: $eQBT8.fetchIsDemoProject
};

});
parcelRegister("eQBT8", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $5aa4af5bc33ec272$export$feaee63a215b34da);

var $ldoFd = parcelRequire("ldoFd");

var $iUq1J = parcelRequire("iUq1J");

var $au7K4 = parcelRequire("au7K4");
const $5aa4af5bc33ec272$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $au7K4.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $iUq1J.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("iUq1J", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $e1be306bebb9e883$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $e1be306bebb9e883$export$c498e29d716efe7a);

var $lRmyA = parcelRequire("lRmyA");
const $e1be306bebb9e883$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $e1be306bebb9e883$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});

parcelRegister("au7K4", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $099e9baa7e7daa22$export$f6365b0f25aeae62);
const $099e9baa7e7daa22$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});





parcelRegister("iv53h", function(module, exports) {

$parcel$export(module.exports, "ActiveState", () => $d77f0a6cb13de95d$export$2f27df41e8b7edbb);
$parcel$export(module.exports, "VisualState", () => $d77f0a6cb13de95d$export$285eeaa5f468cfb6);
$parcel$export(module.exports, "Product", () => $d77f0a6cb13de95d$export$264ad599d7cef668);
$parcel$export(module.exports, "Environment", () => $d77f0a6cb13de95d$export$7dc6752a22ab011a);
$parcel$export(module.exports, "GspSectionKey", () => $d77f0a6cb13de95d$export$f4906a03a7a2d0af);
$parcel$export(module.exports, "ChecklistTabKey", () => $d77f0a6cb13de95d$export$4f1a05ccc35315c6);
$parcel$export(module.exports, "ProductTourKey", () => $d77f0a6cb13de95d$export$aa90cbc80c330872);
$parcel$export(module.exports, "HeaderState", () => $d77f0a6cb13de95d$export$38aab4015a34ead);
$parcel$export(module.exports, "TaskId", () => $d77f0a6cb13de95d$export$10cc267f702fbadd);
$parcel$export(module.exports, "BasicsTaskIdsProductionised", () => $d77f0a6cb13de95d$export$fe6666d729b0d637);
$parcel$export(module.exports, "TeamEfficiencyTaskIds", () => $d77f0a6cb13de95d$export$ed4dcaac45c6a484);
$parcel$export(module.exports, "ChangesTaskIds", () => $d77f0a6cb13de95d$export$3de0dd66b0de4cdc);
$parcel$export(module.exports, "IncidentsTaskIds", () => $d77f0a6cb13de95d$export$2852680309cf5a68);
$parcel$export(module.exports, "AlertsTaskIds", () => $d77f0a6cb13de95d$export$4f537e3bd8843f30);
$parcel$export(module.exports, "HasSeenReopenSpotlight", () => $d77f0a6cb13de95d$export$72401d057976d548);
$parcel$export(module.exports, "ContainerType", () => $d77f0a6cb13de95d$export$7d7a98f44861e6f7);
$parcel$export(module.exports, "ExplicitStringBoolean", () => $d77f0a6cb13de95d$export$d7341fa10d264a87);
$parcel$export(module.exports, "PropertyKey", () => $d77f0a6cb13de95d$export$e6bec6a1026bf0b4);
let $d77f0a6cb13de95d$export$2f27df41e8b7edbb = /*#__PURE__*/ function(ActiveState) {
    ActiveState["On"] = "on";
    ActiveState["Off"] = "off";
    return ActiveState;
}({});
let $d77f0a6cb13de95d$export$285eeaa5f468cfb6 = /*#__PURE__*/ function(VisualState) {
    VisualState["Lozenge"] = "lozenge";
    VisualState["FullPanel"] = "full-panel";
    return VisualState;
}({});
let $d77f0a6cb13de95d$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["ServiceDesk"] = "serviceDesk";
    Product["Opsgenie"] = "opsgenie";
    return Product;
}({});
let $d77f0a6cb13de95d$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Local"] = "local";
    Environment["Dev"] = "dev";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    return Environment;
}({});
let $d77f0a6cb13de95d$export$f4906a03a7a2d0af = /*#__PURE__*/ function(GspSectionKey) {
    GspSectionKey["Checklist"] = "checklist";
    GspSectionKey["ProductTours"] = "productTours";
    GspSectionKey["Home"] = "home";
    return GspSectionKey;
}({});
let $d77f0a6cb13de95d$export$4f1a05ccc35315c6 = /*#__PURE__*/ function(ChecklistTabKey) {
    ChecklistTabKey["Basics"] = "basics";
    ChecklistTabKey["TeamEfficiency"] = "teamEfficiency";
    ChecklistTabKey["Incidents"] = "incidents";
    ChecklistTabKey["Changes"] = "changes";
    ChecklistTabKey["Alerts"] = "alerts";
    return ChecklistTabKey;
}({});
let $d77f0a6cb13de95d$export$aa90cbc80c330872 = /*#__PURE__*/ function(ProductTourKey) {
    ProductTourKey["Welcome"] = "welcome";
    ProductTourKey["IncidentManagement"] = "incident-management";
    ProductTourKey["ChangeManagement"] = "change-management";
    return ProductTourKey;
}({});
let $d77f0a6cb13de95d$export$38aab4015a34ead = /*#__PURE__*/ function(HeaderState) {
    HeaderState["Minimized"] = "minimized";
    HeaderState["Expanded"] = "expanded";
    return HeaderState;
}({});
let $d77f0a6cb13de95d$export$10cc267f702fbadd = /*#__PURE__*/ function(TaskId) {
    TaskId["CreateItsmProject"] = "servicedesk-itsm-project-created";
    TaskId["CustomizePortal"] = "servicedesk-portal-name-customized";
    TaskId["AddPortalLogo"] = "servicedesk-logo-added-to-portal";
    TaskId["SetupEmailRequests"] = "servicedesk-email-requests-setup";
    TaskId["SetupChatRequests"] = "servicedesk-chat-requests-setup";
    TaskId["SetupServices"] = "servicedesk-services-setup";
    TaskId["AddTeamMember"] = "servicedesk-team-member-added";
    TaskId["GoBeyondBasics"] = "servicedesk-basics-documentation-accessed";
    TaskId["AutomateYourWork"] = "servicedesk-team-efficiency-automate-your-work";
    TaskId["SetupKnowledgeBase"] = "servicedesk-team-efficiency-setup-knowledge-base";
    TaskId["ConnectCiCdPipeline"] = "servicedesk-change-management-pipeline-connected";
    TaskId["AddChangeApprovers"] = "servicedesk-change-management-change-approvers-added";
    TaskId["TurnOnAutomationRules"] = "servicedesk-change-management-automation-rules-on";
    TaskId["MakeTheMostOfChangeManagement"] = "servicedesk-change-management-documentation-accessed";
    TaskId["SetupProfileForNotifications"] = "opsgenie-user-profile-notifications-setup";
    TaskId["SetupTeam"] = "opsgenie-response-team-setup";
    TaskId["AssignOwnerTeamToServices"] = "opsgenie-owner-team-assigned-to-service";
    TaskId["LevelUpIncidentManagement"] = "opsgenie-incident-management-documentation-accessed";
    TaskId["CustomizeRequestChannels"] = "servicedesk-request-channels-email-portal-requests-customised";
    TaskId["CustomizeRequestTypes"] = "servicedesk-request-types-customised";
    TaskId["ReviewQueueConfigurations"] = "servicedesk-queue-configurations-reviewed";
    TaskId["EnableOpsForTeam"] = "opsgenie-enable-ops-for-team";
    TaskId["ReviewOnCallSetup"] = "opsgenie-review-oncall-setup";
    TaskId["AddIntegration"] = "opsgenie-add-integration";
    TaskId["SetupOpsNotifications"] = "opsgenie-setup-ops-notifications";
    TaskId["ReviewAlerts"] = "opsgenie-review-alerts";
    return TaskId;
}({});
const $d77f0a6cb13de95d$export$9846214c9c3411dc = [
    $d77f0a6cb13de95d$export$10cc267f702fbadd.CreateItsmProject,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.CustomizePortal,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.AddPortalLogo,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupEmailRequests,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupServices,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.AddTeamMember,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.GoBeyondBasics
];
const $d77f0a6cb13de95d$export$fe6666d729b0d637 = [
    $d77f0a6cb13de95d$export$10cc267f702fbadd.CreateItsmProject,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.CustomizePortal,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupEmailRequests,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupChatRequests,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupServices,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.AddTeamMember
];
const $d77f0a6cb13de95d$export$ed4dcaac45c6a484 = [
    $d77f0a6cb13de95d$export$10cc267f702fbadd.AutomateYourWork,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupKnowledgeBase
];
const $d77f0a6cb13de95d$export$3de0dd66b0de4cdc = [
    $d77f0a6cb13de95d$export$10cc267f702fbadd.ConnectCiCdPipeline,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.AddChangeApprovers,
    // Not needed for GA release
    // TaskId.TurnOnAutomationRules,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.MakeTheMostOfChangeManagement
];
const $d77f0a6cb13de95d$export$2852680309cf5a68 = [
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupProfileForNotifications,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupTeam,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.AssignOwnerTeamToServices,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.LevelUpIncidentManagement
];
const $d77f0a6cb13de95d$export$4f537e3bd8843f30 = [
    $d77f0a6cb13de95d$export$10cc267f702fbadd.EnableOpsForTeam,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.ReviewOnCallSetup,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.AddIntegration,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.SetupOpsNotifications,
    $d77f0a6cb13de95d$export$10cc267f702fbadd.ReviewAlerts
];
let $d77f0a6cb13de95d$export$72401d057976d548 = /*#__PURE__*/ function(HasSeenReopenSpotlight) {
    HasSeenReopenSpotlight["Yes"] = "yes";
    HasSeenReopenSpotlight["No"] = "no";
    return HasSeenReopenSpotlight;
}({});
let $d77f0a6cb13de95d$export$7d7a98f44861e6f7 = /*#__PURE__*/ function(ContainerType) {
    ContainerType["Project"] = "project";
    return ContainerType;
}({});
let $d77f0a6cb13de95d$export$d7341fa10d264a87 = /*#__PURE__*/ function(ExplicitStringBoolean) {
    ExplicitStringBoolean["Yes"] = "yes";
    ExplicitStringBoolean["No"] = "no";
    return ExplicitStringBoolean;
}({});
let $d77f0a6cb13de95d$export$e6bec6a1026bf0b4 = /*#__PURE__*/ function(PropertyKey) {
    PropertyKey["VisualState"] = "visualState";
    PropertyKey["ActiveState"] = "activeState";
    PropertyKey["SectionState"] = "sectionState";
    PropertyKey["HasSeenReopenSpotlight"] = "hasSeenReopenSpotlight";
    return PropertyKey;
}({}); // Temporary solution as we don't have types in @atlassian-sox/analytics-web-client

});

parcelRegister("dIgUk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $74d379822532afde$export$e324594224ef24da);

var $bqfo7 = parcelRequire("bqfo7");

var $lKOEf = parcelRequire("lKOEf");

var $zvnJx = parcelRequire("zvnJx");

var $82jJZ = parcelRequire("82jJZ");

var $kYwcF = parcelRequire("kYwcF");

var $3ZIER = parcelRequire("3ZIER");

var $aXUph = parcelRequire("aXUph");

var $1mctb = parcelRequire("1mctb");

var $ghO9h = parcelRequire("ghO9h");
const $74d379822532afde$export$e324594224ef24da = {
    initializeState: $lKOEf.initializeState,
    fetchState: $bqfo7.fetchState,
    savePanelState: $3ZIER.savePanelState,
    reopenGettingStartedPanel: $82jJZ.reopenGettingStartedPanel,
    markReopenSpotlightAsSeen: $zvnJx.markReopenSpotlightAsSeen,
    resolveTask: $kYwcF.resolveTask,
    saveProperty: $aXUph.saveProperty,
    stopRecordingPerformanceExperiences: $ghO9h.stopRecordingPerformanceExperiences,
    setOpsAdminTaskVisibility: $1mctb.setOpsAdminTaskVisibility
};

});
parcelRegister("bqfo7", function(module, exports) {

$parcel$export(module.exports, "fetchState", () => $966d678a0c07fdc2$export$f3df9013f2b58bce);

var $1c8hB = parcelRequire("1c8hB");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $feGjZ = parcelRequire("feGjZ");

var $4ZYEI = parcelRequire("4ZYEI");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $1dL7Z = parcelRequire("1dL7Z");

var $isHzQ = parcelRequire("isHzQ");

var $ajx4y = parcelRequire("ajx4y");

var $lKOEf = parcelRequire("lKOEf");
const $966d678a0c07fdc2$export$e15c3a0c2c6f7c69 = {
    RESPONSE_NOT_OBJECT: 'response is not an object',
    RESPONSE_COMPLETED_ITEMS_NOT_ARRAY: 'response.completedItems is not an array',
    RESPONSE_PROPERTIES_NOT_OBJECT: 'response.properties is not an object',
    RESPONSE_PROPERTIES_USER_NOT_OBJECT: 'response.properties.user is not an object',
    RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING: 'response.properties.user.sectionState is not a string',
    FAILED_PANEL_STATE_JSON_PARSE: 'Failed to parse panelState as JSON'
};
const $966d678a0c07fdc2$var$tryInitializeState = async ({ dispatch: dispatch, ...actionProps })=>{
    const { isProjectTourSeen: isProjectTourSeen, isItsmProject: isItsmProject, projectId: projectId, isItsmSampleProject: isItsmSampleProject, enableOpsTeamMode: enableOpsTeamMode } = actionProps;
    const isNpleForItsmEnabled = (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const hasProject = (isNpleForItsmEnabled || isProjectTourSeen) && isItsmProject && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmSampleProject);
    if (hasProject || // We will show the alert tab regardless of the project conditions.
    enableOpsTeamMode) await dispatch((0, $lKOEf.initializeState)(actionProps))({
        projectId: projectId
    });
};
const $966d678a0c07fdc2$export$8f32748afb26c81d = (response)=>{
    try {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(response)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_NOT_OBJECT);
        const completedTasks = response?.completedItems;
        const properties = response?.properties;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(completedTasks)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_COMPLETED_ITEMS_NOT_ARRAY);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(properties)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_NOT_OBJECT);
        const userProperties = properties.user;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(userProperties)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_NOT_OBJECT);
        const sectionStateString = userProperties.sectionState;
        if (sectionStateString === undefined) return undefined;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(sectionStateString)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING);
        try {
            // further validation on this object to be done within the GSP component
            JSON.parse(sectionStateString);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (parseError) {
            throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.FAILED_PANEL_STATE_JSON_PARSE);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'fetchState_constructDataFromResponse',
                packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                teamName: 'itops-mithril'
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $966d678a0c07fdc2$export$f3df9013f2b58bce = (actionProps)=>({ getState: getState, setState: setState, dispatch: dispatch })=>async ()=>{
            const { isGspInitialized: isGspInitialized, isSaving: isSaving, data: currentData } = getState();
            const { baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // If state is being saved, do not fetch, as it could fetch old state before it has been saved.
            if (isSaving) return;
            // If state is initialized, fetch the state
            if (isGspInitialized) try {
                let response;
                try {
                    response = await (0, $2OdyW.default)((0, $lKOEf.getUrl)({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode !== 404) throw error;
                }
                // If state is being saved, do not save fetched state,
                // as it will override current state that is being saved.
                if (isSaving) return;
                let data = response ? $966d678a0c07fdc2$export$8f32748afb26c81d(response) : undefined;
                if (enableUserCentricMode && data) data = await (0, $ajx4y.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = currentData?.properties.user['ops-admin-tasks-visibility'];
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $isHzQ.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Skip unnecessary re-renders caused by the data reference changing
                if (!!data && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(data, currentData)) return;
                setState({
                    data: data,
                    isGspInitialized: !!data
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.fetchState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if ((0, $1dL7Z.isExpectedError)(error)) return;
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'fetchState',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
            /**
		 * If state is not initialized - try to initialize it
		 * Re-getting isGspInitialized from the getState(), because it might be changed (to false) by the code above
		 */ const { isGspInitialized: currentIsGspInitialized } = getState();
            if (!currentIsGspInitialized) $966d678a0c07fdc2$var$tryInitializeState({
                ...actionProps,
                dispatch: dispatch
            });
        };

});
parcelRegister("1dL7Z", function(module, exports) {

$parcel$export(module.exports, "isInClassicSettingsPage", () => $1d31dcdfdfe25380$export$a6e1eca03e2de987);
$parcel$export(module.exports, "getCurrentPageName", () => $1d31dcdfdfe25380$export$e2c4f60e8cad01fb);
$parcel$export(module.exports, "isExpectedError", () => $1d31dcdfdfe25380$export$8715824c16ceeca0);
$parcel$export(module.exports, "shouldIncludePathname", () => $1d31dcdfdfe25380$export$83501d9ba065ef89);
$parcel$export(module.exports, "shouldExcludePathname", () => $1d31dcdfdfe25380$export$8752a3c4a740bd52);
$parcel$export(module.exports, "shouldExcludeRouteName", () => $1d31dcdfdfe25380$export$5d52a100c70d4375);
// TODO once all pages that checklist cover are in SPA, we should change this to use matchedRoute instead of pathname

var $2oOo5 = parcelRequire("2oOo5");

var $JRB5w = parcelRequire("JRB5w");
const $1d31dcdfdfe25380$export$d7638addf23014e7 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+$/.test(pathname);
const $1d31dcdfdfe25380$export$1b685dac913c7026 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/[\w\W]+$/.test(pathname) || /\/browse\/[\w\W]+$/.test(pathname);
const $1d31dcdfdfe25380$export$a05100bbf8bc68c3 = (pathname)=>/\/projects\/[\w\d]+\/reports/.test(pathname);
const $1d31dcdfdfe25380$export$e75cc3ec1f686973 = (pathname)=>/\/projects\/[\w\d]+\/knowledge/.test(pathname);
const $1d31dcdfdfe25380$export$6292763547421a38 = (pathname)=>/\/projects\/[\w\d]+\/customers$/.test(pathname);
const $1d31dcdfdfe25380$export$35dc6022d31ad167 = (pathname)=>/\/projects\/[\w\d]+\/organization\/[\d]+$/.test(pathname);
const $1d31dcdfdfe25380$export$f8f0d4e52d7e9716 = (pathname)=>$1d31dcdfdfe25380$export$a05100bbf8bc68c3(pathname) && (pathname.endsWith('edit') || pathname.endsWith('new'));
const $1d31dcdfdfe25380$export$753a23d2a857eec = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/edit$/.test(pathname) || /\/projects\/[\w\d]+\/queues\/custom\/new$/.test(pathname);
const $1d31dcdfdfe25380$export$66d002c194bc72aa = (pathname)=>/\/projects\/[\w\d]+\/services\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$430089990bd4af09 = (pathname)=>/\/projects\/[\w\d]+\/on-call-schedule\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$a655a298d384c316 = (pathname)=>/\/projects\/[\w\d]+\/section\/incidents\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$1c5f444b718144b7 = (pathname)=>/\/projects\/[\w\d]+\/section\/problems\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$42dd8a49c7fa462c = (pathname)=>/\/projects\/[\w\d]+\/section\/changes\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$5c77a7ea15a04e63 = (pathname)=>/\/projects\/[\w\d]+\/section\/service-requests\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$dbf902576403f80e = (pathname)=>/\/secure\/project\/EditProject!default.jspa/.test(pathname);
const $1d31dcdfdfe25380$export$458d0b4237ae1dad = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/people/.test(pathname);
const $1d31dcdfdfe25380$export$3b5fbfd2bca32dde = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/summary/.test(pathname);
const $1d31dcdfdfe25380$export$aeffbab88b3257bb = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuetypes/.test(pathname);
const $1d31dcdfdfe25380$export$7e3236de8c2c8fcb = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/request-types\/category\/[\w]+/.test(pathname);
const $1d31dcdfdfe25380$export$908f99db4c2098a0 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/change-management/.test(pathname);
const $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/customer-permissions/.test(pathname);
const $1d31dcdfdfe25380$export$f4e3d864ce1a2f74 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/language/.test(pathname);
const $1d31dcdfdfe25380$export$21361d1ad00e769e = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/portal-settings/.test(pathname);
const $1d31dcdfdfe25380$export$6208845cb364d4de = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/email-settings/.test(pathname);
const $1d31dcdfdfe25380$export$16978d524c086b4 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/email/.test(pathname);
const $1d31dcdfdfe25380$export$b6d6b41b75346458 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/customer-notifications/.test(pathname);
const $1d31dcdfdfe25380$export$5b2153f9a7427657 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/widget/.test(pathname);
const $1d31dcdfdfe25380$export$c5434c69e9b50e81 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/feedback-settings/.test(pathname);
const $1d31dcdfdfe25380$export$3a7002667b72e8d7 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/confluence-kb/.test(pathname);
const $1d31dcdfdfe25380$export$542a1f79f5837827 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/sla/.test(pathname);
const $1d31dcdfdfe25380$export$b748c9dbd5996d34 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/automation/.test(pathname);
const $1d31dcdfdfe25380$export$455a6199a321423 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/apps/.test(pathname);
const $1d31dcdfdfe25380$export$fa426b2da28e4ae2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/workflows/.test(pathname);
const $1d31dcdfdfe25380$export$fc0fba46b7584812 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/screens/.test(pathname);
const $1d31dcdfdfe25380$export$882325faa1a194c6 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/fields/.test(pathname);
const $1d31dcdfdfe25380$export$8bb0073f55baf38b = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-versions/.test(pathname);
const $1d31dcdfdfe25380$export$1b69f3aa169f179 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-components/.test(pathname);
const $1d31dcdfdfe25380$export$1c47b1cb87da237 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/permissions/.test(pathname);
const $1d31dcdfdfe25380$export$ee56a66aa8efb6da = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuesecurity/.test(pathname);
const $1d31dcdfdfe25380$export$6256b4d737fa56f2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/notifications/.test(pathname);
const $1d31dcdfdfe25380$export$3f77d24f8de610a0 = (pathname)=>/\/secure\/ViewCollectors!default.jspa/.test(pathname);
const $1d31dcdfdfe25380$export$a6e1eca03e2de987 = (pathname)=>$1d31dcdfdfe25380$export$dbf902576403f80e(pathname) || $1d31dcdfdfe25380$export$458d0b4237ae1dad(pathname) || $1d31dcdfdfe25380$export$3b5fbfd2bca32dde(pathname) || $1d31dcdfdfe25380$export$aeffbab88b3257bb(pathname) || $1d31dcdfdfe25380$export$7e3236de8c2c8fcb(pathname) || $1d31dcdfdfe25380$export$908f99db4c2098a0(pathname) || $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66(pathname) || $1d31dcdfdfe25380$export$f4e3d864ce1a2f74(pathname) || $1d31dcdfdfe25380$export$21361d1ad00e769e(pathname) || $1d31dcdfdfe25380$export$6208845cb364d4de(pathname) || $1d31dcdfdfe25380$export$16978d524c086b4(pathname) || $1d31dcdfdfe25380$export$b6d6b41b75346458(pathname) || $1d31dcdfdfe25380$export$5b2153f9a7427657(pathname) || $1d31dcdfdfe25380$export$c5434c69e9b50e81(pathname) || $1d31dcdfdfe25380$export$3a7002667b72e8d7(pathname) || $1d31dcdfdfe25380$export$542a1f79f5837827(pathname) || $1d31dcdfdfe25380$export$b748c9dbd5996d34(pathname) || $1d31dcdfdfe25380$export$455a6199a321423(pathname) || $1d31dcdfdfe25380$export$fa426b2da28e4ae2(pathname) || $1d31dcdfdfe25380$export$fc0fba46b7584812(pathname) || $1d31dcdfdfe25380$export$882325faa1a194c6(pathname) || $1d31dcdfdfe25380$export$8bb0073f55baf38b(pathname) || $1d31dcdfdfe25380$export$1b69f3aa169f179(pathname) || $1d31dcdfdfe25380$export$1c47b1cb87da237(pathname) || $1d31dcdfdfe25380$export$ee56a66aa8efb6da(pathname) || $1d31dcdfdfe25380$export$6256b4d737fa56f2(pathname) || $1d31dcdfdfe25380$export$3f77d24f8de610a0(pathname);
const $1d31dcdfdfe25380$var$screenNameMap = {
    queues: $1d31dcdfdfe25380$export$d7638addf23014e7,
    issues: $1d31dcdfdfe25380$export$1b685dac913c7026,
    customers: $1d31dcdfdfe25380$export$6292763547421a38,
    reports: $1d31dcdfdfe25380$export$a05100bbf8bc68c3,
    knowledge: $1d31dcdfdfe25380$export$e75cc3ec1f686973,
    services: $1d31dcdfdfe25380$export$66d002c194bc72aa,
    onCall: $1d31dcdfdfe25380$export$430089990bd4af09,
    incidents: $1d31dcdfdfe25380$export$a655a298d384c316,
    problems: $1d31dcdfdfe25380$export$1c5f444b718144b7,
    changes: $1d31dcdfdfe25380$export$42dd8a49c7fa462c,
    serviceRequests: $1d31dcdfdfe25380$export$5c77a7ea15a04e63,
    classicSettingsDetails: $1d31dcdfdfe25380$export$dbf902576403f80e,
    classicSettingsPeople: $1d31dcdfdfe25380$export$458d0b4237ae1dad,
    classicSettingsSummary: $1d31dcdfdfe25380$export$3b5fbfd2bca32dde,
    classicSettingsIssueTypes: $1d31dcdfdfe25380$export$aeffbab88b3257bb,
    classicSettingsRequestTypes: $1d31dcdfdfe25380$export$7e3236de8c2c8fcb,
    classicSettingsChangeManagement: $1d31dcdfdfe25380$export$908f99db4c2098a0,
    classicSettingsCustomerPermissions: $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66,
    classicSettingsLanguage: $1d31dcdfdfe25380$export$f4e3d864ce1a2f74,
    classicSettingsPortal: $1d31dcdfdfe25380$export$21361d1ad00e769e,
    classicSettingsEmail: $1d31dcdfdfe25380$export$6208845cb364d4de,
    classicSettingsEmailAlias: $1d31dcdfdfe25380$export$16978d524c086b4,
    classicSettingsCustomerNotifications: $1d31dcdfdfe25380$export$b6d6b41b75346458,
    classicSettingsWidget: $1d31dcdfdfe25380$export$5b2153f9a7427657,
    classicSettingsFeedback: $1d31dcdfdfe25380$export$c5434c69e9b50e81,
    classicSettingsConfluence: $1d31dcdfdfe25380$export$3a7002667b72e8d7,
    classicSettingsSla: $1d31dcdfdfe25380$export$542a1f79f5837827,
    classicSettingsAutomation: $1d31dcdfdfe25380$export$b748c9dbd5996d34,
    classicSettingsApps: $1d31dcdfdfe25380$export$455a6199a321423,
    classicSettingsWorkflows: $1d31dcdfdfe25380$export$fa426b2da28e4ae2,
    classicSettingsScreens: $1d31dcdfdfe25380$export$fc0fba46b7584812,
    classicSettingsFields: $1d31dcdfdfe25380$export$882325faa1a194c6,
    classicSettingsVersions: $1d31dcdfdfe25380$export$8bb0073f55baf38b,
    classicSettingsComponents: $1d31dcdfdfe25380$export$1b69f3aa169f179,
    classicSettingsPermissions: $1d31dcdfdfe25380$export$1c47b1cb87da237,
    classicSettingsIssueSecurity: $1d31dcdfdfe25380$export$ee56a66aa8efb6da,
    classicSettingsNotifications: $1d31dcdfdfe25380$export$6256b4d737fa56f2,
    classicSettingsIssueCollectors: $1d31dcdfdfe25380$export$3f77d24f8de610a0
};
const $1d31dcdfdfe25380$export$e2c4f60e8cad01fb = (pathname)=>(0, (/*@__PURE__*/$parcel$interopDefault($2oOo5)))($1d31dcdfdfe25380$var$screenNameMap, (isCurrentScreen)=>isCurrentScreen(pathname)) || '';
const $1d31dcdfdfe25380$export$8715824c16ceeca0 = (error)=>// these are out of our control so treat them as expected
    (0, $JRB5w.isClientFetchError)(error);
const $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications'
    ],
    pathnameRegexesForNple: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications',
        // 'Portal Settings Page'
        '/jira/servicedesk/projects/[\\w\\d]+/settings/portal-settings',
        // 'People Page'
        '/plugins/servlet/project-config/[\\w\\d]+/people',
        // 'Getting Started Page'
        '/jira/servicedesk/projects/[\\w\\d]+/getting-started'
    ],
    routeNames: [
        // 'Reports',
        'servicedesk-reports',
        // 'Reports - Custom',
        'servicedesk-reports-custom',
        // 'Reports - Create',
        'servicedesk-reports-custom-create',
        // 'Reports - Edit',
        'servicedesk-reports-custom-edit',
        // 'Reports - Time Scale Issue',
        'servicedesk-reports-custom-time-scale-issue',
        // 'Reports - Time Scale',
        'servicedesk-reports-custom-time-scale',
        // 'Reports - Satisfaction',
        'servicedesk-reports-satisfaction',
        // 'Reports - Satisfaction Time Scale Issue',
        'servicedesk-reports-satisfaction-time-scale-issue',
        // 'Reports - Satisfaction TIme Scale',
        'servicedesk-reports-satisfaction-time-scale',
        // 'Reports - Summary',
        'servicedesk-reports-summary',
        // 'Reports - Type',
        'servicedesk-reports-type',
        // 'Reports - Workload',
        'servicedesk-reports-workload',
        // 'Queues - New',
        'servicedesk-queues-new',
        // 'Queues - Edit',
        'servicedesk-queues-edit'
    ]
};
const $1d31dcdfdfe25380$var$GSP_INCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        '/jira/people/search'
    ]
};
const $1d31dcdfdfe25380$export$83501d9ba065ef89 = (pathname)=>$1d31dcdfdfe25380$var$GSP_INCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $1d31dcdfdfe25380$export$8752a3c4a740bd52 = (pathname, isNpleForItsmEnabled)=>isNpleForItsmEnabled ? $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexesForNple.some((regex)=>new RegExp(regex).test(pathname)) : $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $1d31dcdfdfe25380$export$5d52a100c70d4375 = (currentRouteName)=>$1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.routeNames.some((routeName)=>routeName === currentRouteName);

});
parcelRegister("2oOo5", function(module, exports) {

var $1FGIk = parcelRequire("1FGIk");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $1bf4e8901877f248$var$findKey(object, predicate) {
    return $1FGIk(object, $7qARj(predicate, 3), $piimr);
}
module.exports = $1bf4e8901877f248$var$findKey;

});
parcelRegister("1FGIk", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $137ac0dffc9def22$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $137ac0dffc9def22$var$baseFindKey;

});



const $ae3aa738acb13786$export$a72c07e4474ec8ca = 'jiraServicedeskGettingStartedPanel';
const $ae3aa738acb13786$export$47712c7937145142 = 320;
const $ae3aa738acb13786$export$1cad4f611a1c0229 = 220;
const $ae3aa738acb13786$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPanel';
const $ae3aa738acb13786$export$bc8b984358922f81 = 'team';
const $ae3aa738acb13786$export$d59a8243d815f2eb = 'jsm-getting-started-panel';
const $ae3aa738acb13786$export$cbbd90bf5df877bd = 'cloudid';
const $ae3aa738acb13786$export$a74074a8f4372ab0 = 'referrer';

parcelRegister("isHzQ", function(module, exports) {

$parcel$export(module.exports, "handleOpsTeamMode", () => $c920f201dd81d401$export$b05151222ac96edd);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $iv53h = parcelRequire("iv53h");
var $ggLkh = parcelRequire("ggLkh");
async function $c920f201dd81d401$export$b05151222ac96edd(data, teamId, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset team centric items if they are set in the project page for the user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $iv53h.TaskId).ReviewOnCallSetup || item === (0, $iv53h.TaskId).AddIntegration) return false;
        return true;
    });
    // If user has not have right to see those items, we don't need to fetch them.
    if (mutatedData.properties.user['ops-admin-tasks-visibility'] === (0, $ggLkh.VisibilityValues).Visible) try {
        const teamCentricResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/team/${teamId}/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by setting team-centric items
        mutatedData.completedItems = [
            ...mutatedData?.completedItems,
            ...teamCentricResponse?.completedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'handleOpsTeamMode-TeamCentricResponse',
                    packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});
parcelRegister("ggLkh", function(module, exports) {

$parcel$export(module.exports, "OpsVisibilityKeys", () => $bd82d9f3d8b85873$export$3cae6a891a2fb0c1);
$parcel$export(module.exports, "SdVisibilityKeys", () => $bd82d9f3d8b85873$export$9ffa2df2d13a51e4);
$parcel$export(module.exports, "OgVisibilityKeys", () => $bd82d9f3d8b85873$export$37aa46ee833f23f2);
$parcel$export(module.exports, "VisibilityValues", () => $bd82d9f3d8b85873$export$b715b908ae0969fa);
$parcel$export(module.exports, "SdVisibilityRoles", () => $bd82d9f3d8b85873$export$47a23917fcedd235);
let $bd82d9f3d8b85873$export$3cae6a891a2fb0c1 = /*#__PURE__*/ function(OpsVisibilityKeys) {
    OpsVisibilityKeys["OpsTasksVisibility"] = "ops-tasks-visibility";
    OpsVisibilityKeys["OpsAdminTasksVisibility"] = "ops-admin-tasks-visibility";
    return OpsVisibilityKeys;
}({});
let $bd82d9f3d8b85873$export$9ffa2df2d13a51e4 = /*#__PURE__*/ function(SdVisibilityKeys) {
    SdVisibilityKeys["SdStandardTasksVisibility"] = "servicedesk-standard-tasks-visibility";
    SdVisibilityKeys["SdAdvancedTasksVisibility"] = "servicedesk-advanced-tasks-visibility";
    return SdVisibilityKeys;
}({});
let $bd82d9f3d8b85873$export$37aa46ee833f23f2 = /*#__PURE__*/ function(OgVisibilityKeys) {
    OgVisibilityKeys["OgSetupProfileForNotificationsTaskVisibility"] = "opsgenie-user-profile-notifications-setup-task-visibility";
    OgVisibilityKeys["OgSetupTeamTaskVisibility"] = "opsgenie-response-team-setup-task-visibility";
    OgVisibilityKeys["OgAssignOwnerTeamToServicesTaskVisibility"] = "opsgenie-owner-team-assigned-to-service-task-visibility";
    OgVisibilityKeys["OgLevelUpIncidentManagementTaskVisibility"] = "opsgenie-incident-management-documentation-accessed-task-visibility";
    return OgVisibilityKeys;
}({});
let $bd82d9f3d8b85873$export$b715b908ae0969fa = /*#__PURE__*/ function(VisibilityValues) {
    VisibilityValues["Hidden"] = "hidden";
    VisibilityValues["Visible"] = "visible";
    VisibilityValues["Unset"] = "unset";
    return VisibilityValues;
}({});
let $bd82d9f3d8b85873$export$47a23917fcedd235 = /*#__PURE__*/ function(SdVisibilityRoles) {
    SdVisibilityRoles["Advanced"] = "advanced";
    SdVisibilityRoles["Standard"] = "standard";
    return SdVisibilityRoles;
}({});

});


parcelRegister("ajx4y", function(module, exports) {

$parcel$export(module.exports, "handleUserCentricMode", () => $07f045f9f08d9204$export$10caa25085bdca55);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $iv53h = parcelRequire("iv53h");
async function $07f045f9f08d9204$export$10caa25085bdca55(data, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset user centric items if they are set in the ops team page for that user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $iv53h.TaskId).ReviewOnCallSetup || item === (0, $iv53h.TaskId).AddIntegration) return false;
        return true;
    });
    try {
        const userCentricResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by getting/setting user-centric endpoint
        const userCentricCompletedItems = userCentricResponse.completedItems.filter((item)=>{
            if (item === (0, $iv53h.TaskId).ReviewOnCallSetup || item === (0, $iv53h.TaskId).AddIntegration) return true;
            return false;
        });
        mutatedData.completedItems = [
            ...mutatedData.completedItems,
            ...userCentricCompletedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'handleUserCentricMode-UserCentricResponse',
                    packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});

parcelRegister("lKOEf", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $7814cf240c11be32$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "initializeState", () => $7814cf240c11be32$export$3ee49b4c70c0ec29);

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");

var $4qfky = parcelRequire("4qfky");
var $ggLkh = parcelRequire("ggLkh");

var $isHzQ = parcelRequire("isHzQ");

var $ajx4y = parcelRequire("ajx4y");

var $3ZIER = parcelRequire("3ZIER");
const $7814cf240c11be32$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/aggregate/list/jsm-getting-started-panel`;
const $7814cf240c11be32$export$3ee49b4c70c0ec29 = (actionProps)=>({ setState: setState, getState: getState, dispatch: dispatch })=>async ({ projectId: projectId })=>{
            const { baseUrl: baseUrl, cloudId: cloudId, isItsmSampleProject: isItsmSampleProject, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // Do not initialize unless it's known that project is not sample ITSM project
            if (isItsmSampleProject !== false) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmSampleProject)) (0, $guiFP.default)({
                    meta: {
                        id: 'initializeState_isItsmSampleProject_unknown',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    }
                });
                return;
            }
            const initializeStateOnce = async (attemptIndex, totalAttempts)=>{
                const isFinalAttempt = attemptIndex === totalAttempts - 1;
                // Stop any other updates to the state that might occur
                setState({
                    isSaving: true
                });
                // Fetch any existing data from ST (this will include any task visibility keys)
                let response;
                try {
                    response = await (0, $2OdyW.default)($7814cf240c11be32$export$94df0e59ebebf4a7({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode === 404) {
                        setState({
                            isSaving: false,
                            isGspInitialized: false
                        });
                        return;
                    }
                    setState({
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'initializeState_fetch',
                            packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
                // TODO: validate properly https://jdog.jira-dev.com/browse/JIG-392
                // We can't use constructDataFromResponse because initial server data only
                // contains a subset of the full GSP state (just task visiblity keys)
                const serverData = response;
                /* Merge in server values and defaults, according to the following:
			 *  - completedItems from default state, to allow for reset behaviour with FSF override flag
			 *  - properties comes from server values first, to add task visibility and non-user properties
			 *  - default state user properties are merged in over the top of server properties to reset
			 *    things like sectionState, activeState, visualState, hasSeenReopenSpotlight in the
			 *    case of FSF override flag where server state already exists.
			 *    Assumption: the only properties contained in the default state are user properties
			 *  - projectId from current project
			 */ let data = {
                    completedItems: (0, $4qfky.defaultGspState).completedItems,
                    properties: {
                        ...serverData.properties,
                        user: {
                            ...serverData.properties.user,
                            ...(0, $4qfky.defaultGspState).properties.user,
                            projectId: projectId
                        }
                    }
                };
                if (enableUserCentricMode && data) data = await (0, $ajx4y.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = getState().data?.properties.user['ops-admin-tasks-visibility'] ?? (0, $ggLkh.VisibilityValues).Hidden;
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $isHzQ.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Save our newly merged state
                try {
                    setState({
                        data: data,
                        isGspInitialized: true,
                        isSaving: false
                    });
                    await dispatch((0, $3ZIER.savePanelState)(actionProps))(data);
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.initializeState succeeded`);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    setState({
                        isGspInitialized: true,
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'initializeState',
                            packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
            await (0, $3gGTI.withExponentialBackoffRetries)({
                callback: initializeStateOnce,
                totalAttempts: 5,
                baseIntervalMs: 500
            });
        };

});
parcelRegister("3gGTI", function(module, exports) {

$parcel$export(module.exports, "withExponentialBackoffRetries", () => $06938d82719cce50$export$344601bd15a7b6d);
const $06938d82719cce50$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $06938d82719cce50$export$344601bd15a7b6d = async ({ callback: callback, totalAttempts: totalAttempts, baseIntervalMs: baseIntervalMs })=>{
    for(let attemptIndex = 0; attemptIndex < totalAttempts; attemptIndex += 1)/* eslint-disable no-await-in-loop */ try {
        return await callback(attemptIndex, totalAttempts);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (attemptIndex + 1 < totalAttempts) // if retry attempts remain, wait time before trying again
        await $06938d82719cce50$var$waitTimeMs(baseIntervalMs * Math.pow(2, attemptIndex));
        else // else if no more attempts, throw the error
        throw error;
    }
    throw Error('withExponentialBackoffRetries should not reach');
};

});

parcelRegister("4qfky", function(module, exports) {

$parcel$export(module.exports, "defaultGspState", () => $33857b725e2d797c$export$4db8363977bdf2d4);
$parcel$export(module.exports, "GSP", () => $33857b725e2d797c$export$1cb8c028028700ec);

var $iv53h = parcelRequire("iv53h");
// This is duplicated to avoid importing from section-state
// to attempt to keep bundle size down.
// These values must be manually kept in sync.
const $33857b725e2d797c$var$defaultSectionStateV2 = {
    version: 2,
    activeSection: (0, $iv53h.GspSectionKey).Home,
    sections: {
        checklist: {
            headerState: (0, $iv53h.HeaderState).Expanded,
            activeTab: (0, $iv53h.ChecklistTabKey).Basics,
            tabs: {
                basics: {
                    activeTask: undefined
                },
                teamEfficiency: {
                    activeTask: undefined
                },
                incidents: {
                    activeTask: undefined
                },
                changes: {
                    activeTask: undefined
                },
                alerts: {
                    activeTask: undefined
                }
            }
        },
        productTours: {
            headerState: (0, $iv53h.HeaderState).Expanded,
            activeTour: (0, $iv53h.ProductTourKey).Welcome
        }
    }
};
const $33857b725e2d797c$export$4db8363977bdf2d4 = {
    completedItems: [
        (0, $iv53h.TaskId).CreateItsmProject
    ],
    properties: {
        containers: [],
        user: {
            activeState: (0, $iv53h.ActiveState).On,
            visualState: (0, $iv53h.VisualState).FullPanel,
            sectionState: JSON.stringify($33857b725e2d797c$var$defaultSectionStateV2),
            hasSeenReopenSpotlight: (0, $iv53h.HasSeenReopenSpotlight).No
        }
    }
};
const $33857b725e2d797c$export$1cb8c028028700ec = 'GettingStartedPanel';

});

parcelRegister("3ZIER", function(module, exports) {

$parcel$export(module.exports, "savePanelState", () => $98e7316a9047ea56$export$8756ef0989d9dd58);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");
const $98e7316a9047ea56$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $98e7316a9047ea56$export$8756ef0989d9dd58 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (state)=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save panel state without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: state,
                    isSaving: true
                });
                const { sectionState: sectionState, activeState: activeState, visualState: visualState, projectId: projectId, hasSeenReopenSpotlight: hasSeenReopenSpotlight } = state.properties.user;
                await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: ()=>(0, $5G2eQ.default)($98e7316a9047ea56$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                sectionState: sectionState,
                                activeState: activeState,
                                visualState: visualState,
                                projectId: projectId,
                                hasSeenReopenSpotlight: hasSeenReopenSpotlight
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.savePanelState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'savePanelState',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("5G2eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fb25724578ccf$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");
const $0d9fb25724578ccf$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fb25724578ccf$export$2e2bcd8739ae039 = (url, options = {})=>(0, $3JafE.Observable).of(url).mergeMap(()=>fetch(url, (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), options), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0d9fb25724578ccf$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $3JafE.Observable).of(response.responseText || 'OK');
    });

});




parcelRegister("zvnJx", function(module, exports) {

$parcel$export(module.exports, "markReopenSpotlightAsSeen", () => $63ec54d2a46c288c$export$e6838fe71dc9c3f5);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");


var $iv53h = parcelRequire("iv53h");

var $3ZIER = parcelRequire("3ZIER");
const $63ec54d2a46c288c$export$e6838fe71dc9c3f5 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ()=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to mark reopen spotlight as seen without current state');
                await dispatch((0, $3ZIER.savePanelState)(actionProps))({
                    ...data,
                    properties: {
                        ...data.properties,
                        user: {
                            ...data.properties.user,
                            hasSeenReopenSpotlight: (0, $iv53h.HasSeenReopenSpotlight).Yes
                        }
                    }
                });
                (0, $jMP2a.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.markReopenSpotlightAsSeen succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'markReopenSpotlightAsSeen',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("82jJZ", function(module, exports) {

$parcel$export(module.exports, "reopenGettingStartedPanel", () => $e6623632044ca83f$export$3f8a23b1578c0a37);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");

var $iv53h = parcelRequire("iv53h");

var $lKOEf = parcelRequire("lKOEf");

var $aXUph = parcelRequire("aXUph");
const $e6623632044ca83f$export$3f8a23b1578c0a37 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ({ projectId: projectId } = {})=>{
            const getStateIfLoaded = async ()=>{
                const state = getState();
                const dataNotYetLoaded = state.isGspInitialized && state.data === undefined;
                if (dataNotYetLoaded) throw new Error('GSP data not yet loaded when trying to reopen');
                return state;
            };
            try {
                // a user can exit a tour and call `reopenGettingStartedPanel` before the GSP
                // state has loaded so retry a few times and hopefully the data will be there.
                // This will only log the final error that is thrown after the retries are exhausted.
                // 6 attempts at 500ms base interval gives us a ~15 second window. We could wait longer
                // but then the GSP reopening would be so far removed from closing the tour that it
                // probably isn't the user experience that we want
                const { data: data, isGspInitialized: isGspInitialized } = await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: getStateIfLoaded,
                    totalAttempts: 6,
                    baseIntervalMs: 500
                });
                if (!isGspInitialized) {
                    if (projectId !== undefined) {
                        await dispatch((0, $lKOEf.initializeState)(actionProps))({
                            projectId: projectId
                        });
                        return;
                    }
                    throw new Error('No projectId to initialize GSP with');
                }
                if (!data) throw new Error('Trying to reopen GSP without current state');
                await dispatch((0, $aXUph.saveProperty)(actionProps))({
                    key: (0, $iv53h.PropertyKey).VisualState,
                    value: (0, $iv53h.VisualState).FullPanel
                });
                await dispatch((0, $aXUph.saveProperty)(actionProps))({
                    key: (0, $iv53h.PropertyKey).ActiveState,
                    value: (0, $iv53h.ActiveState).On
                });
                (0, $jMP2a.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.reopenGettingStartedPanel succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'reopenGettingStartedPanel',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("aXUph", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $4fd2e9e2afb8272e$export$3d751d226e9d1512);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");
const $4fd2e9e2afb8272e$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $4fd2e9e2afb8272e$export$3d751d226e9d1512 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async ({ key: key, value: value })=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save property without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                [key.toString()]: value
                            }
                        }
                    },
                    isSaving: true
                });
                await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: ()=>(0, $5G2eQ.default)($4fd2e9e2afb8272e$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                [key.toString()]: value
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.saveProperty succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'saveProperty',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});


parcelRegister("kYwcF", function(module, exports) {

$parcel$export(module.exports, "resolveTask", () => $e0acf0603356b206$export$7c43f246bcca61d3);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");

var $6vrw7 = parcelRequire("6vrw7");
// Data taken from https://hello.atlassian.net/wiki/spaces/VPORT/pages/808505558/Checklist+Item+Scope+Auto+API+for+Completion
// where 'project' === 'container', 'user' === 'user' and 'instance' === 'workspace'
const $e0acf0603356b206$var$getScopeFromTaskId = (taskId)=>{
    switch(taskId){
        // String literals used instead of `TaskId.<task>` for flow to acknowledge
        // that this is an exhaustive switch statement
        case 'servicedesk-itsm-project-created':
        case 'servicedesk-portal-name-customized':
        case 'servicedesk-logo-added-to-portal':
        case 'servicedesk-email-requests-setup':
        case 'servicedesk-team-member-added':
            return 'container';
        case 'servicedesk-change-management-documentation-accessed':
        case 'servicedesk-basics-documentation-accessed':
        case 'servicedesk-queue-configurations-reviewed':
        case 'servicedesk-request-types-customised':
        case 'servicedesk-request-channels-email-portal-requests-customised':
        case 'servicedesk-chat-requests-setup':
        case 'servicedesk-team-efficiency-automate-your-work':
        case 'servicedesk-team-efficiency-setup-knowledge-base':
            return 'user';
        case 'servicedesk-services-setup':
        case 'servicedesk-change-management-pipeline-connected':
        case 'servicedesk-change-management-change-approvers-added':
        case 'servicedesk-change-management-automation-rules-on':
            return 'workspace';
        // Note that the following should only ever be completed in
        // Opsgenie but they are included here for type completeness
        case 'opsgenie-user-profile-notifications-setup':
        case 'opsgenie-incident-management-documentation-accessed':
            return 'user';
        case 'opsgenie-response-team-setup':
        case 'opsgenie-owner-team-assigned-to-service':
            return 'workspace';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            taskId; // type level assertion that we have an exhaustive switch
            throw new Error(`Unknown scope for task ${taskId}`); // runtime assertion
    }
};
const $e0acf0603356b206$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId, scope: scope, projectId: projectId, taskId: taskId })=>{
    let scopePath = ''; // scope === 'workspace'
    if (scope === 'container') scopePath = `project/${projectId}/`;
    if (scope === 'user') scopePath = 'user/';
    return `${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/${scopePath}list/jsm-getting-started-panel/item/${taskId}`;
};
const $e0acf0603356b206$export$7c43f246bcca61d3 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (taskId)=>{
            const { data: data } = getState();
            try {
                if (!data) return;
                const { completedItems: completedItems, properties: properties } = data;
                const isTaskAlreadyCompleted = completedItems.includes(taskId);
                if (!isTaskAlreadyCompleted) {
                    const updatedTasks = [
                        ...completedItems,
                        taskId
                    ];
                    // Set the state locally without waiting for the API call
                    setState({
                        data: {
                            ...data,
                            completedItems: updatedTasks
                        },
                        isSaving: true
                    });
                    // Hit the appropriate checklist scope endpoint to add the newly completed task
                    const scope = $e0acf0603356b206$var$getScopeFromTaskId(taskId);
                    const projectId = (0, $6vrw7.toProjectId)(properties.user.projectId || '');
                    await (0, $3gGTI.withExponentialBackoffRetries)({
                        callback: ()=>(0, $5G2eQ.default)($e0acf0603356b206$export$94df0e59ebebf4a7({
                                baseUrl: baseUrl,
                                cloudId: cloudId,
                                scope: scope,
                                projectId: projectId,
                                taskId: taskId
                            }), {
                                method: 'POST',
                                credentials: 'include'
                            }).toPromise(),
                        totalAttempts: 5,
                        baseIntervalMs: 500
                    });
                    // Resume polling for GSP state
                    setState({
                        isSaving: false
                    });
                }
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.resolveTask succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'resolveTask',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("1mctb", function(module, exports) {

$parcel$export(module.exports, "setOpsAdminTaskVisibility", () => $ac16bf64e18ce8db$export$b9e7846826f1ebfd);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $ggLkh = parcelRequire("ggLkh");
const $ac16bf64e18ce8db$export$b9e7846826f1ebfd = ({ teamId: teamId, cloudId: cloudId })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data } = getState();
            if (!data) throw new Error('Trying to set ops admin task visibility without current GSP state.');
            try {
                const adminTaskVisibilityResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/full-panel-access?platformTeamId=${teamId}
            `, {
                    method: 'GET'
                });
                const visibility = adminTaskVisibilityResponse.embeddedValue ? (0, $ggLkh.VisibilityValues).Visible : (0, $ggLkh.VisibilityValues).Hidden;
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': visibility
                            }
                        }
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': (0, $ggLkh.VisibilityValues).Hidden
                            }
                        }
                    }
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'setOpsAdminTaskVisibility',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                        teamName: 'Alexstrasza'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});

parcelRegister("ghO9h", function(module, exports) {

$parcel$export(module.exports, "stopRecordingPerformanceExperiences", () => $73f30f16f4664d6e$export$3566fd94709fa84a);
const $73f30f16f4664d6e$export$3566fd94709fa84a = ()=>({ setState: setState })=>()=>{
            setState({
                shouldRecordPerformanceExperiences: false
            });
        };

});



parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hfiyN")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hTkS8")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("c3XjM")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eTjqX")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("hfiyN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kd6Ju');
        const value = parcelRequire('appSk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kd6Ju").then(()=>parcelRequire('appSk'));
}

});

parcelRegister("hTkS8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('5eFqM')
        ]);
        const value = parcelRequire('ddfk6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("5eFqM")
    ]).then(()=>parcelRequire('ddfk6'));
}

});

parcelRegister("c3XjM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ahRif')
        ]);
        const value = parcelRequire('1HvEW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ahRif")
    ]).then(()=>parcelRequire('1HvEW'));
}

});

parcelRegister("eTjqX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cxrYi')
        ]);
        const value = parcelRequire('f9sDQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cxrYi")
    ]).then(()=>parcelRequire('f9sDQ'));
}

});


parcelRegister("3e4zR", function(module, exports) {

$parcel$export(module.exports, "useInitializeActiveTab", () => $fca831ba939738e0$export$b0f185249c3d08fd);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $2j5ni = parcelRequire("2j5ni");

var $dWvpo = parcelRequire("dWvpo");

var $4qfky = parcelRequire("4qfky");
var $iv53h = parcelRequire("iv53h");
const $fca831ba939738e0$export$b0f185249c3d08fd = (activeTabName, gspProjectId)=>{
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $2j5ni.useIsFirstProjectITSM)(gspProjectId);
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const [{ data: gspStateData }, { saveProperty: saveProperty }] = (0, $dWvpo.useGettingStartedPanelState)();
    const [isInitializedActiveTab, setIsInitializedActiveTab] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitializedActiveTab && isNpleForItsmEnabled && gspStateData) {
            const sectionStateJSON = gspStateData.properties?.user?.sectionState ?? (0, $4qfky.defaultGspState).properties.user.sectionState;
            const sectionState = JSON.parse(sectionStateJSON);
            if (sectionState.sections.checklist.activeTab !== activeTabName) {
                sectionState.sections.checklist.activeTab = activeTabName;
                saveProperty({
                    key: (0, $iv53h.PropertyKey).SectionState,
                    value: JSON.stringify(sectionState)
                });
            }
            setIsInitializedActiveTab(true);
        }
    }, [
        isNpleForItsmEnabled,
        gspStateData,
        saveProperty,
        activeTabName,
        isInitializedActiveTab
    ]);
};

});

parcelRegister("51ACp", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $7c9b058abf515682$export$d852f51b8427aefc);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $dsNuc = parcelRequire("dsNuc");
// eslint-disable-next-line jira/react/no-class-components
class $7c9b058abf515682$var$HistoryAdapterComponent extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $dsNuc.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $7c9b058abf515682$export$d852f51b8427aefc = (0, $kJlBc.withRouter)($7c9b058abf515682$var$HistoryAdapterComponent);

});
parcelRegister("dsNuc", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $03e13d3d865e0b52$export$2df73cd79c2401bf);

var $6l6Xk = parcelRequire("6l6Xk");
const $03e13d3d865e0b52$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("2VrwK", function(module, exports) {

$parcel$export(module.exports, "default", () => $221641f20c8411b0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bM4tF = parcelRequire("bM4tF");
var $jPMlZ = parcelRequire("jPMlZ");

var $37mOt = parcelRequire("37mOt");

var $ecKpb = parcelRequire("ecKpb");

const $221641f20c8411b0$var$EmbeddableDirectory = (props)=>{
    const { addFlag: addFlag, appName: appName, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, locale: locale, push: push, replace: replace, docTitle: docTitle, statusCodeHandlers: statusCodeHandlers, env: env, history: history, isSentryEnabled: isSentryEnabled = true, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, subProduct: subProduct, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers } = props;
    if (env) (0, $37mOt.setEnv)(env);
    const analyticsClient = (0, $bM4tF.useSetupAnalyticsClient)(cloudId, appName, subProduct);
    const apolloClient = (0, $jPMlZ.useSetupApolloClient)(cloudId);
    if (!analyticsClient) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ecKpb.default), {
        apolloClient: apolloClient,
        analytics: analyticsClient,
        appName: appName,
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        env: env,
        push: push,
        replace: replace,
        addFlag: addFlag,
        locale: locale,
        docTitle: docTitle,
        statusCodeHandlers: statusCodeHandlers,
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        teamCentralHandlers: teamCentralHandlers,
        skipI18nProvider: false,
        productFeatureFlags: productFeatureFlags,
        invitePeopleHandlers: invitePeopleHandlers,
        isSentryEnabled: isSentryEnabled
    });
};
var $221641f20c8411b0$export$2e2bcd8739ae039 = $221641f20c8411b0$var$EmbeddableDirectory;

});
parcelRegister("bM4tF", function(module, exports) {

$parcel$export(module.exports, "useSetupAnalyticsClient", () => $8927a686cdecd7c9$export$bcd55e98e7c6e45e);

var $eUqFw = parcelRequire("eUqFw");

var $35bvV = parcelRequire("35bvV");
function $8927a686cdecd7c9$var$getAnalyticsSubproduct(appName, subProduct) {
    if (!subProduct) return appName;
    return `jira-${subProduct}-directory`;
}
function $8927a686cdecd7c9$export$bcd55e98e7c6e45e(cloudId, appName, subProduct) {
    const analyticsSubProduct = $8927a686cdecd7c9$var$getAnalyticsSubproduct(appName, subProduct);
    const [analyticsClient, setAnalyticsClient] = (0, $eUqFw.useState)((0, $35bvV.getAnalyticsClient)({
        mode: appName,
        subproduct: analyticsSubProduct,
        cloudId: cloudId
    }));
    // setup analytics object
    (0, $eUqFw.useEffect)(()=>{
        if (!cloudId) return;
        const analytics = (0, $35bvV.getAnalyticsClient)({
            mode: appName,
            subproduct: analyticsSubProduct,
            cloudId: cloudId
        });
        setAnalyticsClient(analytics);
    }, [
        cloudId,
        analyticsSubProduct,
        appName
    ]);
    // TODO: fix-me - currently, cloudId is required to render People app.
    // When analytics client without cloud id is used, Cypress test `dev-packages/cypress/src/specs/analytics.spec.ts` is flaky.
    // It seems that the analytics client without cloud id used first, then analytics client with cloud is replaced, but the app does not re-render in Cypress tests.
    return cloudId ? analyticsClient : undefined;
}

});
parcelRegister("35bvV", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $23eac5298b2b6c23$export$fde53e78fd93a54d);

var $aYU4Z = parcelRequire("aYU4Z");
var $hRleJ = parcelRequire("hRleJ");

var $4GU27 = parcelRequire("4GU27");
var $avLBj = parcelRequire("avLBj");
var $37mOt = parcelRequire("37mOt");

var $aPkDp = parcelRequire("aPkDp");

var $7sTpx = parcelRequire("7sTpx");

var $akWuj = parcelRequire("akWuj");

var $53jQw = parcelRequire("53jQw");
function $23eac5298b2b6c23$var$getServerName() {
    return window.location.hostname;
}
const { LOCAL: $23eac5298b2b6c23$var$LOCAL, DEV: $23eac5298b2b6c23$var$DEV, STAGING: $23eac5298b2b6c23$var$STAGING, PROD: $23eac5298b2b6c23$var$PROD } = (0, $hRleJ.envType);
const $23eac5298b2b6c23$var$ENV_MAP = {
    local: $23eac5298b2b6c23$var$LOCAL,
    test: $23eac5298b2b6c23$var$LOCAL,
    adev: $23eac5298b2b6c23$var$DEV,
    'stg-east': $23eac5298b2b6c23$var$STAGING,
    stg: $23eac5298b2b6c23$var$STAGING
};
const $23eac5298b2b6c23$var$getEnvType = (env)=>{
    return $23eac5298b2b6c23$var$ENV_MAP[env] || $23eac5298b2b6c23$var$PROD;
};
const $23eac5298b2b6c23$var$analyticsConfig = (0, $avLBj.getConfig)().analytics;
const $23eac5298b2b6c23$var$SUB_PRODUCT_DEFAULT = 'siteDirectory';
const $23eac5298b2b6c23$var$PRODUCT_DEFAULT = 'people';
// tslint:disable-line no-any
class $23eac5298b2b6c23$var$AnalyticsClient {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, { commonProperties: commonProperties = {}, eventPrefix: eventPrefix = 'atlassian.people', subproduct: subproduct = $23eac5298b2b6c23$var$SUB_PRODUCT_DEFAULT, cloudId: cloudId = '' } = {}){
        const customOptions = {
            commonProperties: commonProperties,
            eventPrefix: eventPrefix
        };
        this.cloudId = cloudId;
        this.commonProperties = customOptions.commonProperties;
        this.eventPrefix = customOptions.eventPrefix;
        this.state = {
            analyticsscheme: $23eac5298b2b6c23$var$analyticsConfig.scheme,
            analyticsserver: $23eac5298b2b6c23$var$analyticsConfig.server,
            server: $23eac5298b2b6c23$var$getServerName(),
            product: $23eac5298b2b6c23$var$PRODUCT_DEFAULT,
            isReadyToSend: false,
            pendingEventsQueue: [],
            storage_key: 'atlassian.people.analytics',
            ...options
        };
        // New GAS pipeline client
        this.analyticsWebClient = new (0, $aYU4Z.default)({
            env: $23eac5298b2b6c23$var$getEnvType((0, $37mOt.getEnv)()),
            product: 'people',
            subproduct: subproduct
        }, {});
        this.initUFO();
        this._expTracker = (0, $akWuj.configureNewTracker)(this);
    }
    initUFO() {
        if ((0, $4GU27.getAppName)() !== (0, $4GU27.AppNames).STANDALONE_DIRECTORY) return;
        (0, $aPkDp.payloadPublisher).setup({
            gasv3: this.analyticsWebClient,
            product: 'people',
            app: {
                // @ts-ignore
                version: {
                    web: __VERSION__
                }
            },
            region: (0, $37mOt.getEnv)()
        });
    // import { ufologger } from @atlassian/ufo and uncomment the following line to see UFO logs:
    // ufologger.enable();
    }
    getAnalyticsWebClient() {
        return this.analyticsWebClient;
    }
    expTracker() {
        return this._expTracker;
    }
    sendTrackEvent(eventData) {
        this.analyticsWebClient.sendTrackEvent(eventData);
    }
    /**
   * Checks whether the library has been initialized and decides whether the event should be sent or cached
   * @param {*} eventType Values could be 'track', 'screen', 'operation, 'ui'
   * @param {*} eventData Data of the event
   * @param {Function} cb Callback is called when the event is sent successfully.
   */ canEventBeSent(eventType, eventData, cb) {
        if (this.state.isReadyToSend) return true;
        // add to `pendingEventsQueue` in order to send the event later
        this.state.pendingEventsQueue.push({
            eventType: eventType,
            eventData: eventData,
            // `eventCallback` is called when `pendingEventsQueue` is processed and eventData is sent
            eventCallback: cb
        });
        return false;
    }
    pushTrackEvent(eventData, cb) {
        if (this.canEventBeSent('track', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendTrackEvent(event, cb);
        }
    }
    pushUIEvent(eventData, cb) {
        if (this.canEventBeSent('ui', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendUIEvent(event, cb);
        }
    }
    pushOperationalEvent(eventData, cb) {
        if (this.canEventBeSent('operation', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendOperationalEvent(event, cb);
        }
    }
    pushScreenEvent(eventData, cb) {
        const additionalAttributes = (0, $53jQw.default).get();
        (0, $53jQw.default).markUsed();
        if (eventData && additionalAttributes) eventData = {
            ...eventData,
            attributes: {
                ...additionalAttributes,
                ...eventData.attributes
            }
        };
        if (this.canEventBeSent('screen', eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
    }
    buildEventPayload(eventData) {
        return {
            containerType: null,
            containerId: null,
            objectType: null,
            objectId: null,
            source: null,
            actionSubject: null,
            action: null,
            actionSubjectId: null,
            attributes: null,
            tags: [],
            ...eventData
        };
    }
    mapAnalyticsKeyToEvent(analyticsKey) {
        return (0, $7sTpx.analyticsKeyToEventMap)[analyticsKey] || null;
    }
    /**
   *  Start up E-MAU events in the new analytics pipeline (GAS v3)
   *  See: https://extranet.atlassian.com/display/BPO/DACI%3A+E-MAU+Definition
   */ async startUIViewedEvent(principalUserId) {
        if (!principalUserId) return;
        this.analyticsWebClient.setTenantInfo((0, $hRleJ.tenantType).CLOUD_ID, this.cloudId || '');
        this.analyticsWebClient.setUserInfo((0, $hRleJ.userType).ATLASSIAN_ACCOUNT, principalUserId);
        this.analyticsWebClient.startUIViewedEvent();
        this.state.isReadyToSend = true;
        this.flushPendingEventsQueue();
    }
    /**
   * Flush all the pending events in the queue
   */ flushPendingEventsQueue() {
        this.state.pendingEventsQueue.forEach((element)=>{
            const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
            switch(eventType){
                case 'track':
                    this.pushTrackEvent(eventData, eventCallback);
                    break;
                case 'ui':
                    this.pushUIEvent(eventData, eventCallback);
                    break;
                case 'screen':
                    this.pushScreenEvent(eventData, eventCallback);
                    break;
                case 'operation':
                    this.pushOperationalEvent(eventData, eventCallback);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.error('Invalide Event :', element);
                    break;
            }
        });
    }
}
var $23eac5298b2b6c23$export$2e2bcd8739ae039 = $23eac5298b2b6c23$var$AnalyticsClient;
let $23eac5298b2b6c23$var$preservedAnaylticsClient;
const $23eac5298b2b6c23$export$fde53e78fd93a54d = ({ mode: mode, subproduct: subproduct, cloudId: cloudId })=>{
    if (!cloudId) return;
    if ($23eac5298b2b6c23$var$preservedAnaylticsClient) return $23eac5298b2b6c23$var$preservedAnaylticsClient;
    $23eac5298b2b6c23$var$preservedAnaylticsClient = new $23eac5298b2b6c23$var$AnalyticsClient({}, {
        commonProperties: {
            mode: mode
        },
        subproduct: subproduct,
        cloudId: cloudId
    });
    return $23eac5298b2b6c23$var$preservedAnaylticsClient;
};

});
parcelRegister("4GU27", function(module, exports) {

$parcel$export(module.exports, "AppNames", () => $12268ee2ffd3be16$export$b767e803e7ca9563);
$parcel$export(module.exports, "getAppName", () => $12268ee2ffd3be16$export$dcecb2dbc7fe753c);
var $12268ee2ffd3be16$export$b767e803e7ca9563;
(function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
})($12268ee2ffd3be16$export$b767e803e7ca9563 || ($12268ee2ffd3be16$export$b767e803e7ca9563 = {}));
function $12268ee2ffd3be16$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}

});

parcelRegister("avLBj", function(module, exports) {

$parcel$export(module.exports, "isFedramp", () => $3c24c4ec25204a15$export$634ecc602a6871aa);
$parcel$export(module.exports, "getConfig", () => $3c24c4ec25204a15$export$44487a86467333c3);

var $1Zvbf = parcelRequire("1Zvbf");

var $dfBCt = parcelRequire("dfBCt");

var $4GU27 = parcelRequire("4GU27");

var $37mOt = parcelRequire("37mOt");

var $fU34a = parcelRequire("fU34a");
// default configs is also config for production env
const $3c24c4ec25204a15$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard'
};
const $3c24c4ec25204a15$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $3c24c4ec25204a15$var$environmentOverrides = {
    'prod-east': $3c24c4ec25204a15$var$productionConfig,
    local: {
        ...(0, $fU34a.LOCAL_PRODUCTION_BACKEND) ? $3c24c4ec25204a15$var$productionConfig : $3c24c4ec25204a15$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: `${(0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).location.hostname}:3000`
        }
    },
    test: {
        ...$3c24c4ec25204a15$var$localAndTestConfig
    },
    adev: $3c24c4ec25204a15$var$devAndStagingConfig,
    'stg-east': $3c24c4ec25204a15$var$devAndStagingConfig,
    fedramp: $3c24c4ec25204a15$var$fedrampConfig
};
const $3c24c4ec25204a15$var$cachedConfig = {};
function $3c24c4ec25204a15$export$634ecc602a6871aa() {
    return (0, $dfBCt.isFedRamp)();
}
function $3c24c4ec25204a15$export$44487a86467333c3() {
    const env = $3c24c4ec25204a15$export$634ecc602a6871aa() ? 'fedramp' : (0, $37mOt.getEnv)();
    const appName = (0, $4GU27.getAppName)();
    const key = `${env}_${appName}`;
    if (!$3c24c4ec25204a15$var$cachedConfig[key]) {
        if ($3c24c4ec25204a15$var$EnvOverrideKeys.includes(env)) $3c24c4ec25204a15$var$cachedConfig[key] = {
            ...$3c24c4ec25204a15$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $3c24c4ec25204a15$var$cachedConfig[key] = {
            ...$3c24c4ec25204a15$var$environmentOverrides['prod-east']
        };
    }
    return $3c24c4ec25204a15$var$cachedConfig[key];
}

});
parcelRegister("37mOt", function(module, exports) {

$parcel$export(module.exports, "setEnv", () => $90cb06051ad5805a$export$84bc02d3c7a6b55f);
$parcel$export(module.exports, "getEnv", () => $90cb06051ad5805a$export$4bd44a2aa29d3d6e);

var $1Zvbf = parcelRequire("1Zvbf");

var $fU34a = parcelRequire("fU34a");
var $90cb06051ad5805a$export$e7dfafc24fab792e;
(function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
})($90cb06051ad5805a$export$e7dfafc24fab792e || ($90cb06051ad5805a$export$e7dfafc24fab792e = {}));
const $90cb06051ad5805a$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $90cb06051ad5805a$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $90cb06051ad5805a$var$presetEnv;
const $90cb06051ad5805a$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $90cb06051ad5805a$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $90cb06051ad5805a$var$presetEnv = envOverride;
};
function $90cb06051ad5805a$export$4bd44a2aa29d3d6e() {
    if ($90cb06051ad5805a$var$presetEnv) return $90cb06051ad5805a$var$presetEnv;
    if (0, $fU34a.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).__env__;
}
function $90cb06051ad5805a$export$15b8d8b1ba394f55() {
    return $90cb06051ad5805a$export$d76bdf9f4281ae1b[$90cb06051ad5805a$export$4bd44a2aa29d3d6e()];
}

});
parcelRegister("fU34a", function(module, exports) {

$parcel$export(module.exports, "DEV", () => $2486455d18d42cfe$export$404582bc18fe4d9e);
$parcel$export(module.exports, "LOCAL_PRODUCTION_BACKEND", () => $2486455d18d42cfe$export$771a63345d182ddd);
// @ts-ignore
const $2486455d18d42cfe$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $2486455d18d42cfe$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;

});



parcelRegister("7sTpx", function(module, exports) {

$parcel$export(module.exports, "AnalyticsKeys", () => $56f6215c0eb64b43$export$e8d1ded05852e864);
$parcel$export(module.exports, "analyticsKeyToEventMap", () => $56f6215c0eb64b43$export$6430c2bbc66a6fa);
$parcel$export(module.exports, "AnalyticsEventSource", () => $56f6215c0eb64b43$export$2102531865f3e90e);
$parcel$export(module.exports, "AnalyticsEventActions", () => $56f6215c0eb64b43$export$74eee170ad238aae);
$parcel$export(module.exports, "AnalyticsEventSubjects", () => $56f6215c0eb64b43$export$670f80b77450980d);
const $56f6215c0eb64b43$export$e8d1ded05852e864 = {
    ACTIVITY_ALL_VIEW: 'activity.all.view',
    ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
    HISTORY_VIEW: 'history.view',
    PEOPLE_VIEW: 'people-search.view',
    PROFILE_PAGE_VIEW: 'profile-page.view',
    PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
    PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
    PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
    PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
    PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
    PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
    PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
    PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
    PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: 'profile-settings.security.two-step-verification.view',
    PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
    PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
    PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
    TEAM_PROFILE_VIEW: 'team-profile.view',
    KUDOS_PAGE_VIEW: 'kudos-page.view',
    TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
    ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',
    // TODO: remove these once we move to a new analytics platform
    LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view'
};
const $56f6215c0eb64b43$export$6430c2bbc66a6fa = {
    [$56f6215c0eb64b43$export$e8d1ded05852e864.PROFILE_PAGE_VIEW]: 'userProfile',
    [$56f6215c0eb64b43$export$e8d1ded05852e864.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage'
};
let $56f6215c0eb64b43$export$2102531865f3e90e = /*#__PURE__*/ function(AnalyticsEventSource) {
    AnalyticsEventSource["USER_PROFILE_SCREEN"] = "userProfileScreen";
    AnalyticsEventSource["USER_PROFILE_ABOUT"] = "userProfileAbout";
    AnalyticsEventSource["USER_WORK_SCREEN"] = "userWorkScreen";
    AnalyticsEventSource["TEAM_PROFILE_SCREEN"] = "teamProfileScreen";
    AnalyticsEventSource["TEAM_PROFILE_ABOUT"] = "teamProfileAbout";
    AnalyticsEventSource["TEAM_RESTORE_SCREEN"] = "teamRestoreScreen";
    AnalyticsEventSource["TEAM_RESTORE_SUCCESS_FLAG"] = "teamReactivatedSuccessflag";
    AnalyticsEventSource["TEAM_RESTORE_ERROR_FLAG"] = "teamReactivatedErrorflag";
    AnalyticsEventSource["CREATE_TEAM_MODAL"] = "createTeamModal";
    AnalyticsEventSource["DIRECTORY_SCREEN"] = "directoryScreen";
    AnalyticsEventSource["PEOPLE_HOME"] = "peopleHome";
    AnalyticsEventSource["PEOPLE_DRAWER"] = "peopleDrawer";
    AnalyticsEventSource["USER_MENU"] = "userMenu";
    AnalyticsEventSource["ADD_PEOPLE_MODAL"] = "addPeopleModal";
    AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
    AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
    AnalyticsEventSource["INITIALS_DIALOG"] = "avatarInitialsPicker";
    AnalyticsEventSource["KUDOS_SCREEN"] = "kudos";
    AnalyticsEventSource["PROFILE_CARD"] = "profilecard";
    AnalyticsEventSource["TEAMS_PAGE"] = "teamsPage";
    return AnalyticsEventSource;
}({});
let $56f6215c0eb64b43$export$74eee170ad238aae = /*#__PURE__*/ function(AnalyticsEventActions) {
    AnalyticsEventActions["ACCEPTED"] = "accepted";
    AnalyticsEventActions["CLICKED"] = "clicked";
    AnalyticsEventActions["CLOSED"] = "closed";
    AnalyticsEventActions["COLLAPSED"] = "collapsed";
    AnalyticsEventActions["CREATED"] = "created";
    AnalyticsEventActions["DECLINED"] = "declined";
    AnalyticsEventActions["DELETED"] = "deleted";
    AnalyticsEventActions["EDITED"] = "edited";
    AnalyticsEventActions["EXPANDED"] = "expanded";
    AnalyticsEventActions["EXPOSED"] = "exposed";
    AnalyticsEventActions["FAILED"] = "failed";
    AnalyticsEventActions["JOINED"] = "joined";
    AnalyticsEventActions["REDIRECTED"] = "redirected";
    AnalyticsEventActions["REMOVED"] = "removed";
    AnalyticsEventActions["SENT"] = "sent";
    AnalyticsEventActions["SORTED"] = "sorted";
    AnalyticsEventActions["STARTED"] = "started";
    AnalyticsEventActions["OPENED"] = "opened";
    AnalyticsEventActions["SHOWN"] = "shown";
    AnalyticsEventActions["SUBMITTED"] = "submitted";
    AnalyticsEventActions["SUCCEEDED"] = "succeeded";
    AnalyticsEventActions["TRIGGERED"] = "triggered";
    AnalyticsEventActions["TYPED"] = "typed";
    AnalyticsEventActions["VIEWED"] = "viewed";
    AnalyticsEventActions["MOUNTED"] = "mounted";
    AnalyticsEventActions["MOVED"] = "moved";
    AnalyticsEventActions["DRAGGED"] = "dragged";
    AnalyticsEventActions["SELECTED"] = "selected";
    return AnalyticsEventActions;
}({});
let $56f6215c0eb64b43$export$670f80b77450980d = /*#__PURE__*/ function(AnalyticsEventSubjects) {
    AnalyticsEventSubjects["TEAM_LINK"] = "teamLink";
    AnalyticsEventSubjects["BUTTON"] = "button";
    AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
    AnalyticsEventSubjects["FORM"] = "form";
    AnalyticsEventSubjects["ERROR"] = "error";
    return AnalyticsEventSubjects;
}({});

});

parcelRegister("akWuj", function(module, exports) {

$parcel$export(module.exports, "configureNewTracker", () => $786924244d351a67$export$54c7ecd74762af6a);
$parcel$export(module.exports, "isNetworkError", () => $786924244d351a67$export$476aa014e2fd89d5);

var $hUYqC = parcelRequire("hUYqC");

var $4GU27 = parcelRequire("4GU27");

var $7sTpx = parcelRequire("7sTpx");

var $XBVF2 = parcelRequire("XBVF2");

var $2oEyM = parcelRequire("2oEyM");

var $fXCRm = parcelRequire("fXCRm");
function $786924244d351a67$export$54c7ecd74762af6a(analytics) {
    const tracker = new $786924244d351a67$var$DirectoryExperienceTracker({
        isNetworkOfflineError: $786924244d351a67$export$476aa014e2fd89d5
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = $786924244d351a67$var$computePerformanceAttributes(event);
            const errorAttributes = $786924244d351a67$var$computeErrorAttributes(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: (0, $4GU27.getAppName)() === (0, $4GU27.AppNames).STANDALONE_DIRECTORY,
                hasBrowseUsersPermission: (0, $XBVF2.isFlagEnabled)((0, $26c363c9409b0d5d$export$28456d095a642fd))
            });
            const actionSubject = $786924244d351a67$var$sanitiseExperienceName(event.name);
            analytics.pushOperationalEvent({
                source: (0, $7sTpx.AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: actionSubject,
                action: event.action,
                attributes: finalErrorDetails
            });
            if (event.action === 'taskFail') (0, $fXCRm.logErrorMessage)(`taskFail:${actionSubject}`, finalErrorDetails);
        }
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('unload', ()=>{
        tracker.abort({
            reason: 'Abort due to Window unloading',
            attributes: {
                cause: 'WINDOW_UNLOAD'
            }
        });
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('pagehide', ()=>{
        tracker.abort({
            reason: 'Window unloading',
            attributes: {
                cause: 'PAGE_HIDE'
            }
        });
    });
    return tracker;
}
function $786924244d351a67$var$sanitiseExperienceName(name) {
    return name.replace(/[\/-]/g, '_');
}
function $786924244d351a67$var$computeErrorAttributes(event) {
    const attributes = {};
    if (event.action === 'taskFail' && event.error) {
        var _traceId;
        attributes.failError = event.error.message;
        attributes.traceId = (_traceId = event.error.traceId) !== null && _traceId !== void 0 ? _traceId : null;
    }
    if (event.action === 'taskAbort' && event.reason) attributes.abortReason = event.reason;
    return attributes;
}
// compute sloSatisfied: true/false based on the latencySlo attribute
// for monitoring in SignalFx
function $786924244d351a67$var$computePerformanceAttributes(event) {
    if (event.action === 'taskStart') return {};
    const duration = event.duration;
    const latencySlo = event.attributes && event.attributes['latencySlo'];
    if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
    return {
        sloSatisfied: duration <= latencySlo,
        taskDuration: duration,
        latencySlo: latencySlo
    };
}
class $786924244d351a67$var$DirectoryExperienceTracker extends (0, $hUYqC.ExperienceTracker) {
    constructor(options){
        super(options);
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if ((0, $2oEyM.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $2oEyM.isErrorStatusCode)((0, $2oEyM.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        const reason = (0, $2oEyM.ignoredErrorReason)(error);
        if (reason) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: reason,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
    }
}
function $786924244d351a67$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    // @ts-ignore
    !!(error['graphQLErrors'] && error['networkError']));
}

});
const $26c363c9409b0d5d$export$28456d095a642fd = 'internal.browse-users-allowed';

parcelRegister("XBVF2", function(module, exports) {

$parcel$export(module.exports, "FeatureFlag", () => $0b32eeb721b036a1$export$df35587a8f95f16f);
$parcel$export(module.exports, "isFlagEnabled", () => $0b32eeb721b036a1$export$ba72073d757a1bc2);

var $685TP = parcelRequire("685TP");

var $37mOt = parcelRequire("37mOt");

var $2fFJv = parcelRequire("2fFJv");
let $0b32eeb721b036a1$export$df35587a8f95f16f = /*#__PURE__*/ function(FeatureFlag) {
    FeatureFlag["ENABLE_PROJECT_CONNECT_USER_TAGS"] = "enable_skills_and_interest_tags_in_profile_page";
    FeatureFlag["EVENT_ON_CALL_EFF"] = "event-on-call-consolidation_s97c8";
    FeatureFlag["EVENT_ON_CALL_CONSOLIDATION_STATE"] = "event-on-call-consolidation-state";
    FeatureFlag["ENABLE_MOCK_OPEN_SITES_FAIL"] = "ptc-directory-ui.deny-open-sites-in-fe";
    FeatureFlag["DISABLE_ATLAS_CROSSWFLOW_ADS"] = "disable_atlas_crossflow_ads";
    return FeatureFlag;
}({});
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
const $0b32eeb721b036a1$var$DEFAULT_FEATURE_FLAGS = {
    [$0b32eeb721b036a1$export$df35587a8f95f16f.ENABLE_PROJECT_CONNECT_USER_TAGS]: false,
    [$0b32eeb721b036a1$export$df35587a8f95f16f.ENABLE_MOCK_OPEN_SITES_FAIL]: false,
    [$0b32eeb721b036a1$export$df35587a8f95f16f.DISABLE_ATLAS_CROSSWFLOW_ADS]: false,
    [$0b32eeb721b036a1$export$df35587a8f95f16f.EVENT_ON_CALL_EFF]: false,
    [$0b32eeb721b036a1$export$df35587a8f95f16f.EVENT_ON_CALL_CONSOLIDATION_STATE]: false
};
// Overrides only for local/CI environments
const $0b32eeb721b036a1$var$LOCAL_OVERRIDE_FEATURE_FLAGS = {
    // Features rolled out to 100%
    // Atlassian-only features
    [$0b32eeb721b036a1$export$df35587a8f95f16f.ENABLE_PROJECT_CONNECT_USER_TAGS]: true
};
const $0b32eeb721b036a1$export$7101ae34ef1f53be = ()=>{
    var _process, _process$env;
    return ((_process = $2fFJv) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development' || (0, $37mOt.getEnv)() === 'local' ? {
        ...$0b32eeb721b036a1$var$DEFAULT_FEATURE_FLAGS,
        ...$0b32eeb721b036a1$var$LOCAL_OVERRIDE_FEATURE_FLAGS
    } : {
        ...$0b32eeb721b036a1$var$DEFAULT_FEATURE_FLAGS
    };
};
function $0b32eeb721b036a1$export$ba72073d757a1bc2(flag) {
    return (0, $685TP.isFlagEnabled)(flag);
}

});
parcelRegister("685TP", function(module, exports) {

$parcel$export(module.exports, "getSettingsFromStorage", () => $476810eaffe39989$export$b40bc67e97afc0ed);
$parcel$export(module.exports, "isFlagEnabled", () => $476810eaffe39989$export$ba72073d757a1bc2);

var $lfozZ = parcelRequire("lfozZ");

var $iLXgp = parcelRequire("iLXgp");

var $db638 = parcelRequire("db638");
const $476810eaffe39989$var$STORAGE_KEY_SETTINGS = 'atlassian.ptc-directory.settings';
function $476810eaffe39989$export$d9d01ff109db30f0(settings) {
    (0, $iLXgp.default).setItem($476810eaffe39989$var$STORAGE_KEY_SETTINGS, JSON.stringify(settings));
    $476810eaffe39989$export$455c5cbefb010abd(settings);
}
function $476810eaffe39989$export$b40bc67e97afc0ed() {
    const settingsString = (0, $iLXgp.default).getItem($476810eaffe39989$var$STORAGE_KEY_SETTINGS);
    try {
        const parsed = settingsString ? JSON.parse(settingsString) : null;
        if ($476810eaffe39989$var$isStringBooleanDictionary(parsed)) return parsed;
        return null;
    } catch (e) {
        (0, $lfozZ.logException)(e, 'Could not get settings from storage', {
            locallyStoredSettings: settingsString
        });
        return null;
    }
}
const $476810eaffe39989$var$effectiveFlags = {
    ...(0, $db638.DEFAULT_FEATURE_FLAGS),
    ...$476810eaffe39989$export$b40bc67e97afc0ed() || {}
};
function $476810eaffe39989$export$455c5cbefb010abd(newFlags) {
    Object.assign($476810eaffe39989$var$effectiveFlags, newFlags);
}
/**
 * We use this function to validate that the settings retrieved from local storage are of the correct shape.
 * We intentionally don't check against explicit keys, as keys may have changed since being stored.
 */ function $476810eaffe39989$var$isStringBooleanDictionary(result) {
    return result !== null && Object.keys(result).every((resultKey)=>typeof resultKey === 'string' && typeof result[resultKey] === 'boolean');
}
function $476810eaffe39989$export$2f63519103163252(featureFlag) {
    return Object.keys((0, $db638.PRODUCT_FEATURE_FLAGS)).includes(featureFlag);
}
function $476810eaffe39989$export$ba72073d757a1bc2(flag) {
    return $476810eaffe39989$var$effectiveFlags[flag];
}

});
parcelRegister("lfozZ", function(module, exports) {

$parcel$export(module.exports, "logException", () => $f77e10ac9fd2e435$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logInfoMessage", () => $f77e10ac9fd2e435$export$386587bcf05ee8ea);

var $8gATS = parcelRequire("8gATS");
const $f77e10ac9fd2e435$var$packageContext = {
    packageName: "@atlassian/teams",
    packageVersion: "2.30.0"
};
const $f77e10ac9fd2e435$export$f86b2a1a2ce291b3 = (0, $8gATS.logExceptionWithPackageContext)($f77e10ac9fd2e435$var$packageContext);
const $f77e10ac9fd2e435$export$ece28f5cfa04608 = (0, $8gATS.logErrorMessageWithPackageContext)($f77e10ac9fd2e435$var$packageContext);
const $f77e10ac9fd2e435$export$386587bcf05ee8ea = (0, $8gATS.logInfoMessageWithPackageContext)($f77e10ac9fd2e435$var$packageContext);
const $f77e10ac9fd2e435$export$9edc7d6f1c33ddc = (0, $8gATS.createErrorHandlerWithPackageContext)($f77e10ac9fd2e435$var$packageContext);

});

parcelRegister("iLXgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $daaa964abfc621f7$export$2e2bcd8739ae039);

var $lfozZ = parcelRequire("lfozZ");
const $daaa964abfc621f7$var$PREFIX = 'ptc-dir-ui.';
const $daaa964abfc621f7$var$memoryLocalStorage = {
    data: {},
    setItem: (key, value)=>{
        $daaa964abfc621f7$var$memoryLocalStorage.data[key] = value;
    },
    getItem: (key)=>{
        return $daaa964abfc621f7$var$memoryLocalStorage.data[key];
    },
    removeItem: (key)=>{
        delete $daaa964abfc621f7$var$memoryLocalStorage.data[key];
    }
};
const $daaa964abfc621f7$var$localStorage = window.localStorage || $daaa964abfc621f7$var$memoryLocalStorage;
var // A facade for browser localstorage.
$daaa964abfc621f7$export$2e2bcd8739ae039 = {
    isQuotaExceeded () {
        const key = `${$daaa964abfc621f7$var$PREFIX}:${Date.now()}`;
        try {
            $daaa964abfc621f7$var$localStorage.setItem(key, 'test');
        } catch (e) {
            return true;
        } finally{
            $daaa964abfc621f7$var$localStorage.removeItem(key);
        }
        return false;
    },
    setItem (key, value) {
        try {
            $daaa964abfc621f7$var$localStorage.setItem($daaa964abfc621f7$var$PREFIX + key, value);
            return true;
        } catch (error) {
            // maybe we can use cookie as alternative storage
            (0, $lfozZ.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return false;
    },
    getItem (key) {
        try {
            return $daaa964abfc621f7$var$localStorage.getItem($daaa964abfc621f7$var$PREFIX + key);
        } catch (error) {
            (0, $lfozZ.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return null;
    },
    getItemSafely (key, defaultValue, fallback) {
        try {
            const storedValue = $daaa964abfc621f7$var$localStorage.getItem($daaa964abfc621f7$var$PREFIX + key);
            if (storedValue) return storedValue;
            if (this.setItem(key, defaultValue)) return defaultValue;
        } catch (error) {
            (0, $lfozZ.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return fallback;
    }
};

});

parcelRegister("db638", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_FEATURE_FLAGS", () => $9980fec3118a1fbd$export$f55f538942f87030);
$parcel$export(module.exports, "DEFAULT_FEATURE_FLAGS", () => $9980fec3118a1fbd$export$f38af5fc86a6e665);
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
// This is a list of feature flags that are overwritable by products. The defaults are still loaded from the client
const $9980fec3118a1fbd$export$f55f538942f87030 = {};
const $9980fec3118a1fbd$export$f38af5fc86a6e665 = {
    'ptc-directory-ui.enable.cancel-join-requests-silently': false,
    'ptc-directory-ui.deny-open-sites-in-fe': false,
    'ptc-directory-ui.enable.atlas-team-health-monitor': false,
    ...$9980fec3118a1fbd$export$f55f538942f87030
};

});



parcelRegister("2oEyM", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $1bed4902cb161f0a$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $1bed4902cb161f0a$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $1bed4902cb161f0a$export$9677d7c364ada66c);
$parcel$export(module.exports, "ignoredErrorReason", () => $1bed4902cb161f0a$export$ece443678e6cc3f5);
$parcel$export(module.exports, "is4xxError", () => $1bed4902cb161f0a$export$94c4b26e937da69);
$parcel$export(module.exports, "doesErrorContainStatus", () => $1bed4902cb161f0a$export$7c7624f23566b6ff);
$parcel$export(module.exports, "DirectoryErrorCode", () => $1bed4902cb161f0a$export$b19e812222b57630);
$parcel$export(module.exports, "isApolloError", () => $1bed4902cb161f0a$export$17f5e6bd290bb15d);
let $1bed4902cb161f0a$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
let $1bed4902cb161f0a$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $1bed4902cb161f0a$export$cde1786a482f9a1c(error) {
    return $1bed4902cb161f0a$export$9677d7c364ada66c($1bed4902cb161f0a$export$f66f92b8741acd5b.UNAUTHORIZED, error) || $1bed4902cb161f0a$export$9677d7c364ada66c($1bed4902cb161f0a$export$f66f92b8741acd5b.FORBIDDEN, error);
}
const $1bed4902cb161f0a$export$c27af9588f06f6fc = [
    'SentryIgnoreError'
];
const $1bed4902cb161f0a$export$f4c3d57f2f41ffe2 = {
    'Could not verify accountId from header': 'AccountIdMismatch'
};
function $1bed4902cb161f0a$export$ece443678e6cc3f5(error) {
    const constructor = error === null || error === void 0 ? void 0 : error.constructor.name;
    if (constructor && $1bed4902cb161f0a$export$c27af9588f06f6fc.includes(constructor)) return constructor;
    const message = (error === null || error === void 0 ? void 0 : error.message) || '';
    const containedReason = message && Object.keys($1bed4902cb161f0a$export$f4c3d57f2f41ffe2).find((ignoredMessage)=>message.includes(ignoredMessage));
    if (containedReason) return $1bed4902cb161f0a$export$f4c3d57f2f41ffe2[containedReason];
}
function $1bed4902cb161f0a$export$9677d7c364ada66c(statusCode, error) {
    var _error$message;
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!(error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.match(reg));
}
function $1bed4902cb161f0a$export$94c4b26e937da69(error) {
    var _error$message2;
    if (!error) return false;
    const statusCode = error['status'] || error['statusCode'];
    if (parseInt(statusCode, 10) >= 400 && parseInt(statusCode, 10) < 500) return true;
    const reg = new RegExp(/status (code)?.*(4\d\d)/g);
    return !!((_error$message2 = error.message) !== null && _error$message2 !== void 0 && _error$message2.match(reg));
}
function $1bed4902cb161f0a$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
let $1bed4902cb161f0a$export$b19e812222b57630 = /*#__PURE__*/ function(DirectoryErrorCode) {
    DirectoryErrorCode["MISSING_ERROR_MESSAGE"] = "MissingErrorMessage";
    return DirectoryErrorCode;
}({});
let $1bed4902cb161f0a$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
function $1bed4902cb161f0a$export$76843b239f07f80a(error, field) {
    return error instanceof Error && field in error;
}
function $1bed4902cb161f0a$export$17f5e6bd290bb15d(err) {
    return typeof err === 'object' && err !== null && 'graphQLErrors' in err;
}

});

parcelRegister("fXCRm", function(module, exports) {

$parcel$export(module.exports, "logException", () => $b9ea8270168e58f4$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $b9ea8270168e58f4$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $b9ea8270168e58f4$export$386587bcf05ee8ea);
$parcel$export(module.exports, "createErrorHandler", () => $b9ea8270168e58f4$export$9edc7d6f1c33ddc);

var $8gATS = parcelRequire("8gATS");
var $6LbQr = parcelRequire("6LbQr");
const $b9ea8270168e58f4$var$packageContext = {
    packageName: "@atlassian/ptc-common",
    packageVersion: "3.36.2"
};
const $b9ea8270168e58f4$export$f86b2a1a2ce291b3 = (0, $8gATS.logExceptionWithPackageContext)($b9ea8270168e58f4$var$packageContext);
const $b9ea8270168e58f4$export$ece28f5cfa04608 = (0, $8gATS.logErrorMessageWithPackageContext)($b9ea8270168e58f4$var$packageContext);
const $b9ea8270168e58f4$export$386587bcf05ee8ea = (0, $8gATS.logInfoMessageWithPackageContext)($b9ea8270168e58f4$var$packageContext);
const $b9ea8270168e58f4$export$9edc7d6f1c33ddc = (0, $8gATS.createErrorHandlerWithPackageContext)($b9ea8270168e58f4$var$packageContext);

});
parcelRegister("6LbQr", function(module, exports) {

$parcel$export(module.exports, "useTeamsSentryClientSetup", () => $4ec051f9caa37e49$export$e30f49f36a0eeaeb);

var $eUqFw = parcelRequire("eUqFw");

var $5uW8f = parcelRequire("5uW8f");
const $4ec051f9caa37e49$export$e30f49f36a0eeaeb = (isSentryEnabled, config)=>{
    const [sentryInitialised, setSentryInitialised] = (0, $eUqFw.useState)(false);
    const setupSentry = (0, $eUqFw.useCallback)(async ()=>{
        if (!sentryInitialised && isSentryEnabled && !(0, $5uW8f.sentryClient)) await (0, $5uW8f.setupSentryClient)(config);
    }, [
        config,
        isSentryEnabled,
        sentryInitialised
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setupSentry().then(()=>setSentryInitialised(true));
    }, [
        setupSentry
    ]);
    return 0, $5uW8f.sentryClient;
};

});



parcelRegister("53jQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3adca091d2ed8373$export$2e2bcd8739ae039);
/**
 * A singleton module that will store a referrer data in a closure
 * and retrieve that data in an analytics client untill the app has
 * a route transition happened.
 *
 * How it works:
 * 1. whenever we init our app with `src` or `ref` in the URL we gonna preserve them here
 * 2. in every screen event we gonna retrieve `src` and `ref` and add them to event attributes
 * 3. as soon as app transitions to any other route we gonna cleanup the stored referrer data
 *    to stop tracking it further.
 *
 * Notes:
 *  Due to how `referrerInfo` is used to store data temporarily, now it is used only at 2 places:
 * - Analytic Client `packages/common/src/clients/analytics-client.ts`
 * - RecordTransition `packages/embeddable-directory/src/components/RecordTransition/RecordTransition.tsx`
 * If other codes try to access value inside `referrerInfo`, they may access old/empty data.
 */ 
var $1ely8 = parcelRequire("1ely8");
// the storage for our referrer info;
let $3adca091d2ed8373$var$data = null;
const $3adca091d2ed8373$var$referrerInfo = {
    // as we preserving the data, we should at least get it once to record in analytics before allowing cleanup
    isUsed: false,
    markUsed () {
        $3adca091d2ed8373$var$referrerInfo.isUsed = true;
    },
    get () {
        return $3adca091d2ed8373$var$data;
    },
    set ({ src: src = '', ref: ref = '' }) {
        // clean up strings
        $3adca091d2ed8373$var$data = {
            src: (0, $1ely8.sanitiseValue)(src || '', {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            }),
            ref: (0, $1ely8.sanitiseValue)(ref, {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            })
        };
    },
    cleanup (force) {
        if (!$3adca091d2ed8373$var$referrerInfo.isUsed && !force) return;
        $3adca091d2ed8373$var$data = null;
    }
};
var $3adca091d2ed8373$export$2e2bcd8739ae039 = $3adca091d2ed8373$var$referrerInfo;

});
parcelRegister("1ely8", function(module, exports) {

$parcel$export(module.exports, "sanitiseValue", () => $0e57d08defde5c5d$export$b66eb39ba856053f);
const $0e57d08defde5c5d$var$FORBIDDEN_CODE_CHARS = [
    8207 // https://www.fileformat.info/info/unicode/char/200f/index.htm
];
function $0e57d08defde5c5d$export$b66eb39ba856053f(value, options = {}) {
    let trimmedStr = value.trim();
    $0e57d08defde5c5d$var$FORBIDDEN_CODE_CHARS.forEach((codeChar)=>{
        const char = String.fromCharCode(codeChar);
        const re = new RegExp(char, 'gm');
        trimmedStr = trimmedStr.replace(re, '');
    });
    if (options.shouldHaveSafeCharsOnly) {
        trimmedStr = trimmedStr.replace(/[^a-z0-9_-]/gim, '');
        trimmedStr = trimmedStr.trim();
    }
    if (options.shouldEncode) trimmedStr = encodeURIComponent(trimmedStr);
    return trimmedStr;
}

});




parcelRegister("jPMlZ", function(module, exports) {

$parcel$export(module.exports, "useSetupApolloClient", () => $e70849c20605d64e$export$78cd44b109ba6e2a);

var $eUqFw = parcelRequire("eUqFw");

var $ftbjG = parcelRequire("ftbjG");
function $e70849c20605d64e$export$78cd44b109ba6e2a(cloudId) {
    const [apolloClient, setApolloClient] = (0, $eUqFw.useState)((0, $ftbjG.getApolloClient)({
        getCloudId: ()=>cloudId
    }));
    const gatewayClient = (0, $ftbjG.getGatewayClient)();
    // setup directory Apollo client
    (0, $eUqFw.useEffect)(()=>{
        if (!cloudId) return;
        const apolloClient = (0, $ftbjG.getApolloClient)({
            getCloudId: ()=>cloudId
        });
        /**
     * Enables the field @cloudId in apollo queries
     */ apolloClient.writeData({
            data: {
                cloudId: cloudId
            }
        });
        setApolloClient(apolloClient);
    }, [
        cloudId
    ]);
    // setup gateway Apollo client
    (0, $eUqFw.useEffect)(()=>{
        /**
     * Enables the field @cloudId in apollo queries
     */ gatewayClient.writeData({
            data: {
                cloudId: cloudId || 'None'
            }
        });
    }, [
        cloudId,
        gatewayClient
    ]);
    return apolloClient;
}

});
parcelRegister("ftbjG", function(module, exports) {

$parcel$export(module.exports, "getApolloClient", () => $b43257a7194eb56e$export$1e6cfeaf8b88bd01);
$parcel$export(module.exports, "getGatewayClient", () => $b43257a7194eb56e$export$719274339c63410a);
$parcel$export(module.exports, "getTeamCentralClient", () => $b43257a7194eb56e$export$6ef19f8a51b6041);

var $aDSxD = parcelRequire("aDSxD");

var $fU34a = parcelRequire("fU34a");
var $avLBj = parcelRequire("avLBj");

var $7YdTp = parcelRequire("7YdTp");
const $b43257a7194eb56e$var$customFetch = (0, $7YdTp.withDefaultExponentialBackoff)(fetch);
/*************************************************/ // a common Apollo Client
let $b43257a7194eb56e$var$cachedApolloClient;
const $b43257a7194eb56e$export$1e6cfeaf8b88bd01 = (customConfig)=>{
    if ($b43257a7194eb56e$var$cachedApolloClient) return $b43257a7194eb56e$var$cachedApolloClient;
    const apolloClient = $b43257a7194eb56e$export$67100df7b1079985(customConfig);
    // don't cache apolloClient when cloudId is empty string
    if (customConfig !== null && customConfig !== void 0 && customConfig.getCloudId && customConfig !== null && customConfig !== void 0 && customConfig.getCloudId()) $b43257a7194eb56e$var$cachedApolloClient = apolloClient;
    return apolloClient;
};
const $b43257a7194eb56e$export$67100df7b1079985 = (customConfig)=>(0, $aDSxD.createApolloClient)({
        connectToDevTools: !!(0, $fU34a.DEV),
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot,
            collaborationGraph: (0, $avLBj.getConfig)().collaborationGraph
        },
        customFetch: $b43257a7194eb56e$var$customFetch,
        ...customConfig
    });
/*************************************************/ // Worklens client
let $b43257a7194eb56e$var$cachedWorklensClient;
const $b43257a7194eb56e$export$f0c45e63c1288a74 = ()=>{
    if ($b43257a7194eb56e$var$cachedWorklensClient) return $b43257a7194eb56e$var$cachedWorklensClient;
    $b43257a7194eb56e$var$cachedWorklensClient = (0, $aDSxD.createWorklensClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $b43257a7194eb56e$var$customFetch
    });
    return $b43257a7194eb56e$var$cachedWorklensClient;
};
/*************************************************/ // GraphQL Gateway client
let $b43257a7194eb56e$var$cachedGatewayClient;
const $b43257a7194eb56e$export$719274339c63410a = ()=>{
    if ($b43257a7194eb56e$var$cachedGatewayClient) return $b43257a7194eb56e$var$cachedGatewayClient;
    $b43257a7194eb56e$var$cachedGatewayClient = (0, $aDSxD.createAtlassianGatewayClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $b43257a7194eb56e$var$customFetch
    });
    return $b43257a7194eb56e$var$cachedGatewayClient;
};
/*************************************************/ // GraphQL Team Central client
let $b43257a7194eb56e$var$cachedTeamCentralClient;
const $b43257a7194eb56e$export$6ef19f8a51b6041 = ()=>{
    if ($b43257a7194eb56e$var$cachedTeamCentralClient) return $b43257a7194eb56e$var$cachedTeamCentralClient;
    $b43257a7194eb56e$var$cachedTeamCentralClient = (0, $aDSxD.createTeamCentralClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $b43257a7194eb56e$var$customFetch
    });
    return $b43257a7194eb56e$var$cachedTeamCentralClient;
};

});
parcelRegister("aDSxD", function(module, exports) {

$parcel$export(module.exports, "createApolloClient", () => $7bf7dab4ed427bef$export$67100df7b1079985);
$parcel$export(module.exports, "createWorklensClient", () => $7bf7dab4ed427bef$export$72afd8225aad0e67);
$parcel$export(module.exports, "createAtlassianGatewayClient", () => $7bf7dab4ed427bef$export$a518457feff205cb);
$parcel$export(module.exports, "createTeamCentralClient", () => $7bf7dab4ed427bef$export$63d9e7c1fb26588f);

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $711qW = parcelRequire("711qW");

var $aAMCg = parcelRequire("aAMCg");

var $1M9Pg = parcelRequire("1M9Pg");

var $NwkJu = parcelRequire("NwkJu");

var $gbvre = parcelRequire("gbvre");

var $7ciYF = parcelRequire("7ciYF");

var $5Rad2 = parcelRequire("5Rad2");

var $sfOt3 = parcelRequire("sfOt3");

var $3TcZB = parcelRequire("3TcZB");
const $7bf7dab4ed427bef$export$67100df7b1079985 = (options)=>{
    const { retryLink: retryOptions = {}, getCloudId: getCloudId, url: url, statusCodeHandlers: statusCodeHandlers = {}, customFetch: customFetch } = options;
    // Build up a list of Apollo links
    const links = [];
    /**
   * Apollo link for handling request errors
   */ const errorLink = (0, $7ciYF.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    if (errorLink) links.push(errorLink);
    /**
   * Apollo link for retrying certain failed requests
   */ const retryLink = (0, $5Rad2.createRetryLink)(retryOptions);
    if (retryLink) links.push(retryLink);
    /**
   * Apollo link that determines whether to send a request to directory
   * service or resolve the query locally using a custom resolver
   */ const customResolversLink = new (0, $711qW.SchemaLink)({
        schema: (0, $aAMCg.addResolveFunctionsToSchema)({
            schema: $3TcZB.schema,
            resolvers: $sfOt3.default
        }),
        context: {
            url: url,
            fetch: (0, $1M9Pg.getCustomResolversFetch)({
                fetch: customFetch || fetch,
                statusCodeHandlers: statusCodeHandlers
            })
        }
    });
    const directoryHttpLink = (0, $gbvre.createDirectoryHttpLink)({
        url: `${url ? url.stargateRoot : ''}/directory/graphql`,
        getCloudId: getCloudId
    });
    links.push((0, $bvQX6.split)(// if query has @custom, use customResolversLink
    (operation)=>(0, $NwkJu.isCustomQuery)(operation), customResolversLink, // use directory link
    directoryHttpLink));
    return new (0, $jlBDe.default)({
        connectToDevTools: !!options.connectToDevTools,
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)(),
        // empty object enables @client directive
        resolvers: {}
    });
};
const $7bf7dab4ed427bef$export$72afd8225aad0e67 = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $7ciYF.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $5Rad2.createRetryLink)(retryOptions);
    const httpLink = (0, $gbvre.createDirectoryHttpLink)({
        url: `${url.stargateRoot}/worklens/api/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)()
    });
};
const $7bf7dab4ed427bef$export$a518457feff205cb = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $7ciYF.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $5Rad2.createRetryLink)(retryOptions);
    const httpLink = (0, $gbvre.createDirectoryHttpLink)({
        url: `${url.stargateRoot}/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)(),
        // empty object enables @client directive
        resolvers: {}
    });
};
const $7bf7dab4ed427bef$export$63d9e7c1fb26588f = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $7ciYF.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $5Rad2.createRetryLink)(retryOptions);
    const httpLink = (0, $gbvre.createDirectoryHttpLink)({
        url: `${url ? url.stargateRoot : ''}/watermelon/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)({
            dataIdFromObject: (obj)=>{
                switch(obj.__typename){
                    case 'Icon':
                        return `${obj.id}:${obj.shortName}|${obj.color}`;
                    case 'GoalPhaseDetails':
                    case 'ProjectPhaseDetails':
                    case 'GqlJiraIssue':
                    case 'GqlJiraIssueType':
                    case 'GqlJiraStatus':
                    case 'GqlJiraStatusCategory':
                        return `${obj.__typename}:${obj.id}`;
                    default:
                        return obj.id;
                }
            }
        })
    });
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});
parcelRegister("42BH7", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $2f1496a7de754c2a$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $2f1496a7de754c2a$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $2f1496a7de754c2a$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $2f1496a7de754c2a$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $2f1496a7de754c2a$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $2f1496a7de754c2a$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $2f1496a7de754c2a$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $2f1496a7de754c2a$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $2f1496a7de754c2a$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $2f1496a7de754c2a$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $2f1496a7de754c2a$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $2f1496a7de754c2a$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $2f1496a7de754c2a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $2f1496a7de754c2a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $2f1496a7de754c2a$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $2f1496a7de754c2a$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $2f1496a7de754c2a$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $2f1496a7de754c2a$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $2f1496a7de754c2a$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $2f1496a7de754c2a$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $2f1496a7de754c2a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $2f1496a7de754c2a$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $2f1496a7de754c2a$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $2f1496a7de754c2a$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $2f1496a7de754c2a$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $2f1496a7de754c2a$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $2f1496a7de754c2a$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $2f1496a7de754c2a$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $2f1496a7de754c2a$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $2f1496a7de754c2a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $2f1496a7de754c2a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $2f1496a7de754c2a$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $2f1496a7de754c2a$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $2f1496a7de754c2a$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $2f1496a7de754c2a$export$160070228be94b08);

var $961BR = parcelRequire("961BR");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $cGs0N = parcelRequire("cGs0N");

var $66hGB = parcelRequire("66hGB");

var $2fFJv = parcelRequire("2fFJv");
function $2f1496a7de754c2a$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $2f1496a7de754c2a$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $2f1496a7de754c2a$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $2f1496a7de754c2a$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $2f1496a7de754c2a$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $2f1496a7de754c2a$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $2f1496a7de754c2a$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $2f1496a7de754c2a$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $2f1496a7de754c2a$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f1496a7de754c2a$var$isIntValue(value) || $2f1496a7de754c2a$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f1496a7de754c2a$var$isBooleanValue(value) || $2f1496a7de754c2a$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f1496a7de754c2a$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f1496a7de754c2a$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f1496a7de754c2a$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8j2fP.InvariantError)(17);
}
function $2f1496a7de754c2a$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f1496a7de754c2a$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f1496a7de754c2a$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f1496a7de754c2a$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $2f1496a7de754c2a$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f1496a7de754c2a$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f1496a7de754c2a$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $2f1496a7de754c2a$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $2f1496a7de754c2a$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fKE23.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f1496a7de754c2a$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $2f1496a7de754c2a$var$defaultValueFromVariable(node) {
    throw new (0, $8j2fP.InvariantError)(18);
}
function $2f1496a7de754c2a$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f1496a7de754c2a$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $2f1496a7de754c2a$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f1496a7de754c2a$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f1496a7de754c2a$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f1496a7de754c2a$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8j2fP.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $2f1496a7de754c2a$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $961BR.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f1496a7de754c2a$export$2dafb573e282fe8d(names, doc) {
    return $2f1496a7de754c2a$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'client'
    ], document) && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $2f1496a7de754c2a$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f1496a7de754c2a$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8j2fP.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8j2fP.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8j2fP.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f1496a7de754c2a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8j2fP.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f1496a7de754c2a$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f1496a7de754c2a$export$a92e7a440b22bdf0(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8j2fP.invariant)(mutationDef, 1);
    return mutationDef;
}
function $2f1496a7de754c2a$export$a7d0d8111d2386df(doc) {
    (0, $8j2fP.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(3);
        return definition;
    });
    (0, $8j2fP.invariant)(operations.length <= 1, 4);
    return doc;
}
function $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2f1496a7de754c2a$export$78a8e95d8d43ad7f(document) {
    var def = $2f1496a7de754c2a$export$7a5b1fa979d2c158(document);
    (0, $8j2fP.invariant)(def, 5);
    return def;
}
function $2f1496a7de754c2a$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f1496a7de754c2a$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2f1496a7de754c2a$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc);
    (0, $8j2fP.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $2f1496a7de754c2a$export$772111caef41b3f5(doc) {
    (0, $8j2fP.invariant)(doc.kind === 'Document', 7);
    (0, $8j2fP.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8j2fP.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $2f1496a7de754c2a$export$f431198736b7f96d(queryDoc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8j2fP.InvariantError)(10);
}
function $2f1496a7de754c2a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f1496a7de754c2a$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f1496a7de754c2a$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f1496a7de754c2a$export$e6e34fd1f2686227.apply(void 0, (0, $fKE23.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f1496a7de754c2a$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f1496a7de754c2a$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f1496a7de754c2a$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $2f1496a7de754c2a$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $2f1496a7de754c2a$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f1496a7de754c2a$var$nullIfDocIsEmpty(doc) {
    return $2f1496a7de754c2a$var$isEmpty($2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) || $2f1496a7de754c2a$export$772111caef41b3f5(doc), $2f1496a7de754c2a$export$193789b4c8246dd4($2f1496a7de754c2a$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f1496a7de754c2a$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f1496a7de754c2a$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f1496a7de754c2a$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$43b332f87950a467(doc) {
    return (0, $961BR.visit)($2f1496a7de754c2a$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f1496a7de754c2a$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArrays)(selections, [
                        $2f1496a7de754c2a$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f1496a7de754c2a$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $2f1496a7de754c2a$export$74985f3324559867(doc) {
    return $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        $2f1496a7de754c2a$var$connectionRemoveConfig
    ], $2f1496a7de754c2a$export$a7d0d8111d2386df(doc));
}
function $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f1496a7de754c2a$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives)) || nestedCheck && $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f1496a7de754c2a$export$deed3420cb5d2e1d(directives, doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f1496a7de754c2a$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f1496a7de754c2a$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f1496a7de754c2a$var$getArgumentMatcher(config);
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f1496a7de754c2a$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f1496a7de754c2a$export$fb56ad75dd311c12(selection) || $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $2f1496a7de754c2a$export$57c368c23873f32b(document) {
    var definition = $2f1496a7de754c2a$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$8eae69e876ee321e(document) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $961BR.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f1496a7de754c2a$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $2f1496a7de754c2a$var$toString = Object.prototype.toString;
function $2f1496a7de754c2a$export$629a2bd3f5a49ecc(value) {
    return $2f1496a7de754c2a$var$cloneDeepHelper(value, new Map());
}
function $2f1496a7de754c2a$var$cloneDeepHelper(val, seen) {
    switch($2f1496a7de754c2a$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f1496a7de754c2a$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f1496a7de754c2a$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() {
    if (typeof $2fFJv !== 'undefined' && "production") return "production";
    return 'development';
}
function $2f1496a7de754c2a$export$f0cb0fda19c18b37(env) {
    return $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() === env;
}
function $2f1496a7de754c2a$export$f15d00aa73aafac4() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('production') === true;
}
function $2f1496a7de754c2a$export$df77466336fe5355() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('development') === true;
}
function $2f1496a7de754c2a$export$410cbc2864fa25b5() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('test') === true;
}
function $2f1496a7de754c2a$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f1496a7de754c2a$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f1496a7de754c2a$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $2f1496a7de754c2a$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f1496a7de754c2a$export$7f9c177735b71f18(obj) {
    if ($2f1496a7de754c2a$export$df77466336fe5355() || $2f1496a7de754c2a$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $2f1496a7de754c2a$var$deepFreeze(obj);
    }
    return obj;
}
var $2f1496a7de754c2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f1496a7de754c2a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f1496a7de754c2a$export$160070228be94b08(sources);
}
function $2f1496a7de754c2a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f1496a7de754c2a$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f1496a7de754c2a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $2f1496a7de754c2a$var$mergeHelper(target, source, pastCopies) {
    if ($2f1496a7de754c2a$var$isObject(source) && $2f1496a7de754c2a$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f1496a7de754c2a$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f1496a7de754c2a$var$mergeHelper($2f1496a7de754c2a$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f1496a7de754c2a$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fKE23.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f1496a7de754c2a$var$haveWarned = Object.create({});
function $2f1496a7de754c2a$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$2f1496a7de754c2a$export$f15d00aa73aafac4() && !$2f1496a7de754c2a$var$haveWarned[msg]) {
        if (!$2f1496a7de754c2a$export$410cbc2864fa25b5()) $2f1496a7de754c2a$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $2f1496a7de754c2a$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("961BR", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $916291e3e456a050$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $916291e3e456a050$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $916291e3e456a050$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $916291e3e456a050$export$728beebeea393478);

var $biK02 = parcelRequire("biK02");

var $c8MIO = parcelRequire("c8MIO");
var $916291e3e456a050$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $916291e3e456a050$export$a89c95c098ac2a58 = Object.freeze({});
function $916291e3e456a050$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $916291e3e456a050$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $c8MIO.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $biK02.default)(node), "."));
            var visitFn = $916291e3e456a050$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $916291e3e456a050$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $c8MIO.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $916291e3e456a050$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $916291e3e456a050$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("biK02", function(module, exports) {

$parcel$export(module.exports, "default", () => $971870e72b5f63d8$export$2e2bcd8739ae039);

var $8Ygpi = parcelRequire("8Ygpi");
function $971870e72b5f63d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $971870e72b5f63d8$var$_typeof(obj);
}
var $971870e72b5f63d8$var$MAX_ARRAY_LENGTH = 10;
var $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH = 2;
function $971870e72b5f63d8$export$2e2bcd8739ae039(value) {
    return $971870e72b5f63d8$var$formatValue(value, []);
}
function $971870e72b5f63d8$var$formatValue(value, seenValues) {
    switch($971870e72b5f63d8$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $971870e72b5f63d8$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $971870e72b5f63d8$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $971870e72b5f63d8$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $971870e72b5f63d8$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $971870e72b5f63d8$var$formatArray(value, seenValues);
    return $971870e72b5f63d8$var$formatObject(value, seenValues);
}
function $971870e72b5f63d8$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[' + $971870e72b5f63d8$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $971870e72b5f63d8$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $971870e72b5f63d8$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($971870e72b5f63d8$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($971870e72b5f63d8$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $971870e72b5f63d8$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $8Ygpi.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $971870e72b5f63d8$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("8Ygpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e19fa1ae734114$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $02e19fa1ae734114$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $02e19fa1ae734114$export$2e2bcd8739ae039 = $02e19fa1ae734114$var$nodejsCustomInspectSymbol;

});


parcelRegister("c8MIO", function(module, exports) {

$parcel$export(module.exports, "Location", () => $e2c0ca6f27c1fab3$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $e2c0ca6f27c1fab3$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee);

var $51GHS = parcelRequire("51GHS");
var $e2c0ca6f27c1fab3$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$18a2be9195644f38);
var $e2c0ca6f27c1fab3$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$50792b0e93539fde);
function $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("51GHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e114d2d62ce6bf$export$2e2bcd8739ae039);

var $43MJl = parcelRequire("43MJl");

var $8Ygpi = parcelRequire("8Ygpi");
function $01e114d2d62ce6bf$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $43MJl.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $8Ygpi.default) classObject.prototype[0, $8Ygpi.default] = fn;
}

});
parcelRegister("43MJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $56486ec4c154c5f8$export$2e2bcd8739ae039);
function $56486ec4c154c5f8$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("8j2fP", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $60c1d8bb20ac9f24$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $60c1d8bb20ac9f24$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");

var $2fFJv = parcelRequire("2fFJv");
var $60c1d8bb20ac9f24$var$genericMessage = "Invariant Violation";
var $60c1d8bb20ac9f24$var$_a = Object.setPrototypeOf, $60c1d8bb20ac9f24$var$setPrototypeOf = $60c1d8bb20ac9f24$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $60c1d8bb20ac9f24$var$_a;
var $60c1d8bb20ac9f24$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $60c1d8bb20ac9f24$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $60c1d8bb20ac9f24$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $60c1d8bb20ac9f24$var$genericMessage;
        $60c1d8bb20ac9f24$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $60c1d8bb20ac9f24$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $60c1d8bb20ac9f24$export$cea12affaee22fe8(message);
}
function $60c1d8bb20ac9f24$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $60c1d8bb20ac9f24$var$wrapConsoleMethod("warn");
    invariant.error = $60c1d8bb20ac9f24$var$wrapConsoleMethod("error");
})($60c1d8bb20ac9f24$export$f5708dca728d7177 || ($60c1d8bb20ac9f24$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2fFJv === "object") $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = $2fFJv;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($60c1d8bb20ac9f24$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $60c1d8bb20ac9f24$var$invariant$1 = $60c1d8bb20ac9f24$export$f5708dca728d7177;
var $60c1d8bb20ac9f24$export$2e2bcd8739ae039 = $60c1d8bb20ac9f24$var$invariant$1;

});

parcelRegister("cGs0N", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("66hGB", function(module, exports) {

$parcel$export(module.exports, "equal", () => $471105b2f2fd38f1$export$411ce8e5a71e3069);
var $471105b2f2fd38f1$var$_a = Object.prototype, $471105b2f2fd38f1$var$toString = $471105b2f2fd38f1$var$_a.toString, $471105b2f2fd38f1$var$hasOwnProperty = $471105b2f2fd38f1$var$_a.hasOwnProperty;
var $471105b2f2fd38f1$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $471105b2f2fd38f1$export$411ce8e5a71e3069(a, b) {
    try {
        return $471105b2f2fd38f1$var$check(a, b);
    } finally{
        $471105b2f2fd38f1$var$previousComparisons.clear();
    }
}
function $471105b2f2fd38f1$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $471105b2f2fd38f1$var$toString.call(a);
    var bTag = $471105b2f2fd38f1$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$471105b2f2fd38f1$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$471105b2f2fd38f1$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$471105b2f2fd38f1$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $471105b2f2fd38f1$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $471105b2f2fd38f1$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $471105b2f2fd38f1$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $471105b2f2fd38f1$export$2e2bcd8739ae039 = $471105b2f2fd38f1$export$411ce8e5a71e3069;

});



parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("jlBDe", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $03a288f5350d9e9d$export$bd096ddbd246c79c);
$parcel$export(module.exports, "ApolloError", () => $03a288f5350d9e9d$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $03a288f5350d9e9d$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $03a288f5350d9e9d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $6XJYy = parcelRequire("6XJYy");

var $8j2fP = parcelRequire("8j2fP");

var $961BR = parcelRequire("961BR");
var $03a288f5350d9e9d$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($03a288f5350d9e9d$export$bd096ddbd246c79c || ($03a288f5350d9e9d$export$bd096ddbd246c79c = {}));
function $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $03a288f5350d9e9d$var$Observable = function(_super) {
    (0, $fKE23.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6XJYy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $5ECju.default));
function $03a288f5350d9e9d$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $03a288f5350d9e9d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $03a288f5350d9e9d$var$generateErrorMessage = function(err) {
    var message = '';
    if ($03a288f5350d9e9d$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $03a288f5350d9e9d$export$26a337512320b8c6 = function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $03a288f5350d9e9d$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $03a288f5350d9e9d$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($03a288f5350d9e9d$export$160bafb6ac1e0641 || ($03a288f5350d9e9d$export$160bafb6ac1e0641 = {}));
var $03a288f5350d9e9d$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $03a288f5350d9e9d$export$6c1b56eac59c9584 = function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $42BH7.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($03a288f5350d9e9d$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $03a288f5350d9e9d$export$bd096ddbd246c79c.loading : $03a288f5350d9e9d$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            stale: false
        }));
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $66hGB.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8j2fP.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $66hGB.equal)(this.variables, variables)) this.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), variables);
        if (!(0, $66hGB.equal)(this.options.variables, this.variables)) this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8j2fP.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $03a288f5350d9e9d$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $66hGB.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $42BH7.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $42BH7.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $66hGB.equal)(previousVariables, variables)) _this.refetch();
                        else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($03a288f5350d9e9d$var$Observable);
function $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback(error) {}
function $03a288f5350d9e9d$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8j2fP.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $03a288f5350d9e9d$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $03a288f5350d9e9d$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8j2fP.invariant)(!previousQuery || previousQuery.document === query.document || (0, $66hGB.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.loading) {
            if (!(0, $66hGB.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.refetch;
        else networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $03a288f5350d9e9d$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $03a288f5350d9e9d$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $42BH7.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $42BH7.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $42BH7.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $42BH7.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8j2fP.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $42BH7.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $42BH7.getMainDefinition)(document);
                fragments = (0, $42BH7.getFragmentDefinitions)(document);
                fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $03a288f5350d9e9d$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!(0, $42BH7.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42BH7.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8j2fP.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $42BH7.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42BH7.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $42BH7.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $03a288f5350d9e9d$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $03a288f5350d9e9d$var$asyncMap(observable, mapFn) {
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $03a288f5350d9e9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $03a288f5350d9e9d$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $03a288f5350d9e9d$var$MutationStore();
        this.queryStore = new $03a288f5350d9e9d$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $42BH7.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $03a288f5350d9e9d$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8j2fP.invariant)(mutation, 9);
                        (0, $8j2fP.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $03a288f5350d9e9d$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $42BH7.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $03a288f5350d9e9d$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($03a288f5350d9e9d$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $42BH7.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $42BH7.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($03a288f5350d9e9d$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $03a288f5350d9e9d$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $42BH7.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $42BH7.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $42BH7.getDefaultValues)((0, $42BH7.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $fKE23.__assign)({}, options);
        return new $03a288f5350d9e9d$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8j2fP.invariant)(options.query, 12);
        (0, $8j2fP.invariant)(options.query.kind === 'Document', 13);
        (0, $8j2fP.invariant)(!options.returnPartialData, 14);
        (0, $8j2fP.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $42BH7.graphQLResultHasError)(result)) throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $03a288f5350d9e9d$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8j2fP.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $42BH7.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation));
        } else {
            observable = $03a288f5350d9e9d$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $03a288f5350d9e9d$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(result.errors)) return reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.ready && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8j2fP.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $03a288f5350d9e9d$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $03a288f5350d9e9d$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $42BH7.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $42BH7.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $42BH7.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $42BH7.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $42BH7.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $42BH7.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $42BH7.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $03a288f5350d9e9d$var$version = "2.6.10";
var $03a288f5350d9e9d$var$hasSuggestedDevtools = false;
var $03a288f5350d9e9d$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $bvQX6.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8j2fP.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $03a288f5350d9e9d$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $03a288f5350d9e9d$var$version;
        this.localState = new $03a288f5350d9e9d$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $03a288f5350d9e9d$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.query), options);
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $bvQX6.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $03a288f5350d9e9d$export$2e2bcd8739ae039 = $03a288f5350d9e9d$export$13f5a5f0f1dbab88;

});
parcelRegister("bvQX6", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("5ECju")).default);

var $5ECju = parcelRequire("5ECju");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8j2fP.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $fKE23.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $5ECju.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $5ECju.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $42BH7.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fKE23.__assign)({}, context, next(context));
        else context = (0, $fKE23.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $5ECju.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $5ECju.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $5ECju.default).of() : rightLink.request(operation) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $5ECju.default).of() : rightLink.request(operation, forward) || (0, $5ECju.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8j2fP.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $5ECju.default).of();
}

});
parcelRegister("5ECju", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de6865c2ff0290$export$2e2bcd8739ae039);

var $1eC02 = parcelRequire("1eC02");
var $41de6865c2ff0290$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($1eC02)));
var $41de6865c2ff0290$export$2e2bcd8739ae039 = $41de6865c2ff0290$export$77cea355fa80b5f4;

});
parcelRegister("1eC02", function(module, exports) {

module.exports = (parcelRequire("bhbKH")).Observable;

});
parcelRegister("bhbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $835a65fddbd60374$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $835a65fddbd60374$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $835a65fddbd60374$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $835a65fddbd60374$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $835a65fddbd60374$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $835a65fddbd60374$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $835a65fddbd60374$var$hasSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbols() && Boolean(Symbol[name]);
};
var $835a65fddbd60374$var$getSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($835a65fddbd60374$var$hasSymbols() && !$835a65fddbd60374$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $835a65fddbd60374$var$SymbolIterator = $835a65fddbd60374$var$getSymbol('iterator');
var $835a65fddbd60374$var$SymbolObservable = $835a65fddbd60374$var$getSymbol('observable');
var $835a65fddbd60374$var$SymbolSpecies = $835a65fddbd60374$var$getSymbol('species'); // === Abstract Operations ===
function $835a65fddbd60374$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $835a65fddbd60374$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$835a65fddbd60374$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $835a65fddbd60374$var$Observable;
}
function $835a65fddbd60374$var$isObservable(x) {
    return x instanceof $835a65fddbd60374$var$Observable; // SPEC: Brand check
}
function $835a65fddbd60374$var$hostReportError(e) {
    if ($835a65fddbd60374$var$hostReportError.log) $835a65fddbd60374$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $835a65fddbd60374$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $835a65fddbd60374$var$hostReportError(e);
        }
    });
}
function $835a65fddbd60374$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $835a65fddbd60374$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
}
function $835a65fddbd60374$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $835a65fddbd60374$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $835a65fddbd60374$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $835a65fddbd60374$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $835a65fddbd60374$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $835a65fddbd60374$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $835a65fddbd60374$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $835a65fddbd60374$var$enqueue(function() {
            return $835a65fddbd60374$var$flushSubscription(subscription);
        });
        return;
    }
    $835a65fddbd60374$var$notifySubscription(subscription, type, value);
}
var $835a65fddbd60374$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $835a65fddbd60374$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $835a65fddbd60374$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $835a65fddbd60374$var$closeSubscription(this);
                    $835a65fddbd60374$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $835a65fddbd60374$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $835a65fddbd60374$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $835a65fddbd60374$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $835a65fddbd60374$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $835a65fddbd60374$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $835a65fddbd60374$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $835a65fddbd60374$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($835a65fddbd60374$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($835a65fddbd60374$var$hasSymbol('iterator')) {
                    method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $835a65fddbd60374$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $835a65fddbd60374$var$Observable;
if ($835a65fddbd60374$var$hasSymbols()) Object.defineProperty($835a65fddbd60374$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $835a65fddbd60374$var$SymbolObservable,
        hostReportError: $835a65fddbd60374$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("711qW", function(module, exports) {

$parcel$export(module.exports, "SchemaLink", () => $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $3MP74 = parcelRequire("3MP74");
var $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d = function(_super) {
    (0, $fKE23.__extends)(SchemaLink, _super);
    function SchemaLink(_a) {
        var schema = _a.schema, rootValue = _a.rootValue, context = _a.context;
        var _this = _super.call(this) || this;
        _this.schema = schema;
        _this.rootValue = rootValue;
        _this.context = context;
        return _this;
    }
    SchemaLink.prototype.request = function(operation) {
        var _this = this;
        return new (0, $5ECju.default)(function(observer) {
            Promise.resolve((0, $3MP74.execute)(_this.schema, operation.query, _this.rootValue, typeof _this.context === 'function' ? _this.context(operation) : _this.context, operation.variables, operation.operationName)).then(function(data) {
                if (!observer.closed) {
                    observer.next(data);
                    observer.complete();
                }
            }).catch(function(error) {
                if (!observer.closed) observer.error(error);
            });
        });
    };
    return SchemaLink;
}((0, $bvQX6.ApolloLink));
var $51b9bd0fcd15a4c3$export$2e2bcd8739ae039 = $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d;

});
parcelRegister("3MP74", function(module, exports) {

$parcel$export(module.exports, "execute", () => $28b9215d12482e59$export$51396ec711da548b);
$parcel$export(module.exports, "assertValidExecutionArguments", () => $28b9215d12482e59$export$e02b605d81e17af1);
$parcel$export(module.exports, "buildExecutionContext", () => $28b9215d12482e59$export$312a3f029bac48f9);
$parcel$export(module.exports, "defaultFieldResolver", () => $28b9215d12482e59$export$21fc6d079630d659);
$parcel$export(module.exports, "collectFields", () => $28b9215d12482e59$export$c23741d442fe90e9);
$parcel$export(module.exports, "getFieldDef", () => $28b9215d12482e59$export$dab6dcab745bb1b6);
$parcel$export(module.exports, "buildResolveInfo", () => $28b9215d12482e59$export$27b5443b7768606f);

var $biK02 = parcelRequire("biK02");

var $aF2x8 = parcelRequire("aF2x8");

var $43MJl = parcelRequire("43MJl");

var $fZdRY = parcelRequire("fZdRY");

var $cvCbM = parcelRequire("cvCbM");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $3SMRB = parcelRequire("3SMRB");

var $jvU6q = parcelRequire("jvU6q");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $1c4hI = parcelRequire("1c4hI");

var $izaFt = parcelRequire("izaFt");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $bis9F = parcelRequire("bis9F");

var $gqGQB = parcelRequire("gqGQB");
function $28b9215d12482e59$export$51396ec711da548b(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? $28b9215d12482e59$var$executeImpl(argsOrSchema) : $28b9215d12482e59$var$executeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}
function $28b9215d12482e59$export$6d0f20a121527483(args) {
    var result = $28b9215d12482e59$var$executeImpl(args); // Assert that the execution was synchronous.
    if ((0, $cvCbM.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function $28b9215d12482e59$var$executeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // If arguments are missing or incorrect, throw an error.
    $28b9215d12482e59$export$e02b605d81e17af1(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
    // a "Response" with only errors is returned.
    var exeContext = $28b9215d12482e59$export$312a3f029bac48f9(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver); // Return early errors if execution context failed.
    if (Array.isArray(exeContext)) return {
        errors: exeContext
    };
     // Return a Promise that will eventually resolve to the data described by
    // The "Response" section of the GraphQL specification.
    //
    // If errors are encountered while executing a GraphQL field, only that
    // field and its descendants will be omitted, and sibling fields will still
    // be executed. An execution which encounters errors will still result in a
    // resolved Promise.
    var data = $28b9215d12482e59$var$executeOperation(exeContext, exeContext.operation, rootValue);
    return $28b9215d12482e59$var$buildResponse(exeContext, data);
}
/**
 * Given a completed execution context and data, build the { errors, data }
 * response defined by the "Response" section of the GraphQL specification.
 */ function $28b9215d12482e59$var$buildResponse(exeContext, data) {
    if ((0, $cvCbM.default)(data)) return data.then(function(resolved) {
        return $28b9215d12482e59$var$buildResponse(exeContext, resolved);
    });
    return exeContext.errors.length === 0 ? {
        data: data
    } : {
        errors: exeContext.errors,
        data: data
    };
}
function $28b9215d12482e59$export$e02b605d81e17af1(schema, document, rawVariableValues) {
    document || (0, $fZdRY.default)(0, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.
    (0, $izaFt.assertValidSchema)(schema); // Variables, if provided, must be an object.
    rawVariableValues == null || (0, $fbtyx.default)(rawVariableValues) || (0, $fZdRY.default)(0, 'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.');
}
function $28b9215d12482e59$export$312a3f029bac48f9(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver, typeResolver) {
    var _definition$name, _operation$variableDe;
    var operation;
    var fragments = Object.create(null);
    for(var _i2 = 0, _document$definitions2 = document.definitions; _i2 < _document$definitions2.length; _i2++){
        var definition = _document$definitions2[_i2];
        switch(definition.kind){
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
                if (operationName == null) {
                    if (operation !== undefined) return [
                        new (0, $9fgMZ.GraphQLError)('Must provide operation name if query contains multiple operations.')
                    ];
                    operation = definition;
                } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) operation = definition;
                break;
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                fragments[definition.name.value] = definition;
                break;
        }
    }
    if (!operation) {
        if (operationName != null) return [
            new (0, $9fgMZ.GraphQLError)("Unknown operation named \"".concat(operationName, "\"."))
        ];
        return [
            new (0, $9fgMZ.GraphQLError)('Must provide an operation.')
        ];
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var variableDefinitions = (_operation$variableDe = operation.variableDefinitions) !== null && _operation$variableDe !== void 0 ? _operation$variableDe : [];
    var coercedVariableValues = (0, $gqGQB.getVariableValues)(schema, variableDefinitions, rawVariableValues !== null && rawVariableValues !== void 0 ? rawVariableValues : {}, {
        maxErrors: 50
    });
    if (coercedVariableValues.errors) return coercedVariableValues.errors;
    return {
        schema: schema,
        fragments: fragments,
        rootValue: rootValue,
        contextValue: contextValue,
        operation: operation,
        variableValues: coercedVariableValues.coerced,
        fieldResolver: fieldResolver !== null && fieldResolver !== void 0 ? fieldResolver : $28b9215d12482e59$export$21fc6d079630d659,
        typeResolver: typeResolver !== null && typeResolver !== void 0 ? typeResolver : $28b9215d12482e59$export$4a45c17a1ba2cb7,
        errors: []
    };
}
/**
 * Implements the "Evaluating operations" section of the spec.
 */ function $28b9215d12482e59$var$executeOperation(exeContext, operation, rootValue) {
    var type = (0, $bis9F.getOperationRootType)(exeContext.schema, operation);
    var fields = $28b9215d12482e59$export$c23741d442fe90e9(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var path = undefined; // Errors from sub-fields of a NonNull type may propagate to the top level,
    // at which point we still log the error and null the parent field, which
    // in this case is the entire response.
    try {
        var result = operation.operation === 'mutation' ? $28b9215d12482e59$var$executeFieldsSerially(exeContext, type, rootValue, path, fields) : $28b9215d12482e59$var$executeFields(exeContext, type, rootValue, path, fields);
        if ((0, $cvCbM.default)(result)) return result.then(undefined, function(error) {
            exeContext.errors.push(error);
            return Promise.resolve(null);
        });
        return result;
    } catch (error) {
        exeContext.errors.push(error);
        return null;
    }
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "write" mode.
 */ function $28b9215d12482e59$var$executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
    return (0, $3SMRB.default)(Object.keys(fields), function(results, responseName) {
        var fieldNodes = fields[responseName];
        var fieldPath = (0, $kZHaf.addPath)(path, responseName, parentType.name);
        var result = $28b9215d12482e59$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result === undefined) return results;
        if ((0, $cvCbM.default)(result)) return result.then(function(resolvedResult) {
            results[responseName] = resolvedResult;
            return results;
        });
        results[responseName] = result;
        return results;
    }, Object.create(null));
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "read" mode.
 */ function $28b9215d12482e59$var$executeFields(exeContext, parentType, sourceValue, path, fields) {
    var results = Object.create(null);
    var containsPromise = false;
    for(var _i4 = 0, _Object$keys2 = Object.keys(fields); _i4 < _Object$keys2.length; _i4++){
        var responseName = _Object$keys2[_i4];
        var fieldNodes = fields[responseName];
        var fieldPath = (0, $kZHaf.addPath)(path, responseName, parentType.name);
        var result = $28b9215d12482e59$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result !== undefined) {
            results[responseName] = result;
            if ((0, $cvCbM.default)(result)) containsPromise = true;
        }
    } // If there are no promises, we can just return the object
    if (!containsPromise) return results;
     // Otherwise, results is a map from field name to the result of resolving that
    // field, which is possibly a promise. Return a promise that will return this
    // same map, but with any promises replaced with the values they resolved to.
    return (0, $jvU6q.default)(results);
}
function $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
    for(var _i6 = 0, _selectionSet$selecti2 = selectionSet.selections; _i6 < _selectionSet$selecti2.length; _i6++){
        var selection = _selectionSet$selecti2[_i6];
        switch(selection.kind){
            case (0, $1c4hI.Kind).FIELD:
                if (!$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection)) continue;
                var name = $28b9215d12482e59$var$getFieldEntryKey(selection);
                if (!fields[name]) fields[name] = [];
                fields[name].push(selection);
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
                if (!$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection) || !$28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, selection, runtimeType)) continue;
                $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
                break;
            case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
                var fragName = selection.name.value;
                if (visitedFragmentNames[fragName] || !$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection)) continue;
                visitedFragmentNames[fragName] = true;
                var fragment = exeContext.fragments[fragName];
                if (!fragment || !$28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, fragment, runtimeType)) continue;
                $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
                break;
        }
    }
    return fields;
}
/**
 * Determines if a field should be included based on the @include and @skip
 * directives, where @skip has higher precedence than @include.
 */ function $28b9215d12482e59$var$shouldIncludeNode(exeContext, node) {
    var skip = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLSkipDirective), node, exeContext.variableValues);
    if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) return false;
    var include = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLIncludeDirective), node, exeContext.variableValues);
    if ((include === null || include === void 0 ? void 0 : include.if) === false) return false;
    return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */ function $28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, fragment, type) {
    var typeConditionNode = fragment.typeCondition;
    if (!typeConditionNode) return true;
    var conditionalType = (0, $3zSAT.typeFromAST)(exeContext.schema, typeConditionNode);
    if (conditionalType === type) return true;
    if ((0, $lXoEQ.isAbstractType)(conditionalType)) return exeContext.schema.isSubType(conditionalType, type);
    return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */ function $28b9215d12482e59$var$getFieldEntryKey(node) {
    return node.alias ? node.alias.value : node.name.value;
}
/**
 * Resolves the field on the given source object. In particular, this
 * figures out the value that the field returns by calling its resolve function,
 * then calls completeValue to complete promises, serialize scalars, or execute
 * the sub-selection-set for objects.
 */ function $28b9215d12482e59$var$resolveField(exeContext, parentType, source, fieldNodes, path) {
    var _fieldDef$resolve;
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = $28b9215d12482e59$export$dab6dcab745bb1b6(exeContext.schema, parentType, fieldName);
    if (!fieldDef) return;
    var returnType = fieldDef.type;
    var resolveFn = (_fieldDef$resolve = fieldDef.resolve) !== null && _fieldDef$resolve !== void 0 ? _fieldDef$resolve : exeContext.fieldResolver;
    var info = $28b9215d12482e59$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path); // Get the resolve function, regardless of if its result is normal or abrupt (error).
    try {
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        // TODO: find a way to memoize, in case this field is within a List type.
        var args = (0, $gqGQB.getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var _contextValue = exeContext.contextValue;
        var result = resolveFn(source, args, _contextValue, info);
        var completed;
        if ((0, $cvCbM.default)(result)) completed = result.then(function(resolved) {
            return $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
        });
        else completed = $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, result);
        if ((0, $cvCbM.default)(completed)) // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.
        return completed.then(undefined, function(rawError) {
            var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(path));
            return $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext);
        });
        return completed;
    } catch (rawError) {
        var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(path));
        return $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext);
    }
}
function $28b9215d12482e59$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path) {
    // The resolve function's optional fourth argument is a collection of
    // information about the current execution state.
    return {
        fieldName: fieldDef.name,
        fieldNodes: fieldNodes,
        returnType: fieldDef.type,
        parentType: parentType,
        path: path,
        schema: exeContext.schema,
        fragments: exeContext.fragments,
        rootValue: exeContext.rootValue,
        operation: exeContext.operation,
        variableValues: exeContext.variableValues
    };
}
function $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext) {
    // If the field type is non-nullable, then it is resolved without any
    // protection from errors, however it still properly locates the error.
    if ((0, $lXoEQ.isNonNullType)(returnType)) throw error;
     // Otherwise, error protection is applied, logging the error and resolving
    // a null value for this field if one is encountered.
    exeContext.errors.push(error);
    return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Field entries" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by evaluating all sub-selections.
 */ function $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If result is an Error, throw a located error.
    if (result instanceof Error) throw result;
     // If field type is NonNull, complete for inner type, and throw field error
    // if result is null.
    if ((0, $lXoEQ.isNonNullType)(returnType)) {
        var completed = $28b9215d12482e59$var$completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
        if (completed === null) throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
        return completed;
    } // If result value is null or undefined then return null.
    if (result == null) return null;
     // If field type is List, complete each item in the list with the inner type
    if ((0, $lXoEQ.isListType)(returnType)) return $28b9215d12482e59$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
    // returning null if serialization is not possible.
    if ((0, $lXoEQ.isLeafType)(returnType)) return $28b9215d12482e59$var$completeLeafValue(returnType, result);
     // If field type is an abstract type, Interface or Union, determine the
    // runtime Object type and complete for that type.
    if ((0, $lXoEQ.isAbstractType)(returnType)) return $28b9215d12482e59$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is Object, execute and complete all sub-selections.
    // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isObjectType)(returnType)) return $28b9215d12482e59$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
     // istanbul ignore next (Not reachable. All possible output types have been considered)
    (0, $43MJl.default)(0, 'Cannot complete value of unexpected output type: ' + (0, $biK02.default)(returnType));
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */ function $28b9215d12482e59$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
    // This is specified as a simple map, however we're optimizing the path
    // where the list contains no Promises by avoiding creating another Promise.
    var itemType = returnType.ofType;
    var containsPromise = false;
    var completedResults = (0, $8DMvn.default)(result, function(item, index) {
        // No need to modify the info object containing the path,
        // since from here on it is not ever accessed by resolver functions.
        var itemPath = (0, $kZHaf.addPath)(path, index, undefined);
        try {
            var completedItem;
            if ((0, $cvCbM.default)(item)) completedItem = item.then(function(resolved) {
                return $28b9215d12482e59$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, resolved);
            });
            else completedItem = $28b9215d12482e59$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, item);
            if ((0, $cvCbM.default)(completedItem)) {
                containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
                // to take a second callback for the error case.
                return completedItem.then(undefined, function(rawError) {
                    var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(itemPath));
                    return $28b9215d12482e59$var$handleFieldError(error, itemType, exeContext);
                });
            }
            return completedItem;
        } catch (rawError) {
            var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(itemPath));
            return $28b9215d12482e59$var$handleFieldError(error, itemType, exeContext);
        }
    });
    if (completedResults == null) throw new (0, $9fgMZ.GraphQLError)("Expected Iterable, but did not find one for field \"".concat(info.parentType.name, ".").concat(info.fieldName, "\"."));
    return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */ function $28b9215d12482e59$var$completeLeafValue(returnType, result) {
    var serializedResult = returnType.serialize(result);
    if (serializedResult === undefined) throw new Error("Expected a value of type \"".concat((0, $biK02.default)(returnType), "\" but ") + "received: ".concat((0, $biK02.default)(result)));
    return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */ function $28b9215d12482e59$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
    var _returnType$resolveTy;
    var resolveTypeFn = (_returnType$resolveTy = returnType.resolveType) !== null && _returnType$resolveTy !== void 0 ? _returnType$resolveTy : exeContext.typeResolver;
    var contextValue = exeContext.contextValue;
    var runtimeType = resolveTypeFn(result, contextValue, info, returnType);
    if ((0, $cvCbM.default)(runtimeType)) return runtimeType.then(function(resolvedRuntimeType) {
        return $28b9215d12482e59$var$completeObjectValue(exeContext, $28b9215d12482e59$var$ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    });
    return $28b9215d12482e59$var$completeObjectValue(exeContext, $28b9215d12482e59$var$ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}
function $28b9215d12482e59$var$ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
    if (runtimeTypeOrName == null) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\". Either the \"").concat(returnType.name, "\" type should provide a \"resolveType\" function or each possible type should provide an \"isTypeOf\" function."), fieldNodes);
     // FIXME: temporary workaround until support for passing object types would be removed in v16.0.0
    var runtimeTypeName = (0, $lXoEQ.isNamedType)(runtimeTypeOrName) ? runtimeTypeOrName.name : runtimeTypeOrName;
    if (typeof runtimeTypeName !== 'string') throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\" with ") + "value ".concat((0, $biK02.default)(result), ", received \"").concat((0, $biK02.default)(runtimeTypeOrName), "\"."));
    var runtimeType = exeContext.schema.getType(runtimeTypeName);
    if (runtimeType == null) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a type \"").concat(runtimeTypeName, "\" that does not exist inside schema."), fieldNodes);
    if (!(0, $lXoEQ.isObjectType)(runtimeType)) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a non-object type \"").concat(runtimeTypeName, "\"."), fieldNodes);
    if (!exeContext.schema.isSubType(returnType, runtimeType)) throw new (0, $9fgMZ.GraphQLError)("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type for \"").concat(returnType.name, "\"."), fieldNodes);
    return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */ function $28b9215d12482e59$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If there is an isTypeOf predicate function, call it with the
    // current result. If isTypeOf returns false, then raise an error rather
    // than continuing execution.
    if (returnType.isTypeOf) {
        var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
        if ((0, $cvCbM.default)(isTypeOf)) return isTypeOf.then(function(resolvedIsTypeOf) {
            if (!resolvedIsTypeOf) throw $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes);
            return $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
        });
        if (!isTypeOf) throw $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes);
    }
    return $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
}
function $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes) {
    return new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(returnType.name, "\" but got: ").concat((0, $biK02.default)(result), "."), fieldNodes);
}
function $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
    // Collect sub-fields to execute to complete this value.
    var subFieldNodes = $28b9215d12482e59$var$collectSubfields(exeContext, returnType, fieldNodes);
    return $28b9215d12482e59$var$executeFields(exeContext, returnType, result, path, subFieldNodes);
}
/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */ var $28b9215d12482e59$var$collectSubfields = (0, $aF2x8.default)($28b9215d12482e59$var$_collectSubfields);
function $28b9215d12482e59$var$_collectSubfields(exeContext, returnType, fieldNodes) {
    var subFieldNodes = Object.create(null);
    var visitedFragmentNames = Object.create(null);
    for(var _i8 = 0; _i8 < fieldNodes.length; _i8++){
        var node = fieldNodes[_i8];
        if (node.selectionSet) subFieldNodes = $28b9215d12482e59$export$c23741d442fe90e9(exeContext, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
    }
    return subFieldNodes;
}
var $28b9215d12482e59$export$4a45c17a1ba2cb7 = function defaultTypeResolver(value, contextValue, info, abstractType) {
    // First, look for `__typename`.
    if ((0, $fbtyx.default)(value) && typeof value.__typename === 'string') return value.__typename;
     // Otherwise, test each possible type.
    var possibleTypes = info.schema.getPossibleTypes(abstractType);
    var promisedIsTypeOfResults = [];
    for(var i = 0; i < possibleTypes.length; i++){
        var type = possibleTypes[i];
        if (type.isTypeOf) {
            var isTypeOfResult = type.isTypeOf(value, contextValue, info);
            if ((0, $cvCbM.default)(isTypeOfResult)) promisedIsTypeOfResults[i] = isTypeOfResult;
            else if (isTypeOfResult) return type.name;
        }
    }
    if (promisedIsTypeOfResults.length) return Promise.all(promisedIsTypeOfResults).then(function(isTypeOfResults) {
        for(var _i9 = 0; _i9 < isTypeOfResults.length; _i9++){
            if (isTypeOfResults[_i9]) return possibleTypes[_i9].name;
        }
    });
};
var $28b9215d12482e59$export$21fc6d079630d659 = function defaultFieldResolver(source, args, contextValue, info) {
    // ensure source is a value for which property access is acceptable.
    if ((0, $fbtyx.default)(source) || typeof source === 'function') {
        var property = source[info.fieldName];
        if (typeof property === 'function') return source[info.fieldName](args, contextValue, info);
        return property;
    }
};
function $28b9215d12482e59$export$dab6dcab745bb1b6(schema, parentType, fieldName) {
    if (fieldName === (0, $h2iUh.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.SchemaMetaFieldDef;
    else if (fieldName === (0, $h2iUh.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.TypeMetaFieldDef;
    else if (fieldName === (0, $h2iUh.TypeNameMetaFieldDef).name) return 0, $h2iUh.TypeNameMetaFieldDef;
    return parentType.getFields()[fieldName];
}

});
parcelRegister("aF2x8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e58f7eb075f9f2$export$2e2bcd8739ae039);
/**
 * Memoizes the provided three-argument function.
 */ function $f8e58f7eb075f9f2$export$2e2bcd8739ae039(fn) {
    var cache0;
    return function memoized(a1, a2, a3) {
        if (!cache0) cache0 = new WeakMap();
        var cache1 = cache0.get(a1);
        var cache2;
        if (cache1) {
            cache2 = cache1.get(a2);
            if (cache2) {
                var cachedValue = cache2.get(a3);
                if (cachedValue !== undefined) return cachedValue;
            }
        } else {
            cache1 = new WeakMap();
            cache0.set(a1, cache1);
        }
        if (!cache2) {
            cache2 = new WeakMap();
            cache1.set(a2, cache2);
        }
        var newValue = fn(a1, a2, a3);
        cache2.set(a3, newValue);
        return newValue;
    };
}

});

parcelRegister("fZdRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04eb23f905f9ab5$export$2e2bcd8739ae039);
function $b04eb23f905f9ab5$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("cvCbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d6e18c41560dd9$export$2e2bcd8739ae039);
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */ // eslint-disable-next-line no-redeclare
function $23d6e18c41560dd9$export$2e2bcd8739ae039(value) {
    return typeof (value === null || value === void 0 ? void 0 : value.then) === 'function';
}

});

parcelRegister("fbtyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $700b00a777571467$export$2e2bcd8739ae039);
function $700b00a777571467$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $700b00a777571467$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $700b00a777571467$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $700b00a777571467$var$_typeof(obj);
}
function $700b00a777571467$export$2e2bcd8739ae039(value) {
    return $700b00a777571467$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("8DMvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $313b09bab2d4edd6$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $313b09bab2d4edd6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $313b09bab2d4edd6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $313b09bab2d4edd6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $313b09bab2d4edd6$var$_typeof(obj);
}
function $313b09bab2d4edd6$export$2e2bcd8739ae039(collection) {
    var mapFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function(item) {
        return item;
    };
    if (collection == null || $313b09bab2d4edd6$var$_typeof(collection) !== 'object') return null;
    if (Array.isArray(collection)) return collection.map(mapFn);
     // Is Iterable?
    var iteratorMethod = collection[0, $gwa3m.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        // $FlowFixMe[incompatible-use]
        var iterator = iteratorMethod.call(collection);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i)result.push(mapFn(step.value, i));
        return result;
    } // Is Array like?
    var length = collection.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i){
            if (!Object.prototype.hasOwnProperty.call(collection, _i)) return null;
            _result.push(mapFn(collection[String(_i)], _i));
        }
        return _result;
    }
    return null;
}

});
parcelRegister("gwa3m", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $84dde8096e41b064$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $84dde8096e41b064$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $84dde8096e41b064$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $84dde8096e41b064$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});


parcelRegister("3SMRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2153f857d28efb07$export$2e2bcd8739ae039);

var $cvCbM = parcelRequire("cvCbM");
function $2153f857d28efb07$export$2e2bcd8739ae039(values, callback, initialValue) {
    return values.reduce(function(previous, value) {
        return (0, $cvCbM.default)(previous) ? previous.then(function(resolved) {
            return callback(resolved, value);
        }) : callback(previous, value);
    }, initialValue);
}

});

parcelRegister("jvU6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $397d1cfe82a99329$export$2e2bcd8739ae039);
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */ function $397d1cfe82a99329$export$2e2bcd8739ae039(object) {
    var keys = Object.keys(object);
    var valuesAndPromises = keys.map(function(name) {
        return object[name];
    });
    return Promise.all(valuesAndPromises).then(function(values) {
        return values.reduce(function(resolvedObject, value, i) {
            resolvedObject[keys[i]] = value;
            return resolvedObject;
        }, Object.create(null));
    });
}

});

parcelRegister("kZHaf", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $d383cb52810c09e2$export$4c25481b843feb0b);
$parcel$export(module.exports, "pathToArray", () => $d383cb52810c09e2$export$38d939edd7751830);
/**
 * Given a Path and a key, return a new Path containing the new key.
 */ function $d383cb52810c09e2$export$4c25481b843feb0b(prev, key, typename) {
    return {
        prev: prev,
        key: key,
        typename: typename
    };
}
function $d383cb52810c09e2$export$38d939edd7751830(path) {
    var flattened = [];
    var curr = path;
    while(curr){
        flattened.push(curr.key);
        curr = curr.prev;
    }
    return flattened.reverse();
}

});

parcelRegister("9fgMZ", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $20ec348cfe64bfcc$export$92d6ed0888e7cb7f);

var $fbtyx = parcelRequire("fbtyx");

var $gwa3m = parcelRequire("gwa3m");

var $cBRMW = parcelRequire("cBRMW");

var $5LGuP = parcelRequire("5LGuP");
function $20ec348cfe64bfcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $20ec348cfe64bfcc$var$_typeof(obj);
}
function $20ec348cfe64bfcc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $20ec348cfe64bfcc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $20ec348cfe64bfcc$var$ownKeys(Object(source), true).forEach(function(key) {
            $20ec348cfe64bfcc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $20ec348cfe64bfcc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $20ec348cfe64bfcc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20ec348cfe64bfcc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20ec348cfe64bfcc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $20ec348cfe64bfcc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $20ec348cfe64bfcc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $20ec348cfe64bfcc$var$_setPrototypeOf(subClass, superClass);
}
function $20ec348cfe64bfcc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20ec348cfe64bfcc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $20ec348cfe64bfcc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $20ec348cfe64bfcc$var$_possibleConstructorReturn(this, result);
    };
}
function $20ec348cfe64bfcc$var$_possibleConstructorReturn(self, call) {
    if (call && ($20ec348cfe64bfcc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $20ec348cfe64bfcc$var$_assertThisInitialized(self);
}
function $20ec348cfe64bfcc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $20ec348cfe64bfcc$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $20ec348cfe64bfcc$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$20ec348cfe64bfcc$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $20ec348cfe64bfcc$var$_construct(Class, arguments, $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $20ec348cfe64bfcc$var$_setPrototypeOf(Wrapper, Class);
    };
    return $20ec348cfe64bfcc$var$_wrapNativeSuper(Class);
}
function $20ec348cfe64bfcc$var$_construct(Parent, args, Class) {
    if ($20ec348cfe64bfcc$var$_isNativeReflectConstruct()) $20ec348cfe64bfcc$var$_construct = Reflect.construct;
    else $20ec348cfe64bfcc$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $20ec348cfe64bfcc$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $20ec348cfe64bfcc$var$_construct.apply(null, arguments);
}
function $20ec348cfe64bfcc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $20ec348cfe64bfcc$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $20ec348cfe64bfcc$var$_setPrototypeOf(o, p) {
    $20ec348cfe64bfcc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $20ec348cfe64bfcc$var$_setPrototypeOf(o, p);
}
function $20ec348cfe64bfcc$var$_getPrototypeOf(o) {
    $20ec348cfe64bfcc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $20ec348cfe64bfcc$var$_getPrototypeOf(o);
}
var $20ec348cfe64bfcc$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $20ec348cfe64bfcc$var$_inherits(GraphQLError, _Error);
    var _super = $20ec348cfe64bfcc$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $20ec348cfe64bfcc$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $20ec348cfe64bfcc$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $20ec348cfe64bfcc$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $cBRMW.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $cBRMW.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $fbtyx.default)(originalExtensions)) _this.extensions = $20ec348cfe64bfcc$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($20ec348cfe64bfcc$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $20ec348cfe64bfcc$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($20ec348cfe64bfcc$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $20ec348cfe64bfcc$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $20ec348cfe64bfcc$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $20ec348cfe64bfcc$var$_wrapNativeSuper(Error));
function $20ec348cfe64bfcc$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $20ec348cfe64bfcc$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $5LGuP.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $5LGuP.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("cBRMW", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("5LGuP", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $66f0d94dee1ae1b2$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $66f0d94dee1ae1b2$export$867940333fd9f869);

var $cBRMW = parcelRequire("cBRMW");
function $66f0d94dee1ae1b2$export$96a9681e539deed(location) {
    return $66f0d94dee1ae1b2$export$867940333fd9f869(location.source, (0, $cBRMW.getLocation)(location.source, location.start));
}
function $66f0d94dee1ae1b2$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $66f0d94dee1ae1b2$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $66f0d94dee1ae1b2$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $66f0d94dee1ae1b2$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $66f0d94dee1ae1b2$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $66f0d94dee1ae1b2$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $66f0d94dee1ae1b2$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $66f0d94dee1ae1b2$var$leftPad(len, str) {
    return $66f0d94dee1ae1b2$var$whitespace(len - str.length) + str;
}

});


parcelRegister("02KAV", function(module, exports) {

$parcel$export(module.exports, "locatedError", () => $b788feeccd28d1f2$export$d6d5dddbbbfd3fca);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");
function $b788feeccd28d1f2$export$d6d5dddbbbfd3fca(rawOriginalError, nodes, path) {
    var _nodes;
    // Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
    var originalError = rawOriginalError instanceof Error ? rawOriginalError : new Error('Unexpected error value: ' + (0, $biK02.default)(rawOriginalError)); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.
    if (Array.isArray(originalError.path)) return originalError;
    return new (0, $9fgMZ.GraphQLError)(originalError.message, (_nodes = originalError.nodes) !== null && _nodes !== void 0 ? _nodes : nodes, originalError.source, originalError.positions, path, originalError);
}

});

parcelRegister("1c4hI", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $1bf9b417a1cf9d08$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $1bf9b417a1cf9d08$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("izaFt", function(module, exports) {

$parcel$export(module.exports, "validateSchema", () => $52ea6309b40538c9$export$4741711f07dbb8e7);
$parcel$export(module.exports, "assertValidSchema", () => $52ea6309b40538c9$export$d32aa1886d3569c6);

var $bmIpK = parcelRequire("bmIpK");

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $2atqN = parcelRequire("2atqN");

var $f5cpS = parcelRequire("f5cpS");

var $6BdRO = parcelRequire("6BdRO");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $52ea6309b40538c9$export$4741711f07dbb8e7(schema) {
    // First check to ensure the provided value is in fact a GraphQLSchema.
    (0, $6BdRO.assertSchema)(schema); // If this Schema has already been validated, return the previous results.
    if (schema.__validationErrors) return schema.__validationErrors;
     // Validate the schema, producing a list of errors.
    var context = new $52ea6309b40538c9$var$SchemaValidationContext(schema);
    $52ea6309b40538c9$var$validateRootTypes(context);
    $52ea6309b40538c9$var$validateDirectives(context);
    $52ea6309b40538c9$var$validateTypes(context); // Persist the results of validation before returning to ensure validation
    // does not run multiple times for this schema.
    var errors = context.getErrors();
    schema.__validationErrors = errors;
    return errors;
}
function $52ea6309b40538c9$export$d32aa1886d3569c6(schema) {
    var errors = $52ea6309b40538c9$export$4741711f07dbb8e7(schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
var $52ea6309b40538c9$var$SchemaValidationContext = /*#__PURE__*/ function() {
    function SchemaValidationContext(schema) {
        this._errors = [];
        this.schema = schema;
    }
    var _proto = SchemaValidationContext.prototype;
    _proto.reportError = function reportError(message, nodes) {
        var _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;
        this.addError(new (0, $9fgMZ.GraphQLError)(message, _nodes));
    };
    _proto.addError = function addError(error) {
        this._errors.push(error);
    };
    _proto.getErrors = function getErrors() {
        return this._errors;
    };
    return SchemaValidationContext;
}();
function $52ea6309b40538c9$var$validateRootTypes(context) {
    var schema = context.schema;
    var queryType = schema.getQueryType();
    if (!queryType) context.reportError('Query root type must be provided.', schema.astNode);
    else if (!(0, $lXoEQ.isObjectType)(queryType)) {
        var _getOperationTypeNode;
        context.reportError("Query root type must be Object type, it cannot be ".concat((0, $biK02.default)(queryType), "."), (_getOperationTypeNode = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'query')) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
    }
    var mutationType = schema.getMutationType();
    if (mutationType && !(0, $lXoEQ.isObjectType)(mutationType)) {
        var _getOperationTypeNode2;
        context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat((0, $biK02.default)(mutationType), "."), (_getOperationTypeNode2 = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'mutation')) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
    }
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && !(0, $lXoEQ.isObjectType)(subscriptionType)) {
        var _getOperationTypeNode3;
        context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat((0, $biK02.default)(subscriptionType), "."), (_getOperationTypeNode3 = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'subscription')) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
    }
}
function $52ea6309b40538c9$var$getOperationTypeNode(schema, operation) {
    var operationNodes = $52ea6309b40538c9$var$getAllSubNodes(schema, function(node) {
        return node.operationTypes;
    });
    for(var _i2 = 0; _i2 < operationNodes.length; _i2++){
        var node = operationNodes[_i2];
        if (node.operation === operation) return node.type;
    }
    return undefined;
}
function $52ea6309b40538c9$var$validateDirectives(context) {
    for(var _i4 = 0, _context$schema$getDi2 = context.schema.getDirectives(); _i4 < _context$schema$getDi2.length; _i4++){
        var directive = _context$schema$getDi2[_i4];
        // Ensure all directives are in fact GraphQL directives.
        if (!(0, $bOniD.isDirective)(directive)) {
            context.reportError("Expected directive but got: ".concat((0, $biK02.default)(directive), "."), directive === null || directive === void 0 ? void 0 : directive.astNode);
            continue;
        } // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, directive); // TODO: Ensure proper locations.
        // Ensure the arguments are valid.
        for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
            var arg = _directive$args2[_i6];
            // Ensure they are named correctly.
            $52ea6309b40538c9$var$validateName(context, arg); // Ensure the type is an input type.
            if (!(0, $lXoEQ.isInputType)(arg.type)) context.reportError("The type of @".concat(directive.name, "(").concat(arg.name, ":) must be Input Type ") + "but got: ".concat((0, $biK02.default)(arg.type), "."), arg.astNode);
            if ((0, $lXoEQ.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode;
                context.reportError("Required argument @".concat(directive.name, "(").concat(arg.name, ":) cannot be deprecated."), [
                    $52ea6309b40538c9$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type
                ]);
            }
        }
    }
}
function $52ea6309b40538c9$var$validateName(context, node) {
    // Ensure names are valid, however introspection types opt out.
    var error = (0, $2atqN.isValidNameError)(node.name);
    if (error) context.addError((0, $02KAV.locatedError)(error, node.astNode));
}
function $52ea6309b40538c9$var$validateTypes(context) {
    var validateInputObjectCircularRefs = $52ea6309b40538c9$var$createInputObjectCircularRefsValidator(context);
    var typeMap = context.schema.getTypeMap();
    for(var _i8 = 0, _objectValues2 = (0, $dVq2R.default)(typeMap); _i8 < _objectValues2.length; _i8++){
        var type = _objectValues2[_i8];
        // Ensure all provided types are in fact GraphQL type.
        if (!(0, $lXoEQ.isNamedType)(type)) {
            context.reportError("Expected GraphQL named type but got: ".concat((0, $biK02.default)(type), "."), type.astNode);
            continue;
        } // Ensure it is named correctly (excluding introspection types).
        if (!(0, $h2iUh.isIntrospectionType)(type)) $52ea6309b40538c9$var$validateName(context, type);
        if ((0, $lXoEQ.isObjectType)(type)) {
            // Ensure fields are valid
            $52ea6309b40538c9$var$validateFields(context, type); // Ensure objects implement the interfaces they claim to.
            $52ea6309b40538c9$var$validateInterfaces(context, type);
        } else if ((0, $lXoEQ.isInterfaceType)(type)) {
            // Ensure fields are valid.
            $52ea6309b40538c9$var$validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.
            $52ea6309b40538c9$var$validateInterfaces(context, type);
        } else if ((0, $lXoEQ.isUnionType)(type)) // Ensure Unions include valid member types.
        $52ea6309b40538c9$var$validateUnionMembers(context, type);
        else if ((0, $lXoEQ.isEnumType)(type)) // Ensure Enums have valid values.
        $52ea6309b40538c9$var$validateEnumValues(context, type);
        else if ((0, $lXoEQ.isInputObjectType)(type)) {
            // Ensure Input Object fields are valid.
            $52ea6309b40538c9$var$validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references
            validateInputObjectCircularRefs(type);
        }
    }
}
function $52ea6309b40538c9$var$validateFields(context, type) {
    var fields = (0, $dVq2R.default)(type.getFields()); // Objects and Interfaces both must define one or more fields.
    if (fields.length === 0) context.reportError("Type ".concat(type.name, " must define one or more fields."), $52ea6309b40538c9$var$getAllNodes(type));
    for(var _i10 = 0; _i10 < fields.length; _i10++){
        var field = fields[_i10];
        // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, field); // Ensure the type is an output type
        if (!(0, $lXoEQ.isOutputType)(field.type)) {
            var _field$astNode;
            context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat((0, $biK02.default)(field.type), "."), (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
        } // Ensure the arguments are valid
        for(var _i12 = 0, _field$args2 = field.args; _i12 < _field$args2.length; _i12++){
            var arg = _field$args2[_i12];
            var argName = arg.name; // Ensure they are named correctly.
            $52ea6309b40538c9$var$validateName(context, arg); // Ensure the type is an input type
            if (!(0, $lXoEQ.isInputType)(arg.type)) {
                var _arg$astNode2;
                context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat((0, $biK02.default)(arg.type), "."), (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
            }
            if ((0, $lXoEQ.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode3;
                context.reportError("Required argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) cannot be deprecated."), [
                    $52ea6309b40538c9$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type
                ]);
            }
        }
    }
}
function $52ea6309b40538c9$var$validateInterfaces(context, type) {
    var ifaceTypeNames = Object.create(null);
    for(var _i14 = 0, _type$getInterfaces2 = type.getInterfaces(); _i14 < _type$getInterfaces2.length; _i14++){
        var iface = _type$getInterfaces2[_i14];
        if (!(0, $lXoEQ.isInterfaceType)(iface)) {
            context.reportError("Type ".concat((0, $biK02.default)(type), " must only implement Interface types, ") + "it cannot implement ".concat((0, $biK02.default)(iface), "."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (type === iface) {
            context.reportError("Type ".concat(type.name, " cannot implement itself because it would create a circular reference."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (ifaceTypeNames[iface.name]) {
            context.reportError("Type ".concat(type.name, " can only implement ").concat(iface.name, " once."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        ifaceTypeNames[iface.name] = true;
        $52ea6309b40538c9$var$validateTypeImplementsAncestors(context, type, iface);
        $52ea6309b40538c9$var$validateTypeImplementsInterface(context, type, iface);
    }
}
function $52ea6309b40538c9$var$validateTypeImplementsInterface(context, type, iface) {
    var typeFieldMap = type.getFields(); // Assert each interface field is implemented.
    for(var _i16 = 0, _objectValues4 = (0, $dVq2R.default)(iface.getFields()); _i16 < _objectValues4.length; _i16++){
        var ifaceField = _objectValues4[_i16];
        var fieldName = ifaceField.name;
        var typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.
        if (!typeField) {
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ").concat(type.name, " does not provide it."), [
                ifaceField.astNode
            ].concat($52ea6309b40538c9$var$getAllNodes(type)));
            continue;
        } // Assert interface field type is satisfied by type field type, by being
        // a valid subtype. (covariant)
        if (!(0, $f5cpS.isTypeSubTypeOf)(context.schema, typeField.type, ifaceField.type)) {
            var _ifaceField$astNode, _typeField$astNode;
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat((0, $biK02.default)(ifaceField.type), " but ").concat(type.name, ".").concat(fieldName, " ") + "is type ".concat((0, $biK02.default)(typeField.type), "."), [
                (_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type,
                (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type
            ]);
        } // Assert each interface field arg is implemented.
        var _loop = function _loop(_i18, _ifaceField$args2) {
            var ifaceArg = _ifaceField$args2[_i18];
            var argName = ifaceArg.name;
            var typeArg = (0, $bmIpK.default)(typeField.args, function(arg) {
                return arg.name === argName;
            }); // Assert interface field arg exists on object field.
            if (!typeArg) {
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) expected but ").concat(type.name, ".").concat(fieldName, " does not provide it."), [
                    ifaceArg.astNode,
                    typeField.astNode
                ]);
                return "continue";
            } // Assert interface field arg type matches object field arg type.
            // (invariant)
            // TODO: change to contravariant?
            if (!(0, $f5cpS.isEqualType)(ifaceArg.type, typeArg.type)) {
                var _ifaceArg$astNode, _typeArg$astNode;
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat((0, $biK02.default)(ifaceArg.type), " but ") + "".concat(type.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat((0, $biK02.default)(typeArg.type), "."), [
                    (_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type,
                    (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type
                ]);
            } // TODO: validate default values?
        };
        for(var _i18 = 0, _ifaceField$args2 = ifaceField.args; _i18 < _ifaceField$args2.length; _i18++){
            var _ret = _loop(_i18, _ifaceField$args2);
            if (_ret === "continue") continue;
        } // Assert additional arguments must not be required.
        var _loop2 = function _loop2(_i20, _typeField$args2) {
            var typeArg = _typeField$args2[_i20];
            var argName = typeArg.name;
            var ifaceArg = (0, $bmIpK.default)(ifaceField.args, function(arg) {
                return arg.name === argName;
            });
            if (!ifaceArg && (0, $lXoEQ.isRequiredArgument)(typeArg)) context.reportError("Object field ".concat(type.name, ".").concat(fieldName, " includes required argument ").concat(argName, " that is missing from the Interface field ").concat(iface.name, ".").concat(fieldName, "."), [
                typeArg.astNode,
                ifaceField.astNode
            ]);
        };
        for(var _i20 = 0, _typeField$args2 = typeField.args; _i20 < _typeField$args2.length; _i20++)_loop2(_i20, _typeField$args2);
    }
}
function $52ea6309b40538c9$var$validateTypeImplementsAncestors(context, type, iface) {
    var ifaceInterfaces = type.getInterfaces();
    for(var _i22 = 0, _iface$getInterfaces2 = iface.getInterfaces(); _i22 < _iface$getInterfaces2.length; _i22++){
        var transitive = _iface$getInterfaces2[_i22];
        if (ifaceInterfaces.indexOf(transitive) === -1) context.reportError(transitive === type ? "Type ".concat(type.name, " cannot implement ").concat(iface.name, " because it would create a circular reference.") : "Type ".concat(type.name, " must implement ").concat(transitive.name, " because it is implemented by ").concat(iface.name, "."), [].concat($52ea6309b40538c9$var$getAllImplementsInterfaceNodes(iface, transitive), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface)));
    }
}
function $52ea6309b40538c9$var$validateUnionMembers(context, union) {
    var memberTypes = union.getTypes();
    if (memberTypes.length === 0) context.reportError("Union type ".concat(union.name, " must define one or more member types."), $52ea6309b40538c9$var$getAllNodes(union));
    var includedTypeNames = Object.create(null);
    for(var _i24 = 0; _i24 < memberTypes.length; _i24++){
        var memberType = memberTypes[_i24];
        if (includedTypeNames[memberType.name]) {
            context.reportError("Union type ".concat(union.name, " can only include type ").concat(memberType.name, " once."), $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, memberType.name));
            continue;
        }
        includedTypeNames[memberType.name] = true;
        if (!(0, $lXoEQ.isObjectType)(memberType)) context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat((0, $biK02.default)(memberType), "."), $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, String(memberType)));
    }
}
function $52ea6309b40538c9$var$validateEnumValues(context, enumType) {
    var enumValues = enumType.getValues();
    if (enumValues.length === 0) context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), $52ea6309b40538c9$var$getAllNodes(enumType));
    for(var _i26 = 0; _i26 < enumValues.length; _i26++){
        var enumValue = enumValues[_i26];
        var valueName = enumValue.name; // Ensure valid name.
        $52ea6309b40538c9$var$validateName(context, enumValue);
        if (valueName === 'true' || valueName === 'false' || valueName === 'null') context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
    }
}
function $52ea6309b40538c9$var$validateInputFields(context, inputObj) {
    var fields = (0, $dVq2R.default)(inputObj.getFields());
    if (fields.length === 0) context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), $52ea6309b40538c9$var$getAllNodes(inputObj));
     // Ensure the arguments are valid
    for(var _i28 = 0; _i28 < fields.length; _i28++){
        var field = fields[_i28];
        // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, field); // Ensure the type is an input type
        if (!(0, $lXoEQ.isInputType)(field.type)) {
            var _field$astNode2;
            context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat((0, $biK02.default)(field.type), "."), (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
        }
        if ((0, $lXoEQ.isRequiredInputField)(field) && field.deprecationReason != null) {
            var _field$astNode3;
            context.reportError("Required input field ".concat(inputObj.name, ".").concat(field.name, " cannot be deprecated."), [
                $52ea6309b40538c9$var$getDeprecatedDirectiveNode(field.astNode),
                (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type
            ]);
        }
    }
}
function $52ea6309b40538c9$var$createInputObjectCircularRefsValidator(context) {
    // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
    // Tracks already visited types to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors
    var fieldPath = []; // Position in the type path
    var fieldPathIndexByTypeName = Object.create(null);
    return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(inputObj) {
        if (visitedTypes[inputObj.name]) return;
        visitedTypes[inputObj.name] = true;
        fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
        var fields = (0, $dVq2R.default)(inputObj.getFields());
        for(var _i30 = 0; _i30 < fields.length; _i30++){
            var field = fields[_i30];
            if ((0, $lXoEQ.isNonNullType)(field.type) && (0, $lXoEQ.isInputObjectType)(field.type.ofType)) {
                var fieldType = field.type.ofType;
                var cycleIndex = fieldPathIndexByTypeName[fieldType.name];
                fieldPath.push(field);
                if (cycleIndex === undefined) detectCycleRecursive(fieldType);
                else {
                    var cyclePath = fieldPath.slice(cycleIndex);
                    var pathStr = cyclePath.map(function(fieldObj) {
                        return fieldObj.name;
                    }).join('.');
                    context.reportError("Cannot reference Input Object \"".concat(fieldType.name, "\" within itself through a series of non-null fields: \"").concat(pathStr, "\"."), cyclePath.map(function(fieldObj) {
                        return fieldObj.astNode;
                    }));
                }
                fieldPath.pop();
            }
        }
        fieldPathIndexByTypeName[inputObj.name] = undefined;
    }
}
function $52ea6309b40538c9$var$getAllNodes(object) {
    var astNode = object.astNode, extensionASTNodes = object.extensionASTNodes;
    return astNode ? extensionASTNodes ? [
        astNode
    ].concat(extensionASTNodes) : [
        astNode
    ] : extensionASTNodes !== null && extensionASTNodes !== void 0 ? extensionASTNodes : [];
}
function $52ea6309b40538c9$var$getAllSubNodes(object, getter) {
    var subNodes = [];
    for(var _i32 = 0, _getAllNodes2 = $52ea6309b40538c9$var$getAllNodes(object); _i32 < _getAllNodes2.length; _i32++){
        var _getter;
        var node = _getAllNodes2[_i32];
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        subNodes = subNodes.concat((_getter = getter(node)) !== null && _getter !== void 0 ? _getter : []);
    }
    return subNodes;
}
function $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface) {
    return $52ea6309b40538c9$var$getAllSubNodes(type, function(typeNode) {
        return typeNode.interfaces;
    }).filter(function(ifaceNode) {
        return ifaceNode.name.value === iface.name;
    });
}
function $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, typeName) {
    return $52ea6309b40538c9$var$getAllSubNodes(union, function(unionNode) {
        return unionNode.types;
    }).filter(function(typeNode) {
        return typeNode.name.value === typeName;
    });
}
function $52ea6309b40538c9$var$getDeprecatedDirectiveNode(definitionNode) {
    var _definitionNode$direc;
    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find(function(node) {
        return node.name.value === (0, $bOniD.GraphQLDeprecatedDirective).name;
    });
}

});
parcelRegister("bmIpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf979c8600d7bc76$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var $bf979c8600d7bc76$var$find = Array.prototype.find ? function(list, predicate) {
    return Array.prototype.find.call(list, predicate);
} : function(list, predicate) {
    for(var _i2 = 0; _i2 < list.length; _i2++){
        var value = list[_i2];
        if (predicate(value)) return value;
    }
};
var $bf979c8600d7bc76$export$2e2bcd8739ae039 = $bf979c8600d7bc76$var$find;

});

parcelRegister("dVq2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba73c2159267889$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $1ba73c2159267889$var$objectValues = Object.values || function(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
};
var $1ba73c2159267889$export$2e2bcd8739ae039 = $1ba73c2159267889$var$objectValues;

});

parcelRegister("2atqN", function(module, exports) {

$parcel$export(module.exports, "isValidNameError", () => $b83fd21d28648a79$export$4ecdb5b419400d23);

var $fZdRY = parcelRequire("fZdRY");

var $9fgMZ = parcelRequire("9fgMZ");
var $b83fd21d28648a79$var$NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
function $b83fd21d28648a79$export$38c12a9ffd7a1417(name) {
    var error = $b83fd21d28648a79$export$4ecdb5b419400d23(name);
    if (error) throw error;
    return name;
}
function $b83fd21d28648a79$export$4ecdb5b419400d23(name) {
    typeof name === 'string' || (0, $fZdRY.default)(0, 'Expected name to be a string.');
    if (name.length > 1 && name[0] === '_' && name[1] === '_') return new (0, $9fgMZ.GraphQLError)("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by GraphQL introspection."));
    if (!$b83fd21d28648a79$var$NAME_RX.test(name)) return new (0, $9fgMZ.GraphQLError)("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."));
}

});

parcelRegister("f5cpS", function(module, exports) {

$parcel$export(module.exports, "isEqualType", () => $34731a9f0a0c30ed$export$c8e484a9929e6d9f);
$parcel$export(module.exports, "isTypeSubTypeOf", () => $34731a9f0a0c30ed$export$c3f31adb68f3e853);
$parcel$export(module.exports, "doTypesOverlap", () => $34731a9f0a0c30ed$export$5e7a8ea86de754bd);

var $lXoEQ = parcelRequire("lXoEQ");
function $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA, typeB) {
    // Equivalent types are equal.
    if (typeA === typeB) return true;
     // If either type is non-null, the other must also be non-null.
    if ((0, $lXoEQ.isNonNullType)(typeA) && (0, $lXoEQ.isNonNullType)(typeB)) return $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // If either type is a list, the other must also be a list.
    if ((0, $lXoEQ.isListType)(typeA) && (0, $lXoEQ.isListType)(typeB)) return $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // Otherwise the types are not equal.
    return false;
}
function $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType, superType) {
    // Equivalent type is a valid subtype
    if (maybeSubType === superType) return true;
     // If superType is non-null, maybeSubType must also be non-null.
    if ((0, $lXoEQ.isNonNullType)(superType)) {
        if ((0, $lXoEQ.isNonNullType)(maybeSubType)) return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $lXoEQ.isNonNullType)(maybeSubType)) // If superType is nullable, maybeSubType may be non-null or nullable.
    return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType);
     // If superType type is a list, maybeSubType type must also be a list.
    if ((0, $lXoEQ.isListType)(superType)) {
        if ((0, $lXoEQ.isListType)(maybeSubType)) return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $lXoEQ.isListType)(maybeSubType)) // If superType is not a list, maybeSubType must also be not a list.
    return false;
     // If superType type is an abstract type, check if it is super type of maybeSubType.
    // Otherwise, the child type is not a valid subtype of the parent type.
    return (0, $lXoEQ.isAbstractType)(superType) && ((0, $lXoEQ.isInterfaceType)(maybeSubType) || (0, $lXoEQ.isObjectType)(maybeSubType)) && schema.isSubType(superType, maybeSubType);
}
function $34731a9f0a0c30ed$export$5e7a8ea86de754bd(schema, typeA, typeB) {
    // Equivalent types overlap
    if (typeA === typeB) return true;
    if ((0, $lXoEQ.isAbstractType)(typeA)) {
        if ((0, $lXoEQ.isAbstractType)(typeB)) // If both types are abstract, then determine if there is any intersection
        // between possible concrete types of each.
        return schema.getPossibleTypes(typeA).some(function(type) {
            return schema.isSubType(typeB, type);
        });
         // Determine if the latter type is a possible concrete type of the former.
        return schema.isSubType(typeA, typeB);
    }
    if ((0, $lXoEQ.isAbstractType)(typeB)) // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
     // Otherwise the types do not overlap.
    return false;
}

});
parcelRegister("lXoEQ", function(module, exports) {

$parcel$export(module.exports, "isType", () => $4cde51e3b6dfd290$export$26b9f946b448f23e);
$parcel$export(module.exports, "isScalarType", () => $4cde51e3b6dfd290$export$5ef3b9aefb31c08b);
$parcel$export(module.exports, "isObjectType", () => $4cde51e3b6dfd290$export$f3091ca7b0907a5f);
$parcel$export(module.exports, "isInterfaceType", () => $4cde51e3b6dfd290$export$32fba5696fa641e);
$parcel$export(module.exports, "isUnionType", () => $4cde51e3b6dfd290$export$cca4caab5ef5a545);
$parcel$export(module.exports, "isEnumType", () => $4cde51e3b6dfd290$export$360fc30cf304623);
$parcel$export(module.exports, "isInputObjectType", () => $4cde51e3b6dfd290$export$594edc80cf154b94);
$parcel$export(module.exports, "isListType", () => $4cde51e3b6dfd290$export$f1003c1e9d4b008c);
$parcel$export(module.exports, "isNonNullType", () => $4cde51e3b6dfd290$export$146b6508fa0d6c82);
$parcel$export(module.exports, "GraphQLScalarType", () => $4cde51e3b6dfd290$export$64842b98ea53a3c9);
$parcel$export(module.exports, "GraphQLObjectType", () => $4cde51e3b6dfd290$export$375d3757a19c2e6e);
$parcel$export(module.exports, "assertObjectType", () => $4cde51e3b6dfd290$export$37a13eb12fbf3bc7);
$parcel$export(module.exports, "GraphQLInterfaceType", () => $4cde51e3b6dfd290$export$148e92587b8bf1f9);
$parcel$export(module.exports, "assertInterfaceType", () => $4cde51e3b6dfd290$export$b0fa8729bfe4811b);
$parcel$export(module.exports, "GraphQLUnionType", () => $4cde51e3b6dfd290$export$33c479b4c3812d0b);
$parcel$export(module.exports, "GraphQLEnumType", () => $4cde51e3b6dfd290$export$2577fb93f8748953);
$parcel$export(module.exports, "GraphQLInputObjectType", () => $4cde51e3b6dfd290$export$ea29baa44b9fd772);
$parcel$export(module.exports, "GraphQLList", () => $4cde51e3b6dfd290$export$de552006a6243367);
$parcel$export(module.exports, "GraphQLNonNull", () => $4cde51e3b6dfd290$export$ea3122a3d819ac9d);
$parcel$export(module.exports, "isInputType", () => $4cde51e3b6dfd290$export$1e617af703572bb5);
$parcel$export(module.exports, "isOutputType", () => $4cde51e3b6dfd290$export$27aadee607de5794);
$parcel$export(module.exports, "isLeafType", () => $4cde51e3b6dfd290$export$b390adabc64bab3);
$parcel$export(module.exports, "isCompositeType", () => $4cde51e3b6dfd290$export$3d8f0e61f2e75bb0);
$parcel$export(module.exports, "isAbstractType", () => $4cde51e3b6dfd290$export$6ea44a810dec4ac5);
$parcel$export(module.exports, "assertNullableType", () => $4cde51e3b6dfd290$export$9c6e9b78e1767de4);
$parcel$export(module.exports, "getNullableType", () => $4cde51e3b6dfd290$export$88b885687e78334b);
$parcel$export(module.exports, "isNamedType", () => $4cde51e3b6dfd290$export$f99194494d5b1a26);
$parcel$export(module.exports, "getNamedType", () => $4cde51e3b6dfd290$export$e6cd8ba67f39ede0);
$parcel$export(module.exports, "argsToArgsConfig", () => $4cde51e3b6dfd290$export$ae5ade30c645f6fd);
$parcel$export(module.exports, "isRequiredArgument", () => $4cde51e3b6dfd290$export$caef08b21560291a);
$parcel$export(module.exports, "isRequiredInputField", () => $4cde51e3b6dfd290$export$2657dcc79c2b6229);

var $apet0 = parcelRequire("apet0");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $hbiEd = parcelRequire("hbiEd");

var $6MWHL = parcelRequire("6MWHL");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $2AFgT = parcelRequire("2AFgT");

var $aVhwC = parcelRequire("aVhwC");

var $8nBnZ = parcelRequire("8nBnZ");

var $fbtyx = parcelRequire("fbtyx");

var $7J7By = parcelRequire("7J7By");

var $51GHS = parcelRequire("51GHS");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $iTQJQ = parcelRequire("iTQJQ");
function $4cde51e3b6dfd290$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4cde51e3b6dfd290$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4cde51e3b6dfd290$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4cde51e3b6dfd290$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4cde51e3b6dfd290$export$26b9f946b448f23e(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type) || $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) || $4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$804de46662e4ac95(type) {
    if (!$4cde51e3b6dfd290$export$26b9f946b448f23e(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL type."));
    return type;
}
function $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$64842b98ea53a3c9);
}
function $4cde51e3b6dfd290$export$6bfb69547e804cfa(type) {
    if (!$4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Scalar type."));
    return type;
}
function $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$375d3757a19c2e6e);
}
function $4cde51e3b6dfd290$export$37a13eb12fbf3bc7(type) {
    if (!$4cde51e3b6dfd290$export$f3091ca7b0907a5f(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Object type."));
    return type;
}
function $4cde51e3b6dfd290$export$32fba5696fa641e(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$148e92587b8bf1f9);
}
function $4cde51e3b6dfd290$export$b0fa8729bfe4811b(type) {
    if (!$4cde51e3b6dfd290$export$32fba5696fa641e(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Interface type."));
    return type;
}
function $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$33c479b4c3812d0b);
}
function $4cde51e3b6dfd290$export$fd1fc643145b79aa(type) {
    if (!$4cde51e3b6dfd290$export$cca4caab5ef5a545(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Union type."));
    return type;
}
function $4cde51e3b6dfd290$export$360fc30cf304623(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$2577fb93f8748953);
}
function $4cde51e3b6dfd290$export$152b058be1610b0e(type) {
    if (!$4cde51e3b6dfd290$export$360fc30cf304623(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Enum type."));
    return type;
}
function $4cde51e3b6dfd290$export$594edc80cf154b94(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$ea29baa44b9fd772);
}
function $4cde51e3b6dfd290$export$d3177a47c4ed448a(type) {
    if (!$4cde51e3b6dfd290$export$594edc80cf154b94(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Input Object type."));
    return type;
}
function $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$de552006a6243367);
}
function $4cde51e3b6dfd290$export$a4a2309317558e91(type) {
    if (!$4cde51e3b6dfd290$export$f1003c1e9d4b008c(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL List type."));
    return type;
}
function $4cde51e3b6dfd290$export$146b6508fa0d6c82(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$ea3122a3d819ac9d);
}
function $4cde51e3b6dfd290$export$4c0a7702e4a2acc9(type) {
    if (!$4cde51e3b6dfd290$export$146b6508fa0d6c82(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Non-Null type."));
    return type;
}
function $4cde51e3b6dfd290$export$1e617af703572bb5(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type) || $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) && $4cde51e3b6dfd290$export$1e617af703572bb5(type.ofType);
}
function $4cde51e3b6dfd290$export$6e3e8b9b85427518(type) {
    if (!$4cde51e3b6dfd290$export$1e617af703572bb5(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL input type."));
    return type;
}
function $4cde51e3b6dfd290$export$27aadee607de5794(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) && $4cde51e3b6dfd290$export$27aadee607de5794(type.ofType);
}
function $4cde51e3b6dfd290$export$3efb5e473c31d62b(type) {
    if (!$4cde51e3b6dfd290$export$27aadee607de5794(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL output type."));
    return type;
}
function $4cde51e3b6dfd290$export$b390adabc64bab3(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type);
}
function $4cde51e3b6dfd290$export$2bb5b8127c27d0cc(type) {
    if (!$4cde51e3b6dfd290$export$b390adabc64bab3(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL leaf type."));
    return type;
}
function $4cde51e3b6dfd290$export$3d8f0e61f2e75bb0(type) {
    return $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type);
}
function $4cde51e3b6dfd290$export$5b55b276a74cf725(type) {
    if (!$4cde51e3b6dfd290$export$3d8f0e61f2e75bb0(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL composite type."));
    return type;
}
function $4cde51e3b6dfd290$export$6ea44a810dec4ac5(type) {
    return $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type);
}
function $4cde51e3b6dfd290$export$d7092fd91c1fbaf8(type) {
    if (!$4cde51e3b6dfd290$export$6ea44a810dec4ac5(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL abstract type."));
    return type;
}
function $4cde51e3b6dfd290$export$de552006a6243367(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof $4cde51e3b6dfd290$export$de552006a6243367) this.ofType = $4cde51e3b6dfd290$export$804de46662e4ac95(ofType);
    else return new $4cde51e3b6dfd290$export$de552006a6243367(ofType);
} // Need to cast through any to alter the prototype.
$4cde51e3b6dfd290$export$de552006a6243367.prototype.toString = function toString() {
    return '[' + String(this.ofType) + ']';
};
$4cde51e3b6dfd290$export$de552006a6243367.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty($4cde51e3b6dfd290$export$de552006a6243367.prototype, (0, $gwa3m.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLList';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$de552006a6243367);
function $4cde51e3b6dfd290$export$ea3122a3d819ac9d(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof $4cde51e3b6dfd290$export$ea3122a3d819ac9d) this.ofType = $4cde51e3b6dfd290$export$9c6e9b78e1767de4(ofType);
    else return new $4cde51e3b6dfd290$export$ea3122a3d819ac9d(ofType);
} // Need to cast through any to alter the prototype.
$4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype.toString = function toString() {
    return String(this.ofType) + '!';
};
$4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty($4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype, (0, $gwa3m.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLNonNull';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$ea3122a3d819ac9d);
function $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) {
    return $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) || $4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$ee52e012d8d583c6(type) {
    if (!$4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL wrapping type."));
    return type;
}
function $4cde51e3b6dfd290$export$103e38848746832(type) {
    return $4cde51e3b6dfd290$export$26b9f946b448f23e(type) && !$4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$9c6e9b78e1767de4(type) {
    if (!$4cde51e3b6dfd290$export$103e38848746832(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL nullable type."));
    return type;
}
function $4cde51e3b6dfd290$export$88b885687e78334b(type) {
    /* eslint-enable no-redeclare */ if (type) return $4cde51e3b6dfd290$export$146b6508fa0d6c82(type) ? type.ofType : type;
}
function $4cde51e3b6dfd290$export$f99194494d5b1a26(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type);
}
function $4cde51e3b6dfd290$export$57234e7b640498aa(type) {
    if (!$4cde51e3b6dfd290$export$f99194494d5b1a26(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL named type."));
    return type;
}
function $4cde51e3b6dfd290$export$e6cd8ba67f39ede0(type) {
    /* eslint-enable no-redeclare */ if (type) {
        var unwrappedType = type;
        while($4cde51e3b6dfd290$export$2dbe78c78d9c62bb(unwrappedType))unwrappedType = unwrappedType.ofType;
        return unwrappedType;
    }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */ function $4cde51e3b6dfd290$var$resolveThunk(thunk) {
    // $FlowFixMe[incompatible-use]
    return typeof thunk === 'function' ? thunk() : thunk;
}
function $4cde51e3b6dfd290$var$undefineIfEmpty(arr) {
    return arr && arr.length > 0 ? arr : undefined;
}
var $4cde51e3b6dfd290$export$64842b98ea53a3c9 = /*#__PURE__*/ function() {
    function GraphQLScalarType(config) {
        var _config$parseValue, _config$serialize, _config$parseLiteral;
        var parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : (0, $7J7By.default);
        this.name = config.name;
        this.description = config.description;
        this.specifiedByUrl = config.specifiedByUrl;
        this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : (0, $7J7By.default);
        this.parseValue = parseValue;
        this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : function(node, variables) {
            return parseValue((0, $iTQJQ.valueFromASTUntyped)(node, variables));
        };
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.specifiedByUrl == null || typeof config.specifiedByUrl === 'string' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"specifiedByUrl\" as a string, ") + "but got: ".concat((0, $biK02.default)(config.specifiedByUrl), "."));
        config.serialize == null || typeof config.serialize === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar is also used as an input type, ensure \"parseValue\" and \"parseLiteral\" functions are also provided."));
        if (config.parseLiteral) typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" functions."));
    }
    var _proto = GraphQLScalarType.prototype;
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            name: this.name,
            description: this.description,
            specifiedByUrl: this.specifiedByUrl,
            serialize: this.serialize,
            parseValue: this.parseValue,
            parseLiteral: this.parseLiteral,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : []
        };
    };
    _proto.toString = function toString() {
        return this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLScalarType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLScalarType';
            }
        }
    ]);
    return GraphQLScalarType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$64842b98ea53a3c9);
var $4cde51e3b6dfd290$export$375d3757a19c2e6e = /*#__PURE__*/ function() {
    function GraphQLObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.isTypeOf = config.isTypeOf;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $4cde51e3b6dfd290$var$defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.isTypeOf == null || typeof config.isTypeOf === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.isTypeOf), "."));
    }
    var _proto2 = GraphQLObjectType.prototype;
    _proto2.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto2.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto2.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $4cde51e3b6dfd290$var$fieldsToFieldsConfig(this.getFields()),
            isTypeOf: this.isTypeOf,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes || []
        };
    };
    _proto2.toString = function toString() {
        return this.name;
    };
    _proto2.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLObjectType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLObjectType';
            }
        }
    ]);
    return GraphQLObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$375d3757a19c2e6e);
function $4cde51e3b6dfd290$var$defineInterfaces(config) {
    var _resolveThunk;
    var interfaces = (_resolveThunk = $4cde51e3b6dfd290$var$resolveThunk(config.interfaces)) !== null && _resolveThunk !== void 0 ? _resolveThunk : [];
    Array.isArray(interfaces) || (0, $fZdRY.default)(0, "".concat(config.name, " interfaces must be an Array or a function which returns an Array."));
    return interfaces;
}
function $4cde51e3b6dfd290$var$defineFieldMap(config) {
    var fieldMap = $4cde51e3b6dfd290$var$resolveThunk(config.fields);
    $4cde51e3b6dfd290$var$isPlainObj(fieldMap) || (0, $fZdRY.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, $6MWHL.default)(fieldMap, function(fieldConfig, fieldName) {
        var _fieldConfig$args;
        $4cde51e3b6dfd290$var$isPlainObj(fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object."));
        !('isDeprecated' in fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        fieldConfig.resolve == null || typeof fieldConfig.resolve === 'function' || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat((0, $biK02.default)(fieldConfig.resolve), "."));
        var argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
        $4cde51e3b6dfd290$var$isPlainObj(argsConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument names as keys."));
        var args = (0, $apet0.default)(argsConfig).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, $eCJ4z.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            args: args,
            resolve: fieldConfig.resolve,
            subscribe: fieldConfig.subscribe,
            isDeprecated: fieldConfig.deprecationReason != null,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, $eCJ4z.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $4cde51e3b6dfd290$var$isPlainObj(obj) {
    return (0, $fbtyx.default)(obj) && !Array.isArray(obj);
}
function $4cde51e3b6dfd290$var$fieldsToFieldsConfig(fields) {
    return (0, $6MWHL.default)(fields, function(field) {
        return {
            description: field.description,
            type: field.type,
            args: $4cde51e3b6dfd290$export$ae5ade30c645f6fd(field.args),
            resolve: field.resolve,
            subscribe: field.subscribe,
            deprecationReason: field.deprecationReason,
            extensions: field.extensions,
            astNode: field.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$ae5ade30c645f6fd(args) {
    return (0, $2AFgT.default)(args, function(arg) {
        return arg.name;
    }, function(arg) {
        return {
            description: arg.description,
            type: arg.type,
            defaultValue: arg.defaultValue,
            deprecationReason: arg.deprecationReason,
            extensions: arg.extensions,
            astNode: arg.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$caef08b21560291a(arg) {
    return $4cde51e3b6dfd290$export$146b6508fa0d6c82(arg.type) && arg.defaultValue === undefined;
}
var $4cde51e3b6dfd290$export$148e92587b8bf1f9 = /*#__PURE__*/ function() {
    function GraphQLInterfaceType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $4cde51e3b6dfd290$var$defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.resolveType), "."));
    }
    var _proto3 = GraphQLInterfaceType.prototype;
    _proto3.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto3.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto3.toConfig = function toConfig() {
        var _this$extensionASTNod2;
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $4cde51e3b6dfd290$var$fieldsToFieldsConfig(this.getFields()),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod2 = this.extensionASTNodes) !== null && _this$extensionASTNod2 !== void 0 ? _this$extensionASTNod2 : []
        };
    };
    _proto3.toString = function toString() {
        return this.name;
    };
    _proto3.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLInterfaceType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInterfaceType';
            }
        }
    ]);
    return GraphQLInterfaceType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$148e92587b8bf1f9);
var $4cde51e3b6dfd290$export$33c479b4c3812d0b = /*#__PURE__*/ function() {
    function GraphQLUnionType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._types = $4cde51e3b6dfd290$var$defineTypes.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.resolveType), "."));
    }
    var _proto4 = GraphQLUnionType.prototype;
    _proto4.getTypes = function getTypes() {
        if (typeof this._types === 'function') this._types = this._types();
        return this._types;
    };
    _proto4.toConfig = function toConfig() {
        var _this$extensionASTNod3;
        return {
            name: this.name,
            description: this.description,
            types: this.getTypes(),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod3 = this.extensionASTNodes) !== null && _this$extensionASTNod3 !== void 0 ? _this$extensionASTNod3 : []
        };
    };
    _proto4.toString = function toString() {
        return this.name;
    };
    _proto4.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLUnionType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLUnionType';
            }
        }
    ]);
    return GraphQLUnionType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$33c479b4c3812d0b);
function $4cde51e3b6dfd290$var$defineTypes(config) {
    var types = $4cde51e3b6dfd290$var$resolveThunk(config.types);
    Array.isArray(types) || (0, $fZdRY.default)(0, "Must provide Array of types or a function which returns such an array for Union ".concat(config.name, "."));
    return types;
}
var $4cde51e3b6dfd290$export$2577fb93f8748953 = /*#__PURE__*/ function() {
    function GraphQLEnumType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._values = $4cde51e3b6dfd290$var$defineEnumValues(this.name, config.values);
        this._valueLookup = new Map(this._values.map(function(enumValue) {
            return [
                enumValue.value,
                enumValue
            ];
        }));
        this._nameLookup = (0, $hbiEd.default)(this._values, function(value) {
            return value.name;
        });
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
    }
    var _proto5 = GraphQLEnumType.prototype;
    _proto5.getValues = function getValues() {
        return this._values;
    };
    _proto5.getValue = function getValue(name) {
        return this._nameLookup[name];
    };
    _proto5.serialize = function serialize(outputValue) {
        var enumValue = this._valueLookup.get(outputValue);
        if (enumValue === undefined) throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent value: ").concat((0, $biK02.default)(outputValue)));
        return enumValue.name;
    };
    _proto5.parseValue = function parseValue(inputValue) /* T */ {
        if (typeof inputValue !== 'string') {
            var valueStr = (0, $biK02.default)(inputValue);
            throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-string value: ").concat(valueStr, ".") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, valueStr));
        }
        var enumValue = this.getValue(inputValue);
        if (enumValue == null) throw new (0, $9fgMZ.GraphQLError)("Value \"".concat(inputValue, "\" does not exist in \"").concat(this.name, "\" enum.") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, inputValue));
        return enumValue.value;
    };
    _proto5.parseLiteral = function parseLiteral(valueNode, _variables) /* T */ {
        // Note: variables will be resolved to a value before calling this function.
        if (valueNode.kind !== (0, $1c4hI.Kind).ENUM) {
            var valueStr = (0, $aKlnM.print)(valueNode);
            throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-enum value: ").concat(valueStr, ".") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, valueStr), valueNode);
        }
        var enumValue = this.getValue(valueNode.value);
        if (enumValue == null) {
            var _valueStr = (0, $aKlnM.print)(valueNode);
            throw new (0, $9fgMZ.GraphQLError)("Value \"".concat(_valueStr, "\" does not exist in \"").concat(this.name, "\" enum.") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, _valueStr), valueNode);
        }
        return enumValue.value;
    };
    _proto5.toConfig = function toConfig() {
        var _this$extensionASTNod4;
        var values = (0, $2AFgT.default)(this.getValues(), function(value) {
            return value.name;
        }, function(value) {
            return {
                description: value.description,
                value: value.value,
                deprecationReason: value.deprecationReason,
                extensions: value.extensions,
                astNode: value.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            values: values,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod4 = this.extensionASTNodes) !== null && _this$extensionASTNod4 !== void 0 ? _this$extensionASTNod4 : []
        };
    };
    _proto5.toString = function toString() {
        return this.name;
    };
    _proto5.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLEnumType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLEnumType';
            }
        }
    ]);
    return GraphQLEnumType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$2577fb93f8748953);
function $4cde51e3b6dfd290$var$didYouMeanEnumValue(enumType, unknownValueStr) {
    var allNames = enumType.getValues().map(function(value) {
        return value.name;
    });
    var suggestedValues = (0, $bru1k.default)(unknownValueStr, allNames);
    return (0, $8nBnZ.default)('the enum value', suggestedValues);
}
function $4cde51e3b6dfd290$var$defineEnumValues(typeName, valueMap) {
    $4cde51e3b6dfd290$var$isPlainObj(valueMap) || (0, $fZdRY.default)(0, "".concat(typeName, " values must be an object with value names as keys."));
    return (0, $apet0.default)(valueMap).map(function(_ref2) {
        var valueName = _ref2[0], valueConfig = _ref2[1];
        $4cde51e3b6dfd290$var$isPlainObj(valueConfig) || (0, $fZdRY.default)(0, "".concat(typeName, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat((0, $biK02.default)(valueConfig), "."));
        !('isDeprecated' in valueConfig) || (0, $fZdRY.default)(0, "".concat(typeName, ".").concat(valueName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        return {
            name: valueName,
            description: valueConfig.description,
            value: valueConfig.value !== undefined ? valueConfig.value : valueName,
            isDeprecated: valueConfig.deprecationReason != null,
            deprecationReason: valueConfig.deprecationReason,
            extensions: valueConfig.extensions && (0, $eCJ4z.default)(valueConfig.extensions),
            astNode: valueConfig.astNode
        };
    });
}
var $4cde51e3b6dfd290$export$ea29baa44b9fd772 = /*#__PURE__*/ function() {
    function GraphQLInputObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineInputFieldMap.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
    }
    var _proto6 = GraphQLInputObjectType.prototype;
    _proto6.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto6.toConfig = function toConfig() {
        var _this$extensionASTNod5;
        var fields = (0, $6MWHL.default)(this.getFields(), function(field) {
            return {
                description: field.description,
                type: field.type,
                defaultValue: field.defaultValue,
                deprecationReason: field.deprecationReason,
                extensions: field.extensions,
                astNode: field.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            fields: fields,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod5 = this.extensionASTNodes) !== null && _this$extensionASTNod5 !== void 0 ? _this$extensionASTNod5 : []
        };
    };
    _proto6.toString = function toString() {
        return this.name;
    };
    _proto6.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLInputObjectType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInputObjectType';
            }
        }
    ]);
    return GraphQLInputObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$ea29baa44b9fd772);
function $4cde51e3b6dfd290$var$defineInputFieldMap(config) {
    var fieldMap = $4cde51e3b6dfd290$var$resolveThunk(config.fields);
    $4cde51e3b6dfd290$var$isPlainObj(fieldMap) || (0, $fZdRY.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, $6MWHL.default)(fieldMap, function(fieldConfig, fieldName) {
        !('resolve' in fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but Input Types cannot define resolvers."));
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            defaultValue: fieldConfig.defaultValue,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, $eCJ4z.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$2657dcc79c2b6229(field) {
    return $4cde51e3b6dfd290$export$146b6508fa0d6c82(field.type) && field.defaultValue === undefined;
}

});
parcelRegister("apet0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b08f9c07090601a$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $7b08f9c07090601a$var$objectEntries = Object.entries || function(obj) {
    return Object.keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
};
var $7b08f9c07090601a$export$2e2bcd8739ae039 = $7b08f9c07090601a$var$objectEntries;

});

parcelRegister("hbiEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8bc0ac8e121286d$export$2e2bcd8739ae039);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: { name: 'Jon', num: '555-1234' },
 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
 *     const entriesByName = keyMap(
 *       phoneBook,
 *       entry => entry.name
 *     )
 *
 *     // { name: 'Jenny', num: '857-6309' }
 *     const jennyEntry = entriesByName['Jenny']
 *
 */ function $b8bc0ac8e121286d$export$2e2bcd8739ae039(list, keyFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = item;
        return map;
    }, Object.create(null));
}

});

parcelRegister("6MWHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8fd45ca354e0fd3$export$2e2bcd8739ae039);

var $apet0 = parcelRequire("apet0");
function $f8fd45ca354e0fd3$export$2e2bcd8739ae039(map, fn) {
    var result = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, $apet0.default)(map); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var _key = _ref2[0];
        var _value = _ref2[1];
        result[_key] = fn(_value, _key);
    }
    return result;
}

});

parcelRegister("eCJ4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b444aa0d60034f90$export$2e2bcd8739ae039);

var $apet0 = parcelRequire("apet0");
function $b444aa0d60034f90$export$2e2bcd8739ae039(obj) {
    /* eslint-enable no-redeclare */ if (Object.getPrototypeOf(obj) === null) return obj;
    var map = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, $apet0.default)(obj); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var key = _ref2[0];
        var value = _ref2[1];
        map[key] = value;
    }
    return map;
}

});

parcelRegister("2AFgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $825d74909efe1661$export$2e2bcd8739ae039);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: '555-1234', Jenny: '867-5309' }
 *     const phonesByName = keyValMap(
 *       phoneBook,
 *       entry => entry.name,
 *       entry => entry.num
 *     )
 *
 */ function $825d74909efe1661$export$2e2bcd8739ae039(list, keyFn, valFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = valFn(item);
        return map;
    }, Object.create(null));
}

});

parcelRegister("aVhwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef14998e21195a05$export$2e2bcd8739ae039);

function $ef14998e21195a05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ef14998e21195a05$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$ef14998e21195a05$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});

parcelRegister("8nBnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35e74e446587809$export$2e2bcd8739ae039);
var $d35e74e446587809$var$MAX_SUGGESTIONS = 5;
function $d35e74e446587809$export$2e2bcd8739ae039(firstArg, secondArg) {
    var _ref = typeof firstArg === 'string' ? [
        firstArg,
        secondArg
    ] : [
        undefined,
        firstArg
    ], subMessage = _ref[0], suggestionsArg = _ref[1];
    var message = ' Did you mean ';
    if (subMessage) message += subMessage + ' ';
    var suggestions = suggestionsArg.map(function(x) {
        return "\"".concat(x, "\"");
    });
    switch(suggestions.length){
        case 0:
            return '';
        case 1:
            return message + suggestions[0] + '?';
        case 2:
            return message + suggestions[0] + ' or ' + suggestions[1] + '?';
    }
    var selected = suggestions.slice(0, $d35e74e446587809$var$MAX_SUGGESTIONS);
    var lastItem = selected.pop();
    return message + selected.join(', ') + ', or ' + lastItem + '?';
}

});

parcelRegister("7J7By", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3262e5f24e9ad17$export$2e2bcd8739ae039);
/**
 * Returns the first argument it receives.
 */ function $a3262e5f24e9ad17$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("bru1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c1d5be3d827a25$export$2e2bcd8739ae039);

var $daK4l = parcelRequire("daK4l");
function $60c1d5be3d827a25$export$2e2bcd8739ae039(input, options) {
    var optionsByDistance = Object.create(null);
    var lexicalDistance = new $60c1d5be3d827a25$var$LexicalDistance(input);
    var threshold = Math.floor(input.length * 0.4) + 1;
    for(var _i2 = 0; _i2 < options.length; _i2++){
        var option = options[_i2];
        var distance = lexicalDistance.measure(option, threshold);
        if (distance !== undefined) optionsByDistance[option] = distance;
    }
    return Object.keys(optionsByDistance).sort(function(a, b) {
        var distanceDiff = optionsByDistance[a] - optionsByDistance[b];
        return distanceDiff !== 0 ? distanceDiff : (0, $daK4l.default)(a, b);
    });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */ var $60c1d5be3d827a25$var$LexicalDistance = /*#__PURE__*/ function() {
    function LexicalDistance(input) {
        this._input = input;
        this._inputLowerCase = input.toLowerCase();
        this._inputArray = $60c1d5be3d827a25$var$stringToArray(this._inputLowerCase);
        this._rows = [
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0)
        ];
    }
    var _proto = LexicalDistance.prototype;
    _proto.measure = function measure(option, threshold) {
        if (this._input === option) return 0;
        var optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit
        if (this._inputLowerCase === optionLowerCase) return 1;
        var a = $60c1d5be3d827a25$var$stringToArray(optionLowerCase);
        var b = this._inputArray;
        if (a.length < b.length) {
            var tmp = a;
            a = b;
            b = tmp;
        }
        var aLength = a.length;
        var bLength = b.length;
        if (aLength - bLength > threshold) return undefined;
        var rows = this._rows;
        for(var j = 0; j <= bLength; j++)rows[0][j] = j;
        for(var i = 1; i <= aLength; i++){
            var upRow = rows[(i - 1) % 3];
            var currentRow = rows[i % 3];
            var smallestCell = currentRow[0] = i;
            for(var _j = 1; _j <= bLength; _j++){
                var cost = a[i - 1] === b[_j - 1] ? 0 : 1;
                var currentCell = Math.min(upRow[_j] + 1, currentRow[_j - 1] + 1, upRow[_j - 1] + cost // substitute
                );
                if (i > 1 && _j > 1 && a[i - 1] === b[_j - 2] && a[i - 2] === b[_j - 1]) {
                    // transposition
                    var doubleDiagonalCell = rows[(i - 2) % 3][_j - 2];
                    currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
                }
                if (currentCell < smallestCell) smallestCell = currentCell;
                currentRow[_j] = currentCell;
            } // Early exit, since distance can't go smaller than smallest element of the previous row.
            if (smallestCell > threshold) return undefined;
        }
        var distance = rows[aLength % 3][bLength];
        return distance <= threshold ? distance : undefined;
    };
    return LexicalDistance;
}();
function $60c1d5be3d827a25$var$stringToArray(str) {
    var strLength = str.length;
    var array = new Array(strLength);
    for(var i = 0; i < strLength; ++i)array[i] = str.charCodeAt(i);
    return array;
}

});
parcelRegister("daK4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $1240f08dc429303b$export$2e2bcd8739ae039);
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */ function $1240f08dc429303b$export$2e2bcd8739ae039(aStr, bStr) {
    var aIdx = 0;
    var bIdx = 0;
    while(aIdx < aStr.length && bIdx < bStr.length){
        var aChar = aStr.charCodeAt(aIdx);
        var bChar = bStr.charCodeAt(bIdx);
        if ($1240f08dc429303b$var$isDigit(aChar) && $1240f08dc429303b$var$isDigit(bChar)) {
            var aNum = 0;
            do {
                ++aIdx;
                aNum = aNum * 10 + aChar - $1240f08dc429303b$var$DIGIT_0;
                aChar = aStr.charCodeAt(aIdx);
            }while ($1240f08dc429303b$var$isDigit(aChar) && aNum > 0);
            var bNum = 0;
            do {
                ++bIdx;
                bNum = bNum * 10 + bChar - $1240f08dc429303b$var$DIGIT_0;
                bChar = bStr.charCodeAt(bIdx);
            }while ($1240f08dc429303b$var$isDigit(bChar) && bNum > 0);
            if (aNum < bNum) return -1;
            if (aNum > bNum) return 1;
        } else {
            if (aChar < bChar) return -1;
            if (aChar > bChar) return 1;
            ++aIdx;
            ++bIdx;
        }
    }
    return aStr.length - bStr.length;
}
var $1240f08dc429303b$var$DIGIT_0 = 48;
var $1240f08dc429303b$var$DIGIT_9 = 57;
function $1240f08dc429303b$var$isDigit(code) {
    return !isNaN(code) && $1240f08dc429303b$var$DIGIT_0 <= code && code <= $1240f08dc429303b$var$DIGIT_9;
}

});


parcelRegister("aKlnM", function(module, exports) {

$parcel$export(module.exports, "print", () => $1f94f8496a1ffd7f$export$c2d084dc44961371);

var $961BR = parcelRequire("961BR");

var $flA0a = parcelRequire("flA0a");
function $1f94f8496a1ffd7f$export$c2d084dc44961371(ast) {
    return (0, $961BR.visit)(ast, {
        leave: $1f94f8496a1ffd7f$var$printDocASTReducer
    });
}
var $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $1f94f8496a1ffd7f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $1f94f8496a1ffd7f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $1f94f8496a1ffd7f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $1f94f8496a1ffd7f$var$join([
            op,
            $1f94f8496a1ffd7f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' = ', defaultValue) + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $1f94f8496a1ffd7f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $1f94f8496a1ffd7f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
        if (argsLine.length > $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH) argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)');
        return $1f94f8496a1ffd7f$var$join([
            argsLine,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $1f94f8496a1ffd7f$var$join([
            '...',
            $1f94f8496a1ffd7f$var$wrap('on ', typeCondition),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($1f94f8496a1ffd7f$var$wrap('', $1f94f8496a1ffd7f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $flA0a.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $1f94f8496a1ffd7f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $1f94f8496a1ffd7f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $1f94f8496a1ffd7f$var$join([
            'scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $1f94f8496a1ffd7f$var$join([
            'type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    }),
    InputValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $1f94f8496a1ffd7f$var$join([
            name + ': ' + type,
            $1f94f8496a1ffd7f$var$wrap('= ', defaultValue),
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $1f94f8496a1ffd7f$var$join([
            'interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $1f94f8496a1ffd7f$var$join([
            'union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $1f94f8496a1ffd7f$var$join([
            'enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $1f94f8496a1ffd7f$var$join([
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $1f94f8496a1ffd7f$var$join([
            'input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $1f94f8496a1ffd7f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'extend schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $1f94f8496a1ffd7f$var$join([
            'extend scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $1f94f8496a1ffd7f$var$join([
            'extend union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $1f94f8496a1ffd7f$var$join([
            'extend enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }
};
function $1f94f8496a1ffd7f$var$addDescription(cb) {
    return function(node) {
        return $1f94f8496a1ffd7f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $1f94f8496a1ffd7f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $1f94f8496a1ffd7f$var$block(array) {
    return $1f94f8496a1ffd7f$var$wrap('{\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $1f94f8496a1ffd7f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $1f94f8496a1ffd7f$var$indent(str) {
    return $1f94f8496a1ffd7f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $1f94f8496a1ffd7f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $1f94f8496a1ffd7f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($1f94f8496a1ffd7f$var$isMultiline);
}

});
parcelRegister("flA0a", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $06a65b237068075a$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $06a65b237068075a$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $06a65b237068075a$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $06a65b237068075a$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $06a65b237068075a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $06a65b237068075a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $06a65b237068075a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $06a65b237068075a$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $06a65b237068075a$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("iTQJQ", function(module, exports) {

$parcel$export(module.exports, "valueFromASTUntyped", () => $da10b2789fd99674$export$448e0963aec9442f);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $2AFgT = parcelRequire("2AFgT");

var $1c4hI = parcelRequire("1c4hI");
function $da10b2789fd99674$export$448e0963aec9442f(valueNode, variables) {
    switch(valueNode.kind){
        case (0, $1c4hI.Kind).NULL:
            return null;
        case (0, $1c4hI.Kind).INT:
            return parseInt(valueNode.value, 10);
        case (0, $1c4hI.Kind).FLOAT:
            return parseFloat(valueNode.value);
        case (0, $1c4hI.Kind).STRING:
        case (0, $1c4hI.Kind).ENUM:
        case (0, $1c4hI.Kind).BOOLEAN:
            return valueNode.value;
        case (0, $1c4hI.Kind).LIST:
            return valueNode.values.map(function(node) {
                return $da10b2789fd99674$export$448e0963aec9442f(node, variables);
            });
        case (0, $1c4hI.Kind).OBJECT:
            return (0, $2AFgT.default)(valueNode.fields, function(field) {
                return field.name.value;
            }, function(field) {
                return $da10b2789fd99674$export$448e0963aec9442f(field.value, variables);
            });
        case (0, $1c4hI.Kind).VARIABLE:
            return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
    } // istanbul ignore next (Not reachable. All possible value nodes have been considered)
    (0, $43MJl.default)(0, 'Unexpected value node: ' + (0, $biK02.default)(valueNode));
}

});



parcelRegister("6BdRO", function(module, exports) {

$parcel$export(module.exports, "GraphQLSchema", () => $1e230b99124f3642$export$730e8b0fd6e4f02b);
$parcel$export(module.exports, "assertSchema", () => $1e230b99124f3642$export$6554dabc0f90e0c3);

var $bmIpK = parcelRequire("bmIpK");

var $96Cqc = parcelRequire("96Cqc");

var $dVq2R = parcelRequire("dVq2R");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");

var $fbtyx = parcelRequire("fbtyx");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $1e230b99124f3642$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1e230b99124f3642$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1e230b99124f3642$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1e230b99124f3642$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1e230b99124f3642$export$213e2a3e7c4f326e(schema) {
    return (0, $aVhwC.default)(schema, $1e230b99124f3642$export$730e8b0fd6e4f02b);
}
function $1e230b99124f3642$export$6554dabc0f90e0c3(schema) {
    if (!$1e230b99124f3642$export$213e2a3e7c4f326e(schema)) throw new Error("Expected ".concat((0, $biK02.default)(schema), " to be a GraphQL schema."));
    return schema;
}
var $1e230b99124f3642$export$730e8b0fd6e4f02b = /*#__PURE__*/ function() {
    // Used as a cache for validateSchema().
    function GraphQLSchema(config) {
        var _config$directives;
        // If this schema was built from a source known to be valid, then it may be
        // marked with assumeValid to avoid an additional type system validation.
        this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.
        (0, $fbtyx.default)(config) || (0, $fZdRY.default)(0, 'Must provide configuration object.');
        !config.types || Array.isArray(config.types) || (0, $fZdRY.default)(0, "\"types\" must be Array if provided but got: ".concat((0, $biK02.default)(config.types), "."));
        !config.directives || Array.isArray(config.directives) || (0, $fZdRY.default)(0, '"directives" must be Array if provided but got: ' + "".concat((0, $biK02.default)(config.directives), "."));
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = config.extensionASTNodes;
        this._queryType = config.query;
        this._mutationType = config.mutation;
        this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.
        this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : (0, $bOniD.specifiedDirectives); // To preserve order of user-provided types, we add first to add them to
        // the set of "collected" types, so `collectReferencedTypes` ignore them.
        var allReferencedTypes = new Set(config.types);
        if (config.types != null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
            var type = _config$types2[_i2];
            // When we ready to process this type, we remove it from "collected" types
            // and then add it together with all dependent types in the correct position.
            allReferencedTypes.delete(type);
            $1e230b99124f3642$var$collectReferencedTypes(type, allReferencedTypes);
        }
        if (this._queryType != null) $1e230b99124f3642$var$collectReferencedTypes(this._queryType, allReferencedTypes);
        if (this._mutationType != null) $1e230b99124f3642$var$collectReferencedTypes(this._mutationType, allReferencedTypes);
        if (this._subscriptionType != null) $1e230b99124f3642$var$collectReferencedTypes(this._subscriptionType, allReferencedTypes);
        for(var _i4 = 0, _this$_directives2 = this._directives; _i4 < _this$_directives2.length; _i4++){
            var directive = _this$_directives2[_i4];
            // Directives are not validated until validateSchema() is called.
            if ((0, $bOniD.isDirective)(directive)) for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
                var arg = _directive$args2[_i6];
                $1e230b99124f3642$var$collectReferencedTypes(arg.type, allReferencedTypes);
            }
        }
        $1e230b99124f3642$var$collectReferencedTypes((0, $h2iUh.__Schema), allReferencedTypes); // Storing the resulting map for reference by the schema.
        this._typeMap = Object.create(null);
        this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.
        this._implementationsMap = Object.create(null);
        for(var _i8 = 0, _arrayFrom2 = (0, $96Cqc.default)(allReferencedTypes); _i8 < _arrayFrom2.length; _i8++){
            var namedType = _arrayFrom2[_i8];
            if (namedType == null) continue;
            var typeName = namedType.name;
            typeName || (0, $fZdRY.default)(0, 'One of the provided types for building the Schema is missing a name.');
            if (this._typeMap[typeName] !== undefined) throw new Error("Schema must contain uniquely named types but contains multiple types named \"".concat(typeName, "\"."));
            this._typeMap[typeName] = namedType;
            if ((0, $lXoEQ.isInterfaceType)(namedType)) // Store implementations by interface.
            for(var _i10 = 0, _namedType$getInterfa2 = namedType.getInterfaces(); _i10 < _namedType$getInterfa2.length; _i10++){
                var iface = _namedType$getInterfa2[_i10];
                if ((0, $lXoEQ.isInterfaceType)(iface)) {
                    var implementations = this._implementationsMap[iface.name];
                    if (implementations === undefined) implementations = this._implementationsMap[iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    implementations.interfaces.push(namedType);
                }
            }
            else if ((0, $lXoEQ.isObjectType)(namedType)) // Store implementations by objects.
            for(var _i12 = 0, _namedType$getInterfa4 = namedType.getInterfaces(); _i12 < _namedType$getInterfa4.length; _i12++){
                var _iface = _namedType$getInterfa4[_i12];
                if ((0, $lXoEQ.isInterfaceType)(_iface)) {
                    var _implementations = this._implementationsMap[_iface.name];
                    if (_implementations === undefined) _implementations = this._implementationsMap[_iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    _implementations.objects.push(namedType);
                }
            }
        }
    }
    var _proto = GraphQLSchema.prototype;
    _proto.getQueryType = function getQueryType() {
        return this._queryType;
    };
    _proto.getMutationType = function getMutationType() {
        return this._mutationType;
    };
    _proto.getSubscriptionType = function getSubscriptionType() {
        return this._subscriptionType;
    };
    _proto.getTypeMap = function getTypeMap() {
        return this._typeMap;
    };
    _proto.getType = function getType(name) {
        return this.getTypeMap()[name];
    };
    _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
        return (0, $lXoEQ.isUnionType)(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
    };
    _proto.getImplementations = function getImplementations(interfaceType) {
        var implementations = this._implementationsMap[interfaceType.name];
        return implementations !== null && implementations !== void 0 ? implementations : {
            objects: [],
            interfaces: []
        };
    } // @deprecated: use isSubType instead - will be removed in v16.
    ;
    _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
        return this.isSubType(abstractType, possibleType);
    };
    _proto.isSubType = function isSubType(abstractType, maybeSubType) {
        var map = this._subTypeMap[abstractType.name];
        if (map === undefined) {
            map = Object.create(null);
            if ((0, $lXoEQ.isUnionType)(abstractType)) for(var _i14 = 0, _abstractType$getType2 = abstractType.getTypes(); _i14 < _abstractType$getType2.length; _i14++){
                var type = _abstractType$getType2[_i14];
                map[type.name] = true;
            }
            else {
                var implementations = this.getImplementations(abstractType);
                for(var _i16 = 0, _implementations$obje2 = implementations.objects; _i16 < _implementations$obje2.length; _i16++){
                    var _type = _implementations$obje2[_i16];
                    map[_type.name] = true;
                }
                for(var _i18 = 0, _implementations$inte2 = implementations.interfaces; _i18 < _implementations$inte2.length; _i18++){
                    var _type2 = _implementations$inte2[_i18];
                    map[_type2.name] = true;
                }
            }
            this._subTypeMap[abstractType.name] = map;
        }
        return map[maybeSubType.name] !== undefined;
    };
    _proto.getDirectives = function getDirectives() {
        return this._directives;
    };
    _proto.getDirective = function getDirective(name) {
        return (0, $bmIpK.default)(this.getDirectives(), function(directive) {
            return directive.name === name;
        });
    };
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            description: this.description,
            query: this.getQueryType(),
            mutation: this.getMutationType(),
            subscription: this.getSubscriptionType(),
            types: (0, $dVq2R.default)(this.getTypeMap()),
            directives: this.getDirectives().slice(),
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : [],
            assumeValid: this.__validationErrors !== undefined
        };
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $1e230b99124f3642$var$_createClass(GraphQLSchema, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLSchema';
            }
        }
    ]);
    return GraphQLSchema;
}();
function $1e230b99124f3642$var$collectReferencedTypes(type, typeSet) {
    var namedType = (0, $lXoEQ.getNamedType)(type);
    if (!typeSet.has(namedType)) {
        typeSet.add(namedType);
        if ((0, $lXoEQ.isUnionType)(namedType)) for(var _i20 = 0, _namedType$getTypes2 = namedType.getTypes(); _i20 < _namedType$getTypes2.length; _i20++){
            var memberType = _namedType$getTypes2[_i20];
            $1e230b99124f3642$var$collectReferencedTypes(memberType, typeSet);
        }
        else if ((0, $lXoEQ.isObjectType)(namedType) || (0, $lXoEQ.isInterfaceType)(namedType)) {
            for(var _i22 = 0, _namedType$getInterfa6 = namedType.getInterfaces(); _i22 < _namedType$getInterfa6.length; _i22++){
                var interfaceType = _namedType$getInterfa6[_i22];
                $1e230b99124f3642$var$collectReferencedTypes(interfaceType, typeSet);
            }
            for(var _i24 = 0, _objectValues2 = (0, $dVq2R.default)(namedType.getFields()); _i24 < _objectValues2.length; _i24++){
                var field = _objectValues2[_i24];
                $1e230b99124f3642$var$collectReferencedTypes(field.type, typeSet);
                for(var _i26 = 0, _field$args2 = field.args; _i26 < _field$args2.length; _i26++){
                    var arg = _field$args2[_i26];
                    $1e230b99124f3642$var$collectReferencedTypes(arg.type, typeSet);
                }
            }
        } else if ((0, $lXoEQ.isInputObjectType)(namedType)) for(var _i28 = 0, _objectValues4 = (0, $dVq2R.default)(namedType.getFields()); _i28 < _objectValues4.length; _i28++){
            var _field = _objectValues4[_i28];
            $1e230b99124f3642$var$collectReferencedTypes(_field.type, typeSet);
        }
    }
    return typeSet;
}

});
parcelRegister("96Cqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff75e7d75b147b76$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var $ff75e7d75b147b76$var$arrayFrom = Array.from || function(obj, mapFn, thisArg) {
    if (obj == null) throw new TypeError('Array.from requires an array-like object - not null or undefined');
     // Is Iterable?
    var iteratorMethod = obj[0, $gwa3m.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        var iterator = iteratorMethod.call(obj);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i){
            result.push(mapFn.call(thisArg, step.value, i)); // Infinite Iterators could cause forEach to run forever.
            // After a very large number of iterations, produce an error.
            // istanbul ignore if (Too big to actually test)
            if (i > 9999999) throw new TypeError('Near-infinite iteration.');
        }
        return result;
    } // Is Array like?
    var length = obj.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i)if (Object.prototype.hasOwnProperty.call(obj, _i)) _result.push(mapFn.call(thisArg, obj[_i], _i));
        return _result;
    }
    return [];
};
var $ff75e7d75b147b76$export$2e2bcd8739ae039 = $ff75e7d75b147b76$var$arrayFrom;

});

parcelRegister("h2iUh", function(module, exports) {

$parcel$export(module.exports, "__Schema", () => $6ebe99021e9a5959$export$1f18df711f6fa0ac);
$parcel$export(module.exports, "TypeKind", () => $6ebe99021e9a5959$export$c29cf3c48471da7c);
$parcel$export(module.exports, "SchemaMetaFieldDef", () => $6ebe99021e9a5959$export$36ed059ad2080404);
$parcel$export(module.exports, "TypeMetaFieldDef", () => $6ebe99021e9a5959$export$87a968d084148b61);
$parcel$export(module.exports, "TypeNameMetaFieldDef", () => $6ebe99021e9a5959$export$b9c17490e825648e);
$parcel$export(module.exports, "introspectionTypes", () => $6ebe99021e9a5959$export$560bc6e8f6d098f4);
$parcel$export(module.exports, "isIntrospectionType", () => $6ebe99021e9a5959$export$e1862b156b15ce4f);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $aKlnM = parcelRequire("aKlnM");

var $5hGV7 = parcelRequire("5hGV7");

var $cMIyS = parcelRequire("cMIyS");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
var $6ebe99021e9a5959$export$1f18df711f6fa0ac = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Schema',
    description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
    fields: function fields() {
        return {
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(schema) {
                    return schema.description;
                }
            },
            types: {
                description: 'A list of all types supported by this server.',
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7))),
                resolve: function resolve(schema) {
                    return (0, $dVq2R.default)(schema.getTypeMap());
                }
            },
            queryType: {
                description: 'The type that query operations will be rooted at.',
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(schema) {
                    return schema.getQueryType();
                }
            },
            mutationType: {
                description: 'If this server supports mutation, the type that mutation operations will be rooted at.',
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(schema) {
                    return schema.getMutationType();
                }
            },
            subscriptionType: {
                description: 'If this server support subscription, the type that subscription operations will be rooted at.',
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(schema) {
                    return schema.getSubscriptionType();
                }
            },
            directives: {
                description: 'A list of all directives supported by this server.',
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$2492e8c5b8ba489f))),
                resolve: function resolve(schema) {
                    return schema.getDirectives();
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$2492e8c5b8ba489f = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Directive',
    description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(directive) {
                    return directive.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(directive) {
                    return directive.description;
                }
            },
            isRepeatable: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(directive) {
                    return directive.isRepeatable;
                }
            },
            locations: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$70e870c5930737d1))),
                resolve: function resolve(directive) {
                    return directive.locations;
                }
            },
            args: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref) {
                    var includeDeprecated = _ref.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$70e870c5930737d1 = new (0, $lXoEQ.GraphQLEnumType)({
    name: '__DirectiveLocation',
    description: 'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
    values: {
        QUERY: {
            value: (0, $5hGV7.DirectiveLocation).QUERY,
            description: 'Location adjacent to a query operation.'
        },
        MUTATION: {
            value: (0, $5hGV7.DirectiveLocation).MUTATION,
            description: 'Location adjacent to a mutation operation.'
        },
        SUBSCRIPTION: {
            value: (0, $5hGV7.DirectiveLocation).SUBSCRIPTION,
            description: 'Location adjacent to a subscription operation.'
        },
        FIELD: {
            value: (0, $5hGV7.DirectiveLocation).FIELD,
            description: 'Location adjacent to a field.'
        },
        FRAGMENT_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).FRAGMENT_DEFINITION,
            description: 'Location adjacent to a fragment definition.'
        },
        FRAGMENT_SPREAD: {
            value: (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
            description: 'Location adjacent to a fragment spread.'
        },
        INLINE_FRAGMENT: {
            value: (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT,
            description: 'Location adjacent to an inline fragment.'
        },
        VARIABLE_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).VARIABLE_DEFINITION,
            description: 'Location adjacent to a variable definition.'
        },
        SCHEMA: {
            value: (0, $5hGV7.DirectiveLocation).SCHEMA,
            description: 'Location adjacent to a schema definition.'
        },
        SCALAR: {
            value: (0, $5hGV7.DirectiveLocation).SCALAR,
            description: 'Location adjacent to a scalar definition.'
        },
        OBJECT: {
            value: (0, $5hGV7.DirectiveLocation).OBJECT,
            description: 'Location adjacent to an object type definition.'
        },
        FIELD_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION,
            description: 'Location adjacent to a field definition.'
        },
        ARGUMENT_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION,
            description: 'Location adjacent to an argument definition.'
        },
        INTERFACE: {
            value: (0, $5hGV7.DirectiveLocation).INTERFACE,
            description: 'Location adjacent to an interface definition.'
        },
        UNION: {
            value: (0, $5hGV7.DirectiveLocation).UNION,
            description: 'Location adjacent to a union definition.'
        },
        ENUM: {
            value: (0, $5hGV7.DirectiveLocation).ENUM,
            description: 'Location adjacent to an enum definition.'
        },
        ENUM_VALUE: {
            value: (0, $5hGV7.DirectiveLocation).ENUM_VALUE,
            description: 'Location adjacent to an enum value definition.'
        },
        INPUT_OBJECT: {
            value: (0, $5hGV7.DirectiveLocation).INPUT_OBJECT,
            description: 'Location adjacent to an input object type definition.'
        },
        INPUT_FIELD_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION,
            description: 'Location adjacent to an input object field definition.'
        }
    }
});
var $6ebe99021e9a5959$export$b46ca740abcddda7 = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Type',
    description: 'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
    fields: function fields() {
        return {
            kind: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$163610506c99e78f),
                resolve: function resolve(type) {
                    if ((0, $lXoEQ.isScalarType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.SCALAR;
                    if ((0, $lXoEQ.isObjectType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.OBJECT;
                    if ((0, $lXoEQ.isInterfaceType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.INTERFACE;
                    if ((0, $lXoEQ.isUnionType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.UNION;
                    if ((0, $lXoEQ.isEnumType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.ENUM;
                    if ((0, $lXoEQ.isInputObjectType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.INPUT_OBJECT;
                    if ((0, $lXoEQ.isListType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.LIST;
                     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
                    if ((0, $lXoEQ.isNonNullType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.NON_NULL;
                     // istanbul ignore next (Not reachable. All possible types have been considered)
                    (0, $43MJl.default)(0, "Unexpected type: \"".concat((0, $biK02.default)(type), "\"."));
                }
            },
            name: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(type) {
                    return type.name !== undefined ? type.name : undefined;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(type) {
                    return type.description !== undefined ? type.description : undefined;
                }
            },
            specifiedByUrl: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.specifiedByUrl !== undefined ? obj.specifiedByUrl : undefined;
                }
            },
            fields: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$c93780024e419b02)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref2) {
                    var includeDeprecated = _ref2.includeDeprecated;
                    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) {
                        var fields = (0, $dVq2R.default)(type.getFields());
                        return includeDeprecated ? fields : fields.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            interfaces: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7)),
                resolve: function resolve(type) {
                    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) return type.getInterfaces();
                }
            },
            possibleTypes: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7)),
                resolve: function resolve(type, _args, _context, _ref3) {
                    var schema = _ref3.schema;
                    if ((0, $lXoEQ.isAbstractType)(type)) return schema.getPossibleTypes(type);
                }
            },
            enumValues: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b93e3441ec96b29a)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref4) {
                    var includeDeprecated = _ref4.includeDeprecated;
                    if ((0, $lXoEQ.isEnumType)(type)) {
                        var values = type.getValues();
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            inputFields: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref5) {
                    var includeDeprecated = _ref5.includeDeprecated;
                    if ((0, $lXoEQ.isInputObjectType)(type)) {
                        var values = (0, $dVq2R.default)(type.getFields());
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            ofType: {
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(type) {
                    return type.ofType !== undefined ? type.ofType : undefined;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$c93780024e419b02 = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Field',
    description: 'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(field) {
                    return field.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(field) {
                    return field.description;
                }
            },
            args: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref6) {
                    var includeDeprecated = _ref6.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            },
            type: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(field) {
                    return field.type;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(field) {
                    return field.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$bc79df5a9719c05b = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__InputValue',
    description: 'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(inputValue) {
                    return inputValue.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(inputValue) {
                    return inputValue.description;
                }
            },
            type: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(inputValue) {
                    return inputValue.type;
                }
            },
            defaultValue: {
                type: (0, $auu22.GraphQLString),
                description: 'A GraphQL-formatted string representing the default value for this input value.',
                resolve: function resolve(inputValue) {
                    var type = inputValue.type, defaultValue = inputValue.defaultValue;
                    var valueAST = (0, $cMIyS.astFromValue)(defaultValue, type);
                    return valueAST ? (0, $aKlnM.print)(valueAST) : null;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$b93e3441ec96b29a = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__EnumValue',
    description: 'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(enumValue) {
                    return enumValue.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.description;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$c29cf3c48471da7c = Object.freeze({
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    INPUT_OBJECT: 'INPUT_OBJECT',
    LIST: 'LIST',
    NON_NULL: 'NON_NULL'
});
var $6ebe99021e9a5959$export$163610506c99e78f = new (0, $lXoEQ.GraphQLEnumType)({
    name: '__TypeKind',
    description: 'An enum describing what kind of type a given `__Type` is.',
    values: {
        SCALAR: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.SCALAR,
            description: 'Indicates this type is a scalar.'
        },
        OBJECT: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.OBJECT,
            description: 'Indicates this type is an object. `fields` and `interfaces` are valid fields.'
        },
        INTERFACE: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.INTERFACE,
            description: 'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.'
        },
        UNION: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.UNION,
            description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
        },
        ENUM: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.ENUM,
            description: 'Indicates this type is an enum. `enumValues` is a valid field.'
        },
        INPUT_OBJECT: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.INPUT_OBJECT,
            description: 'Indicates this type is an input object. `inputFields` is a valid field.'
        },
        LIST: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.LIST,
            description: 'Indicates this type is a list. `ofType` is a valid field.'
        },
        NON_NULL: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.NON_NULL,
            description: 'Indicates this type is a non-null. `ofType` is a valid field.'
        }
    }
});
var $6ebe99021e9a5959$export$36ed059ad2080404 = {
    name: '__schema',
    type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$1f18df711f6fa0ac),
    description: 'Access the current type schema of this server.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref7) {
        var schema = _ref7.schema;
        return schema;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$87a968d084148b61 = {
    name: '__type',
    type: $6ebe99021e9a5959$export$b46ca740abcddda7,
    description: 'Request the type information of a single type.',
    args: [
        {
            name: 'name',
            description: undefined,
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
            defaultValue: undefined,
            deprecationReason: undefined,
            extensions: undefined,
            astNode: undefined
        }
    ],
    resolve: function resolve(_source, _ref8, _context, _ref9) {
        var name = _ref8.name;
        var schema = _ref9.schema;
        return schema.getType(name);
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$b9c17490e825648e = {
    name: '__typename',
    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
    description: 'The name of the current Object type at runtime.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref10) {
        var parentType = _ref10.parentType;
        return parentType.name;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$560bc6e8f6d098f4 = Object.freeze([
    $6ebe99021e9a5959$export$1f18df711f6fa0ac,
    $6ebe99021e9a5959$export$2492e8c5b8ba489f,
    $6ebe99021e9a5959$export$70e870c5930737d1,
    $6ebe99021e9a5959$export$b46ca740abcddda7,
    $6ebe99021e9a5959$export$c93780024e419b02,
    $6ebe99021e9a5959$export$bc79df5a9719c05b,
    $6ebe99021e9a5959$export$b93e3441ec96b29a,
    $6ebe99021e9a5959$export$163610506c99e78f
]);
function $6ebe99021e9a5959$export$e1862b156b15ce4f(type) {
    return $6ebe99021e9a5959$export$560bc6e8f6d098f4.some(function(_ref11) {
        var name = _ref11.name;
        return type.name === name;
    });
}

});
parcelRegister("5hGV7", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $d7161a38006ba9b3$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $d7161a38006ba9b3$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("cMIyS", function(module, exports) {

$parcel$export(module.exports, "astFromValue", () => $8815f467872381b8$export$973c016b19737b40);

var $2ajMd = parcelRequire("2ajMd");

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $1c4hI = parcelRequire("1c4hI");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
function $8815f467872381b8$export$973c016b19737b40(value, type) {
    if ((0, $lXoEQ.isNonNullType)(type)) {
        var astValue = $8815f467872381b8$export$973c016b19737b40(value, type.ofType);
        if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === (0, $1c4hI.Kind).NULL) return null;
        return astValue;
    } // only explicit null, not undefined, NaN
    if (value === null) return {
        kind: (0, $1c4hI.Kind).NULL
    };
     // undefined
    if (value === undefined) return null;
     // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
    // the value is not an array, convert the value using the list's item type.
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        var items = (0, $8DMvn.default)(value);
        if (items != null) {
            var valuesNodes = [];
            for(var _i2 = 0; _i2 < items.length; _i2++){
                var item = items[_i2];
                var itemNode = $8815f467872381b8$export$973c016b19737b40(item, itemType);
                if (itemNode != null) valuesNodes.push(itemNode);
            }
            return {
                kind: (0, $1c4hI.Kind).LIST,
                values: valuesNodes
            };
        }
        return $8815f467872381b8$export$973c016b19737b40(value, itemType);
    } // Populate the fields of the input object by creating ASTs from each value
    // in the JavaScript object according to the fields in the input type.
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (!(0, $fbtyx.default)(value)) return null;
        var fieldNodes = [];
        for(var _i4 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldValue = $8815f467872381b8$export$973c016b19737b40(value[field.name], field.type);
            if (fieldValue) fieldNodes.push({
                kind: (0, $1c4hI.Kind).OBJECT_FIELD,
                name: {
                    kind: (0, $1c4hI.Kind).NAME,
                    value: field.name
                },
                value: fieldValue
            });
        }
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: fieldNodes
        };
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        // Since value is an internally represented value, it must be serialized
        // to an externally represented value before converting into an AST.
        var serialized = type.serialize(value);
        if (serialized == null) return null;
         // Others serialize based on their corresponding JavaScript scalar types.
        if (typeof serialized === 'boolean') return {
            kind: (0, $1c4hI.Kind).BOOLEAN,
            value: serialized
        };
         // JavaScript numbers can be Int or Float values.
        if (typeof serialized === 'number' && (0, $2ajMd.default)(serialized)) {
            var stringNum = String(serialized);
            return $8815f467872381b8$var$integerStringRegExp.test(stringNum) ? {
                kind: (0, $1c4hI.Kind).INT,
                value: stringNum
            } : {
                kind: (0, $1c4hI.Kind).FLOAT,
                value: stringNum
            };
        }
        if (typeof serialized === 'string') {
            // Enum types use Enum literals.
            if ((0, $lXoEQ.isEnumType)(type)) return {
                kind: (0, $1c4hI.Kind).ENUM,
                value: serialized
            };
             // ID types can use Int literals.
            if (type === (0, $auu22.GraphQLID) && $8815f467872381b8$var$integerStringRegExp.test(serialized)) return {
                kind: (0, $1c4hI.Kind).INT,
                value: serialized
            };
            return {
                kind: (0, $1c4hI.Kind).STRING,
                value: serialized
            };
        }
        throw new TypeError("Cannot convert value to AST: ".concat((0, $biK02.default)(serialized), "."));
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */ var $8815f467872381b8$var$integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

});
parcelRegister("2ajMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3464f8e85982de$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $ec3464f8e85982de$var$isFinitePolyfill = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};
var $ec3464f8e85982de$export$2e2bcd8739ae039 = $ec3464f8e85982de$var$isFinitePolyfill;

});

parcelRegister("auu22", function(module, exports) {

$parcel$export(module.exports, "GraphQLInt", () => $b7a726a9eae6fb8d$export$4d4383325330928b);
$parcel$export(module.exports, "GraphQLFloat", () => $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d);
$parcel$export(module.exports, "GraphQLString", () => $b7a726a9eae6fb8d$export$bf00325280f7630c);
$parcel$export(module.exports, "GraphQLBoolean", () => $b7a726a9eae6fb8d$export$bcd144a2158fe517);
$parcel$export(module.exports, "GraphQLID", () => $b7a726a9eae6fb8d$export$530df982af95a879);
$parcel$export(module.exports, "specifiedScalarTypes", () => $b7a726a9eae6fb8d$export$5df80378609411b9);
$parcel$export(module.exports, "isSpecifiedScalarType", () => $b7a726a9eae6fb8d$export$5d6bb1cb0ae296ca);

var $2ajMd = parcelRequire("2ajMd");

var $nUGRp = parcelRequire("nUGRp");

var $biK02 = parcelRequire("biK02");

var $fbtyx = parcelRequire("fbtyx");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
// 32-bit signed integer, providing the broadest support across platforms.
//
// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
// they are internally represented as IEEE 754 doubles.
var $b7a726a9eae6fb8d$var$MAX_INT = 2147483647;
var $b7a726a9eae6fb8d$var$MIN_INT = -2147483648;
function $b7a726a9eae6fb8d$var$serializeInt(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, $nUGRp.default)(num)) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $biK02.default)(coercedValue)));
    if (num > $b7a726a9eae6fb8d$var$MAX_INT || num < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)('Int cannot represent non 32-bit signed integer value: ' + (0, $biK02.default)(coercedValue));
    return num;
}
function $b7a726a9eae6fb8d$var$coerceInt(inputValue) {
    if (!(0, $nUGRp.default)(inputValue)) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $biK02.default)(inputValue)));
    if (inputValue > $b7a726a9eae6fb8d$var$MAX_INT || inputValue < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(inputValue));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$4d4383325330928b = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Int',
    description: 'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',
    serialize: $b7a726a9eae6fb8d$var$serializeInt,
    parseValue: $b7a726a9eae6fb8d$var$coerceInt,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        var num = parseInt(valueNode.value, 10);
        if (num > $b7a726a9eae6fb8d$var$MAX_INT || num < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(valueNode.value), valueNode);
        return num;
    }
});
function $b7a726a9eae6fb8d$var$serializeFloat(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, $2ajMd.default)(num)) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $biK02.default)(coercedValue)));
    return num;
}
function $b7a726a9eae6fb8d$var$coerceFloat(inputValue) {
    if (!(0, $2ajMd.default)(inputValue)) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Float',
    description: 'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',
    serialize: $b7a726a9eae6fb8d$var$serializeFloat,
    parseValue: $b7a726a9eae6fb8d$var$coerceFloat,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).FLOAT && valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return parseFloat(valueNode.value);
    }
}); // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).
function $b7a726a9eae6fb8d$var$serializeObject(outputValue) {
    if ((0, $fbtyx.default)(outputValue)) {
        if (typeof outputValue.valueOf === 'function') {
            var valueOfResult = outputValue.valueOf();
            if (!(0, $fbtyx.default)(valueOfResult)) return valueOfResult;
        }
        if (typeof outputValue.toJSON === 'function') // $FlowFixMe[incompatible-use]
        return outputValue.toJSON();
    }
    return outputValue;
}
function $b7a726a9eae6fb8d$var$serializeString(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
    // attempt to coerce object, function, symbol, or other types as strings.
    if (typeof coercedValue === 'string') return coercedValue;
    if (typeof coercedValue === 'boolean') return coercedValue ? 'true' : 'false';
    if ((0, $2ajMd.default)(coercedValue)) return coercedValue.toString();
    throw new (0, $9fgMZ.GraphQLError)("String cannot represent value: ".concat((0, $biK02.default)(outputValue)));
}
function $b7a726a9eae6fb8d$var$coerceString(inputValue) {
    if (typeof inputValue !== 'string') throw new (0, $9fgMZ.GraphQLError)("String cannot represent a non string value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$bf00325280f7630c = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'String',
    description: 'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',
    serialize: $b7a726a9eae6fb8d$var$serializeString,
    parseValue: $b7a726a9eae6fb8d$var$coerceString,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).STRING) throw new (0, $9fgMZ.GraphQLError)("String cannot represent a non string value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function $b7a726a9eae6fb8d$var$serializeBoolean(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue;
    if ((0, $2ajMd.default)(coercedValue)) return coercedValue !== 0;
    throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $biK02.default)(coercedValue)));
}
function $b7a726a9eae6fb8d$var$coerceBoolean(inputValue) {
    if (typeof inputValue !== 'boolean') throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$bcd144a2158fe517 = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Boolean',
    description: 'The `Boolean` scalar type represents `true` or `false`.',
    serialize: $b7a726a9eae6fb8d$var$serializeBoolean,
    parseValue: $b7a726a9eae6fb8d$var$coerceBoolean,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).BOOLEAN) throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function $b7a726a9eae6fb8d$var$serializeID(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'string') return coercedValue;
    if ((0, $nUGRp.default)(coercedValue)) return String(coercedValue);
    throw new (0, $9fgMZ.GraphQLError)("ID cannot represent value: ".concat((0, $biK02.default)(outputValue)));
}
function $b7a726a9eae6fb8d$var$coerceID(inputValue) {
    if (typeof inputValue === 'string') return inputValue;
    if ((0, $nUGRp.default)(inputValue)) return inputValue.toString();
    throw new (0, $9fgMZ.GraphQLError)("ID cannot represent value: ".concat((0, $biK02.default)(inputValue)));
}
var $b7a726a9eae6fb8d$export$530df982af95a879 = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'ID',
    description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
    serialize: $b7a726a9eae6fb8d$var$serializeID,
    parseValue: $b7a726a9eae6fb8d$var$coerceID,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).STRING && valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)('ID cannot represent a non-string and non-integer value: ' + (0, $aKlnM.print)(valueNode), valueNode);
        return valueNode.value;
    }
});
var $b7a726a9eae6fb8d$export$5df80378609411b9 = Object.freeze([
    $b7a726a9eae6fb8d$export$bf00325280f7630c,
    $b7a726a9eae6fb8d$export$4d4383325330928b,
    $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d,
    $b7a726a9eae6fb8d$export$bcd144a2158fe517,
    $b7a726a9eae6fb8d$export$530df982af95a879
]);
function $b7a726a9eae6fb8d$export$5d6bb1cb0ae296ca(type) {
    return $b7a726a9eae6fb8d$export$5df80378609411b9.some(function(_ref) {
        var name = _ref.name;
        return type.name === name;
    });
}

});
parcelRegister("nUGRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c759a73a7c0b3364$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $c759a73a7c0b3364$var$isInteger = Number.isInteger || function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
var $c759a73a7c0b3364$export$2e2bcd8739ae039 = $c759a73a7c0b3364$var$isInteger;

});




parcelRegister("bOniD", function(module, exports) {

$parcel$export(module.exports, "isDirective", () => $68b3a31c3f813eb2$export$4b5d79f26e0e3ad5);
$parcel$export(module.exports, "GraphQLDirective", () => $68b3a31c3f813eb2$export$90407e48aac654e9);
$parcel$export(module.exports, "GraphQLIncludeDirective", () => $68b3a31c3f813eb2$export$f92fb5dbf075dbee);
$parcel$export(module.exports, "GraphQLSkipDirective", () => $68b3a31c3f813eb2$export$7adbe9be7084cfe3);
$parcel$export(module.exports, "DEFAULT_DEPRECATION_REASON", () => $68b3a31c3f813eb2$export$15edbda76f1f9a89);
$parcel$export(module.exports, "GraphQLDeprecatedDirective", () => $68b3a31c3f813eb2$export$ed64f8040ac801d1);
$parcel$export(module.exports, "GraphQLSpecifiedByDirective", () => $68b3a31c3f813eb2$export$26ce3cf10bb75d41);
$parcel$export(module.exports, "specifiedDirectives", () => $68b3a31c3f813eb2$export$c48d2e3f4e034403);
$parcel$export(module.exports, "isSpecifiedDirective", () => $68b3a31c3f813eb2$export$7d2e48434602f4fe);

var $apet0 = parcelRequire("apet0");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");

var $fbtyx = parcelRequire("fbtyx");

var $51GHS = parcelRequire("51GHS");

var $5hGV7 = parcelRequire("5hGV7");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
function $68b3a31c3f813eb2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $68b3a31c3f813eb2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $68b3a31c3f813eb2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $68b3a31c3f813eb2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $68b3a31c3f813eb2$export$4b5d79f26e0e3ad5(directive) {
    return (0, $aVhwC.default)(directive, $68b3a31c3f813eb2$export$90407e48aac654e9);
}
function $68b3a31c3f813eb2$export$976bef3b79eaee5d(directive) {
    if (!$68b3a31c3f813eb2$export$4b5d79f26e0e3ad5(directive)) throw new Error("Expected ".concat((0, $biK02.default)(directive), " to be a GraphQL directive."));
    return directive;
}
var $68b3a31c3f813eb2$export$90407e48aac654e9 = /*#__PURE__*/ function() {
    function GraphQLDirective(config) {
        var _config$isRepeatable, _config$args;
        this.name = config.name;
        this.description = config.description;
        this.locations = config.locations;
        this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        config.name || (0, $fZdRY.default)(0, 'Directive must be named.');
        Array.isArray(config.locations) || (0, $fZdRY.default)(0, "@".concat(config.name, " locations must be an Array."));
        var args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
        (0, $fbtyx.default)(args) && !Array.isArray(args) || (0, $fZdRY.default)(0, "@".concat(config.name, " args must be an object with argument names as keys."));
        this.args = (0, $apet0.default)(args).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, $eCJ4z.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
    }
    var _proto = GraphQLDirective.prototype;
    _proto.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            locations: this.locations,
            args: (0, $lXoEQ.argsToArgsConfig)(this.args),
            isRepeatable: this.isRepeatable,
            extensions: this.extensions,
            astNode: this.astNode
        };
    };
    _proto.toString = function toString() {
        return '@' + this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $68b3a31c3f813eb2$var$_createClass(GraphQLDirective, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLDirective';
            }
        }
    ]);
    return GraphQLDirective;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($68b3a31c3f813eb2$export$90407e48aac654e9);
var $68b3a31c3f813eb2$export$f92fb5dbf075dbee = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'include',
    description: 'Directs the executor to include this field or fragment only when the `if` argument is true.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD,
        (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
            description: 'Included when true.'
        }
    }
});
var $68b3a31c3f813eb2$export$7adbe9be7084cfe3 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'skip',
    description: 'Directs the executor to skip this field or fragment when the `if` argument is true.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD,
        (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
            description: 'Skipped when true.'
        }
    }
});
var $68b3a31c3f813eb2$export$15edbda76f1f9a89 = 'No longer supported';
var $68b3a31c3f813eb2$export$ed64f8040ac801d1 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'deprecated',
    description: 'Marks an element of a GraphQL schema as no longer supported.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION,
        (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION,
        (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION,
        (0, $5hGV7.DirectiveLocation).ENUM_VALUE
    ],
    args: {
        reason: {
            type: (0, $auu22.GraphQLString),
            description: 'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
            defaultValue: $68b3a31c3f813eb2$export$15edbda76f1f9a89
        }
    }
});
var $68b3a31c3f813eb2$export$26ce3cf10bb75d41 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'specifiedBy',
    description: 'Exposes a URL that specifies the behaviour of this scalar.',
    locations: [
        (0, $5hGV7.DirectiveLocation).SCALAR
    ],
    args: {
        url: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
            description: 'The URL that specifies the behaviour of this scalar.'
        }
    }
});
var $68b3a31c3f813eb2$export$c48d2e3f4e034403 = Object.freeze([
    $68b3a31c3f813eb2$export$f92fb5dbf075dbee,
    $68b3a31c3f813eb2$export$7adbe9be7084cfe3,
    $68b3a31c3f813eb2$export$ed64f8040ac801d1,
    $68b3a31c3f813eb2$export$26ce3cf10bb75d41
]);
function $68b3a31c3f813eb2$export$7d2e48434602f4fe(directive) {
    return $68b3a31c3f813eb2$export$c48d2e3f4e034403.some(function(_ref2) {
        var name = _ref2.name;
        return name === directive.name;
    });
}

});



parcelRegister("3zSAT", function(module, exports) {

$parcel$export(module.exports, "typeFromAST", () => $a77d3e2f56140695$export$292685f75a322892);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");
function $a77d3e2f56140695$export$292685f75a322892(schema, typeNode) {
    /* eslint-enable no-redeclare */ var innerType;
    if (typeNode.kind === (0, $1c4hI.Kind).LIST_TYPE) {
        innerType = $a77d3e2f56140695$export$292685f75a322892(schema, typeNode.type);
        return innerType && new (0, $lXoEQ.GraphQLList)(innerType);
    }
    if (typeNode.kind === (0, $1c4hI.Kind).NON_NULL_TYPE) {
        innerType = $a77d3e2f56140695$export$292685f75a322892(schema, typeNode.type);
        return innerType && new (0, $lXoEQ.GraphQLNonNull)(innerType);
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if (typeNode.kind === (0, $1c4hI.Kind).NAMED_TYPE) return schema.getType(typeNode.name.value);
     // istanbul ignore next (Not reachable. All possible type nodes have been considered)
    (0, $43MJl.default)(0, 'Unexpected type node: ' + (0, $biK02.default)(typeNode));
}

});

parcelRegister("bis9F", function(module, exports) {

$parcel$export(module.exports, "getOperationRootType", () => $508b1182b247a60e$export$f5bcbf8a32f314e5);

var $9fgMZ = parcelRequire("9fgMZ");
function $508b1182b247a60e$export$f5bcbf8a32f314e5(schema, operation) {
    if (operation.operation === 'query') {
        var queryType = schema.getQueryType();
        if (!queryType) throw new (0, $9fgMZ.GraphQLError)('Schema does not define the required query root type.', operation);
        return queryType;
    }
    if (operation.operation === 'mutation') {
        var mutationType = schema.getMutationType();
        if (!mutationType) throw new (0, $9fgMZ.GraphQLError)('Schema is not configured for mutations.', operation);
        return mutationType;
    }
    if (operation.operation === 'subscription') {
        var subscriptionType = schema.getSubscriptionType();
        if (!subscriptionType) throw new (0, $9fgMZ.GraphQLError)('Schema is not configured for subscriptions.', operation);
        return subscriptionType;
    }
    throw new (0, $9fgMZ.GraphQLError)('Can only have query, mutation and subscription operations.', operation);
}

});

parcelRegister("gqGQB", function(module, exports) {

$parcel$export(module.exports, "getVariableValues", () => $b695b1e556e9787e$export$2038fbf5c9bccf57);
$parcel$export(module.exports, "getArgumentValues", () => $b695b1e556e9787e$export$5af04a8495f7ef54);
$parcel$export(module.exports, "getDirectiveValues", () => $b695b1e556e9787e$export$1f7174681493b2aa);

var $bmIpK = parcelRequire("bmIpK");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $laAus = parcelRequire("laAus");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $3E0nn = parcelRequire("3E0nn");

var $dEek8 = parcelRequire("dEek8");
function $b695b1e556e9787e$export$2038fbf5c9bccf57(schema, varDefNodes, inputs, options) {
    var errors = [];
    var maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;
    try {
        var coerced = $b695b1e556e9787e$var$coerceVariableValues(schema, varDefNodes, inputs, function(error) {
            if (maxErrors != null && errors.length >= maxErrors) throw new (0, $9fgMZ.GraphQLError)('Too many errors processing variables, error limit reached. Execution aborted.');
            errors.push(error);
        });
        if (errors.length === 0) return {
            coerced: coerced
        };
    } catch (error) {
        errors.push(error);
    }
    return {
        errors: errors
    };
}
function $b695b1e556e9787e$var$coerceVariableValues(schema, varDefNodes, inputs, onError) {
    var coercedValues = {};
    var _loop = function _loop(_i2) {
        var varDefNode = varDefNodes[_i2];
        var varName = varDefNode.variable.name.value;
        var varType = (0, $3zSAT.typeFromAST)(schema, varDefNode.type);
        if (!(0, $lXoEQ.isInputType)(varType)) {
            // Must use input types for variables. This should be caught during
            // validation, however is checked again here for safety.
            var varTypeStr = (0, $aKlnM.print)(varDefNode.type);
            onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" expected value of type \"").concat(varTypeStr, "\" which cannot be used as an input type."), varDefNode.type));
            return "continue";
        }
        if (!$b695b1e556e9787e$var$hasOwnProperty(inputs, varName)) {
            if (varDefNode.defaultValue) coercedValues[varName] = (0, $3E0nn.valueFromAST)(varDefNode.defaultValue, varType);
            else if ((0, $lXoEQ.isNonNullType)(varType)) {
                var _varTypeStr = (0, $biK02.default)(varType);
                onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of required type \"").concat(_varTypeStr, "\" was not provided."), varDefNode));
            }
            return "continue";
        }
        var value = inputs[varName];
        if (value === null && (0, $lXoEQ.isNonNullType)(varType)) {
            var _varTypeStr2 = (0, $biK02.default)(varType);
            onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of non-null type \"").concat(_varTypeStr2, "\" must not be null."), varDefNode));
            return "continue";
        }
        coercedValues[varName] = (0, $dEek8.coerceInputValue)(value, varType, function(path, invalidValue, error) {
            var prefix = "Variable \"$".concat(varName, "\" got invalid value ") + (0, $biK02.default)(invalidValue);
            if (path.length > 0) prefix += " at \"".concat(varName).concat((0, $laAus.default)(path), "\"");
            onError(new (0, $9fgMZ.GraphQLError)(prefix + '; ' + error.message, varDefNode, undefined, undefined, undefined, error.originalError));
        });
    };
    for(var _i2 = 0; _i2 < varDefNodes.length; _i2++){
        var _ret = _loop(_i2);
        if (_ret === "continue") continue;
    }
    return coercedValues;
}
function $b695b1e556e9787e$export$5af04a8495f7ef54(def, node, variableValues) {
    var _node$arguments;
    var coercedValues = {}; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var argumentNodes = (_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [];
    var argNodeMap = (0, $hbiEd.default)(argumentNodes, function(arg) {
        return arg.name.value;
    });
    for(var _i4 = 0, _def$args2 = def.args; _i4 < _def$args2.length; _i4++){
        var argDef = _def$args2[_i4];
        var name = argDef.name;
        var argType = argDef.type;
        var argumentNode = argNodeMap[name];
        if (!argumentNode) {
            if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
            else if ((0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, $biK02.default)(argType), "\" ") + 'was not provided.', node);
            continue;
        }
        var valueNode = argumentNode.value;
        var isNull = valueNode.kind === (0, $1c4hI.Kind).NULL;
        if (valueNode.kind === (0, $1c4hI.Kind).VARIABLE) {
            var variableName = valueNode.name.value;
            if (variableValues == null || !$b695b1e556e9787e$var$hasOwnProperty(variableValues, variableName)) {
                if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, $biK02.default)(argType), "\" ") + "was provided the variable \"$".concat(variableName, "\" which was not provided a runtime value."), valueNode);
                continue;
            }
            isNull = variableValues[variableName] == null;
        }
        if (isNull && (0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of non-null type \"").concat((0, $biK02.default)(argType), "\" ") + 'must not be null.', valueNode);
        var coercedValue = (0, $3E0nn.valueFromAST)(valueNode, argType, variableValues);
        if (coercedValue === undefined) // Note: ValuesOfCorrectTypeRule validation should catch this before
        // execution. This is a runtime check to ensure execution does not
        // continue with an invalid argument value.
        throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" has invalid value ").concat((0, $aKlnM.print)(valueNode), "."), valueNode);
        coercedValues[name] = coercedValue;
    }
    return coercedValues;
}
function $b695b1e556e9787e$export$1f7174681493b2aa(directiveDef, node, variableValues) {
    var directiveNode = node.directives && (0, $bmIpK.default)(node.directives, function(directive) {
        return directive.name.value === directiveDef.name;
    });
    if (directiveNode) return $b695b1e556e9787e$export$5af04a8495f7ef54(directiveDef, directiveNode, variableValues);
}
function $b695b1e556e9787e$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});
parcelRegister("laAus", function(module, exports) {

$parcel$export(module.exports, "default", () => $227415a0e63f15f5$export$2e2bcd8739ae039);
/**
 * Build a string describing the path.
 */ function $227415a0e63f15f5$export$2e2bcd8739ae039(path) {
    return path.map(function(key) {
        return typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key;
    }).join('');
}

});

parcelRegister("3E0nn", function(module, exports) {

$parcel$export(module.exports, "valueFromAST", () => $d700774db2a0232b$export$d32bfdfcfbe60e55);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");
function $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, type, variables) {
    if (!valueNode) // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
    if (valueNode.kind === (0, $1c4hI.Kind).VARIABLE) {
        var variableName = valueNode.name.value;
        if (variables == null || variables[variableName] === undefined) // No valid return value.
        return;
        var variableValue = variables[variableName];
        if (variableValue === null && (0, $lXoEQ.isNonNullType)(type)) return; // Invalid: intentionally return no value.
         // Note: This does no further checking that this variable is correct.
        // This assumes that this query has been validated and the variable
        // usage here is of the correct type.
        return variableValue;
    }
    if ((0, $lXoEQ.isNonNullType)(type)) {
        if (valueNode.kind === (0, $1c4hI.Kind).NULL) return; // Invalid: intentionally return no value.
        return $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, type.ofType, variables);
    }
    if (valueNode.kind === (0, $1c4hI.Kind).NULL) // This is explicitly returning the value null.
    return null;
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        if (valueNode.kind === (0, $1c4hI.Kind).LIST) {
            var coercedValues = [];
            for(var _i2 = 0, _valueNode$values2 = valueNode.values; _i2 < _valueNode$values2.length; _i2++){
                var itemNode = _valueNode$values2[_i2];
                if ($d700774db2a0232b$var$isMissingVariable(itemNode, variables)) {
                    // If an array contains a missing variable, it is either coerced to
                    // null or if the item type is non-null, it considered invalid.
                    if ((0, $lXoEQ.isNonNullType)(itemType)) return; // Invalid: intentionally return no value.
                    coercedValues.push(null);
                } else {
                    var itemValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(itemNode, itemType, variables);
                    if (itemValue === undefined) return; // Invalid: intentionally return no value.
                    coercedValues.push(itemValue);
                }
            }
            return coercedValues;
        }
        var coercedValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, itemType, variables);
        if (coercedValue === undefined) return; // Invalid: intentionally return no value.
        return [
            coercedValue
        ];
    }
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (valueNode.kind !== (0, $1c4hI.Kind).OBJECT) return; // Invalid: intentionally return no value.
        var coercedObj = Object.create(null);
        var fieldNodes = (0, $hbiEd.default)(valueNode.fields, function(field) {
            return field.name.value;
        });
        for(var _i4 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldNode = fieldNodes[field.name];
            if (!fieldNode || $d700774db2a0232b$var$isMissingVariable(fieldNode.value, variables)) {
                if (field.defaultValue !== undefined) coercedObj[field.name] = field.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(field.type)) return; // Invalid: intentionally return no value.
                continue;
            }
            var fieldValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(fieldNode.value, field.type, variables);
            if (fieldValue === undefined) return; // Invalid: intentionally return no value.
            coercedObj[field.name] = fieldValue;
        }
        return coercedObj;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        // Scalars and Enums fulfill parsing a literal value via parseLiteral().
        // Invalid values represent a failure to parse correctly, in which case
        // no value is returned.
        var result;
        try {
            result = type.parseLiteral(valueNode, variables);
        } catch (_error) {
            return; // Invalid: intentionally return no value.
        }
        if (result === undefined) return; // Invalid: intentionally return no value.
        return result;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.
function $d700774db2a0232b$var$isMissingVariable(valueNode, variables) {
    return valueNode.kind === (0, $1c4hI.Kind).VARIABLE && (variables == null || variables[valueNode.name.value] === undefined);
}

});

parcelRegister("dEek8", function(module, exports) {

$parcel$export(module.exports, "coerceInputValue", () => $6618e9631598014d$export$7964ec791f1fa3f1);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $8nBnZ = parcelRequire("8nBnZ");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $bru1k = parcelRequire("bru1k");

var $laAus = parcelRequire("laAus");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $6618e9631598014d$export$7964ec791f1fa3f1(inputValue, type) {
    var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $6618e9631598014d$var$defaultOnError;
    return $6618e9631598014d$var$coerceInputValueImpl(inputValue, type, onError);
}
function $6618e9631598014d$var$defaultOnError(path, invalidValue, error) {
    var errorPrefix = 'Invalid value ' + (0, $biK02.default)(invalidValue);
    if (path.length > 0) errorPrefix += " at \"value".concat((0, $laAus.default)(path), "\"");
    error.message = errorPrefix + ': ' + error.message;
    throw error;
}
function $6618e9631598014d$var$coerceInputValueImpl(inputValue, type, onError, path) {
    if ((0, $lXoEQ.isNonNullType)(type)) {
        if (inputValue != null) return $6618e9631598014d$var$coerceInputValueImpl(inputValue, type.ofType, onError, path);
        onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected non-nullable type \"".concat((0, $biK02.default)(type), "\" not to be null.")));
        return;
    }
    if (inputValue == null) // Explicitly return the value null.
    return null;
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        var coercedList = (0, $8DMvn.default)(inputValue, function(itemValue, index) {
            var itemPath = (0, $kZHaf.addPath)(path, index, undefined);
            return $6618e9631598014d$var$coerceInputValueImpl(itemValue, itemType, onError, itemPath);
        });
        if (coercedList != null) return coercedList;
         // Lists accept a non-list value as a list of one.
        return [
            $6618e9631598014d$var$coerceInputValueImpl(inputValue, itemType, onError, path)
        ];
    }
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (!(0, $fbtyx.default)(inputValue)) {
            onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\" to be an object.")));
            return;
        }
        var coercedValue = {};
        var fieldDefs = type.getFields();
        for(var _i2 = 0, _objectValues2 = (0, $dVq2R.default)(fieldDefs); _i2 < _objectValues2.length; _i2++){
            var field = _objectValues2[_i2];
            var fieldValue = inputValue[field.name];
            if (fieldValue === undefined) {
                if (field.defaultValue !== undefined) coercedValue[field.name] = field.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(field.type)) {
                    var typeStr = (0, $biK02.default)(field.type);
                    onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Field \"".concat(field.name, "\" of required type \"").concat(typeStr, "\" was not provided.")));
                }
                continue;
            }
            coercedValue[field.name] = $6618e9631598014d$var$coerceInputValueImpl(fieldValue, field.type, onError, (0, $kZHaf.addPath)(path, field.name, type.name));
        } // Ensure every provided field is defined.
        for(var _i4 = 0, _Object$keys2 = Object.keys(inputValue); _i4 < _Object$keys2.length; _i4++){
            var fieldName = _Object$keys2[_i4];
            if (!fieldDefs[fieldName]) {
                var suggestions = (0, $bru1k.default)(fieldName, Object.keys(type.getFields()));
                onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldName, "\" is not defined by type \"").concat(type.name, "\".") + (0, $8nBnZ.default)(suggestions)));
            }
        }
        return coercedValue;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        var parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
        // which can throw to indicate failure. If it throws, maintain a reference
        // to the original error.
        try {
            parseResult = type.parseValue(inputValue);
        } catch (error) {
            if (error instanceof (0, $9fgMZ.GraphQLError)) onError((0, $kZHaf.pathToArray)(path), inputValue, error);
            else onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\". ") + error.message, undefined, undefined, undefined, undefined, error));
            return;
        }
        if (parseResult === undefined) onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\".")));
        return parseResult;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
}

});




parcelRegister("aAMCg", function(module, exports) {
function $7b62fa5a6bcf3d57$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7b62fa5a6bcf3d57$var$__export((parcelRequire("crrCr")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("hbdmQ")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("akAyp")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("16dWW")));

var $gVW6u = parcelRequire("gVW6u");
module.exports.SchemaDirectiveVisitor = $gVW6u.SchemaDirectiveVisitor;

});
parcelRegister("crrCr", function(module, exports) {
function $90ed6e3aead06406$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");

var $gVW6u = parcelRequire("gVW6u");

var $b3EaX = parcelRequire("b3EaX");

function $90ed6e3aead06406$var$makeExecutableSchema(_a) {
    var typeDefs = _a.typeDefs, _b = _a.resolvers, resolvers = _b === void 0 ? {} : _b, connectors = _a.connectors, logger = _a.logger, _c = _a.allowUndefinedInResolve, allowUndefinedInResolve = _c === void 0 ? true : _c, _d = _a.resolverValidationOptions, resolverValidationOptions = _d === void 0 ? {} : _d, _e = _a.directiveResolvers, directiveResolvers = _e === void 0 ? null : _e, _f = _a.schemaDirectives, schemaDirectives = _f === void 0 ? null : _f, _g = _a.parseOptions, parseOptions = _g === void 0 ? {} : _g, _h = _a.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _h === void 0 ? false : _h;
    // Validate and clean up arguments
    if (typeof resolverValidationOptions !== 'object') throw new (parcelRequire("cYGSS")).SchemaError('Expected `resolverValidationOptions` to be an object');
    if (!typeDefs) throw new (parcelRequire("cYGSS")).SchemaError('Must provide typeDefs');
    if (!resolvers) throw new (parcelRequire("cYGSS")).SchemaError('Must provide resolvers');
    // We allow passing in an array of resolver maps, in which case we merge them
    var resolverMap = Array.isArray(resolvers) ? resolvers.filter(function(resolverObj) {
        return typeof resolverObj === 'object';
    }).reduce($b3EaX.default, {}) : resolvers;
    // Arguments are now validated and cleaned up
    var schema = (parcelRequire("cYGSS")).buildSchemaFromTypeDefinitions(typeDefs, parseOptions);
    schema = (parcelRequire("cYGSS")).addResolveFunctionsToSchema({
        schema: schema,
        resolvers: resolverMap,
        resolverValidationOptions: resolverValidationOptions,
        inheritResolversFromInterfaces: inheritResolversFromInterfaces
    });
    (parcelRequire("cYGSS")).assertResolveFunctionsPresent(schema, resolverValidationOptions);
    if (!allowUndefinedInResolve) $90ed6e3aead06406$var$addCatchUndefinedToSchema(schema);
    if (logger) $90ed6e3aead06406$var$addErrorLoggingToSchema(schema, logger);
    if (typeof resolvers['__schema'] === 'function') // TODO a bit of a hack now, better rewrite generateSchema to attach it there.
    // not doing that now, because I'd have to rewrite a lot of tests.
    (parcelRequire("cYGSS")).addSchemaLevelResolveFunction(schema, resolvers['__schema']);
    if (connectors) // connectors are optional, at least for now. That means you can just import them in the resolve
    // function if you want.
    (parcelRequire("cYGSS")).attachConnectorsToContext(schema, connectors);
    if (directiveResolvers) (parcelRequire("cYGSS")).attachDirectiveResolvers(schema, directiveResolvers);
    if (schemaDirectives) $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
    return schema;
}
module.exports.makeExecutableSchema = $90ed6e3aead06406$var$makeExecutableSchema;
function $90ed6e3aead06406$var$decorateToCatchUndefined(fn, hint) {
    if (typeof fn === 'undefined') fn = $3MP74.defaultFieldResolver;
    return function(root, args, ctx, info) {
        var result = fn(root, args, ctx, info);
        if (typeof result === 'undefined') throw new Error("Resolve function for \"" + hint + "\" returned undefined");
        return result;
    };
}
function $90ed6e3aead06406$var$addCatchUndefinedToSchema(schema) {
    (parcelRequire("cYGSS")).forEachField(schema, function(field, typeName, fieldName) {
        var errorHint = typeName + "." + fieldName;
        field.resolve = $90ed6e3aead06406$var$decorateToCatchUndefined(field.resolve, errorHint);
    });
}
module.exports.addCatchUndefinedToSchema = $90ed6e3aead06406$var$addCatchUndefinedToSchema;
function $90ed6e3aead06406$var$addErrorLoggingToSchema(schema, logger) {
    if (!logger) throw new Error('Must provide a logger');
    if (typeof logger.log !== 'function') throw new Error('Logger.log must be a function');
    (parcelRequire("cYGSS")).forEachField(schema, function(field, typeName, fieldName) {
        var errorHint = typeName + "." + fieldName;
        field.resolve = (parcelRequire("cYGSS")).decorateWithLogger(field.resolve, logger, errorHint);
    });
}
module.exports.addErrorLoggingToSchema = $90ed6e3aead06406$var$addErrorLoggingToSchema;

$90ed6e3aead06406$var$__export((parcelRequire("cYGSS")));

});
parcelRegister("gVW6u", function(module, exports) {
var $c53f0a6913fad0c1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c53f0a6913fad0c1$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");
var $1c4hI = parcelRequire("1c4hI");

var $gqGQB = parcelRequire("gqGQB");
var $c53f0a6913fad0c1$var$hasOwn = Object.prototype.hasOwnProperty;
// Abstract base class of any visitor implementation, defining the available
// visitor methods along with their parameter types, and providing a static
// helper function for determining whether a subclass implements a given
// visitor method, as opposed to inheriting one of the stubs defined here.
var $c53f0a6913fad0c1$var$SchemaVisitor = /** @class */ function() {
    function SchemaVisitor() {}
    // Determine if this SchemaVisitor (sub)class implements a particular
    // visitor method.
    SchemaVisitor.implementsVisitorMethod = function(methodName) {
        if (!methodName.startsWith('visit')) return false;
        var method = this.prototype[methodName];
        if (typeof method !== 'function') return false;
        if (this === SchemaVisitor) // The SchemaVisitor class implements every visitor method.
        return true;
        var stub = SchemaVisitor.prototype[methodName];
        if (method === stub) // If this.prototype[methodName] was just inherited from SchemaVisitor,
        // then this class does not really implement the method.
        return false;
        return true;
    };
    // Concrete subclasses of SchemaVisitor should override one or more of these
    // visitor methods, in order to express their interest in handling certain
    // schema types/locations. Each method may return null to remove the given
    // type from the schema, a non-null value of the same type to update the
    // type in the schema, or nothing to leave the type as it was.
    /* tslint:disable:no-empty */ SchemaVisitor.prototype.visitSchema = function(schema) {};
    SchemaVisitor.prototype.visitScalar = function(scalar) {};
    SchemaVisitor.prototype.visitObject = function(object) {};
    SchemaVisitor.prototype.visitFieldDefinition = function(field, details) {};
    SchemaVisitor.prototype.visitArgumentDefinition = function(argument, details) {};
    SchemaVisitor.prototype.visitInterface = function(iface) {};
    SchemaVisitor.prototype.visitUnion = function(union) {};
    SchemaVisitor.prototype.visitEnum = function(type) {};
    SchemaVisitor.prototype.visitEnumValue = function(value, details) {};
    SchemaVisitor.prototype.visitInputObject = function(object) {};
    SchemaVisitor.prototype.visitInputFieldDefinition = function(field, details) {};
    return SchemaVisitor;
}();
module.exports.SchemaVisitor = $c53f0a6913fad0c1$var$SchemaVisitor;
// Generic function for visiting GraphQLSchema objects.
function $c53f0a6913fad0c1$var$visitSchema(schema, // To accommodate as many different visitor patterns as possible, the
// visitSchema function does not simply accept a single instance of the
// SchemaVisitor class, but instead accepts a function that takes the
// current VisitableSchemaType object and the name of a visitor method and
// returns an array of SchemaVisitor instances that implement the visitor
// method and have an interest in handling the given VisitableSchemaType
// object. In the simplest case, this function can always return an array
// containing a single visitor object, without even looking at the type or
// methodName parameters. In other cases, this function might sometimes
// return an empty array to indicate there are no visitors that should be
// applied to the given VisitableSchemaType object. For an example of a
// visitor pattern that benefits from this abstraction, see the
// SchemaDirectiveVisitor class below.
visitorSelector) {
    // Helper function that calls visitorSelector and applies the resulting
    // visitors to the given type, with arguments [type, ...args].
    function callMethod(methodName, type) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        visitorSelector(type, methodName).every(function(visitor) {
            var newType = visitor[methodName].apply(visitor, $c53f0a6913fad0c1$var$__spreadArrays([
                type
            ], args));
            if (typeof newType === 'undefined') // Keep going without modifying type.
            return true;
            if (methodName === 'visitSchema' || type instanceof $6BdRO.GraphQLSchema) throw new Error("Method " + methodName + " cannot replace schema with " + newType);
            if (newType === null) {
                // Stop the loop and return null form callMethod, which will cause
                // the type to be removed from the schema.
                type = null;
                return false;
            }
            // Update type to the new type returned by the visitor method, so that
            // later directives will see the new type, and callMethod will return
            // the final type.
            type = newType;
            return true;
        });
        // If there were no directives for this type object, or if all visitor
        // methods returned nothing, type will be returned unmodified.
        return type;
    }
    // Recursive helper function that calls any appropriate visitor methods for
    // each object in the schema, then traverses the object's children (if any).
    function visit(type) {
        if (type instanceof $6BdRO.GraphQLSchema) {
            // Unlike the other types, the root GraphQLSchema object cannot be
            // replaced by visitor methods, because that would make life very hard
            // for SchemaVisitor subclasses that rely on the original schema object.
            callMethod('visitSchema', type);
            $c53f0a6913fad0c1$var$updateEachKey(type.getTypeMap(), function(namedType, typeName) {
                if (!typeName.startsWith('__')) // Call visit recursively to let it determine which concrete
                // subclass of GraphQLNamedType we found in the type map. Because
                // we're using updateEachKey, the result of visit(namedType) may
                // cause the type to be removed or replaced.
                return visit(namedType);
            });
            return type;
        }
        if (type instanceof $lXoEQ.GraphQLObjectType) {
            // Note that callMethod('visitObject', type) may not actually call any
            // methods, if there are no @directive annotations associated with this
            // type, or if this SchemaDirectiveVisitor subclass does not override
            // the visitObject method.
            var newObject = callMethod('visitObject', type);
            if (newObject) visitFields(newObject);
            return newObject;
        }
        if (type instanceof $lXoEQ.GraphQLInterfaceType) {
            var newInterface = callMethod('visitInterface', type);
            if (newInterface) visitFields(newInterface);
            return newInterface;
        }
        if (type instanceof $lXoEQ.GraphQLInputObjectType) {
            var newInputObject_1 = callMethod('visitInputObject', type);
            if (newInputObject_1) $c53f0a6913fad0c1$var$updateEachKey(newInputObject_1.getFields(), function(field) {
                // Since we call a different method for input object fields, we
                // can't reuse the visitFields function here.
                return callMethod('visitInputFieldDefinition', field, {
                    objectType: newInputObject_1
                });
            });
            return newInputObject_1;
        }
        if (type instanceof $lXoEQ.GraphQLScalarType) return callMethod('visitScalar', type);
        if (type instanceof $lXoEQ.GraphQLUnionType) return callMethod('visitUnion', type);
        if (type instanceof $lXoEQ.GraphQLEnumType) {
            var newEnum_1 = callMethod('visitEnum', type);
            if (newEnum_1) $c53f0a6913fad0c1$var$updateEachKey(newEnum_1.getValues(), function(value) {
                return callMethod('visitEnumValue', value, {
                    enumType: newEnum_1
                });
            });
            return newEnum_1;
        }
        throw new Error("Unexpected schema type: " + type);
    }
    function visitFields(type) {
        $c53f0a6913fad0c1$var$updateEachKey(type.getFields(), function(field) {
            // It would be nice if we could call visit(field) recursively here, but
            // GraphQLField is merely a type, not a value that can be detected using
            // an instanceof check, so we have to visit the fields in this lexical
            // context, so that TypeScript can validate the call to
            // visitFieldDefinition.
            var newField = callMethod('visitFieldDefinition', field, {
                // While any field visitor needs a reference to the field object, some
                // field visitors may also need to know the enclosing (parent) type,
                // perhaps to determine if the parent is a GraphQLObjectType or a
                // GraphQLInterfaceType. To obtain a reference to the parent, a
                // visitor method can have a second parameter, which will be an object
                // with an .objectType property referring to the parent.
                objectType: type
            });
            if (newField && newField.args) $c53f0a6913fad0c1$var$updateEachKey(newField.args, function(arg) {
                return callMethod('visitArgumentDefinition', arg, {
                    // Like visitFieldDefinition, visitArgumentDefinition takes a
                    // second parameter that provides additional context, namely the
                    // parent .field and grandparent .objectType. Remember that the
                    // current GraphQLSchema is always available via this.schema.
                    field: newField,
                    objectType: type
                });
            });
            return newField;
        });
    }
    visit(schema);
    // Return the original schema for convenience, even though it cannot have
    // been replaced or removed by the code above.
    return schema;
}
module.exports.visitSchema = $c53f0a6913fad0c1$var$visitSchema;
// Update any references to named schema types that disagree with the named
// types found in schema.getTypeMap().
function $c53f0a6913fad0c1$var$healSchema(schema) {
    heal(schema);
    return schema;
    function heal(type) {
        if (type instanceof $6BdRO.GraphQLSchema) {
            var originalTypeMap_1 = type.getTypeMap();
            var actualNamedTypeMap_1 = Object.create(null);
            // If any of the .name properties of the GraphQLNamedType objects in
            // schema.getTypeMap() have changed, the keys of the type map need to
            // be updated accordingly.
            $c53f0a6913fad0c1$var$each(originalTypeMap_1, function(namedType, typeName) {
                if (typeName.startsWith('__')) return;
                var actualName = namedType.name;
                if (actualName.startsWith('__')) return;
                if ($c53f0a6913fad0c1$var$hasOwn.call(actualNamedTypeMap_1, actualName)) throw new Error("Duplicate schema type name " + actualName);
                actualNamedTypeMap_1[actualName] = namedType;
            // Note: we are deliberately leaving namedType in the schema by its
            // original name (which might be different from actualName), so that
            // references by that name can be healed.
            });
            // Now add back every named type by its actual name.
            $c53f0a6913fad0c1$var$each(actualNamedTypeMap_1, function(namedType, typeName) {
                originalTypeMap_1[typeName] = namedType;
            });
            // Directive declaration argument types can refer to named types.
            $c53f0a6913fad0c1$var$each(type.getDirectives(), function(decl) {
                if (decl.args) $c53f0a6913fad0c1$var$each(decl.args, function(arg) {
                    arg.type = healType(arg.type);
                });
            });
            $c53f0a6913fad0c1$var$each(originalTypeMap_1, function(namedType, typeName) {
                if (!typeName.startsWith('__')) heal(namedType);
            });
            $c53f0a6913fad0c1$var$updateEachKey(originalTypeMap_1, function(namedType, typeName) {
                // Dangling references to renamed types should remain in the schema
                // during healing, but must be removed now, so that the following
                // invariant holds for all names: schema.getType(name).name === name
                if (!typeName.startsWith('__') && !$c53f0a6913fad0c1$var$hasOwn.call(actualNamedTypeMap_1, typeName)) return null;
            });
        } else if (type instanceof $lXoEQ.GraphQLObjectType) {
            healFields(type);
            $c53f0a6913fad0c1$var$each(type.getInterfaces(), function(iface) {
                return heal(iface);
            });
        } else if (type instanceof $lXoEQ.GraphQLInterfaceType) healFields(type);
        else if (type instanceof $lXoEQ.GraphQLInputObjectType) $c53f0a6913fad0c1$var$each(type.getFields(), function(field) {
            field.type = healType(field.type);
        });
        else if (type instanceof $lXoEQ.GraphQLScalarType) ;
        else if (type instanceof $lXoEQ.GraphQLUnionType) $c53f0a6913fad0c1$var$updateEachKey(type.getTypes(), function(t) {
            return healType(t);
        });
        else if (type instanceof $lXoEQ.GraphQLEnumType) ;
        else throw new Error("Unexpected schema type: " + type);
    }
    function healFields(type) {
        $c53f0a6913fad0c1$var$each(type.getFields(), function(field) {
            field.type = healType(field.type);
            if (field.args) $c53f0a6913fad0c1$var$each(field.args, function(arg) {
                arg.type = healType(arg.type);
            });
        });
    }
    function healType(type) {
        // Unwrap the two known wrapper types
        if (type instanceof $lXoEQ.GraphQLList) type = new $lXoEQ.GraphQLList(healType(type.ofType));
        else if (type instanceof $lXoEQ.GraphQLNonNull) type = new $lXoEQ.GraphQLNonNull(healType(type.ofType));
        else if ($lXoEQ.isNamedType(type)) {
            // If a type annotation on a field or an argument or a union member is
            // any `GraphQLNamedType` with a `name`, then it must end up identical
            // to `schema.getType(name)`, since `schema.getTypeMap()` is the source
            // of truth for all named schema types.
            var namedType = type;
            var officialType = schema.getType(namedType.name);
            if (officialType && namedType !== officialType) return officialType;
        }
        return type;
    }
}
module.exports.healSchema = $c53f0a6913fad0c1$var$healSchema;
// This class represents a reusable implementation of a @directive that may
// appear in a GraphQL schema written in Schema Definition Language.
//
// By overriding one or more visit{Object,Union,...} methods, a subclass
// registers interest in certain schema types, such as GraphQLObjectType,
// GraphQLUnionType, etc. When SchemaDirectiveVisitor.visitSchemaDirectives is
// called with a GraphQLSchema object and a map of visitor subclasses, the
// overidden methods of those subclasses allow the visitors to obtain
// references to any type objects that have @directives attached to them,
// enabling visitors to inspect or modify the schema as appropriate.
//
// For example, if a directive called @rest(url: "...") appears after a field
// definition, a SchemaDirectiveVisitor subclass could provide meaning to that
// directive by overriding the visitFieldDefinition method (which receives a
// GraphQLField parameter), and then the body of that visitor method could
// manipulate the field's resolver function to fetch data from a REST endpoint
// described by the url argument passed to the @rest directive:
//
//   const typeDefs = `
//   type Query {
//     people: [Person] @rest(url: "/api/v1/people")
//   }`;
//
//   const schema = makeExecutableSchema({ typeDefs });
//
//   SchemaDirectiveVisitor.visitSchemaDirectives(schema, {
//     rest: class extends SchemaDirectiveVisitor {
//       public visitFieldDefinition(field: GraphQLField<any, any>) {
//         const { url } = this.args;
//         field.resolve = () => fetch(url);
//       }
//     }
//   });
//
// The subclass in this example is defined as an anonymous class expression,
// for brevity. A truly reusable SchemaDirectiveVisitor would most likely be
// defined in a library using a named class declaration, and then exported for
// consumption by other modules and packages.
//
// See below for a complete list of overridable visitor methods, their
// parameter types, and more details about the properties exposed by instances
// of the SchemaDirectiveVisitor class.
var $c53f0a6913fad0c1$var$SchemaDirectiveVisitor = /** @class */ function(_super) {
    $c53f0a6913fad0c1$var$__extends(SchemaDirectiveVisitor, _super);
    // Mark the constructor protected to enforce passing SchemaDirectiveVisitor
    // subclasses (not instances) to visitSchemaDirectives.
    function SchemaDirectiveVisitor(config) {
        var _this = _super.call(this) || this;
        _this.name = config.name;
        _this.args = config.args;
        _this.visitedType = config.visitedType;
        _this.schema = config.schema;
        _this.context = config.context;
        return _this;
    }
    // Override this method to return a custom GraphQLDirective (or modify one
    // already present in the schema) to enforce argument types, provide default
    // argument values, or specify schema locations where this @directive may
    // appear. By default, any declaration found in the schema will be returned.
    SchemaDirectiveVisitor.getDirectiveDeclaration = function(directiveName, schema) {
        return schema.getDirective(directiveName);
    };
    // Call SchemaDirectiveVisitor.visitSchemaDirectives to visit every
    // @directive in the schema and create an appropriate SchemaDirectiveVisitor
    // instance to visit the object decorated by the @directive.
    SchemaDirectiveVisitor.visitSchemaDirectives = function(schema, directiveVisitors, // Optional context object that will be available to all visitor instances
    // via this.context. Defaults to an empty null-prototype object.
    context) {
        if (context === void 0) context = Object.create(null);
        // If the schema declares any directives for public consumption, record
        // them here so that we can properly coerce arguments when/if we encounter
        // an occurrence of the directive while walking the schema below.
        var declaredDirectives = this.getDeclaredDirectives(schema, directiveVisitors);
        // Map from directive names to lists of SchemaDirectiveVisitor instances
        // created while visiting the schema.
        var createdVisitors = Object.create(null);
        Object.keys(directiveVisitors).forEach(function(directiveName) {
            createdVisitors[directiveName] = [];
        });
        function visitorSelector(type, methodName) {
            var visitors = [];
            var directiveNodes = type.astNode && type.astNode.directives;
            if (!directiveNodes) return visitors;
            directiveNodes.forEach(function(directiveNode) {
                var directiveName = directiveNode.name.value;
                if (!$c53f0a6913fad0c1$var$hasOwn.call(directiveVisitors, directiveName)) return;
                var visitorClass = directiveVisitors[directiveName];
                // Avoid creating visitor objects if visitorClass does not override
                // the visitor method named by methodName.
                if (!visitorClass.implementsVisitorMethod(methodName)) return;
                var decl = declaredDirectives[directiveName];
                var args;
                if (decl) // If this directive was explicitly declared, use the declared
                // argument types (and any default values) to check, coerce, and/or
                // supply default values for the given arguments.
                args = $gqGQB.getArgumentValues(decl, directiveNode);
                else {
                    // If this directive was not explicitly declared, just convert the
                    // argument nodes to their corresponding JavaScript values.
                    args = Object.create(null);
                    directiveNode.arguments.forEach(function(arg) {
                        args[arg.name.value] = $c53f0a6913fad0c1$var$valueFromASTUntyped(arg.value);
                    });
                }
                // As foretold in comments near the top of the visitSchemaDirectives
                // method, this is where instances of the SchemaDirectiveVisitor class
                // get created and assigned names. While subclasses could override the
                // constructor method, the constructor is marked as protected, so
                // these are the only arguments that will ever be passed.
                visitors.push(new visitorClass({
                    name: directiveName,
                    args: args,
                    visitedType: type,
                    schema: schema,
                    context: context
                }));
            });
            if (visitors.length > 0) visitors.forEach(function(visitor) {
                createdVisitors[visitor.name].push(visitor);
            });
            return visitors;
        }
        $c53f0a6913fad0c1$var$visitSchema(schema, visitorSelector);
        // Automatically update any references to named schema types replaced
        // during the traversal, so implementors don't have to worry about that.
        $c53f0a6913fad0c1$var$healSchema(schema);
        return createdVisitors;
    };
    SchemaDirectiveVisitor.getDeclaredDirectives = function(schema, directiveVisitors) {
        var declaredDirectives = Object.create(null);
        $c53f0a6913fad0c1$var$each(schema.getDirectives(), function(decl) {
            declaredDirectives[decl.name] = decl;
        });
        // If the visitor subclass overrides getDirectiveDeclaration, and it
        // returns a non-null GraphQLDirective, use that instead of any directive
        // declared in the schema itself. Reasoning: if a SchemaDirectiveVisitor
        // goes to the trouble of implementing getDirectiveDeclaration, it should
        // be able to rely on that implementation.
        $c53f0a6913fad0c1$var$each(directiveVisitors, function(visitorClass, directiveName) {
            var decl = visitorClass.getDirectiveDeclaration(directiveName, schema);
            if (decl) declaredDirectives[directiveName] = decl;
        });
        $c53f0a6913fad0c1$var$each(declaredDirectives, function(decl, name) {
            if (!$c53f0a6913fad0c1$var$hasOwn.call(directiveVisitors, name)) // SchemaDirectiveVisitors.visitSchemaDirectives might be called
            // multiple times with partial directiveVisitors maps, so it's not
            // necessarily an error for directiveVisitors to be missing an
            // implementation of a directive that was declared in the schema.
            return;
            var visitorClass = directiveVisitors[name];
            $c53f0a6913fad0c1$var$each(decl.locations, function(loc) {
                var visitorMethodName = $c53f0a6913fad0c1$var$directiveLocationToVisitorMethodName(loc);
                if ($c53f0a6913fad0c1$var$SchemaVisitor.implementsVisitorMethod(visitorMethodName) && !visitorClass.implementsVisitorMethod(visitorMethodName)) // While visitor subclasses may implement extra visitor methods,
                // it's definitely a mistake if the GraphQLDirective declares itself
                // applicable to certain schema locations, and the visitor subclass
                // does not implement all the corresponding methods.
                throw new Error("SchemaDirectiveVisitor for @" + name + " must implement " + visitorMethodName + " method");
            });
        });
        return declaredDirectives;
    };
    return SchemaDirectiveVisitor;
}($c53f0a6913fad0c1$var$SchemaVisitor);
module.exports.SchemaDirectiveVisitor = $c53f0a6913fad0c1$var$SchemaDirectiveVisitor;
// Convert a string like "FIELD_DEFINITION" to "visitFieldDefinition".
function $c53f0a6913fad0c1$var$directiveLocationToVisitorMethodName(loc) {
    return 'visit' + loc.replace(/([^_]*)_?/g, function(wholeMatch, part) {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
}
function $c53f0a6913fad0c1$var$each(arrayOrObject, callback) {
    Object.keys(arrayOrObject).forEach(function(key) {
        callback(arrayOrObject[key], key);
    });
}
// A more powerful version of each that has the ability to replace or remove
// array or object keys.
function $c53f0a6913fad0c1$var$updateEachKey(arrayOrObject, // The callback can return nothing to leave the key untouched, null to remove
// the key from the array or object, or a non-null V to replace the value.
callback) {
    var deletedCount = 0;
    Object.keys(arrayOrObject).forEach(function(key) {
        var result = callback(arrayOrObject[key], key);
        if (typeof result === 'undefined') return;
        if (result === null) {
            delete arrayOrObject[key];
            deletedCount++;
            return;
        }
        arrayOrObject[key] = result;
    });
    if (deletedCount > 0 && Array.isArray(arrayOrObject)) // Remove any holes from the array due to deleted elements.
    arrayOrObject.splice(0).forEach(function(elem) {
        arrayOrObject.push(elem);
    });
}
// Similar to the graphql-js function of the same name, slightly simplified:
// https://github.com/graphql/graphql-js/blob/master/src/utilities/valueFromASTUntyped.js
function $c53f0a6913fad0c1$var$valueFromASTUntyped(valueNode) {
    switch(valueNode.kind){
        case $1c4hI.Kind.NULL:
            return null;
        case $1c4hI.Kind.INT:
            return parseInt(valueNode.value, 10);
        case $1c4hI.Kind.FLOAT:
            return parseFloat(valueNode.value);
        case $1c4hI.Kind.STRING:
        case $1c4hI.Kind.ENUM:
        case $1c4hI.Kind.BOOLEAN:
            return valueNode.value;
        case $1c4hI.Kind.LIST:
            return valueNode.values.map($c53f0a6913fad0c1$var$valueFromASTUntyped);
        case $1c4hI.Kind.OBJECT:
            var obj_1 = Object.create(null);
            valueNode.fields.forEach(function(field) {
                obj_1[field.name.value] = $c53f0a6913fad0c1$var$valueFromASTUntyped(field.value);
            });
            return obj_1;
        /* istanbul ignore next */ default:
            throw new Error('Unexpected value kind: ' + valueNode.kind);
    }
}

});

parcelRegister("b3EaX", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $80cf239c99e32ce4$var$mergeDeep(target, source) {
    var output = Object.assign({}, target);
    if ($80cf239c99e32ce4$var$isObject(target) && $80cf239c99e32ce4$var$isObject(source)) Object.keys(source).forEach(function(key) {
        var _a, _b;
        if ($80cf239c99e32ce4$var$isObject(source[key])) {
            if (!(key in target)) Object.assign(output, (_a = {}, _a[key] = source[key], _a));
            else output[key] = $80cf239c99e32ce4$var$mergeDeep(target[key], source[key]);
        } else Object.assign(output, (_b = {}, _b[key] = source[key], _b));
    });
    return output;
}
module.exports.default = $80cf239c99e32ce4$var$mergeDeep;
function $80cf239c99e32ce4$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

});

parcelRegister("cYGSS", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gLRgj = parcelRequire("gLRgj");
module.exports.addResolveFunctionsToSchema = $gLRgj.default;

var $lQXQV = parcelRequire("lQXQV");
module.exports.addSchemaLevelResolveFunction = $lQXQV.default;

var $7ZqjT = parcelRequire("7ZqjT");
module.exports.assertResolveFunctionsPresent = $7ZqjT.default;

var $glxQ5 = parcelRequire("glxQ5");
module.exports.attachDirectiveResolvers = $glxQ5.default;

var $4Vy0J = parcelRequire("4Vy0J");
module.exports.attachConnectorsToContext = $4Vy0J.default;

var $kYZ7H = parcelRequire("kYZ7H");
module.exports.buildSchemaFromTypeDefinitions = $kYZ7H.default;

var $zi3Qo = parcelRequire("zi3Qo");
module.exports.chainResolvers = $zi3Qo.chainResolvers;

var $3zHIx = parcelRequire("3zHIx");
module.exports.checkForResolveTypeResolver = $3zHIx.default;

var $fzT6r = parcelRequire("fzT6r");
module.exports.concatenateTypeDefs = $fzT6r.default;

var $jhVll = parcelRequire("jhVll");
module.exports.decorateWithLogger = $jhVll.default;

var $anY4o = parcelRequire("anY4o");
module.exports.extendResolversFromInterfaces = $anY4o.default;

var $4YHnC = parcelRequire("4YHnC");
module.exports.extractExtensionDefinitions = $4YHnC.default;

var $bKZOs = parcelRequire("bKZOs");
module.exports.forEachField = $bKZOs.default;

var $69KMn = parcelRequire("69KMn");
module.exports.SchemaError = $69KMn.default;

});
parcelRegister("gLRgj", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cYGSS = parcelRequire("cYGSS");

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");

var $esVhq = parcelRequire("esVhq");

var $cYGSS = parcelRequire("cYGSS");

var $l0ywS = parcelRequire("l0ywS");
function $c35a59e5905db8e3$var$addResolveFunctionsToSchema(options, legacyInputResolvers, legacyInputValidationOptions) {
    if (options instanceof $6BdRO.GraphQLSchema) {
        console.warn('The addResolveFunctionsToSchema function takes named options now; see IAddResolveFunctionsToSchemaOptions');
        options = {
            schema: options,
            resolvers: legacyInputResolvers,
            resolverValidationOptions: legacyInputValidationOptions
        };
    }
    var schema = options.schema, inputResolvers = options.resolvers, _a = options.resolverValidationOptions, resolverValidationOptions = _a === void 0 ? {} : _a, _b = options.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _b === void 0 ? false : _b;
    var _c = resolverValidationOptions.allowResolversNotInSchema, allowResolversNotInSchema = _c === void 0 ? false : _c, requireResolversForResolveType = resolverValidationOptions.requireResolversForResolveType;
    var resolvers = inheritResolversFromInterfaces ? $cYGSS.extendResolversFromInterfaces(schema, inputResolvers) : inputResolvers;
    // Used to map the external value of an enum to its internal value, when
    // that internal value is provided by a resolver.
    var enumValueMap = Object.create(null);
    Object.keys(resolvers).forEach(function(typeName) {
        var resolverValue = resolvers[typeName];
        var resolverType = typeof resolverValue;
        if (resolverType !== 'object' && resolverType !== 'function') throw new $cYGSS.SchemaError("\"" + typeName + "\" defined in resolvers, but has invalid value \"" + resolverValue + "\". A resolver's value " + "must be of type object or function.");
        var type = schema.getType(typeName);
        if (!type && typeName !== '__schema') {
            if (allowResolversNotInSchema) return;
            throw new $cYGSS.SchemaError("\"" + typeName + "\" defined in resolvers, but not in schema");
        }
        Object.keys(resolverValue).forEach(function(fieldName) {
            if (fieldName.startsWith('__')) {
                // this is for isTypeOf and resolveType and all the other stuff.
                type[fieldName.substring(2)] = resolverValue[fieldName];
                return;
            }
            if (type instanceof $lXoEQ.GraphQLScalarType) {
                type[fieldName] = resolverValue[fieldName];
                return;
            }
            if (type instanceof $lXoEQ.GraphQLEnumType) {
                if (!type.getValue(fieldName)) {
                    if (allowResolversNotInSchema) return;
                    throw new $cYGSS.SchemaError(typeName + "." + fieldName + " was defined in resolvers, but enum is not in schema");
                }
                // We've encountered an enum resolver that is being used to provide an
                // internal enum value.
                // Reference: https://www.apollographql.com/docs/graphql-tools/scalars.html#internal-values
                //
                // We're storing a map of the current enums external facing value to
                // its resolver provided internal value. This map is used to transform
                // the current schema to a new schema that includes enums with the new
                // internal value.
                enumValueMap[type.name] = enumValueMap[type.name] || {};
                enumValueMap[type.name][fieldName] = resolverValue[fieldName];
                return;
            }
            // object type
            var fields = $c35a59e5905db8e3$var$getFieldsForType(type);
            if (!fields) {
                if (allowResolversNotInSchema) return;
                throw new $cYGSS.SchemaError(typeName + " was defined in resolvers, but it's not an object");
            }
            if (!fields[fieldName]) {
                if (allowResolversNotInSchema) return;
                throw new $cYGSS.SchemaError(typeName + "." + fieldName + " defined in resolvers, but not in schema");
            }
            var field = fields[fieldName];
            var fieldResolve = resolverValue[fieldName];
            if (typeof fieldResolve === 'function') // for convenience. Allows shorter syntax in resolver definition file
            $c35a59e5905db8e3$var$setFieldProperties(field, {
                resolve: fieldResolve
            });
            else {
                if (typeof fieldResolve !== 'object') throw new $cYGSS.SchemaError("Resolver " + typeName + "." + fieldName + " must be object or function");
                $c35a59e5905db8e3$var$setFieldProperties(field, fieldResolve);
            }
        });
    });
    $cYGSS.checkForResolveTypeResolver(schema, requireResolversForResolveType);
    // If there are any enum resolver functions (that are used to return
    // internal enum values), create a new schema that includes enums with the
    // new internal facing values.
    var updatedSchema = $esVhq.applySchemaTransforms(schema, [
        new $l0ywS.default(enumValueMap)
    ]);
    return updatedSchema;
}
function $c35a59e5905db8e3$var$getFieldsForType(type) {
    if (type instanceof $lXoEQ.GraphQLObjectType || type instanceof $lXoEQ.GraphQLInterfaceType) return type.getFields();
    else return undefined;
}
function $c35a59e5905db8e3$var$setFieldProperties(field, propertiesObj) {
    Object.keys(propertiesObj).forEach(function(propertyName) {
        field[propertyName] = propertiesObj[propertyName];
    });
}
module.exports.default = $c35a59e5905db8e3$var$addResolveFunctionsToSchema;

});
parcelRegister("esVhq", function(module, exports) {
var $a8801cd741f34ae5$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $a8801cd741f34ae5$var$applySchemaTransforms(originalSchema, transforms) {
    return transforms.reduce(function(schema, transform) {
        return transform.transformSchema ? transform.transformSchema(schema) : schema;
    }, originalSchema);
}
module.exports.applySchemaTransforms = $a8801cd741f34ae5$var$applySchemaTransforms;
function $a8801cd741f34ae5$var$applyRequestTransforms(originalRequest, transforms) {
    return transforms.reduce(function(request, transform) {
        return transform.transformRequest ? transform.transformRequest(request) : request;
    }, originalRequest);
}
module.exports.applyRequestTransforms = $a8801cd741f34ae5$var$applyRequestTransforms;
function $a8801cd741f34ae5$var$applyResultTransforms(originalResult, transforms) {
    return transforms.reduce(function(result, transform) {
        return transform.transformResult ? transform.transformResult(result) : result;
    }, originalResult);
}
module.exports.applyResultTransforms = $a8801cd741f34ae5$var$applyResultTransforms;
function $a8801cd741f34ae5$var$composeTransforms() {
    var transforms = [];
    for(var _i = 0; _i < arguments.length; _i++)transforms[_i] = arguments[_i];
    var reverseTransforms = $a8801cd741f34ae5$var$__spreadArrays(transforms).reverse();
    return {
        transformSchema: function(originalSchema) {
            return $a8801cd741f34ae5$var$applySchemaTransforms(originalSchema, transforms);
        },
        transformRequest: function(originalRequest) {
            return $a8801cd741f34ae5$var$applyRequestTransforms(originalRequest, reverseTransforms);
        },
        transformResult: function(result) {
            return $a8801cd741f34ae5$var$applyResultTransforms(result, reverseTransforms);
        }
    };
}
module.exports.composeTransforms = $a8801cd741f34ae5$var$composeTransforms;

});

parcelRegister("l0ywS", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $esiZ2 = parcelRequire("esiZ2");
// Transformation used to modifiy `GraphQLEnumType` values in a schema.
var $f4b461dd5b4b26c8$var$ConvertEnumValues = /** @class */ function() {
    function ConvertEnumValues(enumValueMap) {
        this.enumValueMap = enumValueMap;
    }
    // Walk a schema looking for `GraphQLEnumType` types. If found, and
    // matching types have been identified in `this.enumValueMap`, create new
    // `GraphQLEnumType` types using the `this.enumValueMap` specified new
    // values, and return them in the new schema.
    ConvertEnumValues.prototype.transformSchema = function(schema) {
        var _a;
        var enumValueMap = this.enumValueMap;
        if (!enumValueMap || Object.keys(enumValueMap).length === 0) return schema;
        var transformedSchema = $esiZ2.visitSchema(schema, (_a = {}, _a[$esiZ2.VisitSchemaKind.ENUM_TYPE] = function(enumType) {
            var externalToInternalValueMap = enumValueMap[enumType.name];
            if (externalToInternalValueMap) {
                var values = enumType.getValues();
                var newValues_1 = {};
                values.forEach(function(value) {
                    var newValue = Object.keys(externalToInternalValueMap).includes(value.name) ? externalToInternalValueMap[value.name] : value.name;
                    newValues_1[value.name] = {
                        value: newValue,
                        deprecationReason: value.deprecationReason,
                        description: value.description,
                        astNode: value.astNode
                    };
                });
                return new $lXoEQ.GraphQLEnumType({
                    name: enumType.name,
                    description: enumType.description,
                    astNode: enumType.astNode,
                    values: newValues_1
                });
            }
            return enumType;
        }, _a));
        return transformedSchema;
    };
    return ConvertEnumValues;
}();
module.exports.default = $f4b461dd5b4b26c8$var$ConvertEnumValues;

});
parcelRegister("esiZ2", function(module, exports) {
var $a86267ec7e8e9726$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");

var $h8S1f = parcelRequire("h8S1f");
var $a86267ec7e8e9726$var$VisitSchemaKind;
(function(VisitSchemaKind) {
    VisitSchemaKind["TYPE"] = "VisitSchemaKind.TYPE";
    VisitSchemaKind["SCALAR_TYPE"] = "VisitSchemaKind.SCALAR_TYPE";
    VisitSchemaKind["ENUM_TYPE"] = "VisitSchemaKind.ENUM_TYPE";
    VisitSchemaKind["COMPOSITE_TYPE"] = "VisitSchemaKind.COMPOSITE_TYPE";
    VisitSchemaKind["OBJECT_TYPE"] = "VisitSchemaKind.OBJECT_TYPE";
    VisitSchemaKind["INPUT_OBJECT_TYPE"] = "VisitSchemaKind.INPUT_OBJECT_TYPE";
    VisitSchemaKind["ABSTRACT_TYPE"] = "VisitSchemaKind.ABSTRACT_TYPE";
    VisitSchemaKind["UNION_TYPE"] = "VisitSchemaKind.UNION_TYPE";
    VisitSchemaKind["INTERFACE_TYPE"] = "VisitSchemaKind.INTERFACE_TYPE";
    VisitSchemaKind["ROOT_OBJECT"] = "VisitSchemaKind.ROOT_OBJECT";
    VisitSchemaKind["QUERY"] = "VisitSchemaKind.QUERY";
    VisitSchemaKind["MUTATION"] = "VisitSchemaKind.MUTATION";
    VisitSchemaKind["SUBSCRIPTION"] = "VisitSchemaKind.SUBSCRIPTION";
})($a86267ec7e8e9726$var$VisitSchemaKind = module.exports.VisitSchemaKind || (module.exports.VisitSchemaKind = {}));
function $a86267ec7e8e9726$var$visitSchema(schema, visitor, stripResolvers) {
    var types = {};
    var resolveType = $h8S1f.createResolveType(function(name) {
        if (typeof types[name] === 'undefined') throw new Error("Can't find type " + name + ".");
        return types[name];
    });
    var queryType = schema.getQueryType();
    var mutationType = schema.getMutationType();
    var subscriptionType = schema.getSubscriptionType();
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).map(function(typeName) {
        var type = typeMap[typeName];
        if ($lXoEQ.isNamedType(type) && $lXoEQ.getNamedType(type).name.slice(0, 2) !== '__') {
            var specifiers = $a86267ec7e8e9726$var$getTypeSpecifiers(type, schema);
            var typeVisitor = $a86267ec7e8e9726$var$getVisitor(visitor, specifiers);
            if (typeVisitor) {
                var result = typeVisitor(type, schema);
                if (typeof result === 'undefined') types[typeName] = $h8S1f.recreateType(type, resolveType, !stripResolvers);
                else if (result === null) types[typeName] = null;
                else types[typeName] = $h8S1f.recreateType(result, resolveType, !stripResolvers);
            } else types[typeName] = $h8S1f.recreateType(type, resolveType, !stripResolvers);
        }
    });
    return new $6BdRO.GraphQLSchema({
        query: queryType ? types[queryType.name] : null,
        mutation: mutationType ? types[mutationType.name] : null,
        subscription: subscriptionType ? types[subscriptionType.name] : null,
        types: Object.keys(types).map(function(name) {
            return types[name];
        })
    });
}
module.exports.visitSchema = $a86267ec7e8e9726$var$visitSchema;
function $a86267ec7e8e9726$var$getTypeSpecifiers(type, schema) {
    var specifiers = [
        $a86267ec7e8e9726$var$VisitSchemaKind.TYPE
    ];
    if (type instanceof $lXoEQ.GraphQLObjectType) {
        specifiers.unshift($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.OBJECT_TYPE);
        var query = schema.getQueryType();
        var mutation = schema.getMutationType();
        var subscription = schema.getSubscriptionType();
        if (type === query) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.QUERY);
        else if (type === mutation) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.MUTATION);
        else if (type === subscription) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.SUBSCRIPTION);
    } else if (type instanceof $lXoEQ.GraphQLInputObjectType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.INPUT_OBJECT_TYPE);
    else if (type instanceof $lXoEQ.GraphQLInterfaceType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.ABSTRACT_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.INTERFACE_TYPE);
    else if (type instanceof $lXoEQ.GraphQLUnionType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.ABSTRACT_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.UNION_TYPE);
    else if (type instanceof $lXoEQ.GraphQLEnumType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ENUM_TYPE);
    else if (type instanceof $lXoEQ.GraphQLScalarType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.SCALAR_TYPE);
    return specifiers;
}
function $a86267ec7e8e9726$var$getVisitor(visitor, specifiers) {
    var typeVisitor = null;
    var stack = $a86267ec7e8e9726$var$__spreadArrays(specifiers);
    while(!typeVisitor && stack.length > 0){
        var next = stack.pop();
        typeVisitor = visitor[next];
    }
    return typeVisitor;
}

});
parcelRegister("h8S1f", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");
var $bOniD = parcelRequire("bOniD");
var $1c4hI = parcelRequire("1c4hI");

var $kgFtY = parcelRequire("kgFtY");

var $j0Odg = parcelRequire("j0Odg");

var $8je8M = parcelRequire("8je8M");
function $c7ad1618233e9756$var$recreateType(type, resolveType, keepResolvers) {
    if (type instanceof $lXoEQ.GraphQLObjectType) {
        var fields_1 = type.getFields();
        var interfaces_1 = type.getInterfaces();
        return new $lXoEQ.GraphQLObjectType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            isTypeOf: keepResolvers ? type.isTypeOf : undefined,
            fields: function() {
                return $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields_1, resolveType, keepResolvers);
            },
            interfaces: function() {
                return interfaces_1.map(function(iface) {
                    return resolveType(iface);
                });
            }
        });
    } else if (type instanceof $lXoEQ.GraphQLInterfaceType) {
        var fields_2 = type.getFields();
        return new $lXoEQ.GraphQLInterfaceType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            fields: function() {
                return $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields_2, resolveType, keepResolvers);
            },
            resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
                return $j0Odg.default(parent, info.schema);
            }
        });
    } else if (type instanceof $lXoEQ.GraphQLUnionType) return new $lXoEQ.GraphQLUnionType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        types: function() {
            return type.getTypes().map(function(unionMember) {
                return resolveType(unionMember);
            });
        },
        resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
    else if (type instanceof $lXoEQ.GraphQLInputObjectType) return new $lXoEQ.GraphQLInputObjectType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        fields: function() {
            return $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap(type.getFields(), resolveType);
        }
    });
    else if (type instanceof $lXoEQ.GraphQLEnumType) {
        var values = type.getValues();
        var newValues_1 = {};
        values.forEach(function(value) {
            newValues_1[value.name] = {
                value: value.value,
                deprecationReason: value.deprecationReason,
                description: value.description,
                astNode: value.astNode
            };
        });
        return new $lXoEQ.GraphQLEnumType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            values: newValues_1
        });
    } else if (type instanceof $lXoEQ.GraphQLScalarType) {
        if (keepResolvers || $kgFtY.default(type)) return type;
        else return new $lXoEQ.GraphQLScalarType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            serialize: function(value) {
                return value;
            },
            parseValue: function(value) {
                return value;
            },
            parseLiteral: function(ast) {
                return $c7ad1618233e9756$var$parseLiteral(ast);
            }
        });
    } else throw new Error("Invalid type " + type);
}
module.exports.recreateType = $c7ad1618233e9756$var$recreateType;
function $c7ad1618233e9756$var$recreateDirective(directive, resolveType) {
    return new $bOniD.GraphQLDirective({
        name: directive.name,
        description: directive.description,
        locations: directive.locations,
        args: $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(directive.args, resolveType),
        astNode: directive.astNode
    });
}
module.exports.recreateDirective = $c7ad1618233e9756$var$recreateDirective;
function $c7ad1618233e9756$var$parseLiteral(ast) {
    switch(ast.kind){
        case $1c4hI.Kind.STRING:
        case $1c4hI.Kind.BOOLEAN:
            return ast.value;
        case $1c4hI.Kind.INT:
        case $1c4hI.Kind.FLOAT:
            return parseFloat(ast.value);
        case $1c4hI.Kind.OBJECT:
            var value_1 = Object.create(null);
            ast.fields.forEach(function(field) {
                value_1[field.name.value] = $c7ad1618233e9756$var$parseLiteral(field.value);
            });
            return value_1;
        case $1c4hI.Kind.LIST:
            return ast.values.map($c7ad1618233e9756$var$parseLiteral);
        default:
            return null;
    }
}
function $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields, resolveType, keepResolvers) {
    var result = {};
    Object.keys(fields).forEach(function(name) {
        var field = fields[name];
        var type = resolveType(field.type);
        if (type !== null) result[name] = $c7ad1618233e9756$var$fieldToFieldConfig(fields[name], resolveType, keepResolvers);
    });
    return result;
}
module.exports.fieldMapToFieldConfigMap = $c7ad1618233e9756$var$fieldMapToFieldConfigMap;
function $c7ad1618233e9756$var$createResolveType(getType) {
    var resolveType = function(type) {
        if (type instanceof $lXoEQ.GraphQLList) {
            var innerType = resolveType(type.ofType);
            if (innerType === null) return null;
            else return new $lXoEQ.GraphQLList(innerType);
        } else if (type instanceof $lXoEQ.GraphQLNonNull) {
            var innerType = resolveType(type.ofType);
            if (innerType === null) return null;
            else return new $lXoEQ.GraphQLNonNull(innerType);
        } else if ($lXoEQ.isNamedType(type)) {
            var typeName = $lXoEQ.getNamedType(type).name;
            switch(typeName){
                case $auu22.GraphQLInt.name:
                    return $auu22.GraphQLInt;
                case $auu22.GraphQLFloat.name:
                    return $auu22.GraphQLFloat;
                case $auu22.GraphQLString.name:
                    return $auu22.GraphQLString;
                case $auu22.GraphQLBoolean.name:
                    return $auu22.GraphQLBoolean;
                case $auu22.GraphQLID.name:
                    return $auu22.GraphQLID;
                default:
                    return getType(typeName, type);
            }
        } else return type;
    };
    return resolveType;
}
module.exports.createResolveType = $c7ad1618233e9756$var$createResolveType;
function $c7ad1618233e9756$var$fieldToFieldConfig(field, resolveType, keepResolvers) {
    return {
        type: resolveType(field.type),
        args: $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(field.args, resolveType),
        resolve: keepResolvers ? field.resolve : $8je8M.default,
        subscribe: keepResolvers ? field.subscribe : null,
        description: field.description,
        deprecationReason: field.deprecationReason,
        astNode: field.astNode
    };
}
module.exports.fieldToFieldConfig = $c7ad1618233e9756$var$fieldToFieldConfig;
function $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(args, resolveType) {
    var result = {};
    args.forEach(function(arg) {
        var newArg = $c7ad1618233e9756$var$argumentToArgumentConfig(arg, resolveType);
        if (newArg) result[newArg[0]] = newArg[1];
    });
    return result;
}
module.exports.argsToFieldConfigArgumentMap = $c7ad1618233e9756$var$argsToFieldConfigArgumentMap;
function $c7ad1618233e9756$var$argumentToArgumentConfig(argument, resolveType) {
    var type = resolveType(argument.type);
    if (type === null) return null;
    else return [
        argument.name,
        {
            type: type,
            defaultValue: argument.defaultValue,
            description: argument.description
        }
    ];
}
module.exports.argumentToArgumentConfig = $c7ad1618233e9756$var$argumentToArgumentConfig;
function $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap(fields, resolveType) {
    var result = {};
    Object.keys(fields).forEach(function(name) {
        var field = fields[name];
        var type = resolveType(field.type);
        if (type !== null) result[name] = $c7ad1618233e9756$var$inputFieldToFieldConfig(fields[name], resolveType);
    });
    return result;
}
module.exports.inputFieldMapToFieldConfigMap = $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap;
function $c7ad1618233e9756$var$inputFieldToFieldConfig(field, resolveType) {
    return {
        type: resolveType(field.type),
        defaultValue: field.defaultValue,
        description: field.description,
        astNode: field.astNode
    };
}
module.exports.inputFieldToFieldConfig = $c7ad1618233e9756$var$inputFieldToFieldConfig;

});
parcelRegister("kgFtY", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");
// FIXME: Replace with https://github.com/graphql/graphql-js/blob/master/src/type/scalars.js#L139
module.exports.specifiedScalarTypes = [
    $auu22.GraphQLString,
    $auu22.GraphQLInt,
    $auu22.GraphQLFloat,
    $auu22.GraphQLBoolean,
    $auu22.GraphQLID
];
function $ec157ad38f1a9f87$var$isSpecifiedScalarType(type) {
    return $lXoEQ.isNamedType(type) && // Would prefer to use specifiedScalarTypes.some(), however %checks needs
    // a simple expression.
    (type.name === $auu22.GraphQLString.name || type.name === $auu22.GraphQLInt.name || type.name === $auu22.GraphQLFloat.name || type.name === $auu22.GraphQLBoolean.name || type.name === $auu22.GraphQLID.name);
}
module.exports.default = $ec157ad38f1a9f87$var$isSpecifiedScalarType;

});

parcelRegister("j0Odg", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $dd74f7a1403eef9b$var$resolveFromParentTypename(parent, schema) {
    var parentTypename = parent['__typename'];
    if (!parentTypename) throw new Error('Did not fetch typename for object, unable to resolve interface.');
    var resolvedType = schema.getType(parentTypename);
    if (!(resolvedType instanceof $lXoEQ.GraphQLObjectType)) throw new Error('__typename did not match an object type: ' + parentTypename);
    return resolvedType;
}
module.exports.default = $dd74f7a1403eef9b$var$resolveFromParentTypename;

});

parcelRegister("8je8M", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZHaf = parcelRequire("kZHaf");

var $02KAV = parcelRequire("02KAV");

var $10LTa = parcelRequire("10LTa");

var $57Vxb = parcelRequire("57Vxb");
// Resolver that knows how to:
// a) handle aliases for proxied schemas
// b) handle errors from proxied schemas
var $60cb111eb226f1bd$var$defaultMergedResolver = function(parent, args, context, info) {
    if (!parent) return null;
    var responseKey = $57Vxb.getResponseKeyFromInfo(info);
    var errorResult = $10LTa.getErrorsFromParent(parent, responseKey);
    if (errorResult.kind === 'OWN') throw $02KAV.locatedError(new Error(errorResult.error.message), info.fieldNodes, $kZHaf.pathToArray(info.path));
    var result = parent[responseKey];
    if (result == null) result = parent[info.fieldName];
    // subscription result mapping
    if (!result && parent.data && parent.data[responseKey]) result = parent.data[responseKey];
    if (errorResult.errors) result = $10LTa.annotateWithChildrenErrors(result, errorResult.errors);
    return result;
};
module.exports.default = $60cb111eb226f1bd$var$defaultMergedResolver;

});
parcelRegister("10LTa", function(module, exports) {
var $0bcaf03a9acca47e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0bcaf03a9acca47e$var$__assign = module.exports && module.exports.__assign || function() {
    $0bcaf03a9acca47e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0bcaf03a9acca47e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZHaf = parcelRequire("kZHaf");

var $02KAV = parcelRequire("02KAV");

var $57Vxb = parcelRequire("57Vxb");
if (typeof $parcel$global !== 'undefined' && 'Symbol' in $parcel$global || typeof window !== 'undefined' && 'Symbol' in window) module.exports.ERROR_SYMBOL = Symbol('subSchemaErrors');
else module.exports.ERROR_SYMBOL = '@@__subSchemaErrors';
function $0bcaf03a9acca47e$var$annotateWithChildrenErrors(object, childrenErrors) {
    var _a;
    if (!childrenErrors || childrenErrors.length === 0) // Nothing to see here, move along
    return object;
    if (Array.isArray(object)) {
        var byIndex_1 = {};
        childrenErrors.forEach(function(error) {
            if (!error.path) return;
            var index = error.path[1];
            var current = byIndex_1[index] || [];
            current.push($0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, error), {
                path: error.path.slice(1)
            }));
            byIndex_1[index] = current;
        });
        return object.map(function(item, index) {
            return $0bcaf03a9acca47e$var$annotateWithChildrenErrors(item, byIndex_1[index]);
        });
    }
    return $0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, object), (_a = {}, _a[module.exports.ERROR_SYMBOL] = childrenErrors.map(function(error) {
        return $0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, error), error.path ? {
            path: error.path.slice(1)
        } : {});
    }), _a));
}
module.exports.annotateWithChildrenErrors = $0bcaf03a9acca47e$var$annotateWithChildrenErrors;
function $0bcaf03a9acca47e$var$getErrorsFromParent(object, fieldName) {
    var errors = object && object[module.exports.ERROR_SYMBOL] || [];
    var childrenErrors = [];
    for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
        var error = errors_1[_i];
        if (!error.path || error.path.length === 1 && error.path[0] === fieldName) return {
            kind: 'OWN',
            error: error
        };
        else if (error.path[0] === fieldName) childrenErrors.push(error);
    }
    return {
        kind: 'CHILDREN',
        errors: childrenErrors
    };
}
module.exports.getErrorsFromParent = $0bcaf03a9acca47e$var$getErrorsFromParent;
var $0bcaf03a9acca47e$var$CombinedError = /** @class */ function(_super) {
    $0bcaf03a9acca47e$var$__extends(CombinedError, _super);
    function CombinedError(message, errors) {
        var _this = _super.call(this, message) || this;
        _this.errors = errors;
        return _this;
    }
    return CombinedError;
}(Error);
function $0bcaf03a9acca47e$var$checkResultAndHandleErrors(result, info, responseKey) {
    if (!responseKey) responseKey = $57Vxb.getResponseKeyFromInfo(info);
    if (result.errors && (!result.data || result.data[responseKey] == null)) {
        // apollo-link-http & http-link-dataloader need the
        // result property to be passed through for better error handling.
        // If there is only one error, which contains a result property, pass the error through
        var newError = result.errors.length === 1 && $0bcaf03a9acca47e$var$hasResult(result.errors[0]) ? result.errors[0] : new $0bcaf03a9acca47e$var$CombinedError($0bcaf03a9acca47e$var$concatErrors(result.errors), result.errors);
        throw $02KAV.locatedError(newError, info.fieldNodes, $kZHaf.pathToArray(info.path));
    }
    var resultObject = result.data[responseKey];
    if (result.errors) resultObject = $0bcaf03a9acca47e$var$annotateWithChildrenErrors(resultObject, result.errors);
    return resultObject;
}
module.exports.checkResultAndHandleErrors = $0bcaf03a9acca47e$var$checkResultAndHandleErrors;
function $0bcaf03a9acca47e$var$concatErrors(errors) {
    return errors.map(function(error) {
        return error.message;
    }).join('\n');
}
function $0bcaf03a9acca47e$var$hasResult(error) {
    return error.result || error.extensions || error.originalError && error.originalError.result;
}

});
parcelRegister("57Vxb", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Get the key under which the result of this resolver will be placed in the response JSON. Basically, just
 * resolves aliases.
 * @param info The info argument to the resolver.
 */ function $3bba3c508f8a2a51$var$getResponseKeyFromInfo(info) {
    return info.fieldNodes[0].alias ? info.fieldNodes[0].alias.value : info.fieldName;
}
module.exports.getResponseKeyFromInfo = $3bba3c508f8a2a51$var$getResponseKeyFromInfo;

});







parcelRegister("lQXQV", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
// wraps all resolve functions of query, mutation or subscription fields
// with the provided function to simulate a root schema level resolve funciton
function $fe8ce1cef8f746df$var$addSchemaLevelResolveFunction(schema, fn) {
    // TODO test that schema is a schema, fn is a function
    var rootTypes = [
        schema.getQueryType(),
        schema.getMutationType(),
        schema.getSubscriptionType()
    ].filter(function(x) {
        return !!x;
    });
    rootTypes.forEach(function(type) {
        // XXX this should run at most once per request to simulate a true root resolver
        // for graphql-js this is an approximation that works with queries but not mutations
        var rootResolveFn = $fe8ce1cef8f746df$var$runAtMostOncePerRequest(fn);
        var fields = type.getFields();
        Object.keys(fields).forEach(function(fieldName) {
            // XXX if the type is a subscription, a same query AST will be ran multiple times so we
            // deactivate here the runOnce if it's a subscription. This may not be optimal though...
            if (type === schema.getSubscriptionType()) fields[fieldName].resolve = $fe8ce1cef8f746df$var$wrapResolver(fields[fieldName].resolve, fn);
            else fields[fieldName].resolve = $fe8ce1cef8f746df$var$wrapResolver(fields[fieldName].resolve, rootResolveFn);
        });
    });
}
// XXX badly named function. this doesn't really wrap, it just chains resolvers...
function $fe8ce1cef8f746df$var$wrapResolver(innerResolver, outerResolver) {
    return function(obj, args, ctx, info) {
        return Promise.resolve(outerResolver(obj, args, ctx, info)).then(function(root) {
            if (innerResolver) return innerResolver(root, args, ctx, info);
            return $3MP74.defaultFieldResolver(root, args, ctx, info);
        });
    };
}
// XXX this function only works for resolvers
// XXX very hacky way to remember if the function
// already ran for this request. This will only work
// if people don't actually cache the operation.
// if they do cache the operation, they will have to
// manually remove the __runAtMostOnce before every request.
function $fe8ce1cef8f746df$var$runAtMostOncePerRequest(fn) {
    var value;
    var randomNumber = Math.random();
    return function(root, args, ctx, info) {
        if (!info.operation['__runAtMostOnce']) info.operation['__runAtMostOnce'] = {};
        if (!info.operation['__runAtMostOnce'][randomNumber]) {
            info.operation['__runAtMostOnce'][randomNumber] = true;
            value = fn(root, args, ctx, info);
        }
        return value;
    };
}
module.exports.default = $fe8ce1cef8f746df$var$addSchemaLevelResolveFunction;

});

parcelRegister("7ZqjT", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $cYGSS = parcelRequire("cYGSS");
function $5d12a578553eba05$var$assertResolveFunctionsPresent(schema, resolverValidationOptions) {
    if (resolverValidationOptions === void 0) resolverValidationOptions = {};
    var _a = resolverValidationOptions.requireResolversForArgs, requireResolversForArgs = _a === void 0 ? false : _a, _b = resolverValidationOptions.requireResolversForNonScalar, requireResolversForNonScalar = _b === void 0 ? false : _b, _c = resolverValidationOptions.requireResolversForAllFields, requireResolversForAllFields = _c === void 0 ? false : _c;
    if (requireResolversForAllFields && (requireResolversForArgs || requireResolversForNonScalar)) throw new TypeError("requireResolversForAllFields takes precedence over the more specific assertions. Please configure either requireResolversForAllFields or requireResolversForArgs / requireResolversForNonScalar, but not a combination of them.");
    $cYGSS.forEachField(schema, function(field, typeName, fieldName) {
        // requires a resolve function for *every* field.
        if (requireResolversForAllFields) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
        // requires a resolve function on every field that has arguments
        if (requireResolversForArgs && field.args.length > 0) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
        // requires a resolve function on every field that returns a non-scalar type
        if (requireResolversForNonScalar && !($lXoEQ.getNamedType(field.type) instanceof $lXoEQ.GraphQLScalarType)) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
    });
}
function $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName) {
    if (!field.resolve) {
        console.warn(// tslint:disable-next-line: max-line-length
        "Resolve function missing for \"" + typeName + "." + fieldName + "\". To disable this warning check https://github.com/apollostack/graphql-tools/issues/131");
        return;
    }
    if (typeof field.resolve !== 'function') throw new $cYGSS.SchemaError("Resolver \"" + typeName + "." + fieldName + "\" must be a function");
}
module.exports.default = $5d12a578553eba05$var$assertResolveFunctionsPresent;

});

parcelRegister("glxQ5", function(module, exports) {
var $be68db39ae07a569$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $be68db39ae07a569$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $be68db39ae07a569$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");

var $gVW6u = parcelRequire("gVW6u");
function $be68db39ae07a569$var$attachDirectiveResolvers(schema, directiveResolvers) {
    if (typeof directiveResolvers !== 'object') throw new Error("Expected directiveResolvers to be of type object, got " + typeof directiveResolvers);
    if (Array.isArray(directiveResolvers)) throw new Error('Expected directiveResolvers to be of type object, got Array');
    var schemaDirectives = Object.create(null);
    Object.keys(directiveResolvers).forEach(function(directiveName) {
        schemaDirectives[directiveName] = /** @class */ function(_super) {
            $be68db39ae07a569$var$__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.visitFieldDefinition = function(field) {
                var _this = this;
                var resolver = directiveResolvers[directiveName];
                var originalResolver = field.resolve || $3MP74.defaultFieldResolver;
                var directiveArgs = this.args;
                field.resolve = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var source = args[0], context = args[2], info = args[3];
                    return resolver(function() {
                        return $be68db39ae07a569$var$__awaiter(_this, void 0, void 0, function() {
                            return $be68db39ae07a569$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    originalResolver.apply(field, args)
                                ];
                            });
                        });
                    }, source, directiveArgs, context, info);
                };
            };
            return class_1;
        }($gVW6u.SchemaDirectiveVisitor);
    });
    $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
}
module.exports.default = $be68db39ae07a569$var$attachDirectiveResolvers;

});

parcelRegister("4Vy0J", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6BdRO = parcelRequire("6BdRO");

var $ie50m = parcelRequire("ie50m");

var $cYGSS = parcelRequire("cYGSS");
// takes a GraphQL-JS schema and an object of connectors, then attaches
// the connectors to the context by wrapping each query or mutation resolve
// function with a function that attaches connectors if they don't exist.
// attaches connectors only once to make sure they are singletons
var $3966de2652c7f7e4$var$attachConnectorsToContext = $ie50m.deprecated({
    version: '0.7.0',
    url: 'https://github.com/apollostack/graphql-tools/issues/140'
}, function(schema, connectors) {
    if (!schema || !(schema instanceof $6BdRO.GraphQLSchema)) throw new Error("schema must be an instance of GraphQLSchema. This error could be caused by installing more than one version of GraphQL-JS");
    if (typeof connectors !== 'object') {
        var connectorType = typeof connectors;
        throw new Error("Expected connectors to be of type object, got " + connectorType);
    }
    if (Object.keys(connectors).length === 0) throw new Error('Expected connectors to not be an empty object');
    if (Array.isArray(connectors)) throw new Error('Expected connectors to be of type object, got Array');
    if (schema['_apolloConnectorsAttached']) throw new Error('Connectors already attached to context, cannot attach more than once');
    schema['_apolloConnectorsAttached'] = true;
    var attachconnectorFn = function(root, args, ctx) {
        if (typeof ctx !== 'object') {
            // if in any way possible, we should throw an error when the attachconnectors
            // function is called, not when a query is executed.
            var contextType = typeof ctx;
            throw new Error("Cannot attach connector because context is not an object: " + contextType);
        }
        if (typeof ctx.connectors === 'undefined') ctx.connectors = {};
        Object.keys(connectors).forEach(function(connectorName) {
            var connector = connectors[connectorName];
            if (!!connector.prototype) ctx.connectors[connectorName] = new connector(ctx);
            else throw new Error("Connector must be a function or an class");
        });
        return root;
    };
    $cYGSS.addSchemaLevelResolveFunction(schema, attachconnectorFn);
});
module.exports.default = $3966de2652c7f7e4$var$attachConnectorsToContext;

});
parcelRegister("ie50m", function(module, exports) {
/*
    Deprecated Decorator v0.1
    https://github.com/vilic/deprecated-decorator
*/ "use strict";
/** @internal */ module.exports.options = {
    getWarner: undefined
};
function $d44d6aab074f7c0d$var$createWarner(type, name, alternative, version, url) {
    var warnedPositions = {};
    return function() {
        var stack = new Error().stack || '';
        var at = (stack.match(/(?:\s+at\s.+){2}\s+at\s(.+)/) || [
            undefined,
            ''
        ])[1];
        if (/\)$/.test(at)) at = at.match(/[^(]+(?=\)$)/)[0];
        else at = at.trim();
        if (at in warnedPositions) return;
        warnedPositions[at] = true;
        var message;
        switch(type){
            case 'class':
                message = 'Class';
                break;
            case 'property':
                message = 'Property';
                break;
            case 'method':
                message = 'Method';
                break;
            case 'function':
                message = 'Function';
                break;
        }
        message += " `" + name + "` has been deprecated";
        if (version) message += " since version " + version;
        if (alternative) message += ", use `" + alternative + "` instead";
        message += '.';
        if (at) message += "\n    at " + at;
        if (url) message += "\nCheck out " + url + " for more information.";
        console.warn(message);
    };
}
function $d44d6aab074f7c0d$var$decorateProperty(type, name, descriptor, alternative, version, url) {
    var warner = (module.exports.options.getWarner || $d44d6aab074f7c0d$var$createWarner)(type, name, alternative, version, url);
    descriptor = descriptor || {
        writable: true,
        enumerable: false,
        configurable: true
    };
    var deprecatedDescriptor = {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable
    };
    if (descriptor.get || descriptor.set) {
        if (descriptor.get) deprecatedDescriptor.get = function() {
            warner();
            return descriptor.get.call(this);
        };
        if (descriptor.set) deprecatedDescriptor.set = function(value) {
            warner();
            return descriptor.set.call(this, value);
        };
    } else {
        var propertyValue_1 = descriptor.value;
        deprecatedDescriptor.get = function() {
            warner();
            return propertyValue_1;
        };
        if (descriptor.writable) deprecatedDescriptor.set = function(value) {
            warner();
            propertyValue_1 = value;
        };
    }
    return deprecatedDescriptor;
}
function $d44d6aab074f7c0d$var$decorateFunction(type, target, alternative, version, url) {
    var name = target.name;
    var warner = (module.exports.options.getWarner || $d44d6aab074f7c0d$var$createWarner)(type, name, alternative, version, url);
    var fn = function() {
        warner();
        return target.apply(this, arguments);
    };
    for(var _i = 0, _a = Object.getOwnPropertyNames(target); _i < _a.length; _i++){
        var propertyName = _a[_i];
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyName);
        if (descriptor.writable) fn[propertyName] = target[propertyName];
        else if (descriptor.configurable) Object.defineProperty(fn, propertyName, descriptor);
    }
    return fn;
}
function $d44d6aab074f7c0d$var$deprecated() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    var fn = args[args.length - 1];
    if (typeof fn === 'function') fn = args.pop();
    else fn = undefined;
    var options = args[0];
    var alternative;
    var version;
    var url;
    if (typeof options === 'string') {
        alternative = options;
        version = args[1];
        url = args[2];
    } else if (options) alternative = options.alternative, version = options.version, url = options.url, options;
    if (fn) return $d44d6aab074f7c0d$var$decorateFunction('function', fn, alternative, version, url);
    return function(target, name, descriptor) {
        if (typeof name === 'string') {
            var type = descriptor && typeof descriptor.value === 'function' ? 'method' : 'property';
            return $d44d6aab074f7c0d$var$decorateProperty(type, name, descriptor, alternative, version, url);
        } else if (typeof target === 'function') {
            var constructor = $d44d6aab074f7c0d$var$decorateFunction('class', target, alternative, version, url);
            var className = target.name;
            for(var _i = 0, _a = Object.getOwnPropertyNames(constructor); _i < _a.length; _i++){
                var propertyName = _a[_i];
                var descriptor_1 = Object.getOwnPropertyDescriptor(constructor, propertyName);
                descriptor_1 = $d44d6aab074f7c0d$var$decorateProperty('class', className, descriptor_1, alternative, version, url);
                if (descriptor_1.writable) constructor[propertyName] = target[propertyName];
                else if (descriptor_1.configurable) Object.defineProperty(constructor, propertyName, descriptor_1);
            }
            return constructor;
        }
    };
}
module.exports.deprecated = $d44d6aab074f7c0d$var$deprecated;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d44d6aab074f7c0d$var$deprecated;

});


parcelRegister("kYZ7H", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gUA8G = parcelRequire("gUA8G");
var $glHRe = parcelRequire("glHRe");
var $6ds0g = parcelRequire("6ds0g");

var $cYGSS = parcelRequire("cYGSS");

var $9Dtw4 = parcelRequire("9Dtw4");
function $f468d303274a5a69$var$buildSchemaFromTypeDefinitions(typeDefinitions, parseOptions) {
    // TODO: accept only array here, otherwise interfaces get confusing.
    var myDefinitions = typeDefinitions;
    var astDocument;
    if ($f468d303274a5a69$var$isDocumentNode(typeDefinitions)) astDocument = typeDefinitions;
    else if (typeof myDefinitions !== 'string') {
        if (!Array.isArray(myDefinitions)) {
            var type = typeof myDefinitions;
            throw new $cYGSS.SchemaError("typeDefs must be a string, array or schema AST, got " + type);
        }
        myDefinitions = $cYGSS.concatenateTypeDefs(myDefinitions);
    }
    if (typeof myDefinitions === 'string') astDocument = $6ds0g.parse(myDefinitions, parseOptions);
    var backcompatOptions = {
        commentDescriptions: true
    };
    var typesAst = $9Dtw4.default(astDocument);
    // TODO fix types https://github.com/apollographql/graphql-tools/issues/542
    var schema = $gUA8G.buildASTSchema(typesAst, backcompatOptions);
    var extensionsAst = $cYGSS.extractExtensionDefinitions(astDocument);
    if (extensionsAst.definitions.length > 0) // TODO fix types https://github.com/apollographql/graphql-tools/issues/542
    schema = $glHRe.extendSchema(schema, extensionsAst, backcompatOptions);
    return schema;
}
function $f468d303274a5a69$var$isDocumentNode(typeDefinitions) {
    return typeDefinitions.kind !== undefined;
}
module.exports.default = $f468d303274a5a69$var$buildSchemaFromTypeDefinitions;

});
parcelRegister("gUA8G", function(module, exports) {

$parcel$export(module.exports, "buildASTSchema", () => $7def873e387d0baa$export$25eeb85cb306d87);
$parcel$export(module.exports, "buildSchema", () => $7def873e387d0baa$export$f668ee82107a74bd);

var $fZdRY = parcelRequire("fZdRY");

var $1c4hI = parcelRequire("1c4hI");

var $6ds0g = parcelRequire("6ds0g");

var $dGflO = parcelRequire("dGflO");

var $6BdRO = parcelRequire("6BdRO");

var $bOniD = parcelRequire("bOniD");

var $glHRe = parcelRequire("glHRe");
function $7def873e387d0baa$export$25eeb85cb306d87(documentAST, options) {
    documentAST != null && documentAST.kind === (0, $1c4hI.Kind).DOCUMENT || (0, $fZdRY.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, $dGflO.assertValidSDL)(documentAST);
    var emptySchemaConfig = {
        description: undefined,
        types: [],
        directives: [],
        extensions: undefined,
        extensionASTNodes: [],
        assumeValid: false
    };
    var config = (0, $glHRe.extendSchemaImpl)(emptySchemaConfig, documentAST, options);
    if (config.astNode == null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
        var type = _config$types2[_i2];
        switch(type.name){
            // Note: While this could make early assertions to get the correctly
            // typed values below, that would throw immediately while type system
            // validation with validateSchema() will produce more actionable results.
            case 'Query':
                config.query = type;
                break;
            case 'Mutation':
                config.mutation = type;
                break;
            case 'Subscription':
                config.subscription = type;
                break;
        }
    }
    var directives = config.directives; // If specified directives were not explicitly declared, add them.
    var _loop = function _loop(_i4) {
        var stdDirective = (0, $bOniD.specifiedDirectives)[_i4];
        if (directives.every(function(directive) {
            return directive.name !== stdDirective.name;
        })) directives.push(stdDirective);
    };
    for(var _i4 = 0; _i4 < (0, $bOniD.specifiedDirectives).length; _i4++)_loop(_i4);
    return new (0, $6BdRO.GraphQLSchema)(config);
}
function $7def873e387d0baa$export$f668ee82107a74bd(source, options) {
    var document = (0, $6ds0g.parse)(source, {
        noLocation: options === null || options === void 0 ? void 0 : options.noLocation,
        allowLegacySDLEmptyFields: options === null || options === void 0 ? void 0 : options.allowLegacySDLEmptyFields,
        allowLegacySDLImplementsInterfaces: options === null || options === void 0 ? void 0 : options.allowLegacySDLImplementsInterfaces,
        experimentalFragmentVariables: options === null || options === void 0 ? void 0 : options.experimentalFragmentVariables
    });
    return $7def873e387d0baa$export$25eeb85cb306d87(document, {
        commentDescriptions: options === null || options === void 0 ? void 0 : options.commentDescriptions,
        assumeValidSDL: options === null || options === void 0 ? void 0 : options.assumeValidSDL,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    });
}

});
parcelRegister("6ds0g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d396d90054ce02d1$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $d396d90054ce02d1$export$5303528d1070ff6f);

var $l48s6 = parcelRequire("l48s6");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $7vqrl = parcelRequire("7vqrl");

var $5hGV7 = parcelRequire("5hGV7");

var $b5rqB = parcelRequire("b5rqB");
function $d396d90054ce02d1$export$98e6a39c04603d36(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d396d90054ce02d1$export$5303528d1070ff6f(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return value;
}
function $d396d90054ce02d1$export$28b8f402ccc88182(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return type;
}
var $d396d90054ce02d1$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $7vqrl.isSource)(source) ? source : new (0, $7vqrl.Source)(source);
        this._lexer = new (0, $b5rqB.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $hFu5F.TokenKind).NAME);
        return {
            kind: (0, $1c4hI.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).DOCUMENT,
            definitions: this.many((0, $hFu5F.TokenKind).SOF, this.parseDefinition, (0, $hFu5F.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $hFu5F.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $hFu5F.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $hFu5F.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).DOLLAR);
        return {
            kind: (0, $1c4hI.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).SELECTION_SET,
            selections: this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseSelection, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $hFu5F.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $1c4hI.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $hFu5F.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, item, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $hFu5F.TokenKind).NAME)) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $hFu5F.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $hFu5F.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $hFu5F.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).STRING:
            case (0, $hFu5F.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $hFu5F.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $1c4hI.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $1c4hI.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $hFu5F.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $1c4hI.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $hFu5F.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).LIST,
            values: this.any((0, $hFu5F.TokenKind).BRACKET_L, item, (0, $hFu5F.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: this.any((0, $hFu5F.TokenKind).BRACE_L, item, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $hFu5F.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).AT);
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $hFu5F.TokenKind).BRACKET_R);
            type = {
                kind: (0, $1c4hI.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BANG)) return {
            kind: (0, $1c4hI.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $hFu5F.TokenKind).STRING) || this.peek((0, $hFu5F.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $hFu5F.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $hFu5F.TokenKind).AMP) || this.peek((0, $hFu5F.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $hFu5F.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $hFu5F.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $hFu5F.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $hFu5F.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5hGV7.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $c8MIO.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d396d90054ce02d1$var$getTokenKindDesc(kind), ", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenDesc(token) {
    var value = token.value;
    return $d396d90054ce02d1$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenKindDesc(kind) {
    return (0, $b5rqB.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("l48s6", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $6cdd0c9c097dfc31$export$bbee0c6176c019d4);

var $9fgMZ = parcelRequire("9fgMZ");
function $6cdd0c9c097dfc31$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $9fgMZ.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});

parcelRegister("hFu5F", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $7350b511ab98151f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $7350b511ab98151f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("7vqrl", function(module, exports) {

$parcel$export(module.exports, "Source", () => $0269dc101dba4337$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $0269dc101dba4337$export$75135ee9ed6e435b);

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");
function $0269dc101dba4337$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0269dc101dba4337$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0269dc101dba4337$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0269dc101dba4337$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0269dc101dba4337$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fZdRY.default)(0, "Body must be a string. Received: ".concat((0, $biK02.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fZdRY.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fZdRY.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $0269dc101dba4337$var$_createClass(Source, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $0269dc101dba4337$export$75135ee9ed6e435b(source) {
    return (0, $aVhwC.default)(source, $0269dc101dba4337$export$1d2df86270c81ecb);
}

});

parcelRegister("b5rqB", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $a5d33b5906ae43cc$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $a5d33b5906ae43cc$export$59ac0f4da287406a);

var $l48s6 = parcelRequire("l48s6");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");
var $a5d33b5906ae43cc$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $hFu5F.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $a5d33b5906ae43cc$var$readToken(this, token);
        }while (token.kind === (0, $hFu5F.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $a5d33b5906ae43cc$export$59ac0f4da287406a(kind) {
    return kind === (0, $hFu5F.TokenKind).BANG || kind === (0, $hFu5F.TokenKind).DOLLAR || kind === (0, $hFu5F.TokenKind).AMP || kind === (0, $hFu5F.TokenKind).PAREN_L || kind === (0, $hFu5F.TokenKind).PAREN_R || kind === (0, $hFu5F.TokenKind).SPREAD || kind === (0, $hFu5F.TokenKind).COLON || kind === (0, $hFu5F.TokenKind).EQUALS || kind === (0, $hFu5F.TokenKind).AT || kind === (0, $hFu5F.TokenKind).BRACKET_L || kind === (0, $hFu5F.TokenKind).BRACKET_R || kind === (0, $hFu5F.TokenKind).BRACE_L || kind === (0, $hFu5F.TokenKind).PIPE || kind === (0, $hFu5F.TokenKind).BRACE_R;
}
function $a5d33b5906ae43cc$var$printCharCode(code) {
    return isNaN(code) ? (0, $hFu5F.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $a5d33b5906ae43cc$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $a5d33b5906ae43cc$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $a5d33b5906ae43cc$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $a5d33b5906ae43cc$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $a5d33b5906ae43cc$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $a5d33b5906ae43cc$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $l48s6.syntaxError)(source, pos, $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $a5d33b5906ae43cc$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $a5d33b5906ae43cc$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    } else {
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $a5d33b5906ae43cc$var$isNameStart(code)) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    return new (0, $c8MIO.Token)(isFloat ? (0, $hFu5F.TokenKind).FLOAT : (0, $hFu5F.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $a5d33b5906ae43cc$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $a5d33b5906ae43cc$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $a5d33b5906ae43cc$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $a5d33b5906ae43cc$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $flA0a.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $a5d33b5906ae43cc$var$uniCharCode(a, b, c, d) {
    return $a5d33b5906ae43cc$var$char2hex(a) << 12 | $a5d33b5906ae43cc$var$char2hex(b) << 8 | $a5d33b5906ae43cc$var$char2hex(c) << 4 | $a5d33b5906ae43cc$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $a5d33b5906ae43cc$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $a5d33b5906ae43cc$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $a5d33b5906ae43cc$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});


parcelRegister("dGflO", function(module, exports) {

$parcel$export(module.exports, "validate", () => $2cc2c5fa39eae947$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "assertValidSDL", () => $2cc2c5fa39eae947$export$e53e4d7168bd6d92);
$parcel$export(module.exports, "assertValidSDLExtension", () => $2cc2c5fa39eae947$export$9917845776f624a4);

var $fZdRY = parcelRequire("fZdRY");

var $9fgMZ = parcelRequire("9fgMZ");

var $961BR = parcelRequire("961BR");

var $izaFt = parcelRequire("izaFt");

var $hMOry = parcelRequire("hMOry");

var $k6EZ2 = parcelRequire("k6EZ2");

var $5RV6E = parcelRequire("5RV6E");
function $2cc2c5fa39eae947$export$a22775fa5e2eebd9(schema, documentAST) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $k6EZ2.specifiedRules);
    var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new (0, $hMOry.TypeInfo)(schema);
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        maxErrors: undefined
    };
    documentAST || (0, $fZdRY.default)(0, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.
    (0, $izaFt.assertValidSchema)(schema);
    var abortObj = Object.freeze({});
    var errors = [];
    var context = new (0, $5RV6E.ValidationContext)(schema, documentAST, typeInfo, function(error) {
        if (options.maxErrors != null && errors.length >= options.maxErrors) {
            errors.push(new (0, $9fgMZ.GraphQLError)('Too many validation errors, error limit reached. Validation aborted.'));
            throw abortObj;
        }
        errors.push(error);
    }); // This uses a specialized visitor which runs multiple visitors in parallel,
    // while maintaining the visitor skip and break API.
    var visitor = (0, $961BR.visitInParallel)(rules.map(function(rule) {
        return rule(context);
    })); // Visit the whole document with each instance of all provided rules.
    try {
        (0, $961BR.visit)(documentAST, (0, $hMOry.visitWithTypeInfo)(typeInfo, visitor));
    } catch (e) {
        if (e !== abortObj) throw e;
    }
    return errors;
}
function $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST, schemaToExtend) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $k6EZ2.specifiedSDLRules);
    var errors = [];
    var context = new (0, $5RV6E.SDLValidationContext)(documentAST, schemaToExtend, function(error) {
        errors.push(error);
    });
    var visitors = rules.map(function(rule) {
        return rule(context);
    });
    (0, $961BR.visit)(documentAST, (0, $961BR.visitInParallel)(visitors));
    return errors;
}
function $2cc2c5fa39eae947$export$e53e4d7168bd6d92(documentAST) {
    var errors = $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
function $2cc2c5fa39eae947$export$9917845776f624a4(documentAST, schema) {
    var errors = $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST, schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}

});
parcelRegister("hMOry", function(module, exports) {

$parcel$export(module.exports, "TypeInfo", () => $3a9a642677abfb9d$export$f0c1fe746ce4bb1e);
$parcel$export(module.exports, "visitWithTypeInfo", () => $3a9a642677abfb9d$export$18ca434620348336);

var $bmIpK = parcelRequire("bmIpK");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $961BR = parcelRequire("961BR");

var $lXoEQ = parcelRequire("lXoEQ");

var $h2iUh = parcelRequire("h2iUh");

var $3zSAT = parcelRequire("3zSAT");
var $3a9a642677abfb9d$export$f0c1fe746ce4bb1e = /*#__PURE__*/ function() {
    function TypeInfo(schema, // to support non-spec-compliant code bases. You should never need to use it.
    // It may disappear in the future.
    getFieldDefFn, // beginning somewhere other than documents.
    initialType) {
        this._schema = schema;
        this._typeStack = [];
        this._parentTypeStack = [];
        this._inputTypeStack = [];
        this._fieldDefStack = [];
        this._defaultValueStack = [];
        this._directive = null;
        this._argument = null;
        this._enumValue = null;
        this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : $3a9a642677abfb9d$var$getFieldDef;
        if (initialType) {
            if ((0, $lXoEQ.isInputType)(initialType)) this._inputTypeStack.push(initialType);
            if ((0, $lXoEQ.isCompositeType)(initialType)) this._parentTypeStack.push(initialType);
            if ((0, $lXoEQ.isOutputType)(initialType)) this._typeStack.push(initialType);
        }
    }
    var _proto = TypeInfo.prototype;
    _proto.getType = function getType() {
        if (this._typeStack.length > 0) return this._typeStack[this._typeStack.length - 1];
    };
    _proto.getParentType = function getParentType() {
        if (this._parentTypeStack.length > 0) return this._parentTypeStack[this._parentTypeStack.length - 1];
    };
    _proto.getInputType = function getInputType() {
        if (this._inputTypeStack.length > 0) return this._inputTypeStack[this._inputTypeStack.length - 1];
    };
    _proto.getParentInputType = function getParentInputType() {
        if (this._inputTypeStack.length > 1) return this._inputTypeStack[this._inputTypeStack.length - 2];
    };
    _proto.getFieldDef = function getFieldDef() {
        if (this._fieldDefStack.length > 0) return this._fieldDefStack[this._fieldDefStack.length - 1];
    };
    _proto.getDefaultValue = function getDefaultValue() {
        if (this._defaultValueStack.length > 0) return this._defaultValueStack[this._defaultValueStack.length - 1];
    };
    _proto.getDirective = function getDirective() {
        return this._directive;
    };
    _proto.getArgument = function getArgument() {
        return this._argument;
    };
    _proto.getEnumValue = function getEnumValue() {
        return this._enumValue;
    };
    _proto.enter = function enter(node) {
        var schema = this._schema; // Note: many of the types below are explicitly typed as "mixed" to drop
        // any assumptions of a valid schema to ensure runtime types are properly
        // checked before continuing since TypeInfo is used as part of validation
        // which occurs before guarantees of schema and document validity.
        switch(node.kind){
            case (0, $1c4hI.Kind).SELECTION_SET:
                var namedType = (0, $lXoEQ.getNamedType)(this.getType());
                this._parentTypeStack.push((0, $lXoEQ.isCompositeType)(namedType) ? namedType : undefined);
                break;
            case (0, $1c4hI.Kind).FIELD:
                var parentType = this.getParentType();
                var fieldDef;
                var fieldType;
                if (parentType) {
                    fieldDef = this._getFieldDef(schema, parentType, node);
                    if (fieldDef) fieldType = fieldDef.type;
                }
                this._fieldDefStack.push(fieldDef);
                this._typeStack.push((0, $lXoEQ.isOutputType)(fieldType) ? fieldType : undefined);
                break;
            case (0, $1c4hI.Kind).DIRECTIVE:
                this._directive = schema.getDirective(node.name.value);
                break;
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
                var type;
                switch(node.operation){
                    case 'query':
                        type = schema.getQueryType();
                        break;
                    case 'mutation':
                        type = schema.getMutationType();
                        break;
                    case 'subscription':
                        type = schema.getSubscriptionType();
                        break;
                }
                this._typeStack.push((0, $lXoEQ.isObjectType)(type) ? type : undefined);
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                var typeConditionAST = node.typeCondition;
                var outputType = typeConditionAST ? (0, $3zSAT.typeFromAST)(schema, typeConditionAST) : (0, $lXoEQ.getNamedType)(this.getType());
                this._typeStack.push((0, $lXoEQ.isOutputType)(outputType) ? outputType : undefined);
                break;
            case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
                var inputType = (0, $3zSAT.typeFromAST)(schema, node.type);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(inputType) ? inputType : undefined);
                break;
            case (0, $1c4hI.Kind).ARGUMENT:
                var _this$getDirective;
                var argDef;
                var argType;
                var fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();
                if (fieldOrDirective) {
                    argDef = (0, $bmIpK.default)(fieldOrDirective.args, function(arg) {
                        return arg.name === node.name.value;
                    });
                    if (argDef) argType = argDef.type;
                }
                this._argument = argDef;
                this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(argType) ? argType : undefined);
                break;
            case (0, $1c4hI.Kind).LIST:
                var listType = (0, $lXoEQ.getNullableType)(this.getInputType());
                var itemType = (0, $lXoEQ.isListType)(listType) ? listType.ofType : listType; // List positions never have a default value.
                this._defaultValueStack.push(undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(itemType) ? itemType : undefined);
                break;
            case (0, $1c4hI.Kind).OBJECT_FIELD:
                var objectType = (0, $lXoEQ.getNamedType)(this.getInputType());
                var inputFieldType;
                var inputField;
                if ((0, $lXoEQ.isInputObjectType)(objectType)) {
                    inputField = objectType.getFields()[node.name.value];
                    if (inputField) inputFieldType = inputField.type;
                }
                this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(inputFieldType) ? inputFieldType : undefined);
                break;
            case (0, $1c4hI.Kind).ENUM:
                var enumType = (0, $lXoEQ.getNamedType)(this.getInputType());
                var enumValue;
                if ((0, $lXoEQ.isEnumType)(enumType)) enumValue = enumType.getValue(node.value);
                this._enumValue = enumValue;
                break;
        }
    };
    _proto.leave = function leave(node) {
        switch(node.kind){
            case (0, $1c4hI.Kind).SELECTION_SET:
                this._parentTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).FIELD:
                this._fieldDefStack.pop();
                this._typeStack.pop();
                break;
            case (0, $1c4hI.Kind).DIRECTIVE:
                this._directive = null;
                break;
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                this._typeStack.pop();
                break;
            case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).ARGUMENT:
                this._argument = null;
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).LIST:
            case (0, $1c4hI.Kind).OBJECT_FIELD:
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).ENUM:
                this._enumValue = null;
                break;
        }
    };
    return TypeInfo;
}();
/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */ function $3a9a642677abfb9d$var$getFieldDef(schema, parentType, fieldNode) {
    var name = fieldNode.name.value;
    if (name === (0, $h2iUh.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.SchemaMetaFieldDef;
    if (name === (0, $h2iUh.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.TypeMetaFieldDef;
    if (name === (0, $h2iUh.TypeNameMetaFieldDef).name && (0, $lXoEQ.isCompositeType)(parentType)) return 0, $h2iUh.TypeNameMetaFieldDef;
    if ((0, $lXoEQ.isObjectType)(parentType) || (0, $lXoEQ.isInterfaceType)(parentType)) return parentType.getFields()[name];
}
function $3a9a642677abfb9d$export$18ca434620348336(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = (0, $961BR.getVisitFn)(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ((0, $c8MIO.isNode)(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = (0, $961BR.getVisitFn)(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}

});

parcelRegister("k6EZ2", function(module, exports) {

$parcel$export(module.exports, "specifiedRules", () => $1607320a9964483f$export$ac8e8f03d4e8a76c);
$parcel$export(module.exports, "specifiedSDLRules", () => $1607320a9964483f$export$117d63808a280985);
// Spec Section: "Executable Definitions"

var $aqW0R = parcelRequire("aqW0R");

var $2GDYp = parcelRequire("2GDYp");

var $O3j40 = parcelRequire("O3j40");

var $ldBEm = parcelRequire("ldBEm");

var $6e5RT = parcelRequire("6e5RT");

var $czW5Z = parcelRequire("czW5Z");

var $3Rll6 = parcelRequire("3Rll6");

var $d8bud = parcelRequire("d8bud");

var $hRE8v = parcelRequire("hRE8v");

var $alcPf = parcelRequire("alcPf");

var $50e65 = parcelRequire("50e65");

var $lajJ7 = parcelRequire("lajJ7");

var $rkd39 = parcelRequire("rkd39");

var $bRsXY = parcelRequire("bRsXY");

var $b6uMB = parcelRequire("b6uMB");

var $8zYa7 = parcelRequire("8zYa7");

var $5k1Qg = parcelRequire("5k1Qg");

var $loWoH = parcelRequire("loWoH");

var $is7or = parcelRequire("is7or");

var $gGl3W = parcelRequire("gGl3W");

var $kXrJO = parcelRequire("kXrJO");

var $bhI3j = parcelRequire("bhI3j");

var $bN26g = parcelRequire("bN26g");

var $gnP1U = parcelRequire("gnP1U");

var $h0Hyz = parcelRequire("h0Hyz");

var $1W7Gt = parcelRequire("1W7Gt");

var $gawpj = parcelRequire("gawpj");

var $b8axV = parcelRequire("b8axV");

var $lOmVT = parcelRequire("lOmVT");

var $1H4NC = parcelRequire("1H4NC");

var $lVZ4j = parcelRequire("lVZ4j");

var $jCJ2v = parcelRequire("jCJ2v");

var $kJWSQ = parcelRequire("kJWSQ");
var $1607320a9964483f$export$ac8e8f03d4e8a76c = Object.freeze([
    (0, $aqW0R.ExecutableDefinitionsRule),
    (0, $2GDYp.UniqueOperationNamesRule),
    (0, $O3j40.LoneAnonymousOperationRule),
    (0, $ldBEm.SingleFieldSubscriptionsRule),
    (0, $6e5RT.KnownTypeNamesRule),
    (0, $czW5Z.FragmentsOnCompositeTypesRule),
    (0, $3Rll6.VariablesAreInputTypesRule),
    (0, $d8bud.ScalarLeafsRule),
    (0, $hRE8v.FieldsOnCorrectTypeRule),
    (0, $alcPf.UniqueFragmentNamesRule),
    (0, $50e65.KnownFragmentNamesRule),
    (0, $lajJ7.NoUnusedFragmentsRule),
    (0, $rkd39.PossibleFragmentSpreadsRule),
    (0, $bRsXY.NoFragmentCyclesRule),
    (0, $b6uMB.UniqueVariableNamesRule),
    (0, $8zYa7.NoUndefinedVariablesRule),
    (0, $5k1Qg.NoUnusedVariablesRule),
    (0, $loWoH.KnownDirectivesRule),
    (0, $is7or.UniqueDirectivesPerLocationRule),
    (0, $gGl3W.KnownArgumentNamesRule),
    (0, $kXrJO.UniqueArgumentNamesRule),
    (0, $bhI3j.ValuesOfCorrectTypeRule),
    (0, $bN26g.ProvidedRequiredArgumentsRule),
    (0, $gnP1U.VariablesInAllowedPositionRule),
    (0, $h0Hyz.OverlappingFieldsCanBeMergedRule),
    (0, $1W7Gt.UniqueInputFieldNamesRule)
]);
var $1607320a9964483f$export$117d63808a280985 = Object.freeze([
    (0, $gawpj.LoneSchemaDefinitionRule),
    (0, $b8axV.UniqueOperationTypesRule),
    (0, $lOmVT.UniqueTypeNamesRule),
    (0, $1H4NC.UniqueEnumValueNamesRule),
    (0, $lVZ4j.UniqueFieldDefinitionNamesRule),
    (0, $jCJ2v.UniqueDirectiveNamesRule),
    (0, $6e5RT.KnownTypeNamesRule),
    (0, $loWoH.KnownDirectivesRule),
    (0, $is7or.UniqueDirectivesPerLocationRule),
    (0, $kJWSQ.PossibleTypeExtensionsRule),
    (0, $gGl3W.KnownArgumentNamesOnDirectivesRule),
    (0, $kXrJO.UniqueArgumentNamesRule),
    (0, $1W7Gt.UniqueInputFieldNamesRule),
    (0, $bN26g.ProvidedRequiredArgumentsOnDirectivesRule)
]);

});
parcelRegister("aqW0R", function(module, exports) {

$parcel$export(module.exports, "ExecutableDefinitionsRule", () => $3f76dad52af02d86$export$c3d3637a3c3c605e);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");
function $3f76dad52af02d86$export$c3d3637a3c3c605e(context) {
    return {
        Document: function Document(node) {
            for(var _i2 = 0, _node$definitions2 = node.definitions; _i2 < _node$definitions2.length; _i2++){
                var definition = _node$definitions2[_i2];
                if (!(0, $9nArG.isExecutableDefinitionNode)(definition)) {
                    var defName = definition.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || definition.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION ? 'schema' : '"' + definition.name.value + '"';
                    context.reportError(new (0, $9fgMZ.GraphQLError)("The ".concat(defName, " definition is not executable."), definition));
                }
            }
            return false;
        }
    };
}

});
parcelRegister("9nArG", function(module, exports) {

$parcel$export(module.exports, "isExecutableDefinitionNode", () => $6727414c23a41723$export$4cedd8740794bd78);
$parcel$export(module.exports, "isTypeSystemDefinitionNode", () => $6727414c23a41723$export$b05c7141ec7770ba);
$parcel$export(module.exports, "isTypeSystemExtensionNode", () => $6727414c23a41723$export$fbc18e88163d676d);
$parcel$export(module.exports, "isTypeDefinitionNode", () => $6727414c23a41723$export$a3584bba04f5bfe0);
$parcel$export(module.exports, "isTypeExtensionNode", () => $6727414c23a41723$export$d7907721b241e11f);

var $1c4hI = parcelRequire("1c4hI");
function $6727414c23a41723$export$e7ecd7c16613ccfd(node) {
    return $6727414c23a41723$export$4cedd8740794bd78(node) || $6727414c23a41723$export$b05c7141ec7770ba(node) || $6727414c23a41723$export$fbc18e88163d676d(node);
}
function $6727414c23a41723$export$4cedd8740794bd78(node) {
    return node.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION || node.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION;
}
function $6727414c23a41723$export$65772b71e1d017ba(node) {
    return node.kind === (0, $1c4hI.Kind).FIELD || node.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD || node.kind === (0, $1c4hI.Kind).INLINE_FRAGMENT;
}
function $6727414c23a41723$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $1c4hI.Kind).VARIABLE || node.kind === (0, $1c4hI.Kind).INT || node.kind === (0, $1c4hI.Kind).FLOAT || node.kind === (0, $1c4hI.Kind).STRING || node.kind === (0, $1c4hI.Kind).BOOLEAN || node.kind === (0, $1c4hI.Kind).NULL || node.kind === (0, $1c4hI.Kind).ENUM || node.kind === (0, $1c4hI.Kind).LIST || node.kind === (0, $1c4hI.Kind).OBJECT;
}
function $6727414c23a41723$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $1c4hI.Kind).NAMED_TYPE || node.kind === (0, $1c4hI.Kind).LIST_TYPE || node.kind === (0, $1c4hI.Kind).NON_NULL_TYPE;
}
function $6727414c23a41723$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || $6727414c23a41723$export$a3584bba04f5bfe0(node) || node.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION;
}
function $6727414c23a41723$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $6727414c23a41723$export$fbc18e88163d676d(node) {
    return node.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION || $6727414c23a41723$export$d7907721b241e11f(node);
}
function $6727414c23a41723$export$d7907721b241e11f(node) {
    return node.kind === (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("2GDYp", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationNamesRule", () => $88c36e73ececd949$export$a40a702cd7ad2eae);

var $9fgMZ = parcelRequire("9fgMZ");
function $88c36e73ececd949$export$a40a702cd7ad2eae(context) {
    var knownOperationNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition(node) {
            var operationName = node.name;
            if (operationName) {
                if (knownOperationNames[operationName.value]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one operation named \"".concat(operationName.value, "\"."), [
                    knownOperationNames[operationName.value],
                    operationName
                ]));
                else knownOperationNames[operationName.value] = operationName;
            }
            return false;
        },
        FragmentDefinition: function FragmentDefinition() {
            return false;
        }
    };
}

});

parcelRegister("O3j40", function(module, exports) {

$parcel$export(module.exports, "LoneAnonymousOperationRule", () => $6e91d6c02aeb4125$export$3a79c63c3de7a55f);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");
function $6e91d6c02aeb4125$export$3a79c63c3de7a55f(context) {
    var operationCount = 0;
    return {
        Document: function Document(node) {
            operationCount = node.definitions.filter(function(definition) {
                return definition.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION;
            }).length;
        },
        OperationDefinition: function OperationDefinition(node) {
            if (!node.name && operationCount > 1) context.reportError(new (0, $9fgMZ.GraphQLError)('This anonymous operation must be the only defined operation.', node));
        }
    };
}

});

parcelRegister("ldBEm", function(module, exports) {

$parcel$export(module.exports, "SingleFieldSubscriptionsRule", () => $870ac591d38eb8ac$export$477fa0c787c0222d);

var $9fgMZ = parcelRequire("9fgMZ");
function $870ac591d38eb8ac$export$477fa0c787c0222d(context) {
    return {
        OperationDefinition: function OperationDefinition(node) {
            if (node.operation === 'subscription') {
                if (node.selectionSet.selections.length !== 1) context.reportError(new (0, $9fgMZ.GraphQLError)(node.name ? "Subscription \"".concat(node.name.value, "\" must select only one top level field.") : 'Anonymous Subscription must select only one top level field.', node.selectionSet.selections.slice(1)));
            }
        }
    };
}

});

parcelRegister("6e5RT", function(module, exports) {

$parcel$export(module.exports, "KnownTypeNamesRule", () => $30acddca3c136894$export$2317edbae2efecbd);

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $9nArG = parcelRequire("9nArG");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");
function $30acddca3c136894$export$2317edbae2efecbd(context) {
    var schema = context.getSchema();
    var existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, $9nArG.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = true;
    }
    var typeNames = Object.keys(existingTypesMap).concat(Object.keys(definedTypes));
    return {
        NamedType: function NamedType(node, _1, parent, _2, ancestors) {
            var typeName = node.name.value;
            if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
                var _ancestors$;
                var definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
                var isSDL = definitionNode != null && $30acddca3c136894$var$isSDLNode(definitionNode);
                if (isSDL && $30acddca3c136894$var$isStandardTypeName(typeName)) return;
                var suggestedTypes = (0, $bru1k.default)(typeName, isSDL ? $30acddca3c136894$var$standardTypeNames.concat(typeNames) : typeNames);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown type \"".concat(typeName, "\".") + (0, $8nBnZ.default)(suggestedTypes), node));
            }
        }
    };
}
var $30acddca3c136894$var$standardTypeNames = [].concat((0, $auu22.specifiedScalarTypes), (0, $h2iUh.introspectionTypes)).map(function(type) {
    return type.name;
});
function $30acddca3c136894$var$isStandardTypeName(typeName) {
    return $30acddca3c136894$var$standardTypeNames.indexOf(typeName) !== -1;
}
function $30acddca3c136894$var$isSDLNode(value) {
    return !Array.isArray(value) && ((0, $9nArG.isTypeSystemDefinitionNode)(value) || (0, $9nArG.isTypeSystemExtensionNode)(value));
}

});

parcelRegister("czW5Z", function(module, exports) {

$parcel$export(module.exports, "FragmentsOnCompositeTypesRule", () => $f80cba82208a6444$export$cb5241ba71fd55e0);

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $f80cba82208a6444$export$cb5241ba71fd55e0(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var typeCondition = node.typeCondition;
            if (typeCondition) {
                var type = (0, $3zSAT.typeFromAST)(context.getSchema(), typeCondition);
                if (type && !(0, $lXoEQ.isCompositeType)(type)) {
                    var typeStr = (0, $aKlnM.print)(typeCondition);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment cannot condition on non composite type \"".concat(typeStr, "\"."), typeCondition));
                }
            }
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var type = (0, $3zSAT.typeFromAST)(context.getSchema(), node.typeCondition);
            if (type && !(0, $lXoEQ.isCompositeType)(type)) {
                var typeStr = (0, $aKlnM.print)(node.typeCondition);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(node.name.value, "\" cannot condition on non composite type \"").concat(typeStr, "\"."), node.typeCondition));
            }
        }
    };
}

});

parcelRegister("3Rll6", function(module, exports) {

$parcel$export(module.exports, "VariablesAreInputTypesRule", () => $ab1cf3b33f18ed8d$export$f20a29632b437591);

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $ab1cf3b33f18ed8d$export$f20a29632b437591(context) {
    return {
        VariableDefinition: function VariableDefinition(node) {
            var type = (0, $3zSAT.typeFromAST)(context.getSchema(), node.type);
            if (type && !(0, $lXoEQ.isInputType)(type)) {
                var variableName = node.variable.name.value;
                var typeName = (0, $aKlnM.print)(node.type);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\"."), node.type));
            }
        }
    };
}

});

parcelRegister("d8bud", function(module, exports) {

$parcel$export(module.exports, "ScalarLeafsRule", () => $df259c4803cc1d81$export$d779f66f65c88b9a);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $df259c4803cc1d81$export$d779f66f65c88b9a(context) {
    return {
        Field: function Field(node) {
            var type = context.getType();
            var selectionSet = node.selectionSet;
            if (type) {
                if ((0, $lXoEQ.isLeafType)((0, $lXoEQ.getNamedType)(type))) {
                    if (selectionSet) {
                        var fieldName = node.name.value;
                        var typeStr = (0, $biK02.default)(type);
                        context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldName, "\" must not have a selection since type \"").concat(typeStr, "\" has no subfields."), selectionSet));
                    }
                } else if (!selectionSet) {
                    var _fieldName = node.name.value;
                    var _typeStr = (0, $biK02.default)(type);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(_fieldName, "\" of type \"").concat(_typeStr, "\" must have a selection of subfields. Did you mean \"").concat(_fieldName, " { ... }\"?"), node));
                }
            }
        }
    };
}

});

parcelRegister("hRE8v", function(module, exports) {

$parcel$export(module.exports, "FieldsOnCorrectTypeRule", () => $ab2475b39bd43e66$export$595e5c0bf2d10a85);

var $96Cqc = parcelRequire("96Cqc");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $daK4l = parcelRequire("daK4l");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $ab2475b39bd43e66$export$595e5c0bf2d10a85(context) {
    return {
        Field: function Field(node) {
            var type = context.getParentType();
            if (type) {
                var fieldDef = context.getFieldDef();
                if (!fieldDef) {
                    // This field doesn't exist, lets look for suggestions.
                    var schema = context.getSchema();
                    var fieldName = node.name.value; // First determine if there are any suggested types to condition on.
                    var suggestion = (0, $8nBnZ.default)('to use an inline fragment on', $ab2475b39bd43e66$var$getSuggestedTypeNames(schema, type, fieldName)); // If there are no suggested types, then perhaps this was a typo?
                    if (suggestion === '') suggestion = (0, $8nBnZ.default)($ab2475b39bd43e66$var$getSuggestedFieldNames(type, fieldName));
                     // Report an error, including helpful suggestions.
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot query field \"".concat(fieldName, "\" on type \"").concat(type.name, "\".") + suggestion, node));
                }
            }
        }
    };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */ function $ab2475b39bd43e66$var$getSuggestedTypeNames(schema, type, fieldName) {
    if (!(0, $lXoEQ.isAbstractType)(type)) // Must be an Object type, which does not have possible fields.
    return [];
    var suggestedTypes = new Set();
    var usageCount = Object.create(null);
    for(var _i2 = 0, _schema$getPossibleTy2 = schema.getPossibleTypes(type); _i2 < _schema$getPossibleTy2.length; _i2++){
        var possibleType = _schema$getPossibleTy2[_i2];
        if (!possibleType.getFields()[fieldName]) continue;
         // This object type defines this field.
        suggestedTypes.add(possibleType);
        usageCount[possibleType.name] = 1;
        for(var _i4 = 0, _possibleType$getInte2 = possibleType.getInterfaces(); _i4 < _possibleType$getInte2.length; _i4++){
            var _usageCount$possibleI;
            var possibleInterface = _possibleType$getInte2[_i4];
            if (!possibleInterface.getFields()[fieldName]) continue;
             // This interface type defines this field.
            suggestedTypes.add(possibleInterface);
            usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
        }
    }
    return (0, $96Cqc.default)(suggestedTypes).sort(function(typeA, typeB) {
        // Suggest both interface and object types based on how common they are.
        var usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];
        if (usageCountDiff !== 0) return usageCountDiff;
         // Suggest super types first followed by subtypes
        if ((0, $lXoEQ.isInterfaceType)(typeA) && schema.isSubType(typeA, typeB)) return -1;
        if ((0, $lXoEQ.isInterfaceType)(typeB) && schema.isSubType(typeB, typeA)) return 1;
        return (0, $daK4l.default)(typeA.name, typeB.name);
    }).map(function(x) {
        return x.name;
    });
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */ function $ab2475b39bd43e66$var$getSuggestedFieldNames(type, fieldName) {
    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) {
        var possibleFieldNames = Object.keys(type.getFields());
        return (0, $bru1k.default)(fieldName, possibleFieldNames);
    } // Otherwise, must be a Union type, which does not define fields.
    return [];
}

});

parcelRegister("alcPf", function(module, exports) {

$parcel$export(module.exports, "UniqueFragmentNamesRule", () => $2a7b73aaa0b2b3c4$export$a920e0f1967f4b0a);

var $9fgMZ = parcelRequire("9fgMZ");
function $2a7b73aaa0b2b3c4$export$a920e0f1967f4b0a(context) {
    var knownFragmentNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var fragmentName = node.name.value;
            if (knownFragmentNames[fragmentName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one fragment named \"".concat(fragmentName, "\"."), [
                knownFragmentNames[fragmentName],
                node.name
            ]));
            else knownFragmentNames[fragmentName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("50e65", function(module, exports) {

$parcel$export(module.exports, "KnownFragmentNamesRule", () => $9260c47151c2fbfb$export$94c8dd81fb6d3111);

var $9fgMZ = parcelRequire("9fgMZ");
function $9260c47151c2fbfb$export$94c8dd81fb6d3111(context) {
    return {
        FragmentSpread: function FragmentSpread(node) {
            var fragmentName = node.name.value;
            var fragment = context.getFragment(fragmentName);
            if (!fragment) context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown fragment \"".concat(fragmentName, "\"."), node.name));
        }
    };
}

});

parcelRegister("lajJ7", function(module, exports) {

$parcel$export(module.exports, "NoUnusedFragmentsRule", () => $7e58a6a99152422b$export$d29d2e5ed74717af);

var $9fgMZ = parcelRequire("9fgMZ");
function $7e58a6a99152422b$export$d29d2e5ed74717af(context) {
    var operationDefs = [];
    var fragmentDefs = [];
    return {
        OperationDefinition: function OperationDefinition(node) {
            operationDefs.push(node);
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            fragmentDefs.push(node);
            return false;
        },
        Document: {
            leave: function leave() {
                var fragmentNameUsed = Object.create(null);
                for(var _i2 = 0; _i2 < operationDefs.length; _i2++){
                    var operation = operationDefs[_i2];
                    for(var _i4 = 0, _context$getRecursive2 = context.getRecursivelyReferencedFragments(operation); _i4 < _context$getRecursive2.length; _i4++){
                        var fragment = _context$getRecursive2[_i4];
                        fragmentNameUsed[fragment.name.value] = true;
                    }
                }
                for(var _i6 = 0; _i6 < fragmentDefs.length; _i6++){
                    var fragmentDef = fragmentDefs[_i6];
                    var fragName = fragmentDef.name.value;
                    if (fragmentNameUsed[fragName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(fragName, "\" is never used."), fragmentDef));
                }
            }
        }
    };
}

});

parcelRegister("rkd39", function(module, exports) {

$parcel$export(module.exports, "PossibleFragmentSpreadsRule", () => $3ff113974e6929b5$export$aa7b39ab48da3359);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $f5cpS = parcelRequire("f5cpS");
function $3ff113974e6929b5$export$aa7b39ab48da3359(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var fragType = context.getType();
            var parentType = context.getParentType();
            if ((0, $lXoEQ.isCompositeType)(fragType) && (0, $lXoEQ.isCompositeType)(parentType) && !(0, $f5cpS.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, $biK02.default)(parentType);
                var fragTypeStr = (0, $biK02.default)(fragType);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment cannot be spread here as objects of type \"".concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        },
        FragmentSpread: function FragmentSpread(node) {
            var fragName = node.name.value;
            var fragType = $3ff113974e6929b5$var$getFragmentType(context, fragName);
            var parentType = context.getParentType();
            if (fragType && parentType && !(0, $f5cpS.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, $biK02.default)(parentType);
                var fragTypeStr = (0, $biK02.default)(fragType);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(fragName, "\" cannot be spread here as objects of type \"").concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        }
    };
}
function $3ff113974e6929b5$var$getFragmentType(context, name) {
    var frag = context.getFragment(name);
    if (frag) {
        var type = (0, $3zSAT.typeFromAST)(context.getSchema(), frag.typeCondition);
        if ((0, $lXoEQ.isCompositeType)(type)) return type;
    }
}

});

parcelRegister("bRsXY", function(module, exports) {

$parcel$export(module.exports, "NoFragmentCyclesRule", () => $a757a6928f091056$export$25eccb87f5a000e6);

var $9fgMZ = parcelRequire("9fgMZ");
function $a757a6928f091056$export$25eccb87f5a000e6(context) {
    // Tracks already visited fragments to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors
    var spreadPath = []; // Position in the spread path
    var spreadPathIndexByName = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            detectCycleRecursive(node);
            return false;
        }
    }; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(fragment) {
        if (visitedFrags[fragment.name.value]) return;
        var fragmentName = fragment.name.value;
        visitedFrags[fragmentName] = true;
        var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
        if (spreadNodes.length === 0) return;
        spreadPathIndexByName[fragmentName] = spreadPath.length;
        for(var _i2 = 0; _i2 < spreadNodes.length; _i2++){
            var spreadNode = spreadNodes[_i2];
            var spreadName = spreadNode.name.value;
            var cycleIndex = spreadPathIndexByName[spreadName];
            spreadPath.push(spreadNode);
            if (cycleIndex === undefined) {
                var spreadFragment = context.getFragment(spreadName);
                if (spreadFragment) detectCycleRecursive(spreadFragment);
            } else {
                var cyclePath = spreadPath.slice(cycleIndex);
                var viaPath = cyclePath.slice(0, -1).map(function(s) {
                    return '"' + s.name.value + '"';
                }).join(', ');
                context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot spread fragment \"".concat(spreadName, "\" within itself") + (viaPath !== '' ? " via ".concat(viaPath, ".") : '.'), cyclePath));
            }
            spreadPath.pop();
        }
        spreadPathIndexByName[fragmentName] = undefined;
    }
}

});

parcelRegister("b6uMB", function(module, exports) {

$parcel$export(module.exports, "UniqueVariableNamesRule", () => $8cba4410d1ba8a7f$export$b9352e3a23ba4aa2);

var $9fgMZ = parcelRequire("9fgMZ");
function $8cba4410d1ba8a7f$export$b9352e3a23ba4aa2(context) {
    var knownVariableNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            knownVariableNames = Object.create(null);
        },
        VariableDefinition: function VariableDefinition(node) {
            var variableName = node.variable.name.value;
            if (knownVariableNames[variableName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one variable named \"$".concat(variableName, "\"."), [
                knownVariableNames[variableName],
                node.variable.name
            ]));
            else knownVariableNames[variableName] = node.variable.name;
        }
    };
}

});

parcelRegister("8zYa7", function(module, exports) {

$parcel$export(module.exports, "NoUndefinedVariablesRule", () => $9f30efbbf7a4ad88$export$207476dbb3f797ab);

var $9fgMZ = parcelRequire("9fgMZ");
function $9f30efbbf7a4ad88$export$207476dbb3f797ab(context) {
    var variableNameDefined = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                variableNameDefined = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var varName = node.name.value;
                    if (variableNameDefined[varName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)(operation.name ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(varName, "\" is not defined."), [
                        node,
                        operation
                    ]));
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            variableNameDefined[node.variable.name.value] = true;
        }
    };
}

});

parcelRegister("5k1Qg", function(module, exports) {

$parcel$export(module.exports, "NoUnusedVariablesRule", () => $73f3814f2ba8a2d1$export$300a3bc5a4f49273);

var $9fgMZ = parcelRequire("9fgMZ");
function $73f3814f2ba8a2d1$export$300a3bc5a4f49273(context) {
    var variableDefs = [];
    return {
        OperationDefinition: {
            enter: function enter() {
                variableDefs = [];
            },
            leave: function leave(operation) {
                var variableNameUsed = Object.create(null);
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    variableNameUsed[node.name.value] = true;
                }
                for(var _i4 = 0, _variableDefs2 = variableDefs; _i4 < _variableDefs2.length; _i4++){
                    var variableDef = _variableDefs2[_i4];
                    var variableName = variableDef.variable.name.value;
                    if (variableNameUsed[variableName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)(operation.name ? "Variable \"$".concat(variableName, "\" is never used in operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(variableName, "\" is never used."), variableDef));
                }
            }
        },
        VariableDefinition: function VariableDefinition(def) {
            variableDefs.push(def);
        }
    };
}

});

parcelRegister("loWoH", function(module, exports) {

$parcel$export(module.exports, "KnownDirectivesRule", () => $f639a2bd47be29e5$export$f4ca94d7d1cf5874);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $5hGV7 = parcelRequire("5hGV7");

var $bOniD = parcelRequire("bOniD");
function $f639a2bd47be29e5$export$f4ca94d7d1cf5874(context) {
    var locationsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        locationsMap[directive.name] = directive.locations;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) locationsMap[def.name.value] = def.locations.map(function(name) {
            return name.value;
        });
    }
    return {
        Directive: function Directive(node, _key, _parent, _path, ancestors) {
            var name = node.name.value;
            var locations = locationsMap[name];
            if (!locations) {
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown directive \"@".concat(name, "\"."), node));
                return;
            }
            var candidateLocation = $f639a2bd47be29e5$var$getDirectiveLocationForASTPath(ancestors);
            if (candidateLocation && locations.indexOf(candidateLocation) === -1) context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(name, "\" may not be used on ").concat(candidateLocation, "."), node));
        }
    };
}
function $f639a2bd47be29e5$var$getDirectiveLocationForASTPath(ancestors) {
    var appliedTo = ancestors[ancestors.length - 1];
    !Array.isArray(appliedTo) || (0, $43MJl.default)(0);
    switch(appliedTo.kind){
        case (0, $1c4hI.Kind).OPERATION_DEFINITION:
            return $f639a2bd47be29e5$var$getDirectiveLocationForOperation(appliedTo.operation);
        case (0, $1c4hI.Kind).FIELD:
            return (0, $5hGV7.DirectiveLocation).FIELD;
        case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
            return (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD;
        case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            return (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT;
        case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).FRAGMENT_DEFINITION;
        case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).VARIABLE_DEFINITION;
        case (0, $1c4hI.Kind).SCHEMA_DEFINITION:
        case (0, $1c4hI.Kind).SCHEMA_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).SCHEMA;
        case (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).SCALAR;
        case (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).OBJECT;
        case (0, $1c4hI.Kind).FIELD_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION;
        case (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).INTERFACE;
        case (0, $1c4hI.Kind).UNION_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).UNION_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).UNION;
        case (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).ENUM;
        case (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).ENUM_VALUE;
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).INPUT_OBJECT;
        case (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION:
            var parentNode = ancestors[ancestors.length - 3];
            return parentNode.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION ? (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION : (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION;
    }
}
function $f639a2bd47be29e5$var$getDirectiveLocationForOperation(operation) {
    switch(operation){
        case 'query':
            return (0, $5hGV7.DirectiveLocation).QUERY;
        case 'mutation':
            return (0, $5hGV7.DirectiveLocation).MUTATION;
        case 'subscription':
            return (0, $5hGV7.DirectiveLocation).SUBSCRIPTION;
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected operation: ' + (0, $biK02.default)(operation));
}

});

parcelRegister("is7or", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectivesPerLocationRule", () => $d948a6cd5aabc74f$export$4a38f68ea408504c);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");

var $bOniD = parcelRequire("bOniD");
function $d948a6cd5aabc74f$export$4a38f68ea408504c(context) {
    var uniqueDirectiveMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
    var schemaDirectives = Object.create(null);
    var typeDirectivesMap = Object.create(null);
    return {
        // Many different AST nodes may contain directives. Rather than listing
        // them all, just listen for entering any node, and check to see if it
        // defines any directives.
        enter: function enter(node) {
            if (node.directives == null) return;
            var seenDirectives;
            if (node.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || node.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION) seenDirectives = schemaDirectives;
            else if ((0, $9nArG.isTypeDefinitionNode)(node) || (0, $9nArG.isTypeExtensionNode)(node)) {
                var typeName = node.name.value;
                seenDirectives = typeDirectivesMap[typeName];
                if (seenDirectives === undefined) typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
            } else seenDirectives = Object.create(null);
            for(var _i6 = 0, _node$directives2 = node.directives; _i6 < _node$directives2.length; _i6++){
                var _directive = _node$directives2[_i6];
                var directiveName = _directive.name.value;
                if (uniqueDirectiveMap[directiveName]) {
                    if (seenDirectives[directiveName]) context.reportError(new (0, $9fgMZ.GraphQLError)("The directive \"@".concat(directiveName, "\" can only be used once at this location."), [
                        seenDirectives[directiveName],
                        _directive
                    ]));
                    else seenDirectives[directiveName] = _directive;
                }
            }
        }
    };
}

});

parcelRegister("gGl3W", function(module, exports) {

$parcel$export(module.exports, "KnownArgumentNamesRule", () => $f06ff2fed7190b23$export$5d7b3b4b6779c802);
$parcel$export(module.exports, "KnownArgumentNamesOnDirectivesRule", () => $f06ff2fed7190b23$export$6eb6eb4c5417f2c4);

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $bOniD = parcelRequire("bOniD");
function $f06ff2fed7190b23$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f06ff2fed7190b23$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f06ff2fed7190b23$var$ownKeys(Object(source), true).forEach(function(key) {
            $f06ff2fed7190b23$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f06ff2fed7190b23$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f06ff2fed7190b23$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f06ff2fed7190b23$export$5d7b3b4b6779c802(context) {
    return $f06ff2fed7190b23$var$_objectSpread($f06ff2fed7190b23$var$_objectSpread({}, $f06ff2fed7190b23$export$6eb6eb4c5417f2c4(context)), {}, {
        Argument: function Argument(argNode) {
            var argDef = context.getArgument();
            var fieldDef = context.getFieldDef();
            var parentType = context.getParentType();
            if (!argDef && fieldDef && parentType) {
                var argName = argNode.name.value;
                var knownArgsNames = fieldDef.args.map(function(arg) {
                    return arg.name;
                });
                var suggestions = (0, $bru1k.default)(argName, knownArgsNames);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown argument \"".concat(argName, "\" on field \"").concat(parentType.name, ".").concat(fieldDef.name, "\".") + (0, $8nBnZ.default)(suggestions), argNode));
            }
        }
    });
}
function $f06ff2fed7190b23$export$6eb6eb4c5417f2c4(context) {
    var directiveArgs = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        directiveArgs[directive.name] = directive.args.map(function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            directiveArgs[def.name.value] = argsNodes.map(function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: function Directive(directiveNode) {
            var directiveName = directiveNode.name.value;
            var knownArgs = directiveArgs[directiveName];
            if (directiveNode.arguments && knownArgs) for(var _i6 = 0, _directiveNode$argume2 = directiveNode.arguments; _i6 < _directiveNode$argume2.length; _i6++){
                var argNode = _directiveNode$argume2[_i6];
                var argName = argNode.name.value;
                if (knownArgs.indexOf(argName) === -1) {
                    var suggestions = (0, $bru1k.default)(argName, knownArgs);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".") + (0, $8nBnZ.default)(suggestions), argNode));
                }
            }
            return false;
        }
    };
}

});

parcelRegister("kXrJO", function(module, exports) {

$parcel$export(module.exports, "UniqueArgumentNamesRule", () => $bc8bcb3d805db150$export$8598b5acb1d855ca);

var $9fgMZ = parcelRequire("9fgMZ");
function $bc8bcb3d805db150$export$8598b5acb1d855ca(context) {
    var knownArgNames = Object.create(null);
    return {
        Field: function Field() {
            knownArgNames = Object.create(null);
        },
        Directive: function Directive() {
            knownArgNames = Object.create(null);
        },
        Argument: function Argument(node) {
            var argName = node.name.value;
            if (knownArgNames[argName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one argument named \"".concat(argName, "\"."), [
                knownArgNames[argName],
                node.name
            ]));
            else knownArgNames[argName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("bhI3j", function(module, exports) {

$parcel$export(module.exports, "ValuesOfCorrectTypeRule", () => $7b4ecfc9076050ee$export$669bf87f50cfda9b);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");
function $7b4ecfc9076050ee$export$669bf87f50cfda9b(context) {
    return {
        ListValue: function ListValue(node) {
            // Note: TypeInfo will traverse into a list's item type, so look to the
            // parent input type to check if it is a list.
            var type = (0, $lXoEQ.getNullableType)(context.getParentInputType());
            if (!(0, $lXoEQ.isListType)(type)) {
                $7b4ecfc9076050ee$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            }
        },
        ObjectValue: function ObjectValue(node) {
            var type = (0, $lXoEQ.getNamedType)(context.getInputType());
            if (!(0, $lXoEQ.isInputObjectType)(type)) {
                $7b4ecfc9076050ee$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            } // Ensure every required field exists.
            var fieldNodeMap = (0, $hbiEd.default)(node.fields, function(field) {
                return field.name.value;
            });
            for(var _i2 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i2 < _objectValues2.length; _i2++){
                var fieldDef = _objectValues2[_i2];
                var fieldNode = fieldNodeMap[fieldDef.name];
                if (!fieldNode && (0, $lXoEQ.isRequiredInputField)(fieldDef)) {
                    var typeStr = (0, $biK02.default)(fieldDef.type);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(type.name, ".").concat(fieldDef.name, "\" of required type \"").concat(typeStr, "\" was not provided."), node));
                }
            }
        },
        ObjectField: function ObjectField(node) {
            var parentType = (0, $lXoEQ.getNamedType)(context.getParentInputType());
            var fieldType = context.getInputType();
            if (!fieldType && (0, $lXoEQ.isInputObjectType)(parentType)) {
                var suggestions = (0, $bru1k.default)(node.name.value, Object.keys(parentType.getFields()));
                context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(node.name.value, "\" is not defined by type \"").concat(parentType.name, "\".") + (0, $8nBnZ.default)(suggestions), node));
            }
        },
        NullValue: function NullValue(node) {
            var type = context.getInputType();
            if ((0, $lXoEQ.isNonNullType)(type)) context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat((0, $biK02.default)(type), "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        },
        EnumValue: function EnumValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        IntValue: function IntValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        FloatValue: function FloatValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        StringValue: function StringValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        BooleanValue: function BooleanValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        }
    };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */ function $7b4ecfc9076050ee$var$isValidValueNode(context, node) {
    // Report any error at the full type expected by the location.
    var locationType = context.getInputType();
    if (!locationType) return;
    var type = (0, $lXoEQ.getNamedType)(locationType);
    if (!(0, $lXoEQ.isLeafType)(type)) {
        var typeStr = (0, $biK02.default)(locationType);
        context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(typeStr, "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        return;
    } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
    // which may throw or return an invalid value to indicate failure.
    try {
        var parseResult = type.parseLiteral(node, undefined);
        if (parseResult === undefined) {
            var _typeStr = (0, $biK02.default)(locationType);
            context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(_typeStr, "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        }
    } catch (error) {
        var _typeStr2 = (0, $biK02.default)(locationType);
        if (error instanceof (0, $9fgMZ.GraphQLError)) context.reportError(error);
        else context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(_typeStr2, "\", found ").concat((0, $aKlnM.print)(node), "; ") + error.message, node, undefined, undefined, undefined, error));
    }
}

});

parcelRegister("bN26g", function(module, exports) {

$parcel$export(module.exports, "ProvidedRequiredArgumentsRule", () => $ab49904624b6b37c$export$4df169576372c8b2);
$parcel$export(module.exports, "ProvidedRequiredArgumentsOnDirectivesRule", () => $ab49904624b6b37c$export$5ff6a71c337c020f);

var $biK02 = parcelRequire("biK02");

var $hbiEd = parcelRequire("hbiEd");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $ab49904624b6b37c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ab49904624b6b37c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ab49904624b6b37c$var$ownKeys(Object(source), true).forEach(function(key) {
            $ab49904624b6b37c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ab49904624b6b37c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ab49904624b6b37c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ab49904624b6b37c$export$4df169576372c8b2(context) {
    return $ab49904624b6b37c$var$_objectSpread($ab49904624b6b37c$var$_objectSpread({}, $ab49904624b6b37c$export$5ff6a71c337c020f(context)), {}, {
        Field: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(fieldNode) {
                var _fieldNode$arguments;
                var fieldDef = context.getFieldDef();
                if (!fieldDef) return false;
                 // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                var argNodes = (_fieldNode$arguments = fieldNode.arguments) !== null && _fieldNode$arguments !== void 0 ? _fieldNode$arguments : [];
                var argNodeMap = (0, $hbiEd.default)(argNodes, function(arg) {
                    return arg.name.value;
                });
                for(var _i2 = 0, _fieldDef$args2 = fieldDef.args; _i2 < _fieldDef$args2.length; _i2++){
                    var argDef = _fieldDef$args2[_i2];
                    var argNode = argNodeMap[argDef.name];
                    if (!argNode && (0, $lXoEQ.isRequiredArgument)(argDef)) {
                        var argTypeStr = (0, $biK02.default)(argDef.type);
                        context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), fieldNode));
                    }
                }
            }
        }
    });
}
function $ab49904624b6b37c$export$5ff6a71c337c020f(context) {
    var requiredArgsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i4 = 0; _i4 < definedDirectives.length; _i4++){
        var directive = definedDirectives[_i4];
        requiredArgsMap[directive.name] = (0, $hbiEd.default)(directive.args.filter((0, $lXoEQ.isRequiredArgument)), function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i6 = 0; _i6 < astDefinitions.length; _i6++){
        var def = astDefinitions[_i6];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            requiredArgsMap[def.name.value] = (0, $hbiEd.default)(argNodes.filter($ab49904624b6b37c$var$isRequiredArgumentNode), function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(directiveNode) {
                var directiveName = directiveNode.name.value;
                var requiredArgs = requiredArgsMap[directiveName];
                if (requiredArgs) {
                    var _directiveNode$argume;
                    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                    var _argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
                    var argNodeMap = (0, $hbiEd.default)(_argNodes, function(arg) {
                        return arg.name.value;
                    });
                    for(var _i8 = 0, _Object$keys2 = Object.keys(requiredArgs); _i8 < _Object$keys2.length; _i8++){
                        var argName = _Object$keys2[_i8];
                        if (!argNodeMap[argName]) {
                            var argType = requiredArgs[argName].type;
                            var argTypeStr = (0, $lXoEQ.isType)(argType) ? (0, $biK02.default)(argType) : (0, $aKlnM.print)(argType);
                            context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), directiveNode));
                        }
                    }
                }
            }
        }
    };
}
function $ab49904624b6b37c$var$isRequiredArgumentNode(arg) {
    return arg.type.kind === (0, $1c4hI.Kind).NON_NULL_TYPE && arg.defaultValue == null;
}

});

parcelRegister("gnP1U", function(module, exports) {

$parcel$export(module.exports, "VariablesInAllowedPositionRule", () => $2271e9cfabe9e688$export$7251631d636f2f74);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $f5cpS = parcelRequire("f5cpS");
function $2271e9cfabe9e688$export$7251631d636f2f74(context) {
    var varDefMap = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                varDefMap = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var type = _ref2.type;
                    var defaultValue = _ref2.defaultValue;
                    var varName = node.name.value;
                    var varDef = varDefMap[varName];
                    if (varDef && type) {
                        // A var type is allowed if it is the same or more strict (e.g. is
                        // a subtype of) than the expected type. It can be more strict if
                        // the variable type is non-null when the expected type is nullable.
                        // If both are list types, the variable item type can be more strict
                        // than the expected item type (contravariant).
                        var schema = context.getSchema();
                        var varType = (0, $3zSAT.typeFromAST)(schema, varDef.type);
                        if (varType && !$2271e9cfabe9e688$var$allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
                            var varTypeStr = (0, $biK02.default)(varType);
                            var typeStr = (0, $biK02.default)(type);
                            context.reportError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of type \"").concat(varTypeStr, "\" used in position expecting type \"").concat(typeStr, "\"."), [
                                varDef,
                                node
                            ]));
                        }
                    }
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            varDefMap[node.variable.name.value] = node;
        }
    };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */ function $2271e9cfabe9e688$var$allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
    if ((0, $lXoEQ.isNonNullType)(locationType) && !(0, $lXoEQ.isNonNullType)(varType)) {
        var hasNonNullVariableDefaultValue = varDefaultValue != null && varDefaultValue.kind !== (0, $1c4hI.Kind).NULL;
        var hasLocationDefaultValue = locationDefaultValue !== undefined;
        if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) return false;
        var nullableLocationType = locationType.ofType;
        return (0, $f5cpS.isTypeSubTypeOf)(schema, varType, nullableLocationType);
    }
    return (0, $f5cpS.isTypeSubTypeOf)(schema, varType, locationType);
}

});

parcelRegister("h0Hyz", function(module, exports) {

$parcel$export(module.exports, "OverlappingFieldsCanBeMergedRule", () => $79d19cce53ef75b6$export$ca8652d62af5670);

var $bmIpK = parcelRequire("bmIpK");

var $apet0 = parcelRequire("apet0");

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $79d19cce53ef75b6$var$reasonMessage(reason) {
    if (Array.isArray(reason)) return reason.map(function(_ref) {
        var responseName = _ref[0], subReason = _ref[1];
        return "subfields \"".concat(responseName, "\" conflict because ") + $79d19cce53ef75b6$var$reasonMessage(subReason);
    }).join(' and ');
    return reason;
}
function $79d19cce53ef75b6$export$ca8652d62af5670(context) {
    // A memoization for when two fragments are compared "between" each other for
    // conflicts. Two fragments may be compared many times, so memoizing this can
    // dramatically improve the performance of this validator.
    var comparedFragmentPairs = new $79d19cce53ef75b6$var$PairSet(); // A cache for the "field map" and list of fragment names found in any given
    // selection set. Selection sets may be asked for this information multiple
    // times, so this improves the performance of this validator.
    var cachedFieldsAndFragmentNames = new Map();
    return {
        SelectionSet: function SelectionSet(selectionSet) {
            var conflicts = $79d19cce53ef75b6$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
            for(var _i2 = 0; _i2 < conflicts.length; _i2++){
                var _ref3 = conflicts[_i2];
                var _ref2$ = _ref3[0];
                var responseName = _ref2$[0];
                var reason = _ref2$[1];
                var fields1 = _ref3[1];
                var fields2 = _ref3[2];
                var reasonMsg = $79d19cce53ef75b6$var$reasonMessage(reason);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fields \"".concat(responseName, "\" conflict because ").concat(reasonMsg, ". Use different aliases on the fields to fetch both if this was intentional."), fields1.concat(fields2)));
            }
        }
    };
}
/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */ // Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function $79d19cce53ef75b6$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
    var conflicts = [];
    var _getFieldsAndFragment = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet), fieldMap = _getFieldsAndFragment[0], fragmentNames = _getFieldsAndFragment[1]; // (A) Find find all conflicts "within" the fields of this selection set.
    // Note: this is the *only place* `collectConflictsWithin` is called.
    $79d19cce53ef75b6$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
    if (fragmentNames.length !== 0) // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for(var i = 0; i < fragmentNames.length; i++){
        $79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
        // selection set to collect conflicts between fragments spread together.
        // This compares each item in the list of fragment names to every other
        // item in that same list (except for itself).
        for(var j = i + 1; j < fragmentNames.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
    }
    return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.
function $79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
    var fragment = context.getFragment(fragmentName);
    if (!fragment) return;
    var _getReferencedFieldsA = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment), fieldMap2 = _getReferencedFieldsA[0], fragmentNames2 = _getReferencedFieldsA[1]; // Do not compare a fragment's fieldMap to itself.
    if (fieldMap === fieldMap2) return;
     // (D) First collect any conflicts between the provided collection of fields
    // and the collection of fields represented by the given fragment.
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
    // and any fragment names found in the given fragment.
    for(var i = 0; i < fragmentNames2.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.
function $79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
    // No need to compare a fragment to itself.
    if (fragmentName1 === fragmentName2) return;
     // Memoize so two fragments are not compared for conflicts more than once.
    if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) return;
    comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
    var fragment1 = context.getFragment(fragmentName1);
    var fragment2 = context.getFragment(fragmentName2);
    if (!fragment1 || !fragment2) return;
    var _getReferencedFieldsA2 = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1), fieldMap1 = _getReferencedFieldsA2[0], fragmentNames1 = _getReferencedFieldsA2[1];
    var _getReferencedFieldsA3 = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2), fieldMap2 = _getReferencedFieldsA3[0], fragmentNames2 = _getReferencedFieldsA3[1]; // (F) First, collect all conflicts between these two collections of fields
    // (not including any nested fragments).
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
    // fragments spread in the second fragment.
    for(var j = 0; j < fragmentNames2.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
     // (G) Then collect conflicts between the second fragment and any nested
    // fragments spread in the first fragment.
    for(var i = 0; i < fragmentNames1.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.
function $79d19cce53ef75b6$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
    var conflicts = [];
    var _getFieldsAndFragment2 = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1), fieldMap1 = _getFieldsAndFragment2[0], fragmentNames1 = _getFieldsAndFragment2[1];
    var _getFieldsAndFragment3 = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2), fieldMap2 = _getFieldsAndFragment3[0], fragmentNames2 = _getFieldsAndFragment3[1]; // (H) First, collect all conflicts between these two collections of field.
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
    // those referenced by each fragment name associated with the second.
    if (fragmentNames2.length !== 0) for(var j = 0; j < fragmentNames2.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
     // (I) Then collect conflicts between the second collection of fields and
    // those referenced by each fragment name associated with the first.
    if (fragmentNames1.length !== 0) for(var i = 0; i < fragmentNames1.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
     // (J) Also collect conflicts between any fragment names by the first and
    // fragment names by the second. This compares each item in the first set of
    // names to each item in the second set of names.
    for(var _i3 = 0; _i3 < fragmentNames1.length; _i3++)for(var _j = 0; _j < fragmentNames2.length; _j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i3], fragmentNames2[_j]);
    return conflicts;
} // Collect all Conflicts "within" one collection of fields.
function $79d19cce53ef75b6$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For every response name, if there are multiple fields, they
    // must be compared to find a potential conflict.
    for(var _i5 = 0, _objectEntries2 = (0, $apet0.default)(fieldMap); _i5 < _objectEntries2.length; _i5++){
        var _ref5 = _objectEntries2[_i5];
        var responseName = _ref5[0];
        var fields = _ref5[1];
        // This compares every field in the list to every other field in this list
        // (except to itself). If the list only has one item, nothing needs to
        // be compared.
        if (fields.length > 1) {
            for(var i = 0; i < fields.length; i++)for(var j = i + 1; j < fields.length; j++){
                var conflict = $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, responseName, fields[i], fields[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.
function $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For any response name which appears in both provided field
    // maps, each field from the first field map must be compared to every field
    // in the second field map to find potential conflicts.
    for(var _i7 = 0, _Object$keys2 = Object.keys(fieldMap1); _i7 < _Object$keys2.length; _i7++){
        var responseName = _Object$keys2[_i7];
        var fields2 = fieldMap2[responseName];
        if (fields2) {
            var fields1 = fieldMap1[responseName];
            for(var i = 0; i < fields1.length; i++)for(var j = 0; j < fields2.length; j++){
                var conflict = $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.
function $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
    var parentType1 = field1[0], node1 = field1[1], def1 = field1[2];
    var parentType2 = field2[0], node2 = field2[1], def2 = field2[2]; // If it is known that two fields could not possibly apply at the same
    // time, due to the parent types, then it is safe to permit them to diverge
    // in aliased field or arguments used as they will not present any ambiguity
    // by differing.
    // It is known that two parent types could never overlap if they are
    // different Object types. Interface or Union types might overlap - if not
    // in the current state of the schema, then perhaps in some future version,
    // thus may not safely diverge.
    var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, $lXoEQ.isObjectType)(parentType1) && (0, $lXoEQ.isObjectType)(parentType2);
    if (!areMutuallyExclusive) {
        var _node1$arguments, _node2$arguments;
        // Two aliases must refer to the same field.
        var name1 = node1.name.value;
        var name2 = node2.name.value;
        if (name1 !== name2) return [
            [
                responseName,
                "\"".concat(name1, "\" and \"").concat(name2, "\" are different fields")
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args1 = (_node1$arguments = node1.arguments) !== null && _node1$arguments !== void 0 ? _node1$arguments : []; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args2 = (_node2$arguments = node2.arguments) !== null && _node2$arguments !== void 0 ? _node2$arguments : []; // Two field calls must have the same arguments.
        if (!$79d19cce53ef75b6$var$sameArguments(args1, args2)) return [
            [
                responseName,
                'they have differing arguments'
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
    } // The return type for each field.
    var type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
    var type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;
    if (type1 && type2 && $79d19cce53ef75b6$var$doTypesConflict(type1, type2)) return [
        [
            responseName,
            "they return conflicting types \"".concat((0, $biK02.default)(type1), "\" and \"").concat((0, $biK02.default)(type2), "\"")
        ],
        [
            node1
        ],
        [
            node2
        ]
    ];
     // Collect and compare sub-fields. Use the same "visited fragment names" list
    // for both collections so fields in a fragment reference are never
    // compared to themselves.
    var selectionSet1 = node1.selectionSet;
    var selectionSet2 = node2.selectionSet;
    if (selectionSet1 && selectionSet2) {
        var conflicts = $79d19cce53ef75b6$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, $lXoEQ.getNamedType)(type1), selectionSet1, (0, $lXoEQ.getNamedType)(type2), selectionSet2);
        return $79d19cce53ef75b6$var$subfieldConflicts(conflicts, responseName, node1, node2);
    }
}
function $79d19cce53ef75b6$var$sameArguments(arguments1, arguments2) {
    if (arguments1.length !== arguments2.length) return false;
    return arguments1.every(function(argument1) {
        var argument2 = (0, $bmIpK.default)(arguments2, function(argument) {
            return argument.name.value === argument1.name.value;
        });
        if (!argument2) return false;
        return $79d19cce53ef75b6$var$sameValue(argument1.value, argument2.value);
    });
}
function $79d19cce53ef75b6$var$sameValue(value1, value2) {
    return (0, $aKlnM.print)(value1) === (0, $aKlnM.print)(value2);
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.
function $79d19cce53ef75b6$var$doTypesConflict(type1, type2) {
    if ((0, $lXoEQ.isListType)(type1)) return (0, $lXoEQ.isListType)(type2) ? $79d19cce53ef75b6$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $lXoEQ.isListType)(type2)) return true;
    if ((0, $lXoEQ.isNonNullType)(type1)) return (0, $lXoEQ.isNonNullType)(type2) ? $79d19cce53ef75b6$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $lXoEQ.isNonNullType)(type2)) return true;
    if ((0, $lXoEQ.isLeafType)(type1) || (0, $lXoEQ.isLeafType)(type2)) return type1 !== type2;
    return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.
function $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
    var cached = cachedFieldsAndFragmentNames.get(selectionSet);
    if (!cached) {
        var nodeAndDefs = Object.create(null);
        var fragmentNames = Object.create(null);
        $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
        cached = [
            nodeAndDefs,
            Object.keys(fragmentNames)
        ];
        cachedFieldsAndFragmentNames.set(selectionSet, cached);
    }
    return cached;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.
function $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
    // Short-circuit building a type from the node if possible.
    var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
    if (cached) return cached;
    var fragmentType = (0, $3zSAT.typeFromAST)(context.getSchema(), fragment.typeCondition);
    return $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}
function $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
    for(var _i9 = 0, _selectionSet$selecti2 = selectionSet.selections; _i9 < _selectionSet$selecti2.length; _i9++){
        var selection = _selectionSet$selecti2[_i9];
        switch(selection.kind){
            case (0, $1c4hI.Kind).FIELD:
                var fieldName = selection.name.value;
                var fieldDef = void 0;
                if ((0, $lXoEQ.isObjectType)(parentType) || (0, $lXoEQ.isInterfaceType)(parentType)) fieldDef = parentType.getFields()[fieldName];
                var responseName = selection.alias ? selection.alias.value : fieldName;
                if (!nodeAndDefs[responseName]) nodeAndDefs[responseName] = [];
                nodeAndDefs[responseName].push([
                    parentType,
                    selection,
                    fieldDef
                ]);
                break;
            case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
                fragmentNames[selection.name.value] = true;
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
                var typeCondition = selection.typeCondition;
                var inlineFragmentType = typeCondition ? (0, $3zSAT.typeFromAST)(context.getSchema(), typeCondition) : parentType;
                $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
                break;
        }
    }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.
function $79d19cce53ef75b6$var$subfieldConflicts(conflicts, responseName, node1, node2) {
    if (conflicts.length > 0) return [
        [
            responseName,
            conflicts.map(function(_ref6) {
                var reason = _ref6[0];
                return reason;
            })
        ],
        conflicts.reduce(function(allFields, _ref7) {
            var fields1 = _ref7[1];
            return allFields.concat(fields1);
        }, [
            node1
        ]),
        conflicts.reduce(function(allFields, _ref8) {
            var fields2 = _ref8[2];
            return allFields.concat(fields2);
        }, [
            node2
        ])
    ];
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does
 * not matter. We do this by maintaining a sort of double adjacency sets.
 */ var $79d19cce53ef75b6$var$PairSet = /*#__PURE__*/ function() {
    function PairSet() {
        this._data = Object.create(null);
    }
    var _proto = PairSet.prototype;
    _proto.has = function has(a, b, areMutuallyExclusive) {
        var first = this._data[a];
        var result = first && first[b];
        if (result === undefined) return false;
         // areMutuallyExclusive being false is a superset of being true,
        // hence if we want to know if this PairSet "has" these two with no
        // exclusivity, we have to ensure it was added as such.
        if (areMutuallyExclusive === false) return result === false;
        return true;
    };
    _proto.add = function add(a, b, areMutuallyExclusive) {
        this._pairSetAdd(a, b, areMutuallyExclusive);
        this._pairSetAdd(b, a, areMutuallyExclusive);
    };
    _proto._pairSetAdd = function _pairSetAdd(a, b, areMutuallyExclusive) {
        var map = this._data[a];
        if (!map) {
            map = Object.create(null);
            this._data[a] = map;
        }
        map[b] = areMutuallyExclusive;
    };
    return PairSet;
}();

});

parcelRegister("1W7Gt", function(module, exports) {

$parcel$export(module.exports, "UniqueInputFieldNamesRule", () => $eb92478c221189f8$export$de7865c052ebdd8c);

var $9fgMZ = parcelRequire("9fgMZ");
function $eb92478c221189f8$export$de7865c052ebdd8c(context) {
    var knownNameStack = [];
    var knownNames = Object.create(null);
    return {
        ObjectValue: {
            enter: function enter() {
                knownNameStack.push(knownNames);
                knownNames = Object.create(null);
            },
            leave: function leave() {
                knownNames = knownNameStack.pop();
            }
        },
        ObjectField: function ObjectField(node) {
            var fieldName = node.name.value;
            if (knownNames[fieldName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one input field named \"".concat(fieldName, "\"."), [
                knownNames[fieldName],
                node.name
            ]));
            else knownNames[fieldName] = node.name;
        }
    };
}

});

parcelRegister("gawpj", function(module, exports) {

$parcel$export(module.exports, "LoneSchemaDefinitionRule", () => $f71f83ba1740d4a2$export$9eae4c44f9d64405);

var $9fgMZ = parcelRequire("9fgMZ");
function $f71f83ba1740d4a2$export$9eae4c44f9d64405(context) {
    var _ref, _ref2, _oldSchema$astNode;
    var oldSchema = context.getSchema();
    var alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
    var schemaDefinitionsCount = 0;
    return {
        SchemaDefinition: function SchemaDefinition(node) {
            if (alreadyDefined) {
                context.reportError(new (0, $9fgMZ.GraphQLError)('Cannot define a new schema within a schema extension.', node));
                return;
            }
            if (schemaDefinitionsCount > 0) context.reportError(new (0, $9fgMZ.GraphQLError)('Must provide only one schema definition.', node));
            ++schemaDefinitionsCount;
        }
    };
}

});

parcelRegister("b8axV", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationTypesRule", () => $892cef0dee83a4c5$export$d9750570c6d13894);

var $9fgMZ = parcelRequire("9fgMZ");
function $892cef0dee83a4c5$export$d9750570c6d13894(context) {
    var schema = context.getSchema();
    var definedOperationTypes = Object.create(null);
    var existingOperationTypes = schema ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType()
    } : {};
    return {
        SchemaDefinition: checkOperationTypes,
        SchemaExtension: checkOperationTypes
    };
    function checkOperationTypes(node) {
        var _node$operationTypes;
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
        for(var _i2 = 0; _i2 < operationTypesNodes.length; _i2++){
            var operationType = operationTypesNodes[_i2];
            var operation = operationType.operation;
            var alreadyDefinedOperationType = definedOperationTypes[operation];
            if (existingOperationTypes[operation]) context.reportError(new (0, $9fgMZ.GraphQLError)("Type for ".concat(operation, " already defined in the schema. It cannot be redefined."), operationType));
            else if (alreadyDefinedOperationType) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one ".concat(operation, " type in schema."), [
                alreadyDefinedOperationType,
                operationType
            ]));
            else definedOperationTypes[operation] = operationType;
        }
        return false;
    }
}

});

parcelRegister("lOmVT", function(module, exports) {

$parcel$export(module.exports, "UniqueTypeNamesRule", () => $2484c652452810b0$export$380307ee0123f80e);

var $9fgMZ = parcelRequire("9fgMZ");
function $2484c652452810b0$export$380307ee0123f80e(context) {
    var knownTypeNames = Object.create(null);
    var schema = context.getSchema();
    return {
        ScalarTypeDefinition: checkTypeName,
        ObjectTypeDefinition: checkTypeName,
        InterfaceTypeDefinition: checkTypeName,
        UnionTypeDefinition: checkTypeName,
        EnumTypeDefinition: checkTypeName,
        InputObjectTypeDefinition: checkTypeName
    };
    function checkTypeName(node) {
        var typeName = node.name.value;
        if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
            context.reportError(new (0, $9fgMZ.GraphQLError)("Type \"".concat(typeName, "\" already exists in the schema. It cannot also be defined in this type definition."), node.name));
            return;
        }
        if (knownTypeNames[typeName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one type named \"".concat(typeName, "\"."), [
            knownTypeNames[typeName],
            node.name
        ]));
        else knownTypeNames[typeName] = node.name;
        return false;
    }
}

});

parcelRegister("1H4NC", function(module, exports) {

$parcel$export(module.exports, "UniqueEnumValueNamesRule", () => $2bea4695779a7344$export$f5a22bb45cdc635d);

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $2bea4695779a7344$export$f5a22bb45cdc635d(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownValueNames = Object.create(null);
    return {
        EnumTypeDefinition: checkValueUniqueness,
        EnumTypeExtension: checkValueUniqueness
    };
    function checkValueUniqueness(node) {
        var _node$values;
        var typeName = node.name.value;
        if (!knownValueNames[typeName]) knownValueNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
        var valueNames = knownValueNames[typeName];
        for(var _i2 = 0; _i2 < valueNodes.length; _i2++){
            var valueDef = valueNodes[_i2];
            var valueName = valueDef.name.value;
            var existingType = existingTypeMap[typeName];
            if ((0, $lXoEQ.isEnumType)(existingType) && existingType.getValue(valueName)) context.reportError(new (0, $9fgMZ.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" already exists in the schema. It cannot also be defined in this type extension."), valueDef.name));
            else if (valueNames[valueName]) context.reportError(new (0, $9fgMZ.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" can only be defined once."), [
                valueNames[valueName],
                valueDef.name
            ]));
            else valueNames[valueName] = valueDef.name;
        }
        return false;
    }
}

});

parcelRegister("lVZ4j", function(module, exports) {

$parcel$export(module.exports, "UniqueFieldDefinitionNamesRule", () => $c30f67380d4d4d7a$export$b3dfc0de81924308);

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $c30f67380d4d4d7a$export$b3dfc0de81924308(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownFieldNames = Object.create(null);
    return {
        InputObjectTypeDefinition: checkFieldUniqueness,
        InputObjectTypeExtension: checkFieldUniqueness,
        InterfaceTypeDefinition: checkFieldUniqueness,
        InterfaceTypeExtension: checkFieldUniqueness,
        ObjectTypeDefinition: checkFieldUniqueness,
        ObjectTypeExtension: checkFieldUniqueness
    };
    function checkFieldUniqueness(node) {
        var _node$fields;
        var typeName = node.name.value;
        if (!knownFieldNames[typeName]) knownFieldNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
        var fieldNames = knownFieldNames[typeName];
        for(var _i2 = 0; _i2 < fieldNodes.length; _i2++){
            var fieldDef = fieldNodes[_i2];
            var fieldName = fieldDef.name.value;
            if ($c30f67380d4d4d7a$var$hasField(existingTypeMap[typeName], fieldName)) context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" already exists in the schema. It cannot also be defined in this type extension."), fieldDef.name));
            else if (fieldNames[fieldName]) context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" can only be defined once."), [
                fieldNames[fieldName],
                fieldDef.name
            ]));
            else fieldNames[fieldName] = fieldDef.name;
        }
        return false;
    }
}
function $c30f67380d4d4d7a$var$hasField(type, fieldName) {
    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type) || (0, $lXoEQ.isInputObjectType)(type)) return type.getFields()[fieldName] != null;
    return false;
}

});

parcelRegister("jCJ2v", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectiveNamesRule", () => $d3a75eab1a7085ce$export$b06952068b20c86f);

var $9fgMZ = parcelRequire("9fgMZ");
function $d3a75eab1a7085ce$export$b06952068b20c86f(context) {
    var knownDirectiveNames = Object.create(null);
    var schema = context.getSchema();
    return {
        DirectiveDefinition: function DirectiveDefinition(node) {
            var directiveName = node.name.value;
            if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
                context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(directiveName, "\" already exists in the schema. It cannot be redefined."), node.name));
                return;
            }
            if (knownDirectiveNames[directiveName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one directive named \"@".concat(directiveName, "\"."), [
                knownDirectiveNames[directiveName],
                node.name
            ]));
            else knownDirectiveNames[directiveName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("kJWSQ", function(module, exports) {

$parcel$export(module.exports, "PossibleTypeExtensionsRule", () => $56e81335f8ee936c$export$50309357bc4f0e8b);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");

var $lXoEQ = parcelRequire("lXoEQ");
var $56e81335f8ee936c$var$_defKindToExtKind;
function $56e81335f8ee936c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $56e81335f8ee936c$export$50309357bc4f0e8b(context) {
    var schema = context.getSchema();
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, $9nArG.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = def;
    }
    return {
        ScalarTypeExtension: checkExtension,
        ObjectTypeExtension: checkExtension,
        InterfaceTypeExtension: checkExtension,
        UnionTypeExtension: checkExtension,
        EnumTypeExtension: checkExtension,
        InputObjectTypeExtension: checkExtension
    };
    function checkExtension(node) {
        var typeName = node.name.value;
        var defNode = definedTypes[typeName];
        var existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
        var expectedKind;
        if (defNode) expectedKind = $56e81335f8ee936c$var$defKindToExtKind[defNode.kind];
        else if (existingType) expectedKind = $56e81335f8ee936c$var$typeToExtKind(existingType);
        if (expectedKind) {
            if (expectedKind !== node.kind) {
                var kindStr = $56e81335f8ee936c$var$extensionKindToTypeName(node.kind);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot extend non-".concat(kindStr, " type \"").concat(typeName, "\"."), defNode ? [
                    defNode,
                    node
                ] : node));
            }
        } else {
            var allTypeNames = Object.keys(definedTypes);
            if (schema) allTypeNames = allTypeNames.concat(Object.keys(schema.getTypeMap()));
            var suggestedTypes = (0, $bru1k.default)(typeName, allTypeNames);
            context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot extend type \"".concat(typeName, "\" because it is not defined.") + (0, $8nBnZ.default)(suggestedTypes), node.name));
        }
    }
}
var $56e81335f8ee936c$var$defKindToExtKind = ($56e81335f8ee936c$var$_defKindToExtKind = {}, $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION, (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION, (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION, (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).UNION_TYPE_DEFINITION, (0, $1c4hI.Kind).UNION_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION, (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION, (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION), $56e81335f8ee936c$var$_defKindToExtKind);
function $56e81335f8ee936c$var$typeToExtKind(type) {
    if ((0, $lXoEQ.isScalarType)(type)) return (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION;
    if ((0, $lXoEQ.isObjectType)(type)) return (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION;
    if ((0, $lXoEQ.isInterfaceType)(type)) return (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION;
    if ((0, $lXoEQ.isUnionType)(type)) return (0, $1c4hI.Kind).UNION_TYPE_EXTENSION;
    if ((0, $lXoEQ.isEnumType)(type)) return (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION;
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isInputObjectType)(type)) return (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION;
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
}
function $56e81335f8ee936c$var$extensionKindToTypeName(kind) {
    switch(kind){
        case (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION:
            return 'scalar';
        case (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION:
            return 'object';
        case (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION:
            return 'interface';
        case (0, $1c4hI.Kind).UNION_TYPE_EXTENSION:
            return 'union';
        case (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION:
            return 'enum';
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return 'input object';
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected kind: ' + (0, $biK02.default)(kind));
}

});


parcelRegister("5RV6E", function(module, exports) {

$parcel$export(module.exports, "SDLValidationContext", () => $4e98916749b0fed4$export$62ce401b55355c79);
$parcel$export(module.exports, "ValidationContext", () => $4e98916749b0fed4$export$d452675449e81987);

var $1c4hI = parcelRequire("1c4hI");

var $961BR = parcelRequire("961BR");

var $hMOry = parcelRequire("hMOry");
function $4e98916749b0fed4$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e98916749b0fed4$export$ebdf7b7a2f7aef8b = /*#__PURE__*/ function() {
    function ASTValidationContext(ast, onError) {
        this._ast = ast;
        this._fragments = undefined;
        this._fragmentSpreads = new Map();
        this._recursivelyReferencedFragments = new Map();
        this._onError = onError;
    }
    var _proto = ASTValidationContext.prototype;
    _proto.reportError = function reportError(error) {
        this._onError(error);
    };
    _proto.getDocument = function getDocument() {
        return this._ast;
    };
    _proto.getFragment = function getFragment(name) {
        var fragments = this._fragments;
        if (!fragments) this._fragments = fragments = this.getDocument().definitions.reduce(function(frags, statement) {
            if (statement.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION) frags[statement.name.value] = statement;
            return frags;
        }, Object.create(null));
        return fragments[name];
    };
    _proto.getFragmentSpreads = function getFragmentSpreads(node) {
        var spreads = this._fragmentSpreads.get(node);
        if (!spreads) {
            spreads = [];
            var setsToVisit = [
                node
            ];
            while(setsToVisit.length !== 0){
                var set = setsToVisit.pop();
                for(var _i2 = 0, _set$selections2 = set.selections; _i2 < _set$selections2.length; _i2++){
                    var selection = _set$selections2[_i2];
                    if (selection.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD) spreads.push(selection);
                    else if (selection.selectionSet) setsToVisit.push(selection.selectionSet);
                }
            }
            this._fragmentSpreads.set(node, spreads);
        }
        return spreads;
    };
    _proto.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
        var fragments = this._recursivelyReferencedFragments.get(operation);
        if (!fragments) {
            fragments = [];
            var collectedNames = Object.create(null);
            var nodesToVisit = [
                operation.selectionSet
            ];
            while(nodesToVisit.length !== 0){
                var node = nodesToVisit.pop();
                for(var _i4 = 0, _this$getFragmentSpre2 = this.getFragmentSpreads(node); _i4 < _this$getFragmentSpre2.length; _i4++){
                    var spread = _this$getFragmentSpre2[_i4];
                    var fragName = spread.name.value;
                    if (collectedNames[fragName] !== true) {
                        collectedNames[fragName] = true;
                        var fragment = this.getFragment(fragName);
                        if (fragment) {
                            fragments.push(fragment);
                            nodesToVisit.push(fragment.selectionSet);
                        }
                    }
                }
            }
            this._recursivelyReferencedFragments.set(operation, fragments);
        }
        return fragments;
    };
    return ASTValidationContext;
}();
var $4e98916749b0fed4$export$62ce401b55355c79 = /*#__PURE__*/ function(_ASTValidationContext) {
    $4e98916749b0fed4$var$_inheritsLoose(SDLValidationContext, _ASTValidationContext);
    function SDLValidationContext(ast, schema, onError) {
        var _this;
        _this = _ASTValidationContext.call(this, ast, onError) || this;
        _this._schema = schema;
        return _this;
    }
    var _proto2 = SDLValidationContext.prototype;
    _proto2.getSchema = function getSchema() {
        return this._schema;
    };
    return SDLValidationContext;
}($4e98916749b0fed4$export$ebdf7b7a2f7aef8b);
var $4e98916749b0fed4$export$d452675449e81987 = /*#__PURE__*/ function(_ASTValidationContext2) {
    $4e98916749b0fed4$var$_inheritsLoose(ValidationContext, _ASTValidationContext2);
    function ValidationContext(schema, ast, typeInfo, onError) {
        var _this2;
        _this2 = _ASTValidationContext2.call(this, ast, onError) || this;
        _this2._schema = schema;
        _this2._typeInfo = typeInfo;
        _this2._variableUsages = new Map();
        _this2._recursiveVariableUsages = new Map();
        return _this2;
    }
    var _proto3 = ValidationContext.prototype;
    _proto3.getSchema = function getSchema() {
        return this._schema;
    };
    _proto3.getVariableUsages = function getVariableUsages(node) {
        var usages = this._variableUsages.get(node);
        if (!usages) {
            var newUsages = [];
            var typeInfo = new (0, $hMOry.TypeInfo)(this._schema);
            (0, $961BR.visit)(node, (0, $hMOry.visitWithTypeInfo)(typeInfo, {
                VariableDefinition: function VariableDefinition() {
                    return false;
                },
                Variable: function Variable(variable) {
                    newUsages.push({
                        node: variable,
                        type: typeInfo.getInputType(),
                        defaultValue: typeInfo.getDefaultValue()
                    });
                }
            }));
            usages = newUsages;
            this._variableUsages.set(node, usages);
        }
        return usages;
    };
    _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
        var usages = this._recursiveVariableUsages.get(operation);
        if (!usages) {
            usages = this.getVariableUsages(operation);
            for(var _i6 = 0, _this$getRecursivelyR2 = this.getRecursivelyReferencedFragments(operation); _i6 < _this$getRecursivelyR2.length; _i6++){
                var frag = _this$getRecursivelyR2[_i6];
                usages = usages.concat(this.getVariableUsages(frag));
            }
            this._recursiveVariableUsages.set(operation, usages);
        }
        return usages;
    };
    _proto3.getType = function getType() {
        return this._typeInfo.getType();
    };
    _proto3.getParentType = function getParentType() {
        return this._typeInfo.getParentType();
    };
    _proto3.getInputType = function getInputType() {
        return this._typeInfo.getInputType();
    };
    _proto3.getParentInputType = function getParentInputType() {
        return this._typeInfo.getParentInputType();
    };
    _proto3.getFieldDef = function getFieldDef() {
        return this._typeInfo.getFieldDef();
    };
    _proto3.getDirective = function getDirective() {
        return this._typeInfo.getDirective();
    };
    _proto3.getArgument = function getArgument() {
        return this._typeInfo.getArgument();
    };
    _proto3.getEnumValue = function getEnumValue() {
        return this._typeInfo.getEnumValue();
    };
    return ValidationContext;
}($4e98916749b0fed4$export$ebdf7b7a2f7aef8b);

});


parcelRegister("glHRe", function(module, exports) {

$parcel$export(module.exports, "extendSchema", () => $6ade12bb8df37dc4$export$35f5fe5f3e862ea3);
$parcel$export(module.exports, "extendSchemaImpl", () => $6ade12bb8df37dc4$export$97eac8f938300c6f);
$parcel$export(module.exports, "getDescription", () => $6ade12bb8df37dc4$export$67580b1c13935958);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $6MWHL = parcelRequire("6MWHL");

var $43MJl = parcelRequire("43MJl");

var $fZdRY = parcelRequire("fZdRY");

var $1c4hI = parcelRequire("1c4hI");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");

var $9nArG = parcelRequire("9nArG");

var $dGflO = parcelRequire("dGflO");

var $gqGQB = parcelRequire("gqGQB");

var $6BdRO = parcelRequire("6BdRO");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $3E0nn = parcelRequire("3E0nn");
function $6ade12bb8df37dc4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ade12bb8df37dc4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6ade12bb8df37dc4$var$ownKeys(Object(source), true).forEach(function(key) {
            $6ade12bb8df37dc4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6ade12bb8df37dc4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ade12bb8df37dc4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ade12bb8df37dc4$export$35f5fe5f3e862ea3(schema, documentAST, options) {
    (0, $6BdRO.assertSchema)(schema);
    documentAST != null && documentAST.kind === (0, $1c4hI.Kind).DOCUMENT || (0, $fZdRY.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, $dGflO.assertValidSDLExtension)(documentAST, schema);
    var schemaConfig = schema.toConfig();
    var extendedConfig = $6ade12bb8df37dc4$export$97eac8f938300c6f(schemaConfig, documentAST, options);
    return schemaConfig === extendedConfig ? schema : new (0, $6BdRO.GraphQLSchema)(extendedConfig);
}
function $6ade12bb8df37dc4$export$97eac8f938300c6f(schemaConfig, documentAST, options) {
    var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;
    // Collect the type definitions and extensions found in the document.
    var typeDefs = [];
    var typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
    // have the same name. For example, a type named "skip".
    var directiveDefs = [];
    var schemaDef; // Schema extensions are collected which may add additional operation types.
    var schemaExtensions = [];
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var def = _documentAST$definiti2[_i2];
        if (def.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION) schemaDef = def;
        else if (def.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION) schemaExtensions.push(def);
        else if ((0, $9nArG.isTypeDefinitionNode)(def)) typeDefs.push(def);
        else if ((0, $9nArG.isTypeExtensionNode)(def)) {
            var extendedTypeName = def.name.value;
            var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
            typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([
                def
            ]) : [
                def
            ];
        } else if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) directiveDefs.push(def);
    } // If this document contains no new types, extensions, or directives then
    // return the same unmodified GraphQLSchema instance.
    if (Object.keys(typeExtensionsMap).length === 0 && typeDefs.length === 0 && directiveDefs.length === 0 && schemaExtensions.length === 0 && schemaDef == null) return schemaConfig;
    var typeMap = Object.create(null);
    for(var _i4 = 0, _schemaConfig$types2 = schemaConfig.types; _i4 < _schemaConfig$types2.length; _i4++){
        var existingType = _schemaConfig$types2[_i4];
        typeMap[existingType.name] = extendNamedType(existingType);
    }
    for(var _i6 = 0; _i6 < typeDefs.length; _i6++){
        var _stdTypeMap$name;
        var typeNode = typeDefs[_i6];
        var name = typeNode.name.value;
        typeMap[name] = (_stdTypeMap$name = $6ade12bb8df37dc4$var$stdTypeMap[name]) !== null && _stdTypeMap$name !== void 0 ? _stdTypeMap$name : buildType(typeNode);
    }
    var operationTypes = $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({
        // Get the extended root operation types.
        query: schemaConfig.query && replaceNamedType(schemaConfig.query),
        mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
        subscription: schemaConfig.subscription && replaceNamedType(schemaConfig.subscription)
    }, schemaDef && getOperationTypes([
        schemaDef
    ])), getOperationTypes(schemaExtensions)); // Then produce and return a Schema config with these types.
    return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({
        description: (_schemaDef = schemaDef) === null || _schemaDef === void 0 ? void 0 : (_schemaDef$descriptio = _schemaDef.description) === null || _schemaDef$descriptio === void 0 ? void 0 : _schemaDef$descriptio.value
    }, operationTypes), {}, {
        types: (0, $dVq2R.default)(typeMap),
        directives: [].concat(schemaConfig.directives.map(replaceDirective), directiveDefs.map(buildDirective)),
        extensions: undefined,
        astNode: (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0 ? _schemaDef2 : schemaConfig.astNode,
        extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
        assumeValid: (_options$assumeValid = options === null || options === void 0 ? void 0 : options.assumeValid) !== null && _options$assumeValid !== void 0 ? _options$assumeValid : false
    }); // Below are functions used for producing this schema that have closed over
    // this scope and have access to the schema, cache, and newly defined types.
    function replaceType(type) {
        if ((0, $lXoEQ.isListType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, $lXoEQ.GraphQLList)(replaceType(type.ofType));
        if ((0, $lXoEQ.isNonNullType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, $lXoEQ.GraphQLNonNull)(replaceType(type.ofType));
        return replaceNamedType(type);
    }
    function replaceNamedType(type) {
        // Note: While this could make early assertions to get the correctly
        // typed values, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return typeMap[type.name];
    }
    function replaceDirective(directive) {
        var config = directive.toConfig();
        return new (0, $bOniD.GraphQLDirective)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            args: (0, $6MWHL.default)(config.args, extendArg)
        }));
    }
    function extendNamedType(type) {
        if ((0, $h2iUh.isIntrospectionType)(type) || (0, $auu22.isSpecifiedScalarType)(type)) // Builtin types are not extended.
        return type;
        if ((0, $lXoEQ.isScalarType)(type)) return extendScalarType(type);
        if ((0, $lXoEQ.isObjectType)(type)) return extendObjectType(type);
        if ((0, $lXoEQ.isInterfaceType)(type)) return extendInterfaceType(type);
        if ((0, $lXoEQ.isUnionType)(type)) return extendUnionType(type);
        if ((0, $lXoEQ.isEnumType)(type)) return extendEnumType(type);
         // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
        if ((0, $lXoEQ.isInputObjectType)(type)) return extendInputObjectType(type);
         // istanbul ignore next (Not reachable. All possible types have been considered)
        (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
    }
    function extendInputObjectType(type) {
        var _typeExtensionsMap$co;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co !== void 0 ? _typeExtensionsMap$co : [];
        return new (0, $lXoEQ.GraphQLInputObjectType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, function(field) {
                    return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, field), {}, {
                        type: replaceType(field.type)
                    });
                })), buildInputFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendEnumType(type) {
        var _typeExtensionsMap$ty;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null && _typeExtensionsMap$ty !== void 0 ? _typeExtensionsMap$ty : [];
        return new (0, $lXoEQ.GraphQLEnumType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            values: $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config.values), buildEnumValueMap(extensions)),
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendScalarType(type) {
        var _typeExtensionsMap$co2;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co2 !== void 0 ? _typeExtensionsMap$co2 : [];
        var specifiedByUrl = config.specifiedByUrl;
        for(var _i8 = 0; _i8 < extensions.length; _i8++){
            var _getSpecifiedByUrl;
            var extensionNode = extensions[_i8];
            specifiedByUrl = (_getSpecifiedByUrl = $6ade12bb8df37dc4$var$getSpecifiedByUrl(extensionNode)) !== null && _getSpecifiedByUrl !== void 0 ? _getSpecifiedByUrl : specifiedByUrl;
        }
        return new (0, $lXoEQ.GraphQLScalarType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            specifiedByUrl: specifiedByUrl,
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendObjectType(type) {
        var _typeExtensionsMap$co3;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co3 !== void 0 ? _typeExtensionsMap$co3 : [];
        return new (0, $lXoEQ.GraphQLObjectType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendInterfaceType(type) {
        var _typeExtensionsMap$co4;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co4 !== void 0 ? _typeExtensionsMap$co4 : [];
        return new (0, $lXoEQ.GraphQLInterfaceType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendUnionType(type) {
        var _typeExtensionsMap$co5;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co5 !== void 0 ? _typeExtensionsMap$co5 : [];
        return new (0, $lXoEQ.GraphQLUnionType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            types: function types() {
                return [].concat(type.getTypes().map(replaceNamedType), buildUnionTypes(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendField(field) {
        return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, field), {}, {
            type: replaceType(field.type),
            // $FlowFixMe[incompatible-call]
            args: (0, $6MWHL.default)(field.args, extendArg)
        });
    }
    function extendArg(arg) {
        return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, arg), {}, {
            type: replaceType(arg.type)
        });
    }
    function getOperationTypes(nodes) {
        var opTypes = {};
        for(var _i10 = 0; _i10 < nodes.length; _i10++){
            var _node$operationTypes;
            var node = nodes[_i10];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
            for(var _i12 = 0; _i12 < operationTypesNodes.length; _i12++){
                var operationType = operationTypesNodes[_i12];
                opTypes[operationType.operation] = getNamedType(operationType.type);
            }
        } // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return opTypes;
    }
    function getNamedType(node) {
        var _stdTypeMap$name2;
        var name = node.name.value;
        var type = (_stdTypeMap$name2 = $6ade12bb8df37dc4$var$stdTypeMap[name]) !== null && _stdTypeMap$name2 !== void 0 ? _stdTypeMap$name2 : typeMap[name];
        if (type === undefined) throw new Error("Unknown type: \"".concat(name, "\"."));
        return type;
    }
    function getWrappedType(node) {
        if (node.kind === (0, $1c4hI.Kind).LIST_TYPE) return new (0, $lXoEQ.GraphQLList)(getWrappedType(node.type));
        if (node.kind === (0, $1c4hI.Kind).NON_NULL_TYPE) return new (0, $lXoEQ.GraphQLNonNull)(getWrappedType(node.type));
        return getNamedType(node);
    }
    function buildDirective(node) {
        var locations = node.locations.map(function(_ref) {
            var value = _ref.value;
            return value;
        });
        return new (0, $bOniD.GraphQLDirective)({
            name: node.name.value,
            description: $6ade12bb8df37dc4$export$67580b1c13935958(node, options),
            locations: locations,
            isRepeatable: node.repeatable,
            args: buildArgumentMap(node.arguments),
            astNode: node
        });
    }
    function buildFieldMap(nodes) {
        var fieldConfigMap = Object.create(null);
        for(var _i14 = 0; _i14 < nodes.length; _i14++){
            var _node$fields;
            var node = nodes[_i14];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var nodeFields = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
            for(var _i16 = 0; _i16 < nodeFields.length; _i16++){
                var field = nodeFields[_i16];
                fieldConfigMap[field.name.value] = {
                    // Note: While this could make assertions to get the correctly typed
                    // value, that would throw immediately while type system validation
                    // with validateSchema() will produce more actionable results.
                    type: getWrappedType(field.type),
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(field, options),
                    args: buildArgumentMap(field.arguments),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return fieldConfigMap;
    }
    function buildArgumentMap(args) {
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var argsNodes = args !== null && args !== void 0 ? args : [];
        var argConfigMap = Object.create(null);
        for(var _i18 = 0; _i18 < argsNodes.length; _i18++){
            var arg = argsNodes[_i18];
            // Note: While this could make assertions to get the correctly typed
            // value, that would throw immediately while type system validation
            // with validateSchema() will produce more actionable results.
            var type = getWrappedType(arg.type);
            argConfigMap[arg.name.value] = {
                type: type,
                description: $6ade12bb8df37dc4$export$67580b1c13935958(arg, options),
                defaultValue: (0, $3E0nn.valueFromAST)(arg.defaultValue, type),
                deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(arg),
                astNode: arg
            };
        }
        return argConfigMap;
    }
    function buildInputFieldMap(nodes) {
        var inputFieldMap = Object.create(null);
        for(var _i20 = 0; _i20 < nodes.length; _i20++){
            var _node$fields2;
            var node = nodes[_i20];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var fieldsNodes = (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0 ? _node$fields2 : [];
            for(var _i22 = 0; _i22 < fieldsNodes.length; _i22++){
                var field = fieldsNodes[_i22];
                // Note: While this could make assertions to get the correctly typed
                // value, that would throw immediately while type system validation
                // with validateSchema() will produce more actionable results.
                var type = getWrappedType(field.type);
                inputFieldMap[field.name.value] = {
                    type: type,
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(field, options),
                    defaultValue: (0, $3E0nn.valueFromAST)(field.defaultValue, type),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return inputFieldMap;
    }
    function buildEnumValueMap(nodes) {
        var enumValueMap = Object.create(null);
        for(var _i24 = 0; _i24 < nodes.length; _i24++){
            var _node$values;
            var node = nodes[_i24];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var valuesNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
            for(var _i26 = 0; _i26 < valuesNodes.length; _i26++){
                var value = valuesNodes[_i26];
                enumValueMap[value.name.value] = {
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(value, options),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(value),
                    astNode: value
                };
            }
        }
        return enumValueMap;
    }
    function buildInterfaces(nodes) {
        var interfaces = [];
        for(var _i28 = 0; _i28 < nodes.length; _i28++){
            var _node$interfaces;
            var node = nodes[_i28];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var interfacesNodes = (_node$interfaces = node.interfaces) !== null && _node$interfaces !== void 0 ? _node$interfaces : [];
            for(var _i30 = 0; _i30 < interfacesNodes.length; _i30++){
                var type = interfacesNodes[_i30];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                interfaces.push(getNamedType(type));
            }
        }
        return interfaces;
    }
    function buildUnionTypes(nodes) {
        var types = [];
        for(var _i32 = 0; _i32 < nodes.length; _i32++){
            var _node$types;
            var node = nodes[_i32];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var typeNodes = (_node$types = node.types) !== null && _node$types !== void 0 ? _node$types : [];
            for(var _i34 = 0; _i34 < typeNodes.length; _i34++){
                var type = typeNodes[_i34];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                types.push(getNamedType(type));
            }
        }
        return types;
    }
    function buildType(astNode) {
        var _typeExtensionsMap$na;
        var name = astNode.name.value;
        var description = $6ade12bb8df37dc4$export$67580b1c13935958(astNode, options);
        var extensionNodes = (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null && _typeExtensionsMap$na !== void 0 ? _typeExtensionsMap$na : [];
        switch(astNode.kind){
            case (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION:
                var extensionASTNodes = extensionNodes;
                var allNodes = [
                    astNode
                ].concat(extensionASTNodes);
                return new (0, $lXoEQ.GraphQLObjectType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: extensionASTNodes
                });
            case (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION:
                var _extensionASTNodes = extensionNodes;
                var _allNodes = [
                    astNode
                ].concat(_extensionASTNodes);
                return new (0, $lXoEQ.GraphQLInterfaceType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(_allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(_allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes
                });
            case (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION:
                var _extensionASTNodes2 = extensionNodes;
                var _allNodes2 = [
                    astNode
                ].concat(_extensionASTNodes2);
                return new (0, $lXoEQ.GraphQLEnumType)({
                    name: name,
                    description: description,
                    values: buildEnumValueMap(_allNodes2),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes2
                });
            case (0, $1c4hI.Kind).UNION_TYPE_DEFINITION:
                var _extensionASTNodes3 = extensionNodes;
                var _allNodes3 = [
                    astNode
                ].concat(_extensionASTNodes3);
                return new (0, $lXoEQ.GraphQLUnionType)({
                    name: name,
                    description: description,
                    types: function types() {
                        return buildUnionTypes(_allNodes3);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes3
                });
            case (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION:
                var _extensionASTNodes4 = extensionNodes;
                return new (0, $lXoEQ.GraphQLScalarType)({
                    name: name,
                    description: description,
                    specifiedByUrl: $6ade12bb8df37dc4$var$getSpecifiedByUrl(astNode),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes4
                });
            case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION:
                var _extensionASTNodes5 = extensionNodes;
                var _allNodes4 = [
                    astNode
                ].concat(_extensionASTNodes5);
                return new (0, $lXoEQ.GraphQLInputObjectType)({
                    name: name,
                    description: description,
                    fields: function fields() {
                        return buildInputFieldMap(_allNodes4);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes5
                });
        } // istanbul ignore next (Not reachable. All possible type definition nodes have been considered)
        (0, $43MJl.default)(0, 'Unexpected type definition node: ' + (0, $biK02.default)(astNode));
    }
}
var $6ade12bb8df37dc4$var$stdTypeMap = (0, $hbiEd.default)((0, $auu22.specifiedScalarTypes).concat((0, $h2iUh.introspectionTypes)), function(type) {
    return type.name;
});
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */ function $6ade12bb8df37dc4$var$getDeprecationReason(node) {
    var deprecated = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLDeprecatedDirective), node);
    return deprecated === null || deprecated === void 0 ? void 0 : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByUrl.
 */ function $6ade12bb8df37dc4$var$getSpecifiedByUrl(node) {
    var specifiedBy = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLSpecifiedByDirective), node);
    return specifiedBy === null || specifiedBy === void 0 ? void 0 : specifiedBy.url;
}
function $6ade12bb8df37dc4$export$67580b1c13935958(node, options) {
    if (node.description) return node.description.value;
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) {
        var rawValue = $6ade12bb8df37dc4$var$getLeadingCommentBlock(node);
        if (rawValue !== undefined) return (0, $flA0a.dedentBlockStringValue)('\n' + rawValue);
    }
}
function $6ade12bb8df37dc4$var$getLeadingCommentBlock(node) {
    var loc = node.loc;
    if (!loc) return;
    var comments = [];
    var token = loc.startToken.prev;
    while(token != null && token.kind === (0, $hFu5F.TokenKind).COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line){
        var value = String(token.value);
        comments.push(value);
        token = token.prev;
    }
    return comments.length > 0 ? comments.reverse().join('\n') : undefined;
}

});


parcelRegister("9Dtw4", function(module, exports) {
var $703ea6dd6d6923b7$var$__assign = module.exports && module.exports.__assign || function() {
    $703ea6dd6d6923b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $703ea6dd6d6923b7$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
function $703ea6dd6d6923b7$var$filterExtensionDefinitions(ast) {
    var extensionDefs = ast.definitions.filter(function(def) {
        return def.kind !== $1c4hI.Kind.OBJECT_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.INTERFACE_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.INPUT_OBJECT_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.UNION_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.ENUM_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.SCALAR_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.SCHEMA_EXTENSION;
    });
    return $703ea6dd6d6923b7$var$__assign($703ea6dd6d6923b7$var$__assign({}, ast), {
        definitions: extensionDefs
    });
}
module.exports.default = $703ea6dd6d6923b7$var$filterExtensionDefinitions;

});


parcelRegister("zi3Qo", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
function $06a14789b0ee6806$var$chainResolvers(resolvers) {
    return function(root, args, ctx, info) {
        return resolvers.reduce(function(prev, curResolver) {
            if (curResolver) return curResolver(prev, args, ctx, info);
            return $3MP74.defaultFieldResolver(prev, args, ctx, info);
        }, root);
    };
}
module.exports.chainResolvers = $06a14789b0ee6806$var$chainResolvers;

});

parcelRegister("3zHIx", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $cYGSS = parcelRequire("cYGSS");
// If we have any union or interface types throw if no there is no resolveType or isTypeOf resolvers
function $29a68d5bffacbb58$var$checkForResolveTypeResolver(schema, requireResolversForResolveType) {
    Object.keys(schema.getTypeMap()).map(function(typeName) {
        return schema.getType(typeName);
    }).forEach(function(type) {
        if (!(type instanceof $lXoEQ.GraphQLUnionType || type instanceof $lXoEQ.GraphQLInterfaceType)) return;
        if (!type.resolveType) {
            if (requireResolversForResolveType === false) return;
            if (requireResolversForResolveType === true) throw new $cYGSS.SchemaError("Type \"" + type.name + "\" is missing a \"resolveType\" resolver");
            // tslint:disable-next-line:max-line-length
            console.warn("Type \"" + type.name + "\" is missing a \"__resolveType\" resolver. Pass false into " + "\"resolverValidationOptions.requireResolversForResolveType\" to disable this warning.");
        }
    });
}
module.exports.default = $29a68d5bffacbb58$var$checkForResolveTypeResolver;

});

parcelRegister("fzT6r", function(module, exports) {
var $b574de2b55f17580$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aKlnM = parcelRequire("aKlnM");

var $cYGSS = parcelRequire("cYGSS");
function $b574de2b55f17580$var$concatenateTypeDefs(typeDefinitionsAry, calledFunctionRefs) {
    if (calledFunctionRefs === void 0) calledFunctionRefs = [];
    var resolvedTypeDefinitions = [];
    typeDefinitionsAry.forEach(function(typeDef) {
        if (typeDef.kind !== undefined) typeDef = $aKlnM.print(typeDef);
        if (typeof typeDef === 'function') {
            if (calledFunctionRefs.indexOf(typeDef) === -1) {
                calledFunctionRefs.push(typeDef);
                resolvedTypeDefinitions = resolvedTypeDefinitions.concat($b574de2b55f17580$var$concatenateTypeDefs(typeDef(), calledFunctionRefs));
            }
        } else if (typeof typeDef === 'string') resolvedTypeDefinitions.push(typeDef.trim());
        else {
            var type = typeof typeDef;
            throw new $cYGSS.SchemaError("typeDef array must contain only strings and functions, got " + type);
        }
    });
    return $b574de2b55f17580$var$uniq(resolvedTypeDefinitions.map(function(x) {
        return x.trim();
    })).join('\n');
}
function $b574de2b55f17580$var$uniq(array) {
    return array.reduce(function(accumulator, currentValue) {
        return accumulator.indexOf(currentValue) === -1 ? $b574de2b55f17580$var$__spreadArrays(accumulator, [
            currentValue
        ]) : accumulator;
    }, []);
}
module.exports.default = $b574de2b55f17580$var$concatenateTypeDefs;

});

parcelRegister("jhVll", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
/*
 * fn: The function to decorate with the logger
 * logger: an object instance of type Logger
 * hint: an optional hint to add to the error's message
 */ function $e0ac160d29c86bae$var$decorateWithLogger(fn, logger, hint) {
    if (typeof fn === 'undefined') fn = $3MP74.defaultFieldResolver;
    var logError = function(e) {
        // TODO: clone the error properly
        var newE = new Error();
        newE.stack = e.stack;
        /* istanbul ignore else: always get the hint from addErrorLoggingToSchema */ if (hint) {
            newE['originalMessage'] = e.message;
            newE['message'] = "Error in resolver " + hint + "\n" + e.message;
        }
        logger.log(newE);
    };
    return function(root, args, ctx, info) {
        try {
            var result = fn(root, args, ctx, info);
            // If the resolve function returns a Promise log any Promise rejects.
            if (result && typeof result.then === 'function' && typeof result.catch === 'function') result.catch(function(reason) {
                // make sure that it's an error we're logging.
                var error = reason instanceof Error ? reason : new Error(reason);
                logError(error);
                // We don't want to leave an unhandled exception so pass on error.
                return reason;
            });
            return result;
        } catch (e) {
            logError(e);
            // we want to pass on the error, just in case.
            throw e;
        }
    };
}
module.exports.default = $e0ac160d29c86bae$var$decorateWithLogger;

});

parcelRegister("anY4o", function(module, exports) {
var $78faa5f901c93c41$var$__assign = module.exports && module.exports.__assign || function() {
    $78faa5f901c93c41$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $78faa5f901c93c41$var$__assign.apply(this, arguments);
};
var $78faa5f901c93c41$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $78faa5f901c93c41$var$extendResolversFromInterfaces(schema, resolvers) {
    var typeNames = Object.keys($78faa5f901c93c41$var$__assign($78faa5f901c93c41$var$__assign({}, schema.getTypeMap()), resolvers));
    var extendedResolvers = {};
    typeNames.forEach(function(typeName) {
        var typeResolvers = resolvers[typeName];
        var type = schema.getType(typeName);
        if (type instanceof $lXoEQ.GraphQLObjectType) {
            var interfaceResolvers = type.getInterfaces().map(function(iFace) {
                return resolvers[iFace.name];
            });
            extendedResolvers[typeName] = Object.assign.apply(Object, $78faa5f901c93c41$var$__spreadArrays([
                {}
            ], interfaceResolvers, [
                typeResolvers
            ]));
        } else if (typeResolvers) extendedResolvers[typeName] = typeResolvers;
    });
    return extendedResolvers;
}
module.exports.default = $78faa5f901c93c41$var$extendResolversFromInterfaces;

});

parcelRegister("4YHnC", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $39fe6a5e79c5f7d4$var$newExtensionDefinitionKind = 'ObjectTypeExtension';
var $39fe6a5e79c5f7d4$var$interfaceExtensionDefinitionKind = 'InterfaceTypeExtension';
var $39fe6a5e79c5f7d4$var$inputObjectExtensionDefinitionKind = 'InputObjectTypeExtension';
var $39fe6a5e79c5f7d4$var$unionExtensionDefinitionKind = 'UnionTypeExtension';
var $39fe6a5e79c5f7d4$var$enumExtensionDefinitionKind = 'EnumTypeExtension';
function $39fe6a5e79c5f7d4$var$extractExtensionDefinitions(ast) {
    var extensionDefs = ast.definitions.filter(function(def) {
        return def.kind === $39fe6a5e79c5f7d4$var$newExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$interfaceExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$inputObjectExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$unionExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$enumExtensionDefinitionKind;
    });
    return Object.assign({}, ast, {
        definitions: extensionDefs
    });
}
module.exports.default = $39fe6a5e79c5f7d4$var$extractExtensionDefinitions;

});

parcelRegister("bKZOs", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $88f3f05290386e89$var$forEachField(schema, fn) {
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        // TODO: maybe have an option to include these?
        if (!$lXoEQ.getNamedType(type).name.startsWith('__') && type instanceof $lXoEQ.GraphQLObjectType) {
            var fields_1 = type.getFields();
            Object.keys(fields_1).forEach(function(fieldName) {
                var field = fields_1[fieldName];
                fn(field, typeName, fieldName);
            });
        }
    });
}
module.exports.default = $88f3f05290386e89$var$forEachField;

});

parcelRegister("69KMn", function(module, exports) {
var $47b7debb288af193$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// @schemaDefinition: A GraphQL type schema in shorthand
// @resolvers: Definitions for resolvers to be merged with schema
var $47b7debb288af193$var$SchemaError = /** @class */ function(_super) {
    $47b7debb288af193$var$__extends(SchemaError, _super);
    function SchemaError(message) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return SchemaError;
}(Error);
module.exports.default = $47b7debb288af193$var$SchemaError;

});



parcelRegister("hbdmQ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $9CBYi = parcelRequire("9CBYi");
var $6BdRO = parcelRequire("6BdRO");

var $hompL = parcelRequire("hompL");

var $crrCr = parcelRequire("crrCr");
// This function wraps addMockFunctionsToSchema for more convenience
function $c81dd5440f0cf1c4$var$mockServer(schema, mocks, preserveResolvers) {
    if (preserveResolvers === void 0) preserveResolvers = false;
    var mySchema;
    if (!(schema instanceof $6BdRO.GraphQLSchema)) // TODO: provide useful error messages here if this fails
    mySchema = $crrCr.buildSchemaFromTypeDefinitions(schema);
    else mySchema = schema;
    $c81dd5440f0cf1c4$var$addMockFunctionsToSchema({
        schema: mySchema,
        mocks: mocks,
        preserveResolvers: preserveResolvers
    });
    return {
        query: function(query, vars) {
            return $9CBYi.graphql(mySchema, query, {}, {}, vars);
        }
    };
}
module.exports.mockServer = $c81dd5440f0cf1c4$var$mockServer;
var $c81dd5440f0cf1c4$var$defaultMockMap = new Map();
$c81dd5440f0cf1c4$var$defaultMockMap.set('Int', function() {
    return Math.round(Math.random() * 200) - 100;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('Float', function() {
    return Math.random() * 200 - 100;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('String', function() {
    return 'Hello World';
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('Boolean', function() {
    return Math.random() > 0.5;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('ID', function() {
    return $hompL.v4();
});
// TODO allow providing a seed such that lengths of list could be deterministic
// this could be done by using casual to get a random list length if the casual
// object is global.
function $c81dd5440f0cf1c4$var$addMockFunctionsToSchema(_a) {
    var schema = _a.schema, _b = _a.mocks, mocks = _b === void 0 ? {} : _b, _c = _a.preserveResolvers, preserveResolvers = _c === void 0 ? false : _c;
    if (!schema) throw new Error('Must provide schema to mock');
    if (!(schema instanceof $6BdRO.GraphQLSchema)) throw new Error('Value at "schema" must be of type GraphQLSchema');
    if (!$c81dd5440f0cf1c4$var$isObject(mocks)) throw new Error('mocks must be of type Object');
    // use Map internally, because that API is nicer.
    var mockFunctionMap = new Map();
    Object.keys(mocks).forEach(function(typeName) {
        mockFunctionMap.set(typeName, mocks[typeName]);
    });
    mockFunctionMap.forEach(function(mockFunction, mockTypeName) {
        if (typeof mockFunction !== 'function') throw new Error("mockFunctionMap[" + mockTypeName + "] must be a function");
    });
    var mockType = function(type, typeName, fieldName) {
        // order of precendence for mocking:
        // 1. if the object passed in already has fieldName, just use that
        // --> if it's a function, that becomes your resolver
        // --> if it's a value, the mock resolver will return that
        // 2. if the nullableType is a list, recurse
        // 2. if there's a mock defined for this typeName, that will be used
        // 3. if there's no mock defined, use the default mocks for this type
        return function(root, args, context, info) {
            // nullability doesn't matter for the purpose of mocking.
            var fieldType = $lXoEQ.getNullableType(type);
            var namedFieldType = $lXoEQ.getNamedType(fieldType);
            if (root && typeof root[fieldName] !== 'undefined') {
                var result = void 0;
                // if we're here, the field is already defined
                if (typeof root[fieldName] === 'function') {
                    result = root[fieldName](root, args, context, info);
                    if (result instanceof $c81dd5440f0cf1c4$var$MockList) result = result.mock(root, args, context, info, fieldType, mockType);
                } else result = root[fieldName];
                // Now we merge the result with the default mock for this type.
                // This allows overriding defaults while writing very little code.
                if (mockFunctionMap.has(namedFieldType.name)) result = $c81dd5440f0cf1c4$var$mergeMocks(mockFunctionMap.get(namedFieldType.name).bind(null, root, args, context, info), result);
                return result;
            }
            if (fieldType instanceof $lXoEQ.GraphQLList || fieldType instanceof $lXoEQ.GraphQLNonNull) return [
                mockType(fieldType.ofType)(root, args, context, info),
                mockType(fieldType.ofType)(root, args, context, info)
            ];
            if (mockFunctionMap.has(fieldType.name) && !(fieldType instanceof $lXoEQ.GraphQLUnionType || fieldType instanceof $lXoEQ.GraphQLInterfaceType)) // the object passed doesn't have this field, so we apply the default mock
            return mockFunctionMap.get(fieldType.name)(root, args, context, info);
            if (fieldType instanceof $lXoEQ.GraphQLObjectType) // objects don't return actual data, we only need to mock scalars!
            return {};
            // if a mock function is provided for unionType or interfaceType, execute it to resolve the concrete type
            // otherwise randomly pick a type from all implementation types
            if (fieldType instanceof $lXoEQ.GraphQLUnionType || fieldType instanceof $lXoEQ.GraphQLInterfaceType) {
                var implementationType = void 0;
                if (mockFunctionMap.has(fieldType.name)) {
                    var interfaceMockObj = mockFunctionMap.get(fieldType.name)(root, args, context, info);
                    if (!interfaceMockObj || !interfaceMockObj.__typename) return Error("Please return a __typename in \"" + fieldType.name + "\"");
                    implementationType = schema.getType(interfaceMockObj.__typename);
                } else {
                    var possibleTypes = schema.getPossibleTypes(fieldType);
                    implementationType = $c81dd5440f0cf1c4$var$getRandomElement(possibleTypes);
                }
                return Object.assign({
                    __typename: implementationType
                }, mockType(implementationType)(root, args, context, info));
            }
            if (fieldType instanceof $lXoEQ.GraphQLEnumType) return $c81dd5440f0cf1c4$var$getRandomElement(fieldType.getValues()).value;
            if ($c81dd5440f0cf1c4$var$defaultMockMap.has(fieldType.name)) return $c81dd5440f0cf1c4$var$defaultMockMap.get(fieldType.name)(root, args, context, info);
            // if we get to here, we don't have a value, and we don't have a mock for this type,
            // we could return undefined, but that would be hard to debug, so we throw instead.
            // however, we returning it instead of throwing it, so preserveResolvers can handle the failures.
            return Error("No mock defined for type \"" + fieldType.name + "\"");
        };
    };
    $crrCr.forEachField(schema, function(field, typeName, fieldName) {
        $c81dd5440f0cf1c4$var$assignResolveType(field.type, preserveResolvers);
        var mockResolver;
        // we have to handle the root mutation and root query types differently,
        // because no resolver is called at the root.
        /* istanbul ignore next: Must provide schema DefinitionNode with query type or a type named Query. */ var isOnQueryType = schema.getQueryType() && schema.getQueryType().name === typeName;
        var isOnMutationType = schema.getMutationType() && schema.getMutationType().name === typeName;
        if (isOnQueryType || isOnMutationType) {
            if (mockFunctionMap.has(typeName)) {
                var rootMock_1 = mockFunctionMap.get(typeName);
                // XXX: BUG in here, need to provide proper signature for rootMock.
                if (typeof rootMock_1(undefined, {}, {}, {})[fieldName] === 'function') mockResolver = function(root, args, context, info) {
                    var updatedRoot = root || {}; // TODO: should we clone instead?
                    updatedRoot[fieldName] = rootMock_1(root, args, context, info)[fieldName];
                    // XXX this is a bit of a hack to still use mockType, which
                    // lets you mock lists etc. as well
                    // otherwise we could just set field.resolve to rootMock()[fieldName]
                    // it's like pretending there was a resolve function that ran before
                    // the root resolve function.
                    return mockType(field.type, typeName, fieldName)(updatedRoot, args, context, info);
                };
            }
        }
        if (!mockResolver) mockResolver = mockType(field.type, typeName, fieldName);
        if (!preserveResolvers || !field.resolve) field.resolve = mockResolver;
        else {
            var oldResolver_1 = field.resolve;
            field.resolve = function(rootObject, args, context, info) {
                return Promise.all([
                    mockResolver(rootObject, args, context, info),
                    oldResolver_1(rootObject, args, context, info)
                ]).then(function(values) {
                    var mockedValue = values[0], resolvedValue = values[1];
                    // In case we couldn't mock
                    if (mockedValue instanceof Error) {
                        // only if value was not resolved, populate the error.
                        if (undefined === resolvedValue) throw mockedValue;
                        return resolvedValue;
                    }
                    if (resolvedValue instanceof Date && mockedValue instanceof Date) return undefined !== resolvedValue ? resolvedValue : mockedValue;
                    if ($c81dd5440f0cf1c4$var$isObject(mockedValue) && $c81dd5440f0cf1c4$var$isObject(resolvedValue)) {
                        // Object.assign() won't do here, as we need to all properties, including
                        // the non-enumerable ones and defined using Object.defineProperty
                        var emptyObject = Object.create(Object.getPrototypeOf(resolvedValue));
                        return $c81dd5440f0cf1c4$var$copyOwnProps(emptyObject, resolvedValue, mockedValue);
                    }
                    return undefined !== resolvedValue ? resolvedValue : mockedValue;
                });
            };
        }
    });
}
module.exports.addMockFunctionsToSchema = $c81dd5440f0cf1c4$var$addMockFunctionsToSchema;
function $c81dd5440f0cf1c4$var$isObject(thing) {
    return thing === Object(thing) && !Array.isArray(thing);
}
// returns a random element from that ary
function $c81dd5440f0cf1c4$var$getRandomElement(ary) {
    var sample = Math.floor(Math.random() * ary.length);
    return ary[sample];
}
function $c81dd5440f0cf1c4$var$mergeObjects(a, b) {
    return Object.assign(a, b);
}
function $c81dd5440f0cf1c4$var$copyOwnPropsIfNotPresent(target, source) {
    Object.getOwnPropertyNames(source).forEach(function(prop) {
        if (!Object.getOwnPropertyDescriptor(target, prop)) Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop));
    });
}
function $c81dd5440f0cf1c4$var$copyOwnProps(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        var chain = source;
        while(chain){
            $c81dd5440f0cf1c4$var$copyOwnPropsIfNotPresent(target, chain);
            chain = Object.getPrototypeOf(chain);
        }
    });
    return target;
}
// takes either an object or a (possibly nested) array
// and completes the customMock object with any fields
// defined on genericMock
// only merges objects or arrays. Scalars are returned as is
function $c81dd5440f0cf1c4$var$mergeMocks(genericMockFunction, customMock) {
    if (Array.isArray(customMock)) return customMock.map(function(el) {
        return $c81dd5440f0cf1c4$var$mergeMocks(genericMockFunction, el);
    });
    if ($c81dd5440f0cf1c4$var$isObject(customMock)) return $c81dd5440f0cf1c4$var$mergeObjects(genericMockFunction(), customMock);
    return customMock;
}
function $c81dd5440f0cf1c4$var$getResolveType(namedFieldType) {
    if (namedFieldType instanceof $lXoEQ.GraphQLInterfaceType || namedFieldType instanceof $lXoEQ.GraphQLUnionType) return namedFieldType.resolveType;
    else return undefined;
}
function $c81dd5440f0cf1c4$var$assignResolveType(type, preserveResolvers) {
    var fieldType = $lXoEQ.getNullableType(type);
    var namedFieldType = $lXoEQ.getNamedType(fieldType);
    var oldResolveType = $c81dd5440f0cf1c4$var$getResolveType(namedFieldType);
    if (preserveResolvers && oldResolveType && oldResolveType.length) return;
    if (namedFieldType instanceof $lXoEQ.GraphQLUnionType || namedFieldType instanceof $lXoEQ.GraphQLInterfaceType) // the default `resolveType` always returns null. We add a fallback
    // resolution that works with how unions and interface are mocked
    namedFieldType.resolveType = function(data, context, info) {
        return info.schema.getType(data.__typename);
    };
}
var $c81dd5440f0cf1c4$var$MockList = /** @class */ function() {
    // wrappedFunction can return another MockList or a value
    function MockList(len, wrappedFunction) {
        this.len = len;
        if (typeof wrappedFunction !== 'undefined') {
            if (typeof wrappedFunction !== 'function') throw new Error('Second argument to MockList must be a function or undefined');
            this.wrappedFunction = wrappedFunction;
        }
    }
    MockList.prototype.mock = function(root, args, context, info, fieldType, mockTypeFunc) {
        var arr;
        if (Array.isArray(this.len)) arr = new Array(this.randint(this.len[0], this.len[1]));
        else arr = new Array(this.len);
        for(var i = 0; i < arr.length; i++)if (typeof this.wrappedFunction === 'function') {
            var res = this.wrappedFunction(root, args, context, info);
            if (res instanceof MockList) {
                var nullableType = $lXoEQ.getNullableType(fieldType.ofType);
                arr[i] = res.mock(root, args, context, info, nullableType, mockTypeFunc);
            } else arr[i] = res;
        } else arr[i] = mockTypeFunc(fieldType.ofType)(root, args, context, info);
        return arr;
    };
    MockList.prototype.randint = function(low, high) {
        return Math.floor(Math.random() * (high - low + 1) + low);
    };
    return MockList;
}();
module.exports.MockList = $c81dd5440f0cf1c4$var$MockList;

});
parcelRegister("9CBYi", function(module, exports) {

$parcel$export(module.exports, "graphql", () => $c4e440e580a0befe$export$1eb4e7c0ed67b035);

var $cvCbM = parcelRequire("cvCbM");

var $6ds0g = parcelRequire("6ds0g");

var $dGflO = parcelRequire("dGflO");

var $izaFt = parcelRequire("izaFt");

var $3MP74 = parcelRequire("3MP74");
function $c4e440e580a0befe$export$1eb4e7c0ed67b035(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    var _arguments = arguments;
    /* eslint-enable no-redeclare */ // Always return a Promise for a consistent API.
    return new Promise(function(resolve) {
        return resolve(_arguments.length === 1 ? $c4e440e580a0befe$var$graphqlImpl(argsOrSchema) : $c4e440e580a0befe$var$graphqlImpl({
            schema: argsOrSchema,
            source: source,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            typeResolver: typeResolver
        }));
    });
}
function $c4e440e580a0befe$export$51b1816fb8b0711e(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    var result = arguments.length === 1 ? $c4e440e580a0befe$var$graphqlImpl(argsOrSchema) : $c4e440e580a0befe$var$graphqlImpl({
        schema: argsOrSchema,
        source: source,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    }); // Assert that the execution was synchronous.
    if ((0, $cvCbM.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function $c4e440e580a0befe$var$graphqlImpl(args) {
    var schema = args.schema, source = args.source, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // Validate Schema
    var schemaValidationErrors = (0, $izaFt.validateSchema)(schema);
    if (schemaValidationErrors.length > 0) return {
        errors: schemaValidationErrors
    };
     // Parse
    var document;
    try {
        document = (0, $6ds0g.parse)(source);
    } catch (syntaxError) {
        return {
            errors: [
                syntaxError
            ]
        };
    } // Validate
    var validationErrors = (0, $dGflO.validate)(schema, document);
    if (validationErrors.length > 0) return {
        errors: validationErrors
    };
     // Execute
    return (0, $3MP74.execute)({
        schema: schema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}

});


parcelRegister("akAyp", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1kTmX = parcelRequire("1kTmX");
module.exports.makeRemoteExecutableSchema = $1kTmX.default;
module.exports.defaultCreateRemoteResolver = $1kTmX.createResolver;

var $cns77 = parcelRequire("cns77");
module.exports.introspectSchema = $cns77.default;

var $2KwZj = parcelRequire("2KwZj");
module.exports.mergeSchemas = $2KwZj.default;

var $7UWAA = parcelRequire("7UWAA");
module.exports.delegateToSchema = $7UWAA.default;

var $8je8M = parcelRequire("8je8M");
module.exports.defaultMergedResolver = $8je8M.default;

});
parcelRegister("1kTmX", function(module, exports) {
var $0f929bdd6e89143d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0f929bdd6e89143d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0f929bdd6e89143d$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gUA8G = parcelRequire("gUA8G");
var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $gQVH8 = parcelRequire("gQVH8");

var $i07ri = parcelRequire("i07ri");

var $hRrcw = parcelRequire("hRrcw");

var $crrCr = parcelRequire("crrCr");

var $h8S1f = parcelRequire("h8S1f");

var $j0Odg = parcelRequire("j0Odg");

var $8je8M = parcelRequire("8je8M");

var $10LTa = parcelRequire("10LTa");

var $583I3 = parcelRequire("583I3");
function $0f929bdd6e89143d$var$makeRemoteExecutableSchema(_a) {
    var _b;
    var schema = _a.schema, link = _a.link, fetcher = _a.fetcher, _c = _a.createResolver, customCreateResolver = _c === void 0 ? $0f929bdd6e89143d$var$createResolver : _c, buildSchemaOptions = _a.buildSchemaOptions, _d = _a.printSchemaOptions, printSchemaOptions = _d === void 0 ? {
        commentDescriptions: true
    } : _d;
    if (!fetcher && link) fetcher = $i07ri.default(link);
    var typeDefs;
    if (typeof schema === 'string') {
        typeDefs = schema;
        schema = $gUA8G.buildSchema(typeDefs, buildSchemaOptions);
    } else typeDefs = $gQVH8.printSchema(schema, printSchemaOptions);
    // prepare query resolvers
    var queryResolvers = {};
    var queryType = schema.getQueryType();
    var queries = queryType.getFields();
    Object.keys(queries).forEach(function(key) {
        queryResolvers[key] = customCreateResolver(fetcher);
    });
    // prepare mutation resolvers
    var mutationResolvers = {};
    var mutationType = schema.getMutationType();
    if (mutationType) {
        var mutations = mutationType.getFields();
        Object.keys(mutations).forEach(function(key) {
            mutationResolvers[key] = customCreateResolver(fetcher);
        });
    }
    // prepare subscription resolvers
    var subscriptionResolvers = {};
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) {
        var subscriptions = subscriptionType.getFields();
        Object.keys(subscriptions).forEach(function(key) {
            subscriptionResolvers[key] = {
                subscribe: $0f929bdd6e89143d$var$createSubscriptionResolver(key, link)
            };
        });
    }
    // merge resolvers into resolver map
    var resolvers = (_b = {}, _b[queryType.name] = queryResolvers, _b);
    if (!$hRrcw.default(mutationResolvers)) resolvers[mutationType.name] = mutationResolvers;
    if (!$hRrcw.default(subscriptionResolvers)) resolvers[subscriptionType.name] = subscriptionResolvers;
    // add missing abstract resolvers (scalar, unions, interfaces)
    var typeMap = schema.getTypeMap();
    var types = Object.keys(typeMap).map(function(name) {
        return typeMap[name];
    });
    var _loop_1 = function(type) {
        if (type instanceof $lXoEQ.GraphQLInterfaceType || type instanceof $lXoEQ.GraphQLUnionType) resolvers[type.name] = {
            __resolveType: function(parent, context, info) {
                return $j0Odg.default(parent, info.schema);
            }
        };
        else if (type instanceof $lXoEQ.GraphQLScalarType) {
            if (!(type === $auu22.GraphQLID || type === $auu22.GraphQLString || type === $auu22.GraphQLFloat || type === $auu22.GraphQLBoolean || type === $auu22.GraphQLInt)) resolvers[type.name] = $h8S1f.recreateType(type, function(name) {
                return null;
            }, false);
        } else if (type instanceof $lXoEQ.GraphQLObjectType && type.name.slice(0, 2) !== '__' && type !== queryType && type !== mutationType && type !== subscriptionType) {
            var resolver_1 = {};
            Object.keys(type.getFields()).forEach(function(field) {
                resolver_1[field] = $8je8M.default;
            });
            resolvers[type.name] = resolver_1;
        }
    };
    for(var _i = 0, types_1 = types; _i < types_1.length; _i++){
        var type = types_1[_i];
        _loop_1(type);
    }
    return $crrCr.makeExecutableSchema({
        typeDefs: typeDefs,
        resolvers: resolvers
    });
}
module.exports.default = $0f929bdd6e89143d$var$makeRemoteExecutableSchema;
function $0f929bdd6e89143d$var$createResolver(fetcher) {
    var _this = this;
    return function(root, args, context, info) {
        return $0f929bdd6e89143d$var$__awaiter(_this, void 0, void 0, function() {
            var fragments, document, result;
            return $0f929bdd6e89143d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragments = Object.keys(info.fragments).map(function(fragment) {
                            return info.fragments[fragment];
                        });
                        document = {
                            kind: $1c4hI.Kind.DOCUMENT,
                            definitions: $0f929bdd6e89143d$var$__spreadArrays([
                                info.operation
                            ], fragments)
                        };
                        return [
                            4 /*yield*/ ,
                            fetcher({
                                query: document,
                                variables: info.variableValues,
                                context: {
                                    graphqlContext: context
                                }
                            })
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            $10LTa.checkResultAndHandleErrors(result, info)
                        ];
                }
            });
        });
    };
}
module.exports.createResolver = $0f929bdd6e89143d$var$createResolver;
function $0f929bdd6e89143d$var$createSubscriptionResolver(name, link) {
    return function(root, args, context, info) {
        var fragments = Object.keys(info.fragments).map(function(fragment) {
            return info.fragments[fragment];
        });
        var document = {
            kind: $1c4hI.Kind.DOCUMENT,
            definitions: $0f929bdd6e89143d$var$__spreadArrays([
                info.operation
            ], fragments)
        };
        var operation = {
            query: document,
            variables: info.variableValues,
            context: {
                graphqlContext: context
            }
        };
        var observable = $i07ri.execute(link, operation);
        return $583I3.observableToAsyncIterable(observable);
    };
}

});
parcelRegister("gQVH8", function(module, exports) {

$parcel$export(module.exports, "printSchema", () => $ad02b274e585f6bd$export$f7c984b74d0fc2e7);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $aKlnM = parcelRequire("aKlnM");

var $flA0a = parcelRequire("flA0a");

var $h2iUh = parcelRequire("h2iUh");

var $auu22 = parcelRequire("auu22");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $cMIyS = parcelRequire("cMIyS");
function $ad02b274e585f6bd$export$f7c984b74d0fc2e7(schema, options) {
    return $ad02b274e585f6bd$var$printFilteredSchema(schema, function(n) {
        return !(0, $bOniD.isSpecifiedDirective)(n);
    }, $ad02b274e585f6bd$var$isDefinedType, options);
}
function $ad02b274e585f6bd$export$436bfe9e87d1be55(schema, options) {
    return $ad02b274e585f6bd$var$printFilteredSchema(schema, (0, $bOniD.isSpecifiedDirective), (0, $h2iUh.isIntrospectionType), options);
}
function $ad02b274e585f6bd$var$isDefinedType(type) {
    return !(0, $auu22.isSpecifiedScalarType)(type) && !(0, $h2iUh.isIntrospectionType)(type);
}
function $ad02b274e585f6bd$var$printFilteredSchema(schema, directiveFilter, typeFilter, options) {
    var directives = schema.getDirectives().filter(directiveFilter);
    var types = (0, $dVq2R.default)(schema.getTypeMap()).filter(typeFilter);
    return [
        $ad02b274e585f6bd$var$printSchemaDefinition(schema)
    ].concat(directives.map(function(directive) {
        return $ad02b274e585f6bd$var$printDirective(directive, options);
    }), types.map(function(type) {
        return $ad02b274e585f6bd$export$199528f8b0f9bf49(type, options);
    })).filter(Boolean).join('\n\n') + '\n';
}
function $ad02b274e585f6bd$var$printSchemaDefinition(schema) {
    if (schema.description == null && $ad02b274e585f6bd$var$isSchemaOfCommonNames(schema)) return;
    var operationTypes = [];
    var queryType = schema.getQueryType();
    if (queryType) operationTypes.push("  query: ".concat(queryType.name));
    var mutationType = schema.getMutationType();
    if (mutationType) operationTypes.push("  mutation: ".concat(mutationType.name));
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) operationTypes.push("  subscription: ".concat(subscriptionType.name));
    return $ad02b274e585f6bd$var$printDescription({}, schema) + "schema {\n".concat(operationTypes.join('\n'), "\n}");
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *   }
 *
 * When using this naming convention, the schema description can be omitted.
 */ function $ad02b274e585f6bd$var$isSchemaOfCommonNames(schema) {
    var queryType = schema.getQueryType();
    if (queryType && queryType.name !== 'Query') return false;
    var mutationType = schema.getMutationType();
    if (mutationType && mutationType.name !== 'Mutation') return false;
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && subscriptionType.name !== 'Subscription') return false;
    return true;
}
function $ad02b274e585f6bd$export$199528f8b0f9bf49(type, options) {
    if ((0, $lXoEQ.isScalarType)(type)) return $ad02b274e585f6bd$var$printScalar(type, options);
    if ((0, $lXoEQ.isObjectType)(type)) return $ad02b274e585f6bd$var$printObject(type, options);
    if ((0, $lXoEQ.isInterfaceType)(type)) return $ad02b274e585f6bd$var$printInterface(type, options);
    if ((0, $lXoEQ.isUnionType)(type)) return $ad02b274e585f6bd$var$printUnion(type, options);
    if ((0, $lXoEQ.isEnumType)(type)) return $ad02b274e585f6bd$var$printEnum(type, options);
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isInputObjectType)(type)) return $ad02b274e585f6bd$var$printInputObject(type, options);
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
}
function $ad02b274e585f6bd$var$printScalar(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "scalar ".concat(type.name) + $ad02b274e585f6bd$var$printSpecifiedByUrl(type);
}
function $ad02b274e585f6bd$var$printImplementedInterfaces(type) {
    var interfaces = type.getInterfaces();
    return interfaces.length ? ' implements ' + interfaces.map(function(i) {
        return i.name;
    }).join(' & ') : '';
}
function $ad02b274e585f6bd$var$printObject(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "type ".concat(type.name) + $ad02b274e585f6bd$var$printImplementedInterfaces(type) + $ad02b274e585f6bd$var$printFields(options, type);
}
function $ad02b274e585f6bd$var$printInterface(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "interface ".concat(type.name) + $ad02b274e585f6bd$var$printImplementedInterfaces(type) + $ad02b274e585f6bd$var$printFields(options, type);
}
function $ad02b274e585f6bd$var$printUnion(type, options) {
    var types = type.getTypes();
    var possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
    return $ad02b274e585f6bd$var$printDescription(options, type) + 'union ' + type.name + possibleTypes;
}
function $ad02b274e585f6bd$var$printEnum(type, options) {
    var values = type.getValues().map(function(value, i) {
        return $ad02b274e585f6bd$var$printDescription(options, value, '  ', !i) + '  ' + value.name + $ad02b274e585f6bd$var$printDeprecated(value.deprecationReason);
    });
    return $ad02b274e585f6bd$var$printDescription(options, type) + "enum ".concat(type.name) + $ad02b274e585f6bd$var$printBlock(values);
}
function $ad02b274e585f6bd$var$printInputObject(type, options) {
    var fields = (0, $dVq2R.default)(type.getFields()).map(function(f, i) {
        return $ad02b274e585f6bd$var$printDescription(options, f, '  ', !i) + '  ' + $ad02b274e585f6bd$var$printInputValue(f);
    });
    return $ad02b274e585f6bd$var$printDescription(options, type) + "input ".concat(type.name) + $ad02b274e585f6bd$var$printBlock(fields);
}
function $ad02b274e585f6bd$var$printFields(options, type) {
    var fields = (0, $dVq2R.default)(type.getFields()).map(function(f, i) {
        return $ad02b274e585f6bd$var$printDescription(options, f, '  ', !i) + '  ' + f.name + $ad02b274e585f6bd$var$printArgs(options, f.args, '  ') + ': ' + String(f.type) + $ad02b274e585f6bd$var$printDeprecated(f.deprecationReason);
    });
    return $ad02b274e585f6bd$var$printBlock(fields);
}
function $ad02b274e585f6bd$var$printBlock(items) {
    return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}
function $ad02b274e585f6bd$var$printArgs(options, args) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    if (args.length === 0) return '';
     // If every arg does not have a description, print them on one line.
    if (args.every(function(arg) {
        return !arg.description;
    })) return '(' + args.map($ad02b274e585f6bd$var$printInputValue).join(', ') + ')';
    return '(\n' + args.map(function(arg, i) {
        return $ad02b274e585f6bd$var$printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + $ad02b274e585f6bd$var$printInputValue(arg);
    }).join('\n') + '\n' + indentation + ')';
}
function $ad02b274e585f6bd$var$printInputValue(arg) {
    var defaultAST = (0, $cMIyS.astFromValue)(arg.defaultValue, arg.type);
    var argDecl = arg.name + ': ' + String(arg.type);
    if (defaultAST) argDecl += " = ".concat((0, $aKlnM.print)(defaultAST));
    return argDecl + $ad02b274e585f6bd$var$printDeprecated(arg.deprecationReason);
}
function $ad02b274e585f6bd$var$printDirective(directive, options) {
    return $ad02b274e585f6bd$var$printDescription(options, directive) + 'directive @' + directive.name + $ad02b274e585f6bd$var$printArgs(options, directive.args) + (directive.isRepeatable ? ' repeatable' : '') + ' on ' + directive.locations.join(' | ');
}
function $ad02b274e585f6bd$var$printDeprecated(reason) {
    if (reason == null) return '';
    var reasonAST = (0, $cMIyS.astFromValue)(reason, (0, $auu22.GraphQLString));
    if (reasonAST && reason !== (0, $bOniD.DEFAULT_DEPRECATION_REASON)) return ' @deprecated(reason: ' + (0, $aKlnM.print)(reasonAST) + ')';
    return ' @deprecated';
}
function $ad02b274e585f6bd$var$printSpecifiedByUrl(scalar) {
    if (scalar.specifiedByUrl == null) return '';
    var url = scalar.specifiedByUrl;
    var urlAST = (0, $cMIyS.astFromValue)(url, (0, $auu22.GraphQLString));
    urlAST || (0, $43MJl.default)(0, 'Unexpected null value returned from `astFromValue` for specifiedByUrl');
    return ' @specifiedBy(url: ' + (0, $aKlnM.print)(urlAST) + ')';
}
function $ad02b274e585f6bd$var$printDescription(options, def) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var description = def.description;
    if (description == null) return '';
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) return $ad02b274e585f6bd$var$printDescriptionWithComments(description, indentation, firstInBlock);
    var preferMultipleLines = description.length > 70;
    var blockString = (0, $flA0a.printBlockString)(description, '', preferMultipleLines);
    var prefix = indentation && !firstInBlock ? '\n' + indentation : indentation;
    return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}
function $ad02b274e585f6bd$var$printDescriptionWithComments(description, indentation, firstInBlock) {
    var prefix = indentation && !firstInBlock ? '\n' : '';
    var comment = description.split('\n').map(function(line) {
        return indentation + (line !== '' ? '# ' + line : '#');
    }).join('\n');
    return prefix + comment + '\n';
}

});

parcelRegister("i07ri", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bvQX6 = parcelRequire("bvQX6");

var $bvQX6 = parcelRequire("bvQX6");
module.exports.execute = $bvQX6.execute;
function $0361c62ee1cf4ad3$var$linkToFetcher(link) {
    return function(fetcherOperation) {
        return $bvQX6.makePromise($bvQX6.execute(link, fetcherOperation));
    };
}
module.exports.default = $0361c62ee1cf4ad3$var$linkToFetcher;

});

parcelRegister("hRrcw", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $d00c7c79d0194f7f$var$isEmptyObject(obj) {
    if (!obj) return true;
    for(var key in obj){
        if (Object.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
module.exports.default = $d00c7c79d0194f7f$var$isEmptyObject;

});

parcelRegister("583I3", function(module, exports) {
var $3bc093be1df103cf$var$__assign = module.exports && module.exports.__assign || function() {
    $3bc093be1df103cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bc093be1df103cf$var$__assign.apply(this, arguments);
};
var $3bc093be1df103cf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3bc093be1df103cf$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cRJgL = parcelRequire("cRJgL");
function $3bc093be1df103cf$var$observableToAsyncIterable(observable) {
    var _a;
    var pullQueue = [];
    var pushQueue = [];
    var listening = true;
    var pushValue = function(_a) {
        var data = _a.data;
        if (pullQueue.length !== 0) pullQueue.shift()({
            value: data,
            done: false
        });
        else pushQueue.push({
            value: data
        });
    };
    var pushError = function(error) {
        if (pullQueue.length !== 0) pullQueue.shift()({
            value: {
                errors: [
                    error
                ]
            },
            done: false
        });
        else pushQueue.push({
            value: {
                errors: [
                    error
                ]
            }
        });
    };
    var pullValue = function() {
        return new Promise(function(resolve) {
            if (pushQueue.length !== 0) {
                var element = pushQueue.shift();
                // either {value: {errors: [...]}} or {value: ...}
                resolve($3bc093be1df103cf$var$__assign($3bc093be1df103cf$var$__assign({}, element), {
                    done: false
                }));
            } else pullQueue.push(resolve);
        });
    };
    var subscription = observable.subscribe({
        next: function(value) {
            pushValue(value);
        },
        error: function(err) {
            pushError(err);
        }
    });
    var emptyQueue = function() {
        if (listening) {
            listening = false;
            subscription.unsubscribe();
            pullQueue.forEach(function(resolve) {
                return resolve({
                    value: undefined,
                    done: true
                });
            });
            pullQueue.length = 0;
            pushQueue.length = 0;
        }
    };
    return _a = {
        next: function() {
            return $3bc093be1df103cf$var$__awaiter(this, void 0, void 0, function() {
                return $3bc093be1df103cf$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        listening ? pullValue() : this.return()
                    ];
                });
            });
        },
        return: function() {
            emptyQueue();
            return Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function(error) {
            emptyQueue();
            return Promise.reject(error);
        }
    }, _a[$cRJgL.$$asyncIterator] = function() {
        return this;
    }, _a;
}
module.exports.observableToAsyncIterable = $3bc093be1df103cf$var$observableToAsyncIterable;

});
parcelRegister("cRJgL", function(module, exports) {

$parcel$export(module.exports, "$$asyncIterator", () => $367ded6c6908ab1f$export$5ee754c34122a0ae);
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */ /**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */ /**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */ // In ES2015 environments, Symbol exists
var $367ded6c6908ab1f$var$SYMBOL /*: any */  = typeof Symbol === 'function' ? Symbol : void 0;
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var $367ded6c6908ab1f$var$SYMBOL_ITERATOR = $367ded6c6908ab1f$var$SYMBOL && $367ded6c6908ab1f$var$SYMBOL.iterator;
var $367ded6c6908ab1f$export$9785f547d3164dac = $367ded6c6908ab1f$var$SYMBOL_ITERATOR || '@@iterator';
function $367ded6c6908ab1f$export$9652023d9040757(obj) {
    return !!$367ded6c6908ab1f$export$23f5ee39f998bf6f(obj);
}
function $367ded6c6908ab1f$export$1e2f57719e155213(obj) {
    var length = obj != null && obj.length;
    return typeof length === 'number' && length >= 0 && length % 1 === 0;
}
function $367ded6c6908ab1f$export$cea7aa84e978eba5(obj) {
    return Object(obj) === obj && ($367ded6c6908ab1f$export$1e2f57719e155213(obj) || $367ded6c6908ab1f$export$9652023d9040757(obj));
}
function $367ded6c6908ab1f$export$6731da38428a8625(iterable) {
    var method = $367ded6c6908ab1f$export$23f5ee39f998bf6f(iterable);
    if (method) return method.call(iterable);
}
function $367ded6c6908ab1f$export$23f5ee39f998bf6f(iterable) {
    if (iterable != null) {
        var method = $367ded6c6908ab1f$var$SYMBOL_ITERATOR && iterable[$367ded6c6908ab1f$var$SYMBOL_ITERATOR] || iterable['@@iterator'];
        if (typeof method === 'function') return method;
    }
}
function $367ded6c6908ab1f$export$7342c78d7e13e778(collection) {
    if (collection != null) {
        var iterator = $367ded6c6908ab1f$export$6731da38428a8625(collection);
        if (iterator) return iterator;
        if ($367ded6c6908ab1f$export$1e2f57719e155213(collection)) return new $367ded6c6908ab1f$var$ArrayLikeIterator(collection);
    }
}
// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function $367ded6c6908ab1f$var$ArrayLikeIterator(obj) {
    this._o = obj;
    this._i = 0;
}
// Note: all Iterators are themselves Iterable.
$367ded6c6908ab1f$var$ArrayLikeIterator.prototype[$367ded6c6908ab1f$export$9785f547d3164dac] = function() {
    return this;
};
// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
$367ded6c6908ab1f$var$ArrayLikeIterator.prototype.next = function() {
    if (this._o === void 0 || this._i >= this._o.length) {
        this._o = void 0;
        return {
            value: void 0,
            done: true
        };
    }
    return {
        value: this._o[this._i++],
        done: false
    };
};
function $367ded6c6908ab1f$export$4b80e395e36b5a56(collection, callback, thisArg) {
    if (collection != null) {
        if (typeof collection.forEach === 'function') return collection.forEach(callback, thisArg);
        var i = 0;
        var iterator = $367ded6c6908ab1f$export$6731da38428a8625(collection);
        if (iterator) {
            var step;
            while(!(step = iterator.next()).done){
                callback.call(thisArg, step.value, i++, collection);
                // Infinite Iterators could cause forEach to run forever.
                // After a very large number of iterations, produce an error.
                /* istanbul ignore if */ if (i > 9999999) throw new TypeError('Near-infinite iteration.');
            }
        } else if ($367ded6c6908ab1f$export$1e2f57719e155213(collection)) {
            for(; i < collection.length; i++)if (collection.hasOwnProperty(i)) callback.call(thisArg, collection[i], i, collection);
        }
    }
}
/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////
/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */ /**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */ // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR = $367ded6c6908ab1f$var$SYMBOL && $367ded6c6908ab1f$var$SYMBOL.asyncIterator;
var $367ded6c6908ab1f$export$5ee754c34122a0ae = $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR || '@@asyncIterator';
function $367ded6c6908ab1f$export$edb10ab8dd75a915(obj) {
    return !!$367ded6c6908ab1f$export$b39a85787ec1202f(obj);
}
function $367ded6c6908ab1f$export$d5127502cdffbf83(asyncIterable) {
    var method = $367ded6c6908ab1f$export$b39a85787ec1202f(asyncIterable);
    if (method) return method.call(asyncIterable);
}
function $367ded6c6908ab1f$export$b39a85787ec1202f(asyncIterable) {
    if (asyncIterable != null) {
        var method = $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR && asyncIterable[$367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR] || asyncIterable['@@asyncIterator'];
        if (typeof method === 'function') return method;
    }
}
function $367ded6c6908ab1f$export$86c18c6347f4a8c4(source) {
    if (source != null) {
        var asyncIterator = $367ded6c6908ab1f$export$d5127502cdffbf83(source);
        if (asyncIterator) return asyncIterator;
        var iterator = $367ded6c6908ab1f$export$7342c78d7e13e778(source);
        if (iterator) return new $367ded6c6908ab1f$var$AsyncFromSyncIterator(iterator);
    }
}
// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function $367ded6c6908ab1f$var$AsyncFromSyncIterator(iterator) {
    this._i = iterator;
}
// Note: all AsyncIterators are themselves AsyncIterable.
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype[$367ded6c6908ab1f$export$5ee754c34122a0ae] = function() {
    return this;
};
// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.next = function(value) {
    return $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'next', value);
};
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.return = function(value) {
    return this._i.return ? $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'return', value) : Promise.resolve({
        value: value,
        done: true
    });
};
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.throw = function(value) {
    return this._i.throw ? $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'throw', value) : Promise.reject(value);
};
function $367ded6c6908ab1f$var$unwrapAsyncFromSync(iterator, fn, value) {
    var step;
    return new Promise(function(resolve) {
        step = iterator[fn](value);
        resolve(step.value);
    }).then(function(value) {
        return {
            value: value,
            done: step.done
        };
    });
}
function $367ded6c6908ab1f$export$186aebae43ba1fda(source, callback, thisArg) {
    var asyncIterator = $367ded6c6908ab1f$export$86c18c6347f4a8c4(source);
    if (asyncIterator) {
        var i = 0;
        return new Promise(function(resolve, reject) {
            function next() {
                asyncIterator.next().then(function(step) {
                    if (!step.done) Promise.resolve(callback.call(thisArg, step.value, i++, source)).then(next).catch(reject);
                    else resolve();
                    // Explicitly return null, silencing bluebird-style warnings.
                    return null;
                }).catch(reject);
                // Explicitly return null, silencing bluebird-style warnings.
                return null;
            }
            next();
        });
    }
}

});



parcelRegister("cns77", function(module, exports) {
var $902d70db2f1b5675$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $902d70db2f1b5675$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kYuQD = parcelRequire("kYuQD");
var $6ds0g = parcelRequire("6ds0g");

var $iZRls = parcelRequire("iZRls");

var $i07ri = parcelRequire("i07ri");
var $902d70db2f1b5675$var$parsedIntrospectionQuery = $6ds0g.parse($iZRls.getIntrospectionQuery());
function $902d70db2f1b5675$var$introspectSchema(fetcher, linkContext) {
    return $902d70db2f1b5675$var$__awaiter(this, void 0, void 0, function() {
        var introspectionResult, schema;
        return $902d70db2f1b5675$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    // Convert link to fetcher
                    if (fetcher.request) fetcher = $i07ri.default(fetcher);
                    return [
                        4 /*yield*/ ,
                        fetcher({
                            query: $902d70db2f1b5675$var$parsedIntrospectionQuery,
                            context: linkContext
                        })
                    ];
                case 1:
                    introspectionResult = _a.sent();
                    if (introspectionResult.errors && introspectionResult.errors.length || !introspectionResult.data.__schema) throw introspectionResult.errors;
                    else {
                        schema = $kYuQD.buildClientSchema(introspectionResult.data);
                        return [
                            2 /*return*/ ,
                            schema
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.default = $902d70db2f1b5675$var$introspectSchema;

});
parcelRegister("kYuQD", function(module, exports) {

$parcel$export(module.exports, "buildClientSchema", () => $b48bf1e0077cad25$export$de8c236cf09c987c);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $2AFgT = parcelRequire("2AFgT");

var $fbtyx = parcelRequire("fbtyx");

var $6ds0g = parcelRequire("6ds0g");

var $6BdRO = parcelRequire("6BdRO");

var $bOniD = parcelRequire("bOniD");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");

var $lXoEQ = parcelRequire("lXoEQ");

var $3E0nn = parcelRequire("3E0nn");
function $b48bf1e0077cad25$export$de8c236cf09c987c(introspection, options) {
    (0, $fbtyx.default)(introspection) && (0, $fbtyx.default)(introspection.__schema) || (0, $fZdRY.default)(0, "Invalid or incomplete introspection result. Ensure that you are passing \"data\" property of introspection response and no \"errors\" was returned alongside: ".concat((0, $biK02.default)(introspection), ".")); // Get the schema from the introspection result.
    var schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.
    var typeMap = (0, $2AFgT.default)(schemaIntrospection.types, function(typeIntrospection) {
        return typeIntrospection.name;
    }, function(typeIntrospection) {
        return buildType(typeIntrospection);
    }); // Include standard types only if they are used.
    for(var _i2 = 0, _ref2 = [].concat((0, $auu22.specifiedScalarTypes), (0, $h2iUh.introspectionTypes)); _i2 < _ref2.length; _i2++){
        var stdType = _ref2[_i2];
        if (typeMap[stdType.name]) typeMap[stdType.name] = stdType;
    } // Get the root Query, Mutation, and Subscription types.
    var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
    var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
    var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
    // directives were not queried for.
    var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.
    return new (0, $6BdRO.GraphQLSchema)({
        description: schemaIntrospection.description,
        query: queryType,
        mutation: mutationType,
        subscription: subscriptionType,
        types: (0, $dVq2R.default)(typeMap),
        directives: directives,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    }); // Given a type reference in introspection, return the GraphQLType instance.
    // preferring cached instances before building new instances.
    function getType(typeRef) {
        if (typeRef.kind === (0, $h2iUh.TypeKind).LIST) {
            var itemRef = typeRef.ofType;
            if (!itemRef) throw new Error('Decorated type deeper than introspection query.');
            return new (0, $lXoEQ.GraphQLList)(getType(itemRef));
        }
        if (typeRef.kind === (0, $h2iUh.TypeKind).NON_NULL) {
            var nullableRef = typeRef.ofType;
            if (!nullableRef) throw new Error('Decorated type deeper than introspection query.');
            var nullableType = getType(nullableRef);
            return new (0, $lXoEQ.GraphQLNonNull)((0, $lXoEQ.assertNullableType)(nullableType));
        }
        return getNamedType(typeRef);
    }
    function getNamedType(typeRef) {
        var typeName = typeRef.name;
        if (!typeName) throw new Error("Unknown type reference: ".concat((0, $biK02.default)(typeRef), "."));
        var type = typeMap[typeName];
        if (!type) throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure that a full introspection query is used in order to build a client schema."));
        return type;
    }
    function getObjectType(typeRef) {
        return (0, $lXoEQ.assertObjectType)(getNamedType(typeRef));
    }
    function getInterfaceType(typeRef) {
        return (0, $lXoEQ.assertInterfaceType)(getNamedType(typeRef));
    } // Given a type's introspection result, construct the correct
    // GraphQLType instance.
    function buildType(type) {
        if (type != null && type.name != null && type.kind != null) switch(type.kind){
            case (0, $h2iUh.TypeKind).SCALAR:
                return buildScalarDef(type);
            case (0, $h2iUh.TypeKind).OBJECT:
                return buildObjectDef(type);
            case (0, $h2iUh.TypeKind).INTERFACE:
                return buildInterfaceDef(type);
            case (0, $h2iUh.TypeKind).UNION:
                return buildUnionDef(type);
            case (0, $h2iUh.TypeKind).ENUM:
                return buildEnumDef(type);
            case (0, $h2iUh.TypeKind).INPUT_OBJECT:
                return buildInputObjectDef(type);
        }
        var typeStr = (0, $biK02.default)(type);
        throw new Error("Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ".concat(typeStr, "."));
    }
    function buildScalarDef(scalarIntrospection) {
        return new (0, $lXoEQ.GraphQLScalarType)({
            name: scalarIntrospection.name,
            description: scalarIntrospection.description,
            specifiedByUrl: scalarIntrospection.specifiedByUrl
        });
    }
    function buildImplementationsList(implementingIntrospection) {
        // TODO: Temporary workaround until GraphQL ecosystem will fully support
        // 'interfaces' on interface types.
        if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === (0, $h2iUh.TypeKind).INTERFACE) return [];
        if (!implementingIntrospection.interfaces) {
            var implementingIntrospectionStr = (0, $biK02.default)(implementingIntrospection);
            throw new Error("Introspection result missing interfaces: ".concat(implementingIntrospectionStr, "."));
        }
        return implementingIntrospection.interfaces.map(getInterfaceType);
    }
    function buildObjectDef(objectIntrospection) {
        return new (0, $lXoEQ.GraphQLObjectType)({
            name: objectIntrospection.name,
            description: objectIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(objectIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(objectIntrospection);
            }
        });
    }
    function buildInterfaceDef(interfaceIntrospection) {
        return new (0, $lXoEQ.GraphQLInterfaceType)({
            name: interfaceIntrospection.name,
            description: interfaceIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(interfaceIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(interfaceIntrospection);
            }
        });
    }
    function buildUnionDef(unionIntrospection) {
        if (!unionIntrospection.possibleTypes) {
            var unionIntrospectionStr = (0, $biK02.default)(unionIntrospection);
            throw new Error("Introspection result missing possibleTypes: ".concat(unionIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLUnionType)({
            name: unionIntrospection.name,
            description: unionIntrospection.description,
            types: function types() {
                return unionIntrospection.possibleTypes.map(getObjectType);
            }
        });
    }
    function buildEnumDef(enumIntrospection) {
        if (!enumIntrospection.enumValues) {
            var enumIntrospectionStr = (0, $biK02.default)(enumIntrospection);
            throw new Error("Introspection result missing enumValues: ".concat(enumIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLEnumType)({
            name: enumIntrospection.name,
            description: enumIntrospection.description,
            values: (0, $2AFgT.default)(enumIntrospection.enumValues, function(valueIntrospection) {
                return valueIntrospection.name;
            }, function(valueIntrospection) {
                return {
                    description: valueIntrospection.description,
                    deprecationReason: valueIntrospection.deprecationReason
                };
            })
        });
    }
    function buildInputObjectDef(inputObjectIntrospection) {
        if (!inputObjectIntrospection.inputFields) {
            var inputObjectIntrospectionStr = (0, $biK02.default)(inputObjectIntrospection);
            throw new Error("Introspection result missing inputFields: ".concat(inputObjectIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLInputObjectType)({
            name: inputObjectIntrospection.name,
            description: inputObjectIntrospection.description,
            fields: function fields() {
                return buildInputValueDefMap(inputObjectIntrospection.inputFields);
            }
        });
    }
    function buildFieldDefMap(typeIntrospection) {
        if (!typeIntrospection.fields) throw new Error("Introspection result missing fields: ".concat((0, $biK02.default)(typeIntrospection), "."));
        return (0, $2AFgT.default)(typeIntrospection.fields, function(fieldIntrospection) {
            return fieldIntrospection.name;
        }, buildField);
    }
    function buildField(fieldIntrospection) {
        var type = getType(fieldIntrospection.type);
        if (!(0, $lXoEQ.isOutputType)(type)) {
            var typeStr = (0, $biK02.default)(type);
            throw new Error("Introspection must provide output type for fields, but received: ".concat(typeStr, "."));
        }
        if (!fieldIntrospection.args) {
            var fieldIntrospectionStr = (0, $biK02.default)(fieldIntrospection);
            throw new Error("Introspection result missing field args: ".concat(fieldIntrospectionStr, "."));
        }
        return {
            description: fieldIntrospection.description,
            deprecationReason: fieldIntrospection.deprecationReason,
            type: type,
            args: buildInputValueDefMap(fieldIntrospection.args)
        };
    }
    function buildInputValueDefMap(inputValueIntrospections) {
        return (0, $2AFgT.default)(inputValueIntrospections, function(inputValue) {
            return inputValue.name;
        }, buildInputValue);
    }
    function buildInputValue(inputValueIntrospection) {
        var type = getType(inputValueIntrospection.type);
        if (!(0, $lXoEQ.isInputType)(type)) {
            var typeStr = (0, $biK02.default)(type);
            throw new Error("Introspection must provide input type for arguments, but received: ".concat(typeStr, "."));
        }
        var defaultValue = inputValueIntrospection.defaultValue != null ? (0, $3E0nn.valueFromAST)((0, $6ds0g.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
        return {
            description: inputValueIntrospection.description,
            type: type,
            defaultValue: defaultValue,
            deprecationReason: inputValueIntrospection.deprecationReason
        };
    }
    function buildDirective(directiveIntrospection) {
        if (!directiveIntrospection.args) {
            var directiveIntrospectionStr = (0, $biK02.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive args: ".concat(directiveIntrospectionStr, "."));
        }
        if (!directiveIntrospection.locations) {
            var _directiveIntrospectionStr = (0, $biK02.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive locations: ".concat(_directiveIntrospectionStr, "."));
        }
        return new (0, $bOniD.GraphQLDirective)({
            name: directiveIntrospection.name,
            description: directiveIntrospection.description,
            isRepeatable: directiveIntrospection.isRepeatable,
            locations: directiveIntrospection.locations.slice(),
            args: buildInputValueDefMap(directiveIntrospection.args)
        });
    }
}

});

parcelRegister("iZRls", function(module, exports) {

$parcel$export(module.exports, "getIntrospectionQuery", () => $1669bb0e2cec0c6e$export$67a66015194c88d7);
function $1669bb0e2cec0c6e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1669bb0e2cec0c6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1669bb0e2cec0c6e$var$ownKeys(Object(source), true).forEach(function(key) {
            $1669bb0e2cec0c6e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1669bb0e2cec0c6e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1669bb0e2cec0c6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1669bb0e2cec0c6e$export$67a66015194c88d7(options) {
    var optionsWithDefault = $1669bb0e2cec0c6e$var$_objectSpread({
        descriptions: true,
        specifiedByUrl: false,
        directiveIsRepeatable: false,
        schemaDescription: false,
        inputValueDeprecation: false
    }, options);
    var descriptions = optionsWithDefault.descriptions ? 'description' : '';
    var specifiedByUrl = optionsWithDefault.specifiedByUrl ? 'specifiedByUrl' : '';
    var directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? 'isRepeatable' : '';
    var schemaDescription = optionsWithDefault.schemaDescription ? descriptions : '';
    function inputDeprecation(str) {
        return optionsWithDefault.inputValueDeprecation ? str : '';
    }
    return "\n    query IntrospectionQuery {\n      __schema {\n        ".concat(schemaDescription, "\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ").concat(descriptions, "\n          ").concat(directiveIsRepeatable, "\n          locations\n          args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions, "\n      ").concat(specifiedByUrl, "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields").concat(inputDeprecation('(includeDeprecated: true)'), " {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions, "\n      type { ...TypeRef }\n      defaultValue\n      ").concat(inputDeprecation('isDeprecated'), "\n      ").concat(inputDeprecation('deprecationReason'), "\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
}

});


parcelRegister("2KwZj", function(module, exports) {
var $2009775a7df124d7$var$__assign = module.exports && module.exports.__assign || function() {
    $2009775a7df124d7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2009775a7df124d7$var$__assign.apply(this, arguments);
};
var $2009775a7df124d7$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $glHRe = parcelRequire("glHRe");
var $lXoEQ = parcelRequire("lXoEQ");
var $bOniD = parcelRequire("bOniD");
var $6BdRO = parcelRequire("6BdRO");
var $1c4hI = parcelRequire("1c4hI");
var $6ds0g = parcelRequire("6ds0g");

var $crrCr = parcelRequire("crrCr");

var $h8S1f = parcelRequire("h8S1f");

var $7UWAA = parcelRequire("7UWAA");

var $dkK13 = parcelRequire("dkK13");

var $16dWW = parcelRequire("16dWW");

var $b3EaX = parcelRequire("b3EaX");

var $gVW6u = parcelRequire("gVW6u");
function $2009775a7df124d7$var$mergeSchemas(_a) {
    var schemas = _a.schemas, onTypeConflict = _a.onTypeConflict, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
    return $2009775a7df124d7$var$mergeSchemasImplementation({
        schemas: schemas,
        resolvers: resolvers,
        schemaDirectives: schemaDirectives,
        inheritResolversFromInterfaces: inheritResolversFromInterfaces,
        mergeDirectives: mergeDirectives
    });
}
module.exports.default = $2009775a7df124d7$var$mergeSchemas;
function $2009775a7df124d7$var$mergeSchemasImplementation(_a) {
    var schemas = _a.schemas, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
    var allSchemas = [];
    var typeCandidates = {};
    var types = {};
    var extensions = [];
    var directives = [];
    var fragments = [];
    var resolveType = $h8S1f.createResolveType(function(name) {
        if (types[name] === undefined) throw new Error("Can't find type " + name + ".");
        return types[name];
    });
    schemas.forEach(function(schema) {
        if (schema instanceof $6BdRO.GraphQLSchema) {
            allSchemas.push(schema);
            var queryType_1 = schema.getQueryType();
            var mutationType_1 = schema.getMutationType();
            var subscriptionType_1 = schema.getSubscriptionType();
            if (queryType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Query', {
                schema: schema,
                type: queryType_1
            });
            if (mutationType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Mutation', {
                schema: schema,
                type: mutationType_1
            });
            if (subscriptionType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Subscription', {
                schema: schema,
                type: subscriptionType_1
            });
            if (mergeDirectives) {
                var directiveInstances = schema.getDirectives();
                directiveInstances.forEach(function(directive) {
                    directives.push(directive);
                });
            }
            var typeMap_1 = schema.getTypeMap();
            Object.keys(typeMap_1).forEach(function(typeName) {
                var type = typeMap_1[typeName];
                if ($lXoEQ.isNamedType(type) && $lXoEQ.getNamedType(type).name.slice(0, 2) !== '__' && type !== queryType_1 && type !== mutationType_1 && type !== subscriptionType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                    schema: schema,
                    type: type
                });
            });
        } else if (typeof schema === 'string' || schema && schema.kind === $1c4hI.Kind.DOCUMENT) {
            var parsedSchemaDocument = typeof schema === 'string' ? $6ds0g.parse(schema) : schema;
            parsedSchemaDocument.definitions.forEach(function(def) {
                var type = $dkK13.default(def);
                if (type instanceof $bOniD.GraphQLDirective && mergeDirectives) directives.push(type);
                else if (type && !(type instanceof $bOniD.GraphQLDirective)) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                    type: type
                });
            });
            var extensionsDocument = $crrCr.extractExtensionDefinitions(parsedSchemaDocument);
            if (extensionsDocument.definitions.length > 0) extensions.push(extensionsDocument);
        } else if (Array.isArray(schema)) schema.forEach(function(type) {
            $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                type: type
            });
        });
        else throw new Error("Invalid schema passed");
    });
    var mergeInfo = $2009775a7df124d7$var$createMergeInfo(allSchemas, fragments);
    if (!resolvers) resolvers = {};
    else if (typeof resolvers === 'function') {
        console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
        resolvers = resolvers(mergeInfo);
    } else if (Array.isArray(resolvers)) resolvers = resolvers.reduce(function(left, right) {
        if (typeof right === 'function') {
            console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
            right = right(mergeInfo);
        }
        return $b3EaX.default(left, right);
    }, {});
    var generatedResolvers = {};
    Object.keys(typeCandidates).forEach(function(typeName) {
        var resultType = $2009775a7df124d7$var$defaultVisitType(typeName, typeCandidates[typeName]);
        if (resultType === null) types[typeName] = null;
        else {
            var type = void 0;
            var typeResolvers = void 0;
            if ($lXoEQ.isNamedType(resultType)) type = resultType;
            else if (resultType.type) {
                type = resultType.type;
                typeResolvers = resultType.resolvers;
            } else throw new Error("Invalid visitType result for type " + typeName);
            types[typeName] = $h8S1f.recreateType(type, resolveType, false);
            if (typeResolvers) generatedResolvers[typeName] = typeResolvers;
        }
    });
    var mergedSchema = new $6BdRO.GraphQLSchema({
        query: types.Query,
        mutation: types.Mutation,
        subscription: types.Subscription,
        types: Object.keys(types).map(function(key) {
            return types[key];
        }),
        directives: directives.map(function(directive) {
            return $h8S1f.recreateDirective(directive, resolveType);
        })
    });
    extensions.forEach(function(extension) {
        mergedSchema = $glHRe.extendSchema(mergedSchema, extension, {
            commentDescriptions: true
        });
    });
    if (!resolvers) resolvers = {};
    else if (Array.isArray(resolvers)) resolvers = resolvers.reduce($b3EaX.default, {});
    Object.keys(resolvers).forEach(function(typeName) {
        var type = resolvers[typeName];
        if (type instanceof $lXoEQ.GraphQLScalarType) return;
        Object.keys(type).forEach(function(fieldName) {
            var field = type[fieldName];
            if (field.fragment) fragments.push({
                field: fieldName,
                fragment: field.fragment
            });
        });
    });
    mergedSchema = $crrCr.addResolveFunctionsToSchema({
        schema: mergedSchema,
        resolvers: $b3EaX.default(generatedResolvers, resolvers),
        inheritResolversFromInterfaces: inheritResolversFromInterfaces
    });
    $2009775a7df124d7$var$forEachField(mergedSchema, function(field) {
        if (field.resolve) {
            var fieldResolver_1 = field.resolve;
            field.resolve = function(parent, args, context, info) {
                var newInfo = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, info), {
                    mergeInfo: mergeInfo
                });
                return fieldResolver_1(parent, args, context, newInfo);
            };
        }
        if (field.subscribe) {
            var fieldResolver_2 = field.subscribe;
            field.subscribe = function(parent, args, context, info) {
                var newInfo = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, info), {
                    mergeInfo: mergeInfo
                });
                return fieldResolver_2(parent, args, context, newInfo);
            };
        }
    });
    if (schemaDirectives) $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(mergedSchema, schemaDirectives);
    return mergedSchema;
}
function $2009775a7df124d7$var$createMergeInfo(allSchemas, fragments) {
    return {
        delegate: function(operation, fieldName, args, context, info, transforms) {
            console.warn("`mergeInfo.delegate` is deprecated. Use `mergeInfo.delegateToSchema and pass explicit schema instances.");
            var schema = $2009775a7df124d7$var$guessSchemaByRootField(allSchemas, operation, fieldName);
            var expandTransforms = new $16dWW.ExpandAbstractTypes(info.schema, schema);
            var fragmentTransform = new $16dWW.ReplaceFieldWithFragment(schema, fragments);
            return $7UWAA.default({
                schema: schema,
                operation: operation,
                fieldName: fieldName,
                args: args,
                context: context,
                info: info,
                transforms: $2009775a7df124d7$var$__spreadArrays(transforms || [], [
                    expandTransforms,
                    fragmentTransform
                ])
            });
        },
        delegateToSchema: function(options) {
            return $7UWAA.default($2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, options), {
                transforms: options.transforms
            }));
        },
        fragments: fragments
    };
}
function $2009775a7df124d7$var$guessSchemaByRootField(schemas, operation, fieldName) {
    for(var _i = 0, schemas_1 = schemas; _i < schemas_1.length; _i++){
        var schema = schemas_1[_i];
        var rootObject = void 0;
        if (operation === 'subscription') rootObject = schema.getSubscriptionType();
        else if (operation === 'mutation') rootObject = schema.getMutationType();
        else rootObject = schema.getQueryType();
        if (rootObject) {
            var fields = rootObject.getFields();
            if (fields[fieldName]) return schema;
        }
    }
    throw new Error("Could not find subschema with field `" + operation + "." + fieldName + "`");
}
function $2009775a7df124d7$var$createDelegatingResolver(schema, operation, fieldName) {
    return function(root, args, context, info) {
        return info.mergeInfo.delegateToSchema({
            schema: schema,
            operation: operation,
            fieldName: fieldName,
            args: args,
            context: context,
            info: info
        });
    };
}
function $2009775a7df124d7$var$forEachField(schema, fn) {
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        if (!$lXoEQ.getNamedType(type).name.startsWith('__') && type instanceof $lXoEQ.GraphQLObjectType) {
            var fields_1 = type.getFields();
            Object.keys(fields_1).forEach(function(fieldName) {
                var field = fields_1[fieldName];
                fn(field, typeName, fieldName);
            });
        }
    });
}
function $2009775a7df124d7$var$addTypeCandidate(typeCandidates, name, typeCandidate) {
    if (!typeCandidates[name]) typeCandidates[name] = [];
    typeCandidates[name].push(typeCandidate);
}
function $2009775a7df124d7$var$defaultVisitType(name, candidates, candidateSelector) {
    if (!candidateSelector) candidateSelector = function(cands) {
        return cands[cands.length - 1];
    };
    var resolveType = $h8S1f.createResolveType(function(_, type) {
        return type;
    });
    if (name === 'Query' || name === 'Mutation' || name === 'Subscription') {
        var fields_2 = {};
        var operationName_1;
        switch(name){
            case 'Query':
                operationName_1 = 'query';
                break;
            case 'Mutation':
                operationName_1 = 'mutation';
                break;
            case 'Subscription':
                operationName_1 = 'subscription';
                break;
            default:
                break;
        }
        var resolvers_1 = {};
        var resolverKey_1 = operationName_1 === 'subscription' ? 'subscribe' : 'resolve';
        candidates.forEach(function(_a) {
            var candidateType = _a.type, schema = _a.schema;
            var candidateFields = candidateType.getFields();
            fields_2 = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, fields_2), candidateFields);
            Object.keys(candidateFields).forEach(function(fieldName) {
                var _a;
                resolvers_1[fieldName] = (_a = {}, _a[resolverKey_1] = $2009775a7df124d7$var$createDelegatingResolver(schema, operationName_1, fieldName), _a);
            });
        });
        var type = new $lXoEQ.GraphQLObjectType({
            name: name,
            fields: $h8S1f.fieldMapToFieldConfigMap(fields_2, resolveType, false)
        });
        return {
            type: type,
            resolvers: resolvers_1
        };
    } else {
        var candidate = candidateSelector(candidates);
        return candidate.type;
    }
}

});
parcelRegister("7UWAA", function(module, exports) {
var $5c3b35ed0de98ad1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5c3b35ed0de98ad1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5c3b35ed0de98ad1$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
var $6BdRO = parcelRequire("6BdRO");
var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $2vhbx = parcelRequire("2vhbx");
var $dGflO = parcelRequire("dGflO");

var $esVhq = parcelRequire("esVhq");

var $iijzq = parcelRequire("iijzq");

var $8Vthi = parcelRequire("8Vthi");

var $aYyML = parcelRequire("aYyML");

var $gvWNr = parcelRequire("gvWNr");

var $fB7Hv = parcelRequire("fB7Hv");

var $kYtVo = parcelRequire("kYtVo");

var $4trzE = parcelRequire("4trzE");

var $goXjX = parcelRequire("goXjX");
function $5c3b35ed0de98ad1$var$delegateToSchema(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (options instanceof $6BdRO.GraphQLSchema) throw new Error("Passing positional arguments to delegateToSchema is a deprecated. Please pass named parameters instead.");
    return $5c3b35ed0de98ad1$var$delegateToSchemaImplementation(options);
}
module.exports.default = $5c3b35ed0de98ad1$var$delegateToSchema;
function $5c3b35ed0de98ad1$var$delegateToSchemaImplementation(options) {
    return $5c3b35ed0de98ad1$var$__awaiter(this, void 0, void 0, function() {
        var info, _a, args, operation, rawDocument, rawRequest, transforms, processedRequest, errors, _b, executionResult;
        return $5c3b35ed0de98ad1$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    info = options.info, _a = options.args, args = _a === void 0 ? {} : _a;
                    operation = options.operation || info.operation.operation;
                    rawDocument = $5c3b35ed0de98ad1$var$createDocument(options.fieldName, operation, info.fieldNodes, Object.keys(info.fragments).map(function(fragmentName) {
                        return info.fragments[fragmentName];
                    }), info.operation.variableDefinitions, info.operation.name);
                    rawRequest = {
                        document: rawDocument,
                        variables: info.variableValues
                    };
                    transforms = $5c3b35ed0de98ad1$var$__spreadArrays(options.transforms || [], [
                        new $kYtVo.default(info.schema, options.schema)
                    ]);
                    if (info.mergeInfo && info.mergeInfo.fragments) transforms.push(new $4trzE.default(options.schema, info.mergeInfo.fragments));
                    transforms = transforms.concat([
                        new $iijzq.default(options.schema, args),
                        new $8Vthi.default(options.schema),
                        new $aYyML.default(options.schema),
                        new $gvWNr.default(info, options.fieldName)
                    ]);
                    if ($lXoEQ.isEnumType(options.info.returnType)) transforms = transforms.concat(new $goXjX.default(options.info.returnType));
                    processedRequest = $esVhq.applyRequestTransforms(rawRequest, transforms);
                    if (!options.skipValidation) {
                        errors = $dGflO.validate(options.schema, processedRequest.document);
                        if (errors.length > 0) throw errors;
                    }
                    if (!(operation === 'query' || operation === 'mutation')) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = $esVhq.applyResultTransforms;
                    return [
                        4 /*yield*/ ,
                        $3MP74.execute(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.apply(void 0, [
                            _c.sent(),
                            transforms
                        ])
                    ];
                case 2:
                    if (!(operation === 'subscription')) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        $2vhbx.subscribe(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                    ];
                case 3:
                    executionResult = _c.sent();
                    // "subscribe" to the subscription result and map the result through the transforms
                    return [
                        2 /*return*/ ,
                        $fB7Hv.default(executionResult, function(result) {
                            var _a;
                            var transformedResult = $esVhq.applyResultTransforms(result, transforms);
                            var subscriptionKey = Object.keys(result.data)[0];
                            // for some reason the returned transformedResult needs to be nested inside the root subscription field
                            // does not work otherwise...
                            return _a = {}, _a[subscriptionKey] = transformedResult, _a;
                        })
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $5c3b35ed0de98ad1$var$createDocument(targetField, targetOperation, originalSelections, fragments, variables, operationName) {
    var selections = [];
    var args = [];
    originalSelections.forEach(function(field) {
        var fieldSelections = field.selectionSet ? field.selectionSet.selections : [];
        selections = selections.concat(fieldSelections);
        args = args.concat(field.arguments || []);
    });
    var selectionSet = null;
    if (selections.length > 0) selectionSet = {
        kind: $1c4hI.Kind.SELECTION_SET,
        selections: selections
    };
    var rootField = {
        kind: $1c4hI.Kind.FIELD,
        alias: null,
        arguments: args,
        selectionSet: selectionSet,
        name: {
            kind: $1c4hI.Kind.NAME,
            value: targetField
        }
    };
    var rootSelectionSet = {
        kind: $1c4hI.Kind.SELECTION_SET,
        selections: [
            rootField
        ]
    };
    var operationDefinition = {
        kind: $1c4hI.Kind.OPERATION_DEFINITION,
        operation: targetOperation,
        variableDefinitions: variables,
        selectionSet: rootSelectionSet,
        name: operationName
    };
    return {
        kind: $1c4hI.Kind.DOCUMENT,
        definitions: $5c3b35ed0de98ad1$var$__spreadArrays([
            operationDefinition
        ], fragments)
    };
}

});
parcelRegister("2vhbx", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $0952dea42f1ba206$export$ec068583843480e7);

var $biK02 = parcelRequire("biK02");

var $lVzNK = parcelRequire("lVzNK");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $gqGQB = parcelRequire("gqGQB");

var $3MP74 = parcelRequire("3MP74");

var $bis9F = parcelRequire("bis9F");

var $b1Z8M = parcelRequire("b1Z8M");
function $0952dea42f1ba206$export$ec068583843480e7(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? $0952dea42f1ba206$var$subscribeImpl(argsOrSchema) : $0952dea42f1ba206$var$subscribeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        subscribeFieldResolver: subscribeFieldResolver
    });
}
/**
 * This function checks if the error is a GraphQLError. If it is, report it as
 * an ExecutionResult, containing only errors and no data. Otherwise treat the
 * error as a system-class error and re-throw it.
 */ function $0952dea42f1ba206$var$reportGraphQLError(error) {
    if (error instanceof (0, $9fgMZ.GraphQLError)) return {
        errors: [
            error
        ]
    };
    throw error;
}
function $0952dea42f1ba206$var$subscribeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, subscribeFieldResolver = args.subscribeFieldResolver;
    var sourcePromise = $0952dea42f1ba206$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver); // For each payload yielded from a subscription, map it over the normal
    // GraphQL `execute` function, with `payload` as the rootValue.
    // This implements the "MapSourceToResponseEvent" algorithm described in
    // the GraphQL specification. The `execute` function provides the
    // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
    // "ExecuteQuery" algorithm, for which `execute` is also used.
    var mapSourceToResponse = function mapSourceToResponse(payload) {
        return (0, $3MP74.execute)({
            schema: schema,
            document: document,
            rootValue: payload,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver
        });
    }; // Resolve the Source Stream, then map every source value to a
    // ExecutionResult value as described above.
    return sourcePromise.then(function(resultOrStream) {
        return (0, $lVzNK.default)(resultOrStream) ? (0, $b1Z8M.default)(resultOrStream, mapSourceToResponse, $0952dea42f1ba206$var$reportGraphQLError) : resultOrStream;
    });
}
function $0952dea42f1ba206$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
    // If arguments are missing or incorrectly typed, this is an internal
    // developer mistake which should throw an early error.
    (0, $3MP74.assertValidExecutionArguments)(schema, document, variableValues);
    return new Promise(function(resolve) {
        // If a valid context cannot be created due to incorrect arguments,
        // this will throw an error.
        var exeContext = (0, $3MP74.buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
        resolve(Array.isArray(exeContext) ? {
            errors: exeContext
        } : $0952dea42f1ba206$var$executeSubscription(exeContext));
    }).catch($0952dea42f1ba206$var$reportGraphQLError);
}
function $0952dea42f1ba206$var$executeSubscription(exeContext) {
    var schema = exeContext.schema, operation = exeContext.operation, variableValues = exeContext.variableValues, rootValue = exeContext.rootValue;
    var type = (0, $bis9F.getOperationRootType)(schema, operation);
    var fields = (0, $3MP74.collectFields)(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var responseNames = Object.keys(fields);
    var responseName = responseNames[0];
    var fieldNodes = fields[responseName];
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = (0, $3MP74.getFieldDef)(schema, type, fieldName);
    if (!fieldDef) throw new (0, $9fgMZ.GraphQLError)("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
    var path = (0, $kZHaf.addPath)(undefined, responseName, type.name);
    var info = (0, $3MP74.buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path); // Coerce to Promise for easier error handling and consistent return type.
    return new Promise(function(resolveResult) {
        var _fieldDef$subscribe;
        // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
        // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        var args = (0, $gqGQB.getArgumentValues)(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
        // AsyncIterable yielding raw payloads.
        var resolveFn = (_fieldDef$subscribe = fieldDef.subscribe) !== null && _fieldDef$subscribe !== void 0 ? _fieldDef$subscribe : exeContext.fieldResolver;
        resolveResult(resolveFn(rootValue, args, contextValue, info));
    }).then(function(eventStream) {
        if (eventStream instanceof Error) throw (0, $02KAV.locatedError)(eventStream, fieldNodes, (0, $kZHaf.pathToArray)(path));
         // Assert field returned an event stream, otherwise yield an error.
        if (!(0, $lVzNK.default)(eventStream)) throw new Error('Subscription field must return Async Iterable. ' + "Received: ".concat((0, $biK02.default)(eventStream), "."));
        return eventStream;
    }, function(error) {
        throw (0, $02KAV.locatedError)(error, fieldNodes, (0, $kZHaf.pathToArray)(path));
    });
}

});
parcelRegister("lVzNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c2a0b88b975b05$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $f0c2a0b88b975b05$export$2e2bcd8739ae039(maybeAsyncIterable) {
    return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[0, $gwa3m.SYMBOL_ASYNC_ITERATOR]) === 'function';
}

});

parcelRegister("b1Z8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70a078baba341ab$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $e70a078baba341ab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e70a078baba341ab$export$2e2bcd8739ae039(iterable, callback, rejectCallback) {
    // $FlowFixMe[prop-missing]
    var iteratorMethod = iterable[0, $gwa3m.SYMBOL_ASYNC_ITERATOR];
    var iterator = iteratorMethod.call(iterable);
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function abruptClose(error) {
            var rethrow = function rethrow() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : $e70a078baba341ab$var$asyncMapValue(result.value, callback).then($e70a078baba341ab$var$iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject = rejectCallback;
        mapReject = function mapReject(error) {
            return $e70a078baba341ab$var$asyncMapValue(error, reject).then($e70a078baba341ab$var$iteratorResult, abruptClose);
        };
    }
    /* TODO: Flow doesn't support symbols as keys:
     https://github.com/facebook/flow/issues/3258 */ return $e70a078baba341ab$var$_defineProperty({
        next: function next() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function _return() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function _throw(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, (0, $gwa3m.SYMBOL_ASYNC_ITERATOR), function() {
        return this;
    });
}
function $e70a078baba341ab$var$asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function $e70a078baba341ab$var$iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

});


parcelRegister("iijzq", function(module, exports) {
var $d51916b58a73dae6$var$__assign = module.exports && module.exports.__assign || function() {
    $d51916b58a73dae6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d51916b58a73dae6$var$__assign.apply(this, arguments);
};
var $d51916b58a73dae6$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $d51916b58a73dae6$var$AddArgumentsAsVariablesTransform = /** @class */ function() {
    function AddArgumentsAsVariablesTransform(schema, args) {
        this.schema = schema;
        this.args = args;
    }
    AddArgumentsAsVariablesTransform.prototype.transformRequest = function(originalRequest) {
        var _a = $d51916b58a73dae6$var$addVariablesToRootField(this.schema, originalRequest.document, this.args), document = _a.document, newVariables = _a.newVariables;
        var variables = $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, originalRequest.variables), newVariables);
        return {
            document: document,
            variables: variables
        };
    };
    return AddArgumentsAsVariablesTransform;
}();
module.exports.default = $d51916b58a73dae6$var$AddArgumentsAsVariablesTransform;
function $d51916b58a73dae6$var$addVariablesToRootField(targetSchema, document, args) {
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var variableNames = {};
    var newOperations = operations.map(function(operation) {
        var existingVariables = operation.variableDefinitions.map(function(variableDefinition) {
            return variableDefinition.variable.name.value;
        });
        var variableCounter = 0;
        var variables = {};
        var generateVariableName = function(argName) {
            var varName;
            do {
                varName = "_v" + variableCounter + "_" + argName;
                variableCounter++;
            }while (existingVariables.indexOf(varName) !== -1);
            return varName;
        };
        var type;
        if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
        else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
        else type = targetSchema.getQueryType();
        var newSelectionSet = [];
        operation.selectionSet.selections.forEach(function(selection) {
            if (selection.kind === $1c4hI.Kind.FIELD) {
                var newArgs_1 = {};
                selection.arguments.forEach(function(argument) {
                    newArgs_1[argument.name.value] = argument;
                });
                var name_1 = selection.name.value;
                var field = type.getFields()[name_1];
                field.args.forEach(function(argument) {
                    if (argument.name in args) {
                        var variableName = generateVariableName(argument.name);
                        variableNames[argument.name] = variableName;
                        newArgs_1[argument.name] = {
                            kind: $1c4hI.Kind.ARGUMENT,
                            name: {
                                kind: $1c4hI.Kind.NAME,
                                value: argument.name
                            },
                            value: {
                                kind: $1c4hI.Kind.VARIABLE,
                                name: {
                                    kind: $1c4hI.Kind.NAME,
                                    value: variableName
                                }
                            }
                        };
                        existingVariables.push(variableName);
                        variables[variableName] = {
                            kind: $1c4hI.Kind.VARIABLE_DEFINITION,
                            variable: {
                                kind: $1c4hI.Kind.VARIABLE,
                                name: {
                                    kind: $1c4hI.Kind.NAME,
                                    value: variableName
                                }
                            },
                            type: $d51916b58a73dae6$var$typeToAst(argument.type)
                        };
                    }
                });
                newSelectionSet.push($d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, selection), {
                    arguments: Object.keys(newArgs_1).map(function(argName) {
                        return newArgs_1[argName];
                    })
                }));
            } else newSelectionSet.push(selection);
        });
        return $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, operation), {
            variableDefinitions: operation.variableDefinitions.concat(Object.keys(variables).map(function(varName) {
                return variables[varName];
            })),
            selectionSet: {
                kind: $1c4hI.Kind.SELECTION_SET,
                selections: newSelectionSet
            }
        });
    });
    var newVariables = {};
    Object.keys(variableNames).forEach(function(name) {
        newVariables[variableNames[name]] = args[name];
    });
    return {
        document: $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, document), {
            definitions: $d51916b58a73dae6$var$__spreadArrays(newOperations, fragments)
        }),
        newVariables: newVariables
    };
}
function $d51916b58a73dae6$var$typeToAst(type) {
    if (type instanceof $lXoEQ.GraphQLNonNull) {
        var innerType = $d51916b58a73dae6$var$typeToAst(type.ofType);
        if (innerType.kind === $1c4hI.Kind.LIST_TYPE || innerType.kind === $1c4hI.Kind.NAMED_TYPE) return {
            kind: $1c4hI.Kind.NON_NULL_TYPE,
            type: innerType
        };
        else throw new Error('Incorrent inner non-null type');
    } else if (type instanceof $lXoEQ.GraphQLList) return {
        kind: $1c4hI.Kind.LIST_TYPE,
        type: $d51916b58a73dae6$var$typeToAst(type.ofType)
    };
    else return {
        kind: $1c4hI.Kind.NAMED_TYPE,
        name: {
            kind: $1c4hI.Kind.NAME,
            value: type.toString()
        }
    };
}

});

parcelRegister("8Vthi", function(module, exports) {
var $67fa5b975bcbc2ac$var$__assign = module.exports && module.exports.__assign || function() {
    $67fa5b975bcbc2ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67fa5b975bcbc2ac$var$__assign.apply(this, arguments);
};
var $67fa5b975bcbc2ac$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $h2iUh = parcelRequire("h2iUh");
var $961BR = parcelRequire("961BR");

var $eYOZQ = parcelRequire("eYOZQ");
var $67fa5b975bcbc2ac$var$FilterToSchema = /** @class */ function() {
    function FilterToSchema(targetSchema) {
        this.targetSchema = targetSchema;
    }
    FilterToSchema.prototype.transformRequest = function(originalRequest) {
        var document = $67fa5b975bcbc2ac$var$filterDocumentToSchema(this.targetSchema, originalRequest.document);
        return $67fa5b975bcbc2ac$var$__assign($67fa5b975bcbc2ac$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return FilterToSchema;
}();
module.exports.default = $67fa5b975bcbc2ac$var$FilterToSchema;
function $67fa5b975bcbc2ac$var$filterDocumentToSchema(targetSchema, document) {
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var usedFragments = [];
    var newOperations = [];
    var newFragments = [];
    var validFragments = fragments.filter(function(fragment) {
        var typeName = fragment.typeCondition.name.value;
        return Boolean(targetSchema.getType(typeName));
    });
    var validFragmentsWithType = {};
    validFragments.forEach(function(fragment) {
        var typeName = fragment.typeCondition.name.value;
        var type = targetSchema.getType(typeName);
        validFragmentsWithType[fragment.name.value] = type;
    });
    var fragmentSet = Object.create(null);
    operations.forEach(function(operation) {
        var type;
        if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
        else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
        else type = targetSchema.getQueryType();
        var _a = $67fa5b975bcbc2ac$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, operation.selectionSet), selectionSet = _a.selectionSet, operationUsedFragments = _a.usedFragments, operationUsedVariables = _a.usedVariables;
        usedFragments = $67fa5b975bcbc2ac$var$union(usedFragments, operationUsedFragments);
        var _b = $67fa5b975bcbc2ac$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments), collectedUsedVariables = _b.usedVariables, collectedNewFragments = _b.newFragments, collectedFragmentSet = _b.fragmentSet;
        var fullUsedVariables = $67fa5b975bcbc2ac$var$union(operationUsedVariables, collectedUsedVariables);
        newFragments = collectedNewFragments;
        fragmentSet = collectedFragmentSet;
        var variableDefinitions = operation.variableDefinitions.filter(function(variable) {
            return fullUsedVariables.indexOf(variable.variable.name.value) !== -1;
        });
        newOperations.push({
            kind: $1c4hI.Kind.OPERATION_DEFINITION,
            operation: operation.operation,
            name: operation.name,
            directives: operation.directives,
            variableDefinitions: variableDefinitions,
            selectionSet: selectionSet
        });
    });
    return {
        kind: $1c4hI.Kind.DOCUMENT,
        definitions: $67fa5b975bcbc2ac$var$__spreadArrays(newOperations, newFragments)
    };
}
function $67fa5b975bcbc2ac$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments) {
    var usedVariables = [];
    var newFragments = [];
    var _loop_1 = function() {
        var nextFragmentName = usedFragments.pop();
        var fragment = validFragments.find(function(fr) {
            return fr.name.value === nextFragmentName;
        });
        if (fragment) {
            var name_1 = nextFragmentName;
            var typeName = fragment.typeCondition.name.value;
            var type = targetSchema.getType(typeName);
            var _a = $67fa5b975bcbc2ac$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, fragment.selectionSet), selectionSet = _a.selectionSet, fragmentUsedFragments = _a.usedFragments, fragmentUsedVariables = _a.usedVariables;
            usedFragments = $67fa5b975bcbc2ac$var$union(usedFragments, fragmentUsedFragments);
            usedVariables = $67fa5b975bcbc2ac$var$union(usedVariables, fragmentUsedVariables);
            if (!fragmentSet[name_1]) {
                fragmentSet[name_1] = true;
                newFragments.push({
                    kind: $1c4hI.Kind.FRAGMENT_DEFINITION,
                    name: {
                        kind: $1c4hI.Kind.NAME,
                        value: name_1
                    },
                    typeCondition: fragment.typeCondition,
                    selectionSet: selectionSet
                });
            }
        }
    };
    while(usedFragments.length !== 0)_loop_1();
    return {
        usedVariables: usedVariables,
        newFragments: newFragments,
        fragmentSet: fragmentSet
    };
}
function $67fa5b975bcbc2ac$var$filterSelectionSet(schema, type, validFragments, selectionSet) {
    var _a;
    var usedFragments = [];
    var usedVariables = [];
    var typeStack = [
        type
    ];
    // Should be rewritten using visitWithSchema
    var filteredSelectionSet = $961BR.visit(selectionSet, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
        enter: function(node) {
            var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
            if (parentType instanceof $lXoEQ.GraphQLObjectType || parentType instanceof $lXoEQ.GraphQLInterfaceType) {
                var fields = parentType.getFields();
                var field = node.name.value === '__typename' ? $h2iUh.TypeNameMetaFieldDef : fields[node.name.value];
                if (!field) return null;
                else typeStack.push(field.type);
                var argNames_1 = (field.args || []).map(function(arg) {
                    return arg.name;
                });
                if (node.arguments) {
                    var args = node.arguments.filter(function(arg) {
                        return argNames_1.indexOf(arg.name.value) !== -1;
                    });
                    if (args.length !== node.arguments.length) return $67fa5b975bcbc2ac$var$__assign($67fa5b975bcbc2ac$var$__assign({}, node), {
                        arguments: args
                    });
                }
            } else if (parentType instanceof $lXoEQ.GraphQLUnionType && node.name.value === '__typename') typeStack.push($h2iUh.TypeNameMetaFieldDef.type);
        },
        leave: function(node) {
            var _a;
            var currentType = typeStack.pop();
            var resolvedType = $67fa5b975bcbc2ac$var$resolveType(currentType);
            if (resolvedType instanceof $lXoEQ.GraphQLObjectType || resolvedType instanceof $lXoEQ.GraphQLInterfaceType) {
                var selections = node.selectionSet && node.selectionSet.selections || null;
                if (!selections || selections.length === 0) {
                    // need to remove any added variables. Is there a better way to do this?
                    $961BR.visit(node, (_a = {}, _a[$1c4hI.Kind.VARIABLE] = function(variableNode) {
                        var index = usedVariables.indexOf(variableNode.name.value);
                        if (index !== -1) usedVariables.splice(index, 1);
                    }, _a));
                    return null;
                }
            }
        }
    }, _a[$1c4hI.Kind.FRAGMENT_SPREAD] = function(node) {
        if (node.name.value in validFragments) {
            var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
            var innerType = validFragments[node.name.value];
            if (!$eYOZQ.default(schema, parentType, innerType)) return null;
            else {
                usedFragments.push(node.name.value);
                return;
            }
        } else return null;
    }, _a[$1c4hI.Kind.INLINE_FRAGMENT] = {
        enter: function(node) {
            if (node.typeCondition) {
                var innerType = schema.getType(node.typeCondition.name.value);
                var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
                if ($eYOZQ.default(schema, parentType, innerType)) typeStack.push(innerType);
                else return null;
            }
        },
        leave: function(node) {
            typeStack.pop();
        }
    }, _a[$1c4hI.Kind.VARIABLE] = function(node) {
        usedVariables.push(node.name.value);
    }, _a));
    return {
        selectionSet: filteredSelectionSet,
        usedFragments: usedFragments,
        usedVariables: usedVariables
    };
}
function $67fa5b975bcbc2ac$var$resolveType(type) {
    var lastType = type;
    while(lastType instanceof $lXoEQ.GraphQLNonNull || lastType instanceof $lXoEQ.GraphQLList)lastType = lastType.ofType;
    return lastType;
}
function $67fa5b975bcbc2ac$var$union() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var cache = {};
    var result = [];
    arrays.forEach(function(array) {
        array.forEach(function(item) {
            if (!cache[item]) {
                cache[item] = true;
                result.push(item);
            }
        });
    });
    return result;
}

});
parcelRegister("eYOZQ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f5cpS = parcelRequire("f5cpS");
var $lXoEQ = parcelRequire("lXoEQ");
function $ae7e3a242f220513$var$implementsAbstractType(schema, typeA, typeB) {
    if (typeA === typeB) return true;
    else if ($lXoEQ.isCompositeType(typeA) && $lXoEQ.isCompositeType(typeB)) return $f5cpS.doTypesOverlap(schema, typeA, typeB);
    else return false;
}
module.exports.default = $ae7e3a242f220513$var$implementsAbstractType;

});


parcelRegister("aYyML", function(module, exports) {
var $7fda7dad3e357eae$var$__assign = module.exports && module.exports.__assign || function() {
    $7fda7dad3e357eae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fda7dad3e357eae$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");
var $7fda7dad3e357eae$var$AddTypenameToAbstract = /** @class */ function() {
    function AddTypenameToAbstract(targetSchema) {
        this.targetSchema = targetSchema;
    }
    AddTypenameToAbstract.prototype.transformRequest = function(originalRequest) {
        var document = $7fda7dad3e357eae$var$addTypenameToAbstract(this.targetSchema, originalRequest.document);
        return $7fda7dad3e357eae$var$__assign($7fda7dad3e357eae$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return AddTypenameToAbstract;
}();
module.exports.default = $7fda7dad3e357eae$var$AddTypenameToAbstract;
function $7fda7dad3e357eae$var$addTypenameToAbstract(targetSchema, document) {
    var _a;
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(document, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var parentType = typeInfo.getParentType();
        var selections = node.selections;
        if (parentType && (parentType instanceof $lXoEQ.GraphQLInterfaceType || parentType instanceof $lXoEQ.GraphQLUnionType) && !selections.find(function(_) {
            return _.kind === $1c4hI.Kind.FIELD && _.name.value === '__typename';
        })) selections = selections.concat({
            kind: $1c4hI.Kind.FIELD,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: '__typename'
            }
        });
        if (selections !== node.selections) return $7fda7dad3e357eae$var$__assign($7fda7dad3e357eae$var$__assign({}, node), {
            selections: selections
        });
    }, _a)));
}

});

parcelRegister("gvWNr", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10LTa = parcelRequire("10LTa");
var $c05d26599fa40d22$var$CheckResultAndHandleErrors = /** @class */ function() {
    function CheckResultAndHandleErrors(info, fieldName) {
        this.info = info;
        this.fieldName = fieldName;
    }
    CheckResultAndHandleErrors.prototype.transformResult = function(result) {
        return $10LTa.checkResultAndHandleErrors(result, this.info, this.fieldName);
    };
    return CheckResultAndHandleErrors;
}();
module.exports.default = $c05d26599fa40d22$var$CheckResultAndHandleErrors;

});

parcelRegister("fB7Hv", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cRJgL = parcelRequire("cRJgL");
/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */ function $b5b048e835d5ba5c$var$mapAsyncIterator(iterator, callback, rejectCallback) {
    var _a;
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function(error) {
            var rethrow = function() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : $b5b048e835d5ba5c$var$asyncMapValue(result.value, callback).then($b5b048e835d5ba5c$var$iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject_1 = rejectCallback;
        mapReject = function(error) {
            return $b5b048e835d5ba5c$var$asyncMapValue(error, reject_1).then($b5b048e835d5ba5c$var$iteratorResult, abruptClose);
        };
    }
    return _a = {
        next: function() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, _a[$cRJgL.$$asyncIterator] = function() {
        return this;
    }, _a;
}
module.exports.default = $b5b048e835d5ba5c$var$mapAsyncIterator;
function $b5b048e835d5ba5c$var$asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function $b5b048e835d5ba5c$var$iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

});

parcelRegister("kYtVo", function(module, exports) {
var $f4509fae9d1b991a$var$__assign = module.exports && module.exports.__assign || function() {
    $f4509fae9d1b991a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4509fae9d1b991a$var$__assign.apply(this, arguments);
};
var $f4509fae9d1b991a$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");

var $eYOZQ = parcelRequire("eYOZQ");
var $f4509fae9d1b991a$var$ExpandAbstractTypes = /** @class */ function() {
    function ExpandAbstractTypes(transformedSchema, targetSchema) {
        this.targetSchema = targetSchema;
        this.mapping = $f4509fae9d1b991a$var$extractPossibleTypes(transformedSchema, targetSchema);
        this.reverseMapping = $f4509fae9d1b991a$var$flipMapping(this.mapping);
    }
    ExpandAbstractTypes.prototype.transformRequest = function(originalRequest) {
        var document = $f4509fae9d1b991a$var$expandAbstractTypes(this.targetSchema, this.mapping, this.reverseMapping, originalRequest.document);
        return $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return ExpandAbstractTypes;
}();
module.exports.default = $f4509fae9d1b991a$var$ExpandAbstractTypes;
function $f4509fae9d1b991a$var$extractPossibleTypes(transformedSchema, targetSchema) {
    var typeMap = transformedSchema.getTypeMap();
    var mapping = {};
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        if ($lXoEQ.isAbstractType(type)) {
            var targetType = targetSchema.getType(typeName);
            if (!$lXoEQ.isAbstractType(targetType)) {
                var implementations = transformedSchema.getPossibleTypes(type) || [];
                mapping[typeName] = implementations.filter(function(impl) {
                    return targetSchema.getType(impl.name);
                }).map(function(impl) {
                    return impl.name;
                });
            }
        }
    });
    return mapping;
}
function $f4509fae9d1b991a$var$flipMapping(mapping) {
    var result = {};
    Object.keys(mapping).forEach(function(typeName) {
        var toTypeNames = mapping[typeName];
        toTypeNames.forEach(function(toTypeName) {
            if (!result[toTypeName]) result[toTypeName] = [];
            result[toTypeName].push(typeName);
        });
    });
    return result;
}
function $f4509fae9d1b991a$var$expandAbstractTypes(targetSchema, mapping, reverseMapping, document) {
    var _a;
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var existingFragmentNames = fragments.map(function(fragment) {
        return fragment.name.value;
    });
    var fragmentCounter = 0;
    var generateFragmentName = function(typeName) {
        var fragmentName;
        do {
            fragmentName = "_" + typeName + "_Fragment" + fragmentCounter;
            fragmentCounter++;
        }while (existingFragmentNames.indexOf(fragmentName) !== -1);
        return fragmentName;
    };
    var newFragments = [];
    var fragmentReplacements = {};
    fragments.forEach(function(fragment) {
        newFragments.push(fragment);
        var possibleTypes = mapping[fragment.typeCondition.name.value];
        if (possibleTypes) {
            fragmentReplacements[fragment.name.value] = [];
            possibleTypes.forEach(function(possibleTypeName) {
                var name = generateFragmentName(possibleTypeName);
                existingFragmentNames.push(name);
                var newFragment = {
                    kind: $1c4hI.Kind.FRAGMENT_DEFINITION,
                    name: {
                        kind: $1c4hI.Kind.NAME,
                        value: name
                    },
                    typeCondition: {
                        kind: $1c4hI.Kind.NAMED_TYPE,
                        name: {
                            kind: $1c4hI.Kind.NAME,
                            value: possibleTypeName
                        }
                    },
                    selectionSet: fragment.selectionSet
                };
                newFragments.push(newFragment);
                fragmentReplacements[fragment.name.value].push({
                    fragmentName: name,
                    typeName: possibleTypeName
                });
            });
        }
    });
    var newDocument = $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, document), {
        definitions: $f4509fae9d1b991a$var$__spreadArrays(operations, newFragments)
    });
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(newDocument, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var newSelections = $f4509fae9d1b991a$var$__spreadArrays(node.selections);
        var parentType = $lXoEQ.getNamedType(typeInfo.getParentType());
        node.selections.forEach(function(selection) {
            if (selection.kind === $1c4hI.Kind.INLINE_FRAGMENT) {
                var possibleTypes = mapping[selection.typeCondition.name.value];
                if (possibleTypes) possibleTypes.forEach(function(possibleType) {
                    if ($eYOZQ.default(targetSchema, parentType, targetSchema.getType(possibleType))) newSelections.push({
                        kind: $1c4hI.Kind.INLINE_FRAGMENT,
                        typeCondition: {
                            kind: $1c4hI.Kind.NAMED_TYPE,
                            name: {
                                kind: $1c4hI.Kind.NAME,
                                value: possibleType
                            }
                        },
                        selectionSet: selection.selectionSet
                    });
                });
            } else if (selection.kind === $1c4hI.Kind.FRAGMENT_SPREAD) {
                var fragmentName = selection.name.value;
                var replacements = fragmentReplacements[fragmentName];
                if (replacements) replacements.forEach(function(replacement) {
                    var typeName = replacement.typeName;
                    if ($eYOZQ.default(targetSchema, parentType, targetSchema.getType(typeName))) newSelections.push({
                        kind: $1c4hI.Kind.FRAGMENT_SPREAD,
                        name: {
                            kind: $1c4hI.Kind.NAME,
                            value: replacement.fragmentName
                        }
                    });
                });
            }
        });
        if (parentType && reverseMapping[parentType.name]) newSelections.push({
            kind: $1c4hI.Kind.FIELD,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: '__typename'
            }
        });
        if (newSelections.length !== node.selections.length) return $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, node), {
            selections: newSelections
        });
    }, _a)));
}

});

parcelRegister("4trzE", function(module, exports) {
var $341f4279b3bb4e24$var$__assign = module.exports && module.exports.__assign || function() {
    $341f4279b3bb4e24$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $341f4279b3bb4e24$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
var $6ds0g = parcelRequire("6ds0g");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");
var $341f4279b3bb4e24$var$ReplaceFieldWithFragment = /** @class */ function() {
    function ReplaceFieldWithFragment(targetSchema, fragments) {
        this.targetSchema = targetSchema;
        this.mapping = {};
        for(var _i = 0, fragments_1 = fragments; _i < fragments_1.length; _i++){
            var _a = fragments_1[_i], field = _a.field, fragment = _a.fragment;
            var parsedFragment = $341f4279b3bb4e24$var$parseFragmentToInlineFragment(fragment);
            var actualTypeName = parsedFragment.typeCondition.name.value;
            this.mapping[actualTypeName] = this.mapping[actualTypeName] || {};
            if (this.mapping[actualTypeName][field]) this.mapping[actualTypeName][field].push(parsedFragment);
            else this.mapping[actualTypeName][field] = [
                parsedFragment
            ];
        }
    }
    ReplaceFieldWithFragment.prototype.transformRequest = function(originalRequest) {
        var document = $341f4279b3bb4e24$var$replaceFieldsWithFragments(this.targetSchema, originalRequest.document, this.mapping);
        return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return ReplaceFieldWithFragment;
}();
module.exports.default = $341f4279b3bb4e24$var$ReplaceFieldWithFragment;
function $341f4279b3bb4e24$var$replaceFieldsWithFragments(targetSchema, document, mapping) {
    var _a;
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(document, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var parentType = typeInfo.getParentType();
        if (parentType) {
            var parentTypeName_1 = parentType.name;
            var selections_1 = node.selections;
            if (mapping[parentTypeName_1]) node.selections.forEach(function(selection) {
                if (selection.kind === $1c4hI.Kind.FIELD) {
                    var name_1 = selection.name.value;
                    var fragments = mapping[parentTypeName_1][name_1];
                    if (fragments && fragments.length > 0) {
                        var fragment = $341f4279b3bb4e24$var$concatInlineFragments(parentTypeName_1, fragments);
                        selections_1 = selections_1.concat(fragment);
                    }
                }
            });
            if (selections_1 !== node.selections) return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, node), {
                selections: selections_1
            });
        }
    }, _a)));
}
function $341f4279b3bb4e24$var$parseFragmentToInlineFragment(definitions) {
    if (definitions.trim().startsWith('fragment')) {
        var document_1 = $6ds0g.parse(definitions);
        for(var _i = 0, _a = document_1.definitions; _i < _a.length; _i++){
            var definition = _a[_i];
            if (definition.kind === $1c4hI.Kind.FRAGMENT_DEFINITION) return {
                kind: $1c4hI.Kind.INLINE_FRAGMENT,
                typeCondition: definition.typeCondition,
                selectionSet: definition.selectionSet
            };
        }
    }
    var query = $6ds0g.parse("{" + definitions + "}").definitions[0];
    for(var _b = 0, _c = query.selectionSet.selections; _b < _c.length; _b++){
        var selection = _c[_b];
        if (selection.kind === $1c4hI.Kind.INLINE_FRAGMENT) return selection;
    }
    throw new Error('Could not parse fragment');
}
function $341f4279b3bb4e24$var$concatInlineFragments(type, fragments) {
    var fragmentSelections = fragments.reduce(function(selections, fragment) {
        return selections.concat(fragment.selectionSet.selections);
    }, []);
    var deduplicatedFragmentSelection = $341f4279b3bb4e24$var$deduplicateSelection(fragmentSelections);
    return {
        kind: $1c4hI.Kind.INLINE_FRAGMENT,
        typeCondition: {
            kind: $1c4hI.Kind.NAMED_TYPE,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: type
            }
        },
        selectionSet: {
            kind: $1c4hI.Kind.SELECTION_SET,
            selections: deduplicatedFragmentSelection
        }
    };
}
function $341f4279b3bb4e24$var$deduplicateSelection(nodes) {
    var selectionMap = nodes.reduce(function(map, node) {
        var _a, _b, _c;
        switch(node.kind){
            case 'Field':
                if (node.alias) {
                    if (map.hasOwnProperty(node.alias.value)) return map;
                    else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_a = {}, _a[node.alias.value] = node, _a));
                } else {
                    if (map.hasOwnProperty(node.name.value)) return map;
                    else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_b = {}, _b[node.name.value] = node, _b));
                }
            case 'FragmentSpread':
                if (map.hasOwnProperty(node.name.value)) return map;
                else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_c = {}, _c[node.name.value] = node, _c));
            case 'InlineFragment':
                if (map.__fragment) {
                    var fragment = map.__fragment;
                    return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), {
                        __fragment: $341f4279b3bb4e24$var$concatInlineFragments(fragment.typeCondition.name.value, [
                            fragment,
                            node
                        ])
                    });
                } else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), {
                    __fragment: node
                });
            default:
                return map;
        }
    }, {});
    var selection = Object.keys(selectionMap).reduce(function(selectionList, node) {
        return selectionList.concat(selectionMap[node]);
    }, []);
    return selection;
}

});

parcelRegister("goXjX", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bf0ce71a50359f69$var$ConvertEnumResponse = /** @class */ function() {
    function ConvertEnumResponse(enumNode) {
        this.enumNode = enumNode;
    }
    ConvertEnumResponse.prototype.transformResult = function(result) {
        var value = this.enumNode.getValue(result);
        if (value) return value.value;
        return result;
    };
    return ConvertEnumResponse;
}();
module.exports.default = $bf0ce71a50359f69$var$ConvertEnumResponse;

});


parcelRegister("dkK13", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5hGV7 = parcelRequire("5hGV7");
var $glHRe = parcelRequire("glHRe");
var $bOniD = parcelRequire("bOniD");
var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");
var $1c4hI = parcelRequire("1c4hI");
var $3E0nn = parcelRequire("3E0nn");

var $j0Odg = parcelRequire("j0Odg");
var $9b50d66fb2ab7736$var$backcompatOptions = {
    commentDescriptions: true
};
function $9b50d66fb2ab7736$var$typeFromAST(node) {
    switch(node.kind){
        case $1c4hI.Kind.OBJECT_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeObjectType(node);
        case $1c4hI.Kind.INTERFACE_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeInterfaceType(node);
        case $1c4hI.Kind.ENUM_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeEnumType(node);
        case $1c4hI.Kind.UNION_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeUnionType(node);
        case $1c4hI.Kind.SCALAR_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeScalarType(node);
        case $1c4hI.Kind.INPUT_OBJECT_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeInputObjectType(node);
        case $1c4hI.Kind.DIRECTIVE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeDirective(node);
        default:
            return null;
    }
}
module.exports.default = $9b50d66fb2ab7736$var$typeFromAST;
function $9b50d66fb2ab7736$var$makeObjectType(node) {
    return new $lXoEQ.GraphQLObjectType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeFields(node.fields);
        },
        interfaces: function() {
            return node.interfaces.map(function(iface) {
                return $9b50d66fb2ab7736$var$createNamedStub(iface.name.value, 'interface');
            });
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeInterfaceType(node) {
    return new $lXoEQ.GraphQLInterfaceType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeFields(node.fields);
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        resolveType: function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
}
function $9b50d66fb2ab7736$var$makeEnumType(node) {
    var values = {};
    node.values.forEach(function(value) {
        values[value.name.value] = {
            description: $glHRe.getDescription(value, $9b50d66fb2ab7736$var$backcompatOptions)
        };
    });
    return new $lXoEQ.GraphQLEnumType({
        name: node.name.value,
        values: values,
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeUnionType(node) {
    return new $lXoEQ.GraphQLUnionType({
        name: node.name.value,
        types: function() {
            return node.types.map(function(type) {
                return $9b50d66fb2ab7736$var$resolveType(type, 'object');
            });
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        resolveType: function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
}
function $9b50d66fb2ab7736$var$makeScalarType(node) {
    return new $lXoEQ.GraphQLScalarType({
        name: node.name.value,
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        serialize: function() {
            return null;
        },
        // Note: validation calls the parse functions to determine if a
        // literal value is correct. Returning null would cause use of custom
        // scalars to always fail validation. Returning false causes them to
        // always pass validation.
        parseValue: function() {
            return false;
        },
        parseLiteral: function() {
            return false;
        }
    });
}
function $9b50d66fb2ab7736$var$makeInputObjectType(node) {
    return new $lXoEQ.GraphQLInputObjectType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeValues(node.fields);
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeFields(nodes) {
    var result = {};
    nodes.forEach(function(node) {
        var deprecatedDirective = node.directives.find(function(directive) {
            return directive && directive.name && directive.name.value === 'deprecated';
        });
        var deprecatedArgument = deprecatedDirective && deprecatedDirective.arguments && deprecatedDirective.arguments.find(function(arg) {
            return arg && arg.name && arg.name.value === 'reason';
        });
        var deprecationReason = deprecatedArgument && deprecatedArgument.value && deprecatedArgument.value.value;
        result[node.name.value] = {
            type: $9b50d66fb2ab7736$var$resolveType(node.type, 'object'),
            args: $9b50d66fb2ab7736$var$makeValues(node.arguments),
            description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
            deprecationReason: deprecationReason
        };
    });
    return result;
}
function $9b50d66fb2ab7736$var$makeValues(nodes) {
    var result = {};
    nodes.forEach(function(node) {
        var type = $9b50d66fb2ab7736$var$resolveType(node.type, 'input');
        result[node.name.value] = {
            type: type,
            defaultValue: $3E0nn.valueFromAST(node.defaultValue, type),
            description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
        };
    });
    return result;
}
function $9b50d66fb2ab7736$var$resolveType(node, type) {
    switch(node.kind){
        case $1c4hI.Kind.LIST_TYPE:
            return new $lXoEQ.GraphQLList($9b50d66fb2ab7736$var$resolveType(node.type, type));
        case $1c4hI.Kind.NON_NULL_TYPE:
            return new $lXoEQ.GraphQLNonNull($9b50d66fb2ab7736$var$resolveType(node.type, type));
        default:
            return $9b50d66fb2ab7736$var$createNamedStub(node.name.value, type);
    }
}
function $9b50d66fb2ab7736$var$createNamedStub(name, type) {
    var constructor;
    if (type === 'object') constructor = $lXoEQ.GraphQLObjectType;
    else if (type === 'interface') constructor = $lXoEQ.GraphQLInterfaceType;
    else constructor = $lXoEQ.GraphQLInputObjectType;
    return new constructor({
        name: name,
        fields: {
            __fake: {
                type: $auu22.GraphQLString
            }
        }
    });
}
function $9b50d66fb2ab7736$var$makeDirective(node) {
    var locations = [];
    node.locations.forEach(function(location) {
        if (location.value in $5hGV7.DirectiveLocation) locations.push(location.value);
    });
    return new $bOniD.GraphQLDirective({
        name: node.name.value,
        description: node.description ? node.description.value : null,
        args: $9b50d66fb2ab7736$var$makeValues(node.arguments),
        locations: locations
    });
}

});

parcelRegister("16dWW", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5HvdU = parcelRequire("5HvdU");
module.exports.transformSchema = $5HvdU.default;

var $iijzq = parcelRequire("iijzq");
module.exports.AddArgumentsAsVariables = $iijzq.default;

var $gvWNr = parcelRequire("gvWNr");
module.exports.CheckResultAndHandleErrors = $gvWNr.default;

var $4trzE = parcelRequire("4trzE");
module.exports.ReplaceFieldWithFragment = $4trzE.default;

var $aYyML = parcelRequire("aYyML");
module.exports.AddTypenameToAbstract = $aYyML.default;

var $8Vthi = parcelRequire("8Vthi");
module.exports.FilterToSchema = $8Vthi.default;

var $irkOK = parcelRequire("irkOK");
module.exports.RenameTypes = $irkOK.default;

var $dhAZO = parcelRequire("dhAZO");
module.exports.FilterTypes = $dhAZO.default;

var $kXMIm = parcelRequire("kXMIm");
module.exports.TransformRootFields = $kXMIm.default;

var $loOHi = parcelRequire("loOHi");
module.exports.RenameRootFields = $loOHi.default;

var $2PHcZ = parcelRequire("2PHcZ");
module.exports.FilterRootFields = $2PHcZ.default;

var $kYtVo = parcelRequire("kYtVo");
module.exports.ExpandAbstractTypes = $kYtVo.default;

var $1t5NR = parcelRequire("1t5NR");
module.exports.ExtractField = $1t5NR.default;

var $6rbaH = parcelRequire("6rbaH");
module.exports.WrapQuery = $6rbaH.default;

});
parcelRegister("5HvdU", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $crrCr = parcelRequire("crrCr");

var $esiZ2 = parcelRequire("esiZ2");

var $esVhq = parcelRequire("esVhq");

var $cLqiN = parcelRequire("cLqiN");
function $4269303177f37031$var$transformSchema(targetSchema, transforms) {
    var schema = $esiZ2.visitSchema(targetSchema, {}, true);
    var mapping = $cLqiN.generateSimpleMapping(targetSchema);
    var resolvers = $cLqiN.generateProxyingResolvers(targetSchema, transforms, mapping);
    schema = $crrCr.addResolveFunctionsToSchema({
        schema: schema,
        resolvers: resolvers,
        resolverValidationOptions: {
            allowResolversNotInSchema: true
        }
    });
    schema = $esVhq.applySchemaTransforms(schema, transforms);
    schema.transforms = transforms;
    return schema;
}
module.exports.default = $4269303177f37031$var$transformSchema;

});
parcelRegister("cLqiN", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7UWAA = parcelRequire("7UWAA");
function $94ae46e8a1e4c305$var$generateProxyingResolvers(targetSchema, transforms, mapping) {
    var result = {};
    Object.keys(mapping).forEach(function(name) {
        result[name] = {};
        var innerMapping = mapping[name];
        Object.keys(innerMapping).forEach(function(from) {
            var _a;
            var to = innerMapping[from];
            var resolverType = to.operation === 'subscription' ? 'subscribe' : 'resolve';
            result[name][from] = (_a = {}, _a[resolverType] = $94ae46e8a1e4c305$var$createProxyingResolver(targetSchema, to.operation, to.name, transforms), _a);
        });
    });
    return result;
}
module.exports.generateProxyingResolvers = $94ae46e8a1e4c305$var$generateProxyingResolvers;
function $94ae46e8a1e4c305$var$generateSimpleMapping(targetSchema) {
    var query = targetSchema.getQueryType();
    var mutation = targetSchema.getMutationType();
    var subscription = targetSchema.getSubscriptionType();
    var result = {};
    if (query) result[query.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(query, 'query');
    if (mutation) result[mutation.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(mutation, 'mutation');
    if (subscription) result[subscription.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(subscription, 'subscription');
    return result;
}
module.exports.generateSimpleMapping = $94ae46e8a1e4c305$var$generateSimpleMapping;
function $94ae46e8a1e4c305$var$generateMappingFromObjectType(type, operation) {
    var result = {};
    var fields = type.getFields();
    Object.keys(fields).forEach(function(fieldName) {
        result[fieldName] = {
            name: fieldName,
            operation: operation
        };
    });
    return result;
}
module.exports.generateMappingFromObjectType = $94ae46e8a1e4c305$var$generateMappingFromObjectType;
function $94ae46e8a1e4c305$var$createProxyingResolver(schema, operation, fieldName, transforms) {
    return function(parent, args, context, info) {
        return $7UWAA.default({
            schema: schema,
            operation: operation,
            fieldName: fieldName,
            args: {},
            context: context,
            info: info,
            transforms: transforms
        });
    };
}

});


parcelRegister("irkOK", function(module, exports) {
var $d6cae588b371003a$var$__assign = module.exports && module.exports.__assign || function() {
    $d6cae588b371003a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d6cae588b371003a$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $961BR = parcelRequire("961BR");

var $kgFtY = parcelRequire("kgFtY");

var $esiZ2 = parcelRequire("esiZ2");
var $d6cae588b371003a$var$RenameTypes = /** @class */ function() {
    function RenameTypes(renamer, options) {
        this.renamer = renamer;
        this.reverseMap = {};
        var _a = options || {}, _b = _a.renameBuiltins, renameBuiltins = _b === void 0 ? false : _b, _c = _a.renameScalars, renameScalars = _c === void 0 ? true : _c;
        this.renameBuiltins = renameBuiltins;
        this.renameScalars = renameScalars;
    }
    RenameTypes.prototype.transformSchema = function(originalSchema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(originalSchema, (_a = {}, _a[$esiZ2.VisitSchemaKind.TYPE] = function(type) {
            if ($kgFtY.default(type) && !_this.renameBuiltins) return undefined;
            if (type instanceof $lXoEQ.GraphQLScalarType && !_this.renameScalars) return undefined;
            var newName = _this.renamer(type.name);
            if (newName && newName !== type.name) {
                _this.reverseMap[newName] = type.name;
                var newType = Object.assign(Object.create(type), type);
                newType.name = newName;
                return newType;
            }
        }, _a[$esiZ2.VisitSchemaKind.ROOT_OBJECT] = function(type) {
            return undefined;
        }, _a));
    };
    RenameTypes.prototype.transformRequest = function(originalRequest) {
        var _a;
        var _this = this;
        var newDocument = $961BR.visit(originalRequest.document, (_a = {}, _a[$1c4hI.Kind.NAMED_TYPE] = function(node) {
            var name = node.name.value;
            if (name in _this.reverseMap) return $d6cae588b371003a$var$__assign($d6cae588b371003a$var$__assign({}, node), {
                name: {
                    kind: $1c4hI.Kind.NAME,
                    value: _this.reverseMap[name]
                }
            });
        }, _a));
        return {
            document: newDocument,
            variables: originalRequest.variables
        };
    };
    RenameTypes.prototype.transformResult = function(result) {
        if (result.data) {
            var data = this.renameTypes(result.data, 'data');
            if (data !== result.data) return $d6cae588b371003a$var$__assign($d6cae588b371003a$var$__assign({}, result), {
                data: data
            });
        }
        return result;
    };
    RenameTypes.prototype.renameTypes = function(value, name) {
        var _this = this;
        if (name === '__typename') return this.renamer(value);
        if (value && typeof value === 'object') {
            var newValue_1 = Array.isArray(value) ? [] : Object.create(Object.getPrototypeOf(value));
            var returnNewValue_1 = false;
            Object.keys(value).forEach(function(key) {
                var oldChild = value[key];
                var newChild = _this.renameTypes(oldChild, key);
                newValue_1[key] = newChild;
                if (newChild !== oldChild) returnNewValue_1 = true;
            });
            if (returnNewValue_1) return newValue_1;
        }
        return value;
    };
    return RenameTypes;
}();
module.exports.default = $d6cae588b371003a$var$RenameTypes;

});

parcelRegister("dhAZO", function(module, exports) {
/* tslint:disable:no-unused-expression */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $esiZ2 = parcelRequire("esiZ2");
var $9ab98f817eaa02e6$var$FilterTypes = /** @class */ function() {
    function FilterTypes(filter) {
        this.filter = filter;
    }
    FilterTypes.prototype.transformSchema = function(schema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(schema, (_a = {}, _a[$esiZ2.VisitSchemaKind.TYPE] = function(type) {
            if (_this.filter(type)) return undefined;
            else return null;
        }, _a));
    };
    return FilterTypes;
}();
module.exports.default = $9ab98f817eaa02e6$var$FilterTypes;

});

parcelRegister("kXMIm", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $hRrcw = parcelRequire("hRrcw");

var $esiZ2 = parcelRequire("esiZ2");

var $h8S1f = parcelRequire("h8S1f");
var $f42f1b0b8b143d7f$var$TransformRootFields = /** @class */ function() {
    function TransformRootFields(transform) {
        this.transform = transform;
    }
    TransformRootFields.prototype.transformSchema = function(originalSchema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(originalSchema, (_a = {}, _a[$esiZ2.VisitSchemaKind.QUERY] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Query', fieldName, field);
            });
        }, _a[$esiZ2.VisitSchemaKind.MUTATION] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Mutation', fieldName, field);
            });
        }, _a[$esiZ2.VisitSchemaKind.SUBSCRIPTION] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Subscription', fieldName, field);
            });
        }, _a));
    };
    return TransformRootFields;
}();
module.exports.default = $f42f1b0b8b143d7f$var$TransformRootFields;
function $f42f1b0b8b143d7f$var$transformFields(type, transformer) {
    var resolveType = $h8S1f.createResolveType(function(name, originalType) {
        return originalType;
    });
    var fields = type.getFields();
    var newFields = {};
    Object.keys(fields).forEach(function(fieldName) {
        var field = fields[fieldName];
        var newField = transformer(fieldName, field);
        if (typeof newField === 'undefined') newFields[fieldName] = $h8S1f.fieldToFieldConfig(field, resolveType, true);
        else if (newField !== null) {
            if (newField.name) newFields[newField.name] = newField.field;
            else newFields[fieldName] = newField;
        }
    });
    if ($hRrcw.default(newFields)) return null;
    else return new $lXoEQ.GraphQLObjectType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        fields: newFields
    });
}

});

parcelRegister("loOHi", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h8S1f = parcelRequire("h8S1f");

var $kXMIm = parcelRequire("kXMIm");
var $0405365c21702eb7$var$RenameRootFields = /** @class */ function() {
    function RenameRootFields(renamer) {
        var resolveType = $h8S1f.createResolveType(function(name, type) {
            return type;
        });
        this.transformer = new $kXMIm.default(function(operation, fieldName, field) {
            return {
                name: renamer(operation, fieldName, field),
                field: $h8S1f.fieldToFieldConfig(field, resolveType, true)
            };
        });
    }
    RenameRootFields.prototype.transformSchema = function(originalSchema) {
        return this.transformer.transformSchema(originalSchema);
    };
    return RenameRootFields;
}();
module.exports.default = $0405365c21702eb7$var$RenameRootFields;

});

parcelRegister("2PHcZ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kXMIm = parcelRequire("kXMIm");
var $2101dc7cb7293aa4$var$FilterRootFields = /** @class */ function() {
    function FilterRootFields(filter) {
        this.transformer = new $kXMIm.default(function(operation, fieldName, field) {
            if (filter(operation, fieldName, field)) return undefined;
            else return null;
        });
    }
    FilterRootFields.prototype.transformSchema = function(originalSchema) {
        return this.transformer.transformSchema(originalSchema);
    };
    return FilterRootFields;
}();
module.exports.default = $2101dc7cb7293aa4$var$FilterRootFields;

});

parcelRegister("1t5NR", function(module, exports) {
var $111d00430a4fd662$var$__assign = module.exports && module.exports.__assign || function() {
    $111d00430a4fd662$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $111d00430a4fd662$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $961BR = parcelRequire("961BR");
var $1c4hI = parcelRequire("1c4hI");
var $111d00430a4fd662$var$ExtractField = /** @class */ function() {
    function ExtractField(_a) {
        var from = _a.from, to = _a.to;
        this.from = from;
        this.to = to;
    }
    ExtractField.prototype.transformRequest = function(originalRequest) {
        var _a, _b;
        var fromSelection;
        var ourPathFrom = JSON.stringify(this.from);
        var ourPathTo = JSON.stringify(this.to);
        var fieldPath = [];
        $961BR.visit(originalRequest.document, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPathFrom === JSON.stringify(fieldPath)) {
                    fromSelection = node.selectionSet;
                    return $961BR.BREAK;
                }
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _a));
        fieldPath = [];
        var newDocument = $961BR.visit(originalRequest.document, (_b = {}, _b[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPathTo === JSON.stringify(fieldPath) && fromSelection) return $111d00430a4fd662$var$__assign($111d00430a4fd662$var$__assign({}, node), {
                    selectionSet: fromSelection
                });
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _b));
        return $111d00430a4fd662$var$__assign($111d00430a4fd662$var$__assign({}, originalRequest), {
            document: newDocument
        });
    };
    return ExtractField;
}();
module.exports.default = $111d00430a4fd662$var$ExtractField;

});

parcelRegister("6rbaH", function(module, exports) {
var $4afdee23e45449aa$var$__assign = module.exports && module.exports.__assign || function() {
    $4afdee23e45449aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4afdee23e45449aa$var$__assign.apply(this, arguments);
};
var $4afdee23e45449aa$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
var $961BR = parcelRequire("961BR");
var $4afdee23e45449aa$var$WrapQuery = /** @class */ function() {
    function WrapQuery(path, wrapper, extractor) {
        this.path = path;
        this.wrapper = wrapper;
        this.extractor = extractor;
    }
    WrapQuery.prototype.transformRequest = function(originalRequest) {
        var _a;
        var _this = this;
        var document = originalRequest.document;
        var fieldPath = [];
        var ourPath = JSON.stringify(this.path);
        var newDocument = $961BR.visit(document, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPath === JSON.stringify(fieldPath)) {
                    var wrapResult = _this.wrapper(node.selectionSet);
                    // Selection can be either a single selection or a selection set. If it's just one selection,
                    // let's wrap it in a selection set. Otherwise, keep it as is.
                    var selectionSet = wrapResult.kind === $1c4hI.Kind.SELECTION_SET ? wrapResult : {
                        kind: $1c4hI.Kind.SELECTION_SET,
                        selections: [
                            wrapResult
                        ]
                    };
                    return $4afdee23e45449aa$var$__assign($4afdee23e45449aa$var$__assign({}, node), {
                        selectionSet: selectionSet
                    });
                }
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _a));
        return $4afdee23e45449aa$var$__assign($4afdee23e45449aa$var$__assign({}, originalRequest), {
            document: newDocument
        });
    };
    WrapQuery.prototype.transformResult = function(originalResult) {
        var rootData = originalResult.data;
        if (rootData) {
            var data = rootData;
            var path = $4afdee23e45449aa$var$__spreadArrays(this.path);
            while(path.length > 1){
                var next = path.shift();
                if (data[next]) data = data[next];
            }
            data[path[0]] = this.extractor(data[path[0]]);
        }
        return {
            data: rootData,
            errors: originalResult.errors
        };
    };
    return WrapQuery;
}();
module.exports.default = $4afdee23e45449aa$var$WrapQuery;

});





parcelRegister("1M9Pg", function(module, exports) {

$parcel$export(module.exports, "getCustomResolversFetch", () => $14b1e5582e03fbf5$export$18b0a4b86a372cdb);
class $14b1e5582e03fbf5$export$26e841bcf1aeb894 extends Error {
    constructor(response, resBody){
        super(`[FetchError] Request failed with status ${response.status} and statusMessage=${response.statusText}`);
        this.status = response.status;
        this.response = response;
        this.responseBody = resBody;
        this.name = this.constructor.name;
    }
}
function $14b1e5582e03fbf5$var$removeEmptyProp(obj) {
    const result = {
        ...obj
    };
    Object.entries(result).forEach(([key, val])=>{
        if (val === undefined || val === null) // @ts-ignore (TS7053)
        delete result[key];
    });
    return result;
}
// In docs of fetch API, https://developer.mozilla.org/en/docs/Web/API/Fetch_API,
// fetch just throw error for network error, it does not throw error for server error like 400,...
async function $14b1e5582e03fbf5$var$handleFetchCommonResponse(res) {
    if (!res.ok) {
        let resBody;
        try {
            resBody = await res.json();
        } catch (e) {
        // ignore parsing body error
        }
        throw new $14b1e5582e03fbf5$export$26e841bcf1aeb894(res, resBody);
    }
    return res;
}
const $14b1e5582e03fbf5$export$18b0a4b86a372cdb = ({ fetch: fetch, statusCodeHandlers: statusCodeHandlers = {} })=>(url, fetchOptions = {})=>{
        const headers = {
            'Content-Type': 'application/json',
            ...fetchOptions.headers
        };
        return fetch(url, {
            credentials: 'include',
            ...fetchOptions,
            headers: $14b1e5582e03fbf5$var$removeEmptyProp(headers)
        }).then((response)=>{
            const { status: status } = response;
            const handler = statusCodeHandlers[status];
            if (typeof handler === 'function') handler(response);
            return response;
        }).then($14b1e5582e03fbf5$var$handleFetchCommonResponse);
    };

});

parcelRegister("NwkJu", function(module, exports) {

$parcel$export(module.exports, "isCustomQuery", () => $094da875295d8fc4$export$e722a3789f7fabfb);

var $1F1kL = parcelRequire("1F1kL");
const $094da875295d8fc4$var$isDefinitionObjectHasDirective = (def, directiveName)=>{
    if (!def) return false;
    for (const node of def){
        const { operation: type, directives: directives } = node;
        if (type === 'query' || type === 'mutation') return directives && directives.some((directive)=>directive.name.value === directiveName);
    }
};
const $094da875295d8fc4$var$isQueryContainDirective = (opt, directiveName)=>{
    const globalDef = opt.query && opt.query.definitions;
    const childDef = opt.query && // @ts-ignore (TS7053)
    opt.query[opt.operationName] && // @ts-ignore (TS7053)
    opt.query[opt.operationName].definitions;
    return !!($094da875295d8fc4$var$isDefinitionObjectHasDirective(globalDef, directiveName) || $094da875295d8fc4$var$isDefinitionObjectHasDirective(childDef, directiveName));
};
const $094da875295d8fc4$export$e722a3789f7fabfb = (opt)=>{
    return $094da875295d8fc4$var$isQueryContainDirective(opt, (0, $1F1kL.Directives).CUSTOM);
};

});
parcelRegister("1F1kL", function(module, exports) {

$parcel$export(module.exports, "Directives", () => $135aa7a8906b8eac$export$129646a0e1af8d85);
$parcel$export(module.exports, "CustomDirective", () => $135aa7a8906b8eac$export$97a7ea7443254e53);

var $5hGV7 = parcelRequire("5hGV7");
var $bOniD = parcelRequire("bOniD");
let $135aa7a8906b8eac$export$129646a0e1af8d85 = /*#__PURE__*/ function(Directives) {
    Directives["CUSTOM"] = "custom";
    return Directives;
}({});
const $135aa7a8906b8eac$export$97a7ea7443254e53 = new (0, $bOniD.GraphQLDirective)({
    name: $135aa7a8906b8eac$export$129646a0e1af8d85.CUSTOM,
    locations: [
        (0, $5hGV7.DirectiveLocation).QUERY,
        (0, $5hGV7.DirectiveLocation).MUTATION
    ]
});

});


parcelRegister("gbvre", function(module, exports) {

$parcel$export(module.exports, "createDirectoryHttpLink", () => $bc860f6baf14eacc$export$bacc55ff336c5f9d);
/*
 * Apollo link that does the fetching
 * Docs: https://www.apollographql.com/docs/link/links/http.html
 */ 
var $35Kb7 = parcelRequire("35Kb7");
const $bc860f6baf14eacc$export$bacc55ff336c5f9d = ({ url: url, getCloudId: getCloudId })=>{
    const customFetch = async (uri, options)=>{
        const body = JSON.parse(options.body);
        const uriWithOps = body.operationName ? `${uri}?q=${body.operationName}` : uri;
        if (body.variables && body.variables._withCloudId && getCloudId) {
            delete body.variables._withCloudId;
            body.variables.cloudId = getCloudId();
            options.body = JSON.stringify(body);
        }
        return fetch(uriWithOps, options);
    };
    return new (0, $35Kb7.HttpLink)({
        uri: url,
        credentials: 'include',
        fetch: customFetch
    });
};

});
parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $5ECju.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});



parcelRegister("7ciYF", function(module, exports) {

$parcel$export(module.exports, "createErrorLink", () => $53d85fed03d4a4ee$export$d0106730d0f8f3b5);
/*
 * Apollo Link for additional requests error handling
 * Docs: https://www.apollographql.com/docs/link/links/error.html
 */ 
var $aqG9W = parcelRequire("aqG9W");

var $ajTgl = parcelRequire("ajTgl");
const $53d85fed03d4a4ee$export$d0106730d0f8f3b5 = ({ statusCodeHandlers: statusCodeHandlers })=>(0, $aqG9W.onError)((errorResponse)=>{
        const networkError = errorResponse.networkError;
        const graphQLErrors = errorResponse.graphQLErrors;
        if (graphQLErrors) // Our existing GraphQLError has its own type, and graphql one is not exposing the type information correctly
        // So in here we gonna go with `any` type for now
        // eslint-disable-next-line no-console
        console.error((0, $ajTgl.GraphQLError).from(errorResponse.graphQLErrors));
        if (networkError) {
            const statusCode = networkError.statusCode;
            const handler = statusCodeHandlers[statusCode];
            if (typeof handler === 'function') {
                /**
       * these functions are expecting a Response object, which is not present here.
       * It appears statusCodeHandlers are never passed to createErrorLink, so we should investigate removal
       */ // @ts-ignore
                handler();
                return;
            }
        }
    });

});
parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $5ECju.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("ajTgl", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $78368bbae312451c$export$92d6ed0888e7cb7f);

var $5zQU9 = parcelRequire("5zQU9");
var $78368bbae312451c$var$_class;
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $78368bbae312451c$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $78368bbae312451c$export$c73ca302efeda3b4 extends $78368bbae312451c$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $78368bbae312451c$export$c73ca302efeda3b4.prototype);
    }
}
class $78368bbae312451c$export$20de9a0e470e95aa extends $78368bbae312451c$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $78368bbae312451c$export$20de9a0e470e95aa.prototype);
    }
}
class $78368bbae312451c$export$65bd6083489bd8bb extends $78368bbae312451c$var$CommonError {
    constructor({ message: message, status: status }){
        super(message);
        Object.setPrototypeOf(this, $78368bbae312451c$export$65bd6083489bd8bb.prototype);
        this.status = status;
    }
}
class $78368bbae312451c$export$92d6ed0888e7cb7f extends $78368bbae312451c$var$CommonError {
    // tslint:disable-line no-any
    constructor({ message: message = 'unknown', category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $78368bbae312451c$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
}
$78368bbae312451c$var$_class = $78368bbae312451c$export$92d6ed0888e7cb7f;
(0, $5zQU9.default)($78368bbae312451c$export$92d6ed0888e7cb7f, "from", (rawErrors)=>{
    const firstError = rawErrors[0];
    const errorData = {
        category: firstError.category,
        message: firstError.message
    };
    if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
        obj[item.field] = item.message;
        return obj;
    }, {});
    return new $78368bbae312451c$var$_class(errorData);
});

});


parcelRegister("5Rad2", function(module, exports) {

$parcel$export(module.exports, "createRetryLink", () => $4439d25db7532b85$export$91ceafe7c6f4a732);
/*
 * Apollo Link to make sure our requests have re-try functionality in case of request failure
 * Docs: https://www.apollographql.com/docs/link/links/retry.html
 */ 
var $kcwGc = parcelRequire("kcwGc");
const $4439d25db7532b85$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $4439d25db7532b85$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
const $4439d25db7532b85$export$91ceafe7c6f4a732 = (retryOptions)=>new (0, $kcwGc.RetryLink)({
        delay: {
            initial: $4439d25db7532b85$export$8f4286bf21155381.INITIAL_DELAY,
            max: Infinity,
            jitter: $4439d25db7532b85$export$8f4286bf21155381.JITTER,
            ...retryOptions.delay
        },
        attempts: {
            max: $4439d25db7532b85$export$8f4286bf21155381.MAX_RETRIES,
            retryIf: (error, operation)=>{
                const context = operation.getContext();
                const response = context.response;
                const noRetry = context.noRetry;
                return $4439d25db7532b85$export$55b2fbd5d4a32495(response && response.status) && !noRetry;
            },
            ...retryOptions.attempts
        }
    });

});
parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $5ECju.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});


parcelRegister("sfOt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $054ee1c56d2b49c4$export$2e2bcd8739ae039);
// queries

var $7Pe2w = parcelRequire("7Pe2w");

var $bIeVG = parcelRequire("bIeVG");

var $5J1A2 = parcelRequire("5J1A2");

var $dcK67 = parcelRequire("dcK67");

var $2hFCB = parcelRequire("2hFCB");

var $cbCth = parcelRequire("cbCth");

var $9yv9G = parcelRequire("9yv9G");

var $2HKkh = parcelRequire("2HKkh");

var $kiN4x = parcelRequire("kiN4x");

var $iLBQP = parcelRequire("iLBQP");

var $3ZzsA = parcelRequire("3ZzsA");

var $5U2Hc = parcelRequire("5U2Hc");

var $brWlY = parcelRequire("brWlY");

var $eR1IV = parcelRequire("eR1IV");

var $4gsnr = parcelRequire("4gsnr");

var $6ZbMa = parcelRequire("6ZbMa");
// mutations
const $054ee1c56d2b49c4$var$resolvers = {
    Query: {
        User: $3ZzsA.default,
        MyAvatar: $dcK67.default,
        UserOrganization: $6ZbMa.default,
        UserManageConfig: $5U2Hc.default,
        UserManagePrivacySettings: $eR1IV.default,
        UserManageLinkedAccounts: $brWlY.default,
        UserManagePrivacySettingsAllowed: $4gsnr.default,
        TeamInSlack: $2hFCB.default,
        Containers: $7Pe2w.default,
        TeamLinkIcons: $cbCth.default
    },
    Mutation: {
        updateUser: $2HKkh.default,
        deleteUserAvatar: $bIeVG.default,
        updateUserAvatar: $kiN4x.default,
        updateUserPrivacySettings: $iLBQP.default,
        updateTeamInSlack: $9yv9G.default,
        disconnectTeamInSlack: $5J1A2.default
    }
};
var $054ee1c56d2b49c4$export$2e2bcd8739ae039 = $054ee1c56d2b49c4$var$resolvers;

});
parcelRegister("7Pe2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b282fd2460ac380$export$2e2bcd8739ae039);
const $5b282fd2460ac380$var$Containers = async (_, args, context, info)=>{
    const { userId: userId, maxNumberOfResults: maxNumberOfResults, principalId: principalId, siteId: siteId, sessionId: sessionId } = args;
    return await context.fetch(`${context.url.collaborationGraph}/v1/collaborationgraph/user/container`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        })
    }).then((res)=>{
        // Matches type of QueryData['Containers'] in
        // packages/embeddable-directory/src/components/CGContainers/ContainersQuery.tsx
        return res.json();
    });
};
var $5b282fd2460ac380$export$2e2bcd8739ae039 = $5b282fd2460ac380$var$Containers;

});

parcelRegister("bIeVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $886f62689df35a50$export$2e2bcd8739ae039);
const $886f62689df35a50$var$deleteUserAvatar = async (_, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    return context.fetch(url, {
        method: 'DELETE'
    }).then(()=>true);
};
var $886f62689df35a50$export$2e2bcd8739ae039 = $886f62689df35a50$var$deleteUserAvatar;

});

parcelRegister("5J1A2", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b261890bf9866f$export$2e2bcd8739ae039);
const $42b261890bf9866f$var$disconnectTeamInSlack = async (_, args, context)=>{
    const { teamId: teamId } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}`;
    return context.fetch(url, {
        method: 'DELETE'
    }).then((data)=>data.json()).then((data)=>({
            id: teamId,
            // this helps to update cache easily
            ...data
        }));
};
var $42b261890bf9866f$export$2e2bcd8739ae039 = $42b261890bf9866f$var$disconnectTeamInSlack;

});

parcelRegister("dcK67", function(module, exports) {

$parcel$export(module.exports, "default", () => $99d0276a1aff5bce$export$2e2bcd8739ae039);
const $99d0276a1aff5bce$var$myAvatar = async (root, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    return context.fetch(url).then((data)=>data.json());
};
var $99d0276a1aff5bce$export$2e2bcd8739ae039 = $99d0276a1aff5bce$var$myAvatar;

});

parcelRegister("2hFCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a9d748319dcd1b8$export$2e2bcd8739ae039);
const $1a9d748319dcd1b8$var$teamInSlack = async (root, args, context)=>{
    const { teamId: teamId, teamName: teamName } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?teamName=${encodeURIComponent(teamName)}`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>({
            id: teamId,
            // this helps to update cache easily
            ...data
        }));
};
var $1a9d748319dcd1b8$export$2e2bcd8739ae039 = $1a9d748319dcd1b8$var$teamInSlack;

});

parcelRegister("cbCth", function(module, exports) {

$parcel$export(module.exports, "default", () => $024a227ed07396b0$export$2e2bcd8739ae039);

var $fgw5I = parcelRequire("fgw5I");
const $024a227ed07396b0$var$TeamLinkIcons = async (_, args, context, info)=>{
    const requestBody = args.teamLinkUrls.map((url)=>({
            resourceUrl: url
        }));
    const options = {
        method: 'POST',
        body: JSON.stringify(requestBody)
    };
    return context.fetch(`${context.url.stargateRoot}/object-resolver/resolve/batch`, options).then((res)=>res.json()).then((0, $fgw5I.transformIconData));
};
var $024a227ed07396b0$export$2e2bcd8739ae039 = $024a227ed07396b0$var$TeamLinkIcons;

});
parcelRegister("fgw5I", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $b1d13e4dfe1a00f9$export$39f4468adf4cb57c);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ /**
 * These names match the Provider Name in the JSON-LD response from respective resolvers
 */ var $b1d13e4dfe1a00f9$var$ProviderNames = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}($b1d13e4dfe1a00f9$var$ProviderNames || {});
const $b1d13e4dfe1a00f9$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case $b1d13e4dfe1a00f9$var$ProviderNames.CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $b1d13e4dfe1a00f9$var$getConfluenceFavicon(url),
                productName: name
            };
        case $b1d13e4dfe1a00f9$var$ProviderNames.JIRA:
            return {
                linkUrl: url,
                iconUrl: $b1d13e4dfe1a00f9$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $b1d13e4dfe1a00f9$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $b1d13e4dfe1a00f9$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($b1d13e4dfe1a00f9$var$isIconItemSuccess).map((resp)=>resp.body.data).map($b1d13e4dfe1a00f9$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $b1d13e4dfe1a00f9$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $b1d13e4dfe1a00f9$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});


parcelRegister("9yv9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4f74cfd78bebf2$export$2e2bcd8739ae039);
const $6f4f74cfd78bebf2$var$updateTeamInSlack = async (_, args, context)=>{
    const { teamId: teamId, channelId: channelId, usergroupHandle: usergroupHandle } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`;
    return context.fetch(url, {
        method: 'POST'
    }).then((data)=>data.json()).then((data)=>({
            id: teamId,
            // this helps to update cache easily
            ...data
        }));
};
var $6f4f74cfd78bebf2$export$2e2bcd8739ae039 = $6f4f74cfd78bebf2$var$updateTeamInSlack;

});

parcelRegister("2HKkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f838856adba87b2$export$2e2bcd8739ae039);

var $8x3ue = parcelRequire("8x3ue");
const $1f838856adba87b2$var$updateUser = async (_, args, context, info)=>{
    const { id: id, input: input } = args;
    const url = `${context.url.stargateRoot}/users/${id}/manage/profile`;
    const body = JSON.stringify($8x3ue.toManageAPIInput(input));
    return context.fetch(url, {
        method: 'PATCH',
        body: body
    }).then((data)=>data.json()).then((res)=>$8x3ue.fromManageAPIResponse(res));
};
var $1f838856adba87b2$export$2e2bcd8739ae039 = $1f838856adba87b2$var$updateUser;

});
parcelRegister("8x3ue", function(module, exports) {

$parcel$export(module.exports, "fromManageAPIResponse", () => $63641c2af2eb1663$export$5299664357e4f3dd);
$parcel$export(module.exports, "toManageAPIInput", () => $63641c2af2eb1663$export$7b103107c889cb67);

var $6x1NF = parcelRequire("6x1NF");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $63641c2af2eb1663$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $63641c2af2eb1663$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $63641c2af2eb1663$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $6x1NF.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($63641c2af2eb1663$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($63641c2af2eb1663$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$63641c2af2eb1663$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($63641c2af2eb1663$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($63641c2af2eb1663$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$63641c2af2eb1663$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
const $63641c2af2eb1663$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($63641c2af2eb1663$var$PROFILE_PROPS_MAP.has(key)) output[$63641c2af2eb1663$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($63641c2af2eb1663$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$63641c2af2eb1663$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};

});


parcelRegister("kiN4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7b8dc88e01790f$export$2e2bcd8739ae039);

var $aSVz3 = parcelRequire("aSVz3");
const $ec7b8dc88e01790f$var$updateUserAvatar = async (_, args, context)=>{
    const { userId: userId, fileURI: fileURI } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    const fileObject = (0, $aSVz3.dataURItoFile)(fileURI);
    const formData = new FormData();
    formData.append('file', fileObject);
    const fetchOptions = {
        method: 'PUT',
        body: formData,
        headers: {
            'Content-Type': undefined
        }
    };
    return context// @ts-ignore: we want to not pass 'Content-Type' header explicitly
    .fetch(url, fetchOptions)// Although current API in id-public-api-facade does not return new uploaded avatar,
    // we still want to have it in client-side
    .then(()=>({
            url: fileURI
        }));
};
var $ec7b8dc88e01790f$export$2e2bcd8739ae039 = $ec7b8dc88e01790f$var$updateUserAvatar;

});
parcelRegister("aSVz3", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $7ecb99a1f7d7243a$export$80d19edb7b1ae293);
function $7ecb99a1f7d7243a$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});


parcelRegister("iLBQP", function(module, exports) {

$parcel$export(module.exports, "default", () => $da99fa3aca9088e0$export$2e2bcd8739ae039);

var $4mXC7 = parcelRequire("4mXC7");
const $da99fa3aca9088e0$var$updateUserPrivacySettings = async (_, args, context, info)=>{
    const { id: id, input: input } = args;
    const url = `${context.url.stargateRoot}/users/${id}/manage/privacy-settings`;
    const body = JSON.stringify((0, $4mXC7.transformPrivacySettingsFormatFromSchemaToApi)(input));
    return context.fetch(url, {
        method: 'PATCH',
        body: body
    }).then((data)=>data.json()).then((data)=>(0, $4mXC7.transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
            ...data,
            id: id
        }));
};
var $da99fa3aca9088e0$export$2e2bcd8739ae039 = $da99fa3aca9088e0$var$updateUserPrivacySettings;

});
parcelRegister("4mXC7", function(module, exports) {

$parcel$export(module.exports, "PRIVACY_SETTINGS_SCHEMA_TO_API_MAP", () => $32e7758f4fbb30c7$export$4154b9b275895abf);
$parcel$export(module.exports, "transformPrivacySettingsFormatFromApiToSchema", () => $32e7758f4fbb30c7$export$bfc3808f21c9d49d);
$parcel$export(module.exports, "transformPrivacySettingsFormatFromSchemaToApi", () => $32e7758f4fbb30c7$export$f5a6643bba95b2d0);

var $7Nzw2 = parcelRequire("7Nzw2");
const $32e7758f4fbb30c7$var$manageUserPrivacySettingsKeys = [
    'name',
    'nickname',
    'zoneinfo',
    'picture',
    'email',
    'phoneNumber',
    'jobTitle',
    'organization',
    'department',
    'location'
];
const $32e7758f4fbb30c7$var$schemaKeys = {
    name: 'name',
    nickname: 'nickname',
    zoneinfo: 'zoneinfo',
    picture: 'picture',
    email: 'email',
    phoneNumber: 'phoneNumber',
    jobTitle: 'jobTitle',
    organization: 'organization',
    department: 'department',
    location: 'location'
};
const $32e7758f4fbb30c7$var$apiKeys = {
    name: 'name',
    nickname: 'nickname',
    zoneinfo: 'zoneinfo',
    picture: 'picture',
    email: 'email',
    phoneNumber: 'extended_profile.phone_number',
    jobTitle: 'extended_profile.job_title',
    organization: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $32e7758f4fbb30c7$export$4154b9b275895abf = {
    [$32e7758f4fbb30c7$var$schemaKeys.name]: $32e7758f4fbb30c7$var$apiKeys.name,
    [$32e7758f4fbb30c7$var$schemaKeys.nickname]: $32e7758f4fbb30c7$var$apiKeys.nickname,
    [$32e7758f4fbb30c7$var$schemaKeys.zoneinfo]: $32e7758f4fbb30c7$var$apiKeys.zoneinfo,
    [$32e7758f4fbb30c7$var$schemaKeys.picture]: $32e7758f4fbb30c7$var$apiKeys.picture,
    [$32e7758f4fbb30c7$var$schemaKeys.email]: $32e7758f4fbb30c7$var$apiKeys.email,
    [$32e7758f4fbb30c7$var$schemaKeys.phoneNumber]: $32e7758f4fbb30c7$var$apiKeys.phoneNumber,
    // extended profile
    [$32e7758f4fbb30c7$var$schemaKeys.jobTitle]: $32e7758f4fbb30c7$var$apiKeys.jobTitle,
    [$32e7758f4fbb30c7$var$schemaKeys.organization]: $32e7758f4fbb30c7$var$apiKeys.organization,
    [$32e7758f4fbb30c7$var$schemaKeys.department]: $32e7758f4fbb30c7$var$apiKeys.department,
    [$32e7758f4fbb30c7$var$schemaKeys.location]: $32e7758f4fbb30c7$var$apiKeys.location
};
const $32e7758f4fbb30c7$export$bfc3808f21c9d49d = (data)=>Object.keys($32e7758f4fbb30c7$export$4154b9b275895abf).reduce((memo, schemaValue)=>{
        const apiResponseKey = $32e7758f4fbb30c7$export$4154b9b275895abf[schemaValue];
        const privacySetting = data[apiResponseKey];
        memo[schemaValue] = (0, $7Nzw2.toUpperCase)(privacySetting);
        return memo;
    }, {});
const $32e7758f4fbb30c7$export$64774399daaaf8ff = {
    [$32e7758f4fbb30c7$var$apiKeys.name]: $32e7758f4fbb30c7$var$schemaKeys.name,
    [$32e7758f4fbb30c7$var$apiKeys.nickname]: $32e7758f4fbb30c7$var$schemaKeys.nickname,
    [$32e7758f4fbb30c7$var$apiKeys.zoneinfo]: $32e7758f4fbb30c7$var$schemaKeys.zoneinfo,
    [$32e7758f4fbb30c7$var$apiKeys.picture]: $32e7758f4fbb30c7$var$schemaKeys.picture,
    [$32e7758f4fbb30c7$var$apiKeys.email]: $32e7758f4fbb30c7$var$schemaKeys.email,
    [$32e7758f4fbb30c7$var$apiKeys.phoneNumber]: $32e7758f4fbb30c7$var$schemaKeys.phoneNumber,
    // extended profile
    [$32e7758f4fbb30c7$var$apiKeys.jobTitle]: $32e7758f4fbb30c7$var$schemaKeys.jobTitle,
    [$32e7758f4fbb30c7$var$apiKeys.organization]: $32e7758f4fbb30c7$var$schemaKeys.organization,
    [$32e7758f4fbb30c7$var$apiKeys.department]: $32e7758f4fbb30c7$var$schemaKeys.department,
    [$32e7758f4fbb30c7$var$apiKeys.location]: $32e7758f4fbb30c7$var$schemaKeys.location
};
const $32e7758f4fbb30c7$export$f5a6643bba95b2d0 = (data)=>Object.keys($32e7758f4fbb30c7$export$64774399daaaf8ff).reduce((memo, apiValue)=>{
        const apiResponseKey = $32e7758f4fbb30c7$export$64774399daaaf8ff[apiValue];
        const privacySetting = data[apiResponseKey];
        if (privacySetting) memo[apiValue] = privacySetting.toLowerCase();
        return memo;
    }, {});

});
parcelRegister("7Nzw2", function(module, exports) {

$parcel$export(module.exports, "toUpperCase", () => $5ad8a8ab9b6b2aac$export$d80c591a9e16646);
const $5ad8a8ab9b6b2aac$export$d80c591a9e16646 = (input)=>{
    if (typeof input === 'string') return input.toUpperCase();
    return null;
};

});



parcelRegister("3ZzsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e82933ed96cea6b$export$2e2bcd8739ae039);
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

var $8x3ue = parcelRequire("8x3ue");
const $2e82933ed96cea6b$var$User = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/profile`;
    return context.fetch(url).then((data)=>data.json()).then((res)=>$8x3ue.fromManageAPIResponse(res));
};
var $2e82933ed96cea6b$export$2e2bcd8739ae039 = $2e82933ed96cea6b$var$User;

});

parcelRegister("5U2Hc", function(module, exports) {

$parcel$export(module.exports, "default", () => $44c4460a8e153bd5$export$2e2bcd8739ae039);
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

var $kGOUd = parcelRequire("kGOUd");
const $44c4460a8e153bd5$var$UserManageConfig = async (_, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $kGOUd.transformUserManageConfig)(data));
};
var $44c4460a8e153bd5$export$2e2bcd8739ae039 = $44c4460a8e153bd5$var$UserManageConfig;

});
parcelRegister("kGOUd", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $f0ff37b6537ad2ff$export$d7725d3d27b80a68);
const $f0ff37b6537ad2ff$var$MUTABILITY_DETAILS_MAP = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $f0ff37b6537ad2ff$var$CUSTOM_FIELD_PLACE = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $f0ff37b6537ad2ff$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $f0ff37b6537ad2ff$var$CUSTOM_FIELD_PLACE[field]) return data[$f0ff37b6537ad2ff$var$CUSTOM_FIELD_PLACE[field]];
    const mappedFieldKey = $f0ff37b6537ad2ff$var$MUTABILITY_DETAILS_MAP[field];
    // @ts-ignore
    return data['profile.write'][mappedFieldKey];
};
const $f0ff37b6537ad2ff$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $f0ff37b6537ad2ff$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return null;
    const reason = fieldConfig.reason;
    return {
        field: field,
        reason: reason && reason.key || null
    };
};
const $f0ff37b6537ad2ff$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($f0ff37b6537ad2ff$var$MUTABILITY_DETAILS_MAP)// @ts-ignore
        .map((field)=>$f0ff37b6537ad2ff$var$getMutabilityConstraintFor(data, field)).filter((truthy)=>truthy)
    });

});


parcelRegister("brWlY", function(module, exports) {

$parcel$export(module.exports, "default", () => $855f7b131004d238$export$2e2bcd8739ae039);
const $855f7b131004d238$var$UserManageLinkedAccounts = (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/linked-accounts`;
    return context.fetch(url).then((res)=>res.json()).then((data)=>{
        return {
            google: Boolean(data && data.google && data.google.linked),
            microsoft: Boolean(data && data.microsoft && data.microsoft.linked),
            apple: Boolean(data && data.apple && data.apple.linked),
            saml: Boolean(data && data.saml && data.saml.linked)
        };
    });
};
var $855f7b131004d238$export$2e2bcd8739ae039 = $855f7b131004d238$var$UserManageLinkedAccounts;

});

parcelRegister("eR1IV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad075a347a6ffbc7$export$2e2bcd8739ae039);

var $4mXC7 = parcelRequire("4mXC7");
const $ad075a347a6ffbc7$var$UserManagePrivacySettings = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $4mXC7.transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
            ...data,
            id: userId
        }));
};
var $ad075a347a6ffbc7$export$2e2bcd8739ae039 = $ad075a347a6ffbc7$var$UserManagePrivacySettings;

});

parcelRegister("4gsnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $31aeab260da469e9$export$2e2bcd8739ae039);

var $bpXl4 = parcelRequire("bpXl4");
const $31aeab260da469e9$var$UserManagePrivacySettingsAllowed = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings/allowed`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $bpXl4.transformUserManagePrivacySettingsAllowed)(data));
};
var $31aeab260da469e9$export$2e2bcd8739ae039 = $31aeab260da469e9$var$UserManagePrivacySettingsAllowed;

});
parcelRegister("bpXl4", function(module, exports) {

$parcel$export(module.exports, "transformUserManagePrivacySettingsAllowed", () => $85000ef3d553141b$export$3f9c63641eb8459e);

var $7Nzw2 = parcelRequire("7Nzw2");

var $4mXC7 = parcelRequire("4mXC7");
const $85000ef3d553141b$var$getAllowedPrivacySettingsFor = (data, schemaValue)=>{
    const apiResponseKey = (0, $4mXC7.PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)[schemaValue];
    const allowedPrivacySettings = data[apiResponseKey];
    if (!allowedPrivacySettings || !allowedPrivacySettings.length) return null;
    return allowedPrivacySettings.map((0, $7Nzw2.toUpperCase));
};
const $85000ef3d553141b$export$3f9c63641eb8459e = (data)=>Object.keys((0, $4mXC7.PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)).reduce((memo, schemaValue)=>{
        memo[schemaValue] = $85000ef3d553141b$var$getAllowedPrivacySettingsFor(data, schemaValue);
        return memo;
    }, {});

});


parcelRegister("6ZbMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5161930c7e957610$export$2e2bcd8739ae039);
const $5161930c7e957610$var$UserOrganization = async (_, args, context, info)=>{
    const url = `${context.url.stargateRoot}/my-orgs`;
    return context.fetch(url).then((data)=>data.json()).then((res)=>({
            cloudId: res.managedBy && res.managedBy.id || null,
            name: res.managedBy && res.managedBy.name || null
        }));
};
var $5161930c7e957610$export$2e2bcd8739ae039 = $5161930c7e957610$var$UserOrganization;

});


parcelRegister("3TcZB", function(module, exports) {

$parcel$export(module.exports, "schema", () => $2d509639964b4752$export$4902baddc787debb);

var $6BdRO = parcelRequire("6BdRO");

var $1F1kL = parcelRequire("1F1kL");

var $2clke = parcelRequire("2clke");

var $f1Ydh = parcelRequire("f1Ydh");
const $2d509639964b4752$export$4902baddc787debb = new (0, $6BdRO.GraphQLSchema)({
    directives: [
        (0, $1F1kL.CustomDirective)
    ],
    query: (0, $f1Ydh.default),
    mutation: (0, $2clke.default)
});

});
parcelRegister("2clke", function(module, exports) {

$parcel$export(module.exports, "default", () => $199d3e8c61ff2794$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $cXiIY = parcelRequire("cXiIY");

var $jdT7B = parcelRequire("jdT7B");

var $5EE2K = parcelRequire("5EE2K");

var $4MYwA = parcelRequire("4MYwA");
const $199d3e8c61ff2794$var$MutationRoot = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        updateUser: {
            type: (0, $5EE2K.default),
            args: {
                id: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                input: {
                    type: (0, $5EE2K.UserInput)
                }
            }
        },
        deleteUserAvatar: {
            description: "Delete user's Atlassian account avatar. In the absence of an Atlassian account avatar, the user's gravatar will be used",
            type: (0, $auu22.GraphQLBoolean),
            args: {
                userId: {
                    description: "User's Atlassian account ID",
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        updateUserAvatar: {
            description: 'Upload an Atlassian account avatar.',
            type: new (0, $lXoEQ.GraphQLObjectType)({
                fields: {
                    url: {
                        type: (0, $auu22.GraphQLString)
                    }
                },
                name: (0, $cXiIY.TypeNames).AVATAR,
                description: 'New avatar URL after uploading successfully'
            }),
            args: {
                userId: {
                    description: "User's Atlassian account ID",
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                fileURI: {
                    description: `Encoded string of image file will be uploaded.
            The avatar has a file size limit of 1MB.`,
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        updateUserPrivacySettings: {
            description: "Updates a user\u2019s privacy settings.",
            type: (0, $4MYwA.default),
            args: {
                id: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                input: {
                    type: (0, $4MYwA.UserPrivacySettingsInput)
                }
            }
        },
        updateTeamInSlack: {
            type: (0, $jdT7B.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                channelId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                usergroupHandle: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        disconnectTeamInSlack: {
            type: (0, $jdT7B.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        }
    },
    name: 'Mutation'
});
var $199d3e8c61ff2794$export$2e2bcd8739ae039 = $199d3e8c61ff2794$var$MutationRoot;

});
parcelRegister("cXiIY", function(module, exports) {

$parcel$export(module.exports, "TypeNames", () => $96e985000967e60d$export$df40df59413bc65c);
let $96e985000967e60d$export$df40df59413bc65c = /*#__PURE__*/ function(TypeNames) {
    TypeNames["USER"] = "_custom_User";
    TypeNames["USER_INPUT"] = "_custom_UserInput";
    TypeNames["USER_MANAGE_CONFIG"] = "_custom_UserManageConfig";
    TypeNames["USER_DETAILS_MUTABILITY_CONSTRAINTS"] = "_custom_UserDetailsMutabilityConstraints";
    TypeNames["USER_MANAGE_LINKED_ACCOUNTS"] = "_custom_UserManageLinkedAccounts";
    TypeNames["PRIVACY_VALUE"] = "_custom_PrivacyValue";
    TypeNames["PRIVACY_VALUE_INPUT"] = "_custom_PrivacyValueInput";
    TypeNames["PRIVACY_SETTINGS"] = "_custom_PrivacySettings";
    TypeNames["PRIVACY_SETTINGS_INPUT"] = "_custom_PrivacySettingsInput";
    TypeNames["PRIVACY_VALUES_CONFIG"] = "_custom_PrivacyValuesConfig";
    TypeNames["USER_PLACE"] = "_custom_UserPlace";
    TypeNames["USER_ORGANIZATION"] = "_custom_UserOrganization";
    TypeNames["PERMISSION_VALUE"] = "_custom_PermissionValue";
    TypeNames["AVATAR"] = "_custom_Avatar";
    TypeNames["MY_AVATAR"] = "_custom_MyAvatar";
    TypeNames["TeamSlackStatus"] = "_custom_TeamSlackStatus";
    TypeNames["CLASSIC_APP"] = "_custom_ClassicApp";
    TypeNames["CLASSIC_APPS"] = "_custom_ClassicApps";
    TypeNames["MARKETPLACE_APP"] = "_custom_MarketplaceApp";
    TypeNames["CLASSIC_APP_INSTALLATION"] = "_custom_ClassicAppInstallation";
    TypeNames["MARKETPLACE_APP_PERMISSION"] = "_custom_MarketplaceAppPermission";
    TypeNames["MARKETPLACE_APP_PERMISSIONS"] = "_custom_MarketplaceAppPermissions";
    TypeNames["API_TOKEN"] = "_custom_ApiToken";
    TypeNames["SESSIONS_AND_DEVICES"] = "_custom_SessionsAndDevices";
    TypeNames["SESSION"] = "_custom_Session";
    TypeNames["DEVICE"] = "_custom_Device";
    TypeNames["ELEVATED_SESSION"] = "_custom_ElevatedSession";
    TypeNames["TSV_ENROLLMENT_DETAILS"] = "_custom_TsvEnrollmentDetails";
    TypeNames["CONTAINERS"] = "_custom_Containers";
    TypeNames["CONTAINER"] = "_custom_Container";
    TypeNames["CONTAINER_DETAILS"] = "_custom_ContainerDetails";
    TypeNames["COLOUR_SETTING"] = "_custom_ColourSetting";
    TypeNames["TEAM_LINK_ICON"] = "_custom_TeamLinkIcon";
    return TypeNames;
}({});

});

parcelRegister("jdT7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe9fd3bb55b2b52$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $cXiIY = parcelRequire("cXiIY");
const $dfe9fd3bb55b2b52$var$TeamInSlackStatusType = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: (0, $auu22.GraphQLString)
        },
        connected: {
            type: (0, $auu22.GraphQLBoolean)
        },
        slackChannelId: {
            type: (0, $auu22.GraphQLString)
        },
        slackChannelName: {
            type: (0, $auu22.GraphQLString)
        },
        usergroupHandle: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $cXiIY.TypeNames).TeamSlackStatus,
    description: 'Whether the team has opted in to being synced with slack'
});
var $dfe9fd3bb55b2b52$export$2e2bcd8739ae039 = $dfe9fd3bb55b2b52$var$TeamInSlackStatusType;

});

parcelRegister("5EE2K", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dfbff6f0bf3aeb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "UserInput", () => $41dfbff6f0bf3aeb$export$3ac5e585cf392ee0);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $cXiIY = parcelRequire("cXiIY");
const $41dfbff6f0bf3aeb$var$User = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: (0, $auu22.GraphQLString)
        },
        fullName: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        timezone: {
            type: (0, $auu22.GraphQLString)
        },
        locale: {
            type: (0, $auu22.GraphQLString)
        },
        avatarUrl: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        status: {
            type: (0, $auu22.GraphQLString)
        },
        // extended profile
        title: {
            type: (0, $auu22.GraphQLString)
        },
        companyName: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        },
        // This should be considered to move to component level that uses timezone
        localTime: {
            type: (0, $auu22.GraphQLString),
            args: {
                format: {
                    description: 'moment.js format string',
                    type: (0, $auu22.GraphQLString),
                    defaultValue: ''
                },
                locale: {
                    description: 'locale for output',
                    type: (0, $auu22.GraphQLString),
                    defaultValue: 'en'
                }
            }
        }
    },
    name: (0, $cXiIY.TypeNames).USER,
    description: 'All User related data will be behind this GraphQL section'
});
var $41dfbff6f0bf3aeb$export$2e2bcd8739ae039 = $41dfbff6f0bf3aeb$var$User;
const $41dfbff6f0bf3aeb$export$3ac5e585cf392ee0 = new (0, $lXoEQ.GraphQLInputObjectType)({
    fields: {
        fullName: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        timezone: {
            type: (0, $auu22.GraphQLString)
        },
        locale: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        status: {
            type: (0, $auu22.GraphQLString)
        },
        // extended profile
        title: {
            type: (0, $auu22.GraphQLString)
        },
        companyName: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $cXiIY.TypeNames).USER_INPUT
});

});

parcelRegister("4MYwA", function(module, exports) {

$parcel$export(module.exports, "UserPrivacySettingsInput", () => $37ca980634c00d2b$export$5d92383dfb6e3588);
$parcel$export(module.exports, "PrivacyValue", () => $37ca980634c00d2b$export$8d71fec0dbffb7e5);
$parcel$export(module.exports, "default", () => $37ca980634c00d2b$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $cXiIY = parcelRequire("cXiIY");
const $37ca980634c00d2b$export$5c97c5d10d84e13c = new (0, $lXoEQ.GraphQLEnumType)({
    name: (0, $cXiIY.TypeNames).PRIVACY_VALUE_INPUT,
    values: {
        PUBLIC: {
            value: 'public'
        },
        COLLABORATOR: {
            value: 'collaborator'
        },
        PRIVATE: {
            value: 'private'
        }
    }
});
const $37ca980634c00d2b$export$5d92383dfb6e3588 = new (0, $lXoEQ.GraphQLInputObjectType)({
    fields: {
        name: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        jobTitle: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        organization: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        zoneinfo: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        },
        picture: {
            type: (0, $auu22.GraphQLString)
        },
        teamType: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $cXiIY.TypeNames).PRIVACY_SETTINGS_INPUT,
    description: 'User privacy settings values to be set'
});
const $37ca980634c00d2b$var$DefaultPrivacyValue = new (0, $lXoEQ.GraphQLEnumType)({
    name: (0, $cXiIY.TypeNames).PRIVACY_VALUE,
    values: {
        PUBLIC: {
            value: 'PUBLIC'
        },
        COLLABORATOR: {
            value: 'COLLABORATOR'
        },
        PRIVATE: {
            value: 'PRIVATE'
        }
    }
});
const $37ca980634c00d2b$export$8d71fec0dbffb7e5 = new (0, $lXoEQ.GraphQLNonNull)($37ca980634c00d2b$var$DefaultPrivacyValue);
const $37ca980634c00d2b$var$UserManagePrivacySettings = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        name: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        nickname: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        jobTitle: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        department: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        organization: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        location: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        zoneinfo: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        email: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        phoneNumber: {
            type: $37ca980634c00d2b$var$DefaultPrivacyValue
        },
        picture: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        },
        teamType: {
            type: $37ca980634c00d2b$export$8d71fec0dbffb7e5
        }
    },
    name: (0, $cXiIY.TypeNames).PRIVACY_SETTINGS,
    description: 'User privacy settings values'
});
var $37ca980634c00d2b$export$2e2bcd8739ae039 = $37ca980634c00d2b$var$UserManagePrivacySettings;

});


parcelRegister("f1Ydh", function(module, exports) {

$parcel$export(module.exports, "default", () => $af15a81b45e91d37$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $69AX8 = parcelRequire("69AX8");
var $jdT7B = parcelRequire("jdT7B");
var $f5uU9 = parcelRequire("f5uU9");
var $5EE2K = parcelRequire("5EE2K");
var $anw3B = parcelRequire("anw3B");
var $1A2Ia = parcelRequire("1A2Ia");
var $4MYwA = parcelRequire("4MYwA");
var $6SK9e = parcelRequire("6SK9e");
var $bCY0Z = parcelRequire("bCY0Z");

var $1EzqM = parcelRequire("1EzqM");
const $af15a81b45e91d37$var$QueryRoot = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        UserOrganization: {
            type: (0, $bCY0Z.default)
        },
        User: {
            type: (0, $5EE2K.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        MyAvatar: {
            type: (0, $69AX8.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManageConfig: {
            type: (0, $anw3B.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManagePrivacySettings: {
            type: (0, $4MYwA.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManagePrivacySettingsAllowed: {
            type: (0, $6SK9e.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManageLinkedAccounts: {
            type: (0, $1A2Ia.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        TeamInSlack: {
            type: (0, $jdT7B.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                teamName: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        Containers: {
            type: (0, $1EzqM.default),
            args: {
                principalId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                siteId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                maxNumberOfResults: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLInt))
                },
                sessionId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        TeamLinkIcons: {
            type: new (0, $lXoEQ.GraphQLList)((0, $f5uU9.default)),
            args: {
                teamLinkUrls: {
                    type: new (0, $lXoEQ.GraphQLList)((0, $auu22.GraphQLString))
                }
            }
        }
    },
    name: 'Query'
});
var $af15a81b45e91d37$export$2e2bcd8739ae039 = $af15a81b45e91d37$var$QueryRoot;

});
parcelRegister("69AX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b03f61a24dec11$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $cXiIY = parcelRequire("cXiIY");
const $47b03f61a24dec11$var$MyAvatar = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        url: {
            type: (0, $auu22.GraphQLString)
        },
        uploaded: {
            type: (0, $auu22.GraphQLBoolean)
        }
    },
    name: (0, $cXiIY.TypeNames).MY_AVATAR,
    description: "Get meta-data about current user\u2019s avatar"
});
var $47b03f61a24dec11$export$2e2bcd8739ae039 = $47b03f61a24dec11$var$MyAvatar;

});

parcelRegister("f5uU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $afbf4baf24535a55$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $cXiIY = parcelRequire("cXiIY");
const $afbf4baf24535a55$var$TeamLinkIcon = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        linkUrl: {
            type: (0, $auu22.GraphQLString)
        },
        iconUrl: {
            type: (0, $auu22.GraphQLString)
        },
        productName: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $cXiIY.TypeNames).TEAM_LINK_ICON,
    description: 'Icon URL to use for a link'
});
var $afbf4baf24535a55$export$2e2bcd8739ae039 = $afbf4baf24535a55$var$TeamLinkIcon;

});

parcelRegister("anw3B", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e4eb43734f9a5b$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $cXiIY = parcelRequire("cXiIY");
const $78e4eb43734f9a5b$var$MutabilityConstraints = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        field: {
            type: (0, $auu22.GraphQLString)
        },
        reason: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $cXiIY.TypeNames).USER_DETAILS_MUTABILITY_CONSTRAINTS
});
const $78e4eb43734f9a5b$var$UserManageConfig = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        mutabilityConstraints: {
            type: new (0, $lXoEQ.GraphQLList)($78e4eb43734f9a5b$var$MutabilityConstraints)
        }
    },
    name: (0, $cXiIY.TypeNames).USER_MANAGE_CONFIG,
    description: 'User mutability constraints values'
});
var $78e4eb43734f9a5b$export$2e2bcd8739ae039 = $78e4eb43734f9a5b$var$UserManageConfig;

});

parcelRegister("1A2Ia", function(module, exports) {

$parcel$export(module.exports, "default", () => $126b41af72f5ad3d$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $cXiIY = parcelRequire("cXiIY");
const $126b41af72f5ad3d$var$LinkedAccounts = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        google: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        microsoft: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        apple: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        saml: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        }
    },
    name: (0, $cXiIY.TypeNames).USER_MANAGE_LINKED_ACCOUNTS
});
var $126b41af72f5ad3d$export$2e2bcd8739ae039 = $126b41af72f5ad3d$var$LinkedAccounts;

});

parcelRegister("6SK9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $502b95370a764207$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");

var $cXiIY = parcelRequire("cXiIY");

var $4MYwA = parcelRequire("4MYwA");
const $502b95370a764207$var$AllowedPrivacyValue = new (0, $lXoEQ.GraphQLList)((0, $4MYwA.PrivacyValue));
const $502b95370a764207$var$UserManagePrivacySettingsAllowed = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        name: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        nickname: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        jobTitle: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        department: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        organization: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        location: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        zoneinfo: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        email: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        phoneNumber: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        picture: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        },
        teamType: {
            type: $502b95370a764207$var$AllowedPrivacyValue
        }
    },
    name: (0, $cXiIY.TypeNames).PRIVACY_VALUES_CONFIG,
    description: 'User privacy settings allowed values'
});
var $502b95370a764207$export$2e2bcd8739ae039 = $502b95370a764207$var$UserManagePrivacySettingsAllowed;

});

parcelRegister("bCY0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8771cc09585fe74e$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $cXiIY = parcelRequire("cXiIY");
const $8771cc09585fe74e$var$UserPlace = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        cloudId: {
            type: (0, $auu22.GraphQLString)
        },
        name: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $cXiIY.TypeNames).USER_ORGANIZATION,
    description: 'Organization a user belongs to'
});
var $8771cc09585fe74e$export$2e2bcd8739ae039 = $8771cc09585fe74e$var$UserPlace;

});

parcelRegister("1EzqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $134502be5166319d$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $cXiIY = parcelRequire("cXiIY");
const $134502be5166319d$var$ContainerDetails = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        key: {
            type: (0, $auu22.GraphQLString)
        },
        name: {
            type: (0, $auu22.GraphQLString)
        },
        url: {
            type: (0, $auu22.GraphQLString)
        },
        iconUrl: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $cXiIY.TypeNames).CONTAINER_DETAILS
});
const $134502be5166319d$var$Container = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        entityType: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        containerType: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        score: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLFloat))
        },
        containerDetails: {
            type: $134502be5166319d$var$ContainerDetails
        }
    },
    name: (0, $cXiIY.TypeNames).CONTAINER
});
const $134502be5166319d$var$Containers = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        collaborationGraphEntities: {
            type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($134502be5166319d$var$Container)))
        }
    },
    name: (0, $cXiIY.TypeNames).CONTAINERS,
    description: 'A list of Places Spaces/Projects'
});
var $134502be5166319d$export$2e2bcd8739ae039 = $134502be5166319d$var$Containers;

});




parcelRegister("7YdTp", function(module, exports) {

$parcel$export(module.exports, "withDefaultExponentialBackoff", () => $5cd8e9ca1d3e609e$export$455df4c93665fa4a);
const $5cd8e9ca1d3e609e$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $5cd8e9ca1d3e609e$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
// tslint:disable-next-line no-any
// tslint:disable-next-line no-any
const $5cd8e9ca1d3e609e$var$defaultRetryIfCallback = (a)=>!a;
const $5cd8e9ca1d3e609e$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $5cd8e9ca1d3e609e$var$defaultRetryIfCallback
};
function $5cd8e9ca1d3e609e$export$20eaa22f2295996f(toTry, hofOptions = $5cd8e9ca1d3e609e$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
   * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
   * The functioned-to-be-retried is called on each recursion.
   */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
function $5cd8e9ca1d3e609e$export$455df4c93665fa4a(fetchOp) {
    return $5cd8e9ca1d3e609e$export$20eaa22f2295996f(fetchOp, {
        initial: $5cd8e9ca1d3e609e$export$8f4286bf21155381.INITIAL_DELAY,
        jitter: $5cd8e9ca1d3e609e$export$8f4286bf21155381.JITTER,
        max: $5cd8e9ca1d3e609e$export$8f4286bf21155381.MAX_RETRIES,
        retryIf: (response)=>$5cd8e9ca1d3e609e$export$55b2fbd5d4a32495(response.status)
    });
}

});



parcelRegister("ecKpb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5762ec1a475248a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4ErPU = parcelRequire("4ErPU");

var $1xrmr = parcelRequire("1xrmr");

var $cHnQD = parcelRequire("cHnQD");
var $04Epr = parcelRequire("04Epr");
var $dkrYA = parcelRequire("dkrYA");
var $4HA2w = parcelRequire("4HA2w");
var $c1nG2 = parcelRequire("c1nG2");
var $6LbQr = parcelRequire("6LbQr");
var $jUprp = parcelRequire("jUprp");
var $clEku = parcelRequire("clEku");

var $8JMI4 = parcelRequire("8JMI4");

var $4OGWt = parcelRequire("4OGWt");

var $8gATS = parcelRequire("8gATS");

var $avLBj = parcelRequire("avLBj");
var $37mOt = parcelRequire("37mOt");

var $5UcXH = parcelRequire("5UcXH");

var $6eCcT = parcelRequire("6eCcT");

var $eKSiD = parcelRequire("eKSiD");

var $7f3ds = parcelRequire("7f3ds");

var $laX0d = parcelRequire("laX0d");

var $etjd2 = parcelRequire("etjd2");
function $a5762ec1a475248a$export$2e2bcd8739ae039(props) {
    const { appName: appName, analytics: analytics, apolloClient: apolloClient, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, replace: replace, push: push, locale: locale, skipI18nProvider: skipI18nProvider, addFlag: addFlag, docTitle: docTitle, env: env, history: history, statusCodeHandlers: statusCodeHandlers, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isSentryEnabled: isSentryEnabled } = props;
    const sentryClient = (0, $6LbQr.useTeamsSentryClientSetup)(isSentryEnabled, {
        appName: appName,
        env: (0, $37mOt.getEnv)()
    });
    const [, { setCloudId: setCloudId }] = (0, $jUprp.useSite)();
    const [, { setOrgId: setOrgId }] = (0, $c1nG2.useOrg)();
    const [, { initTeamCentral: initTeamCentral }] = (0, $clEku.useTeamCentralStoreApi)();
    const { isJiraAvailable: isJiraAvailable } = (0, $8JMI4.useJiraCheckService)(cloudId);
    const expTracker = analytics.expTracker();
    const analyticsClient = analytics.getAnalyticsWebClient();
    (0, $eUqFw.useEffect)(()=>{
        if (orgId) analyticsClient.setOrgInfo(orgId);
    }, [
        analyticsClient,
        orgId
    ]);
    const appConfig = (0, $eUqFw.useMemo)(()=>({
            env: env,
            appName: appName,
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint,
            push: push,
            replace: replace,
            addFlag: addFlag,
            locale: locale,
            docTitle: docTitle,
            cloudId: cloudId,
            orgId: orgId,
            productFeatureFlags: productFeatureFlags,
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot,
            isJiraAvailable: isJiraAvailable
        }), [
        env,
        appName,
        contextSpaPaths,
        contextEntryPoint,
        isJiraAvailable,
        push,
        replace,
        addFlag,
        locale,
        docTitle,
        cloudId,
        orgId,
        productFeatureFlags
    ]);
    // init statusCodeHandlersProvider
    (0, $eUqFw.useEffect)(()=>{
        if (statusCodeHandlers) (0, $4HA2w.statusCodeHandlersProvider).setHandlers(statusCodeHandlers);
    }, [
        statusCodeHandlers
    ]);
    // save cloud id passed from consumers to a remote state management.
    (0, $eUqFw.useEffect)(()=>{
        setCloudId(cloudId);
    }, [
        cloudId,
        setCloudId
    ]);
    // save org id passed from consumers to a remote state management.
    (0, $eUqFw.useEffect)(()=>{
        setOrgId(orgId);
    }, [
        orgId,
        setOrgId
    ]);
    // Init and save various team central related data and preconditions
    (0, $eUqFw.useEffect)(()=>{
        initTeamCentral(appName, cloudId, teamCentralHandlers);
    }, [
        appName,
        cloudId,
        teamCentralHandlers,
        initTeamCentral
    ]);
    const handleTransition = (0, $eUqFw.useCallback)((pathname)=>{
        if (expTracker) expTracker.abort({
            reason: 'Route changes.'
        });
        (0, $8gATS.addBreadcrumb)(pathname);
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkrYA.default), {
        messagesConfig: (0, $5UcXH.default),
        skip: typeof skipI18nProvider !== 'undefined' ? skipI18nProvider : !locale,
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7f3ds.default), {
        analytics: analytics,
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4OGWt.TeamsWrapper), {
        sentryClient: sentryClient,
        appConfig: appConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKSiD.default), {
        env: env,
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        docTitle: docTitle,
        appName: appName,
        addFlag: addFlag,
        push: push,
        locale: locale,
        replace: replace,
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        isJiraAvailable: isJiraAvailable,
        teamCentralHandlers: teamCentralHandlers,
        productFeatureFlags: productFeatureFlags,
        invitePeopleHandlers: invitePeopleHandlers
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cHnQD.default), {
        analytics: analytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1xrmr.ExperienceTrackerContext).Provider, {
        value: analytics.expTracker()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($laX0d.RelativeWrapperOfHeaderImage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
        client: apolloClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $04Epr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $etjd2.default), {
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6eCcT.default), {
        contextEntryPoint: contextEntryPoint,
        history: history,
        onTransition: handleTransition
    })))))))))));
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});

parcelRegister("cHnQD", function(module, exports) {

$parcel$export(module.exports, "default", () => $93ebffe162b366bb$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $fS6sM = parcelRequire("fS6sM");
class $93ebffe162b366bb$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            analytics: this.props.analytics
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fS6sM.AnalyticsContext).Provider, {
            value: this.state
        }, this.props.children);
    }
}

});
parcelRegister("fS6sM", function(module, exports) {

$parcel$export(module.exports, "defaultAnalyticsClient", () => $b8e0e99e9971c8f3$export$7fa70eb12a96b7d1);
$parcel$export(module.exports, "AnalyticsContext", () => $b8e0e99e9971c8f3$export$83cd6c3eba7d8d9e);

var $eUqFw = parcelRequire("eUqFw");

var $fXCRm = parcelRequire("fXCRm");
const $b8e0e99e9971c8f3$var$defaultAnalyticsMethod = ()=>{
    // tslint:disable-next-line no-console
    // eslint-disable-next-line no-console
    console.warn('No analytics client has been provided.');
    (0, $fXCRm.logInfoMessage)('Analytics Context accessed before AnalyticsClient was loaded');
};
const $b8e0e99e9971c8f3$export$7fa70eb12a96b7d1 = {
    getAnalyticsWebClient: ()=>{
        $b8e0e99e9971c8f3$var$defaultAnalyticsMethod();
        return;
    },
    pushTrackEvent: $b8e0e99e9971c8f3$var$defaultAnalyticsMethod,
    pushScreenEvent: $b8e0e99e9971c8f3$var$defaultAnalyticsMethod,
    pushUIEvent: $b8e0e99e9971c8f3$var$defaultAnalyticsMethod,
    pushOperationalEvent: $b8e0e99e9971c8f3$var$defaultAnalyticsMethod,
    startUIViewedEvent: $b8e0e99e9971c8f3$var$defaultAnalyticsMethod,
    expTracker: ()=>{
        throw new Error('No analytics client has been provided');
    }
};
const $b8e0e99e9971c8f3$var$AnalyticsContextState = {
    analytics: $b8e0e99e9971c8f3$export$7fa70eb12a96b7d1
};
const $b8e0e99e9971c8f3$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($b8e0e99e9971c8f3$var$AnalyticsContextState);

});


parcelRegister("04Epr", function(module, exports) {

$parcel$export(module.exports, "default", () => $00dfb8506e2dc2af$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6sTKc = parcelRequire("6sTKc");

var $iDswX = parcelRequire("iDswX");
const $00dfb8506e2dc2af$var$initialStates = {
    DialogComponent: null,
    dialogProps: null,
    isOpen: false
};
function $00dfb8506e2dc2af$var$dialogReducer(state, action) {
    var _action$payload, _action$payload2;
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.DialogComponent) || null,
                dialogProps: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.dialogProps) || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error();
    }
}
function $00dfb8506e2dc2af$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [stateDialogProvider, dispatch] = (0, $eUqFw.useReducer)($00dfb8506e2dc2af$var$dialogReducer, $00dfb8506e2dc2af$var$initialStates);
    const valueProvider = (0, $eUqFw.useMemo)(()=>({
            openDialog: (DialogComponent, dialogProps = null)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent,
                        dialogProps: dialogProps
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return(/*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iDswX.DialogsContext).Provider, {
        value: valueProvider
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6sTKc.default), stateDialogProvider)));
}

});
parcelRegister("6sTKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b50993e5e70dc8f$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $iDswX = parcelRequire("iDswX");
function $4b50993e5e70dc8f$export$2e2bcd8739ae039(props) {
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
    const { closeDialog: closeDialog } = (0, $eUqFw.useContext)((0, $iDswX.DialogsContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
        if (dialogProps !== null && dialogProps !== void 0 && dialogProps.onClose) dialogProps.onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DialogComponent, (0, $kU09D.default)({}, dialogProps, {
        onClose: handleCloseDialog
    })));
}

});
parcelRegister("iDswX", function(module, exports) {

$parcel$export(module.exports, "DialogsContext", () => $d912001699e51824$export$412f7f691e39b0da);

var $eUqFw = parcelRequire("eUqFw");
const $d912001699e51824$var$dialogsContextState = {
    openDialog: ()=>null,
    closeDialog: ()=>null
};
const $d912001699e51824$export$412f7f691e39b0da = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($d912001699e51824$var$dialogsContextState);

});



parcelRegister("dkrYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b42d8197390b7da$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $fXCRm = parcelRequire("fXCRm");

var $9VBtL = parcelRequire("9VBtL");
/**
 * Sets up the react-intl IntlProvider for its children, blocking until translations are loaded
 */ const $9b42d8197390b7da$var$NO_MESSAGES = {};
class $9b42d8197390b7da$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            locale: (0, $9VBtL.DEFAULT_LOCALE),
            messages: undefined
        });
    }
    componentDidMount() {
        if (this.props.skip !== true) this.loadData();
    }
    async loadData() {
        const { messagesConfig: messagesConfig, locale: predefinedLocale } = this.props;
        const locale = await (0, $9VBtL.getEffectiveLocale)(predefinedLocale);
        if (locale === (0, $9VBtL.DEFAULT_LOCALE)) {
            // Everything is already loaded for English
            this.setState({
                locale: (0, $9VBtL.DEFAULT_LOCALE),
                messages: {}
            });
            return;
        }
        try {
            const messages = await (0, $9VBtL.loadIntlData)(messagesConfig, locale);
            this.setState({
                locale: locale,
                messages: messages || $9b42d8197390b7da$var$NO_MESSAGES
            });
        } catch (error) {
            // @ts-ignore
            (0, $fXCRm.logException)(error, 'Error loading translations.', {
                locale: locale
            });
            // show english on error
            this.setState({
                locale: (0, $9VBtL.DEFAULT_LOCALE),
                messages: $9b42d8197390b7da$var$NO_MESSAGES
            });
        }
    }
    render() {
        const { skip: skip } = this.props;
        // TODO: [PTC-4968] Long term 'skip' prop to be removed in favour being skipped by
        //       default and `embeddable-directory` to rely on parent product i18n provider.
        //       The idea is to merge package i18n files into product ones, and ship that
        //       one global product i18n translation rather than packages fetching their own.
        if (skip) return this.props.children;
        const { locale: locale, messages: messages } = this.state;
        // Idea for improvement we should not block rendering UI while fetching messages
        // https://product-fabric.atlassian.net/browse/PTC-2176
        if (!messages) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            key: `intl-provider-5-${locale}`,
            "data-test-language": locale,
            locale: locale,
            defaultLocale: (0, $9VBtL.DEFAULT_LOCALE),
            messages: messages
        }, this.props.children);
    }
}

});
parcelRegister("9VBtL", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $73a6827c8475fa67$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getEffectiveLocale", () => $73a6827c8475fa67$export$5211f28df9ef284a);
$parcel$export(module.exports, "loadIntlData", () => $73a6827c8475fa67$export$d225990554fb28f7);

var $cQWzp = parcelRequire("cQWzp");

var $1Zvbf = parcelRequire("1Zvbf");

var $fs4uE = parcelRequire("fs4uE");
const $73a6827c8475fa67$export$1af4c7e47ad72f44 = 'en';
const $73a6827c8475fa67$export$b6a046f0eef1bb2 = [
    'cs',
    'cs-CZ',
    'da',
    'da-DK',
    'de',
    'de-DE',
    'en-GB',
    'es',
    'es-ES',
    'et',
    'et-EE',
    'fi',
    'fi-FI',
    'fr',
    'fr-FR',
    'hu',
    'hu-HU',
    'is',
    'is-IS',
    'it',
    'it-IT',
    'ja',
    'ja-JP',
    'ko',
    'ko-KR',
    'nb',
    'nb-NO',
    'nl',
    'nl-NL',
    'pl',
    'pl-PL',
    'pt',
    'pt-BR',
    'pt-PT',
    'ro',
    'ro-RO',
    'ru',
    'ru-RU',
    'sk',
    'sk-SK',
    'sv',
    'sv-SE',
    'tr',
    'tr-TR',
    'th',
    'th-TH',
    'uk',
    'uk-UA',
    'vi',
    'vi-VN',
    'zh',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
// In URL, a tester can pass lang code or locale into URL, e.g `?locale=fr` or `?locale=cs-CZ`
const $73a6827c8475fa67$var$getLocaleFromUrl = ()=>{
    const { locale: locale } = (0, (/*@__PURE__*/$parcel$interopDefault($cQWzp))).parse((0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).location.search);
    const localeFromUrl = Array.isArray(locale) ? locale[0] : locale;
    return localeFromUrl;
};
function $73a6827c8475fa67$var$getSupportedLocale(locale) {
    if (typeof locale !== 'string') return null;
    locale = locale.replace('_', '-');
    if ($73a6827c8475fa67$export$b6a046f0eef1bb2.includes(locale)) return locale;
    // If we don't have the exact locale available, attempt to match just the language
    const languageCode = locale.substring(0, 2);
    if ($73a6827c8475fa67$export$b6a046f0eef1bb2.includes(languageCode)) return languageCode;
}
const $73a6827c8475fa67$export$5211f28df9ef284a = async (predefinedLocale)=>{
    // locale that we can manually pass to intl provider
    const receivedLocale = $73a6827c8475fa67$var$getSupportedLocale(predefinedLocale);
    if (receivedLocale) return receivedLocale;
    // locale that we can pass to intl provider via `locale` GET param
    const localeInUrl = $73a6827c8475fa67$var$getSupportedLocale($73a6827c8475fa67$var$getLocaleFromUrl());
    if (localeInUrl) return localeInUrl;
    let userLocale;
    try {
        userLocale = (await (0, $fs4uE.userInfoProvider).get()).locale;
    } catch (e) {
        userLocale = $73a6827c8475fa67$export$1af4c7e47ad72f44;
    }
    return $73a6827c8475fa67$var$getSupportedLocale(userLocale) || $73a6827c8475fa67$export$1af4c7e47ad72f44;
};
const $73a6827c8475fa67$export$d225990554fb28f7 = (localesConfig, locale)=>{
    const pickedConfig = localesConfig.find((config)=>config.locales.includes(locale));
    const loader = pickedConfig === null || pickedConfig === void 0 ? void 0 : pickedConfig.loader;
    if (!loader) return Promise.resolve(null);
    return new Promise((resolve, reject)=>{
        // Fails if we haven't loaded/resolved after 30 seconds
        const rejectTimer = setTimeout(reject, 30000);
        loader().then((res)=>{
            clearTimeout(rejectTimer);
            // depending on a builder and config used in a project the result of dynamic imports could be behind `default`
            // this way we'll cover both cases
            resolve(res && res.default || res);
        });
    });
};

});
parcelRegister("fs4uE", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $b3fcf4d8271037b2$export$30a852ca4cb27370);

var $avLBj = parcelRequire("avLBj");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $b3fcf4d8271037b2$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $b3fcf4d8271037b2$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $b3fcf4d8271037b2$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $avLBj.getConfig)().stargateRoot}/me`).then((me)=>{
            var _me$extended_profile;
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: (_me$extended_profile = me.extended_profile) === null || _me$extended_profile === void 0 ? void 0 : _me$extended_profile.job_title
            };
        });
        return this.promise;
    }
}
const $b3fcf4d8271037b2$export$30a852ca4cb27370 = new $b3fcf4d8271037b2$export$dc10e400a1189789();

});



parcelRegister("4HA2w", function(module, exports) {

$parcel$export(module.exports, "statusCodeHandlersProvider", () => $36c72253bc0b14c0$export$8c005e458e12d501);
$parcel$export(module.exports, "handleResponse", () => $36c72253bc0b14c0$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $36c72253bc0b14c0$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $36c72253bc0b14c0$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $36c72253bc0b14c0$export$8c005e458e12d501.handlers = handlers;
    }
};
function $36c72253bc0b14c0$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $36c72253bc0b14c0$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});

parcelRegister("c1nG2", function(module, exports) {

$parcel$export(module.exports, "useOrg", () => $8c07f1d0ca60bcc6$export$7f785727a26e156);

var $ggKAj = parcelRequire("ggKAj");

var $gdXph = parcelRequire("gdXph");
const $8c07f1d0ca60bcc6$export$7f785727a26e156 = (0, $ggKAj.createHook)((0, $gdXph.Store));

});
parcelRegister("gdXph", function(module, exports) {

$parcel$export(module.exports, "Store", () => $bcfbf13154ce6037$export$390f32400eaf98c9);

var $a61MH = parcelRequire("a61MH");
const $bcfbf13154ce6037$var$actions = {
    setOrgId: (orgId)=>({ setState: setState })=>{
            setState({
                orgId: orgId
            });
        }
};
const $bcfbf13154ce6037$var$initialState = {
    orgId: undefined
};
const $bcfbf13154ce6037$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    initialState: $bcfbf13154ce6037$var$initialState,
    actions: $bcfbf13154ce6037$var$actions,
    name: 'Org'
});

});


parcelRegister("jUprp", function(module, exports) {

$parcel$export(module.exports, "useSite", () => $e7e6fb575013fa47$export$7870fa8e7cdd59f8);

var $ggKAj = parcelRequire("ggKAj");

var $6pMv1 = parcelRequire("6pMv1");
const $e7e6fb575013fa47$export$7870fa8e7cdd59f8 = (0, $ggKAj.createHook)((0, $6pMv1.Store));
const $e7e6fb575013fa47$export$9da0f7c65f28ed16 = ()=>$e7e6fb575013fa47$export$7870fa8e7cdd59f8()[0].cloudId;

});
parcelRegister("6pMv1", function(module, exports) {

$parcel$export(module.exports, "Store", () => $4abab2dc9e407d17$export$390f32400eaf98c9);

var $a61MH = parcelRequire("a61MH");
const $4abab2dc9e407d17$var$actions = {
    // This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
    setCloudId: (cloudId)=>({ setState: setState })=>{
            setState({
                cloudId: cloudId
            });
        }
};
const $4abab2dc9e407d17$var$initialState = {
    cloudId: ''
};
const $4abab2dc9e407d17$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    initialState: $4abab2dc9e407d17$var$initialState,
    actions: $4abab2dc9e407d17$var$actions,
    name: 'Site'
});

});


parcelRegister("clEku", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralStore", () => $8fd6bacb542b19d4$export$39314e672c06693f);
$parcel$export(module.exports, "useTeamCentralStoreApi", () => $8fd6bacb542b19d4$export$7c58a39ba496932b);
$parcel$export(module.exports, "useIsTeamCentral", () => $8fd6bacb542b19d4$export$9da989c55553d02d);
$parcel$export(module.exports, "useTeamCentralPresent", () => $8fd6bacb542b19d4$export$20f07b26e9a56b9);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $d3G5s = parcelRequire("d3G5s");
const $8fd6bacb542b19d4$var$initialState = {
    isTeamCentral: false,
    hasWorkspace: false,
    orgHasWorkspace: false,
    teamCentralHandlers: {}
};
const $8fd6bacb542b19d4$var$actions = {
    initTeamCentral: (appName, cloudId, teamCentralHandlers = {})=>({ setState: setState })=>{
            const isTeamCentral = appName === 'teamcentral-directory';
            if (isTeamCentral) // Assume site already has a TC workspace if directory is running in TC mode
            setState({
                isTeamCentral: isTeamCentral,
                hasWorkspace: true,
                orgHasWorkspace: true,
                teamCentralHandlers: teamCentralHandlers
            });
            else {
                // Otherwise, fetch for workspace information
                const requests = [
                    (0, $d3G5s.default).hasWorkspaceForCloudId(cloudId),
                    (0, $d3G5s.default).doesOrgContainAnyWorkspace(cloudId)
                ];
                Promise.all(requests).then(([hasWorkspace, orgHasWorkspace])=>{
                    setState({
                        isTeamCentral: false,
                        hasWorkspace: hasWorkspace,
                        orgHasWorkspace: orgHasWorkspace,
                        teamCentralHandlers: teamCentralHandlers
                    });
                });
            }
        }
};
/**
 * Manage states of searching People and Teams in search home page.
 */ const $8fd6bacb542b19d4$var$Store = (0, $a61MH.createStore)({
    initialState: $8fd6bacb542b19d4$var$initialState,
    actions: $8fd6bacb542b19d4$var$actions,
    name: 'SearchHomePage'
});
const $8fd6bacb542b19d4$export$39314e672c06693f = (0, $ggKAj.createHook)($8fd6bacb542b19d4$var$Store);
const $8fd6bacb542b19d4$export$7c58a39ba496932b = (0, $ggKAj.createHook)($8fd6bacb542b19d4$var$Store, {
    selector: null
});
const $8fd6bacb542b19d4$export$9da989c55553d02d = (0, $ggKAj.createHook)($8fd6bacb542b19d4$var$Store, {
    selector: (s)=>s.isTeamCentral
});
const $8fd6bacb542b19d4$export$20f07b26e9a56b9 = (0, $ggKAj.createHook)($8fd6bacb542b19d4$var$Store, {
    selector: (s)=>s.isTeamCentral || s.hasWorkspace || s.orgHasWorkspace
});

});
parcelRegister("d3G5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $981c33c9002b02b5$export$2e2bcd8739ae039);

var $avLBj = parcelRequire("avLBj");

var $gUuNN = parcelRequire("gUuNN");
class $981c33c9002b02b5$var$TeamCentralRestClient extends (0, $gUuNN.default) {
    constructor(){
        super({
            serviceUrl: `${(0, $avLBj.getConfig)().stargateRoot}/watermelon`
        });
    }
    async hasWorkspaceForCloudId(cloudId) {
        try {
            await this.getResource(`/workspace/exists?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async doesOrgContainAnyWorkspace(cloudId) {
        try {
            await this.getResource(`/organization/containsAnyWorkspace?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
}
var /**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$981c33c9002b02b5$export$2e2bcd8739ae039 = new $981c33c9002b02b5$var$TeamCentralRestClient();

});
parcelRegister("gUuNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4f9c4f5cf1105aa$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $2vzCR = parcelRequire("2vzCR");

var $6l6Xk = parcelRequire("6l6Xk");

var $i82XG = parcelRequire("i82XG");

var $fSI17 = parcelRequire("fSI17");

var $2oEyM = parcelRequire("2oEyM");

var $7YdTp = parcelRequire("7YdTp");

var $4HA2w = parcelRequire("4HA2w");
const $c4f9c4f5cf1105aa$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
const $c4f9c4f5cf1105aa$var$fetchWithExponentialBackoff = (0, $7YdTp.withDefaultExponentialBackoff)(fetch);
// tslint:disable-next-line no-any
function $c4f9c4f5cf1105aa$var$parseResponse(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}
async function $c4f9c4f5cf1105aa$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || (0, $2oEyM.DirectoryErrorCode).MISSING_ERROR_MESSAGE);
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}
let $c4f9c4f5cf1105aa$var$incrementRedirectCount;
let $c4f9c4f5cf1105aa$var$clearRedirectCount;
$c4f9c4f5cf1105aa$export$7a0fc52d8c359feb();
function $c4f9c4f5cf1105aa$export$7a0fc52d8c359feb() {
    $c4f9c4f5cf1105aa$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $fSI17.setCookie)((0, $fSI17.REDIRECT_COUNT), (0, $fSI17.getCookieAsInteger)((0, $fSI17.REDIRECT_COUNT)) + 1));
    $c4f9c4f5cf1105aa$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $fSI17.clearCookie)((0, $fSI17.REDIRECT_COUNT)));
}
class $c4f9c4f5cf1105aa$var$RestClient {
    constructor({ serviceUrl: serviceUrl = '' } = {}){
        /**
     * This function is necessary for if `statusCodeHandler` prescribes a login
     * redirect upon a 401 response.
     * While the default redirect behaviour may be overriden, this function has
     * been kept separate to ensure it cannot be overriden, lest a host
     * application supply embeddable-directory with a custom handler that suffers
     * the infinite redirect bug.
     */ (0, $5zQU9.default)(this, "preventInfiniteRedirectLoop", (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $c4f9c4f5cf1105aa$var$incrementRedirectCount();
            } else $c4f9c4f5cf1105aa$var$clearRedirectCount();
        });
        this.serviceUrl = serviceUrl;
    }
    async getResource(path) {
        return this.makeRequest(path);
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
       * PATCH must be uppercase as per fetch spec only
       * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
       * are normalised to uppercase.
       *
       * https://github.com/github/fetch/issues/37
       * https://fetch.spec.whatwg.org/#methods
       */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {}) {
        const url = this.serviceUrl + path;
        const options = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, $c4f9c4f5cf1105aa$var$defaultFetchOptions, additionalFetchOptions);
        const response = await $c4f9c4f5cf1105aa$var$fetchWithExponentialBackoff(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $4HA2w.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $i82XG.SentryIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await $c4f9c4f5cf1105aa$export$91c32f1b22d29b2d(response);
                throw new (0, $i82XG.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId !== null && traceId !== void 0 ? traceId : undefined
                });
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : $c4f9c4f5cf1105aa$var$parseResponse(response);
    }
}
var $c4f9c4f5cf1105aa$export$2e2bcd8739ae039 = $c4f9c4f5cf1105aa$var$RestClient;

});
parcelRegister("i82XG", function(module, exports) {

$parcel$export(module.exports, "SentryIgnoreError", () => $d32b4576ee3a6e03$export$20de9a0e470e95aa);
$parcel$export(module.exports, "HttpError", () => $d32b4576ee3a6e03$export$65bd6083489bd8bb);

var $5zQU9 = parcelRequire("5zQU9");
var $d32b4576ee3a6e03$var$_class;
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $d32b4576ee3a6e03$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $d32b4576ee3a6e03$export$c73ca302efeda3b4 extends $d32b4576ee3a6e03$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $d32b4576ee3a6e03$export$c73ca302efeda3b4.prototype);
    }
}
class $d32b4576ee3a6e03$export$20de9a0e470e95aa extends $d32b4576ee3a6e03$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $d32b4576ee3a6e03$export$20de9a0e470e95aa.prototype);
    }
}
class $d32b4576ee3a6e03$export$65bd6083489bd8bb extends $d32b4576ee3a6e03$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId }){
        super(message);
        Object.setPrototypeOf(this, $d32b4576ee3a6e03$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
    }
}
class $d32b4576ee3a6e03$export$92d6ed0888e7cb7f extends $d32b4576ee3a6e03$var$CommonError {
    // tslint:disable-line no-any
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $d32b4576ee3a6e03$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
}
$d32b4576ee3a6e03$var$_class = $d32b4576ee3a6e03$export$92d6ed0888e7cb7f;
(0, $5zQU9.default)($d32b4576ee3a6e03$export$92d6ed0888e7cb7f, "from", (rawErrors)=>{
    const firstError = rawErrors[0];
    const errorData = {
        category: firstError.category,
        message: firstError.message
    };
    if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
        obj[item.field] = item.message;
        return obj;
    }, {});
    return new $d32b4576ee3a6e03$var$_class(errorData);
});

});

parcelRegister("fSI17", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $b8fe0b0a78f4fead$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $b8fe0b0a78f4fead$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $b8fe0b0a78f4fead$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $b8fe0b0a78f4fead$export$ad3506281d5a5e5d);
const $b8fe0b0a78f4fead$export$f6101897f0230549 = 'redirectCount';
const $b8fe0b0a78f4fead$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $b8fe0b0a78f4fead$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $b8fe0b0a78f4fead$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $b8fe0b0a78f4fead$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});




parcelRegister("8JMI4", function(module, exports) {

$parcel$export(module.exports, "useJiraCheckService", () => $65c84f7a86eecbda$export$b998d6ed276aaffa);

var $eUqFw = parcelRequire("eUqFw");

var $9w676 = parcelRequire("9w676");

var $7JbxG = parcelRequire("7JbxG");
const $65c84f7a86eecbda$export$3847702755d66eb8 = (cloudId, options)=>{
    var _result$data;
    const [request, controller] = (0, $eUqFw.useMemo)(()=>(0, $7JbxG.defaultRequestAbort)(cloudId), [
        cloudId
    ]);
    const [getJiraCheck, result] = (0, $9w676.useLazyService)(request, controller, {
        initialState: {
            ...options === null || options === void 0 ? void 0 : options.initialState
        }
    });
    return [
        getJiraCheck,
        {
            ...result,
            isJiraAvailable: Boolean((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.permitted)
        }
    ];
};
const $65c84f7a86eecbda$export$b998d6ed276aaffa = (...[cloudId, options])=>{
    const [getJiraCheck, result] = $65c84f7a86eecbda$export$3847702755d66eb8(cloudId, options);
    (0, $eUqFw.useEffect)(()=>{
        if (cloudId) getJiraCheck();
    }, [
        cloudId,
        getJiraCheck
    ]);
    return result;
};

});
parcelRegister("7JbxG", function(module, exports) {

$parcel$export(module.exports, "defaultRequestAbort", () => $5a05b073e561a6c5$export$46f584bffbc74fe);

var $boS14 = parcelRequire("boS14");
const $5a05b073e561a6c5$export$5cf469f83bcf3f9e = '/gateway/api/permissions/permitted';
const $5a05b073e561a6c5$export$fcd6a587480f569c = (cloudId)=>({
        permissionId: 'write',
        resourceId: `ari:cloud:jira-software::site/${cloudId}`
    });
const $5a05b073e561a6c5$export$46f584bffbc74fe = (cloudId)=>cloudId ? (0, $boS14.requestWithAbort)($5a05b073e561a6c5$export$5cf469f83bcf3f9e, {
        body: JSON.stringify($5a05b073e561a6c5$export$fcd6a587480f569c(cloudId))
    }) : [
        ()=>Promise.resolve(new Response()),
        new AbortController()
    ];

});


parcelRegister("4OGWt", function(module, exports) {

$parcel$export(module.exports, "TeamsWrapper", () => $381d24539dc684ee$export$7d5cea3023a4360c);

var $eUqFw = parcelRequire("eUqFw");

var $47ZoO = parcelRequire("47ZoO");

var $5q0SI = parcelRequire("5q0SI");

var $6LbQr = parcelRequire("6LbQr");

var $efNHE = parcelRequire("efNHE");

var $kKbGE = parcelRequire("kKbGE");

var $91mld = parcelRequire("91mld");
const $381d24539dc684ee$var$IS_LOCAL = false;
function $381d24539dc684ee$export$7d5cea3023a4360c({ children: children, appConfig: appConfig }) {
    (0, $6LbQr.useTeamsSentryClientSetup)(!$381d24539dc684ee$var$IS_LOCAL, {
        env: appConfig.env,
        appName: appConfig.appName ? `${appConfig.appName}` : undefined
    });
    (0, $efNHE.useSetAppConfig)(appConfig);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKbGE.AppConfigProvider), appConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91mld.ProfileCardClientConfigProvider), appConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $47ZoO.WrappedPeopleTeamsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5q0SI.DialogProvider), null, children))));
}

});
parcelRegister("47ZoO", function(module, exports) {

$parcel$export(module.exports, "WrappedPeopleTeamsAnalyticsProvider", () => $30177173247a5f72$export$b73a44d03ba9da78);
$parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", () => $30177173247a5f72$export$48acf7e27d4331f);
$parcel$export(module.exports, "useTeamsExperienceTracker", () => $30177173247a5f72$export$5792e6ebc464482e);

var $eUqFw = parcelRequire("eUqFw");

var $dcbVh = parcelRequire("dcbVh");

var $3YNVM = parcelRequire("3YNVM");

var $dS8ag = parcelRequire("dS8ag");

var $5Bima = parcelRequire("5Bima");
const $30177173247a5f72$var$defaultAnalyticsContextData = {
    packageName: "@atlassian/people-teams-ui",
    packageVersion: "2.13.3"
};
function $30177173247a5f72$export$b73a44d03ba9da78({ analyticsContextData: analyticsContextData, children: children }) {
    const data = (0, $eUqFw.useMemo)(()=>{
        if (typeof analyticsContextData === 'object') return {
            ...$30177173247a5f72$var$defaultAnalyticsContextData,
            ...analyticsContextData
        };
        return $30177173247a5f72$var$defaultAnalyticsContextData;
    }, [
        analyticsContextData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcbVh.PeopleTeamsAnalyticsContext), {
        data: data
    }, children);
}
const $30177173247a5f72$export$48acf7e27d4331f = ()=>(0, $dS8ag.useAnalyticsEvents)();
const $30177173247a5f72$export$b72f2eb2a11f7b8 = ()=>(0, $5Bima.useAnalyticsEventsWithTags)();
const $30177173247a5f72$export$5792e6ebc464482e = ()=>{
    const { fireEvent: fireEvent } = $30177173247a5f72$export$48acf7e27d4331f();
    const fireExperienceEvent = (0, $eUqFw.useCallback)((action, subject, attributes)=>{
        // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
        fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
            ...attributes,
            source: 'clientMetrics'
        });
    }, [
        fireEvent
    ]);
    const experienceTracker = (0, $eUqFw.useMemo)(()=>(0, $3YNVM.createTeamsExperienceTracker)(fireExperienceEvent), [
        fireExperienceEvent
    ]);
    return experienceTracker;
};

});
parcelRegister("3YNVM", function(module, exports) {

$parcel$export(module.exports, "createTeamsExperienceTracker", () => $2e5db4eb953c1699$export$c0c885a04612b38d);

var $74BVL = parcelRequire("74BVL");

var $8YlMd = parcelRequire("8YlMd");

var $G3wd4 = parcelRequire("G3wd4");
function $2e5db4eb953c1699$export$c0c885a04612b38d(fireExperienceEvent, options) {
    const tracker = new (0, $8YlMd.TeamsExperienceTracker)({
        isNetworkOfflineError: (0, $G3wd4.isNetworkError)
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = (0, $G3wd4.computePerformanceAttributes)(event);
            const errorAttributes = (0, $G3wd4.computeErrorAttributes)(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: !!(options !== null && options !== void 0 && options.isStandalone),
                hasBrowseUsersPermission: !!(options !== null && options !== void 0 && options.hasBrowseUsersPermission)
            });
            fireExperienceEvent(event.action, event.name, finalErrorDetails);
            if (event.action === 'taskFail' && options !== null && options !== void 0 && options.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
        }
    });
    (0, $74BVL.bindAll)(window, [
        {
            type: 'unload',
            listener: ()=>tracker.abort({
                    reason: 'Abort due to Window unloading',
                    attributes: {
                        cause: 'WINDOW_UNLOAD'
                    }
                })
        },
        {
            type: 'pagehide',
            listener: ()=>{
                tracker.abort({
                    reason: 'Window unloading',
                    attributes: {
                        cause: 'PAGE_HIDE'
                    }
                });
            }
        }
    ]);
    return tracker;
}

});
parcelRegister("8YlMd", function(module, exports) {

$parcel$export(module.exports, "TeamsExperienceTracker", () => $6884d1b996ceec80$export$9e9a48cf2c297bd1);

var $5zQU9 = parcelRequire("5zQU9");

var $hUYqC = parcelRequire("hUYqC");

var $Jnra9 = parcelRequire("Jnra9");
class $6884d1b996ceec80$export$9e9a48cf2c297bd1 extends (0, $hUYqC.ExperienceTracker) {
    _errorNameInIgnoredList(error) {
        const name = error && error.constructor.name;
        return this._ignoredErrors.includes(name) ? name : undefined;
    }
    constructor(options){
        super(options);
        // error names here will also be sent in the attribute `cause`
        (0, $5zQU9.default)(this, "_ignoredErrors", [
            'SentryIgnoreError'
        ]);
    }
    stopOnError({ name: name, error: error }) {
        if ((0, $Jnra9.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $Jnra9.isErrorStatusCode)((0, $Jnra9.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        const ignoredErrorName = this._errorNameInIgnoredList(error);
        if (ignoredErrorName) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: ignoredErrorName
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error
        });
    }
}

});
parcelRegister("Jnra9", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $088662348cc13fc6$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $088662348cc13fc6$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $088662348cc13fc6$export$9677d7c364ada66c);
let $088662348cc13fc6$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $088662348cc13fc6$export$cde1786a482f9a1c(error) {
    return $088662348cc13fc6$export$9677d7c364ada66c($088662348cc13fc6$export$f66f92b8741acd5b.UNAUTHORIZED, error) || $088662348cc13fc6$export$9677d7c364ada66c($088662348cc13fc6$export$f66f92b8741acd5b.FORBIDDEN, error);
}
function $088662348cc13fc6$export$9677d7c364ada66c(statusCode, error) {
    var _error$message;
    if (!error) return false;
    if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!(error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.match(reg));
}

});


parcelRegister("G3wd4", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $07e6a70fe2acdf81$export$476aa014e2fd89d5);
$parcel$export(module.exports, "computeErrorAttributes", () => $07e6a70fe2acdf81$export$5e7501d1cb9a5aa0);
$parcel$export(module.exports, "computePerformanceAttributes", () => $07e6a70fe2acdf81$export$b978343735080139);

var $leHv2 = parcelRequire("leHv2");
function $07e6a70fe2acdf81$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
function $07e6a70fe2acdf81$export$5e7501d1cb9a5aa0(event) {
    const attributes = {};
    if ($07e6a70fe2acdf81$var$isFailEvent(event)) attributes.failError = event.error;
    if ($07e6a70fe2acdf81$var$isAbortEvent(event)) attributes.abortReason = event.reason;
    return attributes;
}
function $07e6a70fe2acdf81$export$b978343735080139(event) {
    if ($07e6a70fe2acdf81$var$isStopEvent(event)) {
        const duration = event.duration;
        const latencySlo = event.attributes && $07e6a70fe2acdf81$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    return {};
}
function $07e6a70fe2acdf81$var$isStopEvent(e) {
    return (0, $leHv2.isStop)(e);
}
function $07e6a70fe2acdf81$var$isFailEvent(e) {
    return e.action === 'taskFail';
}
function $07e6a70fe2acdf81$var$isAbortEvent(e) {
    return e.action === 'taskAbort';
}
function $07e6a70fe2acdf81$var$hasLatencySLO(attributes) {
    return Object(attributes).hasOwnProperty('latencySlo');
}

});
parcelRegister("leHv2", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $eab71776b63487cc$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $eab71776b63487cc$export$57069f5b2ecc9128);
const $eab71776b63487cc$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $eab71776b63487cc$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});



parcelRegister("dS8ag", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $a196a6cce55fcef3$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f7505922978b2adc09e6d40be074da6f>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $eVHRV = parcelRequire("eVHRV");

var $btesY = parcelRequire("btesY");
const $a196a6cce55fcef3$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEvent = (0, $eUqFw.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $btesY.default)(...params));
        event.fire((0, $eVHRV.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("eVHRV", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $ade86affc54e6006$export$3f072f06b90c3985);

var $88sYM = parcelRequire("88sYM");
const $ade86affc54e6006$export$3f072f06b90c3985 = (0, $88sYM.FabricChannel).peopleTeams;

});

parcelRegister("btesY", function(module, exports) {

$parcel$export(module.exports, "default", () => $859d9fd41e66ac27$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d40b99453dc3bdb802ab78b4560ab56>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ const $859d9fd41e66ac27$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $859d9fd41e66ac27$export$2e2bcd8739ae039 = $859d9fd41e66ac27$var$createEventPayload;

});


parcelRegister("5Bima", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEventsWithTags", () => $413ea5b156ee421f$export$e8e0cef07f76dd91);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $eVHRV = parcelRequire("eVHRV");

var $btesY = parcelRequire("btesY");
const $413ea5b156ee421f$export$e8e0cef07f76dd91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEventWithTags = (0, $eUqFw.useCallback)((tags, ...params)=>{
        const event = createAnalyticsEvent((0, $btesY.default)(...params));
        if (event.payload) event.payload.tags = tags;
        event.fire((0, $eVHRV.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEventWithTags: fireEventWithTags
    };
};

});


parcelRegister("5q0SI", function(module, exports) {

$parcel$export(module.exports, "DialogProvider", () => $3f20107e564c6e37$export$7ab5cfe96fae86d3);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $bWevR = parcelRequire("bWevR");
const $3f20107e564c6e37$var$dialogProviderReducer = (state, action)=>{
    var _action$payload;
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.DialogComponent) || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error(`Unhandled type for dialogReducer: ${action.type}`);
    }
};
const $3f20107e564c6e37$export$b52337b35cd3c980 = (props)=>{
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose } = props;
    const { closeDialog: closeDialog } = (0, $eUqFw.useContext)((0, $bWevR.DialogContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(DialogComponent, {
        onClose: handleCloseDialog
    }));
};
const $3f20107e564c6e37$export$7ab5cfe96fae86d3 = ({ children: children })=>{
    const [dialogProviderState, dispatch] = (0, $eUqFw.useReducer)($3f20107e564c6e37$var$dialogProviderReducer, {
        DialogComponent: null,
        isOpen: false
    });
    const value = (0, $eUqFw.useMemo)(()=>({
            openDialog: (DialogComponent)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bWevR.DialogContext).Provider, {
        value: value
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f20107e564c6e37$export$b52337b35cd3c980, dialogProviderState));
};

});
parcelRegister("bWevR", function(module, exports) {

$parcel$export(module.exports, "DialogContext", () => $8b105e77bb1136e9$export$8b93a07348a7730c);

var $eUqFw = parcelRequire("eUqFw");
const $8b105e77bb1136e9$export$8b93a07348a7730c = /*#__PURE__*/ (0, $eUqFw.createContext)({
    openDialog: ()=>null,
    closeDialog: ()=>null
});

});


parcelRegister("efNHE", function(module, exports) {

$parcel$export(module.exports, "useSetAppConfig", () => $a609055f2a4f4b95$export$338e93cfada2e9d7);

var $46Zuj = parcelRequire("46Zuj");

var $lixMu = parcelRequire("lixMu");

var $owv9B = parcelRequire("owv9B");
const $a609055f2a4f4b95$export$338e93cfada2e9d7 = (appConfig)=>{
    (0, $46Zuj.useSetClientConfig)({
        cloudId: appConfig.cloudId,
        stargateRoot: appConfig.stargateRoot,
        env: appConfig.env,
        orgId: appConfig.orgId,
        principalUserId: appConfig.principalUserId
    });
    (0, $owv9B.useSetTeamsProductConfig)({
        appName: appConfig.appName,
        productName: appConfig.productName,
        isJiraAvailable: appConfig.isJiraAvailable,
        subProduct: appConfig.subProduct,
        locale: appConfig.locale,
        productFeatureFlags: appConfig.productFeatureFlags
    });
    (0, $lixMu.useSetTeamsNavigationConfig)({
        contextSpaPaths: appConfig.contextSpaPaths,
        contextEntryPoint: appConfig.contextEntryPoint
    });
};

});
parcelRegister("46Zuj", function(module, exports) {

$parcel$export(module.exports, "useSetClientConfig", () => $2fe76b2d38bbd3eb$export$2f68760d90a1443f);

var $eUqFw = parcelRequire("eUqFw");

var $7B4qz = parcelRequire("7B4qz");

var $jDNv9 = parcelRequire("jDNv9");
const $2fe76b2d38bbd3eb$export$2f68760d90a1443f = (clientConfig)=>{
    const { setClientConfig: setClientConfig } = (0, $jDNv9.useSetTeamsConfigActions)();
    (0, $7B4qz.useTeamsClientSetup)(clientConfig.stargateRoot, clientConfig.cloudId, clientConfig.orgId);
    (0, $eUqFw.useEffect)(()=>{
        setClientConfig(clientConfig);
    }, [
        setClientConfig,
        clientConfig
    ]);
};

});
parcelRegister("7B4qz", function(module, exports) {

$parcel$export(module.exports, "useTeamsClientSetup", () => $587f6c4f74485986$export$50a3d4f5c944b117);

var $eUqFw = parcelRequire("eUqFw");

var $4ECFx = parcelRequire("4ECFx");

var $8gATS = parcelRequire("8gATS");
const $587f6c4f74485986$export$50a3d4f5c944b117 = (stargateRoot, cloudId, orgId)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!stargateRoot) return;
        (0, $4ECFx.teamsClient).setBaseUrl(stargateRoot);
    }, [
        stargateRoot
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $4ECFx.teamsClient).setContext({
            cloudId: cloudId,
            orgId: orgId
        });
        if (!orgId) (0, $8gATS.logErrorMessage)(`No orgId set - useTeamsClientSetup`, {
            cloudId: cloudId
        });
    }, [
        cloudId,
        orgId
    ]);
};

});

parcelRegister("jDNv9", function(module, exports) {

$parcel$export(module.exports, "useAppConfigStoreState", () => $e4c80ecbafd9f2df$export$ace1f350f4f044c0);
$parcel$export(module.exports, "useSetTeamsConfigActions", () => $e4c80ecbafd9f2df$export$b652cf4936246835);
$parcel$export(module.exports, "useNavigationState", () => $e4c80ecbafd9f2df$export$e482f4662aebc4a0);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $e4c80ecbafd9f2df$var$defaultNavigationState = {
    contextSpaPaths: [],
    contextEntryPoint: null
};
const $e4c80ecbafd9f2df$var$defaultClientConfigState = {
    cloudId: null,
    stargateRoot: '',
    env: undefined
};
const $e4c80ecbafd9f2df$var$defaultTeamsProductConfigState = {
    appName: null,
    productName: null,
    isJiraAvailable: false
};
const $e4c80ecbafd9f2df$var$defaultState = {
    ...$e4c80ecbafd9f2df$var$defaultNavigationState,
    ...$e4c80ecbafd9f2df$var$defaultClientConfigState,
    ...$e4c80ecbafd9f2df$var$defaultTeamsProductConfigState,
    docTitle: {}
};
const $e4c80ecbafd9f2df$var$actions = {
    setNavigationConfig: (navigationConfig)=>({ setState: setState })=>{
            setState({
                ...navigationConfig
            });
        },
    setClientConfig: (clientConfig)=>({ setState: setState })=>{
            setState({
                ...clientConfig
            });
        },
    setTeamsProductConfig: (teamsProductConfig)=>({ setState: setState })=>{
            setState({
                ...teamsProductConfig
            });
        },
    // Set all config at once
    setAppConfig: (appConfig)=>({ setState: setState })=>{
            setState({
                ...appConfig
            });
        }
};
const $e4c80ecbafd9f2df$var$AppConfigStore = (0, $a61MH.createStore)({
    initialState: $e4c80ecbafd9f2df$var$defaultState,
    actions: $e4c80ecbafd9f2df$var$actions
});
const $e4c80ecbafd9f2df$export$61884cfbde7fd829 = (0, $ggKAj.createHook)($e4c80ecbafd9f2df$var$AppConfigStore);
const $e4c80ecbafd9f2df$var$useAppConfigActions = (0, $ggKAj.createHook)($e4c80ecbafd9f2df$var$AppConfigStore, {
    selector: null
});
const $e4c80ecbafd9f2df$export$ace1f350f4f044c0 = ()=>$e4c80ecbafd9f2df$export$61884cfbde7fd829()[0];
const $e4c80ecbafd9f2df$export$b652cf4936246835 = ()=>{
    return $e4c80ecbafd9f2df$var$useAppConfigActions()[1];
};
const $e4c80ecbafd9f2df$export$7b278989f04c1040 = ()=>$e4c80ecbafd9f2df$export$ace1f350f4f044c0().appName;
const $e4c80ecbafd9f2df$export$e482f4662aebc4a0 = ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = $e4c80ecbafd9f2df$export$ace1f350f4f044c0();
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint
    };
};

});


parcelRegister("lixMu", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsNavigationConfig", () => $f8157ba266173a5d$export$254030771a907fca);

var $eUqFw = parcelRequire("eUqFw");

var $jDNv9 = parcelRequire("jDNv9");
const $f8157ba266173a5d$export$254030771a907fca = (config)=>{
    const { setNavigationConfig: setNavigationConfig } = (0, $jDNv9.useSetTeamsConfigActions)();
    (0, $eUqFw.useEffect)(()=>{
        setNavigationConfig(config);
    }, [
        setNavigationConfig,
        config
    ]);
};

});

parcelRegister("owv9B", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsProductConfig", () => $049b741f9164f551$export$f8296902b02e4ba1);

var $eUqFw = parcelRequire("eUqFw");

var $jDNv9 = parcelRequire("jDNv9");
const $049b741f9164f551$export$f8296902b02e4ba1 = (teamsProductConfig)=>{
    const { setTeamsProductConfig: setTeamsProductConfig } = (0, $jDNv9.useSetTeamsConfigActions)();
    (0, $eUqFw.useEffect)(()=>{
        setTeamsProductConfig(teamsProductConfig);
    }, [
        setTeamsProductConfig,
        teamsProductConfig
    ]);
};

});


parcelRegister("kKbGE", function(module, exports) {

$parcel$export(module.exports, "AppConfigProvider", () => $f1a12b52e975f58f$export$42f491f31057ae78);
$parcel$export(module.exports, "useNavigationActions", () => $f1a12b52e975f58f$export$d52b0df9de5d0e40);
$parcel$export(module.exports, "useAddFlag", () => $f1a12b52e975f58f$export$6d75236f0e3dc17e);

var $eUqFw = parcelRequire("eUqFw");

var $fvjQo = parcelRequire("fvjQo");

var $hdQIn = parcelRequire("hdQIn");

var $jDNv9 = parcelRequire("jDNv9");
const $f1a12b52e975f58f$var$error = new Error('AppConfig is not setup in RSS');
const $f1a12b52e975f58f$var$defaultValue = {
    push: ()=>{
        throw $f1a12b52e975f58f$var$error;
    },
    replace: ()=>{
        throw $f1a12b52e975f58f$var$error;
    },
    addFlag: ()=>{
        throw $f1a12b52e975f58f$var$error;
    }
};
const $f1a12b52e975f58f$var$AppConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($f1a12b52e975f58f$var$defaultValue);
function $f1a12b52e975f58f$export$42f491f31057ae78({ children: children, push: pushProp, replace: replaceProp, addFlag: addFlagProp }) {
    const { contextEntryPoint: contextEntryPoint } = (0, $jDNv9.useNavigationState)();
    const addFlag = (0, $eUqFw.useCallback)((props)=>{
        const { type: type, ...rest } = props;
        addFlagProp({
            ...rest,
            id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
            type: type,
            appearance: 'normal',
            icon: (0, $fvjQo.getTypeIcon)(type)
        });
    }, [
        addFlagProp
    ]);
    const push = (0, $eUqFw.useCallback)((path)=>{
        const finalPath = (0, $hdQIn.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return pushProp(finalPath);
    }, [
        pushProp,
        contextEntryPoint
    ]);
    const replace = (0, $eUqFw.useCallback)((path)=>{
        const finalPath = (0, $hdQIn.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return replaceProp(finalPath);
    }, [
        contextEntryPoint,
        replaceProp
    ]);
    const configValue = (0, $eUqFw.useMemo)(()=>({
            addFlag: addFlag,
            push: push,
            replace: replace
        }), [
        addFlag,
        push,
        replace
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1a12b52e975f58f$var$AppConfigContext.Provider, {
        value: configValue
    }, children);
}
const $f1a12b52e975f58f$var$useAppConfigProvider = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($f1a12b52e975f58f$var$AppConfigContext);
const $f1a12b52e975f58f$export$d52b0df9de5d0e40 = ()=>{
    const { push: push, replace: replace } = $f1a12b52e975f58f$var$useAppConfigProvider();
    return {
        push: push,
        replace: replace
    };
};
const $f1a12b52e975f58f$export$6d75236f0e3dc17e = ()=>{
    const { addFlag: addFlag } = $f1a12b52e975f58f$var$useAppConfigProvider();
    return addFlag;
};

});
parcelRegister("fvjQo", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $b49924de1e6b38b9$export$672f92b0d52b7cfe);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");
const $b49924de1e6b38b9$var$flagIconByType = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "",
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`
    })
};
const $b49924de1e6b38b9$var$DefaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
    label: "",
    primaryColor: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`
});
const $b49924de1e6b38b9$export$672f92b0d52b7cfe = (type = 'normal')=>$b49924de1e6b38b9$var$flagIconByType[type] || $b49924de1e6b38b9$var$DefaultIcon;

});

parcelRegister("hdQIn", function(module, exports) {

$parcel$export(module.exports, "isAbsoluteLink", () => $c89c8a9d3a89f3bf$export$895d6838d29edd02);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $c89c8a9d3a89f3bf$export$715c8f9057ac0c01);
$parcel$export(module.exports, "getRelativeUrl", () => $c89c8a9d3a89f3bf$export$d614758658023fd);
$parcel$export(module.exports, "EXTERNAL_LINKS", () => $c89c8a9d3a89f3bf$export$4cf71c31cd7fa836);

var $bAnhx = parcelRequire("bAnhx");

var $lfozZ = parcelRequire("lfozZ");
const $c89c8a9d3a89f3bf$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $c89c8a9d3a89f3bf$export$715c8f9057ac0c01 = (path, contextEntryPoint = null)=>{
    if ($c89c8a9d3a89f3bf$export$895d6838d29edd02(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $c89c8a9d3a89f3bf$export$d614758658023fd = (url)=>{
    if (!$c89c8a9d3a89f3bf$export$895d6838d29edd02(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $lfozZ.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $c89c8a9d3a89f3bf$export$4cf71c31cd7fa836 = {
    TEAM_INVITE_LEARN_MORE: `${(0, $bAnhx.getAtlassianContextUrl)('support')}/atlassian-account/docs/start-an-atlassian-team/#Add-or-remove-members-of-a-team`
};

});
parcelRegister("bAnhx", function(module, exports) {

$parcel$export(module.exports, "getAtlassianContextUrl", () => $299d3bc44f0f7017$export$9986ff99701c314f);
$parcel$export(module.exports, "getAtlassianContextDomain", () => $299d3bc44f0f7017$export$50f0d77e468746eb);

var $bW292 = parcelRequire("bW292");

var $avLBj = parcelRequire("avLBj");
function $299d3bc44f0f7017$export$9986ff99701c314f(domainKey) {
    if ((0, $avLBj.isFedramp)()) return (0, $bW292.getATLContextUrl)(domainKey);
    else return `https://${domainKey}.atlassian.com`;
}
function $299d3bc44f0f7017$export$50f0d77e468746eb(domainKey) {
    if ((0, $avLBj.isFedramp)()) return (0, $bW292.getATLContextDomain)(domainKey);
    else return `${domainKey}.atlassian.com`;
}

});



parcelRegister("91mld", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigProvider", () => $6915899263678530$export$47bd48f80e3bc7b3);

var $eUqFw = parcelRequire("eUqFw");

var $cI2xB = parcelRequire("cI2xB");

var $4xNJU = parcelRequire("4xNJU");
function $6915899263678530$export$47bd48f80e3bc7b3({ children: children, ...props }) {
    const profileCardClient = (0, $4xNJU.useProfileClient)();
    const config = (0, $eUqFw.useMemo)(()=>({
            ...props,
            profileCardClient: profileCardClient
        }), [
        props,
        profileCardClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cI2xB.ProfileCardClientConfigContext).Provider, {
        value: config
    }, children);
}

});
parcelRegister("cI2xB", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigContext", () => $940b90aaa55d86bc$export$c804cb3b184b670f);
$parcel$export(module.exports, "useProfileCardClientConfig", () => $940b90aaa55d86bc$export$a3c560c84e5d436d);

var $eUqFw = parcelRequire("eUqFw");
const $940b90aaa55d86bc$var$error = new Error('ProfileCardClientConfigProvider is not found in higher components');
const $940b90aaa55d86bc$var$defaultState = {
    addFlag: ()=>{
        // eslint-disable-next-line no-console
        console.error($940b90aaa55d86bc$var$error);
    },
    push: ()=>{
        // eslint-disable-next-line no-console
        console.error($940b90aaa55d86bc$var$error);
    },
    contextEntryPoint: null,
    cloudId: null
};
const $940b90aaa55d86bc$export$c804cb3b184b670f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($940b90aaa55d86bc$var$defaultState);
const $940b90aaa55d86bc$export$a3c560c84e5d436d = ()=>(0, $eUqFw.useContext)($940b90aaa55d86bc$export$c804cb3b184b670f);

});

parcelRegister("4xNJU", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $34f0d3b598f81d94$export$d43dc22a8337ee9f);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $8PYmV = parcelRequire("8PYmV");

var $6DV4v = parcelRequire("6DV4v");
const $34f0d3b598f81d94$var$CACHE_MAX_AGE = 60000;
const $34f0d3b598f81d94$var$actions = {
    createClient: (stargateRoot, enableTeamCentral = false)=>({ setState: setState })=>{
            const profileClient = new (0, $8PYmV.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralUrl: enableTeamCentral ? `${stargateRoot}/watermelon/graphql` : undefined,
                // teamCentralBaseUrl: enableTeamCentral
                //   ? getConfig().teamCentralUrl
                //   : undefined,
                cacheSize: 20,
                cacheMaxAge: $34f0d3b598f81d94$var$CACHE_MAX_AGE
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $34f0d3b598f81d94$var$ProfileClientStore = (0, $a61MH.createStore)({
    initialState: {},
    actions: $34f0d3b598f81d94$var$actions
});
const $34f0d3b598f81d94$var$useProfileClientState = (0, $ggKAj.createHook)($34f0d3b598f81d94$var$ProfileClientStore);
const $34f0d3b598f81d94$export$d43dc22a8337ee9f = ()=>{
    // const [teamCentralStore] = useTeamCentralStore();
    const [{ profileClient: profileClient }, { createClient: createClient }] = $34f0d3b598f81d94$var$useProfileClientState();
    const { stargateRoot: stargateRoot } = (0, $6DV4v.useAppConfig)();
    (0, $eUqFw.useEffect)(()=>{
        createClient(stargateRoot);
    }, [
        createClient,
        stargateRoot
    ]);
    // TODO: enable team central
    // useEffect(() => {
    //   if (teamCentralStore.hasWorkspace || teamCentralStore.orgHasWorkspace) {
    //     // re-create the client and enable team central features
    //     createClient(true);
    //   }
    // }, [teamCentralStore.hasWorkspace, teamCentralStore.orgHasWorkspace]);
    return profileClient;
};

});
parcelRegister("8PYmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2720ab38ce9772$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $lsiAJ = parcelRequire("lsiAJ");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
var $ac2720ab38ce9772$export$2e2bcd8739ae039 = (0, $lsiAJ.default);

});
parcelRegister("4eGN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3adc3d48b40454$export$2e2bcd8739ae039);

var $6roQF = parcelRequire("6roQF");
class $7c3adc3d48b40454$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $6roQF.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("lsiAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b7dde52ef02eed$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $XHGTv = parcelRequire("XHGTv");

var $kmpkL = parcelRequire("kmpkL");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
class $84b7dde52ef02eed$var$ProfileCardClient {
    constructor(config, clients){
        this.userClient = clients?.userClient || new (0, $b4hs7.default)(config);
        this.teamClient = clients?.teamClient || new (0, $kWhjG.default)(config);
        this.tcClient = $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    getTeamCentralBaseUrl() {
        return this.tcClient?.options.teamCentralBaseUrl;
    }
    shouldShowGiveKudos() {
        if (!this.tcClient || !this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
}
function $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $XHGTv.getBooleanFF)('platform.profilecard-disable-team-central-client-in-fedramp_ilnm7')) {
        if ((0, $dfBCt.isFedRamp)()) return undefined;
    }
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralUrl = config.teamCentralUrl;
    return teamCentralUrl ? new (0, $kmpkL.default)({
        ...config,
        teamCentralUrl: teamCentralUrl
    }) : undefined;
}
var $84b7dde52ef02eed$export$2e2bcd8739ae039 = $84b7dde52ef02eed$var$ProfileCardClient;

});
parcelRegister("kmpkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8fb2ad4171564c$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $6WG70 = parcelRequire("6WG70");
const $ab8fb2ad4171564c$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $ab8fb2ad4171564c$export$f8c05b360e45cd0 = (featureKey, context)=>({
        query: `
    query isFeatureKeyEnabled($featureKey: String!, $context: [IsFeatureEnabledContextInput]) {
      isFeatureEnabled(featureKey: $featureKey, context: $context) {
        enabled
      }
    }
  `,
        variables: {
            featureKey: featureKey,
            context: context || []
        }
    });
function $ab8fb2ad4171564c$var$hasTCWorkspace(config) {
    return config.cloudId ? fetch(`/gateway/api/watermelon/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
        return !res || res && res.ok;
    }) : Promise.resolve(false);
}
let $ab8fb2ad4171564c$var$isTCReadyPromiseMap = new Map();
class $ab8fb2ad4171564c$var$TeamCentralCardClient extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.featureFlagKeys = new Map();
        this.isTCReadyPromise = this.createTcReadyPromise(options);
    }
    createTcReadyPromise(config) {
        if (config.cloudId) {
            let promise = $ab8fb2ad4171564c$var$isTCReadyPromiseMap.get(config.cloudId);
            if (!promise) {
                promise = $ab8fb2ad4171564c$var$hasTCWorkspace(config);
                $ab8fb2ad4171564c$var$isTCReadyPromiseMap.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    async makeFeatureFlagCheckRequest(featureKey, context) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$f8c05b360e45cd0(featureKey, context);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=isFeatureKeyEnabled`, query);
        return response.isFeatureEnabled.enabled;
    }
    async makeRequest(userId) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$1862ef0c3880ca8d(userId);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
        return response.reportingLines;
    }
    getReportingLines(userId) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    getFlagEnabled(featureKey, productIdentifier) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!featureKey) return Promise.reject(new Error('featureKey missing'));
                if (this.featureFlagKeys.has(featureKey)) return Promise.resolve(this.featureFlagKeys.get(featureKey));
                if (this.bypassOnFailure) return Promise.resolve(false);
                const context = [
                    {
                        key: 'productIdentifier',
                        value: productIdentifier || 'unset'
                    }
                ];
                return new Promise((resolve)=>{
                    this.makeFeatureFlagCheckRequest(featureKey, context).then((enabled)=>{
                        this.featureFlagKeys.set(featureKey, enabled);
                        resolve(enabled);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        resolve(false);
                    });
                });
            }
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    checkWorkspaceExists() {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $ab8fb2ad4171564c$export$2e2bcd8739ae039 = $ab8fb2ad4171564c$var$TeamCentralCardClient;

});
parcelRegister("6WG70", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $415b57eeeceb8e81$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $415b57eeeceb8e81$export$a14afb5f82fe705);

var $j4C9S = parcelRequire("j4C9S");

var $bl3OJ = parcelRequire("bl3OJ");
const $415b57eeeceb8e81$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $415b57eeeceb8e81$var$id = (headers)=>headers;
async function $415b57eeeceb8e81$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleDirectoryGraphQLErrors));
}
async function $415b57eeeceb8e81$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleAGGErrors));
}
async function $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id, handleErrors) {
    const headers = processHeaders($415b57eeeceb8e81$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $j4C9S.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});
parcelRegister("j4C9S", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $343a8316fe4e3587$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $343a8316fe4e3587$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $343a8316fe4e3587$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $343a8316fe4e3587$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $343a8316fe4e3587$export$60d8267243755b9c);
class $343a8316fe4e3587$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $343a8316fe4e3587$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $343a8316fe4e3587$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});

parcelRegister("bl3OJ", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $d2cc0f3532818141$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $d2cc0f3532818141$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $d2cc0f3532818141$export$d9ad65d422ee3f8c);

var $j4C9S = parcelRequire("j4C9S");
const $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $d2cc0f3532818141$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return !!error && $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $j4C9S.AGGError)) return !!error.errorType && $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $d2cc0f3532818141$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $j4C9S.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $j4C9S.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $j4C9S.DirectoryGraphQLErrors) || causeError instanceof (0, $j4C9S.AGGErrors)) return $d2cc0f3532818141$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $d2cc0f3532818141$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $j4C9S.DirectoryGraphQLErrors)(errors, traceId);
};
const $d2cc0f3532818141$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $j4C9S.AGGErrors)(errors, traceId);
};

});



parcelRegister("kWhjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e65ba6df7e3eef$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $k39sp = parcelRequire("k39sp");
class $26e65ba6df7e3eef$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $k39sp.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("3vXh8", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3825798267526520$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3825798267526520$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3825798267526520$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3825798267526520$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3825798267526520$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3825798267526520$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3825798267526520$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3825798267526520$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3825798267526520$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3825798267526520$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3825798267526520$export$c86679da702d560e);

var $cEOpo = parcelRequire("cEOpo");
/** Below lines are copied from teams common analytics */ const $3825798267526520$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3825798267526520$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3825798267526520$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3825798267526520$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3825798267526520$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3825798267526520$var$TEAM_SUBJECT = 'teamProfileCard';
const $3825798267526520$var$USER_SUBJECT = 'profilecard';
const $3825798267526520$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: undefined,
            packageVersion: undefined,
            ...attributes,
            firedAt: Math.round((0, $cEOpo.getPageTime)())
        }
    });
const $3825798267526520$export$d50ab8a3b6975c = (type, method)=>$3825798267526520$var$createEvent('ui', 'triggered', type === 'user' ? $3825798267526520$var$USER_SUBJECT : $3825798267526520$var$TEAM_SUBJECT, undefined, {
        method: method
    });
const $3825798267526520$export$c9b0e37b229a297b = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$TEAM_SUBJECT, 'request', attributes);
const $3825798267526520$export$12dae48763368ac9 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$USER_SUBJECT, 'request', attributes);
const $3825798267526520$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('ui', 'rendered', type === 'user' ? $3825798267526520$var$USER_SUBJECT : $3825798267526520$var$TEAM_SUBJECT, actionSubjectId, attributes);
const $3825798267526520$export$fdcd134fbeb1f921 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', type === 'user' ? $3825798267526520$var$USER_SUBJECT : $3825798267526520$var$TEAM_SUBJECT, 'action', attributes);
const $3825798267526520$export$93260987012593be = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$USER_SUBJECT, 'reportingLines', attributes);
const $3825798267526520$export$79befd155063a6a7 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', type === 'user' ? $3825798267526520$var$USER_SUBJECT : $3825798267526520$var$TEAM_SUBJECT, 'moreActions', attributes);
const $3825798267526520$export$2703289b35687fde = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'avatar', attributes);
const $3825798267526520$export$b4411a7661cf2d3f = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3825798267526520$export$c86679da702d560e = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'errorRetry', attributes);

});
parcelRegister("cEOpo", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $77671953c6d01f45$export$e9faea7c41053334);
const $77671953c6d01f45$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $77671953c6d01f45$var$performanceAvailable = $77671953c6d01f45$var$isPerformanceAvailable();
const $77671953c6d01f45$var$initialPageTime = Date.now();
const $77671953c6d01f45$export$e9faea7c41053334 = ()=>{
    if ($77671953c6d01f45$var$performanceAvailable) return performance.now();
    return Date.now() - $77671953c6d01f45$var$initialPageTime;
};

});


parcelRegister("k39sp", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $b92dd34bfd4aec4a$export$26a8aad0c7182dd6);

var $6WG70 = parcelRequire("6WG70");
const $b92dd34bfd4aec4a$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $b92dd34bfd4aec4a$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $b92dd34bfd4aec4a$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $b92dd34bfd4aec4a$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $b92dd34bfd4aec4a$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $b92dd34bfd4aec4a$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$b92dd34bfd4aec4a$var$TEAM_FRAGMENT}
    }
  }
}`;
const $b92dd34bfd4aec4a$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $b92dd34bfd4aec4a$export$4968f4e0119a5d9c,
        variables: {
            teamId: $b92dd34bfd4aec4a$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $b92dd34bfd4aec4a$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', undefined);
    headers.append('atl-client-version', undefined);
    return headers;
};
async function $b92dd34bfd4aec4a$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $b92dd34bfd4aec4a$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $6WG70.AGGQuery)(url, query, $b92dd34bfd4aec4a$export$1229c72526c01df2);
    return $b92dd34bfd4aec4a$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("b4hs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b3ff2ca38ed950$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $6WG70 = parcelRequire("6WG70");
const $80b3ff2ca38ed950$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $80b3ff2ca38ed950$export$bfbf383663068c37 = (cloudId, userId)=>({
        query: `query User($userId: String!, $cloudId: String!) {
    User: CloudUser(userId: $userId, cloudId: $cloudId) {
      id
      isCurrentUser
      status
      statusModifiedDate
      isBot
      isNotMentionable
      fullName
      nickname
      email
      meta: title
      location
      companyName
      avatarUrl(size: 192)
      remoteWeekdayIndex: localTime(format: "d")
      remoteWeekdayString: localTime(format: "ddd")
      remoteTimeString: localTime(format: "h:mma")
    }
  }`,
        variables: {
            cloudId: cloudId,
            userId: userId
        }
    });
class $80b3ff2ca38ed950$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        if (!this.options.url) throw new Error('options.url is a required parameter');
        const query = $80b3ff2ca38ed950$export$bfbf383663068c37(cloudId, userId);
        const response = await (0, $6WG70.directoryGraphqlQuery)(this.options.url, query);
        return $80b3ff2ca38ed950$export$b26b7f9bcf400835(response);
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});



parcelRegister("6DV4v", function(module, exports) {

$parcel$export(module.exports, "useNavigation", () => $4d62a7db3dc85a22$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useAppConfig", () => $4d62a7db3dc85a22$export$a3e0ece8c3f698d7);

var $kKbGE = parcelRequire("kKbGE");

var $jDNv9 = parcelRequire("jDNv9");

var $jDNv9 = parcelRequire("jDNv9");
const $4d62a7db3dc85a22$export$d0fd4b7106de2769 = ()=>{
    const state = (0, $jDNv9.useNavigationState)();
    const actions = (0, $kKbGE.useNavigationActions)();
    return {
        ...actions,
        ...state
    };
};
const $4d62a7db3dc85a22$export$a3e0ece8c3f698d7 = ()=>{
    const storeState = (0, $jDNv9.useAppConfigStoreState)();
    const navigation = $4d62a7db3dc85a22$export$d0fd4b7106de2769();
    const addFlag = (0, $kKbGE.useAddFlag)();
    return {
        ...storeState,
        ...navigation,
        addFlag: addFlag
    };
};

});




parcelRegister("5UcXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $44cc3cae80593267$export$2e2bcd8739ae039);
// TODO: PTC-2088 - simplify list of locales

























const $44cc3cae80593267$var$messagesConfig = [
    // Czech
    {
        locales: [
            'cs',
            'cs-CZ'
        ],
        loader: ()=>(parcelRequire("ffFXa"))
    },
    // Danish
    {
        locales: [
            'da',
            'da-DK'
        ],
        loader: ()=>(parcelRequire("1pBLn"))
    },
    // German
    {
        locales: [
            'de',
            'de-DE'
        ],
        loader: ()=>(parcelRequire("jgniz"))
    },
    // Spain
    {
        locales: [
            'es',
            'es-ES'
        ],
        loader: ()=>(parcelRequire("9kn5q"))
    },
    // Finnish
    {
        locales: [
            'fi',
            'fi-FI'
        ],
        loader: ()=>(parcelRequire("ciHua"))
    },
    // French
    {
        locales: [
            'fr',
            'fr-FR'
        ],
        loader: ()=>(parcelRequire("lUMsA"))
    },
    // Hungarian
    {
        locales: [
            'hu',
            'hu-HU'
        ],
        loader: ()=>(parcelRequire("cZWWf"))
    },
    // Icelandic
    {
        locales: [
            'is',
            'is-IS'
        ],
        loader: ()=>(parcelRequire("66QVX"))
    },
    // Italian
    {
        locales: [
            'it',
            'it-IT'
        ],
        loader: ()=>(parcelRequire("9dHGC"))
    },
    // Japanese
    {
        locales: [
            'ja',
            'ja-JP'
        ],
        loader: ()=>(parcelRequire("1SwNF"))
    },
    // Korean
    {
        locales: [
            'ko',
            'ko-KR'
        ],
        loader: ()=>(parcelRequire("9YgcK"))
    },
    // Dutch
    {
        locales: [
            'nl',
            'nl-NL'
        ],
        loader: ()=>(parcelRequire("2ojyj"))
    },
    // Norwegian (Norway)
    {
        locales: [
            'nb',
            'nb-NO'
        ],
        loader: ()=>(parcelRequire("gNSU9"))
    },
    // Polish
    {
        locales: [
            'pl',
            'pl-PL'
        ],
        loader: ()=>(parcelRequire("c1h4y"))
    },
    // Portuguese -
    {
        locales: [
            'pt-BR'
        ],
        loader: ()=>(parcelRequire("fSQ48"))
    },
    // Romanian
    {
        locales: [
            'ro',
            'ro-RO'
        ],
        loader: ()=>(parcelRequire("hy7sY"))
    },
    // Russian
    {
        locales: [
            'ru',
            'ru-RU'
        ],
        loader: ()=>(parcelRequire("2GnN0"))
    },
    // Swedish
    {
        locales: [
            'sv',
            'sv-SE'
        ],
        loader: ()=>(parcelRequire("evFDh"))
    },
    // China uses Chinese (Simplified)
    {
        locales: [
            'zh',
            'zh-CN',
            'zh-Hans'
        ],
        loader: ()=>(parcelRequire("UObFx"))
    },
    // Taiwan or Hong Kong uses Chinese (Traditional)
    {
        locales: [
            'zh-TW',
            'zh-HK',
            'zh-Hant'
        ],
        loader: ()=>(parcelRequire("58XfG"))
    },
    // Turkish
    {
        locales: [
            'tr',
            'tr-TR'
        ],
        loader: ()=>(parcelRequire("lfLm9"))
    },
    // Thai
    {
        locales: [
            'th',
            'th-TH'
        ],
        loader: ()=>(parcelRequire("5CJOD"))
    },
    // Ukrainian
    {
        locales: [
            'uk',
            'uk-UA'
        ],
        loader: ()=>(parcelRequire("bqWs4"))
    },
    // Vietnamese
    {
        locales: [
            'vi',
            'vi-VN'
        ],
        loader: ()=>(parcelRequire("k6DUi"))
    },
    // English (UK)
    {
        locales: [
            'en-GB'
        ],
        loader: ()=>(parcelRequire("e4dy9"))
    }
];
var $44cc3cae80593267$export$2e2bcd8739ae039 = $44cc3cae80593267$var$messagesConfig;

});
parcelRegister("ffFXa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5y1ln');
        const value = parcelRequire('31bWb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5y1ln").then(()=>parcelRequire('31bWb'));
}

});

parcelRegister("1pBLn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dSrNb');
        const value = parcelRequire('iyRDF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dSrNb").then(()=>parcelRequire('iyRDF'));
}

});

parcelRegister("jgniz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eSQSO');
        const value = parcelRequire('bzCcn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eSQSO").then(()=>parcelRequire('bzCcn'));
}

});

parcelRegister("9kn5q", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1Z8aM');
        const value = parcelRequire('iQ2Hp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1Z8aM").then(()=>parcelRequire('iQ2Hp'));
}

});

parcelRegister("ciHua", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('a9rM7');
        const value = parcelRequire('eKbCu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("a9rM7").then(()=>parcelRequire('eKbCu'));
}

});

parcelRegister("lUMsA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2BPY7');
        const value = parcelRequire('iJXSj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2BPY7").then(()=>parcelRequire('iJXSj'));
}

});

parcelRegister("cZWWf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8LFp7');
        const value = parcelRequire('25atv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8LFp7").then(()=>parcelRequire('25atv'));
}

});

parcelRegister("66QVX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('82Wgg');
        const value = parcelRequire('1vRLL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("82Wgg").then(()=>parcelRequire('1vRLL'));
}

});

parcelRegister("9dHGC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8QQEW');
        const value = parcelRequire('50vjm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8QQEW").then(()=>parcelRequire('50vjm'));
}

});

parcelRegister("1SwNF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lW7gk');
        const value = parcelRequire('jbP65');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lW7gk").then(()=>parcelRequire('jbP65'));
}

});

parcelRegister("9YgcK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kEYSr');
        const value = parcelRequire('geJOe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kEYSr").then(()=>parcelRequire('geJOe'));
}

});

parcelRegister("2ojyj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5WMYq');
        const value = parcelRequire('4Z3kc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5WMYq").then(()=>parcelRequire('4Z3kc'));
}

});

parcelRegister("gNSU9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('a0rK4');
        const value = parcelRequire('hDEqi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("a0rK4").then(()=>parcelRequire('hDEqi'));
}

});

parcelRegister("c1h4y", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iHYJN');
        const value = parcelRequire('66H5L');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iHYJN").then(()=>parcelRequire('66H5L'));
}

});

parcelRegister("fSQ48", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k6sbh');
        const value = parcelRequire('8KPEH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k6sbh").then(()=>parcelRequire('8KPEH'));
}

});

parcelRegister("hy7sY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lV6eD');
        const value = parcelRequire('huAmD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lV6eD").then(()=>parcelRequire('huAmD'));
}

});

parcelRegister("2GnN0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2AgPY');
        const value = parcelRequire('adTus');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2AgPY").then(()=>parcelRequire('adTus'));
}

});

parcelRegister("evFDh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l9OYK');
        const value = parcelRequire('dxz8O');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l9OYK").then(()=>parcelRequire('dxz8O'));
}

});

parcelRegister("UObFx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hyPA1');
        const value = parcelRequire('U7owy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hyPA1").then(()=>parcelRequire('U7owy'));
}

});

parcelRegister("58XfG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dfYyg');
        const value = parcelRequire('4muGI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dfYyg").then(()=>parcelRequire('4muGI'));
}

});

parcelRegister("lfLm9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b9MhI');
        const value = parcelRequire('1qqr9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b9MhI").then(()=>parcelRequire('1qqr9'));
}

});

parcelRegister("5CJOD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dDIHC');
        const value = parcelRequire('7A2Be');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dDIHC").then(()=>parcelRequire('7A2Be'));
}

});

parcelRegister("bqWs4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('43KlW');
        const value = parcelRequire('1TioH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("43KlW").then(()=>parcelRequire('1TioH'));
}

});

parcelRegister("k6DUi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gO2jt');
        const value = parcelRequire('ilzmq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gO2jt").then(()=>parcelRequire('ilzmq'));
}

});

parcelRegister("e4dy9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ccROC');
        const value = parcelRequire('3rau7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ccROC").then(()=>parcelRequire('3rau7'));
}

});


parcelRegister("6eCcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a1b00339d61245$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $7QNSj = parcelRequire("7QNSj");
var $bqSCJ = parcelRequire("bqSCJ");
var $9MQbY = parcelRequire("9MQbY");

var $9sC8q = parcelRequire("9sC8q");

var $aMk0u = parcelRequire("aMk0u");

var $9PYcQ = parcelRequire("9PYcQ");

var $eYUhH = parcelRequire("eYUhH");

var $3bOQI = parcelRequire("3bOQI");

var $dNnsJ = parcelRequire("dNnsJ");

var $i016T = parcelRequire("i016T");

var $do8sj = parcelRequire("do8sj");

var $6DxuR = parcelRequire("6DxuR");

var $hceq0 = parcelRequire("hceq0");

var $9qoc9 = parcelRequire("9qoc9");

var $cAtBe = parcelRequire("cAtBe");
// Team Profile
// Kudos
const $48a1b00339d61245$var$renderRoutes = (contextEntryPoint, canViewTeams)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9MQbY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        exact: true,
        path: `${contextEntryPoint}/`,
        render: (0, $eYUhH.default)
    }), !canViewTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/search/teams`,
        render: (0, $i016T.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/search`,
        render: (0, $dNnsJ.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/kudos/:uuid`,
        render: (0, $aMk0u.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        exact: true,
        path: `${contextEntryPoint}/team`,
        render: (0, $6DxuR.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bOQI.RouteWithOrgIdLoading), {
        path: `${contextEntryPoint}/team/:teamId`,
        render: (0, $do8sj.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId/work`,
        render: (0, $cAtBe.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId/*`,
        render: (0, $9qoc9.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/me`,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9PYcQ.default), (0, $kU09D.default)({}, props, {
                contextEntryPoint: contextEntryPoint
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId`,
        render: (0, $hceq0.default)
    }));
};
function $48a1b00339d61245$var$AppRoutes(props) {
    const { contextEntryPoint: contextEntryPoint, history: history, onTransition: onTransition } = props;
    const { permissions: { canViewTeams: canViewTeams } } = (0, $9sC8q.useTeamVisibility)();
    (0, $eUqFw.useEffect)(()=>{
        if (!onTransition) return;
        let unsubscribeBlockingHistory = ()=>{};
        let unsubscribeListeningHistory = ()=>{};
        if (history) {
            let lastHistoryLocation;
            unsubscribeListeningHistory = history.listen(({ pathname: pathname })=>{
                lastHistoryLocation = pathname;
            });
            // We're using history.block() here instead of history.listen()
            // because we want this to run BEFORE transition happens.
            unsubscribeBlockingHistory = history.block(({ pathname: pathname })=>{
                if (lastHistoryLocation !== pathname) onTransition(pathname);
            });
        }
        return ()=>{
            unsubscribeBlockingHistory();
            unsubscribeListeningHistory();
        };
    }, [
        onTransition,
        history
    ]);
    const routes = $48a1b00339d61245$var$renderRoutes(contextEntryPoint, canViewTeams);
    // If `history` object is not passed to `EmbeddableDirectory`, `EmbeddableDirectory` will use `Router` component from product in higher component tree.
    // If `history` object is passed to `EmbeddableDirectory`, `EmbeddableDirectory` will render its own `Router` component.
    return history ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqSCJ.default), {
        history: history
    }, routes) : routes;
}
var $48a1b00339d61245$export$2e2bcd8739ae039 = $48a1b00339d61245$var$AppRoutes;

});
parcelRegister("7QNSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7413dcddcdf29e$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $k43p8 = parcelRequire("k43p8");
var $5b7413dcddcdf29e$export$2e2bcd8739ae039 = (0, $k43p8.default);

});
parcelRegister("k43p8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b6d266f4833098$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $1d3eD = parcelRequire("1d3eD");
var $e9b6d266f4833098$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e9b6d266f4833098$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e9b6d266f4833098$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e9b6d266f4833098$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e9b6d266f4833098$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $e9b6d266f4833098$var$Route = function(_React$Component) {
    $e9b6d266f4833098$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $e9b6d266f4833098$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $e9b6d266f4833098$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $e9b6d266f4833098$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $e9b6d266f4833098$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $1d3eD.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.render && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$e9b6d266f4833098$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$e9b6d266f4833098$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$e9b6d266f4833098$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    })
};
$e9b6d266f4833098$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $e9b6d266f4833098$export$2e2bcd8739ae039 = $e9b6d266f4833098$var$Route;

});
parcelRegister("1d3eD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1983bddd0ee331$export$2e2bcd8739ae039);

var $43pB1 = parcelRequire("43pB1");
var $0e1983bddd0ee331$var$patternCache = {};
var $0e1983bddd0ee331$var$cacheLimit = 10000;
var $0e1983bddd0ee331$var$cacheCount = 0;
var $0e1983bddd0ee331$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $0e1983bddd0ee331$var$patternCache[cacheKey] || ($0e1983bddd0ee331$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($43pB1)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($0e1983bddd0ee331$var$cacheCount < $0e1983bddd0ee331$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $0e1983bddd0ee331$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $0e1983bddd0ee331$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $0e1983bddd0ee331$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $0e1983bddd0ee331$export$2e2bcd8739ae039 = $0e1983bddd0ee331$var$matchPath;

});



parcelRegister("bqSCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $852c7e8f766e6629$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $aTrRe = parcelRequire("aTrRe");
var $852c7e8f766e6629$export$2e2bcd8739ae039 = (0, $aTrRe.default);

});
parcelRegister("aTrRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee4a658adeb8d1a$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $7ee4a658adeb8d1a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7ee4a658adeb8d1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ee4a658adeb8d1a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ee4a658adeb8d1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $7ee4a658adeb8d1a$var$Router = function(_React$Component) {
    $7ee4a658adeb8d1a$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $7ee4a658adeb8d1a$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $7ee4a658adeb8d1a$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $7ee4a658adeb8d1a$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $7ee4a658adeb8d1a$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$7ee4a658adeb8d1a$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
};
$7ee4a658adeb8d1a$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$7ee4a658adeb8d1a$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $7ee4a658adeb8d1a$export$2e2bcd8739ae039 = $7ee4a658adeb8d1a$var$Router;

});


parcelRegister("9MQbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $72011505e90bfe2d$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $e8LPn = parcelRequire("e8LPn");
var $72011505e90bfe2d$export$2e2bcd8739ae039 = (0, $e8LPn.default);

});
parcelRegister("e8LPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4b6e9a2b5461b16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $1d3eD = parcelRequire("1d3eD");
function $a4b6e9a2b5461b16$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4b6e9a2b5461b16$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a4b6e9a2b5461b16$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $a4b6e9a2b5461b16$var$Switch = function(_React$Component) {
    $a4b6e9a2b5461b16$var$_inherits(Switch, _React$Component);
    function Switch() {
        $a4b6e9a2b5461b16$var$_classCallCheck(this, Switch);
        return $a4b6e9a2b5461b16$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $1d3eD.default)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$a4b6e9a2b5461b16$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
    }).isRequired
};
$a4b6e9a2b5461b16$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
var $a4b6e9a2b5461b16$export$2e2bcd8739ae039 = $a4b6e9a2b5461b16$var$Switch;

});


parcelRegister("9sC8q", function(module, exports) {

$parcel$export(module.exports, "useTeamVisibility", () => $6e344f600b561af0$export$acf57ff2f92f51c1);

var $eUqFw = parcelRequire("eUqFw");

var $47ZoO = parcelRequire("47ZoO");

var $eFsBo = parcelRequire("eFsBo");

var $lfozZ = parcelRequire("lfozZ");

var $3OBB6 = parcelRequire("3OBB6");

var $jUprp = parcelRequire("jUprp");
const $6e344f600b561af0$export$7d97a022bd09a6fb = ()=>{
    return {
        isTeamsVisiblityEnabled: true,
        failOpenSites: false
    };
};
const $6e344f600b561af0$var$useTeamPermissionsAnalytics = ({ data: data, error: error, permissions: permissions })=>{
    const { fireEvent: fireEvent } = (0, $47ZoO.usePeopleTeamAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (error) {
            (0, $lfozZ.logException)(error, 'Error loading team permissions in useTeamsPermissionsService');
            fireEvent('operational.teamsPermissionsRequest.failed', {
                message: error.message,
                status: error.status,
                path: error.path
            });
        }
    }, [
        error,
        fireEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data && permissions) fireEvent('operational.teamsPermissionsRequest.succeeded', {
            canCreateTeams: permissions.canCreateTeams,
            canViewTeams: permissions.canViewTeams,
            canAdminTeams: !!permissions.canAdminTeams
        });
    }, [
        data,
        fireEvent,
        permissions
    ]);
};
const $6e344f600b561af0$export$acf57ff2f92f51c1 = ()=>{
    const { orgId: orgId } = (0, $3OBB6.useV3OrgIdStatus)();
    const [{ cloudId: cloudId }] = (0, $jUprp.useSite)();
    const result = (0, $eFsBo.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: true
    });
    $6e344f600b561af0$var$useTeamPermissionsAnalytics(result);
    return {
        isLoading: result.isLoading,
        permissions: result.permissions
    };
};

});
parcelRegister("3OBB6", function(module, exports) {

$parcel$export(module.exports, "useV3OrgIdStatus", () => $2c7334b122f4192f$export$52558c271a487a01);

var $c1nG2 = parcelRequire("c1nG2");
function $2c7334b122f4192f$export$52558c271a487a01() {
    const [{ orgId: orgId }] = (0, $c1nG2.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
}

});


parcelRegister("aMk0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d8de80a9e763c18$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $9qEz4 = parcelRequire("9qEz4");

var $6aLWS = parcelRequire("6aLWS");

var $5YswS = parcelRequire("5YswS");
function $7d8de80a9e763c18$var$hasProfileProp(state) {
    return !!state && 'profile' in state;
}
const $7d8de80a9e763c18$var$KudosPageRoute = ({ match: match, location: location })=>{
    const { uuid: uuid } = match.params;
    const profile = $7d8de80a9e763c18$var$hasProfileProp(location.state) ? location.state.profile : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YswS.default), {
        name: (0, $7sTpx.AnalyticsKeys).KUDOS_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qEz4.default), {
        name: (0, $7sTpx.AnalyticsKeys).KUDOS_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6aLWS.default), {
        uuid: uuid,
        referrerProfile: profile
    }));
};
var $7d8de80a9e763c18$export$2e2bcd8739ae039 = $7d8de80a9e763c18$var$KudosPageRoute;

});
parcelRegister("9qEz4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dd6020ce129dad5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $5IcES = parcelRequire("5IcES");
const $6dd6020ce129dad5$export$430619e48d4c20bb = (props)=>{
    const analytics = (0, $5IcES.default)();
    const { name: name } = props;
    (0, $eUqFw.useEffect)(()=>{
        analytics.pushOperationalEvent({
            source: (0, $7sTpx.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: name,
            action: (0, $7sTpx.AnalyticsEventActions).MOUNTED
        });
    }, [
        analytics,
        name
    ]);
    return null;
};
var $6dd6020ce129dad5$export$2e2bcd8739ae039 = $6dd6020ce129dad5$export$430619e48d4c20bb;

});
parcelRegister("5IcES", function(module, exports) {

$parcel$export(module.exports, "default", () => $428ae18342ee5962$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fS6sM = parcelRequire("fS6sM");
const $428ae18342ee5962$var$useAnalytics = ()=>(0, $eUqFw.useContext)((0, $fS6sM.AnalyticsContext)).analytics;
var $428ae18342ee5962$export$2e2bcd8739ae039 = $428ae18342ee5962$var$useAnalytics;

});


parcelRegister("6aLWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $47e8dedcf63d83e0$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $47e8dedcf63d83e0$var$LazyKudosPage = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("iVl7U")),
    loading: ()=>null
});
$47e8dedcf63d83e0$var$LazyKudosPage.displayName = 'lazy(KudosPage)';
var $47e8dedcf63d83e0$export$2e2bcd8739ae039 = $47e8dedcf63d83e0$var$LazyKudosPage;

});
parcelRegister("iVl7U", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('jNKxd')
        ]);
        const value = parcelRequire('3sj1l');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("jNKxd")
    ]).then(()=>parcelRequire('3sj1l'));
}

});


parcelRegister("5YswS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4598afa4fc268ddf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $53jQw = parcelRequire("53jQw");
var $5IcES = parcelRequire("5IcES");

var $lEcvG = parcelRequire("lEcvG");

var $aatMG = parcelRequire("aatMG");
function $4598afa4fc268ddf$var$recordPageVisitOrigin(replace) {
    const url = new URL(window.location.href);
    if (!url || !url.searchParams) return;
    // ref contains a product like confluence, jira etc.
    const ref = url.searchParams.get('ref') || '';
    // src contains a location like appswitcher, peopledrawer etc.
    const src = url.searchParams.get('src') || '';
    if (!ref && !src) return;
    // save referrer info for retrieving it in further screen events
    (0, $53jQw.default).set({
        src: src,
        ref: ref
    });
    url.searchParams.delete('ref');
    url.searchParams.delete('src');
    // replace location if it changed after removing ref and src query params
    if (replace) replace(`${url.pathname}${url.search}`);
}
function $4598afa4fc268ddf$var$RecordTransition(props) {
    const { name: name } = props;
    const { replace: replace } = (0, $lEcvG.useAppConfig)();
    const refInitialLoadTracked = (0, $eUqFw.useRef)(false);
    const analytics = (0, $5IcES.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (!refInitialLoadTracked.current) {
            refInitialLoadTracked.current = true;
            // stores referrer info
            $4598afa4fc268ddf$var$recordPageVisitOrigin(replace);
        } else // cleanup stored referrer info on transition
        (0, $53jQw.default).cleanup();
        (0, $aatMG.default)(name, analytics);
    }, [
        analytics,
        name,
        replace
    ]);
    return null;
}
var $4598afa4fc268ddf$export$2e2bcd8739ae039 = $4598afa4fc268ddf$var$RecordTransition;

});
parcelRegister("lEcvG", function(module, exports) {

$parcel$export(module.exports, "useAppConfig", () => $fc2709a0084d953a$export$a3e0ece8c3f698d7);
$parcel$export(module.exports, "default", () => $fc2709a0084d953a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $fc2709a0084d953a$var$error = new Error('AppConfigProvider is not found in higher components');
const $fc2709a0084d953a$var$defaultState = {
    addFlag: ()=>{
        throw $fc2709a0084d953a$var$error;
    },
    push: ()=>{
        throw $fc2709a0084d953a$var$error;
    },
    replace: ()=>{
        throw $fc2709a0084d953a$var$error;
    },
    history: undefined,
    contextSpaPaths: [],
    contextEntryPoint: '',
    docTitle: {},
    appName: '',
    productName: '',
    env: undefined,
    cloudId: '',
    isJiraAvailable: false,
    productFeatureFlags: {},
    orgId: undefined
};
const $fc2709a0084d953a$var$AppConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($fc2709a0084d953a$var$defaultState);
const $fc2709a0084d953a$export$a3e0ece8c3f698d7 = ()=>{
    return (0, $eUqFw.useContext)($fc2709a0084d953a$var$AppConfigContext);
};
var $fc2709a0084d953a$export$2e2bcd8739ae039 = $fc2709a0084d953a$var$AppConfigContext;

});

parcelRegister("aatMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7671f11a336613f9$export$2e2bcd8739ae039);

var $87Wkc = parcelRequire("87Wkc");
let $7671f11a336613f9$var$dwellHelper = null;
const $7671f11a336613f9$var$buildDwellEventData = (source)=>{
    return {
        actionSubject: 'page',
        source: source
    };
};
const $7671f11a336613f9$var$sendDwellEvent = (eventData, analyticsClient)=>{
    analyticsClient.sendTrackEvent(eventData);
};
const $7671f11a336613f9$var$initialiseDwellTime = (eventSource, analyticsClient)=>{
    if (eventSource) {
        const updatedEventData = $7671f11a336613f9$var$buildDwellEventData(eventSource);
        $7671f11a336613f9$var$dwellHelper = (0, $87Wkc.default)((eventData)=>$7671f11a336613f9$var$sendDwellEvent(eventData, analyticsClient), updatedEventData);
        $7671f11a336613f9$var$dwellHelper.start();
    }
};
const $7671f11a336613f9$var$recordNewPageForDwellTime = (eventSource)=>{
    if ($7671f11a336613f9$var$dwellHelper) {
        if (eventSource) {
            const updatedEventData = $7671f11a336613f9$var$buildDwellEventData(eventSource);
            $7671f11a336613f9$var$dwellHelper.newPage(updatedEventData);
        } else // eslint-disable-next-line no-console
        console.error('Unable to record dwell time transition - missing analytics key or source mapping for route');
    } else // eslint-disable-next-line no-console
    console.error('Dwell time has not been initialised');
};
/**
 * Initialises dwell time measurement, or records a page transition if it is already initialised.
 * Note that dwell time will only be initialised on routes that have an analytics key, which should be
 * all routes except for those that result in a redirect.
 */ const $7671f11a336613f9$var$recordDwellTime = (analyticsKey, analyticsClient)=>{
    const eventName = analyticsClient.mapAnalyticsKeyToEvent(analyticsKey);
    const eventSource = eventName ? `${eventName}Screen` : null;
    if (!$7671f11a336613f9$var$dwellHelper) $7671f11a336613f9$var$initialiseDwellTime(eventSource, analyticsClient);
    else $7671f11a336613f9$var$recordNewPageForDwellTime(eventSource);
};
var $7671f11a336613f9$export$2e2bcd8739ae039 = $7671f11a336613f9$var$recordDwellTime;

});
parcelRegister("87Wkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eac38438a69a1cd$export$2e2bcd8739ae039);

var $5HTho = parcelRequire("5HTho");
const $5eac38438a69a1cd$var$getDwellTimeHelper = (sendMethod, eventData)=>{
    return new (0, $5HTho.default)(sendMethod, eventData);
};
var $5eac38438a69a1cd$export$2e2bcd8739ae039 = $5eac38438a69a1cd$var$getDwellTimeHelper;

});




parcelRegister("9PYcQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7297942a1d8ce874$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $1ely8 = parcelRequire("1ely8");
var $5IcES = parcelRequire("5IcES");
var $2vo6z = parcelRequire("2vo6z");

var $3DtTR = parcelRequire("3DtTR");
function $7297942a1d8ce874$export$2e2bcd8739ae039(props) {
    const { contextEntryPoint: contextEntryPoint, location: location } = props;
    const [{ principalUserId: principalUserId }] = (0, $2vo6z.usePrincipalUser)();
    const analytics = (0, $5IcES.default)();
    const url = new URL(window.location.href);
    const ref = (0, $1ely8.sanitiseValue)(url.searchParams.get('ref') || '', {
        shouldHaveSafeCharsOnly: true,
        shouldEncode: true
    });
    (0, $eUqFw.useEffect)(()=>{
        analytics.pushTrackEvent({
            source: (0, $7sTpx.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'redirectMePathToMyProfile',
            action: (0, $7sTpx.AnalyticsEventActions).REDIRECTED,
            attributes: {
                ref: ref
            }
        });
    }, [
        analytics,
        ref
    ]);
    if (!principalUserId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DtTR.default), {
        to: `${contextEntryPoint}/${principalUserId}${location.search}`
    });
}

});
parcelRegister("2vo6z", function(module, exports) {

$parcel$export(module.exports, "usePrincipalUser", () => $1d312cc88f9089cf$export$33e3bf16c7530dd4);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $4ECFx = parcelRequire("4ECFx");
var $4wzHf = parcelRequire("4wzHf");
// types
// Private actions:
// It is called by `getPrincipalUserInfo` action
const $1d312cc88f9089cf$var$getIsSiteAdmin = (cloudId)=>async ({ setState: setState })=>{
        if (!cloudId) {
            setState({
                isSiteAdmin: false
            });
            return;
        }
        let isSiteAdmin = false;
        try {
            isSiteAdmin = await (0, $4ECFx.teamsClient).getIsSiteAdmin(cloudId);
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        } finally{
            setState({
                isSiteAdmin: isSiteAdmin
            });
        }
    };
// it is called by `getPrincipalUserInfo` action
const $1d312cc88f9089cf$var$getMutability = (userId)=>async ({ setState: setState })=>{
        try {
            const data = await (0, $4ECFx.teamsClient).getProfileWithMutability(userId);
            setState({
                mutabilityConstraints: data
            });
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        }
    };
const $1d312cc88f9089cf$var$actions = {
    /**
   * Get user information of current logged-in user.
   * @param cloudId: If Cloud Id is passed, that means People Directory is rendered in a site and we use Cloud Id to check 'isSiteAdmin' info.
   * If Cloud Id is not passed, `isSiteAdmin` is false by default.
   */ getPrincipalUserInfo: (cloudId)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // stop fetching when it is already fetched
            if (getState().isFetching || getState().hasLoaded) return;
            setState({
                isFetching: true,
                hasLoaded: false
            });
            try {
                const userBasicData = await (0, $4wzHf.userInfoProvider).get();
                setState({
                    principalUserId: userBasicData.userId,
                    ...userBasicData
                });
                dispatch($1d312cc88f9089cf$var$getIsSiteAdmin(cloudId));
                dispatch($1d312cc88f9089cf$var$getMutability(userBasicData.userId));
                setState({
                    hasLoaded: true
                });
            } catch (e) {
                setState({
                    hasError: true,
                    hasLoaded: false
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        }
};
const $1d312cc88f9089cf$var$initialState = {
    principalUserId: '',
    avatarUrl: '',
    email: '',
    fullName: '',
    title: '',
    isSiteAdmin: false,
    isFetching: false,
    hasError: false,
    hasLoaded: false
};
/**
 * Manage states of a site
 */ const $1d312cc88f9089cf$var$Store = (0, $a61MH.createStore)({
    initialState: $1d312cc88f9089cf$var$initialState,
    actions: $1d312cc88f9089cf$var$actions,
    name: 'User'
});
const $1d312cc88f9089cf$export$33e3bf16c7530dd4 = (0, $ggKAj.createHook)($1d312cc88f9089cf$var$Store);

});
parcelRegister("4wzHf", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $34b5d72dfeef356f$export$30a852ca4cb27370);

var $1gWjz = parcelRequire("1gWjz");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $34b5d72dfeef356f$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $34b5d72dfeef356f$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $34b5d72dfeef356f$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $1gWjz.DEFAULT_CONFIG).stargateRoot}/me`).then((me)=>{
            var _me$extended_profile;
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: (_me$extended_profile = me.extended_profile) === null || _me$extended_profile === void 0 ? void 0 : _me$extended_profile.job_title
            };
        });
        return this.promise;
    }
}
const $34b5d72dfeef356f$export$30a852ca4cb27370 = new $34b5d72dfeef356f$export$dc10e400a1189789();

});


parcelRegister("3DtTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a5c351d454f70cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEcvG = parcelRequire("lEcvG");
const $2a5c351d454f70cb$var$Redirect = ({ to: to })=>{
    const { replace: replace } = (0, $lEcvG.useAppConfig)();
    (0, $eUqFw.useEffect)(()=>{
        replace(to);
    }, [
        replace,
        to
    ]);
    return null;
};
var $2a5c351d454f70cb$export$2e2bcd8739ae039 = $2a5c351d454f70cb$var$Redirect;

});


parcelRegister("eYUhH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae82543c0447817b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DtTR = parcelRequire("3DtTR");
const $ae82543c0447817b$var$RootRedirect = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DtTR.default), {
        to: `search${location.search}`
    });
var $ae82543c0447817b$export$2e2bcd8739ae039 = $ae82543c0447817b$var$RootRedirect;

});

parcelRegister("3bOQI", function(module, exports) {

$parcel$export(module.exports, "RouteWithOrgIdLoading", () => $2529d7c7509444b9$export$ae0909755df943ac);

var $eUqFw = parcelRequire("eUqFw");

var $7QNSj = parcelRequire("7QNSj");

var $kwce8 = parcelRequire("kwce8");

var $4Bees = parcelRequire("4Bees");

var $c1nG2 = parcelRequire("c1nG2");

var $8gATS = parcelRequire("8gATS");

var $eYUhH = parcelRequire("eYUhH");
function $2529d7c7509444b9$export$ae0909755df943ac({ LoadingComponent: LoadingComponent, ...props }) {
    const [{ orgId: orgId }] = (0, $c1nG2.useOrg)();
    const [timedOut, setTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const handleNoOrgId = (0, $eUqFw.useCallback)(()=>{
        (0, $8gATS.logErrorMessage)('No orgId found after 10 seconds', {
            ...props
        });
        setTimedOut(true);
    }, [
        setTimedOut,
        props
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (orgId) return;
        const timeout = setTimeout(()=>{
            if (!orgId) handleNoOrgId();
        }, 10000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        orgId,
        handleNoOrgId
    ]);
    if (timedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYUhH.default), {
        location: {
            search: ''
        }
    });
    if (!orgId) return LoadingComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingComponent, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2529d7c7509444b9$var$DefaultLoadingWrapper, {
        "data-testid": "route-with-org-id-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: 'large'
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), props);
}
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2529d7c7509444b9$var$DefaultLoadingWrapper = (0, $kwce8.default).div`
	height: 100%;
	width: 100%;
	padding-top: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

});

parcelRegister("dNnsJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b20d1ae324a1b9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $9qEz4 = parcelRequire("9qEz4");

var $5YswS = parcelRequire("5YswS");

var $eqLxI = parcelRequire("eqLxI");
const $a0b20d1ae324a1b9$var$SearchPageRoute = ()=>{
    const url = new URL(window.location.href);
    const searchQuery = url.searchParams.get('q') || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YswS.default), {
        name: (0, $7sTpx.AnalyticsKeys).PEOPLE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qEz4.default), {
        name: (0, $7sTpx.AnalyticsKeys).PEOPLE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eqLxI.default), {
        searchQuery: searchQuery
    })));
};
var $a0b20d1ae324a1b9$export$2e2bcd8739ae039 = $a0b20d1ae324a1b9$var$SearchPageRoute;

});
parcelRegister("eqLxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8185f6663fdc5c8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $a8185f6663fdc5c8$var$LazySearchPage = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("lnaIx")));
var $a8185f6663fdc5c8$export$2e2bcd8739ae039 = $a8185f6663fdc5c8$var$LazySearchPage;

});
parcelRegister("lnaIx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('bsl1G')
        ]);
        const value = parcelRequire('dvvdv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("bsl1G")
    ]).then(()=>parcelRequire('dvvdv'));
}

});



parcelRegister("i016T", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1a9168d1b1e5c0b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $9qEz4 = parcelRequire("9qEz4");

var $5YswS = parcelRequire("5YswS");

var $3LjYb = parcelRequire("3LjYb");
const $d1a9168d1b1e5c0b$var$SearchTeamsError = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YswS.default), {
        name: (0, $7sTpx.AnalyticsKeys).ALL_TEAMS_DISABLED
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qEz4.default), {
        name: (0, $7sTpx.AnalyticsKeys).ALL_TEAMS_DISABLED
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3LjYb.LazyTeamsDisabled), null));
};
var $d1a9168d1b1e5c0b$export$2e2bcd8739ae039 = $d1a9168d1b1e5c0b$var$SearchTeamsError;

});
parcelRegister("3LjYb", function(module, exports) {

$parcel$export(module.exports, "LazyTeamsDisabled", () => $2bd54078e01f20e3$export$f063de2a1a254e59);

var $bYKiA = parcelRequire("bYKiA");

const $2bd54078e01f20e3$export$f063de2a1a254e59 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("8rA7p")).then((module)=>module.TeamsDisabled),
    loading: ()=>null
});
$2bd54078e01f20e3$export$f063de2a1a254e59.displayName = 'lazy(TeamsDisabled)';

});
parcelRegister("8rA7p", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('5Yxj3')
        ]);
        const value = parcelRequire('cvUVv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("5Yxj3")
    ]).then(()=>parcelRequire('cvUVv'));
}

});



parcelRegister("do8sj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf4135ec74bcf39$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $9qEz4 = parcelRequire("9qEz4");

var $5YswS = parcelRequire("5YswS");

var $dye1c = parcelRequire("dye1c");
const $9bf4135ec74bcf39$var$TeamProfileRoute = ({ match: match })=>{
    const { teamId: teamId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YswS.default), {
        name: (0, $7sTpx.AnalyticsKeys).TEAM_PROFILE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qEz4.default), {
        name: (0, $7sTpx.AnalyticsKeys).TEAM_PROFILE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dye1c.default), {
        teamId: teamId
    }));
};
var $9bf4135ec74bcf39$export$2e2bcd8739ae039 = $9bf4135ec74bcf39$var$TeamProfileRoute;

});
parcelRegister("dye1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd953137aed84ed$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $9dd953137aed84ed$var$TeamProfilePage = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("hfOlk")),
    loading: ()=>null
});
$9dd953137aed84ed$var$TeamProfilePage.displayName = 'lazy(TeamProfilePage)';
var $9dd953137aed84ed$export$2e2bcd8739ae039 = $9dd953137aed84ed$var$TeamProfilePage;

});
parcelRegister("hfOlk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('7jHoJ')
        ]);
        const value = parcelRequire('7wVYM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("7jHoJ")
    ]).then(()=>parcelRequire('7wVYM'));
}

});



parcelRegister("6DxuR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d505e60c53be636$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DtTR = parcelRequire("3DtTR");
const $4d505e60c53be636$var$TeamNoIdRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DtTR.default), {
        to: "/search"
    });
var $4d505e60c53be636$export$2e2bcd8739ae039 = $4d505e60c53be636$var$TeamNoIdRedirect;

});

parcelRegister("hceq0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c84ebde100763d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $9qEz4 = parcelRequire("9qEz4");

var $6cHm3 = parcelRequire("6cHm3");

var $5YswS = parcelRequire("5YswS");
const $c84ebde100763d0e$var$UserProfileRoute = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YswS.default), {
        name: (0, $7sTpx.AnalyticsKeys).PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qEz4.default), {
        name: (0, $7sTpx.AnalyticsKeys).PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cHm3.default), {
        userId: decodeURIComponent(userId)
    }));
};
var $c84ebde100763d0e$export$2e2bcd8739ae039 = $c84ebde100763d0e$var$UserProfileRoute;

});
parcelRegister("6cHm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $48457e64e6773667$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $48457e64e6773667$var$LazyUserProfile = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("137z3")),
    loading: ()=>null
});
$48457e64e6773667$var$LazyUserProfile.displayName = 'lazy(UserProfile)';
var $48457e64e6773667$export$2e2bcd8739ae039 = $48457e64e6773667$var$LazyUserProfile;

});
parcelRegister("137z3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('kY7pr')
        ]);
        const value = parcelRequire('619YY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("kY7pr")
    ]).then(()=>parcelRequire('619YY'));
}

});



parcelRegister("9qoc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dc94f5eea44522f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DtTR = parcelRequire("3DtTR");
const $6dc94f5eea44522f$var$UserProfileUnknownRoute = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DtTR.default), {
        to: match.params.userId
    });
var $6dc94f5eea44522f$export$2e2bcd8739ae039 = $6dc94f5eea44522f$var$UserProfileUnknownRoute;

});

parcelRegister("cAtBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $929fcea66b5fb46d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $9qEz4 = parcelRequire("9qEz4");

var $5YswS = parcelRequire("5YswS");

var $dTSEo = parcelRequire("dTSEo");
const $929fcea66b5fb46d$var$UserProfileWorkedOn = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YswS.default), {
        name: (0, $7sTpx.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qEz4.default), {
        name: (0, $7sTpx.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTSEo.default), {
        userId: decodeURIComponent(userId)
    }));
};
var $929fcea66b5fb46d$export$2e2bcd8739ae039 = $929fcea66b5fb46d$var$UserProfileWorkedOn;

});
parcelRegister("dTSEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1eacde1566993ea$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $a1eacde1566993ea$var$LazyUserProfileWorkedOn = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("fpl4y")),
    loading: ()=>null
});
$a1eacde1566993ea$var$LazyUserProfileWorkedOn.displayName = 'lazy(UserProfileWorkedOn)';
var $a1eacde1566993ea$export$2e2bcd8739ae039 = $a1eacde1566993ea$var$LazyUserProfileWorkedOn;

});
parcelRegister("fpl4y", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('lU2yW')
        ]);
        const value = parcelRequire('88am8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("lU2yW")
    ]).then(()=>parcelRequire('88am8'));
}

});




parcelRegister("eKSiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $abdf7b54ac818d39$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $55SOq = parcelRequire("55SOq");

var $lOklV = parcelRequire("lOklV");

var $lEcvG = parcelRequire("lEcvG");

var $7JMhP = parcelRequire("7JMhP");
const $abdf7b54ac818d39$var$appProductMap = {
    '': '',
    'site-directory': '',
    'confluence-directory': (0, $55SOq.ProductName).CONFLUENCE,
    'jira-directory': (0, $55SOq.ProductName).JIRA,
    'teamcentral-directory': (0, $55SOq.ProductName).ATLAS,
    'home-directory': (0, $55SOq.ProductName).HOME
};
const $abdf7b54ac818d39$var$mapAppToProduct = (app)=>{
    return $abdf7b54ac818d39$var$appProductMap[app];
};
class $abdf7b54ac818d39$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "addFlag", (props)=>{
            const { type: type, ...rest } = props;
            this.props.addFlag({
                ...rest,
                id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
                type: type,
                appearance: 'normal',
                icon: (0, $7JMhP.getTypeIcon)(type)
            });
        });
        (0, $5zQU9.default)(this, "push", (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $lOklV.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.push(finalPath);
        });
        (0, $5zQU9.default)(this, "replace", (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $lOklV.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.replace(finalPath);
        });
        (0, $5zQU9.default)(this, "state", {
            addFlag: this.addFlag,
            push: this.push,
            replace: this.replace,
            productName: $abdf7b54ac818d39$var$mapAppToProduct(this.props.appName),
            productFeatureFlags: this.props.productFeatureFlags,
            invitePeopleHandlers: this.props.invitePeopleHandlers
        });
    }
    render() {
        // This is here to let productFeatureFlags from getting updated via props
        const productFeatureFlags = {
            ...this.state.productFeatureFlags,
            ...this.props.productFeatureFlags
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lEcvG.default).Provider, {
            value: {
                ...this.props,
                ...this.state,
                productFeatureFlags: productFeatureFlags
            }
        }, this.props.children);
    }
}

});
parcelRegister("55SOq", function(module, exports) {

$parcel$export(module.exports, "ShortProductKey", () => $3b57effca77c8dcc$export$736dd0bf2ecc436f);
$parcel$export(module.exports, "ProductName", () => $3b57effca77c8dcc$export$acdfad52bc8c6626);
/**
 * ShortProductKey is used in code. It should not have a special characters or empty space
 */ let $3b57effca77c8dcc$export$736dd0bf2ecc436f = /*#__PURE__*/ function(ShortProductKey) {
    ShortProductKey["CONFLUENCE"] = "confluence";
    ShortProductKey["JIRA"] = "jira";
    ShortProductKey["JIRA_CORE"] = "jira_core";
    ShortProductKey["JIRA_SOFTWARE"] = "jira_software";
    ShortProductKey["JIRA_SERVICE_DESK"] = "jira_service_key";
    ShortProductKey["BITBUCKET"] = "bitbucket";
    return ShortProductKey;
}({});
let $3b57effca77c8dcc$export$acdfad52bc8c6626 = /*#__PURE__*/ function(ProductName) {
    ProductName["CONFLUENCE"] = "Confluence";
    ProductName["JIRA"] = "Jira";
    ProductName["JIRA_CORE"] = "Jira Core";
    ProductName["JIRA_SOFTWARE"] = "Jira Software";
    ProductName["JIRA_SERVICE_DESK"] = "Jira Service Desk";
    ProductName["BITBUCKET"] = "Bitbucket";
    ProductName["TEAM_CENTRAL"] = "Team Central";
    ProductName["ATLAS"] = "Atlas";
    ProductName["HOME"] = "Atlassian Home";
    return ProductName;
}({});
const $3b57effca77c8dcc$export$ff506ffd2c56b336 = {
    [$3b57effca77c8dcc$export$acdfad52bc8c6626.JIRA]: 'JIRA',
    [$3b57effca77c8dcc$export$acdfad52bc8c6626.CONFLUENCE]: 'CONFLUENCE',
    [$3b57effca77c8dcc$export$acdfad52bc8c6626.TEAM_CENTRAL]: 'TOWNSQUARE',
    [$3b57effca77c8dcc$export$acdfad52bc8c6626.ATLAS]: 'TOWNSQUARE',
    [$3b57effca77c8dcc$export$acdfad52bc8c6626.HOME]: 'HOME'
};
let $3b57effca77c8dcc$export$fc3a4bf3fb08b1b4 = /*#__PURE__*/ function(LongProductKey) {
    LongProductKey["JIRA_CORE"] = "jira-core.ondemand";
    LongProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    LongProductKey["CONFLUENCE"] = "confluence.ondemand";
    LongProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    LongProductKey["BITBUCKET"] = "bitbucket";
    return LongProductKey;
}({}); // There is no user custom product icon or product display name, so
 // product icon and product name is fixed

});

parcelRegister("lOklV", function(module, exports) {

$parcel$export(module.exports, "getDomainFromLinkUri", () => $fe0e0e11efe8cb77$export$cda14c9dfe45538);
$parcel$export(module.exports, "getRelativeUrl", () => $fe0e0e11efe8cb77$export$d614758658023fd);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $fe0e0e11efe8cb77$export$715c8f9057ac0c01);
$parcel$export(module.exports, "isSPALink", () => $fe0e0e11efe8cb77$export$82ba20246315fbed);

var $fXCRm = parcelRequire("fXCRm");
const $fe0e0e11efe8cb77$export$1cc7e75fbd30f64f = (location)=>`${location.hash}${location.search}`;
const $fe0e0e11efe8cb77$export$cda14c9dfe45538 = (url)=>{
    let hostname;
    try {
        try {
            hostname = $fe0e0e11efe8cb77$export$eb5a321f13bbb969(url);
        } catch (noProtocolError) {
            /**
       * Backend (Legion) validates whether the string is URI compliant. But URL expects
       * the string to have a protocol. This is not validated by URI compliancy. So
       * following is just a quick fix just for display purposes.
       */ hostname = $fe0e0e11efe8cb77$export$eb5a321f13bbb969('http://' + url);
        }
    } catch (error) {
        return '';
    }
    return hostname.replace(/^www\./, '');
};
const $fe0e0e11efe8cb77$export$eb5a321f13bbb969 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.hostname;
};
const $fe0e0e11efe8cb77$export$c8d36b71889c2b08 = (email)=>{
    const parts = email.split('@');
    if (parts.length === 1) return null;
    else if (parts.length === 2 && !parts[0]) return null;
    else if (!parts[parts.length - 1]) return null;
    return parts[parts.length - 1];
};
const $fe0e0e11efe8cb77$export$d614758658023fd = (url)=>{
    if (!$fe0e0e11efe8cb77$var$isAbsoluteLink(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $fXCRm.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $fe0e0e11efe8cb77$var$isAbsoluteLink = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $fe0e0e11efe8cb77$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ($fe0e0e11efe8cb77$var$isAbsoluteLink(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $fe0e0e11efe8cb77$export$82ba20246315fbed = (url, contextSpaPaths)=>{
    if (!contextSpaPaths || !contextSpaPaths.length) return false;
    let isStartWithContextSPA;
    if ($fe0e0e11efe8cb77$var$isAbsoluteLink(url)) try {
        const { pathname: pathname, search: search, hash: hash, origin: origin } = new URL(url);
        const relativeUrl = `${pathname}${search}${hash}`;
        const isSameDomain = window.location.href.includes(origin);
        isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
            return relativeUrl.startsWith(contextPath);
        });
        return isStartWithContextSPA && isSameDomain;
    } catch (error) {
        (0, $fXCRm.logException)(error, 'Cannot parse URL in isSPALink', {
            url: url
        });
        return false;
    }
    // is relative link
    isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
        return url.startsWith(contextPath);
    });
    return isStartWithContextSPA || !url.startsWith('/');
};

});

parcelRegister("7JMhP", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $5a223113d3a698e9$export$672f92b0d52b7cfe);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");
const $5a223113d3a698e9$var$flagIconByType = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "",
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: "",
        primaryColor: `var(--ds-icon-information, ${(0, $PdmhA.B300)})`
    })
};
const $5a223113d3a698e9$var$defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
    label: "",
    primaryColor: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`
});
const $5a223113d3a698e9$export$672f92b0d52b7cfe = (type = 'normal')=>$5a223113d3a698e9$var$flagIconByType[type] || $5a223113d3a698e9$var$defaultIcon;

});


parcelRegister("7f3ds", function(module, exports) {

$parcel$export(module.exports, "default", () => $545c6dc1cec871f1$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $eGYgu = parcelRequire("eGYgu");
var $fXCRm = parcelRequire("fXCRm");
class $545c6dc1cec871f1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            hasError: false
        });
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        const { analytics: analytics, appName: appName } = this.props;
        (0, $fXCRm.logException)(error, 'Caught error in ErrorBoundaryApp', {
            info: errorInfo,
            tags: {
                severity: 'high'
            }
        });
        analytics.pushOperationalEvent({
            source: (0, $7sTpx.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'errorBoundary',
            action: (0, $7sTpx.AnalyticsEventActions).TRIGGERED,
            attributes: {
                product: appName,
                boundary: 'app',
                error: error.toString()
            },
            tags: [
                'error',
                'error-boundary'
            ]
        });
    }
    render() {
        if (!this.state.hasError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eGYgu.GenericErrorPage), {
            hasSupportLink: true
        });
    }
}

});
parcelRegister("eGYgu", function(module, exports) {

$parcel$export(module.exports, "GenericErrorPage", () => $ab23bc4f3d5a035f$export$5d76009b056f3e5d);
$parcel$export(module.exports, "default", () => $ab23bc4f3d5a035f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $bAnhx = parcelRequire("bAnhx");

var $cEwhn = parcelRequire("cEwhn");

var $4xkS7 = parcelRequire("4xkS7");
const $ab23bc4f3d5a035f$export$2369ec80391a4c8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.ErrorImage, {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($cEwhn)))
});
const $ab23bc4f3d5a035f$export$c120a0e80fd44ca6 = ({ title: title, body: body, image: image, actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.Container, {
        "data-test-selector": "error-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.ImageOuter, null, image || $ab23bc4f3d5a035f$export$2369ec80391a4c8c), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.ErrorTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.Title, null, title)), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.DescriptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.Description, null, body))), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4xkS7.ButtonContainer, null, actions));
};
const $ab23bc4f3d5a035f$export$5d76009b056f3e5d = (props)=>{
    const actions = props.hasSupportLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        rel: "noopener noreferrer",
        target: "_blank",
        href: `${(0, $bAnhx.getAtlassianContextUrl)('support')}/contact/#/`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $ab23bc4f3d5a035f$var$messages.contactUs));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab23bc4f3d5a035f$export$c120a0e80fd44ca6, {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $ab23bc4f3d5a035f$var$messages.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $ab23bc4f3d5a035f$var$messages.description),
        actions: actions || undefined
    });
};
const $ab23bc4f3d5a035f$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        id: 'pf-home.generic-error-title',
        defaultMessage: 'Something went wrong'
    },
    contactUs: {
        id: 'ptc-directory.error-boundary.message-link-text',
        defaultMessage: 'Contact support',
        description: 'The text of the link leading to the Atlassian support website, shown below the error description on the error pages'
    },
    description: {
        id: 'pf-home.generic-error-description',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things."
    }
});
var $ab23bc4f3d5a035f$export$2e2bcd8739ae039 = $ab23bc4f3d5a035f$export$c120a0e80fd44ca6;

});
parcelRegister("cEwhn", function(module, exports) {
module.exports = new URL("svg-error-window_ptc.150cf151.svg", import.meta.url).toString();

});

parcelRegister("4xkS7", function(module, exports) {

$parcel$export(module.exports, "ErrorImage", () => $34da6f32d1abe74b$export$7326e6d938a8137b);
$parcel$export(module.exports, "Container", () => $34da6f32d1abe74b$export$42a852a2b6b56249);
$parcel$export(module.exports, "ImageOuter", () => $34da6f32d1abe74b$export$6cce79b2fcc860dc);
$parcel$export(module.exports, "TitleWrapper", () => $34da6f32d1abe74b$export$585a3b23e887288b);
$parcel$export(module.exports, "ButtonContainer", () => $34da6f32d1abe74b$export$eddf54ea3db8d0f0);
$parcel$export(module.exports, "Title", () => $34da6f32d1abe74b$export$f99233281efd08a0);
$parcel$export(module.exports, "DescriptionWrapper", () => $34da6f32d1abe74b$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $34da6f32d1abe74b$export$393edc798c47379d);
$parcel$export(module.exports, "ErrorTextContainer", () => $34da6f32d1abe74b$export$5086488b1ac4411e);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $34da6f32d1abe74b$export$7326e6d938a8137b = (0, $kwce8.default).img`
	width: 263px;
	margin: 0 0 ${"var(--ds-space-600, 48px)"} 0;
	display: flex;
`;
const $34da6f32d1abe74b$export$42a852a2b6b56249 = (0, $kwce8.default).div`
	align-items: center;
	justify-content: center;
	display: flex;
	flex-wrap: wrap;
	margin: ${"var(--ds-space-1000, 80px)"} auto 0;
	max-width: 600px;
	flex-direction: column;

	@media (max-width: 640px) {
		flex-direction: column;
	}
`;
const $34da6f32d1abe74b$export$6cce79b2fcc860dc = (0, $kwce8.default).div`
	flex: none;
	flex-basis: 200px;
	justify-content: center;

	@media (max-width: 640px) {
		margin-right: 0;
		flex-basis: auto;

		& img {
			max-width: 100%;
			padding: 0 ${"var(--ds-space-300, 24px)"};
		}
	}
`;
const $34da6f32d1abe74b$export$585a3b23e887288b = (0, $kwce8.default).div`
	display: flex;
	margin-bottom: ${"var(--ds-space-150, 12px)"};

	@media (max-width: 640px) {
		text-align: center;
	}
`;
const $34da6f32d1abe74b$export$eddf54ea3db8d0f0 = (0, $kwce8.default).div`
	display: flex;
	justify-content: center;
	text-align: center;
	margin-top: ${"var(--ds-space-200, 16px)"};
`;
const $34da6f32d1abe74b$export$f99233281efd08a0 = (0, $kwce8.default).h1``;
const $34da6f32d1abe74b$export$2bf1f2b0d31b60fc = (0, $kwce8.default).div`
	display: flex;
	flex-wrap: wrap;
`;
const $34da6f32d1abe74b$export$393edc798c47379d = (0, $kwce8.default).p`
	font-size: 1em;
	line-height: 24px;
	color: ${`var(--ds-text, ${(0, $PdmhA.N800)})`};

	@media (max-width: 640px) {
		text-align: center;
	}
`;
const $34da6f32d1abe74b$export$5086488b1ac4411e = (0, $kwce8.default).div`
	display: flex;
	justify-content: center;
	text-align: center;
	flex-wrap: wrap;
	width: 80%;
	flex-direction: column;
	align-items: center;

	@media (max-width: 640px) {
		max-width: 304px;
		width: 100%;
	}
`;

});



parcelRegister("laX0d", function(module, exports) {

$parcel$export(module.exports, "App", () => $f6a84cd0f395354b$export$86fbec116b87613f);
$parcel$export(module.exports, "RelativeWrapperOfHeaderImage", () => $f6a84cd0f395354b$export$c0d0370fa0c37541);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $f6a84cd0f395354b$export$86fbec116b87613f = (0, $kwce8.default).div`
	height: 100%;

	* {
		box-sizing: border-box;
	}

	a:hover {
		text-decoration: none;
	}
`;
const $f6a84cd0f395354b$export$c0d0370fa0c37541 = (0, $kwce8.default).div`
	position: relative;
`;

});

parcelRegister("etjd2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a892acabc151b773$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7sTpx = parcelRequire("7sTpx");
var $5IcES = parcelRequire("5IcES");
var $2vo6z = parcelRequire("2vo6z");
var $gjQgj = parcelRequire("gjQgj");
var $jUprp = parcelRequire("jUprp");

var $61syn = parcelRequire("61syn");
const $a892acabc151b773$var$mapAppNameToProduct = {
    '': undefined,
    'site-directory': undefined,
    'confluence-directory': 'CONFLUENCE',
    'jira-directory': 'JIRA',
    'teamcentral-directory': 'TOWNSQUARE',
    'home-directory': 'HOME'
};
function $a892acabc151b773$export$f07589effd6b0ff3(props) {
    const { appName: appName, children: children } = props;
    const [{ cloudId: cloudId }] = (0, $jUprp.useSite)();
    const [{ principalUserId: principalUserId }, { getPrincipalUserInfo: getPrincipalUserInfo }] = (0, $2vo6z.usePrincipalUser)();
    const analytics = (0, $5IcES.default)();
    const [{ hasLoadedSettings: hasLoadedSettings, hasErrorOnFetchSettings: hasErrorOnFetchSettings }, { getSettings: getSettings }] = (0, $gjQgj.useSettings)();
    (0, $eUqFw.useEffect)(()=>{
        analytics.startUIViewedEvent(principalUserId);
    }, [
        analytics,
        principalUserId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasLoadedSettings) analytics.pushOperationalEvent({
            action: hasErrorOnFetchSettings ? (0, $7sTpx.AnalyticsEventActions).FAILED : (0, $7sTpx.AnalyticsEventActions).SUCCEEDED,
            actionSubject: (0, $61syn.SliAnalytics).GetSettings,
            source: (0, $7sTpx.AnalyticsEventSource).DIRECTORY_APP
        });
    }, [
        analytics,
        hasLoadedSettings,
        hasErrorOnFetchSettings
    ]);
    const product = $a892acabc151b773$var$mapAppNameToProduct[appName];
    (0, $eUqFw.useEffect)(()=>{
        // currently, cloudId is a required prop of Embedded Directory
        if (!hasLoadedSettings && cloudId) getSettings(product, cloudId);
    }, [
        product,
        hasLoadedSettings,
        getSettings,
        cloudId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // currently, cloudId is a required prop of Embedded Directory
        if (cloudId) getPrincipalUserInfo(cloudId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId
    ]);
    return children;
}
var $a892acabc151b773$export$2e2bcd8739ae039 = $a892acabc151b773$export$f07589effd6b0ff3;

});
parcelRegister("gjQgj", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $be16f5e06bdbb320$export$61acb772777ef35d);
$parcel$export(module.exports, "useSettings", () => $be16f5e06bdbb320$export$9115b42802a3e44f);

var $cyk9S = parcelRequire("cyk9S");
var $8nAvq = parcelRequire("8nAvq");
const $be16f5e06bdbb320$export$c5cecc6f5d4bab3e = ()=>{
    return true;
};
const $be16f5e06bdbb320$export$61acb772777ef35d = (flagName)=>{
    return (0, $cyk9S.useFeatureFlag)(flagName);
};
const $be16f5e06bdbb320$export$9115b42802a3e44f = ()=>{
    return (0, $8nAvq.useSettings)();
};

});
parcelRegister("cyk9S", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $92384c0be32ac48c$export$61acb772777ef35d);

var $8nAvq = parcelRequire("8nAvq");

var $6DV4v = parcelRequire("6DV4v");
const $92384c0be32ac48c$export$61acb772777ef35d = (flag)=>{
    const { productFeatureFlags: productFeatureFlags } = (0, $6DV4v.useAppConfig)();
    const flagValue = (0, $8nAvq.useSettingsFeatureFlag)(flag);
    if (productFeatureFlags && productFeatureFlags[flag] !== undefined) return productFeatureFlags[flag];
    return flagValue;
};
const $92384c0be32ac48c$export$80200644648c0ee1 = (flagName)=>!!$92384c0be32ac48c$export$61acb772777ef35d(flagName);

});
parcelRegister("8nAvq", function(module, exports) {

$parcel$export(module.exports, "useSettings", () => $619cc9ff498b0fa3$export$9115b42802a3e44f);
$parcel$export(module.exports, "useSettingsFeatureFlag", () => $619cc9ff498b0fa3$export$f2df9067cb58ea32);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $4ECFx = parcelRequire("4ECFx");

var $jYsJv = parcelRequire("jYsJv");

var $685TP = parcelRequire("685TP");
const $619cc9ff498b0fa3$export$28456d095a642fd = 'internal.browse-users-allowed';
const $619cc9ff498b0fa3$var$actions = {
    /**
   * Fetches feature flag settings from LaunchDarkly via activity service and directory service
   * Caches the fetched settings in local storage to be used as optimistic settings on next load
   * @param product - only Embeddable Directory needs product information. Standalone app does not need this.
   * @param cloudId - Cloud Id.
   */ getSettings: (product, cloudId)=>async ({ setState: setState })=>{
            // in siteless, we don't need to query features flags in directory
            const directorySettingPromise = cloudId ? (0, $4ECFx.teamsClient).querySettings(cloudId, product) : Promise.resolve({
                [$619cc9ff498b0fa3$export$28456d095a642fd]: true
            });
            return (0, $jYsJv.promiseWithDefault)(directorySettingPromise, {
                [$619cc9ff498b0fa3$export$28456d095a642fd]: false
            }).then(({ value: browseUsersEnabled, success: settingsSuccess })=>{
                const settingsFromRequests = {
                    // If settings cannot be accessed, default to permission denied.
                    [$619cc9ff498b0fa3$export$28456d095a642fd]: false,
                    ...browseUsersEnabled
                };
                if (settingsSuccess) setState({
                    hasLoadedSettings: true,
                    hasBrowseUsersPermission: !!settingsFromRequests[$619cc9ff498b0fa3$export$28456d095a642fd],
                    settings: {
                        ...settingsFromRequests
                    }
                });
                // Fallback as needed to compute effective flag values
                const finalSettings = {
                    ...(0, $685TP.getSettingsFromStorage)() || {},
                    ...settingsFromRequests
                };
                setState({
                    hasLoadedSettings: true,
                    hasErrorOnFetchSettings: !settingsSuccess,
                    hasBrowseUsersPermission: !!finalSettings[$619cc9ff498b0fa3$export$28456d095a642fd],
                    settings: finalSettings
                });
            });
        }
};
const $619cc9ff498b0fa3$var$initialState = {
    hasLoadedSettings: false,
    hasErrorOnFetchSettings: false,
    hasBrowseUsersPermission: false,
    settings: {
        [$619cc9ff498b0fa3$export$28456d095a642fd]: false,
        ...(0, $685TP.getSettingsFromStorage)() || {}
    }
};
/**
 * Manage states of settings
 */ const $619cc9ff498b0fa3$var$Store = (0, $a61MH.createStore)({
    initialState: $619cc9ff498b0fa3$var$initialState,
    actions: $619cc9ff498b0fa3$var$actions,
    name: 'Settings'
});
const $619cc9ff498b0fa3$export$8376625f8bb18347 = (0, $heB5U.createContainer)($619cc9ff498b0fa3$var$Store, {
    onInit: ()=>({ setState: setState }, state)=>{
            setState(state);
        }
});
const $619cc9ff498b0fa3$export$9115b42802a3e44f = (0, $ggKAj.createHook)($619cc9ff498b0fa3$var$Store);
const $619cc9ff498b0fa3$export$f2df9067cb58ea32 = (flagName)=>{
    const [{ settings: settings }] = $619cc9ff498b0fa3$export$9115b42802a3e44f();
    return settings[flagName];
};

});
parcelRegister("jYsJv", function(module, exports) {

$parcel$export(module.exports, "promiseWithDefault", () => $e8a9e8ace0f2f233$export$a970b469503acdc8);
/**
 * If the promise throws then a default value will be returned as well as a false marker.
 *
 * @param promise The promise to be wrapped.
 * @param defaultValue The value to be returned if an error is thrown.
 */ function $e8a9e8ace0f2f233$export$a970b469503acdc8(promise, defaultValue) {
    return promise.then((value)=>({
            value: value,
            success: true
        })).catch(()=>({
            value: defaultValue,
            success: false
        }));
}

});




parcelRegister("61syn", function(module, exports) {

$parcel$export(module.exports, "SliAnalytics", () => $4628fc2c9c2e5d9c$export$9cb5f615baf57db6);
let $4628fc2c9c2e5d9c$export$9cb5f615baf57db6 = /*#__PURE__*/ function(SliAnalytics) {
    SliAnalytics["GetTeamProfile"] = "GetTeamProfile";
    SliAnalytics["GetTeamMembers"] = "GetTeamMembers";
    SliAnalytics["GetTeamLinks"] = "GetTeamLinks";
    SliAnalytics["TeamSearch"] = "TeamSearch";
    SliAnalytics["AccountCentricUserSearch"] = "AccountCentricUserSearch";
    SliAnalytics["LoadProfileAbout"] = "LoadProfileAbout";
    SliAnalytics["GetSettings"] = "GetSettings";
    return SliAnalytics;
}({});

});




parcelRegister("j0CW6", function(module, exports) {

$parcel$export(module.exports, "createShowFlagHandler", () => $43aa3b2073d8beb6$export$58bf1d914631d59f);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");

var $iFoSH = parcelRequire("iFoSH");
const $43aa3b2073d8beb6$var$FLAG_PTC_ID_DEFAULT = 'ptc-people-directory.flag-id';
const $43aa3b2073d8beb6$export$58bf1d914631d59f = (showFlag, dismissFlag)=>(flagFromPTC)=>{
        const flagType = flagFromPTC.type === 'success' || flagFromPTC.type === 'error' || flagFromPTC.type === 'info' || flagFromPTC.type === 'warning' ? flagFromPTC.type : 'success';
        const flagTitle = flagFromPTC.title;
        const flagDesc = flagFromPTC.description;
        showFlag({
            render: ({ key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFoSH.default), {
                    key: key,
                    id: key || flagFromPTC.id || $43aa3b2073d8beb6$var$FLAG_PTC_ID_DEFAULT,
                    flagType: flagType,
                    title: flagTitle != null ? flagTitle : '',
                    description: flagDesc != null ? flagDesc : '',
                    isAutoDismiss: true,
                    onDismissed: (id)=>{
                        dismissFlag((0, $eo17r.toFlagId)(id));
                    }
                })
        });
    };

});
parcelRegister("iFoSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d199b2da5c2aad1c$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $d199b2da5c2aad1c$export$2e2bcd8739ae039 = (0, $kQ0RL.CommonFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});




parcelRegister("7mFxr", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesPageLoad", () => $08b7272d77e81c54$export$37d218590c0c9938);

var $lNfG4 = parcelRequire("lNfG4");
const $08b7272d77e81c54$export$37d218590c0c9938 = (0, $lNfG4.metrics).pageLoad({
    key: 'people-profiles'
});

});



//# sourceMappingURL=async-people-profiles.36371e7f.js.map
